import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
    en: {
        navbar: {
            home: 'Home',
            aboutUs: 'About Us',
            rooms: 'Rooms',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Food',
            events: 'Events',
            blogs: 'Blogs',
            tours: 'Tours',
            contactUs: 'Contact Us',
            bookOnline: 'Book Online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Select Resort',
            language: 'Language',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Home',
            aboutUs: 'About Us',
            rooms: 'Rooms',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Food',
            events: 'Events',
            blogs: 'Blogs',
            tours: 'Tours',
            contactUs: 'Contact Us',
            bookOnline: 'Book Online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Select Resort',
            language: 'Language',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe River View Room — Comfort with a terrace or private balcony',
            heroSubtitle: 'Unwind in a calming riverside retreat inspired by the serene waters of Bentota, pairing modern amenities with gentle river breezes.',
            bookThisRoom: 'Book this room',
            callReservations: 'Call reservations',

            navAll: 'All',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe with River View',

            soothingHideawayTitle: 'A soothing riverside hideaway',
            soothingHideawayDesc: 'Our Deluxe River View Room is crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the river view in, while the balcony offers your own perch above the flowing waters.',

            highlight1Title: 'Panoramic River Views',
            highlight1Desc: 'Wake up to serene river vistas and golden sunrises from your private balcony.',
            highlight2Title: 'Elegant Riverside Interiors',
            highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
            highlight3Title: 'Serene Sleep Experience',
            highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',

            atAGlance: 'At a glance',
            statSizeLabel: 'Size',
            statViewLabel: 'View',
            statViewValue: 'River View',
            statGuestsLabel: 'Guests',
            statBedLabel: 'Bed',
            statBedValue: 'King or Twin',
            reserve: 'Reserve',

            includedWithStay: 'Included with your stay',
            thoughtfulTouches: 'Thoughtful touches, all-day comfort',
            enhancedCleanliness: 'Enhanced cleanliness and safety standards',

            inclusion1: 'breakfast, Lunch, Dinner at Restaurant',
            inclusion2: 'Free Wi-Fi and in-room workspace',
            inclusion3: '24-hour room service and concierge',
            inclusion4: 'Daily housekeeping with evening turndown',
            inclusion5: 'Access to pool and Ayurveda spa facilities',
            inclusion6: 'parking and shuttle service to nearby attractions',

            amenityGroup1Title: 'Room Features',
            amenityGroup1Item1: '38 sqm of space',
            amenityGroup1Item2: 'Private balcony with seating',
            amenityGroup1Item3: 'Air conditioning with climate control',
            amenityGroup1Item4: 'In-room safe',

            amenityGroup2Title: 'Bath Experience',
            amenityGroup2Item1: 'Rain shower with hot and cold water',
            amenityGroup2Item2: 'Premium bath amenities',
            amenityGroup2Item3: 'Hair dryer',
            amenityGroup2Item4: 'Soft bathrobes and slippers',

            amenityGroup3Title: 'In-Room Comforts',
            amenityGroup3Item1: '55" smart TV with cable',
            amenityGroup3Item2: 'Coffee and tea station',
            amenityGroup3Item3: 'Direct-dial telephone',

            amenityGroup4Title: 'Connectivity',
            amenityGroup4Item1: 'Wi-Fi',
            amenityGroup4Item2: 'Work desk',
            amenityGroup4Item3: '24/7 front desk support',

            inRoomEssentials: 'In-room essentials',
            everythingYouNeed: 'Everything you need to feel at home',
            inRoomEssentialsDesc: 'From seamless connectivity to carefully chosen refreshments, the Deluxe River View Room blends leisure and practicality so you can focus on the moments that matter.',

            complimentaryWifi: 'Wi-Fi',
            coffeeTeaStation: 'Coffee and tea station',
            roomService: '24/7 room service',
            rainShower: 'Rain shower',

            byTheRiver: 'By the river',
            slowDownBreathe: 'Slow down, breathe in the fresh air',

            readyToStay: 'Ready to stay?',
            reserveDeluxeRiverViewToday: 'Reserve a Deluxe River View Room today',
            speakReservations: 'Speak with our reservations team for the best available rates and special offers.',
            checkAvailability: 'Check availability'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe Room — Comfort with a terrace or private balcony',
            heroSubtitle: 'Unwind in a calming riverside retreat inspired by the serene waters of Bentota, pairing modern amenities with gentle river breezes.',
            bookThisRoom: 'Book this room',
            callReservations: 'Call reservations',

            navAll: 'All',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe with River View',

            soothingHideawayTitle: 'A soothing riverside hideaway',
            soothingHideawayDesc: 'The Deluxe Room is crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the river view in, while the balcony offers your own perch above the flowing waters.',

            highlight1Title: 'Panoramic River Views',
            highlight1Desc: 'Wake up to serene river vistas and tropical sunrises from your private balcony.',
            highlight2Title: 'Elegant Riverside Interiors',
            highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
            highlight3Title: 'Serene Sleep Experience',
            highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',

            atAGlance: 'At a glance',
            statSizeLabel: 'Size',
            statViewLabel: 'View',
            statViewValue: 'River View',
            statGuestsLabel: 'Guests',
            statBedLabel: 'Bed',
            statBedValue: 'King or Twin',
            reserve: 'Reserve',

            includedWithStay: 'Included with your stay',
            thoughtfulTouches: 'Thoughtful touches, all-day comfort',
            enhancedCleanliness: 'Enhanced cleanliness and safety standards',

            inclusion1: 'breakfast, lunch, dinner at Restaurant',
            inclusion2: 'Free Wi-Fi and in-room workspace',
            inclusion3: '24-hour room service and concierge',
            inclusion4: 'Daily housekeeping with evening turndown',
            inclusion5: 'Access to pool and Ayurveda spa facilities',
            inclusion6: 'parking and shuttle service to nearby attractions',

            amenityGroup1Title: 'Room Features',
            amenityGroup1Item1: '41 sqm of space',
            amenityGroup1Item2: 'Private balcony with seating',
            amenityGroup1Item3: 'Air conditioning with climate control',
            amenityGroup1Item4: 'In-room safe',

            amenityGroup2Title: 'Bath Experience',
            amenityGroup2Item1: 'Rain shower with hot and cold water',
            amenityGroup2Item2: 'Premium bath amenities',
            amenityGroup2Item3: 'Hair dryer',
            amenityGroup2Item4: 'Soft bathrobes and slippers',

            amenityGroup3Title: 'In-Room Comforts',
            amenityGroup3Item1: '55" smart TV with cable',
            amenityGroup3Item2: 'Coffee and tea station',
            amenityGroup3Item3: 'Direct-dial telephone',

            amenityGroup4Title: 'Connectivity',
            amenityGroup4Item1: 'Wi-Fi',
            amenityGroup4Item2: 'Work desk',
            amenityGroup4Item3: '24/7 front desk support',

            inRoomEssentials: 'In-room essentials',
            everythingYouNeed: 'Everything you need to feel at home',
            inRoomEssentialsDesc: 'From seamless connectivity to carefully chosen refreshments, the Deluxe Room blends leisure and practicality so you can focus on the moments that matter.',

            complimentaryWifi: 'Wi-Fi',
            coffeeTeaStation: 'Coffee and tea station',
            roomService: '24/7 room service',
            rainShower: 'Rain shower',

            byTheRiver: 'By the river',
            slowDownBreathe: 'Slow down, breathe in the fresh air',

            readyToStay: 'Ready to stay?',
            reserveDeluxeToday: 'Reserve the Deluxe Room today',
            speakReservations: 'Speak with our reservations team for the best available rates and special offers.',
            checkAvailability: 'Check availability'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Your Sanctuary Awaits',
            heroSubtitle: 'Riverside sanctuaries designed for healing, restoration, and profound peace along the serene Bentota river.',
            exploreRooms: 'Explore Our Rooms',

            filterAll: 'All',
            filterDeluxeRooms: 'Deluxe Rooms',
            filterRiverViewDeluxe: 'Deluxe Room with River View',

            deluxeRoomName: 'Deluxe Room',
            deluxeRoomCategory: 'Deluxe Rooms',
            deluxeRoomDesc: 'Harmoniously balanced room featuring natural wood elements and riverside views for perfect tranquility.',

            riverViewDeluxeName: 'River View Deluxe',
            riverViewDeluxeCategory: 'Deluxe Room with River View',
            riverViewDeluxeDesc: 'Wake up to the gentle sounds of the river and panoramic riverside views in this elegantly designed deluxe room.',

            noRoomsFound: 'No rooms found in this category.',
            roomSize: 'Room Size',
            guests: 'Guests',
            amenitiesCount: 'Amenities',
            roomAmenities: 'Room Amenities',
            specialFeatures: 'Special Features',

            kingSizeBed: 'King Size Bed',
            workDesk: 'Work Desk',
            rainShower: 'Rain Shower',
            teaStation: 'Tea Station',
            privateTerrace: 'Private Terrace',
            binoculars: 'Binoculars',

            riverView: 'River View',
            naturalLighting: 'Natural Lighting',
            gardenView: 'Garden View',
            sunriseBalcony: 'Sunrise Balcony',
            soundOfRiver: 'Sound of River',

            bookNow: 'Book Now',
            viewDetails: 'View Details',
            viewRoom: 'View Room',

            allRoomsInclude: 'All Rooms Include',
            essentialComforts: 'Essential comforts for your  journey',

            highSpeedWifi: 'High-Speed WiFi',
            herbalTea: 'Herbal Tea Selection',
            climateControl: 'Climate Control',
            organicToiletries: 'Organic Toiletries',
            dailyHousekeeping: 'Daily Housekeeping',
            concierge: '24/7 Concierge',
            yogaMat: 'Yoga Mat & Props',

            beginHealing: 'Begin Your Healing Journey',
            beginHealingDesc: 'Experience authentic Ayurvedic  in serene riverside surroundings designed to nurture your body, calm your mind, and restore your spirit.',
            reserveRoom: 'Reserve Your Room',
            speakAdvisor: 'Speak to  Advisor',

            exploreOurRooms: 'Explore Our Rooms'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',

            heroSubtitle: 'Ayurveda by the riverside',
            heroTagline: 'Find balance, breathe easy, and renew your energy in Aluthgama',
            exploreResort: 'Explore resort',
            bookNow: 'Book now',

            welcomeLabel: 'Welcome',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Nestled along the serene riverside of Bentota, Muthumuni Ayurveda River Resort offers a harmonious blend of ancient healing traditions and tranquil natural beauty. Our sanctuary invites you to embark on a transformative journey, where the gentle flow of the river meets the timeless wisdom of Ayurveda.',
            welcomeDesc2: 'Experience personalized Ayurvedic treatments, savor nourishing cuisine crafted to balance your dosha, and unwind in elegantly appointed rooms with breathtaking riverside views. Whether you seek rejuvenation, relaxation, or spiritual renewal, our dedicated team of Ayurvedic practitioners and experts are here to guide you every step of the way.',
            learnMore: 'Learn More',
            contactUs: 'Contact Us',
            welcomeImageCaption: 'Ayurveda & River Retreat',
            welcomeImageLocation: 'Aluthgama, Sri Lanka',

            service1Title: 'Holistic Ayurveda Therapies',
            service1Desc: 'Personalized consultations, authentic herbal oils, and daily treatments guided by experienced Ayurveda doctors.',

            service2Title: 'Riverside Rooms',
            service2Desc: 'Wake up to the gentle sounds of the river, private balconies, and calming interiors designed for deep rest.',

            service3Title: 'Cuisine',
            service3Desc: 'Fresh Sri Lankan produce, plant-forward menus, and tailored meal plans that complement your dosha.',

            service4Title: 'Yoga & Mindfulness',
            service4Desc: 'Sunrise yoga, sunset meditation, and breathwork sessions set against the rhythm of the waves.',

            service5Title: 'Riverside & Coastal Excursions',
            service5Desc: 'Boat rides on the Bentota River, turtle hatchery visits, spice garden walks, and village cycling tours.',

            highlightTitle: 'A riverside Ayurveda sanctuary',
            highlightDesc: 'Discover holistic healing along the peaceful riverside of Bentota. From tailored treatments to quiet balconies and mindful cuisine, every detail is crafted to restore your rhythm.',

            roomsTitle: 'Our Rooms',
            roomsDesc: 'Choose the sanctuary that matches your pace, from breezy suites to cozy deluxe hideaways, each layered with soft linens, warm wood, and sunrise-ready balconies.',
            room1Title: 'Deluxe Rooms',
            room1Desc: 'Cozy retreats with plush beds, garden views, and warm wooden accents for everyday ease.',
            room2Title: 'Deluxe River View',
            room2Desc: 'Wake to the serene river vista, soft linens, and a private balcony made for peaceful mornings.',
            viewRoom: 'View Room',
            bookableNow: 'Bookable now',
            riverBreezeReady: 'River breeze ready',
            roomBadge: 'Riverside Escape',

            achievementsTitle: 'Trusted by the riverside',
            achievement1Title: 'Happy Guests',
            achievement1Count: '1,000+',
            achievement2Title: 'Ayurveda Treatments',
            achievement2Count: '20+',
            achievement3Title: 'Years of Care',
            achievement3Count: '15+',
            achievement4Title: 'Traveler Accolades',
            achievement4Count: '1,000+',

            experiencesTitle: 'Explore Muthumuni Ayurveda River Resort Experiences',
            experiencesDesc: 'From Ayurveda journeys to curated excursions, choose the experiences that make your stay memorable.',
            planYourStay: 'Plan your stay',
            experience1Title: 'Our Rooms',
            experience1Desc: 'Airy spaces with balconies, river or garden views, and thoughtful comforts for unhurried stays.',
            experience2Title: 'Ayurveda Spa',
            experience2Desc: 'Authentic therapies, steam baths, and restorative massages delivered with time-honored rituals.',
            experience3Title: 'Dining by the River',
            experience3Desc: 'Nutritious Sri Lankan and international cuisine crafted to nourish body and mind.',
            experience4Title: 'Experiences & Tours',
            experience4Desc: 'River safaris, temple visits, water sports, and curated cultural excursions around Bentota.',

            galleryTitle: 'Moments at Muthumuni Ayurveda River Resort',
            galleryDesc: 'A glimpse into our riverside sanctuary—sunrises, serene treatments, nourishing plates, and quiet corners made for you.',
            gallery1Alt: 'Sunlit palm-lined riverbank at Muthumuni',
            gallery2Alt: 'Ayurveda oil treatment in progress',
            gallery3Alt: 'Resort pool with loungers',
            gallery4Alt: 'Herbal ingredients prepared for spa',
            gallery5Alt: 'Couple enjoying sunset by the river',
            gallery6Alt: 'Yoga deck facing the river',
            gallery7Alt: 'Tropical garden pathway',
            gallery8Alt: 'Healthy breakfast spread',
            gallery9Alt: 'Serene riverside view',
            gallery10Alt: 'Warmly lit resort exterior at dusk',
            gallery11Alt: 'Ayurveda herbs and oils display',
            gallery12Alt: 'Cozy seating by the garden',

            boatLabel: 'River Adventures',
            boatTitle: 'Boat Rides on Bentota River',
            boatDesc1: 'Experience the magic of the Bentota River with our enchanting boat rides. Glide through serene waterways surrounded by lush mangrove forests, spotting exotic wildlife including colorful kingfishers, crocodiles, monitor lizards, and playful monkeys. Perfect for nature lovers and photographers seeking unforgettable moments.',
            boatDesc2: 'Whether you choose a peaceful morning cruise, a romantic sunset journey, or an adventurous wildlife exploration, our knowledgeable guides will share fascinating insights about the river\'s ecosystem. Customize your experience with our private charter options, or join our group tours for a more intimate connection with nature.',
            boatFeature1: 'Scenic river cruises through mangroves',
            boatFeature2: 'Wildlife spotting—birds, crocodiles & monkeys',
            boatFeature3: 'Sunrise & sunset boat tour options',
            boatFeature4: 'Experienced local guides included',
            boatImageAlt: 'Boat ride on Bentota River',

            poolLabel: 'Aquatic Serenity',
            poolTitle: 'Pool Area',
            poolDesc1: 'Immerse yourself in tranquility at our pristine pool, where crystal-clear waters meet lush tropical gardens. Designed for relaxation and rejuvenation, our pool area offers the perfect escape to unwind under the Sri Lankan sun.',
            poolDesc2: 'Whether you prefer a refreshing morning swim, an afternoon lounging session with a good book, or a peaceful evening dip, our pool area provides an idyllic setting. Surrounded by comfortable sun loungers, shaded cabanas, and attentive poolside service, every moment becomes a cherished memory.',
            poolFeature1: 'Temperature-controlled pool',
            poolFeature2: 'Surrounded by tropical garden landscapes',
            poolFeature3: 'Poolside refreshments & healthy snacks',
            poolFeature4: 'Premium sun loungers with umbrellas',
            poolImageAlt: 'Relaxing pool area',

            testimonialsTitle: 'Guests on their stay',

            bookingDestination: 'Destination',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Check-in',
            bookingCheckOut: 'Check-out',
            bookingGuests: 'Guests',
            guestsOption1: '1 Guest',
            guestsOption2: '2 Guests',
            guestsOption3: '3 Guests',
            guestsOption4: '4+ Guests',
            bookingCheckAvailability: 'Check Availability'
        },
        aboutus2: {
            heroTitle: 'About Us',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Ancient wisdom meets tranquil riverside beauty at Muthumuni Ayurveda River Resort',
            heroTagline2: 'Personalized Ayurvedic treatments, riverside views and genuine Sri Lankan hospitality',
            slide1: 'Ayurvedic Healing',
            slide2: 'Riverside Serenity',
            slide3: 'Garden Tranquility',
            slide4: 'Herbal Therapies',
            slide5: 'River',
            historyLabel: 'Our Journey',
            historyTitle: 'History of Muthumuni Ayurveda River Resort',
            historyDesc1: 'Established over two decades ago, Muthumuni Ayurveda River Resort was born from a vision to create a sanctuary where ancient Ayurvedic wisdom meets the tranquil beauty of Sri Lanka\'s riverside landscapes. What began as a modest retreat has blossomed into one of Aluthgama\'s most cherished destinations for holistic healing and rejuvenation.',
            historyDesc3: 'Today, Muthumuni stands as a testament to the enduring power of Ayurveda, having welcomed thousands of guests from around the world. Each visitor becomes part of our story, finding balance, healing, and transformation in our peaceful riverside haven.',
            statYear: '15+',
            statYearLabel: 'Years of Excellence',
            statGuest: '1,000+',
            statGuestLabel: 'Happy Guests Served',
            experienceLegacy: 'Experience Our Legacy',
            established: 'Established',
            sinceYear: 'Since 1993',
            chairmanLabel: 'Chairman\'s Message',
            chairmanTitle: 'Guided by Care, Rooted in Ayurveda',
            chairmanDesc1: 'Welcome to Muthumuni Ayurveda River Resort. For over two decades, our purpose has been simple: to offer genuine healing grounded in the timeless wisdom of Ayurveda, delivered with the warmth of Sri Lankan hospitality.',
            chairmanDesc2: 'Here, every detail—from our therapies and cuisine to the tranquility of our spaces—is designed to help you slow down, restore balance, and reconnect with yourself. We are honored to be a part of your journey.',
            chairmanDesc3: 'On behalf of our dedicated team, I invite you to experience the care, authenticity, and serenity that define Muthumuni.',
            chairmanBadge: 'Chairman',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Chairman Mr. Nihal Muthumuni',
            staffLabel: 'Our Team',
            staffTitle: 'Meet Our Dedicated Staff',
            staffDesc1: 'At Muthumuni Ayurveda River Resort, our team is the heart of everything we do. Our staff members are carefully selected and trained professionals who share a deep passion for Ayurvedic and authentic hospitality.',
            staffDesc2: 'From our experienced Ayurvedic practitioners and skilled massage therapists to our dedicated hospitality team, each member brings years of expertise and genuine care to every guest interaction. We believe that true comes not just from treatments, but from the warmth and attention of people who genuinely care about your journey.',
            staffDesc3: 'Our staff undergoes continuous training in the latest Ayurvedic practices while maintaining the highest standards of professionalism and cultural sensitivity. We take pride in creating meaningful connections with our guests, ensuring that every visit becomes a memorable and transformative experience.',
            statStaff: '15+',
            statStaffLabel: 'Skilled Professionals',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Guest Satisfaction',
            staffImageAlt: 'Our dedicated staff team at Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Our Commitment',
            excellenceCare: 'Excellence & Care',
            ctaLabel: 'Get in Touch',
            ctaHeading: 'Ready to Begin Your Journey?',
            ctaDesc: 'Connect with our team to book your personalized Ayurvedic retreat. Whether you have questions about our therapies, accommodations, or special packages, we\'re here to help create your perfect escape.',
            ctaButtonContact: 'Contact Us Now',
            ctaButtonRooms: 'Explore Rooms',
            quickInfoCall: 'Call Us',
            quickInfoEmail: 'Email Us',
            quickInfoLocation: 'Location',
            locationCity: 'Aluthgama, Sri Lanka'
        },

        footer: {
            description: 'Muthumuni Ayurveda Beach Resort is committed to providing exceptional hospitality and experiences, ensuring every guest feels valued and rejuvenated.',
            linksTitle: 'Links',
            contactTitle: 'Contact Us',
            viewLocation: 'View Location',
            navHome: 'Home',
            navAbout: 'About',
            navContact: 'Contact',
            navRooms: 'Rooms',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Developed By',
            developerName: 'Redev Solution +94 764 608 225'
        },
        blogs: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort Blogs',
            heroSubtitle1: 'Stories from the shore, Ayurveda rituals at',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Dive into tips, history, and behind-the-scenes notes.',
            heroAlt: 'Resort beachfront walkway at sunset',
            sectionTitle: 'Muthumuni Ayurveda Beach Resort Blogs',
            sectionDescription: 'Guides, stories, and notes from our coastline retreat—spanning Ayurveda rituals, gemstone lore, and travel tips around Bentota.',
            ayurvedaTitle: 'The Heart of Authentic Ayurveda',
            ayurvedaExcerpt: 'Experience time-honored healing traditions rooted in Sri Lanka\'s ancient wisdom.',
            ayurvedaDescription: 'At Muthumuni Ayurveda Beach Resort, Ayurveda is more than a treatment — it is a way of life. Our therapies are based on centuries-old knowledge, personalized to your body type, and guided by experienced Ayurvedic physicians for deep, lasting balance.',
            ayurvedaAlt: 'Ayurvedic treatment setup with herbal oils and natural elements',
            healingTitle: 'Personalized Healing Journeys',
            healingExcerpt: 'Why every guest\'s program is uniquely designed.',
            healingDescription: 'From initial consultations to daily treatments, your healing journey is carefully tailored. Herbal therapies, therapeutic massages, yoga, and meditation work together to restore harmony between body, mind, and spirit.',
            healingAlt: 'Ayurvedic doctor consulting a guest in a calm setting',
            natureTitle: 'Healing by the Ocean',
            natureExcerpt: 'How the sea breeze and tropical surroundings enhance your journey.',
            natureDescription: 'Nestled along Sri Lanka\'s tranquil coastline, Muthumuni offers a naturally healing environment. The sound of waves, fresh ocean air, and lush greenery amplify the effects of Ayurveda, creating deep relaxation and renewal.',
            natureAlt: 'Beachfront view of the resort with palm trees and ocean',
            foodTitle: 'Ayurvedic Cuisine for Inner Balance',
            foodExcerpt: 'Nourishing meals crafted to support your treatment.',
            foodDescription: 'Our Ayurvedic cuisine is freshly prepared using seasonal, locally sourced ingredients. Each meal is aligned with your dosha, supporting digestion, detoxification, and overall vitality while remaining flavorful and satisfying.',
            foodAlt: 'Traditional Ayurvedic meal served in natural bowls',
            yogaTitle: 'Yoga, Meditation & Inner Stillness',
            yogaExcerpt: 'Gentle practices that calm the mind and strengthen the body.',
            yogaDescription: 'Daily yoga and meditation sessions complement your treatments, improving flexibility, breathing, and mental clarity. These mindful practices help you reconnect with yourself and carry a sense of peace beyond your stay.',
            yogaAlt: 'Guests practicing yoga facing the ocean at sunrise',
            lifestyleTitle: 'Bringing Ayurveda Home',
            lifestyleExcerpt: 'Simple lifestyle practices to continue your journey.',
            lifestyleDescription: 'Before you depart, our experts guide you on maintaining balance through daily routines, diet, and self-care rituals. Take home more than memories — take home a sustainable path to healthier living.',
            lifestyleAlt: 'Guest relaxing with herbal tea in a serene resort setting',
            readMore: 'Read more'
        },
        blogs2: {
            heroTitle: 'Muthumuni Ayurveda River Resort Blogs',
            heroSubtitle1: 'Stories from the riverside, Ayurveda rituals at',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Dive into tips, history, and behind-the-scenes notes.',
            heroAlt: 'Resort riverside walkway at sunset',
            sectionTitle: 'Muthumuni Ayurveda River Resort Blogs',
            sectionDescription: 'Guides, stories, and notes from our riverside retreat—spanning Ayurveda rituals, practices, and travel tips around Bentota.',
            ayurvedaTitle: 'The Heart of Authentic Ayurveda',
            ayurvedaExcerpt: 'Experience time-honored healing traditions rooted in Sri Lanka\'s ancient wisdom.',
            ayurvedaDescription: 'At Muthumuni Ayurveda River Resort, Ayurveda is more than a treatment — it is a way of life. Our therapies are based on centuries-old knowledge, personalized to your body type, and guided by experienced Ayurvedic physicians for deep, lasting balance.',
            ayurvedaAlt: 'Ayurvedic treatment setup with herbal oils and natural elements',
            healingTitle: 'Personalized Healing Journeys',
            healingExcerpt: 'Why every guest\'s program is uniquely designed.',
            healingDescription: 'From initial consultations to daily treatments, your healing journey is carefully tailored. Herbal therapies, therapeutic massages, yoga, and meditation work together to restore harmony between body, mind, and spirit.',
            healingAlt: 'Ayurvedic doctor consulting a guest in a calm setting',
            natureTitle: 'Healing by the Riverside',
            natureExcerpt: 'How the serene river setting and tropical surroundings enhance your journey.',
            natureDescription: 'Nestled along Sri Lanka\'s tranquil riverside, Muthumuni offers a naturally healing environment. The gentle flow of the river, fresh air, and lush greenery amplify the effects of Ayurveda, creating deep relaxation and renewal.',
            natureAlt: 'Riverside view of the resort with palm trees and nature',
            foodTitle: 'Ayurvedic Cuisine for Inner Balance',
            foodExcerpt: 'Nourishing meals crafted to support your treatment.',
            foodDescription: 'Our Ayurvedic cuisine is freshly prepared using seasonal, locally sourced ingredients. Each meal is aligned with your dosha, supporting digestion, detoxification, and overall vitality while remaining flavorful and satisfying.',
            foodAlt: 'Traditional Ayurvedic meal served in natural bowls',
            yogaTitle: 'Yoga, Meditation & Inner Stillness',
            yogaExcerpt: 'Gentle practices that calm the mind and strengthen the body.',
            yogaDescription: 'Daily yoga and meditation sessions complement your treatments, improving flexibility, breathing, and mental clarity. These mindful practices help you reconnect with yourself and carry a sense of peace beyond your stay.',
            yogaAlt: 'Guests practicing yoga facing the river at sunrise',
            lifestyleTitle: 'Bringing Ayurveda Home',
            lifestyleExcerpt: 'Simple lifestyle practices to continue your journey.',
            lifestyleDescription: 'Before you depart, our experts guide you on maintaining balance through daily routines, diet, and self-care rituals. Take home more than memories — take home a sustainable path to healthier living.',
            lifestyleAlt: 'Guest relaxing with herbal tea in a serene resort setting',
            readMore: 'Read more'
        },
        events: {
            heroEyebrow: 'Experiences & Activities',
            heroTitle: 'Our Events',
            heroSubtitle: 'Curated experiences that blend Sri Lankan tradition with coastal luxury',
            heroAlt: 'Events at Muthumuni',
            availableDaily: 'Available Daily',
            bookNow: 'Book Now',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} detail',
            ctaTitle: 'Ready to Create Memories?',
            ctaDescription: 'Contact our team to customize your perfect event experience at Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Contact Us',
            ctaViewRooms: 'View Rooms',
            cookeryTitle: 'Cookery Programs',
            cookerySubtitle: 'Taste of Sri Lanka',
            cookeryDescription: 'Immerse yourself in the vibrant flavors of Sri Lankan cuisine. Our expert chefs guide you through hands-on cooking sessions, teaching you traditional recipes passed down through generations. Learn to prepare aromatic curries, hoppers, coconut sambol, and more using fresh local ingredients.',
            cookeryHighlight1: 'Traditional Sri Lankan recipes',
            cookeryHighlight2: 'Hands-on cooking experience',
            cookeryHighlight3: 'Fresh local ingredients',
            cookeryHighlight4: 'Take recipes home',
            cookeryHighlight5: 'Spice garden tour included',
            meditationTitle: 'Meditation Programs',
            meditationSubtitle: 'Inner Peace & Mindfulness',
            meditationDescription: 'Find tranquility in our guided meditation sessions set against the serene backdrop of the Indian Ocean. Our experienced instructors lead you through ancient mindfulness techniques, breathing exercises, and yoga practices designed to calm the mind and rejuvenate the spirit.',
            meditationHighlight1: 'Sunrise & sunset sessions',
            meditationHighlight2: 'Beachfront meditation',
            meditationHighlight3: 'Guided by experts',
            meditationHighlight4: 'Breathing techniques',
            meditationHighlight5: 'Yoga & mindfulness practices',
            bbqTitle: 'BBQ Events',
            bbqSubtitle: 'Beachside Celebrations',
            bbqDescription: 'Experience unforgettable evenings with our beachside BBQ events. Savor freshly grilled seafood, premium meats, and vegetarian delights while the waves whisper nearby. Live music, fire dancers, and the starlit sky create the perfect ambiance for celebration and connection.',
            bbqHighlight1: 'Fresh grilled seafood',
            bbqHighlight2: 'Oceanfront dining',
            bbqHighlight3: 'Live entertainment',
            bbqHighlight4: 'Bonfire experience',
            bbqHighlight5: 'Customizable menus',
            boatTitle: 'Boat Rides',
            boatSubtitle: 'River & Coastal Adventures',
            boatDescription: 'Embark on enchanting boat journeys along the Bentota River and coastal waters. Glide through mangrove forests, spot exotic birds and wildlife, or enjoy romantic sunset cruises. Our boat rides offer a unique perspective of Sri Lanka\'s natural beauty and diverse ecosystems.',
            boatHighlight1: 'Bentota River cruises',
            boatHighlight2: 'Mangrove exploration',
            boatHighlight3: 'Wildlife spotting',
            boatHighlight4: 'Sunset boat tours',
            boatHighlight5: 'Private charter available',
            ayurvedaLecturesTitle: 'Ayurveda Doctors\' Lectures',
            ayurvedaLecturesSubtitle: 'Ancient Wisdom & Modern Practices',
            ayurvedaLecturesDescription: 'Discover the profound principles of Ayurveda through expert-led lectures by certified Ayurvedic doctors and practitioners. Learn about dosha balancing, herbal remedies, holistic healing practices, and how ancient wisdom applies to modern times. Our interactive sessions demystify Ayurvedic philosophy and its application to daily life.',
            ayurvedaLecturesHighlight1: 'Certified Ayurveda doctors',
            ayurvedaLecturesHighlight2: 'Personalized dosha analysis',
            ayurvedaLecturesHighlight3: 'Herbal remedy education',
            ayurvedaLecturesHighlight4: 'Q&A sessions included',
            ayurvedaLecturesHighlight5: 'Take-home guide',
            traditionalClothsTitle: 'Traditional Cloths Wearing Events',
            traditionalClothsSubtitle: 'Cultural Heritage Experience',
            traditionalClothsDescription: 'Immerse yourself in Sri Lankan cultural heritage by learning to wear and appreciate traditional attire. Our expert stylists guide you through dressing in authentic Kandyan sarees and traditional garments, explaining the cultural significance of each piece. Perfect for special occasions, cultural appreciation, or creating memorable photos.',
            traditionalClothsHighlight1: 'Expert styling guidance',
            traditionalClothsHighlight2: 'Authentic traditional sarees',
            traditionalClothsHighlight3: 'Cultural significance explained',
            traditionalClothsHighlight4: 'Professional photography included',
            traditionalClothsHighlight5: 'Fashion fusion workshops'
        },
        events2: {
            heroEyebrow: 'Experiences & Activities',
            heroTitle: 'Our Events',
            heroSubtitle: 'Curated experiences that blend Sri Lankan tradition with coastal luxury',
            heroAlt: 'Events at Muthumuni',
            availableDaily: 'Available Daily',
            bookNow: 'Book Now',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} detail',
            ctaTitle: 'Ready to Create Memories?',
            ctaDescription: 'Contact our team to customize your perfect event experience at Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Contact Us',
            ctaViewRooms: 'View Rooms',
            cookeryTitle: 'Cookery Programs',
            cookerySubtitle: 'Taste of Sri Lanka',
            cookeryDescription: 'Immerse yourself in the vibrant flavors of Sri Lankan cuisine. Our expert chefs guide you through hands-on cooking sessions, teaching you traditional recipes passed down through generations. Learn to prepare aromatic curries, hoppers, coconut sambol, and more using fresh local ingredients.',
            cookeryHighlight1: 'Traditional Sri Lankan recipes',
            cookeryHighlight2: 'Hands-on cooking experience',
            cookeryHighlight3: 'Fresh local ingredients',
            cookeryHighlight4: 'Take recipes home',
            cookeryHighlight5: 'Spice garden tour included',
            meditationTitle: 'Meditation Programs',
            meditationSubtitle: 'Inner Peace & Mindfulness',
            meditationDescription: 'Find tranquility in our guided meditation sessions set against the serene backdrop of the Indian Ocean. Our experienced instructors lead you through ancient mindfulness techniques, breathing exercises, and yoga practices designed to calm the mind and rejuvenate the spirit.',
            meditationHighlight1: 'Sunrise & sunset sessions',
            meditationHighlight2: 'Beachfront meditation',
            meditationHighlight3: 'Guided by experts',
            meditationHighlight4: 'Breathing techniques',
            meditationHighlight5: 'Yoga & mindfulness practices',
            bbqTitle: 'BBQ Events',
            bbqSubtitle: 'Beachside Celebrations',
            bbqDescription: 'Experience unforgettable evenings with our beachside BBQ events. Savor freshly grilled seafood, premium meats, and vegetarian delights while the waves whisper nearby. Live music, fire dancers, and the starlit sky create the perfect ambiance for celebration and connection.',
            bbqHighlight1: 'Fresh grilled seafood',
            bbqHighlight2: 'Oceanfront dining',
            bbqHighlight3: 'Live entertainment',
            bbqHighlight4: 'Bonfire experience',
            bbqHighlight5: 'Customizable menus',
            boatTitle: 'Boat Rides',
            boatSubtitle: 'River & Coastal Adventures',
            boatDescription: 'Embark on enchanting boat journeys along the Bentota River and coastal waters. Glide through mangrove forests, spot exotic birds and wildlife, or enjoy romantic sunset cruises. Our boat rides offer a unique perspective of Sri Lanka\'s natural beauty and diverse ecosystems.',
            boatHighlight1: 'Bentota River cruises',
            boatHighlight2: 'Mangrove exploration',
            boatHighlight3: 'Wildlife spotting',
            boatHighlight4: 'Sunset boat tours',
            boatHighlight5: 'Private charter available',
            ayurvedaLecturesTitle: 'Ayurveda Doctors\' Lectures',
            ayurvedaLecturesSubtitle: 'Ancient Wisdom & Modern Practices',
            ayurvedaLecturesDescription: 'Discover the profound principles of Ayurveda through expert-led lectures by certified Ayurvedic doctors and practitioners. Learn about dosha balancing, herbal remedies, holistic healing practices, and how ancient wisdom applies to modern times. Our interactive sessions demystify Ayurvedic philosophy and its application to daily life.',
            ayurvedaLecturesHighlight1: 'Certified Ayurveda doctors',
            ayurvedaLecturesHighlight2: 'Personalized dosha analysis',
            ayurvedaLecturesHighlight3: 'Herbal remedy education',
            ayurvedaLecturesHighlight4: 'Q&A sessions included',
            ayurvedaLecturesHighlight5: 'Take-home guide',
            traditionalClothsTitle: 'Traditional Cloths Wearing Events',
            traditionalClothsSubtitle: 'Cultural Heritage Experience',
            traditionalClothsDescription: 'Immerse yourself in Sri Lankan cultural heritage by learning to wear and appreciate traditional attire. Our expert stylists guide you through dressing in authentic Kandyan sarees and traditional garments, explaining the cultural significance of each piece. Perfect for special occasions, cultural appreciation, or creating memorable photos.',
            traditionalClothsHighlight1: 'Expert styling guidance',
            traditionalClothsHighlight2: 'Authentic traditional sarees',
            traditionalClothsHighlight3: 'Cultural significance explained',
            traditionalClothsHighlight4: 'Professional photography included',
            traditionalClothsHighlight5: 'Fashion fusion workshops'
        },
        food: {
            heroTitle: 'Ayurvedic Dining & Coastal Cuisine',
            heroSubtitle: 'Authentic Sri Lankan Flavors & Fresh Coastal Cuisine',
            heroAlt: 'Culinary Experience at Muthumuni Beach Resort',
            wellnessEyebrow: 'Through Food',
            wellnessTitle: 'The Importance of',
            ayurvedicFood: 'Ayurvedic Food',
            wellnessIntro1: 'In Ayurveda, food is considered the greatest medicine. What you eat directly influences your doshas (Vata, Pitta, Kapha), digestion (agni), and overall balance of body, mind, and spirit.',
            wellnessIntro2: 'Ayurvedic nutrition emphasizes fresh, seasonal, whole foods prepared with care and mindful eating. It promotes six tastes (sweet, sour, salty, pungent, bitter, astringent) in every meal to nourish all senses and maintain harmony.',
            wellnessIntro3: 'Proper Ayurvedic food supports strong digestion, helps remove toxins (ama), boosts immunity, improves energy, reduces stress, and prevents many chronic conditions. At Muthumuni, every dish is crafted to align with your unique constitution for deep healing and vitality.',
            foodImage1Alt: 'Traditional Ayurvedic meal with six tastes',
            foodImage2Alt: 'Ayurvedic herbs and spices for balanced nutrition',
            culinaryPhilosophyEyebrow: 'Our Culinary Philosophy',
            culinaryPhilosophyTitle: 'Ayurvedic',
            nutritionHighlight: 'Nutrition',
            culinaryPhilosophyResort: 'at Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ayurvedic Cuisine at Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Fresh & Nourishing',
            healingIngredientsAlt: 'Healthy Ayurvedic Ingredients and Spices',
            healingIngredientsLabel: 'Healing Ingredients',
            philosophyText1: 'The food, which encompasses the six main tastes (sweet, sour, salty, bitter, pungent, and astringent) along with many subtle variations, has been described in classical Ayurvedic texts—some dating back over 5,000 years—together with each food\'s essential properties: Guna (inherent quality), Virya (potency/heating or cooling effect), Vipaka (post-digestive impact), and Prabhava (unique special action).',
            philosophyText2: 'As a result, Ayurvedic nutrition plays a central role at Muthumuni Ayurveda Beach Resort. This does not mean a rigid, monotonous regimen of bland, tasteless, or overly bitter vegetarian meals dictated solely by physicians. On the contrary, our Ayurveda kitchen stands out as one of our greatest strengths: the dishes prepared by our skilled cooks will surprise and delight you every single day of your stay!',
            philosophyText3: 'At breakfast, enjoy a generous buffet featuring fresh tropical fruits, freshly squeezed juices, nourishing herbal soups, home-baked breads and light cookies, plus a variety of authentic Sri Lankan breakfast options. For lunch, savor a colorful and flavorful buffet with mild fish curries, vegetable preparations, and herbal-infused dishes. In the evening, we serve a set vegetarian menu with a fresh fish option available. On Saturdays, we celebrate "Sri Lankan Night" with an expanded buffet—our chefs prepare traditional local specialties right in front of you, creating a lively and authentic experience.',
            philosophyText4: 'In Ayurveda, foods and beverages are classified in many ways—according to taste and properties, the body\'s digestive capacity (agni), suitability for specific health conditions, seasonal appropriateness, and more. At Muthumuni, we carefully consider all these factors simultaneously, making a conscious effort to include all six tastes in balanced combinations tailored to each guest\'s individual constitution.',
            philosophyText5: 'Our meals feature fresh vegetables, tropical fruits, and responsibly sourced fish. We do not serve red meat or alcohol.',
            philosophyText6: 'During meal times, an Ayurvedic doctor or qualified dietician is always available to guide you. They will advise on the most suitable vegetables, herbs, and spices for your current treatment phase and help you select or avoid dishes accordingly. Your personalized herbal elixir and any specific instructions from the health centre team will be placed on your individual table.',
            philosophyText7: 'This level of personalized care and attention to diet is a hallmark of the Muthumuni Ayurveda Beach Resort experience.',
            philosophyText8: 'Food is regarded as Prana—the vital life-sustaining energy—for every human being. That is why we encourage you to approach each meal with full awareness: savoring the aromas, experiencing the tastes, feeling the gentle warmth, and enjoying the mouth-watering sensations mindfully.',
            diningExperienceEyebrow: 'Dining Experience',
            restaurantTitlePrefix: 'Our',
            ayurvedicHighlight: 'Ayurvedic',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Our Ayurvedic restaurant at Muthumuni Beach Resort offers a unique dining experience that harmonizes traditional Ayurvedic principles with authentic Sri Lankan coastal cuisine. We prioritize fresh, locally sourced ingredients to create meals that not only delight the palate but also promote holistic well-being.',
            restaurantDetail2: 'The menu is thoughtfully crafted to balance the six tastes (sweet, sour, salty, bitter, pungent, and astringent) in every dish, ensuring a nourishing and satisfying experience. Each meal is prepared with care, incorporating Ayurvedic herbs and spices known for their healing properties.',
            restaurantDetail3: 'Guests can enjoy a variety of dishes tailored to their individual doshas (body constitutions), with options for vegetarian, vegan, and pescatarian diets. Our chefs work closely with Ayurvedic practitioners to ensure that each meal supports the guests\' health and goals.',
            restaurantDetail4: 'The restaurant\'s ambiance reflects the serene coastal environment, providing a tranquil setting for mindful eating. Whether you\'re indulging in a hearty breakfast buffet or savoring a gourmet dinner, every meal at our Ayurvedic restaurant is an opportunity to nourish both body and soul.',
            restaurantDetail5: 'Join us at Muthumuni Beach Resort\'s Ayurvedic restaurant for a culinary journey that celebrates the rich flavors of Sri Lanka while embracing the timeless wisdom of Ayurveda.',
            restaurantImageAlt: 'Dining at Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Premium Dining',
            premiumDiningDescription: 'Experience authentic Ayurvedic cuisine in a serene riverside setting'
        },
        food2: {
            heroTitle: 'Ayurvedic Dining & Coastal Cuisine',
            heroSubtitle: 'Authentic Sri Lankan Flavors & Fresh Coastal Cuisine',
            heroAlt: 'Culinary Experience at Muthumuni Beach Resort',
            wellnessEyebrow: 'Through Food',
            wellnessTitle: 'The Importance of',
            ayurvedicFood: 'Ayurvedic Food',
            wellnessIntro1: 'In Ayurveda, food is considered the greatest medicine. What you eat directly influences your doshas (Vata, Pitta, Kapha), digestion (agni), and overall balance of body, mind, and spirit.',
            wellnessIntro2: 'Ayurvedic nutrition emphasizes fresh, seasonal, whole foods prepared with care and mindful eating. It promotes six tastes (sweet, sour, salty, pungent, bitter, astringent) in every meal to nourish all senses and maintain harmony.',
            wellnessIntro3: 'Proper Ayurvedic food supports strong digestion, helps remove toxins (ama), boosts immunity, improves energy, reduces stress, and prevents many chronic conditions. At Muthumuni, every dish is crafted to align with your unique constitution for deep healing and vitality.',
            foodImage1Alt: 'Traditional Ayurvedic meal with six tastes',
            foodImage2Alt: 'Ayurvedic herbs and spices for balanced nutrition',
            culinaryPhilosophyEyebrow: 'Our Culinary Philosophy',
            culinaryPhilosophyTitle: 'Ayurvedic',
            nutritionHighlight: 'Nutrition',
            culinaryPhilosophyResort: 'at Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ayurvedic Cuisine at Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Fresh & Nourishing',
            healingIngredientsAlt: 'Healthy Ayurvedic Ingredients and Spices',
            healingIngredientsLabel: 'Healing Ingredients',
            philosophyText1: 'The food, which encompasses the six main tastes (sweet, sour, salty, bitter, pungent, and astringent) along with many subtle variations, has been described in classical Ayurvedic texts—some dating back over 5,000 years—together with each food\'s essential properties: Guna (inherent quality), Virya (potency/heating or cooling effect), Vipaka (post-digestive impact), and Prabhava (unique special action).',
            philosophyText2: 'As a result, Ayurvedic nutrition plays a central role at Muthumuni Ayurveda Beach Resort. This does not mean a rigid, monotonous regimen of bland, tasteless, or overly bitter vegetarian meals dictated solely by physicians. On the contrary, our Ayurveda kitchen stands out as one of our greatest strengths: the dishes prepared by our skilled cooks will surprise and delight you every single day of your stay!',
            philosophyText3: 'At breakfast, enjoy a generous buffet featuring fresh tropical fruits, freshly squeezed juices, nourishing herbal soups, home-baked breads and light cookies, plus a variety of authentic Sri Lankan breakfast options. For lunch, savor a colorful and flavorful buffet with mild fish curries, vegetable preparations, and herbal-infused dishes. In the evening, we serve a set vegetarian menu with a fresh fish option available. On Saturdays, we celebrate "Sri Lankan Night" with an expanded buffet—our chefs prepare traditional local specialties right in front of you, creating a lively and authentic experience.',
            philosophyText4: 'In Ayurveda, foods and beverages are classified in many ways—according to taste and properties, the body\'s digestive capacity (agni), suitability for specific health conditions, seasonal appropriateness, and more. At Muthumuni, we carefully consider all these factors simultaneously, making a conscious effort to include all six tastes in balanced combinations tailored to each guest\'s individual constitution.',
            philosophyText5: 'Our meals feature fresh vegetables, tropical fruits, and responsibly sourced fish. We do not serve red meat or alcohol.',
            philosophyText6: 'During meal times, an Ayurvedic doctor or qualified dietician is always available to guide you. They will advise on the most suitable vegetables, herbs, and spices for your current treatment phase and help you select or avoid dishes accordingly. Your personalized herbal elixir and any specific instructions from the health centre team will be placed on your individual table.',
            philosophyText7: 'This level of personalized care and attention to diet is a hallmark of the Muthumuni Ayurveda Beach Resort experience.',
            philosophyText8: 'Food is regarded as Prana—the vital life-sustaining energy—for every human being. That is why we encourage you to approach each meal with full awareness: savoring the aromas, experiencing the tastes, feeling the gentle warmth, and enjoying the mouth-watering sensations mindfully.',
            diningExperienceEyebrow: 'Dining Experience',
            restaurantTitlePrefix: 'Our',
            ayurvedicHighlight: 'Ayurvedic',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Our Ayurvedic restaurant at Muthumuni Beach Resort offers a unique dining experience that harmonizes traditional Ayurvedic principles with authentic Sri Lankan coastal cuisine. We prioritize fresh, locally sourced ingredients to create meals that not only delight the palate but also promote holistic well-being.',
            restaurantDetail2: 'The menu is thoughtfully crafted to balance the six tastes (sweet, sour, salty, bitter, pungent, and astringent) in every dish, ensuring a nourishing and satisfying experience. Each meal is prepared with care, incorporating Ayurvedic herbs and spices known for their healing properties.',
            restaurantDetail3: 'Guests can enjoy a variety of dishes tailored to their individual doshas (body constitutions), with options for vegetarian, vegan, and pescatarian diets. Our chefs work closely with Ayurvedic practitioners to ensure that each meal supports the guests\' health and goals.',
            restaurantDetail4: 'The restaurant\'s ambiance reflects the serene coastal environment, providing a tranquil setting for mindful eating. Whether you\'re indulging in a hearty breakfast buffet or savoring a gourmet dinner, every meal at our Ayurvedic restaurant is an opportunity to nourish both body and soul.',
            restaurantDetail5: 'Join us at Muthumuni Beach Resort\'s Ayurvedic restaurant for a culinary journey that celebrates the rich flavors of Sri Lanka while embracing the timeless wisdom of Ayurveda.',
            restaurantImageAlt: 'Dining at Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Premium Dining',
            premiumDiningDescription: 'Experience authentic Ayurvedic cuisine in a serene riverside setting'
        },
        yoga: {
            heroTitle: 'Yoga at Resort',
            heroSubtitle: 'Find Balance, Strength & Inner Peace in Beruwala',
            heroAlt: 'Yoga at Muthumuni Beach Resort',
            importanceEyebrow: '& Balance',
            importanceTitle: 'Importance of Yoga & Meditation',
            importanceImageAlt: 'Importance of Yoga and Meditation',
            importanceText1: 'Yoga and meditation are ancient practices that offer numerous physical, mental, and emotional benefits. They promote flexibility, strength, and balance while reducing stress and anxiety.',
            importanceText2: 'Regular practice can enhance concentration, improve sleep quality, and boost overall well-being. Yoga also encourages mindfulness, helping individuals connect with their inner selves and find peace amidst the chaos of daily life.',
            importanceText3: 'At Muthumuni Beach Resort, we provide serene environments perfect for practicing yoga and meditation, allowing guests to rejuvenate their mind, body, and spirit.',
            practiceEyebrow: 'Our Practice',
            practiceTitle: 'Yoga Practice & Experience',
            practiceImageAlt: 'Yoga Practice at Resort',
            practiceText1: 'At Muthumuni Ayurveda Beach Resort, yoga is practiced primarily as traditional Hatha Yoga, combined with Pranayama (breathing techniques). This holistic approach is designed to awaken inner awareness and gently stimulate the Kundalini (often referred to as the third eye). Special emphasis is placed on spinal alignment and flexibility, as a supple spine is believed to slow the aging process—“You are only as old as your spine.”',
            practiceText2: 'Yoga sessions are conducted four times per week and are suitable for both beginners and experienced practitioners. From time to time, special sessions such as Ashtanga Yoga are also introduced, allowing guests to experience a variety of postures and routines. Our Ayurvedic physicians encourage regular participation to support and enhance the overall treatment program.',
            practiceText3: 'All yoga sessions are held in our dedicated Yoga Shala, a calm and serene space designed to support focus, balance, and mindful movement. Each session typically begins with Sun Salutations, followed by Pranayama and a sequence of carefully selected asanas aimed at improving flexibility, circulation, and overall well-being.',
            practiceText4: 'Our experienced yoga teachers adapt each session according to the individual needs, abilities, and health conditions of the guests, ensuring a safe, supportive, and deeply beneficial yoga experience for everyone.',
            spiritualEyebrow: 'Spiritual Journey',
            spiritualTitle: 'Meditation & Spiritual Activities',
            spiritualSubtitle: 'Deepen your spiritual practice with our sacred ceremonies and guided meditation sessions',
            meditationImageAlt: 'Meditation and Spiritual Practice at the Resort',
            meditationTitle: 'Meditation Sessions',
            meditationDesc: 'Guests are invited to participate in guided meditation sessions held three times per week, inspired by Buddhist traditions. These sessions are designed to calm the mind, deepen awareness, and support emotional and spiritual healing. The meditation takes place at a peaceful island temple, which guests reach by boat—adding a serene and meaningful journey that enhances the overall meditative experience.'
        },
        yoga2: {
            heroTitle: 'Yoga at Resort',
            heroSubtitle: 'Find Balance, Strength & Inner Peace in Aluthgama',
            heroAlt: 'Yoga at Muthumuni Resort',
            importanceEyebrow: '& Balance',
            importanceTitle: 'Importance of Yoga & Meditation',
            importanceImageAlt: 'Importance of Yoga and Meditation',
            importanceText1: 'Yoga and meditation are ancient practices that offer numerous physical, mental, and emotional benefits. They promote flexibility, strength, and balance while reducing stress and anxiety.',
            importanceText2: 'Regular practice can enhance concentration, improve sleep quality, and boost overall well-being. Yoga also encourages mindfulness, helping individuals connect with their inner selves and find peace amidst the chaos of daily life.',
            importanceText3: 'At Muthumuni Resort, we provide serene environments perfect for practicing yoga and meditation, allowing guests to rejuvenate their mind, body, and spirit.',
            practiceEyebrow: 'Our Practice',
            practiceTitle: 'Yoga Practice & Experience',
            practiceImageAlt: 'Yoga Practice at Resort',
            practiceText1: 'At Muthumuni Resort, yoga is practiced primarily as traditional Hatha Yoga, combined with Pranayama (breathing techniques). This holistic approach is designed to awaken inner awareness and gently stimulate the Kundalini while placing emphasis on spinal alignment and flexibility.',
            practiceText2: 'Yoga sessions are held regularly and are suitable for both beginners and experienced practitioners. From time to time, special sessions such as Ashtanga Yoga are also introduced.',
            practiceText3: 'All yoga sessions are held in our dedicated Yoga Shala, a calm and serene space designed to support focus, balance, and mindful movement. Each session typically begins with Sun Salutations, followed by Pranayama and a sequence of carefully selected asanas aimed at improving flexibility and circulation.',
            practiceText4: 'Our experienced yoga teachers adapt each session according to the individual needs, abilities, and health conditions of the guests, ensuring a safe and deeply beneficial experience.',
            spiritualEyebrow: 'Spiritual Journey',
            spiritualTitle: 'Meditation & Spiritual Activities',
            spiritualSubtitle: 'Deepen your spiritual practice with our sacred ceremonies and guided meditation sessions',
            meditationImageAlt: 'Meditation and Spiritual Practice at the Resort',
            meditationTitle: 'Meditation Sessions',
            meditationDesc: 'Guests are invited to participate in guided meditation sessions inspired by traditional practices. These sessions are designed to calm the mind, deepen awareness, and support emotional and spiritual healing in a peaceful environment.'
        },

        ayurveda2: {
            accordionTitle1: 'What is Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (a Sanskrit word meaning "science of life") is an ancient whole-body healing system. Panchakarma is a suite of cleansing and rejuvenating therapies designed to restore balance between mind, body, and spirit.',
            accordionTitle2: 'Panchakarma Ayurveda and Your Life Energy',
            accordionDesc2: 'Panchakarma focuses on removing toxins and re-establishing harmony among the doshas (Vata, Pitta, Kapha). Treatments are personalized to each guest to support lasting well-being and vitality.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Vata governs movement and circulation. When balanced, it fosters creativity and vitality. Panchakarma offers grounding treatments to soothe excess Vata and restore equilibrium.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'Pitta governs digestion and metabolism. Cooling, restorative therapies help balance Pitta and reduce inflammation and irritability.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha supports structure and stability. Energizing and circulation-enhancing therapies are used to reduce excess Kapha and promote lightness and flexibility.',
            close: 'Close',
            next: 'Next',
            previous: 'Previous',
            treatmentsTitle: 'Our Signature Panchakarma Ayurvedic Treatments',
            treatmentsSubtitle: 'Time-honored therapies to detoxify, rejuvenate, and restore balance.',
            bookTreatment: 'Book This Treatment',
            benefitsTitle: 'Benefits of Panchakarma Treatments',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'A gentle pouring of warm herbal oil over the forehead to calm the mind.',
            shirodhara1: 'Reduces stress and anxiety',
            shirodhara2: 'Promotes better sleep',
            shirodhara3: 'Enhances mental clarity',
            steamBath: 'Steam Bath',
            steamBathDesc: 'A detoxifying steam treatment to open pores and relax muscles.',
            steamBath1: 'Detoxifies the body',
            steamBath2: 'Improves circulation',
            steamBath3: 'Relieves muscle tension',
            flowerBath: 'Flower Bath',
            flowerBathDesc: 'A soothing bath infused with aromatic flowers for relaxation.',
            flowerBath1: 'Calms the nervous system',
            flowerBath2: 'Hydrates the skin',
            flowerBath3: 'Uplifts mood',
            headMassage: 'Head Massage',
            headMassageDesc: 'A relaxing massage targeting the scalp to relieve tension.',
            headMassage1: 'Reduces headaches',
            headMassage2: 'Improves scalp health',
            headMassage3: 'Promotes relaxation',
            faceMassage: 'Face Massage',
            faceMassageDesc: 'A rejuvenating massage to enhance facial glow and reduce stress.',
            faceMassage1: 'Improves skin tone',
            faceMassage2: 'Reduces facial tension',
            faceMassage3: 'Promotes lymphatic drainage',
            neckMassage: 'Neck Massage',
            neckMassageDesc: 'Focused massage to relieve neck stiffness and tension.',
            neckMassage1: 'Relieves neck pain',
            neckMassage2: 'Improves flexibility',
            neckMassage3: 'Reduces stress',
            shoulderMassage: 'Shoulder Massage',
            shoulderMassageDesc: 'Targeted massage to ease shoulder stiffness and discomfort.',
            shoulderMassage1: 'Reduces shoulder pain',
            shoulderMassage2: 'Improves posture',
            shoulderMassage3: 'Relaxes muscles',
            bodyMassage: 'Body Massage',
            bodyMassageDesc: 'A full-body massage to promote overall relaxation .',
            bodyMassage1: 'Enhances circulation',
            bodyMassage2: 'Relieves muscle soreness',
            bodyMassage3: 'Promotes relaxation',
            backMassage: 'Back Massage',
            backMassageDesc: 'A therapeutic massage targeting back pain and tension.',
            backMassage1: 'Alleviates back pain',
            backMassage2: 'Improves spinal health',
            backMassage3: 'Reduces stress',
            footMassage: 'Foot Massage',
            footMassageDesc: 'A soothing massage to relieve foot pain and promote relaxation.',
            footMassage1: 'Improves circulation',
            footMassage2: 'Reduces foot fatigue',
            footMassage3: 'Promotes relaxation',
            purgative: 'Purgative',
            purgativeDesc: 'A cleansing therapy to eliminate excess Pitta and toxins from the digestive system.',
            purgative1: 'Cleanses the colon',
            purgative2: 'Balances Pitta dosha',
            purgative3: 'Improves digestive health',
            nasalClearing: 'Nasal Cleansing',
            nasalClearingDesc: 'A therapeutic nasal treatment to clear sinuses and improve respiratory function.',
            nasalClearing1: 'Clears nasal congestion',
            nasalClearing2: 'Enhances breathing',
            nasalClearing3: 'Relieves sinus issues',
            powderMassage: 'Powder Massage',
            powderMassageDesc: 'An exfoliating massage using herbal powders to rejuvenate and refresh the skin.',
            powderMassage1: 'Exfoliates dead skin',
            powderMassage2: 'Improves skin texture',
            powderMassage3: 'Promotes circulation',
            intensiveMassage: 'Intensive Massage',
            intensiveMassageDesc: 'A deep therapeutic massage targeting chronic tension and muscle knots with firm pressure and specialized techniques.',
            intensiveMassage1: 'Relieves deep muscle tension',
            intensiveMassage2: 'Improves blood circulation',
            intensiveMassage3: 'Reduces muscle soreness',
            thermoMassage: 'Thermo Massage',
            thermoMassageDesc: 'A warm herbal oil massage using heated therapeutic oils to enhance relaxation and healing benefits.',
            thermoMassage1: 'Soothes sore muscles',
            thermoMassage2: 'Promotes deep relaxation',
            thermoMassage3: 'Enhances energy flow',
            synchronMassage: 'Synchron Massage',
            synchronMassageDesc: 'A synchronized dual-therapist massage for complete body harmony and balanced energy distribution.',
            synchronMassage1: 'Full body harmony',
            synchronMassage2: 'Balanced energy flow',
            synchronMassage3: 'Deep relaxation experience',
            specialMassage: 'Special Massage',
            specialMassageDesc: 'Customized massage therapy tailored to your specific health needs and personal wellness goals.',
            specialMassage1: 'Personalized treatment',
            specialMassage2: 'Targets specific concerns',
            specialMassage3: 'Customized healing approach',
            benefit1Title: 'Detoxification:',
            benefit1Desc: 'Panchakarma treatments help eliminate toxins from the body, promoting overall health and vitality.',
            benefit2Title: 'Improved Digestion:',
            benefit2Desc: 'These therapies enhance digestive function, leading to better nutrient absorption and metabolism.',
            benefit3Title: 'Stress Relief:',
            benefit3Desc: 'Panchakarma is known for its calming effects on the mind and body, reducing stress and anxiety levels.',
            benefit4Title: 'Enhanced Immunity:',
            benefit4Desc: 'Regular Panchakarma treatments can strengthen the immune system, making the body more resilient to illnesses.',
            benefit5Title: 'Rejuvenation:',
            benefit5Desc: 'The therapies promote cellular regeneration, leading to improved skin health and a youthful appearance.',
            benefit6Title: 'Balance of Doshas:',
            benefit6Desc: 'Panchakarma helps restore the balance of the body\'s doshas (Vata, Pitta, Kapha), which is essential for maintaining health according to Ayurvedic principles.',
            akkupancharTitle: 'Acupuncture Therapy',
            akkupancharDesc1: 'is an ancient Ayurvedic therapy that involves the use of herbal pastes and oils applied to specific points on the body. This therapeutic treatment is designed to stimulate vital energy channels and promote healing.',
            akkupancharBenefit: 'Key Benefits:',
            akkupancharDesc2: 'This specialized therapy helps in relieving chronic pain, improving joint flexibility, enhancing blood circulation, and restoring the body\'s natural energy flow. It is particularly effective for those seeking deep therapeutic healing and rejuvenation.',
            akkupancharApplication: 'Therapeutic Application:',
            akkupancharDesc3: 'Acupuncture works by targeting specific marma points (vital junctions) throughout the body, using carefully selected herbal preparations to balance the doshas and promote optimal health and wellness.',
            akkupancharTransform: 'Experience Transformation:',
            akkupancharDesc4: 'At Muthumuni Ayurveda River Resort, our experienced practitioners customize each Acupuncture session to address your unique health needs, ensuring a profound and lasting healing experience.',
            gallery1: 'Shirodhara Therapy',
            gallery2: 'Steam Bath',
            gallery3: 'Flower Bath',
            gallery4: 'Head Massage',
            gallery5: 'Body Massage',
            gallery6: 'Neck Massage',
            gallery7: 'Face Massage',
            gallery8: 'Shoulder Massage',
            sectionEyebrow: 'Panchakarma Ayurveda at Muthumuni',
            sectionDescription: 'Discover the ancient healing art of Panchakarma Ayurveda at our riverside retreat. Our expert Ayurvedic practitioners offer personalized treatments designed to detoxify, rejuvenate, and restore balance to your body, mind, and spirit.',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Rejuvenate Body, Mind & Spirit in Aluthgama',
            heroAlt: 'Ayurveda & at Muthumuni River Resort',
            treatmentProgramme: {
                title: 'Ayurveda Treatment Programme',
                subtitle: 'Your Journey to Balance, Detox & Deep Renewal',
                intro: 'Experience authentic Ayurvedic healing in a peaceful retreat designed to restore your body, calm your mind, and renew your energy. From the moment you arrive, our team takes care of every detail—so you can fully focus on your wellbeing.',
                welcomeTitle: 'Welcome & Gentle Start',
                welcome1: 'Airport pick-up and transfer to the hotel',
                welcome2: 'Warm welcome and hotel orientation',
                welcome3: 'Introduction to your weekly wellness schedule',
                welcome4: 'Relaxation Massage (Day 1) at the Ayurveda Centre to release travel fatigue and prepare your body for treatments',
                doctorTitle: 'Doctor Consultation & Personal Plan',
                doctor1: 'Ayurvedic Doctor Consultation (Day 2 – morning)',
                doctor2: 'Full assessment of your Dosha/body type and health concerns',
                doctor3: 'Translator available upon request',
                doctor4: 'Your doctor creates a personalised treatment plan tailored to your needs and goals',
                dailyTitle: 'Daily Ayurveda Therapies',
                daily1: '4–5 treatments daily (as recommended by the doctor)',
                daily2: 'Therapies selected based on your body constitution and condition',
                daily3: 'Special massages may be added when required',
                daily4: 'Doctor monitors progress daily and may adjust treatments and herbal support to ensure the best results',
                daily5: 'If suitable, a gentle cleansing/purgative process may be recommended',
                herbalTitle: 'Herbal Medicine Support',
                herbalIntro: 'Doctor-prescribed herbal medicines served twice daily:',
                herbal1: 'during breakfast',
                herbal2: 'during dinner',
                herbalClosing: 'Supporting internal healing, detoxification and long-lasting balance.',
                yogaTitle: 'Yoga & Meditation for Mind–Body Harmony',
                yoga1: 'Yoga sessions 4 times per week (approx. 1 hour)',
                yoga2: 'Meditation sessions 2 times per week:',
                yoga3: '— a unique spiritual experience at an Island Temple, reached by boat',
                yoga4: '— guided meditation led by monks (approx. 1 hour)',
                wellnessTitle: 'Included Wellness Experiences',
                wellness1: 'Weekly healthy cookery demonstrations',
                wellness2: 'Free excursion (culture/nature experience)',
                closingTitle: 'Closing Ritual & Departure',
                closing1: 'A beautiful Flower Bath (last day)—a traditional ritual of renewal',
                closing2: 'Final Doctor Consultation to review progress and provide:',
                closing3: '— continued wellness guidance',
                closing4: '— prescriptions and recommendations for home',
                closing5: 'Transfer back to the airport',
            }
        },

        ayurveda: {
            accordionTitle1: 'What is Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (a Sanskrit word that means "science of life" or "knowledge of life") is one of the world\'s oldest whole-body healing systems. It was developed more than 5,000 years ago. Panchakarma Ayurveda is based on the belief that health and balance depend on a delicate balance between the mind, body, spirit, and environment. The main goal of Ayurvedic medicine is to promote good health and prevent, not fight disease. However treatments may be geared toward specific health problems.',
            accordionTitle2: 'Panchakarma Ayurveda and Your Life Energy',
            accordionDesc2: 'Ayurveda is based on the theory that everything in the universe – dead or alive – is connected. If your mind, body, and spirit are in harmony with the universe, you have good health. When something disrupts this balance, you get sick. Among the things that can upset this balance are genetic or birth defects, injuries, climate and seasonal change, age, and your emotions.\n\nThose who practice Ayurveda believe every person is made of five basic elements found in the universe: space, air, fire, water, and earth. These combine in the human body to form three life forces, or energies, called doshas. They control how your body works. They are VATA dosha (space and air); PITTA dosha (fire and water); and KAPHA dosha (water and earth).\n\nEveryone inherits a unique mix of the three doshas. But one is usually stronger than the others. Each one controls a different body function. It\'s believed that your chances of getting sick – and the health issues you develop – are linked to the balance of your doshas.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Those who practice Ayurveda believe this is the most powerful of all three doshas. It controls very basic body functions, like how cells divide. It also controls your mind, breathing, blood flow, heart function, and ability to get rid of waste through your intestines. Things that can disrupt it include eating again too soon after a meal, fear, grief, and staying up too late.\n\nIf Vata is your dominant dosha, you may be smart, creative, vibrant, and your moods change quickly. Physically, you may be thin and lose weight easily, and are usually cold. When you are out of balance, you can get overstimulated and have anxiety, phobias, and be forgetful. You can also be more likely to have conditions like asthma, heart disease, skin problems, and rheumatoid arthritis.\n\nIn Ayurveda, like increases like. For this dosha (space and air), you can balance out too much Vata by doing things that are grounding like meditation, massage, keeping a regular sleep and wake schedule, and eating warm, mild foods.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'This energy controls your digestion, metabolism (how well you break down foods), and certain hormones that are linked to your appetite. Things that can disrupt Pitta are eating sour or spicy foods, spending too much time in the sun, and missing meals.\n\nIf you are Pitta dominant, then you may be goal-oriented, competitive, confident, and a natural leader. Physically, you may have a medium-sized, muscular build and tend to be hot most of the time.\n\nWhen out of balance, you can be too competitive, cranky, quick to anger, and impulsive. If Pitta is your main dosha, you\'re thought to be more likely to have conditions like Crohn\'s disease, heart disease, high blood pressure, indigestion, and fever when you are out of balance.\n\nTo bring Pitta (fire and water) back into balance, you can focus on things that are cooling and light, like salads, cucumbers, and practicing moderation and slow or restorative yoga.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha dosha is thought to control muscle growth, body strength and stability, weight, and your immune system. Things that can disrupt Kapha include daytime naps, eating too many sweet foods, and eating or drinking things that contain too much salt or water.\n\nIf Kapha is your main dosha, you may like routine, stick to expectations, and be accepting, calm, and patient. Physically, you are more likely to have a broad frame and easily gain weight.\n\nWhen out of balance, you can easily get fatigued, avoid taking on new projects, and be possessive, stubborn, and depressed. If you are Kapha dominant, you may be more likely to develop asthma and other breathing disorders, cancer, diabetes, nausea after eating, and obesity.\n\nTo reduce excess Kapha (earth and water) and be more balanced, you can increase the amount of fruits and vegetables in your diet, and do exercise that gets the blood flowing like jogging or sun salutations in yoga.',
            close: 'Close',
            next: 'Next',
            previous: 'Previous',
            treatmentsTitle: 'Our Signature Panchakarma Ayurvedic Treatments',
            treatmentsSubtitle: 'Experience time-honored therapies designed to restore balance, release tension, and rejuvenate your entire being.',
            bookTreatment: 'Book This Treatment',
            benefitsTitle: 'Benefits of Panchakarma Treatments',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'A gentle pouring of warm herbal oil over the forehead to calm the mind.',
            shirodhara1: 'Reduces stress and anxiety',
            shirodhara2: 'Promotes better sleep',
            shirodhara3: 'Enhances mental clarity',
            steamBath: 'Steam Bath',
            steamBathDesc: 'A detoxifying steam treatment to open pores and relax muscles.',
            steamBath1: 'Detoxifies the body',
            steamBath2: 'Improves circulation',
            steamBath3: 'Relieves muscle tension',
            flowerBath: 'Flower Bath',
            flowerBathDesc: 'A soothing bath infused with aromatic flowers for relaxation.',
            flowerBath1: 'Calms the nervous system',
            flowerBath2: 'Hydrates the skin',
            flowerBath3: 'Uplifts mood',
            headMassage: 'Head Massage',
            headMassageDesc: 'A relaxing massage targeting the scalp to relieve tension.',
            headMassage1: 'Reduces headaches',
            headMassage2: 'Improves scalp health',
            headMassage3: 'Promotes relaxation',
            faceMassage: 'Face Massage',
            faceMassageDesc: 'A rejuvenating massage to enhance facial glow and reduce stress.',
            faceMassage1: 'Improves skin tone',
            faceMassage2: 'Reduces facial tension',
            faceMassage3: 'Promotes lymphatic drainage',
            neckMassage: 'Neck Massage',
            neckMassageDesc: 'Focused massage to relieve neck stiffness and tension.',
            neckMassage1: 'Relieves neck pain',
            neckMassage2: 'Improves flexibility',
            neckMassage3: 'Reduces stress',
            shoulderMassage: 'Shoulder Massage',
            shoulderMassageDesc: 'Targeted massage to ease shoulder stiffness and discomfort.',
            shoulderMassage1: 'Reduces shoulder pain',
            shoulderMassage2: 'Improves posture',
            shoulderMassage3: 'Relaxes muscles',
            bodyMassage: 'Body Massage',
            bodyMassageDesc: 'A full-body massage to promote overall relaxation .',
            bodyMassage1: 'Enhances circulation',
            bodyMassage2: 'Relieves muscle soreness',
            bodyMassage3: 'Promotes relaxation',
            backMassage: 'Back Massage',
            backMassageDesc: 'A therapeutic massage targeting back pain and tension.',
            backMassage1: 'Alleviates back pain',
            backMassage2: 'Improves spinal health',
            backMassage3: 'Reduces stress',
            footMassage: 'Foot Massage',
            footMassageDesc: 'A soothing massage to relieve foot pain and promote relaxation.',
            footMassage1: 'Improves circulation',
            footMassage2: 'Reduces foot fatigue',
            footMassage3: 'Promotes relaxation',
            purgative: 'Purgative',
            purgativeDesc: 'A cleansing therapy to eliminate excess Pitta and toxins from the digestive system.',
            purgative1: 'Cleanses the colon',
            purgative2: 'Balances Pitta dosha',
            purgative3: 'Improves digestive health',
            nasalClearing: 'Nasal Cleansing',
            nasalClearingDesc: 'A therapeutic nasal treatment to clear sinuses and improve respiratory function.',
            nasalClearing1: 'Clears nasal congestion',
            nasalClearing2: 'Enhances breathing',
            nasalClearing3: 'Relieves sinus issues',
            powderMassage: 'Powder Massage',
            powderMassageDesc: 'An exfoliating massage using herbal powders to rejuvenate and refresh the skin.',
            powderMassage1: 'Exfoliates dead skin',
            powderMassage2: 'Improves skin texture',
            powderMassage3: 'Promotes circulation',
            intensiveMassageDesc: 'A deep therapeutic massage targeting chronic tension and muscle knots with firm pressure and specialized techniques.',
            intensiveMassage1: 'Relieves deep muscle tension',
            intensiveMassage2: 'Improves blood circulation',
            intensiveMassage3: 'Reduces muscle soreness',
            thermoMassage: 'Thermo Massage',
            thermoMassageDesc: 'A warm herbal oil massage using heated therapeutic oils to enhance relaxation and healing benefits.',
            thermoMassage1: 'Soothes sore muscles',
            thermoMassage2: 'Promotes deep relaxation',
            thermoMassage3: 'Enhances energy flow',
            synchronMassage: 'Synchron Massage',
            synchronMassageDesc: 'A synchronized dual-therapist massage for complete body harmony and balanced energy distribution.',
            synchronMassage1: 'Full body harmony',
            synchronMassage2: 'Balanced energy flow',
            synchronMassage3: 'Deep relaxation experience',
            specialMassage: 'Special Massage',
            specialMassageDesc: 'Customized massage therapy tailored to your specific health needs and personal wellness goals.',
            specialMassage1: 'Personalized treatment',
            specialMassage2: 'Targets specific concerns',
            specialMassage3: 'Customized healing approach',
            benefit1Title: 'Detoxification:',
            benefit1Desc: 'Panchakarma treatments help eliminate toxins from the body, promoting overall health and vitality.',
            benefit2Title: 'Improved Digestion:',
            benefit2Desc: 'These therapies enhance digestive function, leading to better nutrient absorption and metabolism.',
            benefit3Title: 'Stress Relief:',
            benefit3Desc: 'Panchakarma is known for its calming effects on the mind and body, reducing stress and anxiety levels.',
            benefit4Title: 'Enhanced Immunity:',
            benefit4Desc: 'Regular Panchakarma treatments can strengthen the immune system, making the body more resilient to illnesses.',
            benefit5Title: 'Rejuvenation:',
            benefit5Desc: 'The therapies promote cellular regeneration, leading to improved skin health and a youthful appearance.',
            benefit6Title: 'Balance of Doshas:',
            benefit6Desc: 'Panchakarma helps restore the balance of the body\'s doshas (Vata, Pitta, Kapha), which is essential for maintaining health according to Ayurvedic principles.',
            akkupancharTitle: 'Acupuncture Therapy',
            akkupancharDesc1: 'is an ancient Ayurvedic therapy that involves the use of herbal pastes and oils applied to specific points on the body. This therapeutic treatment is designed to stimulate vital energy channels and promote healing.',
            akkupancharBenefit: 'Key Benefits:',
            akkupancharDesc2: 'This specialized therapy helps in relieving chronic pain, improving joint flexibility, enhancing blood circulation, and restoring the body\'s natural energy flow. It is particularly effective for those seeking deep therapeutic healing and rejuvenation.',
            akkupancharApplication: 'Therapeutic Application:',
            akkupancharDesc3: 'Acupuncture works by targeting specific marma points (vital junctions) throughout the body, using carefully selected herbal preparations to balance the doshas and promote optimal health.',
            akkupancharTransform: 'Experience Transformation:',
            akkupancharDesc4: 'At Muthumuni Ayurveda Beach Resort, our experienced practitioners customize each Acupuncture session to address your unique health needs, ensuring a profound and lasting healing experience.',
            gallery1: 'Shirodhara Therapy',
            gallery2: 'Steam Bath',
            gallery3: 'Flower Bath',
            gallery4: 'Head Massage',
            gallery5: 'Body Massage',
            gallery6: 'Neck Massage',
            gallery7: 'Face Massage',
            gallery8: 'Shoulder Massage',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Rejuvenate Body, Mind & Spirit in Beruwala',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA AT MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Discover the ancient healing art of Panchakarma Ayurveda at Muthumuni Ayurveda Beach Resort in Beruwala, Sri Lanka. Our expert Ayurvedic practitioners offer personalized treatments designed to detoxify, rejuvenate, and restore balance to your body, mind, and spirit.',
            treatmentProgramme: {
                title: 'Ayurveda Treatment Programme',
                subtitle: 'Your Journey to Balance, Detox & Deep Renewal',
                intro: 'Experience authentic Ayurvedic healing in a peaceful retreat designed to restore your body, calm your mind, and renew your energy. From the moment you arrive, our team takes care of every detail—so you can fully focus on your wellbeing.',
                welcomeTitle: 'Welcome & Gentle Start',
                contact: {
                    heroTitle: 'Contact Us',
                    heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
                    heroAlt: 'Contact Us',
                    sectionTitle: 'Feel Free To Contact Us',
                    sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
                    sectionDescription: 'Contact Muthumuni Ayurveda Beach Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Beruwala, Mororgalla.',
                    callUs: 'Call Us',
                    emailTitle: 'Email',
                    ourLocation: 'Our Location',
                    locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
                    socialNetwork: 'Social Network',
                    ariaFacebook: 'Facebook',
                    ariaInstagram: 'Instagram',
                    ariaWhatsApp: 'WhatsApp',
                    ariaTikTok: 'TikTok',
                    getInTouch: 'Get In Touch',
                    getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
                    nameLabel: 'Name',
                    emailLabel: 'Email',
                    contactNumberLabel: 'Contact Number',
                    messageLabel: 'Message',
                    sending: 'Sending...',
                    sendMessage: 'Send Message',
                    successMessage: "Your message has been sent successfully! We'll get back to you soon.",
                    errorMessage: 'An error occurred while sending your message. Please try again.',
                    findUsOnMap: 'Find Us on the Map',
                    whatsappSubject: 'Muthumuni Ayurveda Beach Resort Contact',
                    whatsappName: 'Name',
                    whatsappEmail: 'Email',
                    whatsappContactNumber: 'Contact Number',
                    whatsappMessage: 'Message'
                },
                contact2: {
                    heroTitle: 'Contact Us',
                    heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
                    heroAlt: 'Contact Us',
                    sectionTitle: 'Feel Free To Contact Us',
                    sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
                    sectionDescription: 'Contact Muthumuni Ayurveda Beach Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Beruwala, Mororgalla.',
                    callUs: 'Call Us',
                    emailTitle: 'Email',
                    ourLocation: 'Our Location',
                    locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
                    socialNetwork: 'Social Network',
                    ariaFacebook: 'Facebook',
                    ariaInstagram: 'Instagram',
                    ariaWhatsApp: 'WhatsApp',
                    ariaTikTok: 'TikTok',
                    getInTouch: 'Get In Touch',
                    getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
                    nameLabel: 'Name',
                    emailLabel: 'Email',
                    contactNumberLabel: 'Contact Number',
                    messageLabel: 'Message',
                    sending: 'Sending...',
                    sendMessage: 'Send Message',
                    successMessage: "Your message has been sent successfully! We'll get back to you soon.",
                    errorMessage: 'An error occurred while sending your message. Please try again.',
                    findUsOnMap: 'Find Us on the Map',
                    whatsappSubject: 'Muthumuni Ayurveda Beach Resort Contact',
                    whatsappName: 'Name',
                    whatsappEmail: 'Email',
                    whatsappContactNumber: 'Contact Number',
                    whatsappMessage: 'Message'
                },

            },
        },
        tours: {
            heroTitle: 'Tours & Excursions',
            heroSubtitle: 'Discover Sri Lanka\'s Beauty from Beruwala',
            kandeAlt: 'Kande Vihara Temple - Beruwala',
            kandeTitle: 'Kande Vihara Temple Visit',
            kandeBuddhaAlt: 'Giant Buddha Statue at Kande Vihara Temple',
            bentotaTitle: 'Bentota River Boat Safari',
            bentotaAlt: 'Bentota River Boat Safari - Mangroves and Wildlife',
            galleTitle: 'Galle Old City Tour',
            galleAlt: 'Galle Old City Tour',
            sigiriyaTitle: 'Sigiriya Rock Fortress Tour',
            sigiriyaAlt: 'Sigiriya Rock Fortress Tour',
            kandyTitle: 'Kandy Cultural Tour',
            kandyAlt: 'Kandy Cultural Tour',
            bookTour: 'Book This Tour',
            introPara1: 'Sri Lanka is a land of timeless beauty, where golden beaches, lush green landscapes, ancient temples, and vibrant culture come together in perfect harmony.',
            introPara2: 'From the tranquil southwest coast to historic cities, sacred sites, wildlife sanctuaries, and misty hill country, every journey offers a unique and unforgettable experience.',
            introPara3: 'Starting from Muthumuni Ayurveda Beach Resort in Beruwala, our carefully curated tours and excursions are designed to enrich your stay while perfectly balancing exploration, relaxation, .',
            kandeDetail1: 'Kande Vihara Temple (Kande Viharaya) – one of the most iconic Buddhist temples near Beruwala.',
            kandeDetail2: 'Founded in 1734, this serene \'Mountain Temple\' sits atop a hill offering peaceful views over the coastline.',
            kandeDetail3: 'Highlights include the massive 48-meter (160 ft) seated Buddha statue (one of Sri Lanka\'s tallest), intricate Kandyan-era frescoes, ancient relic chamber, beautiful moonstone entrance, and a sacred Bodhi tree over 300 years old.',
            kandeDetail4: 'A perfect half-day spiritual & cultural experience – ideal for morning visits to avoid heat.',
            bentotaDetail1: 'Enjoy a peaceful and scenic boat safari along the Bentota River, one of the most popular nature excursions near Beruwala.',
            bentotaDetail2: 'Glide through lush mangroves, narrow canals, and serene backwaters while spotting local wildlife.',
            bentotaDetail3: 'Common sightings include monitor lizards, crocodiles, various bird species (kingfishers, herons, eagles), monkeys, and occasionally otters or water snakes.',
            bentotaDetail4: 'Your experienced boatman/guide will point out interesting flora, traditional fishing methods, and riverside village life.',
            bentotaDetail5: 'Perfect for nature lovers and photographers – calm, relaxing, and complementary to your Ayurvedic stay.',
            galleDetail1: 'Explore the historic Galle Fort, a UNESCO World Heritage Site and one of Sri Lanka\'s most well-preserved colonial-era forts.',
            galleDetail2: 'Wander through cobblestone streets lined with Dutch colonial buildings, boutique shops, cafes, and art galleries.',
            galleDetail3: 'Visit key landmarks such as the Galle Lighthouse, Dutch Reformed Church, National Maritime Museum, and the ramparts offering stunning ocean views.',
            galleDetail4: 'Learn about the fort\'s rich history, architecture, and cultural significance from your knowledgeable guide.',
            galleDetail5: 'Ideal for history buffs, culture enthusiasts, and those looking to experience Sri Lanka\'s colonial past.',
            sigiriyaDetail1: 'Discover the ancient rock fortress of Sigiriya, one of Sri Lanka\'s most iconic landmarks and a UNESCO World Heritage Site.',
            sigiriyaDetail2: 'Climb the impressive rock to explore the ruins of King Kasyapa\'s palace, adorned with frescoes, water gardens, and the famous Mirror Wall.',
            sigiriyaDetail3: 'Enjoy panoramic views of the surrounding jungle and countryside from the summit.',
            sigiriyaDetail4: 'Learn about the fascinating history, architecture, and legends associated with Sigiriya from your expert guide.',
            sigiriyaDetail5: 'Perfect for history enthusiasts, adventure seekers, and those interested in Sri Lanka\'s rich cultural heritage.',
            kandyDetail1: 'Experience the vibrant culture of Kandy, Sri Lanka\'s last royal capital and a UNESCO World Heritage Site.',
            kandyDetail2: 'Visit the Temple of the Sacred Tooth Relic (Sri Dalada Maligawa), one of the most important Buddhist sites in the world.',
            kandyDetail3: 'Explore the Royal Botanical Gardens in Peradeniya, home to a vast collection of tropical plants and orchids.',
            kandyDetail4: 'Enjoy a traditional Kandyan dance performance, showcasing Sri Lanka\'s rich artistic heritage.',
            kandyDetail5: 'Ideal for culture enthusiasts, history buffs, and those looking to immerse themselves in Sri Lanka\'s traditions.'
        },
        tours2: {
            heroTitle: 'Tours & Excursions',
            heroSubtitle: 'Discover Sri Lanka\'s Beauty from Beruwala',
            kandeAlt: 'Kande Vihara Temple - Beruwala',
            kandeTitle: 'Kande Vihara Temple Visit',
            kandeBuddhaAlt: 'Giant Buddha Statue at Kande Vihara Temple',
            bentotaTitle: 'Bentota River Boat Safari',
            bentotaAlt: 'Bentota River Boat Safari - Mangroves and Wildlife',
            galleTitle: 'Galle Old City Tour',
            galleAlt: 'Galle Old City Tour',
            sigiriyaTitle: 'Sigiriya Rock Fortress Tour',
            sigiriyaAlt: 'Sigiriya Rock Fortress Tour',
            kandyTitle: 'Kandy Cultural Tour',
            kandyAlt: 'Kandy Cultural Tour',
            bookTour: 'Book This Tour',
            introPara1: 'Sri Lanka is a land of timeless beauty, where golden beaches, lush green landscapes, ancient temples, and vibrant culture come together in perfect harmony.',
            introPara2: 'From the tranquil southwest coast to historic cities, sacred sites, wildlife sanctuaries, and misty hill country, every journey offers a unique and unforgettable experience.',
            introPara3: 'Starting from Muthumuni Ayurveda Beach Resort in Beruwala, our carefully curated tours and excursions are designed to enrich your stay while perfectly balancing exploration, relaxation, .',
            kandeDetail1: 'Kande Vihara Temple (Kande Viharaya) – one of the most iconic Buddhist temples near Beruwala.',
            kandeDetail2: 'Founded in 1734, this serene \'Mountain Temple\' sits atop a hill offering peaceful views over the coastline.',
            kandeDetail3: 'Highlights include the massive 48-meter (160 ft) seated Buddha statue (one of Sri Lanka\'s tallest), intricate Kandyan-era frescoes, ancient relic chamber, beautiful moonstone entrance, and a sacred Bodhi tree over 300 years old.',
            kandeDetail4: 'A perfect half-day spiritual & cultural experience – ideal for morning visits to avoid heat.',
            bentotaDetail1: 'Enjoy a peaceful and scenic boat safari along the Bentota River, one of the most popular nature excursions near Beruwala.',
            bentotaDetail2: 'Glide through lush mangroves, narrow canals, and serene backwaters while spotting local wildlife.',
            bentotaDetail3: 'Common sightings include monitor lizards, crocodiles, various bird species (kingfishers, herons, eagles), monkeys, and occasionally otters or water snakes.',
            bentotaDetail4: 'Your experienced boatman/guide will point out interesting flora, traditional fishing methods, and riverside village life.',
            bentotaDetail5: 'Perfect for nature lovers and photographers – calm, relaxing, and complementary to your Ayurvedic stay.',
            galleDetail1: 'Explore the historic Galle Fort, a UNESCO World Heritage Site and one of Sri Lanka\'s most well-preserved colonial-era forts.',
            galleDetail2: 'Wander through cobblestone streets lined with Dutch colonial buildings, boutique shops, cafes, and art galleries.',
            galleDetail3: 'Visit key landmarks such as the Galle Lighthouse, Dutch Reformed Church, National Maritime Museum, and the ramparts offering stunning ocean views.',
            galleDetail4: 'Learn about the fort\'s rich history, architecture, and cultural significance from your knowledgeable guide.',
            galleDetail5: 'Ideal for history buffs, culture enthusiasts, and those looking to experience Sri Lanka\'s colonial past.',
            sigiriyaDetail1: 'Discover the ancient rock fortress of Sigiriya, one of Sri Lanka\'s most iconic landmarks and a UNESCO World Heritage Site.',
            sigiriyaDetail2: 'Climb the impressive rock to explore the ruins of King Kasyapa\'s palace, adorned with frescoes, water gardens, and the famous Mirror Wall.',
            sigiriyaDetail3: 'Enjoy panoramic views of the surrounding jungle and countryside from the summit.',
            sigiriyaDetail4: 'Learn about the fascinating history, architecture, and legends associated with Sigiriya from your expert guide.',
            sigiriyaDetail5: 'Perfect for history enthusiasts, adventure seekers, and those interested in Sri Lanka\'s rich cultural heritage.',
            kandyDetail1: 'Experience the vibrant culture of Kandy, Sri Lanka\'s last royal capital and a UNESCO World Heritage Site.',
            kandyDetail2: 'Visit the Temple of the Sacred Tooth Relic (Sri Dalada Maligawa), one of the most important Buddhist sites in the world.',
            kandyDetail3: 'Explore the Royal Botanical Gardens in Peradeniya, home to a vast collection of tropical plants and orchids.',
            kandyDetail4: 'Enjoy a traditional Kandyan dance performance, showcasing Sri Lanka\'s rich artistic heritage.',
            kandyDetail5: 'Ideal for culture enthusiasts, history buffs, and those looking to immerse themselves in Sri Lanka\'s traditions.'
        },
        contact: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contact Us',
            sectionTitle: 'Feel Free To Contact Us',
            sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
            sectionDescription: 'Contact Muthumuni Ayurveda Beach Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Beruwala, Moragalla.',
            callUs: 'Call Us',
            emailTitle: 'Email',
            ourLocation: 'Our Location',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Get In Touch',
            getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
            nameLabel: 'Name',
            emailLabel: 'Email',
            contactNumberLabel: 'Contact Number',
            messageLabel: 'Message',
            sending: 'Sending...',
            sendMessage: 'Send Message',
            successMessage: "Your message has been sent successfully! We'll get back to you soon.",
            errorMessage: 'An error occurred while sending your message. Please try again.',
            findUsOnMap: 'Find Us on the Map',
            whatsappSubject: 'Muthumuni Ayurveda Beach Resort Contact',
            whatsappName: 'Name',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Contact Number',
            whatsappMessage: 'Message'
        },
        contact2: {
            heroTitle: 'Contact Us',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contact Us',
            sectionTitle: 'Feel Free To Contact Us',
            sectionSubtitle: 'We’re Here to Help You Relax & Rejuvenate',
            sectionDescription: 'Contact Muthumuni Ayurveda Beach Resort for inquiries about your Ayurvedic stay, packages, bookings, or any questions during your time with us in beautiful Beruwala, Moragalla.',
            callUs: 'Call Us',
            emailTitle: 'Email',
            ourLocation: 'Our Location',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Get In Touch',
            getInTouchDescription: 'We’d love to hear from you — our team is ready to assist with your journey, answer questions, and help you plan a rejuvenating stay.',
            nameLabel: 'Name',
            emailLabel: 'Email',
            contactNumberLabel: 'Contact Number',
            messageLabel: 'Message',
            sending: 'Sending...',
            sendMessage: 'Send Message',
            successMessage: "Your message has been sent successfully! We'll get back to you soon.",
            errorMessage: 'An error occurred while sending your message. Please try again.',
            findUsOnMap: 'Find Us on the Map',
            whatsappSubject: 'Muthumuni Ayurveda Beach Resort Contact',
            whatsappName: 'Name',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Contact Number',
            whatsappMessage: 'Message'
        },
        about: {
            heroTitle: 'About Us',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Ancient wisdom meets modern at Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Personalized Ayurvedic treatments, ocean views and genuine Sri Lankan hospitality',
            slide1: 'Ayurvedic Healing',
            slide2: 'Beachfront Serenity',
            slide3: 'Garden Tranquility',
            slide4: 'Herbal Therapies',
            slide5: 'Ocean',
            historyLabel: 'Our Journey',
            historyTitle: 'History of Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Established over two decades ago, Muthumuni Ayurveda Beach Resort was born from a vision to create a sanctuary where ancient Ayurvedic wisdom meets the tranquil beauty of Sri Lanka\'s southern coast. What began as a modest retreat has blossomed into one of Beruwala\'s most cherished destinations for holistic healing and rejuvenation.',
            historyDesc2: 'Our founders, inspired by generations of traditional Ayurvedic practitioners, sought to preserve these time-honored healing arts while providing modern comforts and genuine Sri Lankan hospitality. Through the years, we have remained steadfast in our commitment to authentic experiences, expanding our facilities while never losing sight of the personalized care that defines our legacy.',
            historyDesc3: 'Today, Muthumuni stands as a testament to the enduring power of Ayurveda, having welcomed thousands of guests from around the world. Each visitor becomes part of our story, finding balance, healing, and transformation in our beachfront haven.',
            statYear: '15+',
            statYearLabel: 'Years of Excellence',
            statGuest: '1,000+',
            statGuestLabel: 'Happy Guests Served',
            experienceLegacy: 'Experience Our Legacy',
            established: 'Established',
            since2010: 'Since 2008',
            chairmanLabel: 'Chairman\'s Message',
            chairmanTitle: 'Guided by Care, Rooted in Ayurveda',
            chairmanDesc1: 'Welcome to Muthumuni Ayurveda Beach Resort. For over two decades, our purpose has been simple: to offer genuine healing grounded in the timeless wisdom of Ayurveda, delivered with the warmth of Sri Lankan hospitality.',
            chairmanDesc2: 'Here, every detail—from our therapies and cuisine to the tranquility of our spaces—is designed to help you slow down, restore balance, and reconnect with yourself. We are honored to be a part of your journey.',
            chairmanDesc3: 'On behalf of our dedicated team, I invite you to experience the care, authenticity, and serenity that define Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Chairman',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Chairman Mr. Nihal Muthumuni',
            staffLabel: 'Our Team',
            staffTitle: 'Meet Our Dedicated Staff',
            staffDesc1: 'At Muthumuni Ayurveda Beach Resort, our team is the heart of everything we do. Our staff members are carefully selected and trained professionals who share a deep passion for Ayurvedic and authentic hospitality.',
            staffDesc2: 'From our experienced Ayurvedic practitioners and skilled massage therapists to our dedicated hospitality team, each member brings years of expertise and genuine care to every guest interaction. We believe that true comes not just from treatments, but from the warmth and attention of people who genuinely care about your journey.',
            staffDesc3: 'Our staff undergoes continuous training in the latest Ayurvedic practices while maintaining the highest standards of professionalism and cultural sensitivity. We take pride in creating meaningful connections with our guests, ensuring that every visit becomes a memorable and transformative experience.',
            statStaff: '15+',
            statStaffLabel: 'Skilled Professionals',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Guest Satisfaction',
            staffImageAlt: 'Our dedicated staff team at Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Our Commitment',
            excellenceCare: 'Excellence & Care',
            ctaLabel: 'Get in Touch',
            ctaHeading: 'Ready to Begin Your Journey?',
            ctaDesc: 'Connect with our team to book your personalized Ayurvedic retreat. Whether you have questions about our therapies, accommodations, or special packages, we\'re here to help create your perfect escape.',
            ctaButtonContact: 'Contact Us Now',
            ctaButtonRooms: 'Explore Rooms',
            contactUs: 'Contact Us',
            quickInfoCall: 'Call Us',
            quickInfoEmail: 'Email Us',
            quickInfoLocation: 'Location',
            locationCity: 'Beruwala, Sri Lanka'
        },
        rooms: {
            heroTitle: 'Your Sanctuary Awaits',
            heroSubtitle: 'Handcrafted spaces designed for healing, restoration, and profound peace.',
            heroAlt: 'Muthumuni Ayurveda Beach Resort Rooms',
            exploreRooms: 'Explore Our Rooms',
            filterAll: 'All',
            filterLuxurySuite: 'Sea View Luxury Suite',
            filterDeluxeRooms: 'Deluxe Rooms',
            filterDeluxeSeaView: 'Deluxe Room with Sea View',
            noRoomsFound: 'No rooms found in this category.',
            allRoomsInclude: 'All Rooms Include',
            essentialComforts: 'Essential comforts for your journey',
            roomSize: 'Room Size',
            guests: 'Guests',
            amenities: 'Amenities',
            roomAmenities: 'Room Amenities',
            specialFeatures: 'Special Features',
            bookNow: 'Book Now',
            viewDetails: 'View Details',
            highSpeedWifi: 'High-Speed WiFi',
            herbalTea: 'Herbal Tea Selection',
            climateControl: 'Climate Control',
            rainShower: 'Rain Shower',
            organicToiletries: 'Organic Toiletries',
            dailyHousekeeping: 'Daily Housekeeping',
            concierge: '24/7 Concierge',
            yogaMat: 'Yoga Mat & Props',
            beginHealing: 'Begin Your Healing Journey',
            beginHealingDesc: 'Experience authentic Ayurvedic in surroundings designed to nurture your body, calm your mind, and restore your spirit.',
            reserveRoom: 'Reserve Your Room',
            speakAdvisor: 'Speak to Advisor',
            exploreOurRooms: 'Explore Our Rooms',
            viewRoom: 'View Room',
            luxurySuiteName: 'Sea View Luxury Suite',
            luxurySuiteCategory: 'Sea View Luxury Suite',
            luxurySuiteDesc: 'Experience ultimate serenity in our spacious Luxury Suite, designed with traditional Ayurvedic principles and breathtaking Sea views.',
            deluxeRoomName: 'Deluxe Room',
            deluxeRoomCategory: 'Deluxe Rooms',
            deluxeRoomDesc: 'Harmoniously balanced room featuring natural wood elements and cooling water features for perfect tranquility.',
            seaViewDeluxeName: 'Sea View Deluxe',
            seaViewDeluxeCategory: 'Deluxe Room with Sea View',
            seaViewDeluxeDesc: 'Wake up to calming sea breezes and panoramic ocean views in this elegantly designed deluxe room.',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'Deluxe Room — Comfort with a terrace or private balcony',
                heroSubtitle: 'Unwind in a calming coastal retreat inspired by the golden beaches of Bentota, pairing modern amenities with gentle sea breezes.',
                bookThisRoom: 'Book this room',
                callReservations: 'Call reservations',
                navAll: 'All',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe with Sea View',
                navSuite: 'Suite',
                sectionTitle: 'A soothing coastal hideaway',
                sectionDesc: 'The Deluxe Room is crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the sea view in, while the balcony offers your own perch above the shoreline.',
                highlight1Title: 'Panoramic Beach Views',
                highlight1Desc: 'Wake up to azure waters and golden sunrises from your private balcony.',
                highlight2Title: 'Elegant Coastal Interiors',
                highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
                highlight3Title: 'Serene Sleep Experience',
                highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',
                atAGlance: 'At a glance',
                statSize: 'Size',
                statSizeValue: '55 sqm',
                statView: 'View',
                statViewValue: 'Indian Ocean',
                statGuests: 'Guests',
                statGuestsValue: '2 Adults',
                statBed: 'Bed',
                statBedValue: 'King or Twin',
                reserve: 'Reserve',
                galleryAlt: 'Deluxe room gallery',
                inclusionsTitle: 'Included with your stay',
                inclusionsSubtitle: 'Thoughtful touches, all-day comfort',
                enhancedCleanliness: 'Enhanced cleanliness and safety standards',
                inclusion1: 'breakfast,Lunch,Dinner at Restaurant',
                inclusion2: 'Free Wi-Fi and in-room workspace',
                inclusion3: '24-hour room service and concierge',
                inclusion4: 'Daily housekeeping with evening turndown',
                inclusion5: 'Access to pool and Ayurveda spa facilities',
                inclusion6: 'parking and shuttle service to nearby attractions',
                amenityGroup1Title: 'Room Features',
                amenityGroup1Item1: '55 sqm of space',
                amenityGroup1Item2: 'Private balcony with seating',
                amenityGroup1Item3: 'Air conditioning with climate control',
                amenityGroup1Item4: 'In-room safe',
                amenityGroup2Title: 'Bath Experience',
                amenityGroup2Item1: 'Rain shower with hot and cold water',
                amenityGroup2Item2: 'Premium bath amenities',
                amenityGroup2Item3: 'Hair dryer',
                amenityGroup2Item4: 'Soft bathrobes and slippers',
                amenityGroup3Title: 'In-Room Comforts',
                amenityGroup3Item1: '55" smart TV with cable',
                amenityGroup3Item2: 'Coffee and tea station',
                amenityGroup3Item3: 'Direct-dial telephone',
                amenityGroup4Title: 'Connectivity',
                amenityGroup4Item1: 'Wi-Fi',
                amenityGroup4Item2: 'Work desk',
                amenityGroup4Item3: '24/7 front desk support',
                essentialsTitle: 'In-room essentials',
                essentialsHeading: 'Everything you need to feel at home',
                essentialsDesc: 'From seamless connectivity to carefully chosen refreshments, the Deluxe Room blends leisure and practicality so you can focus on the moments that matter.',
                essential1: 'Wi-Fi',
                essential2: 'Coffee and tea station',
                essential3: '24/7 room service',
                essential4: 'Rain shower',
                oceanTitle: 'By the ocean',
                oceanSubtitle: 'Slow down, breathe in the sea air',
                oceanAlt: 'Deluxe room seating',
                ctaTitle: 'Ready to stay?',
                ctaHeading: 'Reserve the Deluxe Room today',
                ctaDesc: 'Speak with our reservations team for the best available rates and special offers.',
                checkAvailability: 'Check availability'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Comfort with serene coastal charm',
                bookThisRoom: 'Book this room',
                callReservations: 'Call reservations',
                navAll: 'All',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe with Sea View',
                navSuite: 'Suite',
                sectionTitle: 'A soothing coastal hideaway',
                sectionDesc: 'The Luxury Suite is crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the sea view in, while the balcony offers your own perch above the shoreline.',
                highlight1Title: 'Panoramic Beach Views',
                highlight1Desc: 'Wake up to azure waters and golden sunrises from your private balcony.',
                highlight2Title: 'Elegant Coastal Interiors',
                highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
                highlight3Title: 'Serene Sleep Experience',
                highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',
                atAGlance: 'At a glance',
                statSize: 'Size',
                statSizeValue: '75 sqm',
                statView: 'View',
                statViewValue: 'Indian Ocean',
                statGuests: 'Guests',
                statGuestsValue: '2 Adults',
                statBed: 'Bed',
                statBedValue: 'King or Twin',
                reserve: 'Reserve',
                galleryAlt: 'Suite room',
                inclusionsTitle: 'Included with your stay',
                inclusionsSubtitle: 'Thoughtful touches, all-day comfort',
                enhancedCleanliness: 'Enhanced cleanliness and safety standards',
                inclusion1: 'breakfast, lunch, dinner at Restaurant',
                inclusion2: 'Free Wi-Fi and in-room workspace',
                inclusion3: '24-hour room service and concierge',
                inclusion4: 'Daily housekeeping with evening turndown',
                inclusion5: 'Access to pool and Ayurveda spa facilities',
                inclusion6: 'parking and shuttle service to nearby attractions',
                amenityGroup1Title: 'Room Features',
                amenityGroup1Item1: '75 sqm of space',
                amenityGroup1Item2: 'Private balcony with seating',
                amenityGroup1Item3: 'Air conditioning with climate control',
                amenityGroup1Item4: 'In-room safe',
                amenityGroup2Title: 'Bath Experience',
                amenityGroup2Item1: 'Rain shower with hot and cold water',
                amenityGroup2Item2: 'Premium bath amenities',
                amenityGroup2Item3: 'Hair dryer',
                amenityGroup2Item4: 'Soft bathrobes and slippers',
                amenityGroup3Title: 'In-Room Comforts',
                amenityGroup3Item1: '55" smart TV with cable',
                amenityGroup3Item2: 'Coffee and tea station',
                amenityGroup3Item3: 'Direct-dial telephone',
                amenityGroup4Title: 'Connectivity',
                amenityGroup4Item1: 'Wi-Fi',
                amenityGroup4Item2: 'Work desk',
                amenityGroup4Item3: '24/7 front desk support',
                essentialsTitle: 'In-room essentials',
                essentialsHeading: 'Everything you need to feel at home',
                essentialsDesc: 'From seamless connectivity to carefully chosen refreshments, the Luxury Suite blends leisure and practicality so you can focus on the moments that matter.',
                essential1: 'Wi-Fi',
                essential2: 'Coffee and tea station',
                essential3: '24/7 room service',
                essential4: 'Rain shower',
                oceanTitle: 'By the ocean',
                oceanSubtitle: 'Slow down, breathe in the sea air',
                oceanAlt: 'Ocean view',
                ctaTitle: 'Ready to stay?',
                ctaHeading: 'Reserve the Luxury Suite today',
                ctaDesc: 'Speak with our reservations team for the best available rates and special offers.',
                checkAvailability: 'Check availability'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Deluxe Rooms with Sea View',
                heroSubtitle: 'Where luxury meets serene coastal charm',
                bookThisRoom: 'Book this room',
                callReservations: 'Call reservations',
                navAll: 'All',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe with Sea View',
                navSuite: 'Suite',
                sectionTitle: 'A soothing coastal hideaway',
                sectionDesc: 'Our Deluxe Rooms with Sea View are crafted for slow mornings and unhurried sunsets. Soft neutral tones, generous glazing, and thoughtful lighting invite the sea view in, while the balcony offers your own perch above the shoreline.',
                highlight1Title: 'Panoramic Beach Views',
                highlight1Desc: 'Wake up to azure waters and golden sunrises from your private balcony.',
                highlight2Title: 'Elegant Coastal Interiors',
                highlight2Desc: 'Soft neutral palettes, warm timber accents, and generous natural light.',
                highlight3Title: 'Serene Sleep Experience',
                highlight3Desc: 'Plush king bed with premium linens curated for restorative rest.',
                atAGlance: 'At a glance',
                statSize: 'Size',
                statSizeValue: '45 sqm',
                statView: 'View',
                statViewValue: 'Indian Ocean',
                statGuests: 'Guests',
                statGuestsValue: '2 Adults',
                statBed: 'Bed',
                statBedValue: 'King or Twin',
                reserve: 'Reserve',
                galleryAlt: 'Deluxe sea view room',
                inclusionsTitle: 'Included with your stay',
                inclusionsSubtitle: 'Thoughtful touches, all-day comfort',
                enhancedCleanliness: 'Enhanced cleanliness and safety standards',
                inclusion1: 'breakfast, lunch, dinner at Restaurant',
                inclusion2: 'Free Wi-Fi and in-room workspace',
                inclusion3: '24-hour room service and concierge',
                inclusion4: 'Daily housekeeping with evening turndown',
                inclusion5: 'Access to pool and Ayurveda spa facilities',
                inclusion6: 'parking and shuttle service to nearby attractions',
                amenityGroup1Title: 'Room Features',
                amenityGroup1Item1: '45 sqm of space',
                amenityGroup1Item2: 'Private balcony with seating',
                amenityGroup1Item3: 'Air conditioning with climate control',
                amenityGroup1Item4: 'In-room safe',
                amenityGroup2Title: 'Bath Experience',
                amenityGroup2Item1: 'Rain shower with hot and cold water',
                amenityGroup2Item2: 'Premium bath amenities',
                amenityGroup2Item3: 'Hair dryer',
                amenityGroup2Item4: 'Soft bathrobes and slippers',
                amenityGroup3Title: 'In-Room Comforts',
                amenityGroup3Item1: '55" smart TV with cable',
                amenityGroup3Item2: 'Coffee and tea station',
                amenityGroup3Item3: 'Direct-dial telephone',
                amenityGroup4Title: 'Connectivity',
                amenityGroup4Item1: 'Wi-Fi',
                amenityGroup4Item2: 'Work desk',
                amenityGroup4Item3: '24/7 front desk support',
                essentialsTitle: 'In-room essentials',
                essentialsHeading: 'Everything you need to feel at home',
                essentialsDesc: 'From seamless connectivity to carefully chosen refreshments, each Deluxe Room with Sea View blends leisure and practicality so you can focus on the moments that matter.',
                essential1: 'Wi-Fi',
                essential2: 'Coffee and tea station',
                essential3: '24/7 room service',
                essential4: 'Rain shower',
                oceanTitle: 'By the ocean',
                oceanSubtitle: 'Slow down, breathe in the sea air',
                oceanAlt: 'Ocean view',
                ctaTitle: 'Ready to stay?',
                ctaHeading: 'Reserve a Deluxe Room with Sea View today',
                ctaDesc: 'Speak with our reservations team for the best available rates and special offers.',
                checkAvailability: 'Check availability'
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Ayurveda by the ocean',
            heroSubtitle2: 'Find balance, breathe easy, and renew your energy in Beruwala.',
            exploreResort: 'Explore resort',
            bookNow: 'Book now',

            // Welcome Section
            welcomeLabel: 'Welcome',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'Nestled along the pristine shores of Beruwala, Muthumuni Ayurveda Beach Resort offers a harmonious blend of ancient healing traditions and modern coastal luxury. Our sanctuary invites you to embark on a transformative transformative journey, where the rhythmic sounds of the Indian Ocean meet the timeless wisdom of Ayurveda.',
            welcomeDesc2: 'Experience personalized Ayurvedic treatments, savor nourishing cuisine crafted to balance your dosha, and unwind in elegantly appointed rooms with breathtaking ocean views. Whether you seek rejuvenation, relaxation, or spiritual renewal, our dedicated team of Ayurvedic practitioners and experts are here to guide you every step of the way.',
            learnMore: 'Learn More',
            contactUs: 'Contact Us',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Beruwala, Sri Lanka',

            // Highlight Section
            highlightTitle: 'A seaside Ayurveda sanctuary',
            highlightDesc: 'Discover holistic healing on Sri Lanka\'s southwest coast. From tailored treatments to quiet balconies and mindful cuisine, every detail is crafted to restore your rhythm.',

            // Services
            service1Title: 'Holistic Ayurveda Therapies',
            service1Desc: 'Personalized consultations, authentic herbal oils, and daily treatments guided by experienced Ayurveda doctors.',
            service2Title: 'Beachfront Rooms & Suites',
            service2Desc: 'Wake up to ocean breeze, private balconies, and calming interiors designed for deep rest.',
            service3Title: 'Cuisine',
            service3Desc: 'Fresh Sri Lankan produce, plant-forward menus, and tailored meal plans that complement your dosha.',
            service4Title: 'Yoga & Mindfulness',
            service4Desc: 'Sunrise yoga, sunset meditation, and breathwork sessions set against the rhythm of the waves.',
            service5Title: 'Riverside & Coastal Excursions',
            service5Desc: 'Boat rides on the Bentota River, turtle hatchery visits, spice garden walks, and village cycling tours.',

            // Rooms
            roomsTitle: 'Our Rooms',
            roomsDesc: 'Choose the sanctuary that matches your pace, from breezy suites to cozy deluxe hideaways, each layered with soft linens, warm wood, and sunrise-ready balconies.',
            roomBadge: 'Oceanfront Escape',
            bookableNow: 'Bookable now',
            seaBreezeReady: 'Sea breeze ready',
            viewRoom: 'View Room',
            room1Title: 'Sea View Suite Rooms',
            room1Desc: 'Spacious suites with lounge seating, generous balconies, and calming palettes for slow mornings.',
            room2Title: 'Deluxe Rooms',
            room2Desc: 'Cozy retreats with plush beds, garden views, and warm wooden accents for everyday ease.',
            room3Title: 'Deluxe Sea View',
            room3Desc: 'Wake to the ocean horizon, soft linens, and a private balcony made for golden sunsets.',

            // Achievements
            achievementsTitle: 'Trusted by the sea',
            achievement1Title: 'Happy Guests',
            achievement1Count: '1,000+',
            achievement2Title: 'Ayurveda Treatments',
            achievement2Count: '20+',
            achievement3Title: 'Years of Care',
            achievement3Count: '15+',
            achievement4Title: 'Traveler Accolades',
            achievement4Count: '1,000+',

            // Experiences
            experiencesTitle: 'Explore Muthumuni Ayurveda Beach Resort',
            experiencesDesc: 'From Ayurveda journeys to curated excursions, choose the experiences that make your stay memorable.',
            planYourStay: 'Plan your stay',
            experience1Title: 'Rooms & Suites',
            experience1Desc: 'Airy spaces with balconies, ocean or garden views, and thoughtful comforts for unhurried stays.',
            experience2Title: 'Ayurveda Spa',
            experience2Desc: 'Authentic therapies, steam baths, and restorative massages delivered with time-honored rituals.',
            experience3Title: 'Dining Experience',
            experience3Desc: 'Nutritious Sri Lankan and international cuisine served in our restaurant, thoughtfully prepared to nourish both body and mind.',
            experience4Title: 'Experiences & Tours',
            experience4Desc: 'River safaris, temple visits, water sports, and curated cultural excursions around Bentota.',

            // Gallery
            galleryTitle: 'Moments at Muthumuni Ayurveda Beach Resort',
            galleryDesc: 'A glimpse into our coastal sanctuary—sunrises, serene treatments, nourishing plates, and quiet corners made for you.',
            gallery1Alt: 'Sunlit palm-lined beach at Muthumuni',
            gallery2Alt: 'Ayurveda oil treatment in progress',
            gallery3Alt: 'Resort pool with loungers',
            gallery4Alt: 'Herbal ingredients prepared for spa',
            gallery5Alt: 'Couple enjoying sunset by the sea',
            gallery6Alt: 'Yoga deck facing the ocean',
            gallery7Alt: 'Tropical garden pathway',
            gallery8Alt: 'Healthy breakfast spread',
            gallery9Alt: 'Serene riverside view',
            gallery10Alt: 'Warmly lit resort exterior at dusk',
            gallery11Alt: 'Ayurveda herbs and oils display',
            gallery12Alt: 'Cozy seating by the garden',

            // Resort Images
            resort1Alt: 'Open-air lounge with greenery',
            resort2Alt: 'Comfortable room interior',
            resort3Alt: 'Spa treatment space',
            resort4Alt: 'Dining area with natural light',
            resort5Alt: 'Relaxing pool view',

            // Sunset Section
            sunsetLabel: 'Nature\'s Daily Masterpiece',
            sunsetTitle: 'Evening Sunset',
            sunsetDesc1: 'As day gracefully surrenders to dusk, witness the sky transform into a canvas of amber, crimson, and gold. The gentle Indian Ocean mirrors this celestial spectacle, creating a mesmerizing symphony of light and water.',
            sunsetDesc2: 'Every evening at Muthumuni offers front-row seats to one of nature\'s most breathtaking performances. Find your perfect vantage point—whether from your private balcony, the beachfront lounge, or our sunset meditation deck—and let the serene beauty wash over you.',
            sunsetFeature1: 'Unobstructed ocean views from every corner',
            sunsetFeature2: 'Sunset calm meditation',
            sunsetFeature3: 'herbal tea served daily',
            sunsetFeature4: 'Picture-perfect moments every evening',
            sunsetImageAlt: 'Evening sunset at Muthumuni Beach Resort',
            bestTime: 'Best Time',
            sunsetTime: '6:00 PM - 6:45 PM',

            // Pool Section
            poolLabel: 'Aquatic Serenity',
            poolTitle: 'Pool Area',
            poolDesc1: 'Immerse yourself in tranquility at our pristine pool, where crystal-clear waters meet lush tropical gardens. Designed for relaxation and rejuvenation, our pool area offers the perfect escape to unwind under the Sri Lankan sun.',
            poolDesc2: 'Whether you prefer a refreshing morning swim, an afternoon lounging session with a good book, or a peaceful evening dip, our pool area provides an idyllic setting. Surrounded by comfortable sun loungers, shaded cabanas, and attentive poolside service, every moment becomes a cherished memory.',
            poolFeature1: 'Temperature-controlled pool',
            poolFeature2: 'Surrounded by tropical garden landscapes',
            poolFeature3: 'Poolside refreshments & healthy snacks',
            poolFeature4: 'Premium sun loungers with umbrellas',
            poolImageAlt: 'Relaxing pool area at Muthumuni Resort',

            // Testimonials
            testimonialsTitle: 'Guests on their stay'
        }

    },
    de: {
        navbar: {
            home: 'Startseite',
            aboutUs: 'Über uns',
            rooms: 'Zimmer',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Essen',
            events: 'Veranstaltungen',
            blogs: 'Blogs',
            tours: 'Touren',
            contactUs: 'Kontakt',
            bookOnline: 'Online buchen',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Resort wählen',
            language: 'Sprache',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Startseite',
            aboutUs: 'Über uns',
            rooms: 'Zimmer',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Essen',
            events: 'Veranstaltungen',
            blogs: 'Blogs',
            tours: 'Touren',
            contactUs: 'Kontakt',
            bookOnline: 'Online buchen',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Resort wählen',
            language: 'Sprache',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe Zimmer mit Flussblick — Komfort mit Terrasse oder privatem Balkon',
            heroSubtitle: 'Entspannen Sie in einem beruhigenden Rückzugsort am Fluss, inspiriert von den ruhigen Gewässern der Bentota, mit modernen Annehmlichkeiten und sanfter Flussbrise.',
            bookThisRoom: 'Dieses Zimmer buchen',
            callReservations: 'Reservierungen anrufen',

            navAll: 'Alle',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe mit Flussblick',

            soothingHideawayTitle: 'Ein beruhigendes Versteck am Flussufer',
            soothingHideawayDesc: 'Unser Deluxe Zimmer mit Flussblick ist für langsame Morgen und entspannte Sonnenuntergänge gemacht. Weiche neutrale Töne, großzügige Verglasung und durchdachtes Licht lassen den Flussblick herein, während der Balkon Ihren eigenen Platz über dem fließenden Wasser bietet.',

            highlight1Title: 'Panoramablick auf den Fluss',
            highlight1Desc: 'Erwachen Sie mit ruhigen Flussansichten und goldenen Sonnenaufgängen von Ihrem privaten Balkon.',
            highlight2Title: 'Elegante Flussufer-Interieurs',
            highlight2Desc: 'Weiche neutrale Farben, warme Holzakzente und großzügiges natürliches Licht.',
            highlight3Title: 'Beruhigendes Schlaferlebnis',
            highlight3Desc: 'Plüschiges Kingsize-Bett mit Premium-Bettwäsche für erholsamen Schlaf.',

            atAGlance: 'Auf einen Blick',
            statSizeLabel: 'Größe',
            statViewLabel: 'Aussicht',
            statViewValue: 'Flussblick',
            statGuestsLabel: 'Gäste',
            statBedLabel: 'Bett',
            statBedValue: 'King oder Twin',
            reserve: 'Reservieren',

            includedWithStay: 'Inklusive bei Ihrem Aufenthalt',
            thoughtfulTouches: 'Durchdachte Details, ganztägiger Komfort',
            enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',

            inclusion1: 'Kostenloses Frühstück, Mittag- und Abendessen im Restaurant',
            inclusion2: 'High-Speed WLAN und Arbeitsplatz im Zimmer',
            inclusion3: '24-Stunden-Zimmerservice und Concierge',
            inclusion4: 'Tägliche Zimmerreinigung mit Abend-Turndown',
            inclusion5: 'Zugang zum Pool und Ayurveda-Spa-Einrichtungen',
            inclusion6: 'Kostenloser Parkplatz und Shuttle-Service zu nahegelegenen Attraktionen',

            amenityGroup1Title: 'Zimmerausstattung',
            amenityGroup1Item1: '38 m² Fläche',
            amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
            amenityGroup1Item3: 'Klimaanlage mit individueller Regelung',
            amenityGroup1Item4: 'Zimmersafe',

            amenityGroup2Title: 'Bade-Erlebnis',
            amenityGroup2Item1: 'Regendusche mit Warm- und Kaltwasser',
            amenityGroup2Item2: 'Premium-Pflegeprodukte',
            amenityGroup2Item3: 'Föhn',
            amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',

            amenityGroup3Title: 'Komfort im Zimmer',
            amenityGroup3Item1: '55" Smart-TV mit Kabel',
            amenityGroup3Item2: 'Kaffee- und Teestation',
            amenityGroup3Item3: 'Direktwahltelefon',

            amenityGroup4Title: 'Konnektivität',
            amenityGroup4Item1: 'Kostenloses WLAN',
            amenityGroup4Item2: 'Arbeitstisch',
            amenityGroup4Item3: '24/7 Rezeptionssupport',

            inRoomEssentials: 'Zimmer-Essentials',
            everythingYouNeed: 'Alles, was Sie zum Wohlfühlen brauchen',
            inRoomEssentialsDesc: 'Von nahtloser Konnektivität bis zu sorgfältig ausgewählten Erfrischungen – das Deluxe Zimmer mit Flussblick verbindet Freizeit und Praktikabilität, damit Sie sich auf die wichtigen Momente konzentrieren können.',

            complimentaryWifi: 'Kostenloses WLAN',
            coffeeTeaStation: 'Kaffee- und Teestation',
            roomService: '24/7 Zimmerservice',
            rainShower: 'Regendusche',

            byTheRiver: 'Am Fluss',
            slowDownBreathe: 'Entschleunigen, frische Luft atmen',

            readyToStay: 'Bereit zum Aufenthalt?',
            reserveDeluxeRiverViewToday: 'Reservieren Sie heute ein Deluxe Zimmer mit Flussblick',
            speakReservations: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
            checkAvailability: 'Verfügbarkeit prüfen'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Ihr Refugium erwartet Sie',
            heroSubtitle: 'Flussnahe Oasen, entworfen für Heilung, Erneuerung und tiefe Ruhe entlang des friedlichen Bentota-Flusses.',
            exploreRooms: 'Unsere Zimmer entdecken',

            filterAll: 'Alle',
            filterDeluxeRooms: 'Deluxe-Zimmer',
            filterRiverViewDeluxe: 'Deluxe-Zimmer mit Flussblick',

            deluxeRoomName: 'Deluxe-Zimmer',
            deluxeRoomCategory: 'Deluxe-Zimmer',
            deluxeRoomDesc: 'Harmonisch ausgewogenes Zimmer mit natürlichen Holzelementen und Flussblick für perfekte Ruhe.',

            riverViewDeluxeName: 'Deluxe mit Flussblick',
            riverViewDeluxeCategory: 'Deluxe-Zimmer mit Flussblick',
            riverViewDeluxeDesc: 'Erwachen Sie zum sanften Rauschen des Flusses und genießen Sie den Panoramablick auf das Flussufer in diesem elegant gestalteten Deluxe-Zimmer.',

            noRoomsFound: 'Keine Zimmer in dieser Kategorie gefunden.',
            roomSize: 'Zimmergröße',
            guests: 'Gäste',
            amenitiesCount: 'Ausstattung',
            roomAmenities: 'Zimmerausstattung',
            specialFeatures: 'Besondere Merkmale',

            kingSizeBed: 'Kingsize-Bett',
            workDesk: 'Arbeitsschreibtisch',
            rainShower: 'Regendusche',
            teaStation: 'Tee-Station',
            privateTerrace: 'Privater Balkon',
            binoculars: 'Fernglas',

            riverView: 'Flussblick',
            naturalLighting: 'Natürliches Licht',
            gardenView: 'Gartenblick',
            sunriseBalcony: 'Sonnenaufgangsbalkon',
            soundOfRiver: 'Rauschen des Flusses',

            bookNow: 'Jetzt buchen',
            viewDetails: 'Details ansehen',
            viewRoom: 'Zimmer ansehen',

            allRoomsInclude: 'Alle Zimmer enthalten',
            essentialComforts: 'Wesentliche Annehmlichkeiten für Ihre Wellness-Reise',

            highSpeedWifi: 'High-Speed WLAN',
            herbalTea: 'Kräutertee-Auswahl',
            climateControl: 'Klimaanlage',
            organicToiletries: 'Organische Pflegeprodukte',
            dailyHousekeeping: 'Tägliche Zimmerreinigung',
            concierge: '24/7 Concierge',
            yogaMat: 'Yogamatte & Zubehör',

            beginHealing: 'Beginnen Sie Ihre Heilungsreise',
            beginHealingDesc: 'Erleben Sie authentisches ayurvedisches Wohlbefinden in ruhiger Flussumgebung, die Körper, Geist und Seele nährt und wiederherstellt.',
            reserveRoom: 'Zimmer reservieren',
            speakAdvisor: 'Mit Wellness-Berater sprechen',

            exploreOurRooms: 'Unsere Zimmer erkunden'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe Zimmer – Komfort mit Terrasse oder privatem Balkon',
            heroSubtitle: 'Entspannen Sie in einem beruhigenden Rückzugsort am Fluss, inspiriert vom ruhigen Wasser der Bentota, mit modernen Annehmlichkeiten und sanfter Flussbrise.',
            bookThisRoom: 'Dieses Zimmer buchen',
            callReservations: 'Reservierungen anrufen',

            navAll: 'Alle',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe mit Flussblick',

            soothingHideawayTitle: 'Ein beruhigendes Versteck am Flussufer',
            soothingHideawayDesc: 'Das Deluxe Zimmer ist für langsame Morgen und unbeschwerte Sonnenuntergänge gemacht. Sanfte neutrale Töne, großzügige Verglasung und durchdachtes Licht lassen den Flussblick herein, während der Balkon Ihnen einen eigenen Platz über dem fließenden Wasser bietet.',

            highlight1Title: 'Panoramablick auf den Fluss',
            highlight1Desc: 'Erwachen Sie mit ruhigen Flussansichten und tropischen Sonnenaufgängen von Ihrem privaten Balkon.',
            highlight2Title: 'Elegante Flussufer-Interieurs',
            highlight2Desc: 'Weiche neutrale Farben, warme Holzakzente und großzügiges natürliches Licht.',
            highlight3Title: 'Beruhigendes Schlaferlebnis',
            highlight3Desc: 'Plüschiges Kingsize-Bett mit Premium-Bettwäsche für erholsamen Schlaf.',

            atAGlance: 'Auf einen Blick',
            statSizeLabel: 'Größe',
            statViewLabel: 'Aussicht',
            statViewValue: 'Flussblick',
            statGuestsLabel: 'Gäste',
            statBedLabel: 'Bett',
            statBedValue: 'King oder Twin',
            reserve: 'Reservieren',

            includedWithStay: 'Inklusive bei Ihrem Aufenthalt',
            thoughtfulTouches: 'Durchdachte Details, ganztägiger Komfort',
            enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',

            inclusion1: 'Kostenloses Frühstück, Mittag- und Abendessen im Restaurant',
            inclusion2: 'High-Speed WLAN und Arbeitsplatz im Zimmer',
            inclusion3: '24-Stunden-Zimmerservice und Concierge',
            inclusion4: 'Tägliche Zimmerreinigung mit Abend-Turndown',
            inclusion5: 'Zugang zum Pool und Ayurveda-Spa-Einrichtungen',
            inclusion6: 'Kostenloser Parkplatz und Shuttle-Service zu nahegelegenen Attraktionen',

            amenityGroup1Title: 'Zimmerausstattung',
            amenityGroup1Item1: '41 m² Fläche',
            amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
            amenityGroup1Item3: 'Klimaanlage mit individueller Regelung',
            amenityGroup1Item4: 'Zimmersafe',

            amenityGroup2Title: 'Bade-Erlebnis',
            amenityGroup2Item1: 'Regendusche mit Warm- und Kaltwasser',
            amenityGroup2Item2: 'Premium-Pflegeprodukte',
            amenityGroup2Item3: 'Föhn',
            amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',

            amenityGroup3Title: 'Komfort im Zimmer',
            amenityGroup3Item1: '55" Smart-TV mit Kabel',
            amenityGroup3Item2: 'Kaffee- und Teestation',
            amenityGroup3Item3: 'Direktwahltelefon',

            amenityGroup4Title: 'Konnektivität',
            amenityGroup4Item1: 'Kostenloses WLAN',
            amenityGroup4Item2: 'Arbeitstisch',
            amenityGroup4Item3: '24/7 Rezeptionssupport',

            inRoomEssentials: 'Zimmer-Essentials',
            everythingYouNeed: 'Alles, was Sie zum Wohlfühlen brauchen',
            inRoomEssentialsDesc: 'Von nahtloser Konnektivität bis hin zu sorgfältig ausgewählten Erfrischungen – das Deluxe Zimmer verbindet Freizeit und Praktikabilität, damit Sie sich auf die wichtigen Momente konzentrieren können.',

            complimentaryWifi: 'Kostenloses WLAN',
            coffeeTeaStation: 'Kaffee- und Teestation',
            roomService: '24/7 Zimmerservice',
            rainShower: 'Regendusche',

            byTheRiver: 'Am Fluss',
            slowDownBreathe: 'Entschleunigen, frische Luft atmen',

            readyToStay: 'Bereit zum Aufenthalt?',
            reserveDeluxeToday: 'Reservieren Sie heute das Deluxe Zimmer',
            speakReservations: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
            checkAvailability: 'Verfügbarkeit prüfen'
        },
        aboutus2: {
            heroTitle: 'Über uns',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Antike Weisheit trifft auf ruhige Flussufer-Schönheit im Muthumuni Ayurveda River Resort',
            heroTagline2: 'Personalisierte ayurvedische Behandlungen, Flussblick und echte sri-lankische Gastfreundschaft',
            slide1: 'Ayurvedische Heilung',
            slide2: 'Ruhe am Flussufer',
            slide3: 'Garten-Tranquillität',
            slide4: 'Kräutertherapien',
            slide5: 'Fluss-Wellness',
            historyLabel: 'Unsere Reise',
            historyTitle: 'Geschichte des Muthumuni Ayurveda River Resort',
            historyDesc1: 'Vor über zwei Jahrzehnten gegründet, entstand das Muthumuni Ayurveda River Resort aus der Vision, eine Oase zu schaffen, in der alte ayurvedische Weisheit auf die ruhige Schönheit der Flusslandschaften Sri Lankas trifft. Was als bescheidenes Wellness-Refugium begann, hat sich zu einem der beliebtesten Ziele in Aluthgama für ganzheitliche Heilung und Verjüngung entwickelt.',
            historyDesc2: 'Unsere Gründer, inspiriert von Generationen traditioneller ayurvedischer Praktiker, wollten diese zeitlosen Heilkünste bewahren und gleichzeitig modernen Komfort und echte sri-lankische Gastfreundschaft bieten. Über die Jahre hinweg sind wir unserem Engagement für authentische Wellness-Erlebnisse treu geblieben und haben unsere Einrichtungen erweitert, ohne jemals die persönliche Betreuung aus den Augen zu verlieren, die unser Erbe ausmacht.',
            historyDesc3: 'Heute steht Muthumuni als Zeugnis für die anhaltende Kraft der Ayurveda und hat Tausende von Gästen aus aller Welt willkommen geheißen. Jeder Besucher wird Teil unserer Geschichte und findet in unserem friedlichen Flussufer-Hafen Balance, Heilung und Verwandlung.',
            statYear: '15+',
            statYearLabel: 'Jahre Exzellenz im Wellness',
            statGuest: '1.000+',
            statGuestLabel: 'Zufriedene Gäste',
            experienceLegacy: 'Erleben Sie unser Erbe',
            established: 'Gegründet',
            sinceYear: 'Seit 1993',
            chairmanLabel: 'Botschaft des Vorsitzenden',
            chairmanTitle: 'Geleitet von Fürsorge, verwurzelt in Ayurveda',
            chairmanDesc1: 'Willkommen im Muthumuni Ayurveda River Resort. Seit über zwei Jahrzehnten ist unser Ziel einfach: echte Heilung zu bieten, die in der zeitlosen Weisheit der Ayurveda verwurzelt ist und mit der Wärme sri-lankischer Gastfreundschaft übermittelt wird.',
            chairmanDesc2: 'Hier ist jedes Detail – von unseren Therapien und der Küche bis zur Ruhe unserer Räume – darauf ausgelegt, Ihnen zu helfen, langsamer zu werden, das Gleichgewicht wiederherzustellen und sich wieder mit sich selbst zu verbinden. Wir fühlen uns geehrt, Teil Ihrer Wellness-Reise zu sein.',
            chairmanDesc3: 'Im Namen unseres engagierten Teams lade ich Sie ein, die Fürsorge, Authentizität und Gelassenheit zu erleben, die Muthumuni ausmachen.',
            chairmanBadge: 'Vorsitzender',
            chairmanName: 'Herr Nihal Muthumuni',
            chairmanSignature: '— Herr Nihal Muthumuni',
            chairmanImageAlt: 'Vorsitzender Herr Nihal Muthumuni',
            staffLabel: 'Unser Team',
            staffTitle: 'Lernen Sie unser engagiertes Team kennen',
            staffDesc1: 'Im Muthumuni Ayurveda River Resort ist unser Team das Herzstück von allem, was wir tun. Unsere Mitarbeiter sind sorgfältig ausgewählte und geschulte Fachkräfte, die eine tiefe Leidenschaft für ayurvedisches Wohlbefinden und authentische Gastfreundschaft teilen.',
            staffDesc2: 'Von unseren erfahrenen ayurvedischen Praktikern und geschickten Massagetherapeuten bis hin zu unserem engagierten Gastfreundschaftsteam bringt jedes Mitglied jahrelange Expertise und echte Fürsorge in jede Gästeinteraktion ein. Wir glauben, dass wahres Wohlbefinden nicht nur aus Behandlungen entsteht, sondern aus der Wärme und Aufmerksamkeit von Menschen, denen Ihre Reise wirklich am Herzen liegt.',
            staffDesc3: 'Unser Team erhält kontinuierliche Schulungen in den neuesten ayurvedischen Praktiken und wahrt gleichzeitig höchste Standards an Professionalität und kultureller Sensibilität. Wir sind stolz darauf, bedeutungsvolle Verbindungen zu unseren Gästen aufzubauen und sicherzustellen, dass jeder Besuch zu einem unvergesslichen und transformativen Erlebnis wird.',
            statStaff: '15+',
            statStaffLabel: 'Qualifizierte Fachkräfte',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Gästezufriedenheit',
            staffImageAlt: 'Unser engagiertes Team im Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Unser Versprechen',
            excellenceCare: 'Exzellenz & Fürsorge',
            ctaLabel: 'Kontaktieren Sie uns',
            ctaHeading: 'Bereit, Ihre Wellness-Reise zu beginnen?',
            ctaDesc: 'Nehmen Sie Kontakt mit unserem Team auf, um Ihren persönlichen ayurvedischen Rückzugsort zu buchen. Egal ob Sie Fragen zu unseren Therapien, Unterkünften oder speziellen Wellness-Paketen haben – wir helfen Ihnen gerne, Ihre perfekte Auszeit zu gestalten.',
            ctaButtonContact: 'Jetzt kontaktieren',
            ctaButtonRooms: 'Zimmer entdecken',
            quickInfoCall: 'Rufen Sie uns an',
            quickInfoEmail: 'E-Mail an uns',
            quickInfoLocation: 'Standort',
            locationCity: 'Aluthgama, Sri Lanka'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Ayurveda am Flussufer',
            heroTagline: 'Finden Sie Balance, atmen Sie frei und erneuern Sie Ihre Energie in Aluthgama',
            exploreResort: 'Resort entdecken',
            bookNow: 'Jetzt buchen',

            welcomeLabel: 'Willkommen',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Eingebettet am ruhigen Ufer des Bentota-Flusses bietet das Muthumuni Ayurveda River Resort eine harmonische Verbindung alter Heiltraditionen mit stiller natürlicher Schönheit. Unsere Oase lädt Sie ein, eine transformative Reise des Wohlbefindens zu beginnen, bei der der sanfte Flusslauf auf die zeitlose Weisheit der Ayurveda trifft.',
            welcomeDesc2: 'Erleben Sie personalisierte ayurvedische Behandlungen, genießen Sie nährende Küche, die auf Ihr Dosha abgestimmt ist, und entspannen Sie in elegant eingerichteten Zimmern mit atemberaubendem Flussblick. Ob Sie Regeneration, Entspannung oder spirituelle Erneuerung suchen – unser engagiertes Team aus ayurvedischen Praktikern und Wellness-Experten begleitet Sie auf jedem Schritt.',
            learnMore: 'Mehr erfahren',
            contactUs: 'Kontaktieren Sie uns',
            welcomeImageCaption: 'Ayurveda-Wellness & Fluss-Retreat',
            welcomeImageLocation: 'Aluthgama, Sri Lanka',

            highlightTitle: 'Ein ayurvedisches Refugium am Flussufer',
            highlightDesc: 'Entdecken Sie ganzheitliches Heilen entlang des friedlichen Ufers des Bentota. Von maßgeschneiderten Behandlungen über stille Balkone bis hin zu achtsamer Küche – jedes Detail ist darauf ausgelegt, Ihren natürlichen Rhythmus wiederherzustellen.',

            roomsTitle: 'Unsere Zimmer',
            roomsDesc: 'Wählen Sie das Refugium, das zu Ihrem Tempo passt – von luftigen Suiten bis zu gemütlichen Deluxe-Rückzugsorten, alle mit weichen Laken, warmem Holz und balkonbereiten Sonnenaufgängen.',
            room1Title: 'Deluxe-Zimmer',
            room1Desc: 'Gemütliche Rückzugsorte mit luxuriösen Betten, Gartenblick und warmen Holzakzenten für tägliche Leichtigkeit.',
            room2Title: 'Deluxe Flussblick',
            room2Desc: 'Erwachen Sie mit ruhigem Flussblick, weichen Laken und einem privaten Balkon, perfekt für friedliche Morgen.',
            viewRoom: 'Zimmer ansehen',
            bookableNow: 'Jetzt buchbar',
            riverBreezeReady: 'Flussbrise bereit',
            roomBadge: 'Flussufer-Flucht',

            service1Title: 'Ganzheitliche Ayurveda-Therapien',
            service1Desc: 'Personalisierte Beratungen, authentische Kräuteröle und tägliche Behandlungen unter Anleitung erfahrener Ayurveda-Ärzte.',

            service2Title: 'Zimmer am Flussufer',
            service2Desc: 'Wachen Sie zum sanften Rauschen des Flusses auf, mit privaten Balkonen und beruhigenden Innenräumen, die für tiefen Schlaf konzipiert sind.',

            service3Title: 'Wellness-Küche',
            service3Desc: 'Frische Produkte aus Sri Lanka, pflanzenbasierte Menüs und individuell auf Ihr Dosha abgestimmte Ernährungspläne.',

            service4Title: 'Yoga & Achtsamkeit',
            service4Desc: 'Sonnenaufgangs-Yoga, Sonnenuntergangs-Meditation und Atemübungen im Rhythmus der Wellen.',

            service5Title: 'Fluss- & Küstenausflüge',
            service5Desc: 'Bootstouren auf dem Bentota-Fluss, Besuche der Schildkrötenaufzuchtstation, Gewürzgarten-Spaziergänge und Fahrradtouren durch Dörfer.',

            achievementsTitle: 'Vertrauensvolles Wohlbefinden am Flussufer',
            achievement1Title: 'Glückliche Gäste',
            achievement1Count: '1.000+',
            achievement2Title: 'Ayurveda-Behandlungen',
            achievement2Count: '20+',
            achievement3Title: 'Jahre Fürsorge',
            achievement3Count: '15+',
            achievement4Title: 'Reisenden-Auszeichnungen',
            achievement4Count: '1.000+',

            experiencesTitle: 'Entdecken Sie die Erlebnisse im Muthumuni Ayurveda River Resort',
            experiencesDesc: 'Von ayurvedischen Reisen bis zu kuratierten Ausflügen – wählen Sie die Erlebnisse, die Ihren Aufenthalt unvergesslich machen.',
            planYourStay: 'Aufenthalt planen',
            experience1Title: 'Unsere Zimmer',
            experience1Desc: 'Luftige Räume mit Balkonen, Fluss- oder Gartenblick und durchdachtem Komfort für entspannte Aufenthalte.',
            experience2Title: 'Ayurveda-Spa',
            experience2Desc: 'Authentische Therapien, Dampfbäder und regenerierende Massagen nach jahrhundertealten Ritualen.',
            experience3Title: 'Essen am Fluss',
            experience3Desc: 'Nährstoffreiche sri-lankische und internationale Küche, die Körper und Geist nährt.',
            experience4Title: 'Erlebnisse & Touren',
            experience4Desc: 'Fluss-Safaris, Tempelbesuche, Wassersport und kulturelle Ausflüge rund um Bentota.',

            galleryTitle: 'Augenblicke im Muthumuni Ayurveda River Resort',
            galleryDesc: 'Ein Blick in unser Flussufer-Heiligtum – Sonnenaufgänge, ruhige Behandlungen, nährende Teller und stille Ecken, die für Sie gemacht sind.',
            gallery1Alt: 'Sonnenbeschienenes Flussufer mit Palmen in Muthumuni',
            gallery2Alt: 'Laufende Ayurveda-Ölbehandlung',
            gallery3Alt: 'Resort-Pool mit Liegen',
            gallery4Alt: 'Für das Spa vorbereitete Kräuterzutaten',
            gallery5Alt: 'Paar genießt Sonnenuntergang am Fluss',
            gallery6Alt: 'Yoga-Plattform mit Flussblick',
            gallery7Alt: 'Tropischer Gartenweg',
            gallery8Alt: 'Gesundes Frühstücksbuffet',
            gallery9Alt: 'Ruhiger Flussblick',
            gallery10Alt: 'Warmes beleuchtetes Resort-Äußeres in der Dämmerung',
            gallery11Alt: 'Ausstellung ayurvedischer Kräuter und Öle',
            gallery12Alt: 'Gemütliche Sitzecke am Garten',

            boatLabel: 'Flussabenteuer',
            boatTitle: 'Bootstouren auf dem Bentota-Fluss',
            boatDesc1: 'Erleben Sie die Magie des Bentota-Flusses mit unseren bezaubernden Bootstouren. Gleiten Sie durch ruhige Wasserwege, umgeben von üppigen Mangrovenwäldern, und beobachten Sie exotische Tiere: bunte Eisvögel, Krokodile, Warane und verspielte Affen. Perfekt für Naturliebhaber und Fotografen auf der Suche nach unvergesslichen Momenten.',
            boatDesc2: 'Ob Sie eine friedliche Morgenfahrt, eine romantische Sonnenuntergangstour oder eine abenteuerliche Tierbeobachtung wählen – unsere erfahrenen Guides teilen faszinierende Einblicke in das Ökosystem des Flusses. Passen Sie Ihr Erlebnis mit privaten Charter-Optionen an oder schließen Sie sich unseren Gruppentouren an für eine intimere Verbindung zur Natur.',
            boatFeature1: 'Malebische Flussfahrten durch Mangroven',
            boatFeature2: 'Tierbeobachtung – Vögel, Krokodile & Affen',
            boatFeature3: 'Optionen für Sonnenauf- und -untergangsfahrten',
            boatFeature4: 'Erfahrene lokale Guides enthalten',
            boatImageAlt: 'Bootstour auf dem Bentota-Fluss',

            poolLabel: 'Wasserliche Ruhe',
            poolTitle: 'Poolbereich',
            poolDesc1: 'Tauchen Sie ein in die Ruhe unseres makellosen Pools, wo kristallklares Wasser auf üppige tropische Gärten trifft. Der Poolbereich ist für Entspannung und Erneuerung konzipiert und bietet die perfekte Flucht unter der sri-lankischen Sonne.',
            poolDesc2: 'Ob Sie einen erfrischenden Morgenschwimmen, eine gemütliche Nachmittagslesezeit oder ein friedliches Abendbad bevorzugen – unser Poolbereich bietet eine idyllische Kulisse. Umgeben von bequemen Sonnenliegen, schattigen Cabanas und aufmerksamem Pool-Service wird jeder Moment zu einer kostbaren Erinnerung.',
            poolFeature1: 'Temperaturregulierter Pool',
            poolFeature2: 'Umgeben von tropischer Gartenlandschaft',
            poolFeature3: 'Erfrischungen und gesunde Snacks am Pool',
            poolFeature4: 'Premium-Sonnenliegen mit Sonnenschirmen',
            poolImageAlt: 'Entspannender Poolbereich',

            testimonialsTitle: 'Gäste über ihren Aufenthalt',

            bookingDestination: 'Ziel',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Anreise',
            bookingCheckOut: 'Abreise',
            bookingGuests: 'Gäste',
            guestsOption1: '1 Gast',
            guestsOption2: '2 Gäste',
            guestsOption3: '3 Gäste',
            guestsOption4: '4+ Gäste',
            bookingCheckAvailability: 'Verfügbarkeit prüfen'
        },
        ayurveda2: {
            accordionTitle1: 'Was ist Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (ein Sanskrit-Wort, das „Wissenschaft vom Leben“ bedeutet) ist ein uraltes ganzheitliches Heilsystem. Panchakarma ist eine Reihe von reinigenden und verjüngenden Therapien, die darauf abzielen, das Gleichgewicht zwischen Geist, Körper und Seele wiederherzustellen.',
            accordionTitle2: 'Panchakarma Ayurveda und Ihre Lebensenergie',
            accordionDesc2: 'Panchakarma konzentriert sich auf die Entfernung von Toxinen und die Wiederherstellung der Harmonie zwischen den Doshas (Vata, Pitta, Kapha). Die Behandlungen werden individuell auf jeden Gast abgestimmt, um langfristiges Wohlbefinden und Vitalität zu fördern.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Vata steuert Bewegung und Kreislauf. Im Gleichgewicht fördert es Kreativität und Vitalität. Panchakarma bietet erdende Behandlungen, um überschüssiges Vata zu beruhigen und das Gleichgewicht wiederherzustellen.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'Pitta steuert Verdauung und Stoffwechsel. Kühlende, regenerierende Therapien helfen, Pitta auszugleichen und Entzündungen sowie Reizbarkeit zu reduzieren.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha unterstützt Struktur und Stabilität. Belebende und kreislauffördernde Therapien werden eingesetzt, um überschüssiges Kapha zu reduzieren und Leichtigkeit sowie Flexibilität zu fördern.',
            close: 'Schließen',
            next: 'Weiter',
            previous: 'Zurück',
            treatmentsTitle: 'Unsere Signature Panchakarma Ayurvedische Behandlungen',
            treatmentsSubtitle: 'Zeitbewährte Therapien zur Entgiftung, Verjüngung und Wiederherstellung des Gleichgewichts.',
            bookTreatment: 'Diese Behandlung buchen',
            benefitsTitle: 'Vorteile der Panchakarma-Behandlungen',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Ein sanftes Aufgießen von warmem Kräuteröl auf die Stirn, um den Geist zu beruhigen.',
            shirodhara1: 'Reduziert Stress und Angst',
            shirodhara2: 'Fördert besseren Schlaf',
            shirodhara3: 'Verbessert geistige Klarheit',
            steamBath: 'Dampfbad',
            steamBathDesc: 'Eine entgiftende Dampfbehandlung, die Poren öffnet und Muskeln entspannt.',
            steamBath1: 'Entgiftet den Körper',
            steamBath2: 'Verbessert die Durchblutung',
            steamBath3: 'Lindert Muskelverspannungen',
            flowerBath: 'Blütenbad',
            flowerBathDesc: 'Ein beruhigendes Bad mit duftenden Blüten zur Entspannung.',
            flowerBath1: 'Beruhigt das Nervensystem',
            flowerBath2: 'Befeuchtet die Haut',
            flowerBath3: 'Hebt die Stimmung',
            headMassage: 'Kopfmassage',
            headMassageDesc: 'Eine entspannende Massage, die auf die Kopfhaut abzielt, um Verspannungen zu lösen.',
            headMassage1: 'Lindert Kopfschmerzen',
            headMassage2: 'Verbessert die Kopfhautgesundheit',
            headMassage3: 'Fördert Entspannung',
            faceMassage: 'Gesichtsmassage',
            faceMassageDesc: 'Eine verjüngende Massage für einen strahlenden Teint und Stressabbau.',
            faceMassage1: 'Verbessert den Hautton',
            faceMassage2: 'Reduziert Gesichtsverspannungen',
            faceMassage3: 'Fördert Lymphdrainage',
            neckMassage: 'Nackenmassage',
            neckMassageDesc: 'Gezielte Massage zur Linderung von Nackensteifheit und Verspannungen.',
            neckMassage1: 'Lindert Nackenschmerzen',
            neckMassage2: 'Verbessert die Beweglichkeit',
            neckMassage3: 'Reduziert Stress',
            shoulderMassage: 'Schultermassage',
            shoulderMassageDesc: 'Gezielte Massage zur Linderung von Schultersteifheit und Beschwerden.',
            shoulderMassage1: 'Reduziert Schulterschmerzen',
            shoulderMassage2: 'Verbessert die Haltung',
            shoulderMassage3: 'Entspannt die Muskulatur',
            bodyMassage: 'Körpermassage',
            bodyMassageDesc: 'Eine Ganzkörpermassage zur Förderung von Entspannung und Wohlbefinden.',
            bodyMassage1: 'Fördert die Durchblutung',
            bodyMassage2: 'Lindert Muskelschmerzen',
            bodyMassage3: 'Fördert Entspannung',
            backMassage: 'Rückenmassage',
            backMassageDesc: 'Eine therapeutische Massage gegen Rückenschmerzen und Verspannungen.',
            backMassage1: 'Lindert Rückenschmerzen',
            backMassage2: 'Verbessert die Wirbelsäulengesundheit',
            backMassage3: 'Reduziert Stress',
            footMassage: 'Fußmassage',
            footMassageDesc: 'Eine wohltuende Massage zur Linderung von Fußschmerzen und Förderung der Entspannung.',
            footMassage1: 'Verbessert die Durchblutung',
            footMassage2: 'Reduziert Fußermüdung',
            footMassage3: 'Fördert Entspannung',
            purgative: 'Abführmittel',
            purgativeDesc: 'Eine reinigende Therapie zur Beseitigung von überschüssigem Pitta und Toxinen aus dem Verdauungssystem.',
            purgative1: 'Reinigung des Dickdarms',
            purgative2: 'Balanciert Pitta-Dosha',
            purgative3: 'Verbessert die Verdauungsgesundheit',
            nasalClearing: 'Nasenreinigung',
            nasalClearingDesc: 'Eine therapeutische Nasenbehandlung zur Reinigung der Nebenhöhlen und Verbesserung der Atemfunktion.',
            nasalClearing1: 'Befreit die Nasennebenhöhlen',
            nasalClearing2: 'Verbessert die Atmung',
            nasalClearing3: 'Lindert Nebenhöhlenprobleme',
            powderMassage: 'Pulvermassage',
            powderMassageDesc: 'Eine peelende Massage mit Kräuterpulvern zur Verjüngung und Erfrischung der Haut.',
            powderMassage1: 'Entfernt abgestorbene Haut',
            powderMassage2: 'Verbessert die Hautstruktur',
            powderMassage3: 'Fördert die Durchblutung',
            intensiveMassage: 'Intensive Massage',
            intensiveMassageDesc: 'Eine tiefe therapeutische Massage, die chronische Verspannungen und Muskelknoten mit festem Druck und spezialisierten Techniken anspricht.',
            intensiveMassage1: 'Lindert tiefe Muskelverspannungen',
            intensiveMassage2: 'Verbessert die Blutdurchblutung',
            intensiveMassage3: 'Reduziert Muskelkater',
            thermoMassage: 'Thermo-Massage',
            thermoMassageDesc: 'Eine warme Kräuteröl-Massage mit erwärmten therapeutischen Ölen zur Steigerung der Entspannungs- und Heilungsvorteile.',
            thermoMassage1: 'Lindert Muskelkater',
            thermoMassage2: 'Fördert tiefe Entspannung',
            thermoMassage3: 'Verbessert den Energiefluss',
            synchronMassage: 'Synchron-Massage',
            synchronMassageDesc: 'Eine synchronisierte Doppel-Therapeuten-Massage für vollständige Körperharmonie und ausgewogene Energieverteilung.',
            synchronMassage1: 'Vollständige Körperharmonie',
            synchronMassage2: 'Ausgewogener Energiefluss',
            synchronMassage3: 'Tiefe Entspannungserfahrung',
            specialMassage: 'Spezial-Massage',
            specialMassageDesc: 'Individualisierte Massagetherapie, die auf Ihre spezifischen Gesundheitsbedürfnisse und persönlichen Wellness-Ziele abgestimmt ist.',
            specialMassage1: 'Personalisierte Behandlung',
            specialMassage2: 'Behandelt spezifische Probleme',
            specialMassage3: 'Individualisierte Heilungsmethode',
            benefit1Title: 'Entgiftung:',
            benefit1Desc: 'Panchakarma-Behandlungen helfen, Giftstoffe aus dem Körper zu entfernen und fördern allgemeine Gesundheit und Vitalität.',
            benefit2Title: 'Verbesserte Verdauung:',
            benefit2Desc: 'Diese Therapien verbessern die Verdauungsfunktion für bessere Nährstoffaufnahme und Stoffwechsel.',
            benefit3Title: 'Stressabbau:',
            benefit3Desc: 'Panchakarma ist bekannt für seine beruhigende Wirkung auf Körper und Geist und reduziert Stress- und Angstniveaus.',
            benefit4Title: 'Stärkung der Immunität:',
            benefit4Desc: 'Regelmäßige Panchakarma-Behandlungen stärken das Immunsystem und machen den Körper widerstandsfähiger gegen Krankheiten.',
            benefit5Title: 'Verjüngung:',
            benefit5Desc: 'Die Therapien fördern die Zellregeneration für verbesserte Hautgesundheit und jugendliches Aussehen.',
            benefit6Title: 'Gleichgewicht der Doshas:',
            benefit6Desc: 'Panchakarma hilft, das Gleichgewicht der Doshas (Vata, Pitta, Kapha) wiederherzustellen, was gemäß ayurvedischen Prinzipien für die Gesundheit essentiell ist.',
            akkupancharTitle: 'Akupunktur-Therapie',
            akkupancharDesc1: 'ist eine alte ayurvedische Therapie mit Kräuterpasten und Ölen auf spezifischen Körperpunkten. Diese Behandlung stimuliert Energiekanäle und fördert Heilung.',
            akkupancharBenefit: 'Hauptvorteile:',
            akkupancharDesc2: 'Diese spezialisierte Therapie hilft bei chronischen Schmerzen, verbessert Gelenkflexibilität, fördert Durchblutung und stellt natürlichen Energiefluss wieder her. Sie ist besonders wirksam für diejenigen, die tiefe therapeutische Heilung und Verjüngung suchen.',
            akkupancharApplication: 'Therapeutische Anwendung:',
            akkupancharDesc3: 'Akupunktur wirkt auf spezifische Marma-Punkte (vitale Knotenpunkte) im ganzen Körper mit sorgfältig ausgewählten Kräuterzubereitungen zur Ausbalancierung der Doshas und Förderung optimaler Gesundheit und Wellness.',
            akkupancharTransform: 'Transformation erleben:',
            akkupancharDesc4: 'Im Muthumuni Ayurveda River Resort passen unsere erfahrenen Therapeuten jede Akupunktursitzung an Ihre einzigartigen Gesundheitsbedürfnisse an, um eine tiefgreifende und dauerhafte Heilungserfahrung zu gewährleisten.',
            gallery1: 'Shirodhara-Therapie',
            gallery2: 'Dampfbad',
            gallery3: 'Blütenbad',
            gallery4: 'Kopfmassage',
            gallery5: 'Körpermassage',
            gallery6: 'Nackenmassage',
            gallery7: 'Gesichtsmassage',
            gallery8: 'Schultermassage',
            sectionEyebrow: 'Panchakarma Ayurveda bei Muthumuni',
            sectionDescription: 'Entdecken Sie die alte Heilkunst des Panchakarma Ayurveda in unserem Flussufer-Retreat. Unsere erfahrenen ayurvedischen Praktiker bieten personalisierte Behandlungen zur Entgiftung, Verjüngung und Wiederherstellung des Gleichgewichts von Körper, Geist und Seele.',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Körper, Geist & Seele in Aluthgama verjüngen',
            heroAlt: 'Ayurveda & im Muthumuni River Resort',
            treatmentProgramme: {
                title: 'Ayurveda-Behandlungsprogramm',
                subtitle: 'Ihre Reise zu Balance, Entgiftung und tieferer Erneuerung',
                intro: 'Erleben Sie authentische ayurvedische Heilung in einem ruhigen Retreat, das Ihren Körper wiederherstellt, Ihren Geist beruhigt und Ihre Energie erneuert. Von dem Moment an, in dem Sie ankommen, kümmert sich unser Team um jedes Detail – damit Sie sich vollständig auf Ihr Wohlbefinden konzentrieren können.',
                welcomeTitle: 'Willkommen & sanfter Start',
                welcome1: 'Flughafenabholung und Transfer zum Hotel',
                welcome2: 'Warmer Empfang und Hotelführung',
                welcome3: 'Einführung in Ihren wöchentlichen Wellnessplan',
                welcome4: 'Entspannungsmassage (Tag 1) im Ayurveda-Zentrum zur Linderung von Reisemüdigkeit und Vorbereitung Ihres Körpers auf die Behandlungen',
                doctorTitle: 'Ärztliche Beratung & persönlicher Plan',
                doctor1: 'Ärztliche Ayurveda-Beratung (Tag 2 – morgens)',
                doctor2: 'Vollständige Bewertung Ihres Dosha/Körpertyps und Gesundheitsprobleme',
                doctor3: 'Übersetzer auf Anfrage verfügbar',
                doctor4: 'Ihr Arzt erstellt einen personalisierten Behandlungsplan, der auf Ihre Bedürfnisse und Ziele zugeschnitten ist',
                dailyTitle: 'Tägliche Ayurveda-Therapien',
                daily1: '4–5 Behandlungen täglich (wie vom Arzt empfohlen)',
                daily2: 'Therapien basierend auf Ihrer Körperkonstitution und Zustand ausgewählt',
                daily3: 'Spezielle Massagen können bei Bedarf hinzugefügt werden',
                daily4: 'Arzt überwacht täglich Fortschritte und kann Behandlungen und Kräuterunterstützung anpassen, um beste Ergebnisse zu gewährleisten',
                daily5: 'Bei Bedarf kann ein sanftes Reinigungs-/Abführmittelverfahren empfohlen werden',
                herbalTitle: 'Kräutermedizin-Unterstützung',
                herbalIntro: 'Vom Arzt verschriebene Kräutermedizinen zweimal täglich:',
                herbal1: 'zum Frühstück',
                herbal2: 'zum Abendessen',
                herbalClosing: 'Unterstützen innere Heilung, Entgiftung und langfristiges Gleichgewicht.',
                yogaTitle: 'Yoga & Meditation für Körper-Geist-Harmonie',
                yoga1: 'Yoga-Sitzungen 4 mal pro Woche (ca. 1 Stunde)',
                yoga2: 'Meditationssitzungen 2 mal pro Woche:',
                yoga3: '— ein einzigartiges spirituelles Erlebnis auf einem Inseltempel, erreichbar mit dem Boot',
                yoga4: '— angeleitete Meditation von Mönchen (ca. 1 Stunde)',
                wellnessTitle: 'Inbegriffene Wellness-Erfahrungen',
                wellness1: 'Wöchentliche gesunde Koch-Demonstrationen',
                wellness2: 'Kostenloser Ausflug (Kultur-/Naturerlebnis)',
                closingTitle: 'Abschlusszeremonie & Abreise',
                closing1: 'Ein schönes Blütenbad (letzter Tag) – traditionelles Erneuerungsritual',
                closing2: 'Abschließende Ärztliche Beratung zur Überprüfung des Fortschritts und Bereitstellung von:',
                closing3: '— fortgesetzte Wellness-Beratung',
                closing4: '— Verschreibungen und Empfehlungen für zu Hause',
                closing5: 'Transfer zum Flughafen',
            }
        },
        yoga2: {
            heroTitle: 'Yoga im Resort',
            heroSubtitle: 'Balance, Kraft & innere Ruhe in Beruwala finden',
            heroAlt: 'Yoga im Muthumuni Resort',
            importanceEyebrow: 'Wohlbefinden & Balance',
            importanceTitle: 'Bedeutung von Yoga & Meditation',
            importanceImageAlt: 'Bedeutung von Yoga und Meditation',
            importanceText1: 'Yoga und Meditation sind jahrtausendealte Praktiken, die zahlreiche körperliche, geistige und emotionale Vorteile bieten. Sie fördern Beweglichkeit, Kraft und Gleichgewicht und reduzieren gleichzeitig Stress und Ängste.',
            importanceText2: 'Regelmäßiges Üben kann die Konzentration verbessern, die Schlafqualität steigern und das allgemeine Wohlbefinden fördern. Yoga unterstützt auch Achtsamkeit und hilft den Menschen, sich mit ihrem inneren Selbst zu verbinden und inmitten des Alltags Chaos Frieden zu finden.',
            importanceText3: 'Im Muthumuni Resort schaffen wir ruhige Umgebungen, die perfekt für Yoga und Meditation geeignet sind, sodass unsere Gäste Körper, Geist und Seele erneuern können.',
            practiceEyebrow: 'Unsere Praxis',
            practiceTitle: 'Yoga-Praxis & Erfahrung',
            practiceImageAlt: 'Yoga-Praxis im Resort',
            practiceText1: 'Im Muthumuni Resort praktizieren wir hauptsächlich traditionelles Hatha Yoga in Kombination mit Pranayama (Atemtechniken). Dieser ganzheitliche Ansatz zielt darauf ab, innere Bewusstheit zu erwecken, die Kundalini sanft zu stimulieren und dabei besonderen Wert auf Wirbelsäulenausrichtung und Beweglichkeit zu legen.',
            practiceText2: 'Yoga-Stunden finden regelmäßig statt und sind sowohl für Anfänger als auch für erfahrene Praktizierende geeignet. Von Zeit zu Zeit werden auch spezielle Einheiten wie Ashtanga Yoga angeboten.',
            practiceText3: 'Alle Yoga-Sessions finden in unserem speziell dafür eingerichteten Yoga Shala statt – einem ruhigen und friedvollen Raum, der Konzentration, Gleichgewicht und achtsame Bewegung unterstützt. Jede Stunde beginnt in der Regel mit Sonnengrüßen, gefolgt von Pranayama und einer sorgfältig ausgewählten Asana-Sequenz zur Verbesserung von Beweglichkeit und Durchblutung.',
            practiceText4: 'Unsere erfahrenen Yogalehrer passen jede Stunde an die individuellen Bedürfnisse, Fähigkeiten und gesundheitlichen Voraussetzungen der Gäste an, um ein sicheres und tiefgehend wohltuendes Erlebnis zu gewährleisten.',
            spiritualEyebrow: 'Spirituelle Reise',
            spiritualTitle: 'Meditation & Spirituelle Aktivitäten',
            spiritualSubtitle: 'Vertiefen Sie Ihre spirituelle Praxis mit unseren heiligen Zeremonien und geführten Meditationssitzungen',
            meditationImageAlt: 'Meditation und spirituelle Praxis im Resort',
            meditationTitle: 'Meditationssitzungen',
            meditationDesc: 'Gäste sind herzlich eingeladen, an geführten Meditationssitzungen teilzunehmen, die von traditionellen Praktiken inspiriert sind. Diese Sitzungen dienen dazu, den Geist zu beruhigen, das Bewusstsein zu vertiefen und emotionale sowie spirituelle Heilung in friedvoller Umgebung zu unterstützen.'
        },
        food2: {
            heroTitle: 'Ayurvedisches Essen & Küstenküche',
            heroSubtitle: 'Authentische sri-lankische Aromen & frische Küstenküche',
            heroAlt: 'Kulinarisches Erlebnis im Muthumuni Beach Resort',
            wellnessEyebrow: 'Wohlbefinden durch Ernährung',
            wellnessTitle: 'Die Bedeutung von',
            ayurvedicFood: 'Ayurvedischer Ernährung',
            wellnessIntro1: 'In der Ayurveda gilt Nahrung als die größte Medizin. Was Sie essen, beeinflusst direkt Ihre Doshas (Vata, Pitta, Kapha), die Verdauung (Agni) und das gesamte Gleichgewicht von Körper, Geist und Seele.',
            wellnessIntro2: 'Die ayurvedische Ernährung legt Wert auf frische, saisonale, unverarbeitete Lebensmittel, die achtsam zubereitet und genossen werden. Jede Mahlzeit enthält die sechs Geschmacksrichtungen (süß, sauer, salzig, scharf, bitter, herb), um alle Sinne zu nähren und Harmonie zu schaffen.',
            wellnessIntro3: 'Eine richtige ayurvedische Ernährung stärkt die Verdauung, hilft Toxine (Ama) auszuleiten, steigert die Immunität, erhöht die Energie, reduziert Stress und beugt vielen chronischen Erkrankungen vor. Im Muthumuni wird jedes Gericht auf Ihre individuelle Konstitution abgestimmt, um tiefe Heilung und Vitalität zu fördern.',
            foodImage1Alt: 'Traditionelle ayurvedische Mahlzeit mit sechs Geschmacksrichtungen',
            foodImage2Alt: 'Ayurvedische Kräuter und Gewürze für ausgewogene Ernährung',
            culinaryPhilosophyEyebrow: 'Unsere kulinarische Philosophie',
            culinaryPhilosophyTitle: 'Ayurvedische',
            nutritionHighlight: 'Ernährung',
            culinaryPhilosophyResort: 'im Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ayurvedische Küche im Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Frisch & nährend',
            healingIngredientsAlt: 'Gesunde ayurvedische Zutaten und Gewürze',
            healingIngredientsLabel: 'Heilende Zutaten',
            philosophyText1: 'Die Nahrung, die die sechs Hauptgeschmacksrichtungen (süß, sauer, salzig, bitter, scharf, herb) sowie viele feine Abstufungen umfasst, wird in klassischen ayurvedischen Texten – einige über 5.000 Jahre alt – zusammen mit den wesentlichen Eigenschaften jedes Lebensmittels beschrieben: Guna (natürliche Qualität), Virya (heiß/kalt wirkend), Vipaka (Nachverdauungswirkung) und Prabhava (einzigartige spezielle Wirkung).',
            philosophyText2: 'Deshalb spielt die ayurvedische Ernährung im Muthumuni Ayurveda Beach Resort eine zentrale Rolle. Das bedeutet jedoch kein starres, eintöniges Regime aus fade, geschmacklosen oder übermäßig bitteren vegetarischen Gerichten, die allein von Ärzten diktiert werden. Im Gegenteil: Unsere Ayurveda-Küche zählt zu unseren größten Stärken – die von unseren talentierten Köchen zubereiteten Gerichte werden Sie jeden Tag Ihres Aufenthalts überraschen und begeistern!',
            philosophyText3: 'Zum Frühstück erwartet Sie ein reichhaltiges Buffet mit frischen tropischen Früchten, frisch gepressten Säften, nährenden Kräutersuppen, hausgebackenem Brot und leichten Keksen sowie einer Vielzahl authentischer sri-lankischer Frühstücksoptionen. Zum Mittagessen gibt es ein buntes und geschmackvolles Buffet mit milden Fischcurrys, Gemüsezubereitungen und kräuterinfundierten Gerichten. Abends servieren wir ein festes vegetarisches Menü mit einer frischen Fischoption. Samstags feiern wir „Sri Lankan Night“ mit einem erweiterten Buffet – unsere Köche bereiten traditionelle lokale Spezialitäten direkt vor Ihren Augen zu und schaffen ein lebendiges, authentisches Erlebnis.',
            philosophyText4: 'In der Ayurveda werden Lebensmittel und Getränke auf vielfältige Weise klassifiziert – nach Geschmack und Eigenschaften, der Verdauungskapazität (Agni), Eignung für bestimmte Gesundheitszustände, jahreszeitlicher Angemessenheit usw. Im Muthumuni berücksichtigen wir all diese Faktoren gleichzeitig und bemühen uns bewusst, alle sechs Geschmacksrichtungen in ausgewogenen Kombinationen anzubieten, die auf die individuelle Konstitution jedes Gastes abgestimmt sind.',
            philosophyText5: 'Unsere Mahlzeiten bestehen aus frischem Gemüse, tropischen Früchten und verantwortungsvoll bezogenem Fisch. Wir servieren weder rotes Fleisch noch Alkohol.',
            philosophyText6: 'Während der Mahlzeiten steht immer ein ayurvedischer Arzt oder qualifizierter Ernährungsberater zur Verfügung, um Sie zu beraten. Sie erhalten Empfehlungen zu den am besten geeigneten Gemüsen, Kräutern und Gewürzen für Ihre aktuelle Behandlungsphase und Hilfe bei der Auswahl oder Vermeidung bestimmter Gerichte. Ihr persönliches Kräuterelixier sowie spezielle Anweisungen des Gesundheitszentrums werden an Ihrem individuellen Tisch platziert.',
            philosophyText7: 'Dieses Maß an personalisierter Betreuung und Aufmerksamkeit für die Ernährung ist ein Markenzeichen des Muthumuni Ayurveda Beach Resort Erlebnisses.',
            philosophyText8: 'Nahrung wird als Prana – die lebensspendende Energie – für jeden Menschen betrachtet. Deshalb laden wir Sie ein, jede Mahlzeit mit voller Achtsamkeit zu genießen: die Aromen wahrnehmen, die Geschmäcker erleben, die sanfte Wärme spüren und die köstlichen Empfindungen bewusst wahrnehmen.',
            diningExperienceEyebrow: 'Speiseerlebnis',
            restaurantTitlePrefix: 'Unser',
            ayurvedicHighlight: 'Ayurvedisches',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Unser ayurvedisches Restaurant im Muthumuni Beach Resort bietet ein einzigartiges Speiseerlebnis, das traditionelle ayurvedische Prinzipien mit authentischer sri-lankischer Küstenküche harmonisch verbindet. Wir setzen auf frische, lokal bezogene Zutaten, um Gerichte zu kreieren, die nicht nur den Gaumen erfreuen, sondern auch das ganzheitliche Wohlbefinden fördern.',
            restaurantDetail2: 'Das Menü ist sorgfältig gestaltet, um in jedem Gericht die sechs Geschmacksrichtungen (süß, sauer, salzig, bitter, scharf, herb) auszubalancieren und so ein nährendes und befriedigendes Erlebnis zu gewährleisten. Jedes Gericht wird mit Sorgfalt zubereitet und enthält ayurvedische Kräuter und Gewürze mit bekannten heilenden Eigenschaften.',
            restaurantDetail3: 'Die Gäste können eine Vielzahl von Gerichten genießen, die auf ihre individuellen Doshas (Körperkonstitutionen) abgestimmt sind, mit Optionen für vegetarische, vegane und pescetarische Ernährung. Unsere Köche arbeiten eng mit ayurvedischen Praktikern zusammen, um sicherzustellen, dass jede Mahlzeit die Gesundheits- und Wellness-Ziele der Gäste unterstützt.',
            restaurantDetail4: 'Das Ambiente des Restaurants spiegelt die ruhige Küstenumgebung wider und bietet einen friedlichen Rahmen für achtsames Essen. Ob beim reichhaltigen Frühstücksbuffet oder beim Genuss eines Gourmet-Abendessens – jede Mahlzeit in unserem ayurvedischen Restaurant ist eine Gelegenheit, Körper und Seele zu nähren.',
            restaurantDetail5: 'Besuchen Sie uns im ayurvedischen Restaurant des Muthumuni Beach Resort für eine kulinarische Reise, die die reichen Aromen Sri Lankas feiert und die zeitlose Weisheit der Ayurveda umarmt.',
            restaurantImageAlt: 'Essen im Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Premium Dining',
            premiumDiningDescription: 'Erleben Sie authentische ayurvedische Küche in einer ruhigen Flusslage'
        },
        events2: {
            heroEyebrow: 'Erlebnisse & Aktivitäten',
            heroTitle: 'Unsere Events',
            heroSubtitle: 'Kuratierte Erlebnisse, die sri-lankische Tradition mit Küstenluxus verbinden',
            heroAlt: 'Events bei Muthumuni',
            availableDaily: 'Täglich verfügbar',
            bookNow: 'Jetzt buchen',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} Detail',
            ctaTitle: 'Bereit, Erinnerungen zu schaffen?',
            ctaDescription: 'Kontaktieren Sie unser Team, um Ihr perfektes Event-Erlebnis im Muthumuni Ayurveda Beach Resort individuell zu gestalten',
            ctaContact: 'Kontaktieren Sie uns',
            ctaViewRooms: 'Zimmer ansehen',
            cookeryTitle: 'Kochkurse',
            cookerySubtitle: 'Geschmack von Sri Lanka',
            cookeryDescription: 'Tauchen Sie ein in die lebendigen Aromen der sri-lankischen Küche. Unsere erfahrenen Köche führen Sie durch praktische Kochkurse und vermitteln traditionelle Rezepte, die über Generationen weitergegeben wurden. Lernen Sie, aromatische Currys, Hoppers, Kokos-Sambol und mehr mit frischen lokalen Zutaten zuzubereiten.',
            cookeryHighlight1: 'Traditionelle sri-lankische Rezepte',
            cookeryHighlight2: 'Praktische Kocherfahrung',
            cookeryHighlight3: 'Frische lokale Zutaten',
            cookeryHighlight4: 'Rezepte mit nach Hause nehmen',
            cookeryHighlight5: 'Gewürzgarten-Tour inklusive',
            meditationTitle: 'Meditationsprogramme',
            meditationSubtitle: 'Innere Ruhe & Achtsamkeit',
            meditationDescription: 'Finden Sie Ruhe in unseren geführten Meditationssitzungen mit Blick auf den ruhigen Indischen Ozean. Unsere erfahrenen Lehrer führen Sie durch alte Achtsamkeitstechniken, Atemübungen und Yoga-Praktiken, die den Geist beruhigen und den Geist erfrischen.',
            meditationHighlight1: 'Sonnenauf- & Sonnenuntergang-Sessions',
            meditationHighlight2: 'Meditation direkt am Strand',
            meditationHighlight3: 'Von Experten geleitet',
            meditationHighlight4: 'Atemtechniken',
            meditationHighlight5: 'Yoga & Achtsamkeitsübungen',
            bbqTitle: 'BBQ-Partys',
            bbqSubtitle: 'Strandfeiern',
            bbqDescription: 'Erleben Sie unvergessliche Abende bei unseren Strand-BBQ-Partys. Genießen Sie frisch gegrillte Meeresfrüchte, Premium-Fleisch und vegetarische Köstlichkeiten, während die Wellen leise rauschen. Live-Musik, Feuertänzer und der Sternenhimmel schaffen die perfekte Atmosphäre für Feier und Begegnung.',
            bbqHighlight1: 'Frisch gegrillte Meeresfrüchte',
            bbqHighlight2: 'Speisen direkt am Meer',
            bbqHighlight3: 'Live-Unterhaltung',
            bbqHighlight4: 'Lagerfeuer-Erlebnis',
            bbqHighlight5: 'Individualisierbare Menüs',
            boatTitle: 'Bootsfahrten',
            boatSubtitle: 'Fluss- & Küstenabenteuer',
            boatDescription: 'Begeben Sie sich auf zauberhafte Bootsfahrten entlang des Bentota-Flusses und der Küstengewässer. Gleiten Sie durch Mangrovenwälder, beobachten Sie exotische Vögel und Wildtiere oder genießen Sie romantische Sonnenuntergangsfahrten. Unsere Bootsausflüge bieten eine einzigartige Perspektive auf Sri Lankas natürliche Schönheit und vielfältige Ökosysteme.',
            boatHighlight1: 'Bentota-Flussfahrten',
            boatHighlight2: 'Mangroven-Erkundung',
            boatHighlight3: 'Wildtierbeobachtung',
            boatHighlight4: 'Sonnenuntergangs-Bootsfahrten',
            boatHighlight5: 'Privater Charter verfügbar',
            ayurvedaLecturesTitle: 'Vorträge der Ayurveda-Ärzte',
            ayurvedaLecturesSubtitle: 'Alte Weisheit & modernes Wohlbefinden',
            ayurvedaLecturesDescription: 'Entdecken Sie die tiefgründigen Prinzipien der Ayurveda durch fachkundige Vorträge zertifizierter Ayurveda-Ärzte und Praktiker. Lernen Sie Dosha-Ausgleich, pflanzliche Heilmittel, ganzheitliche Heilmethoden und wie alte Weisheit auf modernes Wohlbefinden angewendet wird. Unsere interaktiven Sitzungen machen die ayurvedische Philosophie verständlich und alltagstauglich.',
            ayurvedaLecturesHighlight1: 'Zertifizierte Ayurveda-Ärzte',
            ayurvedaLecturesHighlight2: 'Persönliche Dosha-Analyse',
            ayurvedaLecturesHighlight3: 'Ausbildung zu pflanzlichen Heilmitteln',
            ayurvedaLecturesHighlight4: 'Fragerunden inklusive',
            ayurvedaLecturesHighlight5: 'Mitnehm-Ratgeber für zu Hause',
            traditionalClothsTitle: 'Traditionelle Kleidung tragen Events',
            traditionalClothsSubtitle: 'Kulturelles Erbe erleben',
            traditionalClothsDescription: 'Tauchen Sie ein in das sri-lankische Kulturerbe, indem Sie traditionelle Kleidung anlegen und verstehen lernen. Unsere Experten-Stylisten führen Sie durch das Anlegen authentischer Kandyan-Saris und traditioneller Gewänder und erklären die kulturelle Bedeutung jedes Stücks. Perfekt für besondere Anlässe, kulturelle Wertschätzung oder unvergessliche Fotos.',
            traditionalClothsHighlight1: 'Professionelle Styling-Anleitung',
            traditionalClothsHighlight2: 'Authentische traditionelle Saris',
            traditionalClothsHighlight3: 'Kulturelle Bedeutung erklärt',
            traditionalClothsHighlight4: 'Professionelle Fotografie inklusive',
            traditionalClothsHighlight5: 'Fashion-Fusion-Workshops'
        },
        blogs2: {
            heroTitle: 'Muthumuni Ayurveda River Resort Blogs',
            heroSubtitle1: 'Geschichten vom Flussufer, Ayurveda-Rituale im',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Tauchen Sie ein in Tipps, Geschichte und Einblicke hinter die Kulissen.',
            heroAlt: 'Resort-Flussuferpromenade bei Sonnenuntergang',
            sectionTitle: 'Muthumuni Ayurveda River Resort Blogs',
            sectionDescription: 'Guides, Geschichten und Notizen aus unserem Rückzugsort am Flussufer – von Ayurveda-Ritualen über Wellness-Praktiken bis hin zu Reisetipps rund um Bentota.',
            ayurvedaTitle: 'Das Herz authentischer Ayurveda',
            ayurvedaExcerpt: 'Erleben Sie jahrhundertealte Heiltraditionen, die in der alten Weisheit Sri Lankas verwurzelt sind.',
            ayurvedaDescription: 'Im Muthumuni Ayurveda River Resort ist Ayurveda mehr als eine Behandlung – es ist eine Lebensweise. Unsere Therapien basieren auf jahrhundertealtem Wissen, werden individuell auf Ihren Körpertyp abgestimmt und von erfahrenen ayurvedischen Ärzten geleitet, um ein tiefes, nachhaltiges Gleichgewicht zu schaffen.',
            ayurvedaAlt: 'Ayurvedische Behandlung mit Kräuterölen und natürlichen Elementen',
            healingTitle: 'Persönliche Heilreisen',
            healingExcerpt: 'Warum jedes Wellness-Programm unserer Gäste einzigartig gestaltet wird.',
            healingDescription: 'Von der Erstkonsultation bis zu den täglichen Behandlungen wird Ihre Heilreise sorgfältig auf Sie abgestimmt. Kräutertherapien, therapeutische Massagen, Yoga und Meditation arbeiten zusammen, um Harmonie zwischen Körper, Geist und Seele wiederherzustellen.',
            healingAlt: 'Ayurvedischer Arzt berät einen Gast in ruhiger Atmosphäre',
            natureTitle: 'Heilung am Flussufer',
            natureExcerpt: 'Wie die ruhige Flusslage und die tropische Umgebung Ihr Wohlbefinden verstärken.',
            natureDescription: 'Eingebettet am ruhigen Flussufer Sri Lankas bietet Muthumuni eine natürliche Heilumgebung. Das sanfte Fließen des Flusses, frische Luft und üppiges Grün verstärken die Wirkung von Ayurveda und schaffen tiefe Entspannung und Erneuerung.',
            natureAlt: 'Flussuferblick des Resorts mit Palmen und Natur',
            foodTitle: 'Ayurvedische Küche für inneres Gleichgewicht',
            foodExcerpt: 'Nährstoffreiche Mahlzeiten, die Ihre Behandlung unterstützen.',
            foodDescription: 'Unsere ayurvedische Küche wird täglich frisch mit saisonalen, regionalen Zutaten zubereitet. Jede Mahlzeit ist auf Ihren Dosha-Typ abgestimmt, unterstützt Verdauung, Entgiftung und Vitalität und bleibt dabei geschmackvoll und sättigend.',
            foodAlt: 'Traditionelle ayurvedische Mahlzeit in natürlichen Schalen serviert',
            yogaTitle: 'Yoga, Meditation & innere Stille',
            yogaExcerpt: 'Sanfte Übungen, die den Geist beruhigen und den Körper stärken.',
            yogaDescription: 'Tägliche Yoga- und Meditationssitzungen ergänzen Ihre Behandlungen, verbessern Beweglichkeit, Atmung und mentale Klarheit. Diese achtsamen Praktiken helfen Ihnen, sich wieder mit sich selbst zu verbinden und ein Gefühl von Frieden mit nach Hause zu nehmen.',
            yogaAlt: 'Gäste praktizieren Yoga mit Blick auf den Fluss bei Sonnenaufgang',
            lifestyleTitle: 'Ayurveda mit nach Hause nehmen',
            lifestyleExcerpt: 'Einfache Lebensgewohnheiten, um Ihre Wellness-Reise fortzusetzen.',
            lifestyleDescription: 'Vor Ihrer Abreise geben Ihnen unsere Experten Anleitungen, wie Sie das Gleichgewicht durch tägliche Routinen, Ernährung und Selbstpflegerituale bewahren können. Nehmen Sie mehr als nur Erinnerungen mit – nehmen Sie einen nachhaltigen Weg zu einem gesünderen Leben mit.',
            lifestyleAlt: 'Gast entspannt mit Kräutertee in ruhiger Resort-Umgebung',
            readMore: 'Mehr lesen'
        },
        footer: {
            description: 'Das Muthumuni Ayurveda Beach Resort bietet außergewöhnliche Gastfreundschaft und Wellness-Erlebnisse, damit sich jeder Gast wertgeschätzt und erholt fühlt.',
            linksTitle: 'Links',
            contactTitle: 'Kontakt',
            viewLocation: 'Standort anzeigen',
            navHome: 'Startseite',
            navAbout: 'Über uns',
            navContact: 'Kontakt',
            navRooms: 'Zimmer',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Entwickelt von',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Touren & Ausflüge',
            heroSubtitle: 'Entdecken Sie Sri Lankas Schönheit von Beruwala',
            kandeAlt: 'Kande-Vihara-Tempel - Beruwala',
            kandeTitle: 'Besuch des Kande-Vihara-Tempels',
            kandeBuddhaAlt: 'Riesige Buddha-Statue im Kande-Vihara-Tempel',
            bentotaTitle: 'Bentota-Fluss-Bootsfahrt',
            bentotaAlt: 'Bentota-Fluss-Bootsfahrt - Mangrovenwälder und Tierwelt',
            galleTitle: 'Galle-Altstadt-Tour',
            galleAlt: 'Galle-Altstadt-Tour',
            sigiriyaTitle: 'Sigiriya-Felsenfestung-Tour',
            sigiriyaAlt: 'Sigiriya-Felsenfestung-Tour',
            kandyTitle: 'Kandy-Kulturtour',
            kandyAlt: 'Kandy-Kulturtour',
            bookTour: 'Diese Tour buchen',
            introPara1: 'Sri Lanka ist ein Land zeitloser Schönheit, in dem goldene Strände, üppig grüne Landschaften, alte Tempel und lebendige Kultur in perfekter Harmonie zusammenkommen.',
            introPara2: 'Von der ruhigen Südwestküste bis zu historischen Städten, heiligen Stätten, Wildschutzgebieten und nebligen Berglandschaften bietet jede Reise ein einzigartiges und unvergessliches Erlebnis.',
            introPara3: 'Von unserem Muthumuni Ayurveda Beach Resort in Beruwala aus sind unsere sorgfältig kuratieren Touren und Ausflüge darauf ausgerichtet, Ihren Aufenthalt zu bereichern und perfekt Balance zwischen Erkundung, Entspannung und Wohlbefinden zu schaffen.',
            kandeDetail1: 'Kande-Vihara-Tempel (Kande Viharaya) – einer der ikonischsten buddhistischen Tempel in der Nähe von Beruwala.',
            kandeDetail2: 'Dieser 1734 gegründete, ruhige \'Bergtempel\' thront auf einem Hügel mit friedlichen Ausblicken auf die Küste.',
            kandeDetail3: 'Zu den Höhepunkten gehören die massive 48 Meter hohe sitzende Buddha-Statue (eine der höchsten Sri Lankas), aufwendige Kandyan-Fresken, eine alte Reliquienkammer, ein schöner Mondstein-Eingang und ein über 300 Jahre alter heiliger Bodhi-Baum.',
            kandeDetail4: 'Ein perfektes spirituelles und kulturelles Erlebnis für einen halben Tag – ideal für Morgenbesuche, um der Hitze zu entgehen.',
            bentotaDetail1: 'Genießen Sie eine ruhige und malerische Bootsfahrt entlang des Bentota-Flusses, einer der beliebtesten Naturexkursionen in der Nähe von Beruwala.',
            bentotaDetail2: 'Gleiten Sie durch üppige Mangrovenwälder, enge Kanäle und ruhige Seen und beobachten Sie dabei die lokale Tierwelt.',
            bentotaDetail3: 'Häufige Sichtungen sind Wasserwarane, Krokodile, verschiedene Vogelarten (Eisvögel, Reiher, Adler), Affen und gelegentlich Otter oder Wasserschlangen.',
            bentotaDetail4: 'Ihr erfahrener Bootsführer/Reiseleiter zeigt Ihnen interessante Flora, traditionelle Fischereimethoden und das Leben in Flussdörfern.',
            bentotaDetail5: 'Perfekt für Naturliebhaber und Fotografen – ruhig, entspannend und eine Ergänzung zu Ihrem Ayurveda-Wellness-Aufenthalt.',
            galleDetail1: 'Erkunden Sie die historische Galle-Festung, ein UNESCO-Weltkulturerbe und eine der best erhaltenen Festungen aus der Kolonialzeit Sri Lankas.',
            galleDetail2: 'Wandeln Sie durch Kopfsteinpflasterstraßen, gesäumt von niederländischen Kolonialgebäuden, Boutique-Shops, Cafés und Kunstgalerien.',
            galleDetail3: 'Besuchen Sie Wahrzeichen wie den Galle-Leuchtturm, die niederländische reformierte Kirche, das Nationale Schifffahrtsmuseum und die Wälle mit herrlichem Meerblick.',
            galleDetail4: 'Erfahren Sie von Ihrem sachkundigen Reiseleiter mehr über die reiche Geschichte, Architektur und kulturelle Bedeutung der Festung.',
            galleDetail5: 'Ideal für Geschichtsliebhaber, Kulturfans und diejenigen, die Sri Lankas Kolonialvergangenheit erleben möchten.',
            sigiriyaDetail1: 'Entdecken Sie die antike Felsenfestung Sigiriya, eines der ikonischsten Wahrzeichen Sri Lankas und ein UNESCO-Weltkulturerbe.',
            sigiriyaDetail2: 'Klettern Sie auf den beeindruckenden Felsen und erkunden Sie die Ruinen des Palastes von König Kasyapa, verziert mit Fresken, Wassergärten und der berühmten Spiegelmauer.',
            sigiriyaDetail3: 'Genießen Sie Panoramablicke auf den umliegenden Dschungel und die Landschaft vom Gipfel.',
            sigiriyaDetail4: 'Erfahren Sie von Ihrem Experten über die faszinierende Geschichte, Architektur und Legenden von Sigiriya.',
            sigiriyaDetail5: 'Perfekt für Geschichtsbegeisterte, Abenteuerlustige und diejenigen, die sich für Sri Lankas reiches Kulturerbe interessieren.',
            kandyDetail1: 'Erleben Sie die lebendige Kultur von Kandy, Sri Lankas letzte Königshauptstadt und ein UNESCO-Weltkulturerbe.',
            kandyDetail2: 'Besuchen Sie den Tempel der heiligen Zahnreliquie (Sri Dalada Maligawa), eine der wichtigsten buddhistischen Stätten der Welt.',
            kandyDetail3: 'Erkunden Sie die Royal Botanical Gardens in Peradeniya mit einer großartigen Sammlung von Tropenpflanzen und Orchideen.',
            kandyDetail4: 'Genießen Sie eine traditionelle Kandyan-Tanzaufführung, die Sri Lankas reiches künstlerisches Erbe zeigt.',
            kandyDetail5: 'Ideal für Kulturfans, Geschichtsliebhaber und diejenigen, die sich in Sri Lankas Traditionen vertiefen möchten.'
        },
        tours2: {
            heroTitle: 'Touren & Ausflüge',
            heroSubtitle: 'Entdecken Sie die Schönheit Sri Lankas von Beruwala aus',
            kandeAlt: 'Kande Vihara Tempel – Beruwala',
            kandeTitle: 'Besuch des Kande Vihara Tempels',
            kandeBuddhaAlt: 'Riesige Buddha-Statue im Kande Vihara Tempel',
            bentotaTitle: 'Bentota Fluss Boots-Safari',
            bentotaAlt: 'Bentota Fluss Boots-Safari – Mangroven und Wildtiere',
            galleTitle: 'Galle Altstadt Tour',
            galleAlt: 'Galle Altstadt Tour',
            sigiriyaTitle: 'Sigiriya Felsenfestung Tour',
            sigiriyaAlt: 'Sigiriya Felsenfestung Tour',
            kandyTitle: 'Kandy Kultur Tour',
            kandyAlt: 'Kandy Kultur Tour',
            bookTour: 'Diese Tour buchen',
            introPara1: 'Sri Lanka ist ein Land zeitloser Schönheit, wo goldene Strände, üppige grüne Landschaften, alte Tempel und lebendige Kultur in perfekter Harmonie zusammenkommen.',
            introPara2: 'Von der ruhigen Südwestküste bis zu historischen Städten, heiligen Stätten, Wildreservaten und nebligen Bergregionen bietet jede Reise ein einzigartiges und unvergessliches Erlebnis.',
            introPara3: 'Ausgehend vom Muthumuni Ayurveda Beach Resort in Beruwala sind unsere sorgfältig zusammengestellten Touren und Ausflüge darauf ausgelegt, Ihren Aufenthalt zu bereichern und Erkundung, Entspannung und Wohlbefinden perfekt auszubalancieren.',
            kandeDetail1: 'Kande Vihara Tempel (Kande Viharaya) – einer der ikonischsten buddhistischen Tempel in der Nähe von Beruwala.',
            kandeDetail2: 'Gegründet 1734, thront dieser friedliche „Bergtempel“ auf einem Hügel mit herrlichem Blick über die Küste.',
            kandeDetail3: 'Highlights sind die massive 48 Meter (160 ft) hohe sitzende Buddha-Statue (eine der höchsten Sri Lankas), kunstvolle Fresken aus der Kandyan-Ära, die alte Reliquienkammer, der wunderschöne Mondstein-Eingang und ein heiliger Bodhi-Baum über 300 Jahre alt.',
            kandeDetail4: 'Ein perfektes halbtägiges spirituelles & kulturelles Erlebnis – ideal für Morgenbesuche, um der Hitze zu entgehen.',
            bentotaDetail1: 'Genießen Sie eine friedliche und malerische Boots-Safari entlang des Bentota River, einer der beliebtesten Natur-Ausflüge nahe Beruwala.',
            bentotaDetail2: 'Gleiten Sie durch üppige Mangroven, enge Kanäle und ruhige Gewässer und beobachten Sie dabei die lokale Tierwelt.',
            bentotaDetail3: 'Häufige Sichtungen umfassen Warane, Krokodile, verschiedene Vogelarten (Eisvögel, Reiher, Adler), Affen und gelegentlich Otter oder Wasserschlangen.',
            bentotaDetail4: 'Ihr erfahrener Bootsführer wird interessante Pflanzen, traditionelle Fischfangmethoden und das Leben in den Flussdörfern erklären.',
            bentotaDetail5: 'Perfekt für Naturliebhaber und Fotografen – ruhig, entspannend und ideal ergänzend zu Ihrem ayurvedischen Wellness-Aufenthalt.',
            galleDetail1: 'Erkunden Sie die historische Galle Fort, eine UNESCO-Weltkulturerbestätte und eine der best erhaltenen Kolonialfestungen Sri Lankas.',
            galleDetail2: 'Schlendern Sie durch Kopfsteinpflasterstraßen mit holländischen Kolonialgebäuden, Boutiquen, Cafés und Kunstgalerien.',
            galleDetail3: 'Besuchen Sie wichtige Wahrzeichen wie den Galle Leuchtturm, die Dutch Reformed Church, das Nationale Maritime Museum und die Bastionen mit atemberaubendem Meerblick.',
            galleDetail4: 'Erfahren Sie von Ihrem kenntnisreichen Guide mehr über die reiche Geschichte, Architektur und kulturelle Bedeutung der Festung.',
            galleDetail5: 'Ideal für Geschichtsinteressierte, Kulturliebhaber und alle, die Sri Lankas koloniale Vergangenheit erleben möchten.',
            sigiriyaDetail1: 'Entdecken Sie die antike Felsenfestung Sigiriya, eines der ikonischsten Wahrzeichen Sri Lankas und UNESCO-Weltkulturerbe.',
            sigiriyaDetail2: 'Erklimmen Sie den beeindruckenden Felsen, um die Ruinen des Palastes von König Kasyapa zu erkunden, geschmückt mit Fresken, Wassergärten und der berühmten Spiegelwand.',
            sigiriyaDetail3: 'Genießen Sie vom Gipfel panoramische Ausblicke auf den umliegenden Dschungel und das Land.',
            sigiriyaDetail4: 'Erfahren Sie von Ihrem Experten-Guide mehr über die faszinierende Geschichte, Architektur und Legenden von Sigiriya.',
            sigiriyaDetail5: 'Perfekt für Geschichtsbegeisterte, Abenteuerlustige und alle, die sich für Sri Lankas reiches kulturelles Erbe interessieren.',
            kandyDetail1: 'Erleben Sie die lebendige Kultur von Kandy, der letzten königlichen Hauptstadt Sri Lankas und UNESCO-Weltkulturerbe.',
            kandyDetail2: 'Besuchen Sie den Tempel des Heiligen Zahns (Sri Dalada Maligawa), eine der wichtigsten buddhistischen Stätten der Welt.',
            kandyDetail3: 'Erkunden Sie die Royal Botanical Gardens in Peradeniya mit einer riesigen Sammlung tropischer Pflanzen und Orchideen.',
            kandyDetail4: 'Genießen Sie eine traditionelle Kandyan-Tanzvorführung, die Sri Lankas reiches künstlerisches Erbe zeigt.',
            kandyDetail5: 'Ideal für Kulturliebhaber, Geschichtsinteressierte und alle, die in die Traditionen Sri Lankas eintauchen möchten.'
        },
        blogs: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort Blogs',
            heroSubtitle1: 'Geschichten von der Küste, Ayurveda-Rituale im',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Entdecken Sie Tipps, Geschichte und Einblicke hinter die Kulissen.',
            heroAlt: 'Resort-Strandweg bei Sonnenuntergang',
            sectionTitle: 'Muthumuni Ayurveda Beach Resort Blogs',
            sectionDescription: 'Anleitungen, Geschichten und Notizen aus unserem Küstenrefugium – von Ayurveda-Ritualen über Edelsteingeschichte bis hin zu Reisetipps rund um Bentota.',
            ayurvedaTitle: 'Das Herz des authentischen Ayurveda',
            ayurvedaExcerpt: 'Erleben Sie ehrwürdige Heiltraditionen, verwurzelt in Sri Lankas alter Weisheit.',
            ayurvedaDescription: 'Im Muthumuni Ayurveda Beach Resort ist Ayurveda mehr als eine Behandlung – es ist eine Lebensweise. Unsere Therapien basieren auf jahrhundertealtem Wissen, sind auf Ihren Körpertyp abgestimmt und werden von erfahrenen Ayurveda-Ärzten für tiefes, anhaltendes Gleichgewicht geleitet.',
            ayurvedaAlt: 'Ayurvedische Behandlung mit Kräuterölen und natürlichen Elementen',
            healingTitle: 'Personalisierte Heilreisen',
            healingExcerpt: 'Warum jedes Wellness-Programm einzigartig gestaltet ist.',
            healingDescription: 'Von der ersten Beratung bis zu den täglichen Behandlungen wird Ihre Heilreise sorgfältig auf Sie zugeschnitten. Kräutertherapien, therapeutische Massagen, Yoga und Meditation wirken zusammen, um die Harmonie zwischen Körper, Geist und Seele wiederherzustellen.',
            healingAlt: 'Ayurveda-Arzt berät einen Gast in ruhiger Umgebung',
            natureTitle: 'Heilung am Ozean',
            natureExcerpt: 'Wie Meeresbrise und tropische Umgebung Ihr Wohlbefinden verstärken.',
            natureDescription: 'Eingebettet an Sri Lankas ruhiger Küste bietet Muthumuni eine natürlich heilende Umgebung. Das Rauschen der Wellen, frische Meeresluft und üppiges Grün verstärken die Wirkung von Ayurveda und schaffen tiefe Entspannung und Erneuerung.',
            natureAlt: 'Strandblick auf das Resort mit Palmen und Ozean',
            foodTitle: 'Ayurvedische Küche für inneres Gleichgewicht',
            foodExcerpt: 'Nahrhafte Mahlzeiten zur Unterstützung Ihrer Behandlung.',
            foodDescription: 'Unsere ayurvedische Küche wird frisch mit saisonalen, lokal bezogenen Zutaten zubereitet. Jede Mahlzeit ist auf Ihr Dosha abgestimmt und unterstützt Verdauung, Entgiftung und allgemeine Vitalität, während sie schmackhaft und befriedigend bleibt.',
            foodAlt: 'Traditionelle ayurvedische Mahlzeit in natürlichen Schalen serviert',
            yogaTitle: 'Yoga, Meditation & innere Stille',
            yogaExcerpt: 'Sanfte Praktiken, die den Geist beruhigen und den Körper stärken.',
            yogaDescription: 'Tägliche Yoga- und Meditationssitzungen ergänzen Ihre Behandlungen und verbessern Flexibilität, Atmung und geistige Klarheit. Diese achtsamen Praktiken helfen Ihnen, sich wieder mit sich selbst zu verbinden und ein Gefühl des Friedens über Ihren Aufenthalt hinaus zu bewahren.',
            yogaAlt: 'Gäste praktizieren Yoga mit Blick auf den Ozean bei Sonnenaufgang',
            lifestyleTitle: 'Ayurveda nach Hause bringen',
            lifestyleExcerpt: 'Einfache Lebensstilpraktiken zur Fortsetzung Ihrer Wellness-Reise.',
            lifestyleDescription: 'Vor Ihrer Abreise beraten unsere Experten Sie darüber, wie Sie durch tägliche Routinen, Ernährung und Selbstpflegerituale das Gleichgewicht aufrechterhalten können. Nehmen Sie mehr als Erinnerungen mit nach Hause – nehmen Sie einen nachhaltigen Weg zu gesünderem Leben mit.',
            lifestyleAlt: 'Gast entspannt mit Kräutertee in ruhiger Resort-Umgebung',
            readMore: 'Mehr lesen'
        },
        events: {
            heroEyebrow: 'Erlebnisse & Aktivitäten',
            heroTitle: 'Unsere Veranstaltungen',
            heroSubtitle: 'Kuratiertes Erleben, das sri-lankische Tradition mit Küstenluxus verbindet',
            heroAlt: 'Veranstaltungen bei Muthumuni',
            availableDaily: 'Täglich verfügbar',
            bookNow: 'Jetzt buchen',
            highlightsTitle: 'Highlights',
            detailAlt: '{{title}} im Detail',
            ctaTitle: 'Bereit, Erinnerungen zu schaffen?',
            ctaDescription: 'Kontaktieren Sie unser Team, um Ihr perfektes Veranstaltungserlebnis im Muthumuni Ayurveda Beach Resort zu gestalten',
            ctaContact: 'Kontakt',
            ctaViewRooms: 'Zimmer ansehen',
            cookeryTitle: 'Kochprogramme',
            cookerySubtitle: 'Geschmack Sri Lankas',
            cookeryDescription: 'Tauchen Sie in die lebendigen Aromen der sri-lankischen Küche ein. Unsere Chefköche führen Sie durch praktische Kochsessions und vermitteln traditionelle Rezepte, die über Generationen weitergegeben wurden. Lernen Sie, aromatische Currys, Hoppers, Kokos-Sambol und mehr mit frischen lokalen Zutaten zuzubereiten.',
            cookeryHighlight1: 'Traditionelle sri-lankische Rezepte',
            cookeryHighlight2: 'Praktisches Kocherlebnis',
            cookeryHighlight3: 'Frische lokale Zutaten',
            cookeryHighlight4: 'Rezepte zum Mitnehmen',
            cookeryHighlight5: 'Gewürzgarten-Tour inklusive',
            meditationTitle: 'Meditationsprogramme',
            meditationSubtitle: 'Innere Ruhe & Achtsamkeit',
            meditationDescription: 'Finden Sie Ruhe in unseren geführten Meditationen vor der friedlichen Kulisse des Indischen Ozeans. Unsere erfahrenen Lehrkräfte führen Sie durch alte Achtsamkeitstechniken, Atemübungen und Yoga-Praktiken, die den Geist beruhigen und die Seele erneuern.',
            meditationHighlight1: 'Sonnenaufgangs- & Sonnenuntergangssitzungen',
            meditationHighlight2: 'Meditation am Strand',
            meditationHighlight3: 'Angeleitet von Experten',
            meditationHighlight4: 'Atemtechniken',
            meditationHighlight5: 'Yoga- & Achtsamkeitspraktiken',
            bbqTitle: 'BBQ-Partys',
            bbqSubtitle: 'Feiern am Strand',
            bbqDescription: 'Erleben Sie unvergessliche Abende mit unseren BBQ-Partys am Strand. Genießen Sie frisch gegrillte Meeresfrüchte, Premium-Fleisch und vegetarische Köstlichkeiten, während die Wellen in der Nähe rauschen. Live-Musik, Feuertänzer und der Sternenhimmel schaffen die perfekte Atmosphäre für Feier und Verbindung.',
            bbqHighlight1: 'Frisch gegrillte Meeresfrüchte',
            bbqHighlight2: 'Essen am Ozean',
            bbqHighlight3: 'Live-Unterhaltung',
            bbqHighlight4: 'Lagerfeuer-Erlebnis',
            bbqHighlight5: 'Anpassbare Menüs',
            boatTitle: 'Bootsfahrten',
            boatSubtitle: 'Fluss- & Küstenabenteuer',
            boatDescription: 'Begeben Sie sich auf bezaubernde Bootstouren entlang des Bentota-Flusses und der Küstengewässer. Gleiten Sie durch Mangrovenwälder, beobachten Sie exotische Vögel und Wildtiere oder genießen Sie romantische Sonnenuntergangsfahrten. Unsere Bootsfahrten bieten eine einzigartige Perspektive auf Sri Lankas natürliche Schönheit und vielfältige Ökosysteme.',
            boatHighlight1: 'Bentota-Flussfahrten',
            boatHighlight2: 'Mangroven-Erkundung',
            boatHighlight3: 'Wildtierbeobachtung',
            boatHighlight4: 'Sonnenuntergangs-Bootstouren',
            boatHighlight5: 'Private Charter verfügbar',
            ayurvedaLecturesTitle: 'Vorträge der Ayurveda-Ärzte',
            ayurvedaLecturesSubtitle: 'Alte Weisheit & modernes Wohlbefinden',
            ayurvedaLecturesDescription: 'Entdecken Sie die tiefgreifenden Prinzipien des Ayurveda in fachkundig geleiteten Vorträgen von zertifizierten Ayurveda-Ärzten und Praktikern. Erfahren Sie mehr über Dosha-Balancing, Kräuterheilmittel, ganzheitliche Heilpraktiken und wie alte Weisheit auf modernes Wohlbefinden angewendet wird. Unsere interaktiven Sitzungen entmystifizieren die ayurvedische Philosophie und ihre Anwendung im Alltag.',
            ayurvedaLecturesHighlight1: 'Zertifizierte Ayurveda-Ärzte',
            ayurvedaLecturesHighlight2: 'Personalisierte Dosha-Analyse',
            ayurvedaLecturesHighlight3: 'Wissen zu Kräuterheilmitteln',
            ayurvedaLecturesHighlight4: 'Fragerunden inklusive',
            ayurvedaLecturesHighlight5: 'Wellness-Leitfaden zum Mitnehmen',
            traditionalClothsTitle: 'Events zum Tragen traditioneller Kleidung',
            traditionalClothsSubtitle: 'Erlebnis des kulturellen Erbes',
            traditionalClothsDescription: 'Tauchen Sie in das sri-lankische Kulturerbe ein, indem Sie lernen, traditionelle Kleidung zu tragen und zu schätzen. Unsere Expertinnen und Experten zeigen Ihnen, wie man authentische kandyanische Saris und traditionelle Gewänder trägt, und erklären die kulturelle Bedeutung jedes Stücks. Perfekt für besondere Anlässe, kulturelle Wertschätzung oder unvergessliche Fotos.',
            traditionalClothsHighlight1: 'Styling durch Experten',
            traditionalClothsHighlight2: 'Authentische traditionelle Saris',
            traditionalClothsHighlight3: 'Kulturelle Bedeutung erklärt',
            traditionalClothsHighlight4: 'Professionelle Fotografie inklusive',
            traditionalClothsHighlight5: 'Fashion-Fusion-Workshops'
        },
        food: {
            heroTitle: 'Ayurvedisches Essen & Küstenküche',
            heroSubtitle: 'Authentische sri-lankische Aromen & frische Küstenküche',
            heroAlt: 'Kulinarisches Erlebnis bei Muthumuni Beach Resort',
            wellnessEyebrow: 'durch Essen',
            wellnessTitle: 'Die Bedeutung von',
            ayurvedicFood: 'Ayurvedischem Essen',
            wellnessIntro1: 'In der Ayurveda wird Essen als die größte Medizin betrachtet. Was man isst, beeinflusst direkt deine Doshas (Vata, Pitta, Kapha), Verdauung (agni) und das Gesamtgleichgewicht von Körper, Geist und Seele.',
            wellnessIntro2: 'Ayurvedische Ernährung betont frische, saisonale, ganze Lebensmittel, die mit Sorgfalt zubereitet und achtsam gegessen werden. Sie fördert sechs Geschmacksrichtungen (süß, sauer, salzig, pikant, bitter, adstringierend) in jeder Mahlzeit, um alle Sinne zu nähren und Harmonie zu bewahren.',
            wellnessIntro3: 'Richtige ayurvedische Ernährung unterstützt starke Verdauung, hilft beim Entfernen von Giftstoffen (ama), stärkt die Immunität, verbessert die Energie, reduziert Stress und verhindert viele chronische Erkrankungen. Bei Muthumuni wird jedes Gericht sorgfältig zubereitet, um Ihrer einzigartigen Konstitution für tiefe Heilung und Vitalität zu entsprechen.',
            foodImage1Alt: 'Traditionelle ayurvedische Mahlzeit mit sechs Geschmacksrichtungen',
            foodImage2Alt: 'Ayurvedische Kräuter und Gewürze für ausgewogene Ernährung',
            culinaryPhilosophyEyebrow: 'Unsere kulinarische Philosophie',
            culinaryPhilosophyTitle: 'Ayurvedische',
            nutritionHighlight: 'Ernährung',
            culinaryPhilosophyResort: 'bei Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ayurvedische Küche bei Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Frisch & Nahrhaft',
            healingIngredientsAlt: 'Gesunde ayurvedische Zutaten und Gewürze',
            healingIngredientsLabel: 'Heilende Zutaten',
            philosophyText1: 'Das Essen umfasst die sechs Hauptgeschmacksrichtungen (süß, sauer, salzig, bitter, pikant und adstringierend) mit vielen subtilen Variationen und wurde in klassischen ayurvedischen Texten beschrieben – einige stammen aus Zeiten vor über 5.000 Jahren – zusammen mit den wesentlichen Eigenschaften jedes Lebensmittels: Guna (inhärente Qualität), Virya (Potenz/wärmend oder kühlend), Vipaka (post-verdauungsauswirkung) und Prabhava (einzigartige besondere Wirkung).',
            philosophyText2: 'Infolgedessen spielt ayurvedische Ernährung eine zentrale Rolle bei Muthumuni Ayurveda Beach Resort. Dies bedeutet nicht ein starres, eintöniges Regime von geschmacklosen, geschmacklosen oder übermäßig bitteren vegetarischen Mahlzeiten, die ausschließlich von Ärzten vorgeschrieben werden. Im Gegenteil ist unsere Ayurveda-Küche eine unserer größten Stärken: Die Gerichte, die von unseren geschickten Köchen zubereitet werden, werden Sie jeden einzelnen Tag Ihres Aufenthalts überraschen und erfreuen!',
            philosophyText3: 'Zum Frühstück genießen Sie ein reichhaltiges Buffet mit frischen tropischen Früchten, frisch gepressten Säften, nährenden Kräutersuppen, selbstgebackenem Brot und leichten Keksen sowie einer Vielzahl authentischer sri-lankischer Frühstücksoptionen. Zum Mittagessen können Sie ein buntes und geschmackvolles Buffet mit milden Fischcurrys, Gemüsezubereitungen und kräuterinfundierten Gerichten genießen. Am Abend servieren wir ein festes vegetarisches Menü mit frischer Fischoption. Samstags feiern wir die „Sri-Lanka-Nacht" mit einem erweiterten Buffet – unsere Köche bereiten traditionelle lokale Spezialitäten direkt vor Ihnen zu und schaffen so ein lebhaftes und authentisches Erlebnis.',
            philosophyText4: 'In der Ayurveda werden Lebensmittel und Getränke auf vielfältige Weise klassifiziert – nach Geschmack und Eigenschaften, der Verdauungskapazität des Körpers (agni), Eignung für spezifische Gesundheitszustände, saisonale Angemessenheit und mehr. Bei Muthumuni berücksichtigen wir sorgfältig alle diese Faktoren gleichzeitig und bemühen uns bewusst, alle sechs Geschmacksrichtungen in ausgewogenen Kombinationen einzubeziehen, die der individuellen Konstitution jedes Gastes entsprechen.',
            philosophyText5: 'Unsere Mahlzeiten bestehen aus frischem Gemüse, tropischen Früchten und verantwortungsvoll beschafftem Fisch. Wir servieren kein rotes Fleisch oder Alkohol.',
            philosophyText6: 'Während der Mahlzeiten steht Ihnen immer ein ayurvedischer Arzt oder qualifizierter Ernährungsberater zur Verfügung. Sie beraten Sie zu den am besten geeigneten Gemüsesorten, Kräutern und Gewürzen für Ihre aktuelle Behandlungsphase und helfen Ihnen, Gerichte entsprechend auszuwählen oder zu vermeiden. Ihr personalisiertes Kräuterelixier und alle spezifischen Anweisungen des Gesundheitszentrums werden auf Ihrem persönlichen Tisch platziert.',
            philosophyText7: 'Dieses Maß an persönlicher Aufmerksamkeit und Aufmerksamkeit für die Ernährung ist ein Markenzeichen der Muthumuni Ayurveda Beach Resort-Erfahrung.',
            philosophyText8: 'Essen wird als Prana – die lebenserhaltende Energie – für jeden Menschen betrachtet. Daher empfehlen wir Ihnen, jede Mahlzeit mit vollem Bewusstsein zu genießen: Genießen Sie die Aromen, erleben Sie die Geschmacksrichtungen, fühlen Sie die sanfte Wärme und genießen Sie die verlockenden Sensationen achtsam.',
            diningExperienceEyebrow: 'Speiseerlebnis',
            restaurantTitlePrefix: 'Unser',
            ayurvedicHighlight: 'Ayurvedisches',
            restaurantTitleSuffix: 'Restaurant',
            restaurantDetail1: 'Unser ayurvedisches Restaurant im Muthumuni Beach Resort bietet ein einzigartiges Speiseerlebnis, das traditionelle ayurvedische Prinzipien mit authentischer sri-lankischer Küstenküche verbindet. Wir legen Wert auf frische, lokal beschaffte Zutaten, um Mahlzeiten zu schaffen, die nicht nur den Gaumen erfreuen, sondern auch das allgemeine Wohlbefinden fördern.',
            restaurantDetail2: 'Die Speisekarte ist sorgfältig gestaltet, um die sechs Geschmacksrichtungen (süß, sauer, salzig, bitter, pikant und adstringierend) in jedem Gericht auszugleichen und ein nährendes und befriedigendes Erlebnis zu gewährleisten. Jede Mahlzeit wird mit Sorgfalt zubereitet und enthält ayurvedische Kräuter und Gewürze, die für ihre heilenden Eigenschaften bekannt sind.',
            restaurantDetail3: 'Gäste können eine Vielzahl von Gerichten genießen, die auf ihre individuelle Doshas (Körperkonstitutionen) zugeschnitten sind, mit Optionen für vegetarische, vegane und pescetarische Ernährung. Unsere Köche arbeiten eng mit ayurvedischen Praktizierenden zusammen, um sicherzustellen, dass jede Mahlzeit die Gesundheits- und Wellnessziele der Gäste unterstützt.',
            restaurantDetail4: 'Die Atmosphäre des Restaurants spiegelt die ruhige Küstenumgebung wider und bietet eine ruhige Umgebung zum achtsamen Essen. Egal ob Sie ein herzhaftes Frühstücksbuffet oder ein Gourmet-Abendessen genießen, jede Mahlzeit in unserem ayurvedischen Restaurant ist eine Gelegenheit, Körper und Seele zu nähren.',
            restaurantDetail5: 'Besuchen Sie uns im ayurvedischen Restaurant des Muthumuni Beach Resorts für eine kulinarische Reise, die die reichen Aromen Sri Lankas feiert und gleichzeitig die zeitlose Weisheit der Ayurveda umarmt.',
            restaurantImageAlt: 'Essen bei Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Premium-Gastronomie',
            premiumDiningDescription: 'Genießen Sie authentische ayurvedische Küche in einer ruhigen Flussumgebung'
        },
        yoga: {
            heroTitle: 'Yoga im Resort',
            heroSubtitle: 'Finde Balance, Stärke & innere Ruhe in Beruwala',
            heroAlt: 'Yoga im Muthumuni Beach Resort',
            importanceEyebrow: '& Balance',
            importanceTitle: 'Bedeutung von Yoga & Meditation',
            importanceImageAlt: 'Bedeutung von Yoga und Meditation',
            importanceText1: 'Yoga und Meditation sind uralte Praktiken, die zahlreiche körperliche, mentale und emotionale Vorteile bieten. Sie fördern Flexibilität, Stärke und Balance und reduzieren Stress und Angst.',
            importanceText2: 'Regelmäßige Praxis kann die Konzentration verbessern, die Schlafqualität steigern und das allgemeine Wohlbefinden fördern. Yoga ermutigt zudem zur Achtsamkeit, hilft die eigene innere Mitte zu finden und Ruhe im Alltag zu erleben.',
            importanceText3: 'Im Muthumuni Beach Resort bieten wir ruhige Umgebungen, die ideal für Yoga und Meditation sind, damit Gäste Körper, Geist und Seele regenerieren.',
            practiceEyebrow: 'Unsere Praxis',
            practiceTitle: 'Yoga-Praxis & Erfahrung',
            practiceImageAlt: 'Yoga-Praxis im Resort',
            practiceText1: 'Im Muthumuni Ayurveda Beach Resort wird Yoga hauptsächlich als traditionelles Hatha Yoga praktiziert, kombiniert mit Pranayama (Atemtechniken). Dieser ganzheitliche Ansatz soll das innere Bewusstsein wecken und die Kundalini (oft als drittes Auge bezeichnet) sanft stimulieren. Besonderer Wert wird auf Wirbelsäulen-Ausrichtung und Flexibilität gelegt, da eine geschmeidige Wirbelsäule als Schlüssel für langsameres Altern gilt — „Du bist nur so alt wie deine Wirbelsäule.“',
            practiceText2: 'Yoga-Sitzungen finden viermal pro Woche statt und sind sowohl für Anfänger als auch für Fortgeschrittene geeignet. Von Zeit zu Zeit werden spezielle Einheiten wie Ashtanga Yoga angeboten, sodass Gäste eine Vielfalt an Haltungen und Routinen erleben können. Unsere ayurvedischen Ärzte empfehlen regelmäßige Teilnahme, um das gesamte Behandlungsprogramm zu unterstützen und zu vertiefen.',
            practiceText3: 'Alle Yoga-Sitzungen finden in unserer dedizierten Yoga Shala statt, einem ruhigen Raum für Fokus, Balance und achtsame Bewegung. Jede Einheit beginnt typischerweise mit Sonnengrüßen, gefolgt von Pranayama und einer Sequenz sorgfältig ausgewählter Asanas zur Verbesserung von Flexibilität, Durchblutung und Wohlbefinden.',
            practiceText4: 'Unsere erfahrenen Yogalehrer passen jede Sitzung an die individuellen Bedürfnisse, Fähigkeiten und Gesundheitsbedingungen der Gäste an und sorgen so für ein sicheres, unterstützendes und tief wohltuendes Yoga-Erlebnis.',
            spiritualEyebrow: 'Spirituelle Reise',
            spiritualTitle: 'Meditation & spirituelle Aktivitäten',
            spiritualSubtitle: 'Vertiefe deine spirituelle Praxis mit unseren heiligen Zeremonien und geführten Meditationen',
            meditationImageAlt: 'Meditation und spirituelle Praxis im Resort',
            meditationTitle: 'Meditationssitzungen',
            meditationDesc: 'Gäste sind eingeladen, an geführten Meditationen teilzunehmen, die dreimal pro Woche stattfinden und von buddhistischen Traditionen inspiriert sind. Diese Sitzungen beruhigen den Geist, vertiefen das Bewusstsein und unterstützen emotionale sowie spirituelle Heilung. Die Meditation findet in einem friedlichen Inseltempel statt, den die Gäste per Boot erreichen — eine ruhige und bedeutungsvolle Reise, die das gesamte meditative Erlebnis bereichert.'
        },
        contact: {
            heroTitle: 'Kontakt',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Kontakt',
            sectionTitle: 'Kontaktieren Sie uns gerne',
            sectionSubtitle: 'Wir helfen Ihnen beim Entspannen & Regenerieren',
            sectionDescription: 'Kontaktieren Sie das Muthumuni Ayurveda Beach Resort bei Fragen zu Ihrem Ayurveda-Aufenthalt, Wellness-Paketen, Buchungen oder während Ihres Aufenthalts in Beruwala, Moragalla.',
            callUs: 'Rufen Sie uns an',
            emailTitle: 'E-Mail',
            ourLocation: 'Unser Standort',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Soziale Netzwerke',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Kontakt aufnehmen',
            getInTouchDescription: 'Wir freuen uns auf Ihre Nachricht — unser Team unterstützt Sie gern bei Ihrer Wellness-Reise, beantwortet Fragen und hilft bei der Planung Ihres Aufenthalts.',
            nameLabel: 'Name',
            emailLabel: 'E-Mail',
            contactNumberLabel: 'Telefonnummer',
            messageLabel: 'Nachricht',
            sending: 'Wird gesendet...',
            sendMessage: 'Nachricht senden',
            successMessage: 'Ihre Nachricht wurde erfolgreich gesendet! Wir melden uns bald.',
            errorMessage: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            findUsOnMap: 'Finden Sie uns auf der Karte',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Name',
            whatsappEmail: 'E-Mail',
            whatsappContactNumber: 'Telefonnummer',
            whatsappMessage: 'Nachricht'
        },
        contact2: {
            heroTitle: 'Kontakt',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Kontakt',
            sectionTitle: 'Kontaktieren Sie uns gerne',
            sectionSubtitle: 'Wir helfen Ihnen beim Entspannen & Regenerieren',
            sectionDescription: 'Kontaktieren Sie das Muthumuni Ayurveda Beach Resort bei Fragen zu Ihrem Ayurveda-Aufenthalt, Wellness-Paketen, Buchungen oder während Ihres Aufenthalts in Beruwala, Moragalla.',
            callUs: 'Rufen Sie uns an',
            emailTitle: 'E-Mail',
            ourLocation: 'Unser Standort',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Soziale Netzwerke',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Kontakt aufnehmen',
            getInTouchDescription: 'Wir freuen uns auf Ihre Nachricht — unser Team unterstützt Sie gern bei Ihrer Wellness-Reise, beantwortet Fragen und hilft bei der Planung Ihres Aufenthalts.',
            nameLabel: 'Name',
            emailLabel: 'E-Mail',
            contactNumberLabel: 'Telefonnummer',
            messageLabel: 'Nachricht',
            sending: 'Wird gesendet...',
            sendMessage: 'Nachricht senden',
            successMessage: 'Ihre Nachricht wurde erfolgreich gesendet! Wir melden uns bald.',
            errorMessage: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            findUsOnMap: 'Finden Sie uns auf der Karte',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Name',
            whatsappEmail: 'E-Mail',
            whatsappContactNumber: 'Telefonnummer',
            whatsappMessage: 'Nachricht'
        },

        about: {
            heroTitle: 'Über Uns',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Die alte Weisheit trifft auf modernes Wohlbefinden im Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Personalisierte Ayurveda-Behandlungen, Meerblick und echte sri-lankische Gastfreundschaft',
            slide1: 'Ayurvedische Heilung',
            slide2: 'Strandserenität',
            slide3: 'Gartentranquillität',
            slide4: 'Kräutertherapien',
            slide5: 'Ozean-Wellness',
            historyLabel: 'Unsere Geschichte',
            historyTitle: 'Geschichte des Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Das Muthumuni Ayurveda Beach Resort wurde vor mehr als zwei Jahrzehnten gegründet und entstand aus der Vision, ein Heiligtum zu schaffen, in dem die alten Ayurveda-Weisheit auf die ruhige Schönheit der Südküste Sri Lankas trifft. Was als bescheidener Wellnessrückzugsort begann, hat sich zu einem der beliebtesten Ziele Beruwalas für ganzheitliche Heilung und Verjüngung entwickelt.',
            historyDesc2: 'Unsere Gründer, inspiriert von Generationen traditioneller Ayurveda-Praktizierender, wollten diese bewährten Heilkünste bewahren und gleichzeitig modernen Komfort und echte Sri-Lanka-Gastfreundschaft bieten. Im Laufe der Jahre haben wir uns weiterhin zum Engagement für authentische Wellness-Erfahrungen verpflichtet, haben unsere Einrichtungen erweitert, ohne die personalisierte Pflege aus den Augen zu verlieren, die unser Vermächtnis definiert.',
            historyDesc3: 'Heute ist Muthumuni ein Beweis für die anhaltende Kraft des Ayurveda, nachdem es Tausende von Gästen aus aller Welt begrüßt hat. Jeder Besucher wird Teil unserer Geschichte und findet Balance, Heilung und Transformation in unserem Strandrefugium.',
            statYear: '15+',
            statYearLabel: 'Jahre Wellness-Exzellenz',
            statGuest: '1.000+',
            statGuestLabel: 'Zufriedene Gäste Bedient',
            experienceLegacy: 'Erleben Sie unser Vermächtnis',
            established: 'Etabliert',
            since2010: 'Seit 2008',
            chairmanLabel: 'Botschaft des Vorsitzenden',
            chairmanTitle: 'Von Sorgfalt geleitet, in Ayurveda verwurzelt',
            chairmanDesc1: 'Willkommen im Muthumuni Ayurveda Beach Resort. Seit mehr als zwei Jahrzehnten ist unser Zweck einfach: echte Heilung angeboten, die in der zeitlosen Weisheit des Ayurveda verankert ist und mit der Wärme der Sri-Lanka-Gastfreundschaft vermittelt wird.',
            chairmanDesc2: 'Hier ist jedes Detail – von unseren Therapien und Küche bis zur Ruhe unserer Räume – dazu bestimmt, Ihnen zu helfen, langsamer zu werden, das Gleichgewicht wiederherzustellen und sich selbst wiederzuverbinden. Wir sind geehrt, Teil Ihrer Wellness-Reise zu sein.',
            chairmanDesc3: 'Im Namen unseres engagierten Teams lade ich Sie ein, die Sorgfalt, Authentizität und Gelassenheit zu erleben, die Muthumuni definieren.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Vorsitzender',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Vorsitzender Mr. Nihal Muthumuni',
            staffLabel: 'Unser Team',
            staffTitle: 'Treffen Sie unser engagiertes Personal',
            staffDesc1: 'Im Muthumuni Ayurveda Beach Resort ist unser Team das Herz von allem, was wir tun. Unsere Mitarbeiter sind sorgfältig ausgewählte und ausgebildete Fachleute, die eine tiefe Leidenschaft für Ayurveda-Wellness und echte Gastfreundschaft teilen.',
            staffDesc2: 'Von unseren erfahrenen Ayurveda-Praktizierenden und erfahrenen Massagetherapeuten bis zu unserem engagierten Gastfreundschaftsteam bringt jedes Mitglied jahrelange Expertise und echte Sorgfalt zu jeder Gastinteraktion. Wir glauben, dass echtes Wohlbefinden nicht nur aus Behandlungen kommt, sondern aus der Wärme und Aufmerksamkeit von Menschen, die sich wirklich um Ihre Reise kümmern.',
            staffDesc3: 'Unser Personal durchläuft kontinuierliche Schulungen in den neuesten Ayurveda-Praktiken und wahrt gleichzeitig die höchsten Standards für Professionalität und kulturelle Sensibilität. Wir sind stolz darauf, aussagekräftige Verbindungen mit unseren Gästen zu schaffen und sicherzustellen, dass jeder Besuch zu einer unvergesslichen und transformativen Erfahrung wird.',
            statStaff: '15+',
            statStaffLabel: 'Qualifizierte Fachleute',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Gästezufriedenheit',
            staffImageAlt: 'Unser engagiertes Personal-Team im Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Unser Engagement',
            excellenceCare: 'Exzellenz & Sorgfalt',
            ctaLabel: 'Kontakt aufnehmen',
            ctaHeading: 'Bereit, Ihre Wellness-Reise zu beginnen?',
            ctaDesc: 'Wenden Sie sich an unser Team, um Ihren personalisierten Ayurveda-Rückzug zu buchen. Unabhängig davon, ob Sie Fragen zu unseren Therapien, Unterkünften oder speziellen Wellness-Paketen haben, können wir Ihnen helfen, Ihren perfekten Umgang zu schaffen.',
            ctaButtonContact: 'Kontaktieren Sie uns jetzt',
            ctaButtonRooms: 'Zimmer erkunden',
            contactUs: 'Kontakt',
            quickInfoCall: 'Rufen Sie uns an',
            quickInfoEmail: 'Schreiben Sie uns eine E-Mail',
            quickInfoLocation: 'Ort',
            locationCity: 'Beruwala, Sri Lanka'
        },

        ayurveda: {
            accordionTitle1: 'Was ist Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (ein Sanskrit-Wort, das „Wissenschaft des Lebens" oder „Wissen vom Leben" bedeutet) ist eines der ältesten ganzheitlichen Heilsysteme der Welt. Es wurde vor mehr als 5.000 Jahren entwickelt. Panchakarma Ayurveda basiert auf dem Glauben, dass Gesundheit und Wohlbefinden von einem empfindlichen Gleichgewicht zwischen Verstand, Körper, Geist und Umwelt abhängen.',
            accordionTitle2: 'Panchakarma Ayurveda und deine Lebensenergie',
            accordionDesc2: 'Ayurveda basiert auf der Theorie, dass alles im Universum – lebend oder tot – miteinander verbunden ist. Wenn dein Verstand, Körper und Geist in Harmonie mit dem Universum sind, hast du gute Gesundheit. Diejenigen, die Ayurveda praktizieren, glauben, dass jeder Mensch aus fünf grundlegenden Elementen besteht: Raum, Luft, Feuer, Wasser und Erde. Diese verbinden sich zu drei Doshas: VATA, PITTA und KAPHA.',
            accordionTitle3: 'Vata Dosha',
            accordionDesc3: 'Dies ist das mächtigste aller drei Doshas. Es kontrolliert grundlegende Körperfunktionen wie Zellteilung, Atmung, Blutfluss und Herzfunktion. Wenn Vata dein dominantes Dosha ist, kannst du intelligent, kreativ und lebhaft sein. Bei Ungleichgewicht können Angststörungen auftreten. Balance durch Meditation, Massage und warme Lebensmittel.',
            accordionTitle4: 'Pitta Dosha',
            accordionDesc4: 'Diese Energie kontrolliert Verdauung, Stoffwechsel und Hormone. Bei Pitta-Dominanz bist du zielorientiert, wettbewerbsfähig und selbstbewusst. Bei Ungleichgewicht kannst du mürrisch und impulsiv werden. Balance durch kühlende Lebensmittel wie Salate und langsames Yoga.',
            accordionTitle5: 'Kapha Dosha',
            accordionDesc5: 'Kapha kontrolliert Muskelwachstum, Körperstärke und Immunsystem. Bei Kapha-Dominanz liebst du Routine, bist ruhig und geduldig. Bei Ungleichgewicht Müdigkeit und Gewichtszunahme. Balance durch mehr Obst, Gemüse und Bewegung.',
            close: 'Schließen',
            next: 'Weiter',
            previous: 'Zurück',
            treatmentsTitle: 'Unsere charakteristischen Panchakarma-Ayurveda-Behandlungen',
            treatmentsSubtitle: 'Erleben Sie altehrwürdige Therapien zur Wiederherstellung des Gleichgewichts, Spannungsabbau und Verjüngung Ihres gesamten Wesens.',
            bookTreatment: 'Diese Behandlung buchen',
            benefitsTitle: 'Vorteile der Panchakarma-Behandlungen',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Sanftes Gießen warmen Kräuteröls über die Stirn zur Beruhigung des Geistes.',
            shirodhara1: 'Reduziert Stress und Angst',
            shirodhara2: 'Fördert besseren Schlaf',
            shirodhara3: 'Verbessert geistige Klarheit',
            steamBath: 'Dampfbad',
            steamBathDesc: 'Eine entgiftende Dampfbehandlung zum Öffnen der Poren und Entspannen der Muskeln.',
            steamBath1: 'Entgiftet den Körper',
            steamBath2: 'Verbessert die Durchblutung',
            steamBath3: 'Lindert Muskelverspannungen',
            flowerBath: 'Blumenbad',
            flowerBathDesc: 'Ein beruhigendes Bad mit aromatischen Blüten zur Entspannung.',
            flowerBath1: 'Beruhigt das Nervensystem',
            flowerBath2: 'Spendet der Haut Feuchtigkeit',
            flowerBath3: 'Hebt die Stimmung',
            headMassage: 'Kopfmassage',
            headMassageDesc: 'Eine entspannende Massage der Kopfhaut zur Spannungslösung.',
            headMassage1: 'Reduziert Kopfschmerzen',
            headMassage2: 'Verbessert die Kopfhautgesundheit',
            headMassage3: 'Fördert Entspannung',
            faceMassage: 'Gesichtsmassage',
            faceMassageDesc: 'Eine verjüngende Massage zur Verbesserung des Gesichtsglanzes und Stressabbau.',
            faceMassage1: 'Verbessert den Hautton',
            faceMassage2: 'Reduziert Gesichtsspannungen',
            faceMassage3: 'Fördert Lymphdrainage',
            neckMassage: 'Nackenmassage',
            neckMassageDesc: 'Gezielte Massage zur Linderung von Nackensteifheit und Verspannungen.',
            neckMassage1: 'Lindert Nackenschmerzen',
            neckMassage2: 'Verbessert Flexibilität',
            neckMassage3: 'Reduziert Stress',
            shoulderMassage: 'Schultermassage',
            shoulderMassageDesc: 'Gezielte Massage zur Linderung von Schultersteifheit und Unbehagen.',
            shoulderMassage1: 'Reduziert Schulterschmerzen',
            shoulderMassage2: 'Verbessert die Haltung',
            shoulderMassage3: 'Entspannt Muskeln',
            bodyMassage: 'Ganzkörpermassage',
            bodyMassageDesc: 'Eine Ganzkörpermassage zur Förderung von Entspannung und Wohlbefinden.',
            bodyMassage1: 'Verbessert die Durchblutung',
            bodyMassage2: 'Lindert Muskelschmerzen',
            bodyMassage3: 'Fördert Entspannung',
            backMassage: 'Rückenmassage',
            backMassageDesc: 'Eine therapeutische Massage zur Behandlung von Rückenschmerzen und Verspannungen.',
            backMassage1: 'Lindert Rückenschmerzen',
            backMassage2: 'Verbessert Wirbelsäulengesundheit',
            backMassage3: 'Reduziert Stress',
            footMassage: 'Fußmassage',
            footMassageDesc: 'Eine beruhigende Massage zur Linderung von Fußschmerzen und Entspannung.',
            footMassage1: 'Verbessert die Durchblutung',
            footMassage2: 'Reduziert Fußermüdung',
            footMassage3: 'Fördert Entspannung',
            purgative: 'Abführmittel',
            purgativeDesc: 'Eine Reinigungstherapie zur Beseitigung von überschüssigem Pitta und Toxinen aus dem Verdauungssystem.',
            purgative1: 'Reinigt den Darm',
            purgative2: 'Gleicht Pitta-Dosha aus',
            purgative3: 'Verbessert Verdauungsgesundheit',
            nasalClearing: 'Nasenreinigung',
            nasalClearingDesc: 'Eine therapeutische Nasenbehandlung zur Reinigung der Nebenhöhlen und Verbesserung der Atemfunktion.',
            nasalClearing1: 'Beseitigt Nasenverstopfung',
            nasalClearing2: 'Verbessert die Atmung',
            nasalClearing3: 'Lindert Nebenhöhlenprobleme',
            powderMassage: 'Pulvermassage',
            powderMassageDesc: 'Eine exfolierende Massage mit Kräuterpulvern zur Verjüngung und Erfrischung der Haut.',
            powderMassage1: 'Entfernt abgestorbene Haut',
            powderMassage2: 'Verbessert Hautstruktur',
            powderMassage3: 'Fördert die Durchblutung',
            intensiveMassageDesc: 'Eine tiefe therapeutische Massage, die chronische Verspannungen und Muskelverhärtungen mit festem Druck und speziellen Techniken gezielt behandelt.',
            intensiveMassage1: 'Löst tiefe Muskelverspannungen',
            intensiveMassage2: 'Verbessert die Durchblutung',
            intensiveMassage3: 'Reduziert Muskelkater',
            thermoMassage: 'Thermo-Massage',
            thermoMassageDesc: 'Eine warme Kräuteröl-Massage mit erhitzten therapeutischen Ölen zur Verstärkung von Entspannung und Heilwirkung.',
            thermoMassage1: 'Lindert Muskelkater',
            thermoMassage2: 'Fördert tiefe Entspannung',
            thermoMassage3: 'Verbessert den Energiefluss',
            synchronMassage: 'Synchron-Massage',
            synchronMassageDesc: 'Eine synchronisierte Zwei-Therapeuten-Massage für vollständige Körperharmonie und ausgewogene Energieverteilung.',
            synchronMassage1: 'Volle Körperharmonie',
            synchronMassage2: 'Ausgeglichener Energiefluss',
            synchronMassage3: 'Tiefe Entspannungserfahrung',
            specialMassage: 'Spezial-Massage',
            specialMassageDesc: 'Individuelle Massagetherapie, maßgeschneidert auf Ihre spezifischen gesundheitlichen Bedürfnisse und persönlichen Wellness-Ziele.',
            specialMassage1: 'Personalisierte Behandlung',
            specialMassage2: 'Zielt auf spezifische Beschwerden ab',
            specialMassage3: 'Individueller Heilansatz',
            benefit1Title: 'Entgiftung:',
            benefit1Desc: 'Panchakarma-Behandlungen helfen, Giftstoffe aus dem Körper zu entfernen und fördern Gesundheit und Vitalität.',
            benefit2Title: 'Verbesserte Verdauung:',
            benefit2Desc: 'Diese Therapien verbessern die Verdauungsfunktion für bessere Nährstoffaufnahme und Stoffwechsel.',
            benefit3Title: 'Stressabbau:',
            benefit3Desc: 'Panchakarma ist bekannt für seine beruhigende Wirkung auf Körper und Geist und reduziert Stress- und Angstniveaus.',
            benefit4Title: 'Stärkung der Immunität:',
            benefit4Desc: 'Regelmäßige Panchakarma-Behandlungen stärken das Immunsystem und machen den Körper widerstandsfähiger.',
            benefit5Title: 'Verjüngung:',
            benefit5Desc: 'Die Therapien fördern die Zellregeneration für verbesserte Hautgesundheit und jugendliches Aussehen.',
            benefit6Title: 'Gleichgewicht der Doshas:',
            benefit6Desc: 'Panchakarma hilft, das Gleichgewicht der Doshas (Vata, Pitta, Kapha) wiederherzustellen, was gemäß ayurvedischen Prinzipien für die Gesundheit essentiell ist.',
            akkupancharTitle: 'Acupuncture-Therapie',
            akkupancharDesc1: 'ist eine alte ayurvedische Therapie mit Kräuterpasten und Ölen auf spezifischen Körperpunkten. Diese Behandlung stimuliert Energiekanäle und fördert Heilung.',
            akkupancharBenefit: 'Hauptvorteile:',
            akkupancharDesc2: 'Diese spezialisierte Therapie hilft bei chronischen Schmerzen, verbessert Gelenkflexibilität, fördert Durchblutung und stellt natürlichen Energiefluss wieder her.',
            akkupancharApplication: 'Therapeutische Anwendung:',
            akkupancharDesc3: 'Acupuncture wirkt auf spezifische Marma-Punkte mit sorgfältig ausgewählten Kräuterzubereitungen zur Ausbalancierung der Doshas.',
            akkupancharTransform: 'Transformation erleben:',
            akkupancharDesc4: 'Im Muthumuni Ayurveda Beach Resort passen unsere erfahrenen Therapeuten jede Sitzung an Ihre Gesundheitsbedürfnisse an.',
            gallery1: 'Shirodhara-Therapie',
            gallery2: 'Dampfbad',
            gallery3: 'Blumenbad',
            gallery4: 'Kopfmassage',
            gallery5: 'Ganzkörpermassage',
            gallery6: 'Nackenmassage',
            gallery7: 'Gesichtsmassage',
            gallery8: 'Schultermassage',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Verjüngen Sie Körper, Geist und Seele in Beruwala',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA IM MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Entdecken Sie die alte Heilkunst der Panchakarma Ayurveda im Muthumuni Ayurveda Beach Resort in Beruwala, Sri Lanka. Unsere erfahrenen Ayurveda-Praktizierenden bieten personalisierte Behandlungen an, die Entgiftung, Verjüngung und Gleichgewicht fördern.',
            treatmentProgramme: {
                title: 'Ayurveda-Behandlungsprogramm',
                subtitle: 'Ihre Reise zu Balance, Entgiftung und tieferer Erneuerung',
                intro: 'Erleben Sie authentische ayurvedische Heilung in einem ruhigen Retreat, das Ihren Körper wiederherstellt, Ihren Geist beruhigt und Ihre Energie erneuert. Von dem Moment an, in dem Sie ankommen, kümmert sich unser Team um jedes Detail – damit Sie sich vollständig auf Ihr Wohlbefinden konzentrieren können.',
                welcomeTitle: 'Willkommen & sanfter Start',
                doctorTitle: 'Ärztliche Beratung & persönlicher Plan',
                dailyTherapiesTitle: 'Tägliche Ayurveda-Therapien',
                herbalMedicineTitle: 'Unterstützung durch Kräutermedizin',
                yogaMeditationTitle: 'Yoga & Meditation für Körper-Geist-Harmonie',
                wellnessTitle: 'Integrierte Wellness-Erlebnisse',
                closingTitle: 'Abschlussritual & Abreise',
                welcomePoints: [
                    'Flughafenabholung und Transfer zum Hotel',
                    'Herzlicher Empfang und Hotelführung',
                    'Einführung in Ihren wöchentlichen Wellness-Plan',
                    'Entspannungsmassage (Tag 1) im Ayurveda-Zentrum, um Reisemüdigkeit zu lindern und Ihren Körper auf Behandlungen vorzubereiten'
                ],
                doctorPoints: [
                    'Ayurvedische Ärztliche Beratung (Tag 2 – morgens)',
                    'Vollständige Bewertung Ihres Doshas/Körpertyps und Ihrer Gesundheitsbedenken',
                    'Übersetzer auf Anfrage verfügbar',
                    'Ihr Arzt erstellt einen personalisierten Behandlungsplan, der auf Ihre Bedürfnisse und Ziele zugeschnitten ist'
                ],
                dailyTherapiesPoints: [
                    '4–5 Behandlungen täglich (wie vom Arzt empfohlen)',
                    'Therapien basierend auf Ihrer Körperkonstitution und Ihrem Zustand ausgewählt',
                    'Spezielle Massagen können bei Bedarf hinzugefügt werden',
                    'Der Arzt überwacht täglich die Fortschritte und kann Behandlungen und Kräuterunterstützung anpassen, um beste Ergebnisse zu erreichen',
                    'Falls angemessen, kann ein sanfter Reinigungsprozess empfohlen werden'
                ],
                herbalMedicinePoints: [
                    'Vom Arzt verschriebene Kräuterheilmittel zweimal täglich:',
                    'Zum Frühstück',
                    'Zum Abendessen',
                    'Unterstützen innere Heilung, Entgiftung und langfristige Balance'
                ],
                yogaMeditationPoints: [
                    'Yoga-Sitzungen 4x pro Woche (ca. 1 Stunde)',
                    'Meditationssitzungen 2x pro Woche:',
                    'Ein einzigartiges spirituelles Erlebnis in einem Inseltempel, erreichbar mit dem Boot',
                    'Geführte Meditation von Mönchen geleitet (ca. 1 Stunde)'
                ],
                wellnessPoints: [
                    'Wöchentliche gesunde Kochdemonstration',
                    'Kostenlose Exkursion (Kultur-/Naturerlebnis)'
                ],
                closingPoints: [
                    'Ein wunderschönes Blütenbad (letzter Tag) – ein traditionelles Erneuerungsritual',
                    'Abschließende Ärztliche Beratung, um Fortschritte zu überprüfen und bereitszustellen:',
                    'Fortgesetzte Wellness-Anleitung',
                    'Verschreibungen und Empfehlungen für zu Hause',
                    'Transfer zurück zum Flughafen'
                ]
            },
        },
        rooms: {
            heroTitle: 'Ihr Heiligtum erwartet Sie',
            heroSubtitle: 'Handwerklich gefertigte Räume, die zum Heilen, Wiederherstellen und tiefem Frieden entworfen wurden.',
            heroAlt: 'Zimmer des Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Erkunden Sie unsere Zimmer',
            filterAll: 'Alle',
            filterLuxurySuite: 'Luxus-Suite',
            filterDeluxeRooms: 'Deluxe-Zimmer',
            filterDeluxeSeaView: 'Deluxe-Zimmer mit Meerblick',
            noRoomsFound: 'Keine Zimmer in dieser Kategorie gefunden.',
            allRoomsInclude: 'Alle Zimmer beinhalten',
            essentialComforts: 'Essentielle Annehmlichkeiten für Ihre Wellness-Reise',
            roomSize: 'Zimmergröße',
            guests: 'Gäste',
            amenities: 'Annehmlichkeiten',
            roomAmenities: 'Zimmerausstattung',
            specialFeatures: 'Besondere Merkmale',
            bookNow: 'Jetzt buchen',
            viewDetails: 'Details anzeigen',
            highSpeedWifi: 'Hochgeschwindigkeits-WiFi',
            herbalTea: 'Auswahl an Kräutertees',
            climateControl: 'Klimakontrolle',
            rainShower: 'Regendusche',
            organicToiletries: 'Bio-Toilettenmittel',
            dailyHousekeeping: 'Tägliche Zimmerreinigung',
            concierge: '24/7 Concierge',
            yogaMat: 'Yogamatte & Requisiten',
            beginHealing: 'Beginnen Sie Ihre Heilungsreise',
            beginHealingDesc: 'Erleben Sie authentisches ayurvedisches Wohlbefinden in einer Umgebung, die Ihren Körper nähren, Ihren Geist beruhigen und Ihren Geist wiederherstellen soll.',
            reserveRoom: 'Zimmer reservieren',
            speakAdvisor: 'Mit Wellness-Berater sprechen',
            exploreOurRooms: 'Erkunden Sie unsere Zimmer',
            viewRoom: 'Zimmer ansehen',
            luxurySuiteName: 'Luxus-Suite',
            luxurySuiteCategory: 'Luxus-Suite',
            luxurySuiteDesc: 'Erleben Sie ultimative Ruhe in unserer geräumigen Luxus-Suite, entworfen mit traditionellen ayurvedischen Prinzipien und atemberaubendem Meerblick.',
            deluxeRoomName: 'Deluxe-Zimmer',
            deluxeRoomCategory: 'Deluxe-Zimmer',
            deluxeRoomDesc: 'Harmonisch gestaltetes Zimmer mit natürlichen Holzelementen und kühlenden Wassermerkmalen für perfekte Ruhe.',
            seaViewDeluxeName: 'Deluxe mit Meerblick',
            seaViewDeluxeCategory: 'Deluxe-Zimmer mit Meerblick',
            seaViewDeluxeDesc: 'Erwachen Sie zu beruhigenden Meeresbriesen und panoramalen Meerblicken in diesem elegant gestalteten Deluxe-Zimmer.',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'Deluxe-Zimmer — Komfort mit Terrasse oder privatem Balkon',
                heroSubtitle: 'Entspannen Sie in einem beruhigenden Küstenrückzugsort inspiriert von den goldenen Stränden von Bentota, der moderne Annehmlichkeiten mit sanften Meeresbrisen verbindet.',
                bookThisRoom: 'Dieses Zimmer buchen',
                callReservations: 'Reservierungen anrufen',
                navAll: 'Alle',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe mit Meerblick',
                navSuite: 'Suite',
                sectionTitle: 'Ein beruhigendes Küstenversteck',
                sectionDesc: 'Das Deluxe-Zimmer ist für langsame Morgen und ungehastete Sonnenuntergänge konzipiert. Weiche neutrale Töne, großzügige Verglasung und durchdachte Beleuchtung laden den Meerblick ein, während der Balkon Ihren eigenen Platz über der Küste bietet.',
                highlight1Title: 'Panoramische Strandaussichten',
                highlight1Desc: 'Wachen Sie mit azurblauen Gewässern und goldenen Sonnenaufgängen von Ihrem privaten Balkon auf.',
                highlight2Title: 'Elegante Küsteninterieure',
                highlight2Desc: 'Weiche neutrale Paletten, warme Holzakzente und großzügiges natürliches Licht.',
                highlight3Title: 'Ruhiges Schlaferlebnis',
                highlight3Desc: 'Plüsch-Kingsize-Bett mit Premium-Bettwäsche für erholsame Ruhe.',
                atAGlance: 'Auf einen Blick',
                statSize: 'Größe',
                statSizeValue: '41 qm',
                statView: 'Aussicht',
                statViewValue: 'Indischer Ozean',
                statGuests: 'Gäste',
                statGuestsValue: '2 Erwachsene',
                statBed: 'Bett',
                statBedValue: 'King oder Twin',
                reserve: 'Reservieren',
                galleryAlt: 'Deluxe-Zimmer-Galerie',
                inclusionsTitle: 'Im Aufenthalt enthalten',
                inclusionsSubtitle: 'Durchdachte Details, ganztägiger Komfort',
                enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',
                inclusion1: 'Kostenloses Frühstück, Mittagessen, Abendessen im Restaurant',
                inclusion2: 'Hochgeschwindigkeits-WLAN und Arbeitsbereich im Zimmer',
                inclusion3: '24-Stunden-Zimmerservice und Concierge',
                inclusion4: 'Tägliche Zimmerreinigung mit Abend-Aufdeckservice',
                inclusion5: 'Zugang zum Pool und Ayurveda-Spa-Einrichtungen',
                inclusion6: 'Kostenlose Parkplätze und Shuttle-Service zu nahegelegenen Sehenswürdigkeiten',
                amenityGroup1Title: 'Zimmerausstattung',
                amenityGroup1Item1: '41 qm Fläche',
                amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
                amenityGroup1Item3: 'Klimaanlage mit Klimakontrolle',
                amenityGroup1Item4: 'Zimmersafe',
                amenityGroup2Title: 'Badeerlebnis',
                amenityGroup2Item1: 'Regendusche mit heißem und kaltem Wasser',
                amenityGroup2Item2: 'Premium-Badeausstattung',
                amenityGroup2Item3: 'Haartrockner',
                amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',
                amenityGroup3Title: 'Zimmerkomfort',
                amenityGroup3Item1: '55" Smart-TV mit Kabel',
                amenityGroup3Item2: 'Kaffee- und Teestation',
                amenityGroup3Item3: 'Direktwahltelefon',
                amenityGroup4Title: 'Konnektivität',
                amenityGroup4Item1: 'Kostenloses WLAN',
                amenityGroup4Item2: 'Schreibtisch',
                amenityGroup4Item3: '24/7 Rezeptionsunterstützung',
                essentialsTitle: 'Zimmer-Essentials',
                essentialsHeading: 'Alles, was Sie brauchen, um sich wie zu Hause zu fühlen',
                essentialsDesc: 'Von nahtloser Konnektivität bis hin zu sorgfältig ausgewählten Erfrischungen verbindet das Deluxe-Zimmer Freizeit und Praktikabilität, damit Sie sich auf die Momente konzentrieren können, die zählen.',
                essential1: 'Kostenloses WLAN',
                essential2: 'Kaffee- und Teestation',
                essential3: '24/7 Zimmerservice',
                essential4: 'Regendusche',
                oceanTitle: 'Am Ozean',
                oceanSubtitle: 'Verlangsamen Sie, atmen Sie die Meeresluft ein',
                oceanAlt: 'Deluxe-Zimmer-Sitzbereich',
                ctaTitle: 'Bereit zu bleiben?',
                ctaHeading: 'Reservieren Sie das Deluxe-Zimmer noch heute',
                ctaDesc: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
                checkAvailability: 'Verfügbarkeit prüfen'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Komfort mit einem charmanten Küstenreiz',
                bookThisRoom: 'Dieses Zimmer buchen',
                callReservations: 'Reservierungen anrufen',
                navAll: 'Alle',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe mit Meerblick',
                navSuite: 'Suite',
                sectionTitle: 'Ein beruhigendes Küstenversteck',
                sectionDesc: 'Die Luxussuite ist für langsame Morgen und ungehastete Sonnenuntergänge konzipiert. Weiche neutrale Töne, großzügige Verglasung und durchdachte Beleuchtung laden den Meerblick ein, während der Balkon Ihren eigenen Platz über der Küste bietet.',
                highlight1Title: 'Panoramische Strandaussichten',
                highlight1Desc: 'Wachen Sie mit azurblauen Gewässern und goldenen Sonnenaufgängen von Ihrem privaten Balkon auf.',
                highlight2Title: 'Elegante Küsteninterieure',
                highlight2Desc: 'Weiche neutrale Paletten, warme Holzakzente und großzügiges natürliches Licht.',
                highlight3Title: 'Ruhiges Schlaferlebnis',
                highlight3Desc: 'Plüsch-Kingsize-Bett mit Premium-Bettwäsche für erholsame Ruhe.',
                atAGlance: 'Auf einen Blick',
                statSize: 'Größe',
                statSizeValue: '41 qm',
                statView: 'Aussicht',
                statViewValue: 'Indischer Ozean',
                statGuests: 'Gäste',
                statGuestsValue: '2 Erwachsene',
                statBed: 'Bett',
                statBedValue: 'King oder Twin',
                reserve: 'Reservieren',
                galleryAlt: 'Suite-Zimmer',
                inclusionsTitle: 'Im Aufenthalt enthalten',
                inclusionsSubtitle: 'Durchdachte Details, ganztägiger Komfort',
                enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',
                inclusion1: 'Kostenloses Frühstück, Mittagessen, Abendessen im Restaurant',
                inclusion2: 'Hochgeschwindigkeits-WLAN und Arbeitsbereich im Zimmer',
                inclusion3: '24-Stunden-Zimmerservice und Concierge',
                inclusion4: 'Tägliche Zimmerreinigung mit Abend-Aufdeckservice',
                inclusion5: 'Zugang zum Pool und Ayurveda-Spa-Einrichtungen',
                inclusion6: 'Kostenlose Parkplätze und Shuttle-Service zu nahegelegenen Sehenswürdigkeiten',
                amenityGroup1Title: 'Zimmerausstattung',
                amenityGroup1Item1: '41 qm Fläche',
                amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
                amenityGroup1Item3: 'Klimaanlage mit Klimakontrolle',
                amenityGroup1Item4: 'Zimmersafe',
                amenityGroup2Title: 'Badeerlebnis',
                amenityGroup2Item1: 'Regendusche mit heißem und kaltem Wasser',
                amenityGroup2Item2: 'Premium-Badeausstattung',
                amenityGroup2Item3: 'Haartrockner',
                amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',
                amenityGroup3Title: 'Zimmerkomfort',
                amenityGroup3Item1: '55" Smart-TV mit Kabel',
                amenityGroup3Item2: 'Kaffee- und Teestation',
                amenityGroup3Item3: 'Direktwahltelefon',
                amenityGroup4Title: 'Konnektivität',
                amenityGroup4Item1: 'Kostenloses WLAN',
                amenityGroup4Item2: 'Schreibtisch',
                amenityGroup4Item3: '24/7 Rezeptionsunterstützung',
                essentialsTitle: 'Zimmer-Essentials',
                essentialsHeading: 'Alles, was Sie brauchen, um sich wie zu Hause zu fühlen',
                essentialsDesc: 'Von nahtloser Konnektivität bis hin zu sorgfältig ausgewählten Erfrischungen verbindet die Luxussuite Freizeit und Praktikabilität, damit Sie sich auf die Momente konzentrieren können, die zählen.',
                essential1: 'Kostenloses WLAN',
                essential2: 'Kaffee- und Teestation',
                essential3: '24/7 Zimmerservice',
                essential4: 'Regendusche',
                oceanTitle: 'Am Ozean',
                oceanSubtitle: 'Verlangsamen Sie, atmen Sie die Meeresluft ein',
                oceanAlt: 'Ozeanaussicht',
                ctaTitle: 'Bereit zu bleiben?',
                ctaHeading: 'Reservieren Sie die Luxussuite noch heute',
                ctaDesc: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
                checkAvailability: 'Verfügbarkeit prüfen'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Deluxe-Zimmer mit Meerblick',
                heroSubtitle: 'Wo sich Luxus mit beruhigendem Küstenreiz verbindet',
                bookThisRoom: 'Dieses Zimmer buchen',
                callReservations: 'Reservierungen anrufen',
                navAll: 'Alle',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe mit Meerblick',
                navSuite: 'Suite',
                sectionTitle: 'Ein beruhigendes Küstenversteck',
                sectionDesc: 'Unsere Deluxe-Zimmer mit Meerblick sind für langsame Morgen und ungehastete Sonnenuntergänge konzipiert. Weiche neutrale Töne, großzügige Verglasung und durchdachte Beleuchtung laden den Meerblick ein, während der Balkon Ihren eigenen Platz über der Küste bietet.',
                highlight1Title: 'Panoramische Strandaussichten',
                highlight1Desc: 'Wachen Sie mit azurblauen Gewässern und goldenen Sonnenaufgängen von Ihrem privaten Balkon auf.',
                highlight2Title: 'Elegante Küsteninterieure',
                highlight2Desc: 'Weiche neutrale Paletten, warme Holzakzente und großzügiges natürliches Licht.',
                highlight3Title: 'Ruhiges Schlaferlebnis',
                highlight3Desc: 'Plüsch-Kingsize-Bett mit Premium-Bettwäsche für erholsame Ruhe.',
                atAGlance: 'Auf einen Blick',
                statSize: 'Größe',
                statSizeValue: '41 qm',
                statView: 'Aussicht',
                statViewValue: 'Indischer Ozean',
                statGuests: 'Gäste',
                statGuestsValue: '2 Erwachsene',
                statBed: 'Bett',
                statBedValue: 'King oder Twin',
                reserve: 'Reservieren',
                galleryAlt: 'Deluxe-Zimmer mit Meerblick',
                inclusionsTitle: 'Im Aufenthalt enthalten',
                inclusionsSubtitle: 'Durchdachte Details, ganztägiger Komfort',
                enhancedCleanliness: 'Verbesserte Sauberkeits- und Sicherheitsstandards',
                inclusion1: 'Kostenloses Frühstück, Mittagessen, Abendessen im Restaurant',
                inclusion2: 'Hochgeschwindigkeits-WLAN und Arbeitsbereich im Zimmer',
                inclusion3: '24-Stunden-Zimmerservice und Concierge',
                inclusion4: 'Tägliche Zimmerreinigung mit Abend-Aufdeckservice',
                inclusion5: 'Zugang zum Pool und Ayurveda-Spa-Einrichtungen',
                inclusion6: 'Kostenlose Parkplätze und Shuttle-Service zu nahegelegenen Sehenswürdigkeiten',
                amenityGroup1Title: 'Zimmerausstattung',
                amenityGroup1Item1: '41 qm Fläche',
                amenityGroup1Item2: 'Privater Balkon mit Sitzgelegenheit',
                amenityGroup1Item3: 'Klimaanlage mit Klimakontrolle',
                amenityGroup1Item4: 'Zimmersafe',
                amenityGroup2Title: 'Badeerlebnis',
                amenityGroup2Item1: 'Regendusche mit heißem und kaltem Wasser',
                amenityGroup2Item2: 'Premium-Badeausstattung',
                amenityGroup2Item3: 'Haartrockner',
                amenityGroup2Item4: 'Weiche Bademäntel und Hausschuhe',
                amenityGroup3Title: 'Zimmerkomfort',
                amenityGroup3Item1: '55" Smart-TV mit Kabel',
                amenityGroup3Item2: 'Kaffee- und Teestation',
                amenityGroup3Item3: 'Direktwahltelefon',
                amenityGroup4Title: 'Konnektivität',
                amenityGroup4Item1: 'Kostenloses WLAN',
                amenityGroup4Item2: 'Schreibtisch',
                amenityGroup4Item3: '24/7 Rezeptionsunterstützung',
                essentialsTitle: 'Zimmer-Essentials',
                essentialsHeading: 'Alles, was Sie brauchen, um sich wie zu Hause zu fühlen',
                essentialsDesc: 'Von nahtloser Konnektivität bis hin zu sorgfältig ausgewählten Erfrischungen verbindet jedes Deluxe-Zimmer mit Meerblick Freizeit und Praktikabilität, damit Sie sich auf die Momente konzentrieren können, die zählen.',
                essential1: 'Kostenloses WLAN',
                essential2: 'Kaffee- und Teestation',
                essential3: '24/7 Zimmerservice',
                essential4: 'Regendusche',
                oceanTitle: 'Am Ozean',
                oceanSubtitle: 'Verlangsamen Sie, atmen Sie die Meeresluft ein',
                oceanAlt: 'Ozeanaussicht',
                ctaTitle: 'Bereit zu bleiben?',
                ctaHeading: 'Reservieren Sie ein Deluxe-Zimmer mit Meerblick noch heute',
                ctaDesc: 'Sprechen Sie mit unserem Reservierungsteam für die besten verfügbaren Preise und Sonderangebote.',
                checkAvailability: 'Verfügbarkeit prüfen'
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Ayurveda am Meer',
            heroSubtitle2: 'Finden Sie Ausgewogenheit, atmen Sie freier, und erneuern Sie Ihre Energie in Beruwala.',
            exploreResort: 'Resort erkunden',
            bookNow: 'Jetzt buchen',

            // Welcome Section
            welcomeLabel: 'Willkommen',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'Es liegt an den makellos Ufern von Beruwala und bietet eine harmonische Mischung aus alten Heilungstraditionen und moderner Strandluxus. Unser Heiligtum lädt Sie ein, eine transformative Wellness-Reise zu beginnen, wo der rhythmische Klang des Indischen Ozeans auf die zeitlose Weisheit des Ayurveda trifft.',
            welcomeDesc2: 'Erleben Sie personalisierte Ayurveda-Behandlungen, genießen Sie Nährstoffgerichte, die zum Ausgleich Ihres Doshas beitragen, und entspannen Sie sich in elegant gestalteten Zimmern mit atemberaubender Meeraussicht. Unabhängig davon, ob Sie Verjüngung, Entspannung oder spirituelle Erneuerung anstreben, steht unser engagiertes Team von Ayurveda-Fachleuten und Wellness-Experten bereit, Sie in jedem Schritt zu unterstützen.',
            learnMore: 'Mehr erfahren',
            contactUs: 'Kontaktieren Sie uns',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'Ayurveda & Strandretreat',
            welcomeImageLocation: 'Beruwala, Sri Lanka',

            // Highlight Section
            highlightTitle: 'Ein Ayurveda-Heiligtum am Meer',
            highlightDesc: 'Entdecken Sie ganzheitliche Heilung an der Südwestküste Sri Lankas. Von maßgeschneiderten Behandlungen bis zu ruhigen Balkonen und achtsamem Essen - jedes Detail ist darauf ausgelegt, Ihren Rhythmus wiederherzustellen.',

            // Services
            service1Title: 'Ganzheitliche Ayurveda-Therapien',
            service1Desc: 'Personalisierte Beratungen, authentische Kräuteröle und tägliche Behandlungen unter Anleitung erfahrener Ayurveda-Ärzte.',
            service2Title: 'Strandfront-Zimmer & Suiten',
            service2Desc: 'Wachen Sie auf mit Meeresbrisen, privaten Balkonen und beruhigenden Innenräumen für tiefe Ruhe.',
            service3Title: 'Wellness-Küche',
            service3Desc: 'Frische sri-lankische Produkte, pflanzenorientierte Menüs und maßgeschneiderte Speisepläne, die Ihr Dosha ergänzen.',
            service4Title: 'Yoga & Achtsamkeit',
            service4Desc: 'Sunrise-Yoga, Sonnenuntergangmeditationen und Atemübungen vor dem Rhythmus der Wellen.',
            service5Title: 'Fluss- & Küstenausflüge',
            service5Desc: 'Bootsfahrten auf dem Bentota-Fluss, Schildkrötenbrutplätze, Gärten, Gewürzgärten und Dorffahrradtouren.',

            // Rooms
            roomsTitle: 'Unsere Zimmer',
            roomsDesc: 'Wählen Sie das Heiligtum, das zu Ihrem Tempo passt, von luftigen Suiten bis zu gemütlichen Deluxe-Verstecken, alle mit weichen Leinen, warmem Holz und sonnenaufgangsreifen Balkonen.',
            roomBadge: 'Strandfront-Flucht',
            bookableNow: 'Jetzt buchbar',
            seaBreezeReady: 'Meeresbreise bereit',
            viewRoom: 'Zimmer anzeigen',
            room1Title: 'Suite-Zimmer',
            room1Desc: 'Große Suiten mit Loungebereichen, großzügigen Balkonen und beruhigender Farbpalette für langsame Morgen.',
            room2Title: 'Deluxe-Zimmer',
            room2Desc: 'Gemütliche Rückzugsorte mit luxuriösen Betten, Gartenblick und warmen Holzakzenten für alltägliche Leichtigkeit.',
            room3Title: 'Deluxe Meerblick',
            room3Desc: 'Wachen Sie mit dem Meereshorizont auf, mit weichen Leinen und privatem Balkon für goldene Sonnenuntergänge.',

            // Achievements
            achievementsTitle: 'Vertraute am Meer',
            achievement1Title: 'Glückliche Gäste',
            achievement1Count: '1.000+',
            achievement2Title: 'Ayurveda-Behandlungen',
            achievement2Count: '20+',
            achievement3Title: 'Jahre der Pflege',
            achievement3Count: '15+',
            achievement4Title: 'Reisende Akkumulationen',
            achievement4Count: '1.000+',

            // Experiences
            experiencesTitle: 'Entdecken Sie das Muthumuni Ayurveda Beach Resort',
            experiencesDesc: 'Von Ayurveda-Reisen bis zu kuratierten Ausflügen - wählen Sie die Erlebnisse, die Ihren Aufenthalt unvergesslich machen.',
            planYourStay: 'Planen Sie Ihren Aufenthalt',
            experience1Title: 'Zimmer & Suiten',
            experience1Desc: 'Luftige Räume mit Balkonen, Meer- oder Gartenblick und durchdachtem Komfort für entspannte Aufenthalte.',
            experience2Title: 'Ayurveda-Spa',
            experience2Desc: 'Authentische Therapien, Dampfbäder und restaurative Massagen mit zeitgeprüften Ritualen.',
            experience3Title: 'Gastronomisches Erlebnis',
            experience3Desc: 'Nahrhafte inländische und internationale Küche in unserem Restaurant, sorgfältig zubereitet, um Körper und Geist zu nähren.',
            experience4Title: 'Erlebnisse & Touren',
            experience4Desc: 'Flusssafaris, Tempelbesuche, Wassersportarten und kuratierte kulturelle Ausflüge rund um Bentota.',

            // Gallery
            galleryTitle: 'Momente im Muthumuni Ayurveda Beach Resort',
            galleryDesc: 'Ein Einblick in unser Strandheiligtum - Sonnenaufgänge, ruhige Behandlungen, nahrhafte Speisen und ruhige Ecken für Sie.',
            gallery1Alt: 'Sonniges palmengefäumtes Strand in Muthumuni',
            gallery2Alt: 'Ayurveda-Ölbehandlung im Gange',
            gallery3Alt: 'Resort-Pool mit Liegestühlen',
            gallery4Alt: 'Kräuter vorbereitet für Spa',
            gallery5Alt: 'Paar genießt Sonnenuntergang am Meer',
            gallery6Alt: 'Yoga-Deck blickt auf das Meer',
            gallery7Alt: 'Pfad durch tropischen Garten',
            gallery8Alt: 'Gesundes Frühstück',
            gallery9Alt: 'Ruhiger Flussblick',
            gallery10Alt: 'Warmbeleuchtete Strandresort bei Einbruch der Dunkelheit',
            gallery11Alt: 'Ayurveda-Kräuter- und Öl-Display',
            gallery12Alt: 'Gemütliche Sitzecke im Garten',

            // Resort Images
            resort1Alt: 'Open-Air-Lounge mit Begrünung',
            resort2Alt: 'Komfortables Zimmers Interieur',
            resort3Alt: 'Spa-Behandlungsraum',
            resort4Alt: 'Essbereich mit natürlichem Licht',
            resort5Alt: 'Entspannender Aussicht auf den Pool',

            // Sunset Section
            sunsetLabel: 'Das tägliche Meisterwerk der Natur',
            sunsetTitle: 'Abendsonnenuntergang',
            sunsetDesc1: 'Beobachten Sie, wie der Tag anmutig dem Zwielicht nachgibt, während der Himmel sich in eine Leinwand aus Bernstein, Karminrot und Gold verwandelt. Der sanfte Indische Ozean spiegelt dieses himmlische Schauspiel wider und erzeugt eine fesselnde Symphonie aus Licht und Wasser.',
            sunsetDesc2: 'Jeden Abend bei Muthumuni bietet sich einen Platz in der ersten Reihe zu einer der atemberaubendsten Aufführungen der Natur. Finden Sie Ihren perfekten Aussichtspunkt - ob von Ihrem privaten Balkon, der Strandlounge oder unserem Sonnenuntergängs-Meditationsdeck - und lassen Sie die ruhige Schönheit über Sie hinweggehen.',
            sunsetFeature1: 'Ungehinderter Meerblick von überall',
            sunsetFeature2: 'Sonnenuntergängs-Ruhemeditation',
            sunsetFeature3: 'Kostenloser Kräutertee täglich serviert',
            sunsetFeature4: 'Fotogene Momente jeden Abend',
            sunsetImageAlt: 'Abendsonnenuntergang am Muthumuni Beach Resort',
            bestTime: 'Beste Zeit',
            sunsetTime: '18:00 Uhr - 18:45 Uhr',

            // Pool Section
            poolLabel: 'Aquatische Gelassenheit',
            poolTitle: 'Poolbereich',
            poolDesc1: 'Tauchen Sie ein in die Ruhe unseres makellosen Pools, wo kristallklares Wasser auf üppige tropische Gärten trifft. Unser Poolbereich ist darauf ausgelegt, sich zu entspannen und verjüngt zu werden - die perfekte Flucht, um unter der sri-lankischen Sonne zu entspannen.',
            poolDesc2: 'Ob Sie ein erfrischendes morgendliches Bad, eine nachmittägliche Entspannungssession mit einem guten Buch oder ein ruhiges Abendbad bevorzugen, bietet unser Poolbereich eine ideale Umgebung. Umgeben von komfortablen Liegestühlen, schattigen Kabinen und aufmerksamen Poolservice-Team, wird jeder Moment zu einer wertvollen Erinnerung.',
            poolFeature1: 'Temperaturgesteuerter Pool',
            poolFeature2: 'Umgeben von tropischen Gartenlandschaften',
            poolFeature3: 'Poolside Erfrischungs- & gesunde Snacks',
            poolFeature4: 'Premium-Liegestühle mit Schirmen',
            poolImageAlt: 'Entspannender Poolbereich im Muthumuni Resort',

            // Testimonials
            testimonialsTitle: 'Gäste während ihres Aufenthalts'
        }

    },
    ru: {
        about: {
            heroTitle: 'О нас',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Древняя мудрость встречается с современным здоровьем в курорте Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Персональные аюрведические процедуры, вид на океан и подлинное шри-ланкийское гостеприимство',
            slide1: 'Аюрведическое исцеление',
            slide2: 'Береговое спокойствие',
            slide3: 'Садовое спокойствие',
            slide4: 'Растительные терапии',
            slide5: 'Оздоровление океана',
            historyLabel: 'Наше путешествие',
            historyTitle: 'История курорта Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Основанный более двух десятилетий назад, курорт Muthumuni Ayurveda Beach Resort был создан из видения создать святилище, где древняя аюрведическая мудрость встречается с спокойной красотой южного побережья Шри-Ланки. То, что началось как скромный оздоровительный retreat, превратилось в одно из самых любимых мест Берувалы для холистического исцеления и омоложения.',
            historyDesc2: 'Наши основатели, вдохновленные поколениями традиционных практиков аюрведы, стремились сохранить эти проверенные временем целебные искусства, обеспечивая при этом современные удобства и подлинное шри-ланкийское гостеприимство. Сквозь годы мы оставались верны нашему обязательству перед подлинными оздоровительными впечатлениями, расширяя наши объекты, никогда не теряя из виду личную заботу, определяющую наше наследие.',
            historyDesc3: 'Сегодня Muthumuni стоит как свидетельство длительной силы аюрведы, приветствовав тысячи гостей со всего мира. Каждый посетитель становится частью нашей истории, находя баланс, исцеление и трансформацию в нашем береговом убежище.',
            statYear: '15+',
            statYearLabel: 'Лет оздоровительного совершенства',
            statGuest: '1,000+',
            statGuestLabel: 'Довольных гостей обслужено',
            experienceLegacy: 'Испытайте наше наследие',
            established: 'Основано',
            since2010: 'С 2008',
            chairmanLabel: 'Послание председателя',
            chairmanTitle: 'Руководствуемый заботой, укоренённый в Аюведе',
            chairmanDesc1: 'Добро пожаловать в курорт Muthumuni Ayurveda Beach Resort. На протяжении более двух десятилетий наша цель была простой: предложить подлинное исцеление, коренящееся в безвременной мудрости аюрведы, доставляемое с теплотой шри-ланкийского гостеприимства.',
            chairmanDesc2: 'Здесь каждая деталь — от наших процедур и кухни до спокойствия наших пространств — разработана, чтобы помочь вам замедлиться, восстановить баланс и пересоединить с собой. Мы честь быть частью вашего оздоровительного путешествия.',
            chairmanDesc3: 'От имени нашей преданной команды я приглашаю вас испытать заботу, аутентичность и безмятежность, которые определяют Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Председатель',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Председатель Mr. Nihal Muthumuni',
            staffLabel: 'Наша команда',
            staffTitle: 'Встретьте нашу преданную команду',
            staffDesc1: 'В курорте Muthumuni Ayurveda Beach Resort наша команда — сердце всего, что мы делаем. Члены нашего персонала — тщательно отобранные и обученные профессионалы, которые разделяют глубокую страсть к аюрведическому оздоровлению и подлинному гостеприимству.',
            staffDesc2: 'От наших опытных практиков аюрведы и квалифицированных массажистов до нашей преданной команды гостеприимства, каждый член приносит годы опыта и подлинную заботу к каждому взаимодействию с гостями. Мы верим, что истинное благополучие приходит не только из процедур, но из теплоты и внимания людей, которые искренне заботятся о вашем путешествии.',
            staffDesc3: 'Наш персонал постоянно проходит обучение по последним практикам аюрведы, поддерживая высочайшие стандарты профессионализма и культурной чувствительности. Мы гордимся созданием значимых связей с нашими гостями, обеспечивая, чтобы каждый визит становился памятным и трансформирующим опытом.',
            statStaff: '15+',
            statStaffLabel: 'Квалифицированные специалисты',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Удовлетворение гостей',
            staffImageAlt: 'Наша преданная команда персонала в курорте Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Наше обязательство',
            excellenceCare: 'Совершенство и забота',
            ctaLabel: 'Связаться с нами',
            ctaHeading: 'Готовы начать свое оздоровительное путешествие?',
            ctaDesc: 'Свяжитесь с нашей командой, чтобы забронировать ваш персональный аюрведический retreat. Независимо от того, у вас есть вопросы о наших процедурах, проживании или специальных оздоровительных пакетах, мы здесь, чтобы помочь создать вашу идеальную побег.',
            ctaButtonContact: 'Свяжитесь с нами сейчас',
            ctaButtonRooms: 'Исследуйте номера',
            contactUs: 'Свяжитесь с нами',
            quickInfoCall: 'Позвоните нам',
            quickInfoEmail: 'Напишите нам',
            quickInfoLocation: 'Местоположение',
            locationCity: 'Берувала, Шри-Ланка'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe номер с видом на реку — Комфорт с террасой или частным балконом',
            heroSubtitle: 'Отдыхайте в умиротворяющем убежище на берегу реки, вдохновлённом спокойными водами Бентоты, с современными удобствами и лёгким речным бризом.',
            bookThisRoom: 'Забронировать этот номер',
            callReservations: 'Позвонить в службу бронирования',

            navAll: 'Все',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe с видом на реку',

            soothingHideawayTitle: 'Успокаивающее убежище на берегу реки',
            soothingHideawayDesc: 'Наш Deluxe номер с видом на реку создан для неспешных утр и закатов без спешки. Мягкие нейтральные тона, большие окна и продуманное освещение впускают вид на реку внутрь, а балкон становится вашим личным уголком над текущей водой.',

            highlight1Title: 'Панорамный вид на реку',
            highlight1Desc: 'Просыпайтесь с видом на спокойную реку и золотые рассветы с вашего частного балкона.',
            highlight2Title: 'Элегантные интерьеры у реки',
            highlight2Desc: 'Мягкие нейтральные оттенки, тёплые деревянные акценты и обилие естественного света.',
            highlight3Title: 'Спокойный сон',
            highlight3Desc: 'Пышная кровать king-size с премиальным бельём для восстановительного отдыха.',

            atAGlance: 'Кратко',
            statSizeLabel: 'Площадь',
            statViewLabel: 'Вид',
            statViewValue: 'На реку',
            statGuestsLabel: 'Гости',
            statBedLabel: 'Кровать',
            statBedValue: 'King или Twin',
            reserve: 'Забронировать',

            includedWithStay: 'Включено в проживание',
            thoughtfulTouches: 'Продуманные детали, комфорт круглосуточно',
            enhancedCleanliness: 'Повышенные стандарты чистоты и безопасности',

            inclusion1: 'Бесплатные завтрак, обед и ужин в ресторане Breeze',
            inclusion2: 'Высокоскоростной Wi-Fi и рабочее место в номере',
            inclusion3: 'Круглосуточный рум-сервис и консьерж',
            inclusion4: 'Ежедневная уборка с вечерним turndown',
            inclusion5: 'Доступ к инфинити-бассейну и спа-центру Ayurveda',
            inclusion6: 'Бесплатная парковка и трансфер к близлежащим достопримечательностям',

            amenityGroup1Title: 'Особенности номера',
            amenityGroup1Item1: '38 м² пространства',
            amenityGroup1Item2: 'Частный балкон с сидячими местами',
            amenityGroup1Item3: 'Кондиционер с индивидуальным управлением',
            amenityGroup1Item4: 'Сейф в номере',

            amenityGroup2Title: 'Ванная комната',
            amenityGroup2Item1: 'Дождевой душ с горячей и холодной водой',
            amenityGroup2Item2: 'Премиальные банные принадлежности',
            amenityGroup2Item3: 'Фен',
            amenityGroup2Item4: 'Махровые халаты и тапочки',

            amenityGroup3Title: 'Комфорт в номере',
            amenityGroup3Item1: '55" смарт-ТВ с кабельным ТВ',
            amenityGroup3Item2: 'Кофе- и чайная станция',
            amenityGroup3Item3: 'Прямой телефон',

            amenityGroup4Title: 'Связь',
            amenityGroup4Item1: 'Бесплатный Wi-Fi',
            amenityGroup4Item2: 'Рабочий стол',
            amenityGroup4Item3: 'Поддержка ресепшн 24/7',

            inRoomEssentials: 'Необходимое в номере',
            everythingYouNeed: 'Всё, что нужно, чтобы чувствовать себя как дома',
            inRoomEssentialsDesc: 'От бесперебойной связи до тщательно подобранных напитков — Deluxe номер с видом на реку сочетает отдых и практичность, чтобы вы могли сосредоточиться на важных моментах.',

            complimentaryWifi: 'Бесплатный Wi-Fi',
            coffeeTeaStation: 'Кофе и чайная станция',
            roomService: 'Круглосуточный рум-сервис',
            rainShower: 'Дождевой душ',

            byTheRiver: 'У реки',
            slowDownBreathe: 'Замедлитесь, вдохните свежий воздух',

            readyToStay: 'Готовы остановиться?',
            reserveDeluxeRiverViewToday: 'Забронируйте Deluxe номер с видом на реку сегодня',
            speakReservations: 'Свяжитесь с нашей службой бронирования для лучших цен и специальных предложений.',
            checkAvailability: 'Проверить наличие'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Аюрведа на берегу реки',
            heroTagline: 'Найдите баланс, дышите свободно и восстановите энергию в Алуггаме',
            exploreResort: 'Исследовать курорт',
            bookNow: 'Забронировать сейчас',

            welcomeLabel: 'Добро пожаловать',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Расположенный на спокойном берегу реки Бентота, Muthumuni Ayurveda River Resort предлагает гармоничное сочетание древних целительских традиций и тихой природной красоты. Наше убежище приглашает вас отправиться в трансформирующее путешествие здоровья, где мягкое течение реки встречается с вечной мудростью Аюрведы.',
            welcomeDesc2: 'Познакомьтесь с персонализированными аюрведическими процедурами, насладитесь питательной кухней, адаптированной под вашу дошу, и расслабьтесь в элегантно обставленных номерах с захватывающим видом на реку. Ищете ли вы омоложение, релаксацию или духовное обновление — наша преданная команда аюрведических практиков и специалистов по здоровью будет сопровождать вас на каждом шагу.',
            learnMore: 'Узнать больше',
            contactUs: 'Связаться с нами',
            welcomeImageCaption: 'Аюрведический велнес и речной ретрит',
            welcomeImageLocation: 'Алуггама, Шри-Ланка',

            highlightTitle: 'Аюрведическое убежище на берегу реки',
            highlightDesc: 'Откройте для себя целостное исцеление вдоль спокойного берега Бентоты. От индивидуальных процедур до тихих балконов и осознанной кухни — каждая деталь создана, чтобы восстановить ваш естественный ритм.',

            roomsTitle: 'Наши номера',
            roomsDesc: 'Выберите убежище, соответствующее вашему темпу — от просторных люксов до уютных deluxe-укромных уголков, каждый с мягким бельём, тёплым деревом и балконами, готовыми встретить восход солнца.',
            room1Title: 'Deluxe-номера',
            room1Desc: 'Уютные убежища с роскошными кроватями, видом на сад и тёплыми деревянными акцентами для ежедневного комфорта.',
            room2Title: 'Deluxe с видом на реку',
            room2Desc: 'Просыпайтесь с видом на спокойную реку, с мягким бельём и частным балконом, созданным для мирных утр.',
            viewRoom: 'Посмотреть номер',
            bookableNow: 'Доступно для бронирования',
            riverBreezeReady: 'Готово к речному бризу',
            roomBadge: 'Побег к реке',

            achievementsTitle: 'Надёжный велнес на берегу реки',
            achievement1Title: 'Счастливые гости',
            achievement1Count: '1 000+',
            achievement2Title: 'Аюрведические процедуры',
            achievement2Count: '20+',
            achievement3Title: 'Годы заботы',
            achievement3Count: '15+',
            achievement4Title: 'Похвалы путешественников',
            achievement4Count: '1 000+',

            experiencesTitle: 'Откройте впечатления в Muthumuni Ayurveda River Resort',
            experiencesDesc: 'От аюрведических путешествий до тщательно подобранных экскурсий — выбирайте те впечатления, которые сделают ваш отдых незабываемым.',
            planYourStay: 'Спланировать отдых',
            experience1Title: 'Наши номера',
            experience1Desc: 'Воздушные пространства с балконами, видом на реку или сад и продуманным комфортом для неторопливого пребывания.',
            experience2Title: 'Аюрведический спа',
            experience2Desc: 'Аутентичные терапии, паровые бани и восстанавливающие массажи, выполненные по древним ритуалам.',
            experience3Title: 'Ужин у реки',
            experience3Desc: 'Питательная шри-ланкийская и международная кухня, созданная для питания тела и разума.',
            experience4Title: 'Впечатления и экскурсии',
            experience4Desc: 'Сафари на реке Бентота, посещения храмов, водные виды спорта и культурные экскурсии по окрестностям Бентоты.',

            galleryTitle: 'Моменты в Muthumuni Ayurveda River Resort',
            galleryDesc: 'Взгляд на наше речное убежище — рассветы, спокойные процедуры, питательные блюда и тихие уголки, созданные специально для вас.',
            gallery1Alt: 'Солнечный берег реки с пальмами в Muthumuni',
            gallery2Alt: 'Процедура аюрведического массажа маслом',
            gallery3Alt: 'Бассейн курорта с шезлонгами',
            gallery4Alt: 'Травяные ингредиенты, подготовленные для спа',
            gallery5Alt: 'Пара наслаждается закатом у реки',
            gallery6Alt: 'Йога-платформа с видом на реку',
            gallery7Alt: 'Тропическая садовая дорожка',
            gallery8Alt: 'Здоровый завтрак',
            gallery9Alt: 'Спокойный вид на реку',
            gallery10Alt: 'Тёпло освещённый экстерьер курорта в сумерках',
            gallery11Alt: 'Выставка аюрведических трав и масел',
            gallery12Alt: 'Уютное место для отдыха у сада',

            boatLabel: 'Приключения на реке',
            boatTitle: 'Прогулки на лодке по реке Бентота',
            boatDesc1: 'Познакомьтесь с магией реки Бентота во время наших очаровательных прогулок на лодке. Скользите по спокойным водным путям среди пышных мангровых лесов, наблюдая за экзотической фауной — яркими зимородками, крокодилами, варанами и игривыми обезьянами. Идеально для любителей природы и фотографов, ищущих незабываемые моменты.',
            boatDesc2: 'Выбирайте спокойную утреннюю прогулку, романтический закатный круиз или приключенческое исследование дикой природы — наши опытные гиды поделятся увлекательными фактами об экосистеме реки. Персонализируйте свой опыт с помощью частных чартеров или присоединяйтесь к групповым турам для более близкого контакта с природой.',
            boatFeature1: 'Живописные речные круизы через мангровые заросли',
            boatFeature2: 'Наблюдение за животными — птицы, крокодилы и обезьяны',
            boatFeature3: 'Варианты прогулок на рассвете и закате',
            boatFeature4: 'Опытные местные гиды включены',
            boatImageAlt: 'Прогулка на лодке по реке Бентота',

            poolLabel: 'Водная тишина',
            poolTitle: 'Зона бассейна',
            poolDesc1: 'Погрузитесь в спокойствие нашего кристально чистого инфинити-бассейна, где прозрачная вода встречается с пышными тропическими садами. Зона бассейна создана для релаксации и восстановления и предлагает идеальное убежище для отдыха под солнцем Шри-Ланки.',
            poolDesc2: 'Предпочитаете ли вы освежающее утреннее плавание, ленивый полдень с хорошей книгой или спокойное вечернее купание — наша зона бассейна создаёт идиллическую атмосферу. Окружённая удобными шезлонгами, тенистыми кабанами и внимательным обслуживанием у бассейна, каждая минута превращается в драгоценное воспоминание.',
            poolFeature1: 'Инфинити-бассейн с регулируемой температурой',
            poolFeature2: 'Окружён тропическим садовым ландшафтом',
            poolFeature3: 'Напитки и полезные закуски у бассейна',
            poolFeature4: 'Премиум-шезлонги с зонтиками',
            poolImageAlt: 'Зона отдыха у бассейна',

            testimonialsTitle: 'Отзывы гостей о пребывании',

            bookingDestination: 'Направление',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Заезд',
            bookingCheckOut: 'Выезд',
            bookingGuests: 'Гости',
            guestsOption1: '1 гость',
            guestsOption2: '2 гостя',
            guestsOption3: '3 гостя',
            guestsOption4: '4+ гостей',
            bookingCheckAvailability: 'Проверить наличие',

            service1Title: 'Холистические аюрведические терапии',
            service1Desc: 'Персонализированные консультации, аутентичные травяные масла и ежедневные процедуры под руководством опытных врачей аюрведы.',

            service2Title: 'Номера у реки',
            service2Desc: 'Просыпайтесь под нежный шум реки, с приватными балконами и успокаивающими интерьерами, созданными для глубокого отдыха.',

            service3Title: 'Кухня для здоровья',
            service3Desc: 'Свежие продукты Шри-Ланки, растительные меню и индивидуальные планы питания, соответствующие вашей доше.',

            service4Title: 'Йога и осознанность',
            service4Desc: 'Йога на восходе солнца, медитация на закате и дыхательные практики в ритме волн.',

            service5Title: 'Речные и прибрежные экскурсии',
            service5Desc: 'Прогулки на лодке по реке Бентота, посещение черепашьих ферм, прогулки по садам специй и велосипедные туры по деревням.'
        },
        aboutus2: {
            heroTitle: 'О нас',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Древняя мудрость встречается с умиротворяющей красотой берегов реки в Muthumuni Ayurveda River Resort',
            heroTagline2: 'Персонализированные аюрведические процедуры, виды на реку и настоящая шри-ланкийская гостеприимность',
            slide1: 'Аюрведическое исцеление',
            slide2: 'Спокойствие у реки',
            slide3: 'Тишина сада',
            slide4: 'Травяные терапии',
            slide5: 'Оздоровление у реки',
            historyLabel: 'Наш путь',
            historyTitle: 'История Muthumuni Ayurveda River Resort',
            historyDesc1: 'Основанный более двух десятилетий назад, Muthumuni Ayurveda River Resort родился из стремления создать убежище, где древняя мудрость Аюрведы сочетается с умиротворяющей красотой речных пейзажей Шри-Ланки. Из скромного оздоровительного убежища он превратился в одно из самых любимых мест в Алуггаме для целостного исцеления и омоложения.',
            historyDesc2: 'Наши основатели, вдохновленные поколениями традиционных аюрведических практиков, стремились сохранить эти вековые целительские искусства, предлагая при этом современный комфорт и подлинное шри-ланкийское гостеприимство. Годы шли, а мы оставались верны своему обязательству предоставлять аутентичные оздоровительные впечатления, расширяя инфраструктуру, но никогда не теряя из виду индивидуальный уход, который определяет наше наследие.',
            historyDesc3: 'Сегодня Muthumuni является свидетельством непреходящей силы Аюрведы и принял тысячи гостей со всего мира. Каждый посетитель становится частью нашей истории, обретая равновесие, исцеление и преображение в нашем мирном убежище на берегу реки.',
            statYear: '15+',
            statYearLabel: 'Лет совершенства в оздоровлении',
            statGuest: '1.000+',
            statGuestLabel: 'Довольных гостей',
            experienceLegacy: 'Познакомьтесь с нашим наследием',
            established: 'Основан',
            sinceYear: 'С 1993 года',
            chairmanLabel: 'Обращение председателя',
            chairmanTitle: 'Руководствуемся заботой, укоренены в Аюрведе',
            chairmanDesc1: 'Добро пожаловать в Muthumuni Ayurveda River Resort. Более двух десятилетий наша цель проста: предлагать подлинное исцеление, основанное на вечной мудрости Аюрведы и сопровождаемое теплом шри-ланкийского гостеприимства.',
            chairmanDesc2: 'Здесь каждая деталь — от наших терапий и кухни до спокойствия наших пространств — создана, чтобы помочь вам замедлиться, восстановить равновесие и вновь соединиться с собой. Нам выпала честь быть частью вашего пути к оздоровлению.',
            chairmanDesc3: 'От имени нашей преданной команды я приглашаю вас ощутить заботу, подлинность и умиротворение, которые определяют Muthumuni.',
            chairmanBadge: 'Председатель',
            chairmanName: 'Г-н Нихал Мутхумуни',
            chairmanSignature: '— Г-н Нихал Мутхумуни',
            chairmanImageAlt: 'Председатель г-н Нихал Мутхумуни',
            staffLabel: 'Наша команда',
            staffTitle: 'Познакомьтесь с нашей преданной командой',
            staffDesc1: 'В Muthumuni Ayurveda River Resort наша команда — сердце всего, что мы делаем. Наши сотрудники тщательно отбираются и обучаются — это профессионалы, разделяющие глубокую страсть к аюрведическому оздоровлению и подлинному гостеприимству.',
            staffDesc2: 'От опытных аюрведических практиков и умелых массажистов до преданной команды гостеприимства — каждый член команды привносит годы опыта и искреннюю заботу в каждое взаимодействие с гостями. Мы верим, что настоящее оздоровление рождается не только из процедур, но и из тепла и внимания людей, которым действительно важна ваша поездка.',
            staffDesc3: 'Наша команда постоянно проходит обучение новейшим аюрведическим практикам, сохраняя при этом высочайшие стандарты профессионализма и культурной чувствительности. Мы гордимся тем, что создаем значимые связи с гостями, обеспечивая, чтобы каждый визит становился запоминающимся и трансформирующим опытом.',
            statStaff: '15+',
            statStaffLabel: 'Квалифицированных специалистов',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Удовлетворенность гостей',
            staffImageAlt: 'Наша преданная команда в Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Наше обязательство',
            excellenceCare: 'Превосходство и забота',
            ctaLabel: 'Свяжитесь с нами',
            ctaHeading: 'Готовы начать свой путь к оздоровлению?',
            ctaDesc: 'Свяжитесь с нашей командой, чтобы забронировать персонализированный аюрведический отдых. Есть вопросы о терапиях, размещении или специальных оздоровительных пакетах — мы здесь, чтобы помочь создать ваш идеальный отдых.',
            ctaButtonContact: 'Связаться сейчас',
            ctaButtonRooms: 'Посмотреть номера',
            quickInfoCall: 'Позвоните нам',
            quickInfoEmail: 'Напишите нам',
            quickInfoLocation: 'Местоположение',
            locationCity: 'Алуггама, Шри-Ланка'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Ваше убежище ждёт вас',
            heroSubtitle: 'Прибрежные оазисы, созданные для исцеления, восстановления и глубокого покоя вдоль спокойной реки Бентота.',
            exploreRooms: 'Исследовать номера',

            filterAll: 'Все',
            filterDeluxeRooms: 'Deluxe-номера',
            filterRiverViewDeluxe: 'Deluxe-номер с видом на реку',

            deluxeRoomName: 'Deluxe-номер',
            deluxeRoomCategory: 'Deluxe-номера',
            deluxeRoomDesc: 'Гармонично сбалансированный номер с элементами натурального дерева и видом на реку для идеального спокойствия.',

            riverViewDeluxeName: 'Deluxe с видом на реку',
            riverViewDeluxeCategory: 'Deluxe-номер с видом на реку',
            riverViewDeluxeDesc: 'Просыпайтесь под нежный шум реки и наслаждайтесь панорамным видом на берег в этом элегантно оформленном deluxe-номере.',

            noRoomsFound: 'Номера в этой категории не найдены.',
            roomSize: 'Площадь номера',
            guests: 'Гости',
            amenitiesCount: 'Удобства',
            roomAmenities: 'Удобства номера',
            specialFeatures: 'Особенности',

            kingSizeBed: 'Кровать King Size',
            workDesk: 'Рабочий стол',
            rainShower: 'Дождевой душ',
            teaStation: 'Чайная станция',
            privateTerrace: 'Частная терраса',
            binoculars: 'Бинокль',

            riverView: 'Вид на реку',
            naturalLighting: 'Естественное освещение',
            gardenView: 'Вид на сад',
            sunriseBalcony: 'Балкон для восхода солнца',
            soundOfRiver: 'Звук реки',

            bookNow: 'Забронировать сейчас',
            viewDetails: 'Посмотреть детали',
            viewRoom: 'Посмотреть номер',

            allRoomsInclude: 'Во всех номерах включено',
            essentialComforts: 'Основные удобства для вашего пути к здоровью',

            highSpeedWifi: 'Высокоскоростной Wi-Fi',
            herbalTea: 'Выбор травяных чаёв',
            climateControl: 'Кондиционирование',
            organicToiletries: 'Органическая косметика',
            dailyHousekeeping: 'Ежедневная уборка',
            concierge: 'Консьерж 24/7',
            yogaMat: 'Йога-мат и аксессуары',

            beginHealing: 'Начните своё исцеление',
            beginHealingDesc: 'Познакомьтесь с подлинным аюрведическим благополучием в спокойной речной обстановке, созданной для питания тела, успокоения ума и восстановления духа.',
            reserveRoom: 'Забронировать номер',
            speakAdvisor: 'Поговорить с консультантом по здоровью',

            exploreOurRooms: 'Исследовать наши номера'
        },
        blogs2: {
            heroTitle: 'Блоги Muthumuni Ayurveda River Resort',
            heroSubtitle1: 'Истории с берега реки, ритуалы Аюрведы в',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Погрузитесь в советы, историю и закулисные заметки.',
            heroAlt: 'Прогулочная дорожка у реки на закате',
            sectionTitle: 'Блоги Muthumuni Ayurveda River Resort',
            sectionDescription: 'Путеводители, истории и заметки из нашего уединения на берегу реки — от ритуалов Аюрведы и практик оздоровления до советов путешественникам по окрестностям Бентоты.',
            ayurvedaTitle: 'Сердце подлинной Аюрведы',
            ayurvedaExcerpt: 'Познакомьтесь с древними целительскими традициями, укоренёнными в мудрости Шри-Ланки.',
            ayurvedaDescription: 'В Muthumuni Ayurveda River Resort Аюрведа — это больше, чем лечение, это образ жизни. Наши терапии основаны на знаниях вековой давности, адаптированы под ваш тип тела и проводятся опытными врачами-аюрведистами для достижения глубокого и долговременного баланса.',
            ayurvedaAlt: 'Аюрведическая процедура с травяными маслами и натуральными элементами',
            healingTitle: 'Индивидуальные пути исцеления',
            healingExcerpt: 'Почему программа оздоровления каждого гостя уникальна.',
            healingDescription: 'От первичной консультации до ежедневных процедур — ваш путь исцеления тщательно подбирается. Травяные терапии, лечебные массажи, йога и медитация работают вместе, восстанавливая гармонию тела, разума и духа.',
            healingAlt: 'Аюрведический врач консультирует гостя в спокойной обстановке',
            natureTitle: 'Исцеление у реки',
            natureExcerpt: 'Как спокойная речная обстановка и тропическая природа усиливают ваше благополучие.',
            natureDescription: 'Расположенный на берегу спокойной реки Шри-Ланки, Muthumuni создаёт естественную целительную среду. Мягкое течение реки, свежий воздух и пышная зелень усиливают действие Аюрведы, даря глубокое расслабление и обновление.',
            natureAlt: 'Вид на реку в курорте с пальмами и природой',
            foodTitle: 'Аюрведическая кухня для внутреннего баланса',
            foodExcerpt: 'Питательные блюда, разработанные для поддержки вашего лечения.',
            foodDescription: 'Наша аюрведическая кухня готовится ежедневно из сезонных местных продуктов. Каждое блюдо соответствует вашему доше, поддерживает пищеварение, детоксикацию и жизненную силу, оставаясь при этом вкусным и сытным.',
            foodAlt: 'Традиционное аюрведическое блюдо в натуральных мисках',
            yogaTitle: 'Йога, медитация и внутренняя тишина',
            yogaExcerpt: 'Мягкие практики, успокаивающие ум и укрепляющие тело.',
            yogaDescription: 'Ежедневные занятия йогой и медитацией дополняют ваши процедуры, улучшая гибкость, дыхание и ясность ума. Эти осознанные практики помогают восстановить связь с собой и сохранить ощущение покоя после отъезда.',
            yogaAlt: 'Гости занимаются йогой с видом на реку на рассвете',
            lifestyleTitle: 'Аюрведа с собой домой',
            lifestyleExcerpt: 'Простые привычки для продолжения пути оздоровления.',
            lifestyleDescription: 'Перед отъездом наши эксперты научат вас поддерживать баланс через ежедневные ритуалы, питание и уход за собой. Возьмите с собой не только воспоминания, но и устойчивый путь к более здоровой жизни.',
            lifestyleAlt: 'Гость отдыхает с травяным чаем в спокойной обстановке курорта',
            readMore: 'Читать далее'
        },
        yoga2: {
            heroTitle: 'Йога в курорте',
            heroSubtitle: 'Найдите баланс, силу и внутренний покой в Беруале',
            heroAlt: 'Йога в Muthumuni Resort',
            importanceEyebrow: 'Здоровье и баланс',
            importanceTitle: 'Значение йоги и медитации',
            importanceImageAlt: 'Значение йоги и медитации',
            importanceText1: 'Йога и медитация — древние практики, которые приносят множество физических, ментальных и эмоциональных преимуществ. Они развивают гибкость, силу и равновесие, одновременно снижая стресс и тревогу.',
            importanceText2: 'Регулярная практика улучшает концентрацию, качество сна и общее самочувствие. Йога также способствует осознанности, помогая человеку соединиться со своим внутренним «Я» и обрести покой посреди повседневного хаоса.',
            importanceText3: 'В Muthumuni Resort созданы спокойные пространства, идеально подходящие для занятий йогой и медитацией, чтобы гости могли восстановить тело, разум и душу.',
            practiceEyebrow: 'Наша практика',
            practiceTitle: 'Практика и опыт йоги',
            practiceImageAlt: 'Практика йоги в курорте',
            practiceText1: 'В Muthumuni Resort мы практикуем в основном традиционную хатха-йогу в сочетании с пранаямой (дыхательными техниками). Этот целостный подход направлен на пробуждение внутреннего осознания, мягкую стимуляцию кундалини с акцентом на выравнивание позвоночника и развитие гибкости.',
            practiceText2: 'Занятия йогой проводятся регулярно и подходят как новичкам, так и опытным практикам. Время от времени вводятся специальные занятия, например, аштанга-йога.',
            practiceText3: 'Все занятия проходят в специально оборудованном йога-зале — спокойном и умиротворяющем пространстве, созданном для концентрации, равновесия и осознанного движения. Обычно каждая сессия начинается с приветствия солнцу, затем следует пранаяма и последовательность тщательно подобранных асан для улучшения гибкости и кровообращения.',
            practiceText4: 'Наши опытные преподаватели йоги адаптируют каждое занятие под индивидуальные потребности, возможности и состояние здоровья гостей, обеспечивая безопасность и глубокую пользу.',
            spiritualEyebrow: 'Духовное путешествие',
            spiritualTitle: 'Медитация и духовные активности',
            spiritualSubtitle: 'Углубите свою духовную практику с помощью наших священных церемоний и направляемых медитаций',
            meditationImageAlt: 'Медитация и духовная практика в курорте',
            meditationTitle: 'Сессии медитации',
            meditationDesc: 'Гостей приглашают на направляемые медитации, вдохновлённые традиционными практиками. Эти сессии созданы, чтобы успокоить ум, углубить осознание и поддержать эмоциональное и духовное исцеление в мирной атмосфере.'
        },
        food2: {
            heroTitle: 'Аюрведическое питание и прибрежная кухня',
            heroSubtitle: 'Аутентичные вкусы Шри-Ланки и свежая прибрежная кухня',
            heroAlt: 'Кулинарный опыт в Muthumuni Beach Resort',
            wellnessEyebrow: 'Здоровье через питание',
            wellnessTitle: 'Важность',
            ayurvedicFood: 'Аюрведического питания',
            wellnessIntro1: 'В аюрведе пища считается величайшим лекарством. То, что вы едите, напрямую влияет на ваши доши (Вата, Питта, Капха), пищеварение (агни) и общее равновесие тела, ума и духа.',
            wellnessIntro2: 'Аюрведическое питание делает акцент на свежих, сезонных, цельных продуктах, приготовленных с заботой и осознанным потреблением. В каждой трапезе присутствуют шесть вкусов (сладкий, кислый, солёный, острый, горький, вяжущий), чтобы питать все чувства и поддерживать гармонию.',
            wellnessIntro3: 'Правильное аюрведическое питание укрепляет пищеварение, помогает выводить токсины (аму), повышает иммунитет, увеличивает энергию, снижает стресс и предотвращает многие хронические заболевания. В Muthumuni каждое блюдо создаётся с учётом вашей индивидуальной конституции для глубокого исцеления и жизненной силы.',
            foodImage1Alt: 'Традиционная аюрведическая трапеза с шестью вкусами',
            foodImage2Alt: 'Аюрведические травы и специи для сбалансированного питания',
            culinaryPhilosophyEyebrow: 'Наша кулинарная философия',
            culinaryPhilosophyTitle: 'Аюрведическое',
            nutritionHighlight: 'питание',
            culinaryPhilosophyResort: 'в Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Аюрведическая кухня в Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Свежее и питательное',
            healingIngredientsAlt: 'Полезные аюрведические ингредиенты и специи',
            healingIngredientsLabel: 'Целебные ингредиенты',
            philosophyText1: 'Пища, включающая шесть основных вкусов (сладкий, кислый, солёный, горький, острый, вяжущий) и множество тонких вариаций, описана в классических аюрведических текстах — некоторые из них старше 5000 лет — вместе с основными свойствами каждого продукта: гуна (природное качество), вирья (потенция — нагревающая или охлаждающая), випака (влияние после переваривания) и прабхава (уникальное особое действие).',
            philosophyText2: 'Поэтому аюрведическое питание играет центральную роль в Muthumuni Ayurveda Beach Resort. Это не означает жёсткий, однообразный режим из пресных, безвкусных или чрезмерно горьких вегетарианских блюд, диктуемых только врачами. Напротив, наша аюрведическая кухня — одна из наших главных сильных сторон: блюда, приготовленные нашими талантливыми поварами, будут удивлять и радовать вас каждый день пребывания!',
            philosophyText3: 'На завтрак — щедрый буфет со свежими тропическими фруктами, свежевыжатыми соками, питательными травяными супами, домашним хлебом и лёгким печеньем, а также разнообразные аутентичные сри-ланкийские завтраки. На обед — красочный и вкусный буфет с мягкими рыбными карри, овощными блюдами и травяными блюдами. Вечером подаётся фиксированное вегетарианское меню с опцией свежей рыбы. По субботам мы устраиваем «Sri Lankan Night» с расширенным буфетом — наши повара готовят традиционные местные блюда прямо перед вами, создавая живое и подлинное впечатление.',
            philosophyText4: 'В аюрведе продукты и напитки классифицируются множеством способов — по вкусу и свойствам, пищеварительной способности (агни), пригодности для конкретных состояний здоровья, сезонной уместности и т.д. В Muthumuni мы одновременно учитываем все эти факторы и сознательно стремимся включать все шесть вкусов в сбалансированных сочетаниях, адаптированных под конституцию каждого гостя.',
            philosophyText5: 'В наших блюдах используются свежие овощи, тропические фрукты и ответственно добытая рыба. Мы не подаём красное мясо и алкоголь.',
            philosophyText6: 'Во время приёма пищи всегда присутствует аюрведический врач или квалифицированный диетолог, готовый вас проконсультировать. Они подскажут наиболее подходящие овощи, травы и специи для вашей текущей фазы лечения и помогут выбрать или исключить определённые блюда. Ваш персональный травяной эликсир и любые специальные рекомендации от команды центра здоровья будут размещены на вашем индивидуальном столе.',
            philosophyText7: 'Такой уровень персонализированного ухода и внимания к питанию — визитная карточка опыта Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Пища считается Праной — жизненной энергией, поддерживающей жизнь каждого человека. Поэтому мы приглашаем вас подходить к каждой трапезе с полной осознанностью: наслаждаться ароматами, ощущать вкусы, чувствовать мягкое тепло и сознательно переживать все вкусовые ощущения.',
            diningExperienceEyebrow: 'Опыт питания',
            restaurantTitlePrefix: 'Наш',
            ayurvedicHighlight: 'Аюрведический',
            restaurantTitleSuffix: 'ресторан',
            restaurantDetail1: 'Наш аюрведический ресторан в Muthumuni Beach Resort предлагает уникальный опыт питания, гармонично сочетающий традиционные принципы аюрведы с аутентичной прибрежной кухней Шри-Ланки. Мы делаем акцент на свежих, местных ингредиентах, чтобы создавать блюда, которые радуют вкус и способствуют целостному благополучию.',
            restaurantDetail2: 'Меню тщательно продумано так, чтобы в каждом блюде присутствовали все шесть вкусов (сладкий, кислый, солёный, горький, острый, вяжущий), обеспечивая питательный и приятный опыт. Каждое блюдо готовится с заботой и включает аюрведические травы и специи, известные своими целебными свойствами.',
            restaurantDetail3: 'Гости могут наслаждаться разнообразием блюд, адаптированных под их индивидуальные доши (конституции тела), с вариантами для вегетарианской, веганской и пескетарианской диеты. Наши повара тесно сотрудничают с аюрведическими практиками, чтобы каждое блюдо поддерживало цели здоровья и благополучия гостей.',
            restaurantDetail4: 'Атмосфера ресторана отражает спокойную прибрежную среду, создавая умиротворяющую обстановку для осознанного питания. Будь то сытный завтрак-буфет или изысканный ужин — каждая трапеза в нашем аюрведическом ресторане становится возможностью питать тело и душу.',
            restaurantDetail5: 'Присоединяйтесь к нам в аюрведическом ресторане Muthumuni Beach Resort для кулинарного путешествия, которое прославляет богатые вкусы Шри-Ланки и воплощает вечную мудрость аюрведы.',
            restaurantImageAlt: 'Питание в Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Премиум-питание',
            premiumDiningDescription: 'Насладитесь аутентичной аюрведической кухней в спокойной обстановке у реки'
        },
        tours2: {
            heroTitle: 'Туры и экскурсии',
            heroSubtitle: 'Откройте красоту Шри-Ланки из Беруалы',
            kandeAlt: 'Храм Канде Вихара – Беруала',
            kandeTitle: 'Посещение храма Канде Вихара',
            kandeBuddhaAlt: 'Гигантская статуя Будды в храме Канде Вихара',
            bentotaTitle: 'Сафари на лодке по реке Бентота',
            bentotaAlt: 'Сафари на лодке по реке Бентота – мангровые заросли и дикая природа',
            galleTitle: 'Тур по старому городу Галле',
            galleAlt: 'Тур по старому городу Галле',
            sigiriyaTitle: 'Тур в крепость Сигирия',
            sigiriyaAlt: 'Тур в крепость Сигирия',
            kandyTitle: 'Культурный тур в Канди',
            kandyAlt: 'Культурный тур в Канди',
            bookTour: 'Забронировать этот тур',
            introPara1: 'Шри-Ланка — страна вечной красоты, где золотые пляжи, пышные зелёные пейзажи, древние храмы и яркая культура сливаются в идеальной гармонии.',
            introPara2: 'От спокойного юго-западного побережья до исторических городов, священных мест, заповедников дикой природы и туманных гор — каждое путешествие дарит уникальный и незабываемый опыт.',
            introPara3: 'Начиная с курорта Muthumuni Ayurveda Beach Resort в Беруале, наши тщательно подобранные туры и экскурсии призваны обогатить ваш отдых, идеально сочетая исследование, расслабление и оздоровление.',
            kandeDetail1: 'Храм Канде Вихара (Kande Viharaya) — один из самых знаковых буддийских храмов недалеко от Беруалы.',
            kandeDetail2: 'Основан в 1734 году, этот спокойный «горный храм» расположен на холме с прекрасным видом на побережье.',
            kandeDetail3: 'Главные достопримечательности: огромная 48-метровая (160 футов) сидящая статуя Будды (одна из самых высоких на Шри-Ланке), изысканные фрески эпохи Канди, древняя реликварийная камера, красивый вход с лунным камнем и священное дерево Бодхи возрастом более 300 лет.',
            kandeDetail4: 'Идеальный полудневный духовный и культурный опыт — лучше всего посещать утром, чтобы избежать жары.',
            bentotaDetail1: 'Насладитесь спокойным и живописным сафари на лодке по реке Бентота — одной из самых популярных природных экскурсий рядом с Беруалой.',
            bentotaDetail2: 'Проплывайте среди пышных мангровых зарослей, узких каналов и тихих заводей, наблюдая за местной дикой природой.',
            bentotaDetail3: 'Часто можно увидеть варанов, крокодилов, разнообразных птиц (зимородков, цапель, орлов), обезьян, а иногда выдр или водяных змей.',
            bentotaDetail4: 'Ваш опытный лодочник/гид расскажет об интересной флоре, традиционных способах рыбной ловли и жизни прибрежных деревень.',
            bentotaDetail5: 'Идеально для любителей природы и фотографов — спокойно, расслабляюще и прекрасно дополняет ваш аюрведический отдых.',
            galleDetail1: 'Исследуйте исторический форт Галле — объект Всемирного наследия ЮНЕСКО и один из лучше всего сохранившихся колониальных фортов Шри-Ланки.',
            galleDetail2: 'Прогуляйтесь по мощёным улочкам, окружённым голландскими колониальными зданиями, бутиками, кафе и художественными галереями.',
            galleDetail3: 'Посетите ключевые достопримечательности: маяк Галле, Голландскую реформатскую церковь, Национальный морской музей и крепостные стены с потрясающим видом на океан.',
            galleDetail4: 'Узнайте от знающего гида богатую историю, архитектуру и культурное значение форта.',
            galleDetail5: 'Идеально для любителей истории, культуры и тех, кто хочет прикоснуться к колониальному прошлому Шри-Ланки.',
            sigiriyaDetail1: 'Откройте для себя древнюю скальную крепость Сигирия — один из самых узнаваемых символов Шри-Ланки и объект Всемирного наследия ЮНЕСКО.',
            sigiriyaDetail2: 'Поднимитесь на впечатляющую скалу, чтобы исследовать руины дворца царя Касьяпы, украшенные фресками, водными садами и знаменитой Зеркальной стеной.',
            sigiriyaDetail3: 'Насладитесь панорамными видами на окружающие джунгли и равнины с вершины.',
            sigiriyaDetail4: 'Узнайте от профессионального гида увлекательную историю, архитектуру и легенды Сигирии.',
            sigiriyaDetail5: 'Идеально для любителей истории, приключений и всех, кто интересуется богатым культурным наследием Шри-Ланки.',
            kandyDetail1: 'Погрузитесь в яркую культуру Канди — последней королевской столицы Шри-Ланки и объекта Всемирного наследия ЮНЕСКО.',
            kandyDetail2: 'Посетите Храм Священного Зуба (Sri Dalada Maligawa) — одну из важнейших буддийских святынь мира.',
            kandyDetail3: 'Исследуйте Королевский ботанический сад в Перадении с огромной коллекцией тропических растений и орхидей.',
            kandyDetail4: 'Посмотрите традиционное выступление танцев Канди, демонстрирующее богатое художественное наследие Шри-Ланки.',
            kandyDetail5: 'Идеально для ценителей культуры, истории и тех, кто хочет глубже познакомиться с традициями Шри-Ланки.'
        },
        events2: {
            heroEyebrow: 'Опыт и активности',
            heroTitle: 'Наши мероприятия',
            heroSubtitle: 'Кураторские впечатления, сочетающие традиции Шри-Ланки с прибрежной роскошью',
            heroAlt: 'Мероприятия в Muthumuni',
            availableDaily: 'Ежедневно',
            bookNow: 'Забронировать',
            highlightsTitle: 'Основные моменты',
            detailAlt: 'Детали {{title}}',
            ctaTitle: 'Готовы создавать воспоминания?',
            ctaDescription: 'Свяжитесь с нашей командой, чтобы создать идеальное мероприятие в Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Связаться с нами',
            ctaViewRooms: 'Посмотреть номера',
            cookeryTitle: 'Кулинарные программы',
            cookerySubtitle: 'Вкус Шри-Ланки',
            cookeryDescription: 'Погрузитесь в яркие вкусы шри-ланкийской кухни. Наши шеф-повара проведут вас через практические кулинарные занятия, обучая традиционным рецептам, передаваемым из поколения в поколение. Научитесь готовить ароматные карри, хопперы, кокосовый самбол и многое другое из свежих местных продуктов.',
            cookeryHighlight1: 'Традиционные шри-ланкийские рецепты',
            cookeryHighlight2: 'Практический опыт приготовления',
            cookeryHighlight3: 'Свежие местные ингредиенты',
            cookeryHighlight4: 'Рецепты на дом',
            cookeryHighlight5: 'Экскурсия по саду специй включена',
            meditationTitle: 'Программы медитации',
            meditationSubtitle: 'Внутренний покой и осознанность',
            meditationDescription: 'Найдите умиротворение на наших медитациях с видом на спокойный Индийский океан. Опытные инструкторы познакомят вас с древними техниками осознанности, дыхательными упражнениями и йогой, успокаивающими ум и восстанавливающими дух.',
            meditationHighlight1: 'Сессии на рассвете и закате',
            meditationHighlight2: 'Медитация на пляже',
            meditationHighlight3: 'Руководство экспертов',
            meditationHighlight4: 'Дыхательные техники',
            meditationHighlight5: 'Йога и практики осознанности',
            bbqTitle: 'Вечеринки-барбекю',
            bbqSubtitle: 'Праздники на пляже',
            bbqDescription: 'Проведите незабываемые вечера на наших пляжных барбекю-вечеринках. Наслаждайтесь свежими морепродуктами с гриля, отборным мясом и вегетарианскими блюдами под шёпот волн. Живая музыка, танцы с огнём и звёздное небо создают идеальную атмосферу для праздника и общения.',
            bbqHighlight1: 'Свежие морепродукты на гриле',
            bbqHighlight2: 'Ужин у океана',
            bbqHighlight3: 'Живая музыка и шоу',
            bbqHighlight4: 'Костёр',
            bbqHighlight5: 'Индивидуальные меню',
            boatTitle: 'Прогулки на лодке',
            boatSubtitle: 'Речные и прибрежные приключения',
            boatDescription: 'Отправьтесь в волшебные путешествия по реке Бентота и прибрежным водам. Проплывайте среди мангровых лесов, наблюдайте за экзотическими птицами и животными или наслаждайтесь романтическими закатными круизами. Лодочные прогулки открывают уникальный взгляд на природную красоту и экосистемы Шри-Ланки.',
            boatHighlight1: 'Круизы по реке Бентота',
            boatHighlight2: 'Исследование мангров',
            boatHighlight3: 'Наблюдение за животными',
            boatHighlight4: 'Закатные лодочные туры',
            boatHighlight5: 'Возможность частного чартера',
            ayurvedaLecturesTitle: 'Лекции врачей-аюрведистов',
            ayurvedaLecturesSubtitle: 'Древняя мудрость и современное здоровье',
            ayurvedaLecturesDescription: 'Познакомьтесь с глубокими принципами аюрведы на лекциях сертифицированных врачей и практиков. Узнайте о балансе дош, травяных средствах, целостных методах исцеления и применении древней мудрости в современной жизни. Интерактивные занятия делают философию аюрведы понятной и применимой каждый день.',
            ayurvedaLecturesHighlight1: 'Сертифицированные врачи аюрведы',
            ayurvedaLecturesHighlight2: 'Персональный анализ доши',
            ayurvedaLecturesHighlight3: 'Обучение травяным средствам',
            ayurvedaLecturesHighlight4: 'Сессии вопросов и ответов',
            ayurvedaLecturesHighlight5: 'Руководство по здоровью на дом',
            traditionalClothsTitle: 'Мероприятия по ношению традиционной одежды',
            traditionalClothsSubtitle: 'Погружение в культурное наследие',
            traditionalClothsDescription: 'Погрузитесь в культурное наследие Шри-Ланки, научившись носить и понимать традиционную одежду. Наши стилисты помогут вам надеть аутентичные сари Кандьяна и традиционные наряды, объясняя значение каждого элемента. Идеально для особых случаев, культурного знакомства или красивых фотографий.',
            traditionalClothsHighlight1: 'Профессиональное руководство по стилю',
            traditionalClothsHighlight2: 'Аутентичные традиционные сари',
            traditionalClothsHighlight3: 'Объяснение культурного значения',
            traditionalClothsHighlight4: 'Профессиональная фотосъёмка включена',
            traditionalClothsHighlight5: 'Мастер-классы по модному фьюжн'
        },
        ayurveda2: {
            accordionTitle1: 'Что такое Панчакарма Аюрведа?',
            accordionDesc1: 'Аюрведа (санскритское слово, означающее «наука о жизни») — это древняя целостная система оздоровления. Панчакарма — комплекс очищающих и омолаживающих процедур, направленных на восстановление баланса между разумом, телом и духом.',
            accordionTitle2: 'Панчакарма Аюрведа и ваша жизненная энергия',
            accordionDesc2: 'Панчакарма сосредоточена на выведении токсинов и восстановлении гармонии между дошами (Вата, Питта, Капха). Лечение подбирается индивидуально для каждого гостя, чтобы поддерживать долговременное благополучие и жизненную силу.',
            accordionTitle3: 'Доша Вата',
            accordionDesc3: 'Вата управляет движением и циркуляцией. В равновесии она способствует творчеству и жизненной энергии. Панчакарма предлагает заземляющие процедуры для успокоения избыточной Ваты и восстановления баланса.',
            accordionTitle4: 'Доша Питта',
            accordionDesc4: 'Питта управляет пищеварением и обменом веществ. Охлаждающие и восстанавливающие процедуры помогают сбалансировать Питту, уменьшить воспаления и раздражительность.',
            accordionTitle5: 'Доша Капха',
            accordionDesc5: 'Капха обеспечивает структуру и стабильность. Активизирующие и улучшающие кровообращение процедуры применяются для уменьшения избыточной Капхи и придания лёгкости и гибкости.',
            close: 'Закрыть',
            next: 'Далее',
            previous: 'Назад',
            treatmentsTitle: 'Наши авторские процедуры Панчакарма Аюрведа',
            treatmentsSubtitle: 'Вековые терапии для детоксикации, омоложения и восстановления баланса.',
            bookTreatment: 'Забронировать эту процедуру',
            benefitsTitle: 'Преимущества процедур Панчакарма',
            shirodhara: 'Широдхара',
            shirodharaDesc: 'Мягкое выливание тёплого травяного масла на лоб для успокоения ума.',
            shirodhara1: 'Снижает стресс и тревогу',
            shirodhara2: 'Улучшает сон',
            shirodhara3: 'Повышает ясность ума',
            steamBath: 'Паровая баня',
            steamBathDesc: 'Детоксикационная паровая процедура для открытия пор и расслабления мышц.',
            steamBath1: 'Очищает организм',
            steamBath2: 'Улучшает кровообращение',
            steamBath3: 'Снимает мышечное напряжение',
            flowerBath: 'Цветочная ванна',
            flowerBathDesc: 'Успокаивающая ванна с ароматными цветами для расслабления.',
            flowerBath1: 'Успокаивает нервную систему',
            flowerBath2: 'Увлажняет кожу',
            flowerBath3: 'Поднимает настроение',
            headMassage: 'Массаж головы',
            headMassageDesc: 'Расслабляющий массаж головы для снятия напряжения.',
            headMassage1: 'Уменьшает головные боли',
            headMassage2: 'Улучшает здоровье кожи головы',
            headMassage3: 'Способствует расслаблению',
            faceMassage: 'Массаж лица',
            faceMassageDesc: 'Омолаживающий массаж для сияния лица и снятия стресса.',
            faceMassage1: 'Улучшает тонус кожи',
            faceMassage2: 'Снимает напряжение лица',
            faceMassage3: 'Стимулирует лимфодренаж',
            neckMassage: 'Массаж шеи',
            neckMassageDesc: 'Целенаправленный массаж для снятия скованности и напряжения в шее.',
            neckMassage1: 'Устраняет боль в шее',
            neckMassage2: 'Улучшает подвижность',
            neckMassage3: 'Снижает стресс',
            shoulderMassage: 'Массаж плеч',
            shoulderMassageDesc: 'Целенаправленный массаж для снятия скованности и дискомфорта в плечах.',
            shoulderMassage1: 'Уменьшает боль в плечах',
            shoulderMassage2: 'Улучшает осанку',
            shoulderMassage3: 'Расслабляет мышцы',
            bodyMassage: 'Массаж тела',
            bodyMassageDesc: 'Полнотелый массаж для общей релаксации и оздоровления.',
            bodyMassage1: 'Улучшает кровообращение',
            bodyMassage2: 'Снимает мышечную боль',
            bodyMassage3: 'Способствует расслаблению',
            backMassage: 'Массаж спины',
            backMassageDesc: 'Терапевтический массаж против боли и напряжения в спине.',
            backMassage1: 'Устраняет боль в спине',
            backMassage2: 'Улучшает здоровье позвоночника',
            backMassage3: 'Снижает стресс',
            footMassage: 'Массаж стоп',
            footMassageDesc: 'Успокаивающий массаж стоп для снятия боли и расслабления.',
            footMassage1: 'Улучшает кровообращение',
            footMassage2: 'Снимает усталость ног',
            footMassage3: 'Способствует расслаблению',
            purgative: 'Очищение (Пургатив)',
            purgativeDesc: 'Очищающая терапия для выведения избыточной Питты и токсинов из пищеварительной системы.',
            purgative1: 'Очищает толстый кишечник',
            purgative2: 'Балансирует Питта-дошу',
            purgative3: 'Улучшает здоровье пищеварения',
            nasalClearing: 'Очищение носа',
            nasalClearingDesc: 'Терапевтическая процедура для очищения пазух и улучшения дыхательной функции.',
            nasalClearing1: 'Устраняет заложенность носа',
            nasalClearing2: 'Улучшает дыхание',
            nasalClearing3: 'Снимает проблемы с пазухами',
            powderMassage: 'Массаж порошком',
            powderMassageDesc: 'Отшелушивающий массаж с травяными порошками для обновления и освежения кожи.',
            powderMassage1: 'Удаляет ороговевшую кожу',
            powderMassage2: 'Улучшает текстуру кожи',
            powderMassage3: 'Стимулирует кровообращение',
            intensiveMassage: 'Интенсивный массаж',
            intensiveMassageDesc: 'Глубокий терапевтический массаж, направленный на устранение хронических мышечных напряжений с использованием мощных и специализированных техник.',
            intensiveMassage1: 'Снимает глубокие мышечные напряжения',
            intensiveMassage2: 'Улучшает кровообращение',
            intensiveMassage3: 'Уменьшает мышечную боль',
            thermoMassage: 'Термо-массаж',
            thermoMassageDesc: 'Теплый массаж с травяными маслами, используя подогретые терапевтические масла для усиления расслабления и целебных эффектов.',
            thermoMassage1: 'Успокаивает напряженные мышцы',
            thermoMassage2: 'Способствует глубокому расслаблению',
            thermoMassage3: 'Улучшает энергетический поток',
            synchronMassage: 'Синхро-массаж',
            synchronMassageDesc: 'Синхронизированный массаж двумя терапевтами для полной гармонии тела и сбалансированного распределения энергии.',
            synchronMassage1: 'Полная гармония тела',
            synchronMassage2: 'Сбалансированный энергетический поток',
            synchronMassage3: 'Глубокий опыт расслабления',
            specialMassage: 'Специальный массаж',
            specialMassageDesc: 'Индивидуализированная массажная терапия, подобранная в соответствии с ваши конкретными потребностями в здоровье и личными целями благополучия.',
            specialMassage1: 'Персональное лечение',
            specialMassage2: 'Устраняет конкретные проблемы',
            specialMassage3: 'Индивидуализированный подход к борьбе',
            benefit1Title: 'Детоксикация:',
            benefit1Desc: 'Процедуры Панчакарма помогают выводить токсины из организма, способствуя общему здоровью и жизненной силе.',
            benefit2Title: 'Улучшение пищеварения:',
            benefit2Desc: 'Эти терапии улучшают пищеварительную функцию для лучшего усвоения питательных веществ и обмена веществ.',
            benefit3Title: 'Снижение стресса:',
            benefit3Desc: 'Панчакарма известна своими успокаивающими эффектами на тело и разум, снижая уровни стресса и тревоги.',
            benefit4Title: 'Укрепление иммунитета:',
            benefit4Desc: 'Регулярные процедуры Панчакарма укрепляют иммунную систему, делая организм более устойчивым к заболеваниям.',
            benefit5Title: 'Омоложение:',
            benefit5Desc: 'Терапии способствуют регенерации клеток для улучшения здоровья кожи и молодого вида.',
            benefit6Title: 'Балансировка дош:',
            benefit6Desc: 'Панчакарма помогает восстановить баланс дош (Вата, Питта, Капха), что необходимо для здоровья согласно аюрведическим принципам.',
            akkupancharTitle: 'Акупунктурная терапия',
            akkupancharDesc1: 'это древняя аюрведическая терапия с использованием травяных паст и масел на специфических точках тела. Это лечение стимулирует энергетические каналы и способствует исцелению.',
            akkupancharBenefit: 'Основные преимущества:',
            akkupancharDesc2: 'Эта специализированная терапия помогает при хронических болях, улучшает гибкость суставов, усиливает кровообращение и восстанавливает естественный поток энергии. Она особенно эффективна для тех, кто ищет глубокое терапевтическое исцеление и омоложение.',
            akkupancharApplication: 'Терапевтическое применение:',
            akkupancharDesc3: 'Акупунктура воздействует на специфические точки марма (жизненно важные узлы) по всему телу с тщательно подобранными травяными препаратами для балансировки дош и содействия оптимальному здоровью и благополучию.',
            akkupancharTransform: 'Испытайте трансформацию:',
            akkupancharDesc4: 'В Muthumuni Ayurveda River Resort наши опытные терапевты адаптируют каждую сессию акупунктуры к вашим уникальным потребностям в здоровье, обеспечивая глубокий и длительный опыт исцеления.',
            gallery1: 'Широдхара',
            gallery2: 'Паровая баня',
            gallery3: 'Цветочная ванна',
            gallery4: 'Массаж головы',
            gallery5: 'Массаж тела',
            gallery6: 'Массаж шеи',
            gallery7: 'Массаж лица',
            gallery8: 'Массаж плеч',
            sectionEyebrow: 'Панчакарма Аюрведа в Muthumuni',
            sectionDescription: 'Откройте для себя древнее искусство исцеления Панчакарма Аюрведа в нашем уединении на берегу реки. Наши опытные аюрведические специалисты предлагают индивидуальные процедуры для детоксикации, омоложения и восстановления баланса тела, разума и духа.',
            heroTitle: 'Панчакарма Аюрведа',
            heroSubtitle: 'Омоложение тела, разума и духа в Алуггаме',
            heroAlt: 'Аюрведа и оздоровление в Muthumuni River Resort',
            treatmentProgramme: {
                title: 'Программа аюрведического лечения',
                subtitle: 'Ваше путешествие к балансу, детоксикации и глубокому обновлению',
                intro: 'Испытайте подлинное аюрведическое исцеление в спокойном уединении, которое восстанавливает ваше тело, успокаивает ваш разум и обновляет вашу энергию. С момента вашего прибытия наша команда заботится о каждой детали – чтобы вы могли полностью сосредоточиться на своем благополучии.',
                welcomeTitle: 'Приветствие и мягкое начало',
                welcome1: 'Трансфер из аэропорта и доставка в отель',
                welcome2: 'Теплый прием и экскурсия по отелю',
                welcome3: 'Знакомство с вашим еженедельным планом оздоровления',
                welcome4: 'Расслабляющий массаж (день 1) в аюрведическом центре для снятия усталости от путешествия и подготовки вашего тела к процедурам',
                doctorTitle: 'Консультация врача и персональный план',
                doctor1: 'Консультация аюрведического врача (день 2 – утро)',
                doctor2: 'Полная оценка вашего типа доши/тела и проблем со здоровьем',
                doctor3: 'Переводчик доступен по запросу',
                doctor4: 'Ваш врач создаст персонализированный план лечения, адаптированный к вашим потребностям и целям',
                dailyTitle: 'Ежедневные аюрведические терапии',
                daily1: '4–5 процедур ежедневно (по рекомендации врача)',
                daily2: 'Терапии выбираются на основе вашей конституции тела и состояния',
                daily3: 'Специальные массажи могут быть добавлены по мере необходимости',
                daily4: 'Врач ежедневно контролирует прогресс и может корректировать процедуры и травяную поддержку для обеспечения наилучших результатов',
                daily5: 'При необходимости может быть рекомендована мягкая очистительная процедура/слабительное',
                herbalTitle: 'Поддержка травяными лекарствами',
                herbalIntro: 'Травяные лекарства, назначенные врачом, два раза в день:',
                herbal1: 'с завтраком',
                herbal2: 'с ужином',
                herbalClosing: 'Поддерживают внутреннее исцеление, детоксикацию и долгосрочный баланс.',
                yogaTitle: 'Йога и медитация для гармонии тела и разума',
                yoga1: 'Занятия йогой 4 раза в неделю (примерно 1 час)',
                yoga2: 'Сеансы медитации 2 раза в неделю:',
                yoga3: '— уникальный духовный опыт в островном храме, доступном на лодке',
                yoga4: '— управляемая медитация монахов (примерно 1 час)',
                wellnessTitle: 'Включенные оздоровительные мероприятия',
                wellness1: 'Еженедельные демонстрации здоровой кулинарии',
                wellness2: 'Бесплатная экскурсия (культурный/природный опыт)',
                closingTitle: 'Заключительная церемония и отъезд',
                closing1: 'Красивая цветочная ванна (последний день) – традиционный ритуал обновления',
                closing2: 'Заключительная консультация врача для проверки прогресса и предоставления:',
                closing3: '— продолжающихся рекомендаций по оздоровлению',
                closing4: '— рецепты и рекомендации для дома',
                closing5: 'Трансфер в аэропорт',
            }
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe номер — Комфорт с террасой или частным балконом',
            heroSubtitle: 'Отдыхайте в умиротворяющем убежище на берегу реки, вдохновлённом спокойными водами Бентоты, с современными удобствами и лёгким речным бризом.',
            bookThisRoom: 'Забронировать этот номер',
            callReservations: 'Позвонить в службу бронирования',

            navAll: 'Все',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe с видом на реку',

            soothingHideawayTitle: 'Успокаивающее убежище на берегу реки',
            soothingHideawayDesc: 'Deluxe номер создан для неспешных утр и закатов. Мягкие нейтральные тона, большие окна и продуманное освещение впускают вид на реку, а балкон становится вашим личным уголком над текущей водой.',

            highlight1Title: 'Панорамный вид на реку',
            highlight1Desc: 'Просыпайтесь с видом на спокойную реку и тропические рассветы с вашего частного балкона.',
            highlight2Title: 'Элегантные интерьеры у реки',
            highlight2Desc: 'Мягкие нейтральные оттенки, тёплые деревянные акценты и обилие естественного света.',
            highlight3Title: 'Спокойный сон',
            highlight3Desc: 'Пышная кровать king-size с премиальным бельём для восстановительного отдыха.',

            atAGlance: 'Кратко',
            statSizeLabel: 'Площадь',
            statViewLabel: 'Вид',
            statViewValue: 'На реку',
            statGuestsLabel: 'Гости',
            statBedLabel: 'Кровать',
            statBedValue: 'King или Twin',
            reserve: 'Забронировать',

            includedWithStay: 'Включено в проживание',
            thoughtfulTouches: 'Продуманные детали, комфорт круглосуточно',
            enhancedCleanliness: 'Повышенные стандарты чистоты и безопасности',

            inclusion1: 'Бесплатные завтрак, обед и ужин в ресторане Breeze',
            inclusion2: 'Высокоскоростной Wi-Fi и рабочее место в номере',
            inclusion3: 'Круглосуточный рум-сервис и консьерж',
            inclusion4: 'Ежедневная уборка с вечерним turndown',
            inclusion5: 'Доступ к инфинити-бассейну и спа-центру Ayurveda',
            inclusion6: 'Бесплатная парковка и трансфер к близлежащим достопримечательностям',

            amenityGroup1Title: 'Особенности номера',
            amenityGroup1Item1: '41 м² пространства',
            amenityGroup1Item2: 'Частный балкон с сидячими местами',
            amenityGroup1Item3: 'Кондиционер с индивидуальным управлением',
            amenityGroup1Item4: 'Сейф в номере',

            amenityGroup2Title: 'Ванная комната',
            amenityGroup2Item1: 'Дождевой душ с горячей и холодной водой',
            amenityGroup2Item2: 'Премиальные банные принадлежности',
            amenityGroup2Item3: 'Фен',
            amenityGroup2Item4: 'Махровые халаты и тапочки',

            amenityGroup3Title: 'Комфорт в номере',
            amenityGroup3Item1: '55" смарт-ТВ с кабельным ТВ',
            amenityGroup3Item2: 'Кофе- и чайная станция',
            amenityGroup3Item3: 'Прямой телефон',

            amenityGroup4Title: 'Связь',
            amenityGroup4Item1: 'Бесплатный Wi-Fi',
            amenityGroup4Item2: 'Рабочий стол',
            amenityGroup4Item3: 'Круглосуточная поддержка ресепшн',

            inRoomEssentials: 'Необходимое в номере',
            everythingYouNeed: 'Всё, что нужно, чтобы чувствовать себя как дома',
            inRoomEssentialsDesc: 'От бесперебойной связи до тщательно подобранных напитков — Deluxe номер сочетает отдых и практичность, чтобы вы могли сосредоточиться на важных моментах.',

            complimentaryWifi: 'Бесплатный Wi-Fi',
            coffeeTeaStation: 'Кофе и чайная станция',
            roomService: 'Круглосуточный рум-сервис',
            rainShower: 'Дождевой душ',

            byTheRiver: 'У реки',
            slowDownBreathe: 'Замедлитесь, вдохните свежий воздух',

            readyToStay: 'Готовы остановиться?',
            reserveDeluxeToday: 'Забронируйте Deluxe номер сегодня',
            speakReservations: 'Свяжитесь с нашей службой бронирования для лучших цен и специальных предложений.',
            checkAvailability: 'Проверить наличие'
        },
        rooms: {
            heroTitle: 'Ваше святилище ждет вас',
            heroSubtitle: 'Тщательно разработанные номера, предназначенные для исцеления, восстановления и глубокого спокойствия.',
            heroAlt: 'Комнаты Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Исследуйте наши номера',
            filterAll: 'Все',
            filterLuxurySuite: 'Люкс',
            filterDeluxeRooms: 'Номера Делюкс',
            filterDeluxeSeaView: 'Номер Делюкс с видом на море',
            noRoomsFound: 'В этой категории номеров не найдено.',
            allRoomsInclude: 'Все номера включают',
            essentialComforts: 'Основные удобства для вашего оздоровительного путешествия',
            roomSize: 'Размер номера',
            guests: 'Гости',
            amenities: 'Удобства',
            roomAmenities: 'Удобства номера',
            specialFeatures: 'Специальные возможности',
            bookNow: 'Забронировать сейчас',
            viewDetails: 'Просмотр деталей',
            highSpeedWifi: 'Высокоскоростной WiFi',
            herbalTea: 'Выбор травяных чаев',
            climateControl: 'Климат-контроль',
            rainShower: 'Дождевой душ',
            organicToiletries: 'Органические косметические средства',
            dailyHousekeeping: 'Ежедневная уборка',
            concierge: 'Консьерж 24/7',
            yogaMat: 'Коврик для йоги и реквизит',
            beginHealing: 'Начните свое путешествие исцеления',
            beginHealingDesc: 'Испытайте подлинное аюрведическое благополучие в окружении, которое питает ваше тело, успокаивает ваш ум и восстанавливает ваш дух.',
            reserveRoom: 'Зарезервировать номер',
            speakAdvisor: 'Говорить с советником по здоровью',
            exploreOurRooms: 'Исследуйте наши номера',
            viewRoom: 'Просмотреть номер',
            luxurySuiteName: 'Люкс',
            luxurySuiteCategory: 'Люкс',
            luxurySuiteDesc: 'Испытайте главное спокойствие в нашем просторном люксе, спроектированном в соответствии с традиционными аюрведическими принципами с потрясающим видом на море.',
            deluxeRoomName: 'Номер Делюкс',
            deluxeRoomCategory: 'Номер Делюкс',
            deluxeRoomDesc: 'Гармонично оформленный номер с натуральными деревянными элементами и охлаждающими водными объектами для получения идеального спокойствия.',
            seaViewDeluxeName: 'Делюкс с видом на море',
            seaViewDeluxeCategory: 'Номер Делюкс с видом на море',
            seaViewDeluxeDesc: 'Просыпайтесь к успокаивающему морскому бризу и панорамному виду на море в этом элегантно оформленном номере Делюкс.',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'Номер Делюкс — Комфорт с террасой или частным балконом',
                heroSubtitle: 'Расслабьтесь в успокаивающем прибрежном убежище, вдохновленном золотыми пляжами Бентоты, сочетающем современные удобства с нежным морским бризом.',
                bookThisRoom: 'Забронировать этот номер',
                callReservations: 'Позвонить в службу бронирования',
                navAll: 'Все',
                navDeluxe: 'Делюкс',
                navDeluxeSeaView: 'Делюкс с видом на море',
                navSuite: 'Люкс',
                sectionTitle: 'Успокаивающее прибрежное убежище',
                sectionDesc: 'Номер Делюкс создан для медленных утр и неспешных закатов. Мягкие нейтральные тона, обильное остекление и продуманное освещение приглашают вид на море, а балкон предлагает ваш собственный насест над береговой линией.',
                highlight1Title: 'Панорамный вид на пляж',
                highlight1Desc: 'Просыпайтесь с лазурными водами и золотыми восходами с вашего частного балкона.',
                highlight2Title: 'Элегантные прибрежные интерьеры',
                highlight2Desc: 'Мягкие нейтральные палитры, теплые деревянные акценты и обильный естественный свет.',
                highlight3Title: 'Безмятежный сон',
                highlight3Desc: 'Плюшевая кровать king-size с премиальным постельным бельем для восстановительного отдыха.',
                atAGlance: 'С первого взгляда',
                statSize: 'Размер',
                statSizeValue: '41 кв.м',
                statView: 'Вид',
                statViewValue: 'Индийский океан',
                statGuests: 'Гости',
                statGuestsValue: '2 взрослых',
                statBed: 'Кровать',
                statBedValue: 'King или Twin',
                reserve: 'Зарезервировать',
                galleryAlt: 'Галерея номера Делюкс',
                inclusionsTitle: 'Включено в ваше пребывание',
                inclusionsSubtitle: 'Продуманные детали, комфорт весь день',
                enhancedCleanliness: 'Повышенные стандарты чистоты и безопасности',
                inclusion1: 'Бесплатный завтрак, обед, ужин в ресторане Breeze',
                inclusion2: 'Высокоскоростной Wi-Fi и рабочее пространство в номере',
                inclusion3: '24-часовое обслуживание номеров и консьерж',
                inclusion4: 'Ежедневная уборка номера с вечерним включением',
                inclusion5: 'Доступ к бесконечному бассейну и аюрведическим спа-услугам',
                inclusion6: 'Бесплатная парковка и трансфер к близлежащим достопримечательностям',
                amenityGroup1Title: 'Особенности номера',
                amenityGroup1Item1: '41 кв.м площади',
                amenityGroup1Item2: 'Частный балкон с местами для сидения',
                amenityGroup1Item3: 'Кондиционер с климат-контролем',
                amenityGroup1Item4: 'Сейф в номере',
                amenityGroup2Title: 'Ванная комната',
                amenityGroup2Item1: 'Дождевой душ с горячей и холодной водой',
                amenityGroup2Item2: 'Премиальные банные принадлежности',
                amenityGroup2Item3: 'Фен',
                amenityGroup2Item4: 'Мягкие халаты и тапочки',
                amenityGroup3Title: 'Удобства в номере',
                amenityGroup3Item1: '55" Smart TV с кабельным ТВ',
                amenityGroup3Item2: 'Кофейная и чайная станция',
                amenityGroup3Item3: 'Телефон с прямым набором',
                amenityGroup4Title: 'Подключение',
                amenityGroup4Item1: 'Бесплатный Wi-Fi',
                amenityGroup4Item2: 'Рабочий стол',
                amenityGroup4Item3: 'Поддержка стойки регистрации 24/7',
                essentialsTitle: 'Основные удобства в номере',
                essentialsHeading: 'Все, что вам нужно, чтобы чувствовать себя как дома',
                essentialsDesc: 'От бесшовного подключения до тщательно подобранных напитков, номер Делюкс сочетает досуг и практичность, чтобы вы могли сосредоточиться на моментах, которые имеют значение.',
                essential1: 'Бесплатный Wi-Fi',
                essential2: 'Кофейная и чайная станция',
                essential3: 'Обслуживание номеров 24/7',
                essential4: 'Дождевой душ',
                oceanTitle: 'У океана',
                oceanSubtitle: 'Замедлитесь, вдохните морской воздух',
                oceanAlt: 'Зона отдыха в номере Делюкс',
                ctaTitle: 'Готовы остаться?',
                ctaHeading: 'Зарезервируйте номер Делюкс сегодня',
                ctaDesc: 'Поговорите с нашей командой по бронированию для получения лучших доступных цен и специальных предложений.',
                checkAvailability: 'Проверить доступность'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Комфорт с очаровательным прибрежным шармом',
                bookThisRoom: 'Забронировать этот номер',
                callReservations: 'Позвонить в бронирование',
                navAll: 'Все',
                navDeluxe: 'Делюкс',
                navDeluxeSeaView: 'Делюкс с видом на море',
                navSuite: 'Люкс',
                sectionTitle: 'Успокаивающее прибрежное убежище',
                sectionDesc: 'Люкс-номер разработан для неторопливых утр и неспешных закатов. Мягкие нейтральные тона, щедравая застекленность и продуманное освещение приглашают морской вид, в то время как балкон предлагает вам собственное место над береговой линией.',
                highlight1Title: 'Панорамный вид на пляж',
                highlight1Desc: 'Проснитесь с лазурной водой и золотыми восходами с вашего приватного балкона.',
                highlight2Title: 'Элегантные прибрежные интерьеры',
                highlight2Desc: 'Мягкие нейтральные палитры, теплые деревянные акценты и щедравое естественное освещение.',
                highlight3Title: 'Спокойный опыт сна',
                highlight3Desc: 'Мягкая кровать King Size с премиум-бельем для восстанавливающего отдыха.',
                atAGlance: 'На первый взгляд',
                statSize: 'Размер',
                statSizeValue: '41 кв.м',
                statView: 'Вид',
                statViewValue: 'Индийский океан',
                statGuests: 'Гости',
                statGuestsValue: '2 взрослых',
                statBed: 'Кровать',
                statBedValue: 'King или Twin',
                reserve: 'Забронировать',
                galleryAlt: 'Люкс-номер',
                inclusionsTitle: 'Включено в размещение',
                inclusionsSubtitle: 'Продуманные штрихи, комфорт весь день',
                enhancedCleanliness: 'Улучшенные стандарты чистоты и безопасности',
                inclusion1: 'Бесплатный завтрак, обед, ужин в ресторане Breeze',
                inclusion2: 'Высокоскоростной Wi-Fi и рабочее пространство в номере',
                inclusion3: 'Обслуживание номеров 24 часа и консьерж',
                inclusion4: 'Ежедневная уборка номера с закуской по вечерам',
                inclusion5: 'Доступ к бесконечному бассейну и спа-центру Аюрведы',
                inclusion6: 'Бесплатная парковка и трансферные услуги к близлежащим достопримечательностям',
                amenityGroup1Title: 'Особенности номера',
                amenityGroup1Item1: '41 кв.м пространства',
                amenityGroup1Item2: 'Приватный балкон с местом для отдыха',
                amenityGroup1Item3: 'Кондиционер с климат-контролем',
                amenityGroup1Item4: 'Сейф в номере',
                amenityGroup2Title: 'Опыт ванной комнаты',
                amenityGroup2Item1: 'Дождевоя лейка с горячей и холодной водой',
                amenityGroup2Item2: 'Премиум средства для ванной',
                amenityGroup2Item3: 'Фен',
                amenityGroup2Item4: 'Мягкие халаты и тапочки',
                amenityGroup3Title: 'Удобства в номере',
                amenityGroup3Item1: '55" Smart TV с кабельным ТВ',
                amenityGroup3Item2: 'Кофейная и чайная станция',
                amenityGroup3Item3: 'Телефон с прямым набором',
                amenityGroup4Title: 'Подключение',
                amenityGroup4Item1: 'Бесплатный Wi-Fi',
                amenityGroup4Item2: 'Рабочий стол',
                amenityGroup4Item3: 'Поддержка стойки регистрации 24/7',
                essentialsTitle: 'Основные удобства в номере',
                essentialsHeading: 'Все, что вам нужно, чтобы чувствовать себя как дома',
                essentialsDesc: 'От бесшовного подключения до тщательно подобранных напитков, люкс-номер сочетает досуг и практичность, чтобы вы могли сосредоточиться на моментах, которые имеют значение.',
                essential1: 'Бесплатный Wi-Fi',
                essential2: 'Кофейная и чайная станция',
                essential3: 'Обслуживание номеров 24/7',
                essential4: 'Дождевой душ',
                oceanTitle: 'У океана',
                oceanSubtitle: 'Замедлитесь, вдохните морской воздух',
                oceanAlt: 'Вид на океан',
                ctaTitle: 'Готовы остаться?',
                ctaHeading: 'Зарезервируйте люкс-номер сегодня',
                ctaDesc: 'Поговорите с нашей командой по бронированию для получения лучших доступных цен и специальных предложений.',
                checkAvailability: 'Проверить доступность'
            },
            deluxeSeaViewRoom: {
                resortName: 'Мутхумуни Ресорты',
                heroTitle: 'Люкс номер с видом на море',
                heroSubtitle: 'Погрузитесь в роскошь с захватывающим видом на морской горизонт',
                bookThisRoom: 'Забронировать номер',
                callReservations: 'Позвоните в отдел бронирования',
                navAll: 'Все номера',
                navDeluxe: 'Люкс номер',
                navDeluxeSeaView: 'Люкс номер с видом на море',
                navSuite: 'Люкс люкс-номер',
                sectionTitle: 'Откройте для себя роскошь',
                sectionDesc: 'Наши люкс номера с видом на море предлагают безупречное сочетание комфорта и elegance. Каждая комната тщательно разработана для предоставления непревзойденного опыта отдыха.',
                highlight1Title: 'Вид на частный пляж',
                highlight1Desc: 'Прямой доступ к нашему частному пляжу с белым песком',
                highlight2Title: 'Просторная просторная комната',
                highlight2Desc: '75 квадратных метров сказочного пространства для проживания',
                highlight3Title: 'Ванна на открытом воздухе',
                highlight3Desc: 'Попробуйте роскошное уединение под звездами',
                atAGlance: 'С первого взгляда',
                stat1Label: 'Размер',
                stat1Value: '75 кв. м.',
                stat2Label: 'Вид',
                stat2Value: 'Вид на море',
                stat3Label: 'Гости',
                stat3Value: '2 взрослых',
                stat4Label: 'Кровать',
                stat4Value: 'Король',
                reserve: 'Зарезервировать',
                galleryAlt: 'Роскошный люкс номер с видом на море',
                inclusionsTitle: 'Что входит',
                inclusionsSubtitle: 'Каждый номер включает',
                inclusion1: 'Завтрак у окна с видом на море',
                inclusion2: 'Приветственный напиток на закате',
                inclusion3: 'Ежедневное эспрессо-барное обслуживание',
                inclusion4: 'Безграничный доступ в спа',
                inclusion5: 'Приватный трансфер пляжа',
                inclusion6: 'Wi-Fi премиум-класса',
                enhancedCleanliness: 'Улучшенная уборка и протоколы безопасности',
                amenityGroup1Title: 'Спальня',
                amenityGroup1Item1: 'Автоматическое затемнение',
                amenityGroup1Item2: '100% хлопок премиум-класса',
                amenityGroup1Item3: 'Подушки разной жесткости',
                amenityGroup2Title: 'Ванная комната',
                amenityGroup2Item1: 'Косметика Bvlgari',
                amenityGroup2Item2: 'полы с подогревом',
                amenityGroup2Item3: 'Встроенная система SPA',
                amenityGroup3Title: 'Гостиная',
                amenityGroup3Item1: 'Спутниковое телевидение премиум-класса',
                amenityGroup3Item2: 'Полнофункциональная кухня',
                amenityGroup3Item3: 'Домашняя кинотеатр',
                amenityGroup4Title: 'На открытом воздухе',
                amenityGroup4Item1: 'Приватная терраса с джакузи',
                amenityGroup4Item2: 'Висячая кровать в стиле Баали',
                amenityGroup4Item3: 'Система автоматического орошения',
                essentialsTitle: 'Незаменимое',
                essentialsHeading: 'Ваши основные потребности в номере',
                essentialsDesc: 'Все необходимое в комнате',
                essential1: 'Мини-бар с премиум-напитками',
                essential2: 'Кофейная и чайная станция',
                essential3: 'Обслуживание номеров 24/7',
                essential4: 'Дождевой душ',
                oceanTitle: 'У океана',
                oceanSubtitle: 'Замедлитесь, вдохните морской воздух',
                oceanAlt: 'Вид на океан',
                ctaTitle: 'Готовы остаться?',
                ctaHeading: 'Зарезервируйте люкс номер с видом на море сегодня',
                ctaDesc: 'Поговорите с нашей командой по бронированию для получения лучших доступных цен и специальных предложений.',
                checkAvailability: 'Проверить доступность'
            }
        },

        navbar: {
            home: 'Главная',
            aboutUs: 'О нас',
            rooms: 'Номера',
            ayurveda: 'Аюрведа',
            yoga: 'Йога',
            food: 'Питание',
            events: 'События',
            blogs: 'Блог',
            tours: 'Туры',
            contactUs: 'Контакты',
            bookOnline: 'Забронировать онлайн',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Выбрать курорт',
            language: 'Язык',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Главная',
            aboutUs: 'О нас',
            rooms: 'Номера',
            ayurveda: 'Аюрведа',
            yoga: 'Йога',
            food: 'Питание',
            events: 'События',
            blogs: 'Блог',
            tours: 'Туры',
            contactUs: 'Контакты',
            bookOnline: 'Забронировать онлайн',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Выбрать курорт',
            language: 'Язык',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort стремится к исключительному гостеприимству и оздоровительным впечатлениям, чтобы каждый гость чувствовал заботу и восстановление.',
            linksTitle: 'Ссылки',
            contactTitle: 'Контакты',
            viewLocation: 'Посмотреть расположение',
            navHome: 'Главная',
            navAbout: 'О нас',
            navContact: 'Контакты',
            navRooms: 'Номера',
            navAyurveda: 'Аюрведа',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Разработано',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Туры и экскурсии',
            heroSubtitle: 'Откройте красоту Шри-Ланки из Берувалы',
            kandeAlt: 'Храм Канде Вихара - Берувала',
            kandeTitle: 'Посещение храма Канде Вихара',
            kandeBuddhaAlt: 'Гигантская статуя Будды в храме Канде Вихара',
            bentotaTitle: 'Речное сафари на реке Бентота',
            bentotaAlt: 'Речное сафари на реке Бентота - мангровые леса и дикая природа',
            galleTitle: 'Тур по старому городу Галле',
            galleAlt: 'Тур по старому городу Галле',
            sigiriyaTitle: 'Тур по скальной крепости Сигирия',
            sigiriyaAlt: 'Тур по скальной крепости Сигирия',
            kandyTitle: 'Культурный тур по Канди',
            kandyAlt: 'Культурный тур по Канди',
            bookTour: 'Забронировать этот тур',
            introPara1: 'Шри-Ланка — земля вечной красоты, где золотые пляжи, пышные зеленые ландшафты, древние храмы и яркая культура сходятся в идеальной гармонии.',
            introPara2: 'От спокойного юго-западного побережья до исторических городов, священных мест, заповедников дикой природы и туманных горных районов каждое путешествие предлагает уникальный и незабываемый опыт.',
            introPara3: 'Начиная с Muthumuni Ayurveda Beach Resort в Берувале, наши тщательно подобранные туры и экскурсии разработаны для обогащения вашего пребывания, идеально балансируя исследование, релаксацию и оздоровление.',
            kandeDetail1: 'Храм Канде Вихара (Канде Вихарая) — один из самых культовых буддийских храмов рядом с Берувалой.',
            kandeDetail2: 'Основанный в 1734 году, этот спокойный \'Горный храм\' расположен на холме с мирными видами на побережье.',
            kandeDetail3: 'Достопримечательности включают массивную статую сидящего Будды высотой 48 метров (одна из самых высоких на Шри-Ланке), замысловатые фрески эпохи Канди, древнюю камеру для святых мощей, прекрасный лунный камень и священное дерево Бодхи, возраст которого превышает 300 лет.',
            kandeDetail4: 'Идеальный духовный и культурный опыт на полдня — лучше всего посещать утром, чтобы избежать жары.',
            bentotaDetail1: 'Насладитесь спокойным и живописным речным сафари по реке Бентота, одной из самых популярных природных экскурсий рядом с Берувалой.',
            bentotaDetail2: 'Скользите по пышным мангровым лесам, узким каналам и спокойным водам, наблюдая за дикой природой.',
            bentotaDetail3: 'Обычные наблюдения включают ящериц-мониторов, крокодилов, различные виды птиц (зимородки, цапли, орлы), обезьян и иногда выдр или водяных змей.',
            bentotaDetail4: 'Опытный лодочник/гид укажет вам интересную флору, традиционные способы рыболовства и жизнь в деревнях на берегу реки.',
            bentotaDetail5: 'Идеально для любителей природы и фотографов — спокойно, расслабляюще и дополняет ваш оздоровительный аюрведический отдых.',
            galleDetail1: 'Исследуйте историческую крепость Галле, объект всемирного наследия ЮНЕСКО и одну из лучше всего сохранившихся колониальных крепостей Шри-Ланки.',
            galleDetail2: 'Прогулянитесь по брусчатым улицам с голландскими колониальными зданиями, бутиками, кафе и художественными галереями.',
            galleDetail3: 'Посетите ключевые достопримечательности, такие как маяк Галле, голландская реформатская церковь, национальный морской музей и валы с потрясающим видом на океан.',
            galleDetail4: 'Узнайте о богатой истории, архитектуре и культурном значении крепости от вашего знающего гида.',
            galleDetail5: 'Идеально для любителей истории, поклонников культуры и тех, кто хочет ощутить колониальное прошлое Шри-Ланки.',
            sigiriyaDetail1: 'Откройте для себя древнюю скальную крепость Сигирия, одну из самых культовых достопримечательностей Шри-Ланки и объект всемирного наследия ЮНЕСКО.',
            sigiriyaDetail2: 'Взберитесь на впечатляющую скалу и исследуйте руины дворца царя Кашьяпы, украшенные фресками, водными садами и знаменитой Зеркальной стеной.',
            sigiriyaDetail3: 'Наслаждайтесь панорамными видами на окружающие джунгли и сельскую местность с вершины.',
            sigiriyaDetail4: 'Узнайте о увлекательной истории, архитектуре и легендах, связанных с Сигирией, от вашего опытного гида.',
            sigiriyaDetail5: 'Идеально для любителей истории, искателей приключений и тех, кто интересуется богатым культурным наследием Шри-Ланки.',
            kandyDetail1: 'Испытайте яркую культуру Канди, последнюю королевскую столицу Шри-Ланки и объект всемирного наследия ЮНЕСКО.',
            kandyDetail2: 'Посетите храм Святого Зуба Реликвии (Шри Далада Малигава), одно из самых важных буддийских мест в мире.',
            kandyDetail3: 'Исследуйте Королевские ботанические сады в Перадении с обширной коллекцией тропических растений и орхидей.',
            kandyDetail4: 'Насладитесь традиционным кандийским танцевальным представлением, демонстрирующим богатое художественное наследие Шри-Ланки.',
            kandyDetail5: 'Идеально для поклонников культуры, любителей истории и тех, кто хочет погрузиться в традиции Шри-Ланки.'
        },
        blogs: {
            heroTitle: 'Блоги Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Истории с побережья, ритуалы Аюрведы в',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Погрузитесь в советы, историю и заметки за кулисами.',
            heroAlt: 'Пляжная дорожка курорта на закате',
            sectionTitle: 'Блоги Muthumuni Ayurveda Beach Resort',
            sectionDescription: 'Гиды, истории и заметки из нашего прибрежного убежища — от ритуалов Аюрведы до истории драгоценных камней и советов по путешествиям в окрестностях Бентоты.',
            ayurvedaTitle: 'Сердце аутентичной Аюрведы',
            ayurvedaExcerpt: 'Испытайте вековые традиции исцеления, укорененные в древней мудрости Шри-Ланки.',
            ayurvedaDescription: 'В Muthumuni Ayurveda Beach Resort Аюрведа — это больше, чем лечение, это образ жизни. Наши терапии основаны на многовековых знаниях, персонализированы под ваш тип тела и проводятся опытными аюрведическими врачами для глубокого и устойчивого баланса.',
            ayurvedaAlt: 'Установка аюрведического лечения с травяными маслами и натуральными элементами',
            healingTitle: 'Персонализированные путешествия исцеления',
            healingExcerpt: 'Почему оздоровительная программа каждого гостя уникально разработана.',
            healingDescription: 'От первичной консультации до ежедневных процедур ваше путешествие исцеления тщательно адаптировано. Травяные терапии, терапевтические массажи, йога и медитация работают вместе, чтобы восстановить гармонию между телом, разумом и духом.',
            healingAlt: 'Аюрведический врач консультирует гостя в спокойной обстановке',
            natureTitle: 'Исцеление у океана',
            natureExcerpt: 'Как морской бриз и тропическое окружение усиливают ваше благополучие.',
            natureDescription: 'Расположенный вдоль спокойного побережья Шри-Ланки, Muthumuni предлагает естественную исцеляющую среду. Звук волн, свежий океанский воздух и пышная зелень усиливают эффекты Аюрведы, создавая глубокое расслабление и обновление.',
            natureAlt: 'Вид на пляж курорта с пальмами и океаном',
            foodTitle: 'Аюрведическая кухня для внутреннего баланса',
            foodExcerpt: 'Питательные блюда, созданные для поддержки вашего лечения.',
            foodDescription: 'Наша аюрведическая кухня свежеприготовлена с использованием сезонных, местных ингредиентов. Каждое блюдо соответствует вашей доше, поддерживая пищеварение, детоксикацию и общую жизненную силу, оставаясь при этом вкусным и сытным.',
            foodAlt: 'Традиционное аюрведическое блюдо, поданное в натуральных мисках',
            yogaTitle: 'Йога, медитация и внутренний покой',
            yogaExcerpt: 'Мягкие практики, которые успокаивают ум и укрепляют тело.',
            yogaDescription: 'Ежедневные занятия йогой и медитацией дополняют ваши процедуры, улучшая гибкость, дыхание и ясность ума. Эти осознанные практики помогают вам снова соединиться с собой и сохранить чувство покоя за пределами вашего пребывания.',
            yogaAlt: 'Гости практикуют йогу с видом на океан на рассвете',
            lifestyleTitle: 'Принести Аюрведу домой',
            lifestyleExcerpt: 'Простые практики образа жизни для продолжения вашего оздоровительного путешествия.',
            lifestyleDescription: 'Перед отъездом наши эксперты проконсультируют вас о поддержании баланса с помощью ежедневных рутин, диеты и ритуалов самообслуживания. Заберите домой больше, чем воспоминания — заберите устойчивый путь к более здоровой жизни.',
            lifestyleAlt: 'Гость расслабляется с травяным чаем в безмятежной обстановке курорта',
            readMore: 'Читать далее'
        },
        events: {
            heroEyebrow: 'Впечатления и активности',
            heroTitle: 'Наши события',
            heroSubtitle: 'Курируемые впечатления, соединяющие традиции Шри-Ланки с прибрежной роскошью',
            heroAlt: 'События в Muthumuni',
            availableDaily: 'Доступно ежедневно',
            bookNow: 'Забронировать',
            highlightsTitle: 'Основные моменты',
            detailAlt: '{{title}} — деталь',
            ctaTitle: 'Готовы создать воспоминания?',
            ctaDescription: 'Свяжитесь с нашей командой, чтобы создать идеальный формат вашего события в Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Связаться с нами',
            ctaViewRooms: 'Посмотреть номера',
            cookeryTitle: 'Кулинарные программы',
            cookerySubtitle: 'Вкус Шри-Ланки',
            cookeryDescription: 'Погрузитесь в яркие вкусы шри-ланкийской кухни. Наши опытные шеф-повара проводят практические занятия, обучая традиционным рецептам, передаваемым из поколения в поколение. Научитесь готовить ароматные карри, хопперы, кокосовый самбол и многое другое из свежих местных ингредиентов.',
            cookeryHighlight1: 'Традиционные рецепты Шри-Ланки',
            cookeryHighlight2: 'Практический кулинарный опыт',
            cookeryHighlight3: 'Свежие местные ингредиенты',
            cookeryHighlight4: 'Заберите рецепты домой',
            cookeryHighlight5: 'Экскурсия в сад специй включена',
            meditationTitle: 'Программы медитации',
            meditationSubtitle: 'Внутренний покой и осознанность',
            meditationDescription: 'Найдите спокойствие на наших сеансах медитации на фоне умиротворяющего Индийского океана. Опытные инструкторы проводят вас через древние техники осознанности, дыхательные упражнения и практики йоги, созданные для успокоения ума и обновления духа.',
            meditationHighlight1: 'Сеансы на рассвете и закате',
            meditationHighlight2: 'Медитация у моря',
            meditationHighlight3: 'Под руководством экспертов',
            meditationHighlight4: 'Дыхательные техники',
            meditationHighlight5: 'Практики йоги и осознанности',
            bbqTitle: 'BBQ-вечеринки',
            bbqSubtitle: 'Пляжные праздники',
            bbqDescription: 'Проведите незабываемые вечера на наших пляжных BBQ-вечеринках. Наслаждайтесь свежими морепродуктами на гриле, премиальными мясными блюдами и вегетарианскими угощениями, пока рядом шепчут волны. Живая музыка, танцоры с огнем и звездное небо создают идеальную атмосферу для праздника и общения.',
            bbqHighlight1: 'Свежие морепродукты на гриле',
            bbqHighlight2: 'Ужин у океана',
            bbqHighlight3: 'Живая музыка',
            bbqHighlight4: 'Опыт у костра',
            bbqHighlight5: 'Настраиваемые меню',
            boatTitle: 'Прогулки на лодке',
            boatSubtitle: 'Речные и прибрежные приключения',
            boatDescription: 'Отправьтесь в очаровательные путешествия по реке Бентота и прибрежным водам. Скользите через мангровые леса, наблюдайте экзотических птиц и животных или наслаждайтесь романтическими закатными круизами. Наши прогулки на лодке открывают уникальный взгляд на природную красоту и экосистемы Шри-Ланки.',
            boatHighlight1: 'Круизы по реке Бентота',
            boatHighlight2: 'Исследование мангров',
            boatHighlight3: 'Наблюдение за дикой природой',
            boatHighlight4: 'Закатные туры на лодке',
            boatHighlight5: 'Доступна частная аренда',
            ayurvedaLecturesTitle: 'Лекции врачей по аюрведе',
            ayurvedaLecturesSubtitle: 'Древняя мудрость и современное благополучие',
            ayurvedaLecturesDescription: 'Откройте глубокие принципы аюрведы на лекциях, проводимых сертифицированными врачами и практиками. Узнайте о балансировке дош, травяных средствах, холистических практиках исцеления и о том, как древняя мудрость применима к современному благополучию. Наши интерактивные сессии проясняют философию аюрведы и её применение в повседневной жизни.',
            ayurvedaLecturesHighlight1: 'Сертифицированные врачи аюрведы',
            ayurvedaLecturesHighlight2: 'Персональный анализ доши',
            ayurvedaLecturesHighlight3: 'Обучение травяным средствам',
            ayurvedaLecturesHighlight4: 'Сессии вопросов и ответов',
            ayurvedaLecturesHighlight5: 'Памятка по оздоровлению с собой',
            traditionalClothsTitle: 'Мероприятия по ношению традиционной одежды',
            traditionalClothsSubtitle: 'Опыт культурного наследия',
            traditionalClothsDescription: 'Погрузитесь в культурное наследие Шри-Ланки, изучая традиционную одежду. Наши стилисты покажут, как носить аутентичные кандийские сари и традиционные наряды, объясняя культурное значение каждого элемента. Идеально для особых случаев, культурного знакомства или памятных фотографий.',
            traditionalClothsHighlight1: 'Профессиональные советы по стилю',
            traditionalClothsHighlight2: 'Аутентичные традиционные сари',
            traditionalClothsHighlight3: 'Объяснение культурного значения',
            traditionalClothsHighlight4: 'Профессиональная фотосъёмка включена',
            traditionalClothsHighlight5: 'Мастер-классы по фьюжн-стилю'
        },
        food: {
            heroTitle: 'Аюрведическое питание и прибрежная кухня',
            heroSubtitle: 'Аутентичные шри-ланкийские вкусы и свежая прибрежная кухня',
            heroAlt: 'Кулинарный опыт на пляжном курорте Muthumuni',
            wellnessEyebrow: 'Здоровье через пищу',
            wellnessTitle: 'Значение',
            ayurvedicFood: 'аюрведической пищи',
            wellnessIntro1: 'В аюрведе пища считается величайшей медициной. То, что вы едите, непосредственно влияет на ваши доши (Вата, Питта, Капха), пищеварение (агни) и общий баланс тела, ума и духа.',
            wellnessIntro2: 'Аюрведическое питание подчеркивает свежие, сезонные, цельные продукты, приготовленные с заботой и внимательным питанием. Оно поощряет шесть вкусов (сладкий, кислый, соленый, пикантный, горький, вяжущий) в каждом блюде для питания всех чувств и поддержания гармонии.',
            wellnessIntro3: 'Правильная аюрведическая пища поддерживает сильное пищеварение, помогает удалять токсины (ама), повышает иммунитет, улучшает энергию, снижает стресс и предотвращает многие хронические заболевания. В Muthumuni каждое блюдо тщательно готовится в соответствии с вашей уникальной конституцией для глубокого исцеления и жизненной силы.',
            foodImage1Alt: 'Традиционный аюрведический прием пищи с шестью вкусами',
            foodImage2Alt: 'Аюрведические травы и специи для сбалансированного питания',
            culinaryPhilosophyEyebrow: 'Наша кулинарная философия',
            culinaryPhilosophyTitle: 'Аюрведическое',
            nutritionHighlight: 'питание',
            culinaryPhilosophyResort: 'в Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Аюрведическая кухня в Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Свежее и питательное',
            healingIngredientsAlt: 'Здоровые аюрведические ингредиенты и специи',
            healingIngredientsLabel: 'Целебные ингредиенты',
            philosophyText1: 'Пища, которая включает в себя шесть основных вкусов (сладкий, кислый, соленый, горький, пикантный и вяжущий) с множеством тонких вариаций, была описана в классических аюрведических текстах — некоторые датируются более 5000 лет назад — вместе с существенными свойствами каждой пищи: Гуна (врожденное качество), Вирья (потенция/тепло или охлаждение), Випака (постпищеварительное воздействие) и Прабхава (уникальное специальное действие).',
            philosophyText2: 'В результате аюрведическое питание играет центральную роль в Muthumuni Ayurveda Beach Resort. Это не означает жесткий, однообразный режим пресных, безвкусных или чрезмерно горьких вегетарианских блюд, предписанных исключительно врачами. Напротив, наша аюрведическая кухня является одной из наших величайших сильных сторон: блюда, приготовленные нашими опытными поварами, будут удивлять и радовать вас каждый день вашего пребывания!',
            philosophyText3: 'На завтрак вы получите обильный буфет с свежими тропическими фруктами, свежевыжатыми соками, питательными травяными супами, домашним хлебом и легким печеньем, а также разнообразными аутентичными шри-ланкийскими вариантами завтрака. На обед насладитесь красочным и ароматным буфетом с мягкими рыбными карри, овощными блюдами и травяными блюдами. Вечером мы подаем установленное вегетарианское меню с опцией свежей рыбы. По субботам мы отмечаем «ночь Шри-Ланки» с расширенным буфетом — наши повара готовят традиционные местные специалитеты прямо перед вами, создавая оживленный и аутентичный опыт.',
            philosophyText4: 'В аюрведе пищевые продукты и напитки классифицируются множеством способов — по вкусу и свойствам, пищеварительной способности организма (агни), пригодности для конкретных состояний здоровья, сезонной уместности и многому другому. В Muthumuni мы тщательно учитываем все эти факторы одновременно, сознательно стремясь включить все шесть вкусов в сбалансированные комбинации, адаптированные к индивидуальной конституции каждого гостя.',
            philosophyText5: 'Наши блюда включают свежие овощи, тропические фрукты и ответственно добытую рыбу. Мы не подаем красное мясо или алкоголь.',
            philosophyText6: 'Во время приема пищи аюрведический врач или квалифицированный диетолог всегда готов помочь вам. Они посоветуют вам наиболее подходящие овощи, травы и специи для вашего текущего этапа лечения и помогут вам выбирать или избегать блюд соответственно. Ваш персональный травяной эликсир и любые конкретные инструкции от команды центра здоровья будут размещены на вашем индивидуальном столе.',
            philosophyText7: 'Этот уровень личной заботы и внимания к диете является отличительной чертой опыта Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Пища рассматривается как Прана — жизненная энергия, поддерживающая жизнь — для каждого человека. Вот почему мы поощряем вас подходить к каждому приему пищи с полным осознанием: наслаждаясь ароматами, переживая вкусы, ощущая мягкое тепло и наслаждаясь ароматными ощущениями внимательно.',
            diningExperienceEyebrow: 'Опыт питания',
            restaurantTitlePrefix: 'Наш',
            ayurvedicHighlight: 'аюрведический',
            restaurantTitleSuffix: 'ресторан',
            restaurantDetail1: 'Наш аюрведический ресторан на пляжном курорте Muthumuni предлагает уникальный опыт питания, который гармонирует традиционные аюрведические принципы с аутентичной шри-ланкийской прибрежной кухней. Мы уделяем приоритет свежим, местным ингредиентам для создания блюд, которые не только радуют небо, но и способствуют целостному благополучию.',
            restaurantDetail2: 'Меню тщательно разработано для поддержания баланса шести вкусов (сладкий, кислый, соленый, горький, пикантный и вяжущий) в каждом блюде, обеспечивая питательный и удовлетворительный опыт. Каждое блюдо готовится с заботой, включая аюрведические травы и специи, известные своими целебными свойствами.',
            restaurantDetail3: 'Гости могут наслаждаться разнообразными блюдами, адаптированными к их индивидуальным дошам (типам телосложения), с вариантами для вегетарианской, веганской и пескетарианской диет. Наши повара тесно сотрудничают с практикующими аюрведистами, чтобы гарантировать, что каждое блюдо поддерживает цели здоровья и благополучия гостей.',
            restaurantDetail4: 'Атмосфера ресторана отражает спокойную прибрежную среду, предоставляя безмятежную обстановку для внимательного питания. Независимо от того, наслаждаетесь ли вы обильным завтраком в буфете или смакуете гурманский ужин, каждый прием пищи в нашем аюрведическом ресторане — это возможность питать тело и душу.',
            restaurantDetail5: 'Присоединяйтесь к нам в аюрведическом ресторане Muthumuni Beach Resort в кулинарном путешествии, которое отмечает богатые вкусы Шри-Ланки при одновременном принятии безвременной мудрости Аюрведы.',
            restaurantImageAlt: 'Ужин в Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Премиум-обеды',
            premiumDiningDescription: 'Испытайте аутентичную аюрведическую кухню в спокойной речной обстановке'
        },
        yoga: {
            heroTitle: 'Йога на курорте',
            heroSubtitle: 'Найдите баланс, силу и внутренний покой в Берувале',
            heroAlt: 'Йога в Muthumuni Beach Resort',
            importanceEyebrow: 'Здоровье и баланс',
            importanceTitle: 'Значение йоги и медитации',
            importanceImageAlt: 'Значение йоги и медитации',
            importanceText1: 'Йога и медитация — древние практики, дающие множество физических, ментальных и эмоциональных преимуществ. Они развивают гибкость, силу и баланс, снижая стресс и тревожность.',
            importanceText2: 'Регулярная практика улучшает концентрацию, качество сна и общее самочувствие. Йога также развивает осознанность, помогая человеку соединиться с внутренним «я» и найти спокойствие среди повседневной суеты.',
            importanceText3: 'В Muthumuni Beach Resort мы создаем спокойную среду, идеально подходящую для йоги и медитации, чтобы гости могли восстановить ум, тело и дух.',
            practiceEyebrow: 'Наша практика',
            practiceTitle: 'Практика йоги и опыт',
            practiceImageAlt: 'Практика йоги на курорте',
            practiceText1: 'В Muthumuni Ayurveda Beach Resort йога практикуется преимущественно как традиционная хатха-йога в сочетании с пранаямой (дыхательными техниками). Этот целостный подход направлен на пробуждение внутреннего осознания и мягкую стимуляцию кундалини (часто называемой «третьим глазом»). Особое внимание уделяется выравниванию позвоночника и гибкости, поскольку считается, что гибкий позвоночник замедляет старение — «Вы настолько молоды, насколько молод ваш позвоночник».',
            practiceText2: 'Занятия проводятся четыре раза в неделю и подходят как новичкам, так и опытным практикам. Время от времени вводятся специальные сессии, такие как аштанга-йога, позволяя гостям попробовать разнообразные позы и последовательности. Наши аюрведические врачи поощряют регулярное участие для поддержки и усиления общей программы лечения.',
            practiceText3: 'Все занятия проходят в нашей Yoga Shala — спокойном и гармоничном пространстве, созданном для концентрации, баланса и осознанного движения. Каждая сессия обычно начинается с «Приветствия Солнцу», затем следует пранаяма и последовательность тщательно отобранных асан для улучшения гибкости, кровообращения и общего самочувствия.',
            practiceText4: 'Наши опытные преподаватели йоги адаптируют каждую сессию под индивидуальные потребности, способности и состояние здоровья гостей, обеспечивая безопасный, поддерживающий и глубоко полезный опыт для каждого.',
            spiritualEyebrow: 'Духовное путешествие',
            spiritualTitle: 'Медитация и духовные практики',
            spiritualSubtitle: 'Углубите духовную практику с нашими священными церемониями и сеансами управляемой медитации',
            meditationImageAlt: 'Медитация и духовная практика на курорте',
            meditationTitle: 'Сеансы медитации',
            meditationDesc: 'Гости приглашаются на управляемые медитационные сессии, проходящие три раза в неделю и вдохновленные буддийскими традициями. Эти занятия предназначены для успокоения ума, углубления осознанности и поддержки эмоционального и духовного исцеления. Медитации проходят в тихом храме на острове, до которого гости добираются на лодке — это добавляет особое чувство спокойствия и значимости, усиливая общий медитативный опыт.'
        },
        contact: {
            heroTitle: 'Свяжитесь с нами',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Свяжитесь с нами',
            sectionTitle: 'Свяжитесь с нами в любое время',
            sectionSubtitle: 'Мы поможем вам расслабиться и восстановиться',
            sectionDescription: 'Свяжитесь с Muthumuni Ayurveda Beach Resort по вопросам Ayurveda-программ, оздоровительных пакетов, бронирований или любых вопросов во время вашего пребывания в Берувале, Морагалла.',
            callUs: 'Позвоните нам',
            emailTitle: 'Эл. почта',
            ourLocation: 'Наш адрес',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Социальные сети',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Связаться',
            getInTouchDescription: 'Мы будем рады вашему сообщению — наша команда готова помочь с вашим wellness-путешествием, ответить на вопросы и спланировать отдых.',
            nameLabel: 'Имя',
            emailLabel: 'Эл. почта',
            contactNumberLabel: 'Телефон',
            messageLabel: 'Сообщение',
            sending: 'Отправка...',
            sendMessage: 'Отправить сообщение',
            successMessage: 'Ваше сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.',
            errorMessage: 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.',
            findUsOnMap: 'Найдите нас на карте',
            whatsappSubject: 'Контакт Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Имя',
            whatsappEmail: 'Эл. почта',
            whatsappContactNumber: 'Телефон',
            whatsappMessage: 'Сообщение'
        },

        contact2: {
            heroTitle: 'Свяжитесь с нами',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Свяжитесь с нами',
            sectionTitle: 'Свяжитесь с нами в любое время',
            sectionSubtitle: 'Мы поможем вам расслабиться и восстановиться',
            sectionDescription: 'Свяжитесь с Muthumuni Ayurveda Beach Resort по вопросам Ayurveda-программ, оздоровительных пакетов, бронирований или любых вопросов во время вашего пребывания в Берувале, Морагалла.',
            callUs: 'Позвоните нам',
            emailTitle: 'Эл. почта',
            ourLocation: 'Наш адрес',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Социальные сети',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Связаться',
            getInTouchDescription: 'Мы будем рады вашему сообщению — наша команда готова помочь с вашим wellness-путешествием, ответить на вопросы и спланировать отдых.',
            nameLabel: 'Имя',
            emailLabel: 'Эл. почта',
            contactNumberLabel: 'Телефон',
            messageLabel: 'Сообщение',
            sending: 'Отправка...',
            sendMessage: 'Отправить сообщение',
            successMessage: 'Ваше сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.',
            errorMessage: 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.',
            findUsOnMap: 'Найдите нас на карте',
            whatsappSubject: 'Контакт Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Имя',
            whatsappEmail: 'Эл. почта',
            whatsappContactNumber: 'Телефон',
            whatsappMessage: 'Сообщение'
        },

        ayurveda: {
            accordionTitle1: 'Что такое Панчакарма Аюрведа?',
            accordionDesc1: 'Аюрведа - одна из старейших систем исцеления в мире, разработанная более 5000 лет назад. Панчакарма Аюрведа основана на убеждении, что здоровье зависит от баланса между разумом, телом, духом и окружающей средой.',
            accordionTitle2: 'Панчакарма Аюрведа и жизненная энергия',
            accordionDesc2: 'Аюрведа основана на теории взаимосвязи всего во вселенной. Те, кто практикует Аюрведу, верят, что каждый человек состоит из пяти элементов: пространство, воздух, огонь, вода и земля. Они образуют три доши: ВАТА, ПИТТА и КАПХА.',
            accordionTitle3: 'Вата Доша',
            accordionDesc3: 'Самая мощная доша, контролирующая основные функции организма: деление клеток, дыхание, кровоток, работу сердца. При доминировании Вата вы умны, творческие, энергичны. При дисбалансе - тревога. Баланс через медитацию, массаж и теплую пищу.',
            accordionTitle4: 'Питта Доша',
            accordionDesc4: 'Контролирует пищеварение, метаболизм и гормоны. При доминировании Питта вы целеустремлены, конкурентоспособны, уверены. При дисбалансе - раздражительность. Баланс через охлаждающую пищу и медленную йогу.',
            accordionTitle5: 'Капха Доша',
            accordionDesc5: 'Контролирует рост мышц, силу тела и иммунитет. При доминировании Капха вы любите рутину, спокойны и терпеливы. При дисбалансе - усталость и набор веса. Баланс через фрукты, овощи и упражнения.',
            close: 'Закрыть',
            next: 'Далее',
            previous: 'Назад',
            treatmentsTitle: 'Наши фирменные процедуры Панчакарма Аюрведы',
            treatmentsSubtitle: 'Испытайте проверенные временем терапии для восстановления баланса, снятия напряжения и омоложения.',
            bookTreatment: 'Забронировать процедуру',
            benefitsTitle: 'Преимущества процедур Панчакарма',
            shirodhara: 'Широдхара',
            shirodharaDesc: 'Мягкое поливание теплым травяным маслом на лоб для успокоения ума.',
            shirodhara1: 'Снижает стресс и тревогу',
            shirodhara2: 'Улучшает сон',
            shirodhara3: 'Повышает ясность ума',
            steamBath: 'Паровая баня',
            steamBathDesc: 'Детоксикационная паровая процедура для открытия пор и расслабления мышц.',
            steamBath1: 'Очищает организм',
            steamBath2: 'Улучшает кровообращение',
            steamBath3: 'Снимает мышечное напряжение',
            flowerBath: 'Цветочная ванна',
            flowerBathDesc: 'Успокаивающая ванна с ароматными цветами для расслабления.',
            flowerBath1: 'Успокаивает нервную систему',
            flowerBath2: 'Увлажняет кожу',
            flowerBath3: 'Поднимает настроение',
            headMassage: 'Массаж головы',
            headMassageDesc: 'Расслабляющий массаж кожи головы для снятия напряжения.',
            headMassage1: 'Уменьшает головные боли',
            headMassage2: 'Улучшает здоровье кожи головы',
            headMassage3: 'Способствует расслаблению',
            faceMassage: 'Массаж лица',
            faceMassageDesc: 'Омолаживающий массаж для улучшения сияния лица и снижения стресса.',
            faceMassage1: 'Улучшает тон кожи',
            faceMassage2: 'Снимает лицевое напряжение',
            faceMassage3: 'Способствует лимфодренажу',
            neckMassage: 'Массаж шеи',
            neckMassageDesc: 'Целенаправленный массаж для снятия скованности и напряжения шеи.',
            neckMassage1: 'Снимает боль в шее',
            neckMassage2: 'Улучшает гибкость',
            neckMassage3: 'Снижает стресс',
            shoulderMassage: 'Массаж плеч',
            shoulderMassageDesc: 'Целевой массаж для облегчения скованности и дискомфорта в плечах.',
            shoulderMassage1: 'Уменьшает боль в плечах',
            shoulderMassage2: 'Улучшает осанку',
            shoulderMassage3: 'Расслабляет мышцы',
            bodyMassage: 'Массаж всего тела',
            bodyMassageDesc: 'Массаж всего тела для общего расслабления и оздоровления.',
            bodyMassage1: 'Улучшает кровообращение',
            bodyMassage2: 'Снимает мышечную боль',
            bodyMassage3: 'Способствует расслаблению',
            backMassage: 'Массаж спины',
            backMassageDesc: 'Терапевтический массаж для лечения боли и напряжения в спине.',
            backMassage1: 'Облегчает боль в спине',
            backMassage2: 'Улучшает здоровье позвоночника',
            backMassage3: 'Снижает стресс',
            footMassage: 'Массаж стоп',
            footMassageDesc: 'Успокаивающий массаж для снятия боли в стопах и расслабления.',
            footMassage1: 'Улучшает кровообращение',
            footMassage2: 'Уменьшает усталость ног',
            footMassage3: 'Способствует расслаблению',
            purgative: 'Слабительное',
            purgativeDesc: 'Очищающая терапия для выведения избыточной Питты и токсинов из пищеварительной системы.',
            purgative1: 'Очищает толстую кишку',
            purgative2: 'Балансирует дошу Питта',
            purgative3: 'Улучшает здоровье пищеварения',
            nasalClearing: 'Очищение носа',
            nasalClearingDesc: 'Терапевтическая процедура для носа для очищения пазух и улучшения дыхания.',
            nasalClearing1: 'Устраняет заложенность носа',
            nasalClearing2: 'Улучшает дыхание',
            nasalClearing3: 'Облегчает проблемы с пазухами',
            powderMassage: 'Порошковый массаж',
            powderMassageDesc: 'Отшелушивающий массаж с травяными порошками для омоложения и освежения кожи.',
            powderMassage1: 'Удаляет мертвую кожу',
            powderMassage2: 'Улучшает текстуру кожи',
            powderMassage3: 'Способствует кровообращению',
            intensiveMassageDesc: 'Глубокий терапевтический массаж, направленный на хроническое напряжение и мышечные узлы с сильным давлением и специальными техниками.',
            intensiveMassage1: 'Снимает глубокое мышечное напряжение',
            intensiveMassage2: 'Улучшает кровообращение',
            intensiveMassage3: 'Уменьшает мышечную боль',
            thermoMassage: 'Термо-массаж',
            thermoMassageDesc: 'Тёплый массаж с травяным маслом с использованием подогретых терапевтических масел для усиления расслабления и целебного эффекта.',
            thermoMassage1: 'Успокаивает больные мышцы',
            thermoMassage2: 'Способствует глубокому расслаблению',
            thermoMassage3: 'Улучшает течение энергии',
            synchronMassage: 'Синхронный массаж',
            synchronMassageDesc: 'Синхронизированный массаж двумя терапевтами для полной гармонии тела и сбалансированного распределения энергии.',
            synchronMassage1: 'Полная гармония тела',
            synchronMassage2: 'Сбалансированный поток энергии',
            synchronMassage3: 'Глубокий расслабляющий опыт',
            specialMassage: 'Специальный массаж',
            specialMassageDesc: 'Индивидуальная массажная терапия, адаптированная под ваши конкретные потребности в здоровье и личные цели оздоровления.',
            specialMassage1: 'Персонализированное лечение',
            specialMassage2: 'Направлено на конкретные проблемы',
            specialMassage3: 'Индивидуальный подход к исцелению',
            benefit1Title: 'Детоксикация:',
            benefit1Desc: 'Процедуры Панчакарма помогают выводить токсины из организма, улучшая здоровье и жизненную силу.',
            benefit2Title: 'Улучшенное пищеварение:',
            benefit2Desc: 'Эти терапии улучшают пищеварительную функцию для лучшего усвоения питательных веществ и метаболизма.',
            benefit3Title: 'Снятие стресса:',
            benefit3Desc: 'Панчакарма известна успокаивающим эффектом на тело и ум, снижая уровень стресса и тревоги.',
            benefit4Title: 'Укрепление иммунитета:',
            benefit4Desc: 'Регулярные процедуры Панчакарма укрепляют иммунную систему, делая тело более устойчивым к болезням.',
            benefit5Title: 'Омоложение:',
            benefit5Desc: 'Терапии способствуют регенерации клеток для улучшения здоровья кожи и молодого вида.',
            benefit6Title: 'Баланс дош:',
            benefit6Desc: 'Панчакарма помогает восстановить баланс дош (Вата, Питта, Капха), что необходимо для здоровья согласно аюрведе.',
            akkupancharTitle: 'Терапия Аккупанчар',
            akkupancharDesc1: 'древняя аюрведическая терапия с использованием травяных паст и масел на специфических точках тела. Эта процедура стимулирует энергетические каналы и способствует исцелению.',
            akkupancharBenefit: 'Ключевые преимущества:',
            akkupancharDesc2: 'Эта специализированная терапия помогает при хронической боли, улучшает гибкость суставов, кровообращение и восстанавливает естественный поток энергии.',
            akkupancharApplication: 'Терапевтическое применение:',
            akkupancharDesc3: 'Аккупанчар воздействует на специфические точки марма с тщательно подобранными травяными препаратами для баланса дош.',
            akkupancharTransform: 'Испытайте трансформацию:',
            akkupancharDesc4: 'В Muthumuni Ayurveda Beach Resort наши опытные специалисты настраивают каждую сессию под ваши уникальные потребности.',
            gallery1: 'Терапия Широдхара',
            gallery2: 'Паровая баня',
            gallery3: 'Цветочная ванна',
            gallery4: 'Массаж головы',
            gallery5: 'Массаж тела',
            gallery6: 'Массаж шеи',
            gallery7: 'Массаж лица',
            gallery8: 'Массаж плеч',
            heroTitle: 'Панчакарма Аюрведа',
            heroSubtitle: 'Омолодите тело, ум и дух в Берувале',
            sectionEyebrow: 'ПАНЧАКАРМА АЮРВЕДА В MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Откройте для себя древнее исцеляющее искусство Панчакармы в курортном центре Ayurveda Beach Resort в Берувале. Наши опытные практикующие врачи предлагают персонализированные процедуры для детоксикации, омоложения и восстановления баланса.',
            treatmentProgramme: {
                title: 'Программа аюрведического лечения',
                subtitle: 'Ваш путь к равновесию, детоксикации и глубокому обновлению',
                intro: 'Испытайте подлинное аюрведическое исцеление в спокойном центре, предназначенном для восстановления вашего тела, успокоения ума и восстановления вашей энергии. С момента вашего прибытия наша команда позаботится о каждой детали – чтобы вы могли полностью сосредоточиться на своем благополучии.',
                welcomeTitle: 'Добро пожаловать и нежное начало',
                doctorTitle: 'Консультация врача и личный план',
                dailyTherapiesTitle: 'Ежедневные аюрведические процедуры',
                herbalMedicineTitle: 'Поддержка лечебными травами',
                yogaMeditationTitle: 'Йога и медитация для гармонии тела и ума',
                wellnessTitle: 'Включенные оздоровительные мероприятия',
                closingTitle: 'Заключительный ритуал и отъезд',
                welcomePoints: [
                    'Трансфер из аэропорта и доставка в отель',
                    'Теплый прием и ориентация по отелю',
                    'Введение в вашу еженедельную программу здоровья',
                    'Расслабляющий массаж (День 1) в центре аюрведы для облегчения усталости от путешествия и подготовки тела к процедурам'
                ],
                doctorPoints: [
                    'Консультация врача аюрведы (День 2 – утро)',
                    'Полная оценка вашей доши/типа тела и проблем со здоровьем',
                    'Переводчик доступен по запросу',
                    'Ваш врач создает персональный план лечения, соответствующий вашим потребностям и целям'
                ],
                dailyTherapiesPoints: [
                    '4–5 процедур в день (как рекомендовано врачом)',
                    'Процедуры подобраны на основе вашей конституции тела и состояния',
                    'Специальные массажи могут быть добавлены при необходимости',
                    'Врач ежедневно отслеживает прогресс и может корректировать процедуры и травяную поддержку для получения лучших результатов',
                    'При необходимости может быть рекомендован мягкий процесс очищения'
                ],
                herbalMedicinePoints: [
                    'Травяные лекарства, назначенные врачом, два раза в день:',
                    'Во время завтрака',
                    'Во время ужина',
                    'Поддерживают внутреннее исцеление, детоксикацию и долгосрочное равновесие'
                ],
                yogaMeditationPoints: [
                    'Занятия йогой 4 раза в неделю (приблизительно 1 час)',
                    'Сеансы медитации 2 раза в неделю:',
                    'Уникальный духовный опыт в храме на острове, доступный на лодке',
                    'Управляемая медитация под руководством монахов (приблизительно 1 час)'
                ],
                wellnessPoints: [
                    'Еженедельные демонстрации здорового приготовления пищи',
                    'Бесплатная экскурсия (культурный/природный опыт)'
                ],
                closingPoints: [
                    'Прекрасная ванна из цветов (последний день) – традиционный ритуал обновления',
                    'Заключительная консультация врача для проверки прогресса и предоставления:',
                    'Продолжение рекомендаций по благополучию',
                    'Рецепты и рекомендации для дома',
                    'Трансфер обратно в аэропорт'
                ]
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Курорт Muthumuni Ayurveda Beach',
            heroSubtitle1: 'Аюрведа у океана',
            heroSubtitle2: 'Найдите баланс, дышите легче и обновите свою энергию в Беруваде.',
            exploreResort: 'Изучить курорт',
            bookNow: 'Забронировать сейчас',

            // Welcome Section
            welcomeLabel: 'Добро пожаловать',
            welcomeTitle: 'Курорт Muthumuni Ayurveda Beach',
            welcomeDesc1: 'Расположенный на нетронутом берегу Беруваде, курорт Muthumuni Ayurveda Beach предлагает гармоничное сочетание древних целебных традиций и современного пляжного стиля жизни. Наш святилище приглашает вас начать трансформирующий путь благополучия, где ритмичные звуки Индийского океана встречаются с вечной мудростью Аюрведы.',
            welcomeDesc2: 'Испытайте персонализированные аюрведические процедуры, попробуйте питательные блюда, приготовленные для баланса вашей доши, и расслабьтесь в элегантно оформленных номерах с захватывающим видом на океан. Независимо от того, ищете ли вы омоложение, релаксацию или духовное возрождение, наша преданная команда врачей Аюрведы и экспертов по оздоровлению охотно поможет вам на каждом этапе.',
            learnMore: 'Узнать больше',
            contactUs: 'Свяжитесь с нами',
            welcomeImageAlt: 'Курорт Muthumuni Ayurveda Beach',
            welcomeImageCaption: 'Аюрведа Велнесс и пляжный ретрит',
            welcomeImageLocation: 'Беруваде, Шри-Ланка',

            // Highlight Section
            highlightTitle: 'Святилище Аюрведы у моря',
            highlightDesc: 'Откройте для себя целостное исцеление на юго-западном побережье Шри-Ланки. От персонализированных процедур до тихих балконов и осознанной кухни - каждая деталь разработана для восстановления вашего ритма.',

            // Services
            service1Title: 'Целостные аюрведические процедуры',
            service1Desc: 'Персональные консультации, подлинные травяные масла и ежедневные процедуры под руководством опытных врачей Аюрведы.',
            service2Title: 'Номера и люкс на пляже',
            service2Desc: 'Проснитесь с морским бризом, приватными балконами и успокаивающим интерьером, предназначенным для глубокого отдыха.',
            service3Title: 'Кухня благополучия',
            service3Desc: 'Свежие шри-ланкийские продукты, растительные меню и индивидуальные планы питания, дополняющие вашу дошу.',
            service4Title: 'Йога и внимательность',
            service4Desc: 'Йога на восходе солнца, медитация на закате и дыхательные упражнения в ритме волн.',
            service5Title: 'Экскурсии по реке и побережью',
            service5Desc: 'Прогулки на лодке по реке Бентота, посещение инкубатория черепах, прогулки по саду специй и велосипедные туры по деревням.',

            // Rooms
            roomsTitle: 'Наши номера',
            roomsDesc: 'Выберите святилище, соответствующее вашему стилю, от просторных люксов до уютных делюкс-номеров, каждый с мягким бельем, теплым деревом и балконами, готовыми к восходу солнца.',
            roomBadge: 'Побег на пляж',
            bookableNow: 'Доступна брон',
            seaBreezeReady: 'Готов к морскому бризу',
            viewRoom: 'Просмотреть номер',
            room1Title: 'Номера люкс',
            room1Desc: 'Просторные люкс-номера с зоной отдыха, просторными балконами и успокаивающей палитрой для неспешных утр.',
            room2Title: 'Номера делюкс',
            room2Desc: 'Уютные номера с мягкими кроватями, видом на сад и теплыми деревянными акцентами для повседневного комфорта.',
            room3Title: 'Делюкс с видом на море',
            room3Desc: 'Пробудитесь с морским горизонтом, мягким бельем и приватным балконом для золотых закатов.',

            // Achievements
            achievementsTitle: 'Доверенное благополучие у моря',
            achievement1Title: 'Счастливые гости',
            achievement1Count: '1 000+',
            achievement2Title: 'Аюрведические процедуры',
            achievement2Count: '20+',
            achievement3Title: 'Годы заботы',
            achievement3Count: '15+',
            achievement4Title: 'Путешественники похвалились',
            achievement4Count: '1 000+',

            // Experiences
            experiencesTitle: 'Исследуйте курорт Muthumuni Ayurveda Beach',
            experiencesDesc: 'От путешествий Аюрведы к кураторским экскурсиям - выбирайте впечатления, которые сделают ваш отдых незабываемым.',
            planYourStay: 'Спланируйте свой отдых',
            experience1Title: 'Номера и люкс',
            experience1Desc: 'Просторные номера с балконами, видом на океан или сад и продуманным комфортом для спокойных отдыхов.',
            experience2Title: 'Аюрведа спа',
            experience2Desc: 'Подлинные процедуры, паровые ванны и восстановительные массажи, проведенные с соблюдением древних ритуалов.',
            experience3Title: 'Опыт ужина',
            experience3Desc: 'Питательная шри-ланкийская и международная кухня в нашем ресторане, тщательно приготовленная для питания тела и разума.',
            experience4Title: 'Впечатления и туры',
            experience4Desc: 'Речные сафари, посещение храмов, водные виды спорта и кураторские культурные экскурсии вокруг Бентоты.',

            // Gallery
            galleryTitle: 'Моменты в курорте Muthumuni Ayurveda Beach',
            galleryDesc: 'Взгляд в наше побережное святилище - восходы солнца, безмятежные процедуры, питательные блюда и спокойные уголки для вас.',
            gallery1Alt: 'Залитый солнцем пляж, окруженный пальмами в Muthumuni',
            gallery2Alt: 'Аюрведическое масляное лечение в процессе',
            gallery3Alt: 'Курортный бассейн с шезлонгами',
            gallery4Alt: 'Травы, подготовленные для спа',
            gallery5Alt: 'Пара наслаждается закатом на море',
            gallery6Alt: 'Йога-дека, выходящая на океан',
            gallery7Alt: 'Путь через тропический сад',
            gallery8Alt: 'Здоровый завтрак',
            gallery9Alt: 'Безмятежный вид на реку',
            gallery10Alt: 'Тепло освещенный курорт на берегу на закате',
            gallery11Alt: 'Выставка аюрведических трав и масел',
            gallery12Alt: 'Уютное место в саду',

            // Resort Images
            resort1Alt: 'Открытая гостиная с зеленью',
            resort2Alt: 'Удобный номер интерьер',
            resort3Alt: 'Спа-процедурный кабинет',
            resort4Alt: 'Столовая с естественным светом',
            resort5Alt: 'Расслабляющий вид на бассейн',

            // Sunset Section
            sunsetLabel: 'Ежедневный шедевр природы',
            sunsetTitle: 'Вечерний закат',
            sunsetDesc1: 'Наблюдайте, как день переходит в сумерки, небо превращается в холст амбры, малиновых и золотых тонов. Мягкий Индийский океан отражает это небесное зрелище, создавая завораживающую симфонию света и воды.',
            sunsetDesc2: 'Каждый вечер в Muthumuni предлагает вам лучший вид на одно из самых захватывающих представлений природы. Найдите идеальную точку зрения - будь то с вашего частного балкона, пляжного лаунжа или нашей медитационной палубы заката - и дайте безмятежной красоте охватить вас.',
            sunsetFeature1: 'Беспрепятственный вид на океан со всех уголков',
            sunsetFeature2: 'Успокаивающая медитация на закате',
            sunsetFeature3: 'Бесплатный травяной чай подается ежедневно',
            sunsetFeature4: 'Фотогеничные моменты каждый вечер',
            sunsetImageAlt: 'Вечерний закат на курорте Muthumuni Beach',
            bestTime: 'Лучшее время',
            sunsetTime: '18:00 - 18:45',

            // Pool Section
            poolLabel: 'Акватическое спокойствие',
            poolTitle: 'Бассейн',
            poolDesc1: 'Погрузитесь в спокойствие нашего кристально чистого бассейна с бесконечностью, где хрусталь-чистая вода встречается с пышными тропическими садами. Наш бассейн разработан для расслабления и омоложения - идеальное место для отдыха под шри-ланкийским солнцем.',
            poolDesc2: 'Независимо от того, предпочитаете ли вы освежающее утреннее купание, спокойный полдень с хорошей книгой или мирный вечерний спуск, наш бассейн предлагает идеальное место. Окруженный удобными шезлонгами, тенистыми кабинками и внимательным сервисом, каждый момент становится драгоценным воспоминанием.',
            poolFeature1: 'Бассейн с контролируемой температурой',
            poolFeature2: 'Окружен тропическими садами и ландшафтами',
            poolFeature3: 'Освежающие напитки на берегу бассейна, здоровые закуски',
            poolFeature4: 'Премиум шезлонги с зонтиками',
            poolImageAlt: 'Расслабляющий бассейн в курорте Muthumuni',

            // Testimonials
            testimonialsTitle: 'Гости во время их отдыха'
        }

    },

    it: {
        about: {
            heroTitle: 'Chi Siamo',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'La saggezza antica incontra il benessere moderno presso Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Trattamenti ayurvedici personalizzati, viste sull\'oceano e vera ospitalità dello Sri Lanka',
            slide1: 'Guarigione ayurvedica',
            slide2: 'Serenità sulla spiaggia',
            slide3: 'Tranquillità del giardino',
            slide4: 'Terapie erboristiche',
            slide5: 'Benessere oceanico',
            historyLabel: 'Il nostro viaggio',
            historyTitle: 'Storia di Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Fondato più di due decenni fa, Muthumuni Ayurveda Beach Resort è nato dalla visione di creare un santuario dove la saggezza ayurvedica antica incontra la bellezza tranquilla della costa meridionale dello Sri Lanka. Ciò che è iniziato come un modesto ritiro benessere è fiorito in una delle destinazioni più care di Beruwala per la guarigione olistica e il ringiovanimento.',
            historyDesc2: 'I nostri fondatori, ispirati da generazioni di praticanti tradizionali dell\'ayurveda, hanno cercato di preservare queste arti curative collaudate nel tempo fornendo comfort moderni e vera ospitalità dello Sri Lanka. Nel corso degli anni, siamo rimasti fedeli al nostro impegno per le autentiche esperienze di benessere, espandendo le nostre strutture senza mai perdere di vista la cura personalizzata che definisce il nostro patrimonio.',
            historyDesc3: 'Oggi, Muthumuni rappresenta una testimonianza della duratura potenza dell\'ayurveda, avendo accolto migliaia di ospiti da tutto il mondo. Ogni visitatore diventa parte della nostra storia, trovando equilibrio, guarigione e trasformazione nel nostro rifugio balneare.',
            statYear: '15+',
            statYearLabel: 'Anni di eccellenza nel benessere',
            statGuest: '1.000+',
            statGuestLabel: 'Ospiti felici serviti',
            experienceLegacy: 'Sperimenta il nostro patrimonio',
            established: 'Fondato',
            since2010: 'Dal 2008',
            chairmanLabel: 'Messaggio del presidente',
            chairmanTitle: 'Guidato dalla cura, radicato nell\'Ayurveda',
            chairmanDesc1: 'Benvenuti a Muthumuni Ayurveda Beach Resort. Per più di due decenni, il nostro scopo è stato semplice: offrire una vera guarigione radicata nella saggezza senza tempo dell\'ayurveda, fornita con il calore dell\'ospitalità dello Sri Lanka.',
            chairmanDesc2: 'Qui, ogni dettaglio — dai nostri trattamenti e cuisine alla tranquillità dei nostri spazi — è progettato per aiutarti a rallentare, ripristinare l\'equilibrio e riconnetterti con te stesso. Siamo onorati di essere parte del tuo viaggio di benessere.',
            chairmanDesc3: 'A nome del nostro team dedicato, ti invito a sperimentare la cura, l\'autenticità e la serenità che definiscono Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Presidente',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Presidente Mr. Nihal Muthumuni',
            staffLabel: 'Il nostro team',
            staffTitle: 'Conosci il nostro team dedicato',
            staffDesc1: 'A Muthumuni Ayurveda Beach Resort, il nostro team è il cuore di tutto ciò che facciamo. I membri del nostro staff sono professionisti accuratamente selezionati e addestrati che condividono una profonda passione per il benessere ayurvedico e l\'ospitalità autentica.',
            staffDesc2: 'Dai nostri esperti praticanti ayurvedici e abili terapeuti del massaggio al nostro team dedicato all\'ospitalità, ogni membro porta anni di expertise e vera cura a ogni interazione con gli ospiti. Crediamo che il vero benessere non venga solo dai trattamenti, ma dal calore e dall\'attenzione di persone che sinceramente si preoccupano del tuo viaggio.',
            staffDesc3: 'Il nostro staff segue una formazione continua nelle ultime pratiche ayurvediche mentre mantiene gli standard più elevati di professionalità e sensibilità culturale. Siamo orgogliosi di creare connessioni significative con i nostri ospiti, assicurando che ogni visita diventi un\'esperienza memorabile e trasformativa.',
            statStaff: '15+',
            statStaffLabel: 'Professionisti qualificati',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Soddisfazione degli ospiti',
            staffImageAlt: 'Il nostro team di staff dedicato a Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Il nostro impegno',
            excellenceCare: 'Eccellenza e cura',
            ctaLabel: 'Mettiti in contatto',
            ctaHeading: 'Pronto a iniziare il tuo viaggio di benessere?',
            ctaDesc: 'Contatta il nostro team per prenotare il tuo ritiro ayurvedico personalizzato. Che tu abbia domande sui nostri trattamenti, alloggi o pacchetti benessere speciali, siamo qui per aiutare a creare la tua fuga perfetta.',
            ctaButtonContact: 'Contattaci ora',
            ctaButtonRooms: 'Esplora le camere',
            contactUs: 'Contattaci',
            quickInfoCall: 'Chiamaci',
            quickInfoEmail: 'Inviaci un\'email',
            quickInfoLocation: 'Posizione',
            locationCity: 'Beruwala, Sri Lanka'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Camera Deluxe Vista Fiume — Comfort con terrazza o balcone privato',
            heroSubtitle: 'Rilassatevi in un rifugio tranquillo sul fiume, ispirato alle serene acque di Bentota, con comfort moderni e una leggera brezza fluviale.',
            bookThisRoom: 'Prenota questa camera',
            callReservations: 'Chiama le prenotazioni',

            navAll: 'Tutte',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe con vista fiume',

            soothingHideawayTitle: 'Un rifugio rilassante sul fiume',
            soothingHideawayDesc: 'La nostra camera Deluxe con vista fiume è pensata per mattine lente e tramonti senza fretta. Toni neutri morbidi, ampie vetrate e illuminazione curata lasciano entrare la vista sul fiume, mentre il balcone diventa il vostro angolo privato sopra l’acqua che scorre.',

            highlight1Title: 'Vista panoramica sul fiume',
            highlight1Desc: 'Svegliatevi con viste serene sul fiume e albe dorate dal vostro balcone privato.',
            highlight2Title: 'Interni eleganti sul fiume',
            highlight2Desc: 'Palettes neutre morbide, accenti in legno caldo e abbondante luce naturale.',
            highlight3Title: 'Esperienza di sonno serena',
            highlight3Desc: 'Letto king-size imbottito con lenzuola premium per un riposo rigenerante.',

            atAGlance: 'In breve',
            statSizeLabel: 'Dimensione',
            statViewLabel: 'Vista',
            statViewValue: 'Sul fiume',
            statGuestsLabel: 'Ospiti',
            statBedLabel: 'Letto',
            statBedValue: 'King o Twin',
            reserve: 'Prenota',

            includedWithStay: 'Incluso nel soggiorno',
            thoughtfulTouches: 'Tocchi premurosi, comfort tutto il giorno',
            enhancedCleanliness: 'Standard migliorati di pulizia e sicurezza',

            inclusion1: 'Colazione, pranzo e cena gratuiti al ristorante Breeze',
            inclusion2: 'Wi-Fi ad alta velocità e postazione di lavoro in camera',
            inclusion3: 'Servizio in camera 24h/24 e concierge',
            inclusion4: 'Pulizia giornaliera con turndown serale',
            inclusion5: 'Accesso alla piscina infinity e alle strutture spa ayurvediche',
            inclusion6: 'Parcheggio gratuito e navetta verso le attrazioni vicine',

            amenityGroup1Title: 'Caratteristiche della camera',
            amenityGroup1Item1: '38 m² di spazio',
            amenityGroup1Item2: 'Balcone privato con posti a sedere',
            amenityGroup1Item3: 'Aria condizionata con controllo individuale',
            amenityGroup1Item4: 'Cassaforte in camera',

            amenityGroup2Title: 'Esperienza bagno',
            amenityGroup2Item1: 'Doccia a pioggia con acqua calda e fredda',
            amenityGroup2Item2: 'Prodotti da bagno premium',
            amenityGroup2Item3: 'Phon',
            amenityGroup2Item4: 'Accappatoi morbidi e ciabattine',

            amenityGroup3Title: 'Comfort in camera',
            amenityGroup3Item1: 'Smart TV 55" con cavo',
            amenityGroup3Item2: 'Stazione caffè e tè',
            amenityGroup3Item3: 'Telefono con chiamata diretta',

            amenityGroup4Title: 'Connettività',
            amenityGroup4Item1: 'Wi-Fi gratuito',
            amenityGroup4Item2: 'Scrivania',
            amenityGroup4Item3: 'Supporto reception 24/7',

            inRoomEssentials: 'Essenziali in camera',
            everythingYouNeed: 'Tutto ciò di cui hai bisogno per sentirti a casa',
            inRoomEssentialsDesc: 'Dalla connettività fluida alle bevande accuratamente scelte — la camera Deluxe con vista fiume unisce svago e praticità per concentrarsi sui momenti importanti.',

            complimentaryWifi: 'Wi-Fi gratuito',
            coffeeTeaStation: 'Stazione caffè e tè',
            roomService: 'Servizio in camera 24h/24',
            rainShower: 'Doccia a pioggia',

            byTheRiver: 'Sul fiume',
            slowDownBreathe: 'Rallenta, respira aria fresca',

            readyToStay: 'Pronto a soggiornare?',
            reserveDeluxeRiverViewToday: 'Prenota oggi una camera Deluxe con vista fiume',
            speakReservations: 'Parla con il nostro team prenotazioni per le migliori tariffe e offerte speciali.',
            checkAvailability: 'Verifica disponibilità'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Camera Deluxe — Comfort con terrazza o balcone privato',
            heroSubtitle: 'Rilassatevi in un rifugio tranquillo sul fiume, ispirato alle serene acque di Bentota, con comfort moderni e una leggera brezza fluviale.',
            bookThisRoom: 'Prenota questa camera',
            callReservations: 'Chiama le prenotazioni',

            navAll: 'Tutte',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe con vista fiume',

            soothingHideawayTitle: 'Un rifugio rilassante sul fiume',
            soothingHideawayDesc: 'La camera Deluxe è pensata per mattine lente e tramonti senza fretta. Toni neutri morbidi, ampie vetrate e illuminazione curata lasciano entrare la vista sul fiume, mentre il balcone diventa il vostro angolo personale sopra l’acqua che scorre.',

            highlight1Title: 'Vista panoramica sul fiume',
            highlight1Desc: 'Svegliatevi con viste serene sul fiume e albe tropicali dal vostro balcone privato.',
            highlight2Title: 'Interni eleganti sul fiume',
            highlight2Desc: 'Tonalità neutre morbide, accenti in legno caldo e abbondante luce naturale.',
            highlight3Title: 'Esperienza di sonno serena',
            highlight3Desc: 'Letto king-size imbottito con lenzuola premium per un riposo rigenerante.',

            atAGlance: 'In breve',
            statSizeLabel: 'Dimensione',
            statViewLabel: 'Vista',
            statViewValue: 'Sul fiume',
            statGuestsLabel: 'Ospiti',
            statBedLabel: 'Letto',
            statBedValue: 'King o Twin',
            reserve: 'Prenota',

            includedWithStay: 'Incluso nel soggiorno',
            thoughtfulTouches: 'Tocchi premurosi, comfort tutto il giorno',
            enhancedCleanliness: 'Standard migliorati di pulizia e sicurezza',

            inclusion1: 'Colazione, pranzo e cena gratuiti al ristorante Breeze',
            inclusion2: 'Wi-Fi ad alta velocità e postazione di lavoro in camera',
            inclusion3: 'Servizio in camera 24 ore e concierge',
            inclusion4: 'Pulizia giornaliera con turndown serale',
            inclusion5: 'Accesso alla piscina infinity e alle strutture spa ayurvediche',
            inclusion6: 'Parcheggio gratuito e servizio navetta per le attrazioni vicine',

            amenityGroup1Title: 'Caratteristiche della camera',
            amenityGroup1Item1: '41 m² di spazio',
            amenityGroup1Item2: 'Balcone privato con posti a sedere',
            amenityGroup1Item3: 'Aria condizionata con controllo individuale',
            amenityGroup1Item4: 'Cassaforte in camera',

            amenityGroup2Title: 'Esperienza bagno',
            amenityGroup2Item1: 'Doccia a pioggia con acqua calda e fredda',
            amenityGroup2Item2: 'Prodotti da bagno premium',
            amenityGroup2Item3: 'Phon',
            amenityGroup2Item4: 'Accappatoi morbidi e ciabattine',

            amenityGroup3Title: 'Comfort in camera',
            amenityGroup3Item1: 'Smart TV 55" con cavo',
            amenityGroup3Item2: 'Stazione caffè e tè',
            amenityGroup3Item3: 'Telefono con chiamata diretta',

            amenityGroup4Title: 'Connettività',
            amenityGroup4Item1: 'Wi-Fi gratuito',
            amenityGroup4Item2: 'Scrivania',
            amenityGroup4Item3: 'Supporto reception 24/7',

            inRoomEssentials: 'Essenziali in camera',
            everythingYouNeed: 'Tutto ciò di cui hai bisogno per sentirti a casa',
            inRoomEssentialsDesc: 'Dalla connettività senza interruzioni alle bevande accuratamente scelte — la camera Deluxe unisce svago e praticità così puoi concentrarti sui momenti che contano.',

            complimentaryWifi: 'Wi-Fi gratuito',
            coffeeTeaStation: 'Stazione caffè e tè',
            roomService: 'Servizio in camera 24/7',
            rainShower: 'Doccia a pioggia',

            byTheRiver: 'Sul fiume',
            slowDownBreathe: 'Rallenta, respira aria fresca',

            readyToStay: 'Pronto a soggiornare?',
            reserveDeluxeToday: 'Prenota oggi la camera Deluxe',
            speakReservations: 'Parla con il nostro team prenotazioni per le migliori tariffe disponibili e offerte speciali.',
            checkAvailability: 'Verifica disponibilità'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Il tuo santuario ti aspetta',
            heroSubtitle: 'Rifugi sul fiume progettati per la guarigione, il ripristino e una profonda pace lungo il sereno fiume Bentota.',
            exploreRooms: 'Scopri le camere',

            filterAll: 'Tutte',
            filterDeluxeRooms: 'Camere Deluxe',
            filterRiverViewDeluxe: 'Camera Deluxe con vista fiume',

            deluxeRoomName: 'Camera Deluxe',
            deluxeRoomCategory: 'Camere Deluxe',
            deluxeRoomDesc: 'Camera armoniosamente equilibrata con elementi in legno naturale e vista sul fiume per una perfetta tranquillità.',

            riverViewDeluxeName: 'Deluxe Vista Fiume',
            riverViewDeluxeCategory: 'Camera Deluxe con vista sul fiume',
            riverViewDeluxeDesc: 'Svegliati con i dolci suoni del fiume e goditi viste panoramiche sul fiume in questa camera deluxe elegantemente progettata.',

            noRoomsFound: 'Nessuna camera trovata in questa categoria.',
            roomSize: 'Dimensione camera',
            guests: 'Ospiti',
            amenitiesCount: 'Servizi',
            roomAmenities: 'Servizi della camera',
            specialFeatures: 'Caratteristiche speciali',

            kingSizeBed: 'Letto King Size',
            workDesk: 'Scrivania',
            rainShower: 'Doccia a pioggia',
            teaStation: 'Stazione tè',
            privateTerrace: 'Terrazza privata',
            binoculars: 'Binocolo',

            riverView: 'Vista sul fiume',
            naturalLighting: 'Illuminazione naturale',
            gardenView: 'Vista sul giardino',
            sunriseBalcony: 'Balcone per l’alba',
            soundOfRiver: 'Suono del fiume',

            bookNow: 'Prenota ora',
            viewDetails: 'Vedi dettagli',
            viewRoom: 'Vedi camera',

            allRoomsInclude: 'Tutte le camere includono',
            essentialComforts: 'Comfort essenziali per il tuo percorso di benessere',

            highSpeedWifi: 'Wi-Fi ad alta velocità',
            herbalTea: 'Selezione di tè alle erbe',
            climateControl: 'Climatizzazione',
            organicToiletries: 'Prodotti da toilette biologici',
            dailyHousekeeping: 'Pulizia giornaliera',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tappetino yoga e accessori',

            beginHealing: 'Inizia il tuo viaggio di guarigione',
            beginHealingDesc: 'Vivi un autentico benessere ayurvedico in un ambiente fluviale sereno, progettato per nutrire il corpo, calmare la mente e rigenerare lo spirito.',
            reserveRoom: 'Prenota la tua camera',
            speakAdvisor: 'Parla con un consulente benessere',

            exploreOurRooms: 'Esplora le nostre camere'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Ayurveda sul fiume',
            heroTagline: 'Trova l’equilibrio, respira liberamente e rinnova la tua energia ad Aluthgama',
            exploreResort: 'Scopri il resort',
            bookNow: 'Prenota ora',

            welcomeLabel: 'Benvenuti',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Immerso lungo la tranquilla riva del fiume Bentota, il Muthumuni Ayurveda River Resort offre un’armoniosa fusione tra antiche tradizioni curative e la serena bellezza naturale. Il nostro santuario ti invita a intraprendere un viaggio trasformativo di benessere, dove il dolce scorrere del fiume incontra la saggezza senza tempo dell’Ayurveda.',
            welcomeDesc2: 'Vivi trattamenti ayurvedici personalizzati, assapora una cucina nutriente studiata per il tuo dosha e rilassati in camere elegantemente arredate con vista mozzafiato sul fiume. Che tu stia cercando rigenerazione, relax o rinnovamento spirituale, il nostro team dedicato di praticanti ayurvedici ed esperti di benessere ti accompagnerà in ogni passo del percorso.',
            learnMore: 'Scopri di più',
            contactUs: 'Contattaci',
            welcomeImageCaption: 'Benessere Ayurvedico & Ritiro fluviale',
            welcomeImageLocation: 'Aluthgama, Sri Lanka',

            highlightTitle: 'Un rifugio ayurvedico sul fiume',
            highlightDesc: 'Scopri la guarigione olistica lungo la pacifica riva del Bentota. Dai trattamenti su misura ai balconi silenziosi fino alla cucina consapevole: ogni dettaglio è creato per ristabilire il tuo ritmo naturale.',

            roomsTitle: 'Le nostre camere',
            roomsDesc: 'Scegli il rifugio che si adatta al tuo ritmo: dalle suite ariose agli accoglienti angoli deluxe, ognuna con lenzuola morbide, legno caldo e balconi pronti per l’alba.',
            room1Title: 'Camere Deluxe',
            room1Desc: 'Rifugi accoglienti con letti comodi, vista sul giardino e accenti in legno caldo per un comfort quotidiano.',
            room2Title: 'Deluxe Vista Fiume',
            room2Desc: 'Svegliati con la vista serena sul fiume, lenzuola morbide e un balcone privato perfetto per mattine tranquille.',
            viewRoom: 'Vedi la camera',
            bookableNow: 'Prenotabile ora',
            riverBreezeReady: 'Pronto per la brezza fluviale',
            roomBadge: 'Fuga sul fiume',

            achievementsTitle: 'Benessere affidabile sul fiume',
            achievement1Title: 'Ospiti felici',
            achievement1Count: '1.000+',
            achievement2Title: 'Trattamenti ayurvedici',
            achievement2Count: '20+',
            achievement3Title: 'Anni di cura',
            achievement3Count: '15+',
            achievement4Title: 'Riconoscimenti dei viaggiatori',
            achievement4Count: '1.000+',

            experiencesTitle: 'Scopri le esperienze al Muthumuni Ayurveda River Resort',
            experiencesDesc: 'Dai percorsi ayurvedici alle escursioni curate: scegli le esperienze che renderanno il tuo soggiorno indimenticabile.',
            planYourStay: 'Pianifica il tuo soggiorno',
            experience1Title: 'Le nostre camere',
            experience1Desc: 'Spazi ariosi con balconi, vista sul fiume o sul giardino e comfort pensati per soggiorni senza fretta.',
            experience2Title: 'Spa ayurvedica',
            experience2Desc: 'Terapie autentiche, bagni di vapore e massaggi rigeneranti eseguiti secondo antichi rituali.',
            experience3Title: 'Cena sul fiume',
            experience3Desc: 'Cucina nutriente srilankese e internazionale pensata per nutrire corpo e mente.',
            experience4Title: 'Esperienze & Escursioni',
            experience4Desc: 'Safari fluviali sul Bentota, visite ai templi, sport acquatici ed escursioni culturali intorno a Bentota.',

            galleryTitle: 'Momenti al Muthumuni Ayurveda River Resort',
            galleryDesc: 'Uno sguardo nel nostro rifugio fluviale — albe, trattamenti sereni, piatti nutrienti e angoli tranquilli creati per te.',
            gallery1Alt: 'Riva fluviale illuminata dal sole con palme a Muthumuni',
            gallery2Alt: 'Trattamento ayurvedico con olio in corso',
            gallery3Alt: 'Piscina del resort con lettini',
            gallery4Alt: 'Ingredienti erbali preparati per la spa',
            gallery5Alt: 'Coppia che gode del tramonto sul fiume',
            gallery6Alt: 'Piattaforma yoga con vista sul fiume',
            gallery7Alt: 'Sentiero nel giardino tropicale',
            gallery8Alt: 'Colazione salutare',
            gallery9Alt: 'Vista tranquilla sul fiume',
            gallery10Alt: 'Esterno del resort illuminato al crepuscolo',
            gallery11Alt: 'Esposizione di erbe e oli ayurvedici',
            gallery12Alt: 'Angolo relax vicino al giardino',

            boatLabel: 'Avventure sul fiume',
            boatTitle: 'Gite in barca sul fiume Bentota',
            boatDesc1: 'Vivi la magia del fiume Bentota con le nostre affascinanti gite in barca. Scivola su vie d’acqua tranquille circondate da lussureggianti foreste di mangrovie, avvistando fauna esotica: martin pescatori colorati, coccodrilli, varani e scimmie giocose. Perfetto per amanti della natura e fotografi in cerca di momenti indimenticabili.',
            boatDesc2: 'Scegli una tranquilla crociera mattutina, un viaggio romantico al tramonto o un’esplorazione avventurosa della fauna selvatica — le nostre guide esperte condivideranno informazioni affascinanti sull’ecosistema del fiume. Personalizza la tua esperienza con opzioni di charter privato o unisciti ai tour di gruppo per un contatto più intimo con la natura.',
            boatFeature1: 'Crociere panoramiche tra le mangrovie',
            boatFeature2: 'Avvistamento fauna — uccelli, coccodrilli e scimmie',
            boatFeature3: 'Opzioni di crociere all’alba e al tramonto',
            boatFeature4: 'Guide locali esperte incluse',
            boatImageAlt: 'Gita in barca sul fiume Bentota',

            poolLabel: 'Serenità acquatica',
            poolTitle: 'Area piscina',
            poolDesc1: 'Immergiti nella tranquillità della nostra piscina infinity cristallina, dove l’acqua limpida incontra lussureggianti giardini tropicali. Progettata per relax e rigenerazione, l’area piscina offre la fuga perfetta per rilassarsi sotto il sole dello Sri Lanka.',
            poolDesc2: 'Che tu preferisca un rinfrescante nuoto mattutino, un pomeriggio di lettura rilassata o un bagno tranquillo serale — la nostra area piscina offre uno scenario idilliaco. Circondata da comodi lettini, cabine ombreggiate e servizio attento a bordo piscina, ogni momento diventa un ricordo prezioso.',
            poolFeature1: 'Piscina infinity a temperatura controllata',
            poolFeature2: 'Circondata da paesaggi di giardino tropicale',
            poolFeature3: 'Rinfreschi e snack salutari a bordo piscina',
            poolFeature4: 'Lettini premium con ombrelloni',
            poolImageAlt: 'Area piscina rilassante',

            testimonialsTitle: 'Ospiti sul loro soggiorno',

            bookingDestination: 'Destinazione',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Check-in',
            bookingCheckOut: 'Check-out',
            bookingGuests: 'Ospiti',
            guestsOption1: '1 Ospite',
            guestsOption2: '2 Ospiti',
            guestsOption3: '3 Ospiti',
            guestsOption4: '4+ Ospiti',
            bookingCheckAvailability: 'Verifica disponibilità',

            service1Title: 'Terapie ayurvediche olistiche',
            service1Desc: 'Consulenze personalizzate, oli erbali autentici e trattamenti giornalieri guidati da medici ayurvedici esperti.',

            service2Title: 'Camere sul fiume',
            service2Desc: 'Svegliati con il dolce suono del fiume, balconi privati e interni rilassanti progettati per un riposo profondo.',

            service3Title: 'Cucina benessere',
            service3Desc: 'Prodotti freschi dello Sri Lanka, menu a base vegetale e piani alimentari personalizzati in base al tuo dosha.',

            service4Title: 'Yoga e consapevolezza',
            service4Desc: 'Yoga all’alba, meditazione al tramonto e sessioni di respirazione al ritmo delle onde.',

            service5Title: 'Escursioni fluviali e costiere',
            service5Desc: 'Gite in barca sul fiume Bentota, visite all’allevamento di tartarughe, passeggiate nei giardini di spezie e tour in bicicletta nei villaggi.'
        },
        aboutus2: {
            heroTitle: 'Chi siamo',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Antica saggezza incontra la tranquilla bellezza del fiume al Muthumuni Ayurveda River Resort',
            heroTagline2: 'Trattamenti ayurvedici personalizzati, vista sul fiume e autentica ospitalità dello Sri Lanka',
            slide1: 'Guarigione ayurvedica',
            slide2: 'Serenità sul fiume',
            slide3: 'Tranquillità del giardino',
            slide4: 'Terapie a base di erbe',
            slide5: 'Benessere fluviale',
            historyLabel: 'Il nostro viaggio',
            historyTitle: 'Storia del Muthumuni Ayurveda River Resort',
            historyDesc1: 'Fondato più di due decenni fa, il Muthumuni Ayurveda River Resort nacque dalla visione di creare un santuario in cui l’antica saggezza ayurvedica incontra la serena bellezza dei paesaggi fluviali dello Sri Lanka. Nato come modesto ritiro benessere, si è trasformato in una delle destinazioni più amate di Aluthgama per la guarigione olistica e il ringiovanimento.',
            historyDesc2: 'I nostri fondatori, ispirati da generazioni di praticanti ayurvedici tradizionali, volevano preservare queste arti curative senza tempo offrendo al contempo comfort moderni e autentica ospitalità sri-lankese. Negli anni abbiamo mantenuto il nostro impegno per esperienze benessere autentiche, ampliando le strutture senza mai perdere di vista la cura personalizzata che definisce la nostra eredità.',
            historyDesc3: 'Oggi Muthumuni testimonia il potere duraturo dell’Ayurveda, avendo accolto migliaia di ospiti da tutto il mondo. Ogni visitatore diventa parte della nostra storia, trovando equilibrio, guarigione e trasformazione nel nostro pacifico rifugio sul fiume.',
            statYear: '15+',
            statYearLabel: 'Anni di eccellenza nel benessere',
            statGuest: '1.000+',
            statGuestLabel: 'Ospiti soddisfatti',
            experienceLegacy: 'Scopri la nostra eredità',
            established: 'Fondato',
            sinceYear: 'Dal 1993',
            chairmanLabel: 'Messaggio del Presidente',
            chairmanTitle: 'Guidati dalla cura, radicati nell’Ayurveda',
            chairmanDesc1: 'Benvenuti al Muthumuni Ayurveda River Resort. Da oltre due decenni il nostro scopo è semplice: offrire una vera guarigione basata sulla saggezza senza tempo dell’Ayurveda, accompagnata dal calore dell’ospitalità sri-lankese.',
            chairmanDesc2: 'Qui ogni dettaglio — dalle terapie alla cucina fino alla tranquillità degli spazi — è pensato per aiutarti a rallentare, ristabilire l’equilibrio e riconnetterti con te stesso. Siamo onorati di far parte del tuo percorso di benessere.',
            chairmanDesc3: 'A nome del nostro team dedicato, ti invito a vivere la cura, l’autenticità e la serenità che definiscono Muthumuni.',
            chairmanBadge: 'Presidente',
            chairmanName: 'Sig. Nihal Muthumuni',
            chairmanSignature: '— Sig. Nihal Muthumuni',
            chairmanImageAlt: 'Presidente Sig. Nihal Muthumuni',
            staffLabel: 'Il nostro team',
            staffTitle: 'Incontra il nostro staff dedicato',
            staffDesc1: 'Al Muthumuni Ayurveda River Resort il nostro team è il cuore di tutto ciò che facciamo. I nostri collaboratori sono professionisti selezionati e formati con cura, animati da una profonda passione per il benessere ayurvedico e l’autentica ospitalità.',
            staffDesc2: 'Dai nostri esperti praticanti ayurvedici e terapisti del massaggio fino al team di ospitalità, ogni membro porta anni di esperienza e autentica cura in ogni interazione con gli ospiti. Crediamo che il vero benessere non nasca solo dai trattamenti, ma dal calore e dall’attenzione di persone che tengono sinceramente al tuo percorso.',
            staffDesc3: 'Il nostro staff segue una formazione continua nelle più recenti pratiche ayurvediche mantenendo al contempo elevatissimi standard di professionalità e sensibilità culturale. Siamo orgogliosi di creare connessioni significative con i nostri ospiti, assicurando che ogni visita diventi un’esperienza memorabile e trasformativa.',
            statStaff: '15+',
            statStaffLabel: 'Professionisti qualificati',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Soddisfazione degli ospiti',
            staffImageAlt: 'Il nostro staff dedicato al Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Il nostro impegno',
            excellenceCare: 'Eccellenza e Cura',
            ctaLabel: 'Contattaci',
            ctaHeading: 'Pronto a iniziare il tuo percorso di benessere?',
            ctaDesc: 'Contatta il nostro team per prenotare il tuo ritiro ayurvedico personalizzato. Che tu abbia domande sulle terapie, sugli alloggi o sui pacchetti benessere speciali, siamo qui per aiutarti a creare la tua perfetta fuga.',
            ctaButtonContact: 'Contattaci ora',
            ctaButtonRooms: 'Scopri le camere',
            quickInfoCall: 'Chiamaci',
            quickInfoEmail: 'Scrivici',
            quickInfoLocation: 'Posizione',
            locationCity: 'Aluthgama, Sri Lanka'
        },
        ayurveda2: {
            accordionTitle1: 'Cos\'è il Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (parola sanscrita che significa "scienza della vita") è un antico sistema olistico di guarigione. Il Panchakarma è un insieme di terapie di purificazione e ringiovanimento progettate per ristabilire l’equilibrio tra mente, corpo e spirito.',
            accordionTitle2: 'Panchakarma Ayurveda e la tua energia vitale',
            accordionDesc2: 'Il Panchakarma si concentra sull’eliminazione delle tossine e sul ristabilire l’armonia tra i dosha (Vata, Pitta, Kapha). I trattamenti sono personalizzati per ogni ospite per sostenere benessere e vitalità a lungo termine.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Vata governa il movimento e la circolazione. Quando è in equilibrio favorisce creatività e vitalità. Il Panchakarma offre trattamenti radicanti per calmare l’eccesso di Vata e ripristinare l’equilibrio.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Pitta governa la digestione e il metabolismo. Terapie rinfrescanti e rigeneranti aiutano a bilanciare Pitta e a ridurre infiammazioni e irritabilità.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Kapha sostiene struttura e stabilità. Terapie energizzanti e stimolanti della circolazione vengono utilizzate per ridurre l’eccesso di Kapha e promuovere leggerezza e flessibilità.',
            close: 'Chiudi',
            next: 'Avanti',
            previous: 'Precedente',
            treatmentsTitle: 'I nostri trattamenti Panchakarma Ayurveda signature',
            treatmentsSubtitle: 'Terapie tradizionali per disintossicare, rigenerare e ristabilire l’equilibrio.',
            bookTreatment: 'Prenota questo trattamento',
            benefitsTitle: 'Benefici dei trattamenti Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Versamento delicato di olio caldo alle erbe sulla fronte per calmare la mente.',
            shirodhara1: 'Riduce stress e ansia',
            shirodhara2: 'Favorisce un sonno migliore',
            shirodhara3: 'Migliora la chiarezza mentale',
            steamBath: 'Bagno di vapore',
            steamBathDesc: 'Trattamento detox a vapore per aprire i pori e rilassare i muscoli.',
            steamBath1: 'Disintossica il corpo',
            steamBath2: 'Migliora la circolazione',
            steamBath3: 'Allevia la tensione muscolare',
            flowerBath: 'Bagno ai fiori',
            flowerBathDesc: 'Bagno rilassante infuso con fiori aromatici per il relax.',
            flowerBath1: 'Calma il sistema nervoso',
            flowerBath2: 'Idrata la pelle',
            flowerBath3: 'Solleva l’umore',
            headMassage: 'Massaggio alla testa',
            headMassageDesc: 'Massaggio rilassante mirato al cuoio capelluto per alleviare la tensione.',
            headMassage1: 'Riduce il mal di testa',
            headMassage2: 'Migliora la salute del cuoio capelluto',
            headMassage3: 'Promuove il rilassamento',
            faceMassage: 'Massaggio viso',
            faceMassageDesc: 'Massaggio rigenerante per migliorare la luminosità del viso e ridurre lo stress.',
            faceMassage1: 'Migliora il tono della pelle',
            faceMassage2: 'Riduce la tensione facciale',
            faceMassage3: 'Favorisce il drenaggio linfatico',
            neckMassage: 'Massaggio al collo',
            neckMassageDesc: 'Massaggio mirato per alleviare rigidità e tensione al collo.',
            neckMassage1: 'Allevia il dolore al collo',
            neckMassage2: 'Migliora la flessibilità',
            neckMassage3: 'Riduce lo stress',
            shoulderMassage: 'Massaggio alle spalle',
            shoulderMassageDesc: 'Massaggio mirato per alleviare rigidità e fastidi alle spalle.',
            shoulderMassage1: 'Riduce il dolore alle spalle',
            shoulderMassage2: 'Migliora la postura',
            shoulderMassage3: 'Rilassa i muscoli',
            bodyMassage: 'Massaggio corporeo',
            bodyMassageDesc: 'Massaggio completo per promuovere rilassamento e benessere generale.',
            bodyMassage1: 'Migliora la circolazione',
            bodyMassage2: 'Allevia il dolore muscolare',
            bodyMassage3: 'Promuove il rilassamento',
            backMassage: 'Massaggio alla schiena',
            backMassageDesc: 'Massaggio terapeutico mirato a dolore e tensione nella schiena.',
            backMassage1: 'Allevia il mal di schiena',
            backMassage2: 'Migliora la salute della colonna vertebrale',
            backMassage3: 'Riduce lo stress',
            footMassage: 'Massaggio ai piedi',
            footMassageDesc: 'Massaggio rilassante per alleviare il dolore ai piedi e favorire il relax.',
            footMassage1: 'Migliora la circolazione',
            footMassage2: 'Riduce l’affaticamento dei piedi',
            footMassage3: 'Promuove il rilassamento',
            purgative: 'Purgante',
            purgativeDesc: 'Terapia purificante per eliminare l’eccesso di Pitta e le tossine dal sistema digerente.',
            purgative1: 'Purifica il colon',
            purgative2: 'Bilancia il dosha Pitta',
            purgative3: 'Migliora la salute digestiva',
            nasalClearing: 'Pulizia nasale',
            nasalClearingDesc: 'Trattamento terapeutico nasale per liberare i seni paranasali e migliorare la respirazione.',
            nasalClearing1: 'Libera la congestione nasale',
            nasalClearing2: 'Migliora la respirazione',
            nasalClearing3: 'Allevia i problemi ai seni paranasali',
            powderMassage: 'Massaggio con polvere',
            powderMassageDesc: 'Massaggio esfoliante con polveri erbali per rigenerare e rinfrescare la pelle.',
            powderMassage1: 'Esfolia la pelle morta',
            powderMassage2: 'Migliora la texture della pelle',
            powderMassage3: 'Stimola la circolazione',
            intensiveMassageDesc: 'Un massaggio terapeutico profondo che mira alla tensione cronica e ai nodi muscolari con pressione decisa e tecniche specializzate.',
            intensiveMassage1: 'Allevia la tensione muscolare profonda',
            intensiveMassage2: 'Migliora la circolazione sanguigna',
            intensiveMassage3: 'Riduce il dolore muscolare',
            thermoMassage: 'Massaggio Termico',
            thermoMassageDesc: 'Un massaggio caldo con olio alle erbe utilizzando oli terapeutici riscaldati per migliorare il rilassamento e i benefici curativi.',
            thermoMassage1: 'Calma i muscoli doloranti',
            thermoMassage2: 'Promuove un profondo rilassamento',
            thermoMassage3: 'Favorisce il flusso energetico',
            synchronMassage: 'Massaggio Sincronizzato',
            synchronMassageDesc: 'Un massaggio sincronizzato a due terapisti per l’armonia completa del corpo e la distribuzione equilibrata dell’energia.',
            synchronMassage1: 'Armonia completa del corpo',
            synchronMassage2: 'Flusso energetico equilibrato',
            synchronMassage3: 'Esperienza di profondo rilassamento',
            specialMassage: 'Massaggio Speciale',
            specialMassageDesc: 'Terapia di massaggio personalizzata in base alle tue specifiche esigenze di salute e obiettivi di benessere personali.',
            specialMassage1: 'Trattamento personalizzato',
            specialMassage2: 'Mirato a problemi specifici',
            specialMassage3: 'Approccio curativo su misura',
            benefit1Title: 'Detossificazione:',
            benefit1Desc: 'I trattamenti Panchakarma aiutano a eliminare le tossine dal corpo, promuovendo salute e vitalità generale.',
            benefit2Title: 'Miglioramento della digestione:',
            benefit2Desc: 'Queste terapie migliorano la funzione digestiva, portando a un migliore assorbimento dei nutrienti e metabolismo.',
            benefit3Title: 'Riduzione dello stress:',
            benefit3Desc: 'Il Panchakarma è noto per i suoi effetti calmanti su mente e corpo, riducendo i livelli di stress e ansia.',
            benefit4Title: 'Rafforzamento dell’immunità:',
            benefit4Desc: 'Trattamenti regolari di Panchakarma possono rafforzare il sistema immunitario, rendendo il corpo più resistente alle malattie.',
            benefit5Title: 'Ringiovanimento:',
            benefit5Desc: 'Le terapie promuovono la rigenerazione cellulare, migliorando la salute della pelle e conferendo un aspetto più giovane.',
            benefit6Title: 'Bilanciamento dei dosha:',
            benefit6Desc: 'Il Panchakarma aiuta a ristabilire l’equilibrio dei dosha del corpo (Vata, Pitta, Kapha), essenziale per mantenere la salute secondo i principi ayurvedici.',
            gallery1: 'Terapia Shirodhara',
            gallery2: 'Bagno di vapore',
            gallery3: 'Bagno ai fiori',
            gallery4: 'Massaggio alla testa',
            gallery5: 'Massaggio corporeo',
            gallery6: 'Massaggio al collo',
            gallery7: 'Massaggio viso',
            gallery8: 'Massaggio alle spalle',
            sectionEyebrow: 'Panchakarma Ayurveda a Muthumuni',
            sectionDescription: 'Scopri l’antica arte curativa del Panchakarma Ayurveda nel nostro ritiro sul fiume. I nostri esperti praticanti ayurvedici offrono trattamenti personalizzati per disintossicare, rigenerare e ristabilire l’equilibrio di corpo, mente e spirito.',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Rigenera corpo, mente e spirito ad Aluthgama',
            heroAlt: 'Ayurveda & Benessere al Muthumuni River Resort',
            treatmentProgramme: {
                title: 'Programma di trattamento ayurvedico',
                subtitle: 'Il tuo viaggio verso equilibrio, disintossicazione e rinnovamento profondo',
                intro: 'Sperimenta l\'autentica guarigione ayurvedica in un tranquillo rifugio che ripristina il tuo corpo, calma la tua mente e rinnova la tua energia. Dal momento del tuo arrivo, il nostro team si prende cura di ogni dettaglio – così puoi concentrarti completamente sul tuo benessere.',
                welcomeTitle: 'Benvenuto e inizio dolce',
                welcome1: 'Trasferimento dall\'aeroporto e arrivo in hotel',
                welcome2: 'Calorosa accoglienza e tour dell\'hotel',
                welcome3: 'Introduzione al tuo piano di benessere settimanale',
                welcome4: 'Massaggio di rilassamento (giorno 1) presso il centro ayurvedico per alleviare la stanchezza del viaggio e preparare il corpo ai trattamenti',
                doctorTitle: 'Consulto medico e piano personalizzato',
                doctor1: 'Consulto medico ayurvedico (giorno 2 – mattino)',
                doctor2: 'Valutazione completa del tuo dosha/tipo corporeo e problemi di salute',
                doctor3: 'Traduttore disponibile su richiesta',
                doctor4: 'Il tuo medico creerà un piano di trattamento personalizzato su misura per le tue esigenze e obiettivi',
                dailyTitle: 'Terapie ayurvediche quotidiane',
                daily1: '4–5 trattamenti giornalieri (come raccomandato dal medico)',
                daily2: 'Terapie selezionate in base alla tua costituzione corporea e condizione',
                daily3: 'Massaggi speciali possono essere aggiunti secondo necessità',
                daily4: 'Il medico monitora i progressi giornalmente e può regolare i trattamenti e il supporto a base di erbe per garantire i migliori risultati',
                daily5: 'Se necessario, può essere raccomandata una procedura di pulizia/purgante delicata',
                herbalTitle: 'Supporto con medicine a base di erbe',
                herbalIntro: 'Medicine a base di erbe prescritte dal medico due volte al giorno:',
                herbal1: 'con la colazione',
                herbal2: 'con la cena',
                herbalClosing: 'Supportano la guarigione interna, la disintossicazione e l\'equilibrio a lungo termine.',
                yogaTitle: 'Yoga e meditazione per l\'armonia mente-corpo',
                yoga1: 'Sessioni di yoga 4 volte a settimana (circa 1 ora)',
                yoga2: 'Sessioni di meditazione 2 volte a settimana:',
                yoga3: '— un\'esperienza spirituale unica in un tempio sull\'isola, raggiungibile in barca',
                yoga4: '— meditazione guidata da monaci (circa 1 ora)',
                wellnessTitle: 'Esperienze di benessere incluse',
                wellness1: 'Dimostrazioni di cucina salutare settimanali',
                wellness2: 'Escursione gratuita (esperienza culturale/naturalistica)',
                closingTitle: 'Cerimonia di chiusura e partenza',
                closing1: 'Un bellissimo bagno di fiori (ultimo giorno) – rituale tradizionale di rinnovamento',
                closing2: 'Consulto medico finale per rivedere i progressi e fornire:',
                closing3: '— consulenza continua per il benessere',
                closing4: '— prescrizioni e raccomandazioni per casa',
                closing5: 'Trasferimento all\'aeroporto',
            }
        },
        yoga2: {
            heroTitle: 'Yoga al Resort',
            heroSubtitle: 'Trova equilibrio, forza e pace interiore a Beruwala',
            heroAlt: 'Yoga al Muthumuni Resort',
            importanceEyebrow: 'Benessere & Equilibrio',
            importanceTitle: 'Importanza dello Yoga e della Meditazione',
            importanceImageAlt: 'Importanza dello Yoga e della Meditazione',
            importanceText1: 'Yoga e meditazione sono pratiche antiche che offrono numerosi benefici fisici, mentali ed emotivi. Promuovono flessibilità, forza ed equilibrio riducendo al contempo stress e ansia.',
            importanceText2: 'Una pratica regolare può migliorare la concentrazione, la qualità del sonno e il benessere generale. Lo yoga incoraggia anche la consapevolezza, aiutando le persone a connettersi con il proprio sé interiore e a trovare pace nel caos della vita quotidiana.',
            importanceText3: 'Al Muthumuni Resort offriamo ambienti sereni perfetti per praticare yoga e meditazione, permettendo agli ospiti di rigenerare mente, corpo e spirito.',
            practiceEyebrow: 'La nostra pratica',
            practiceTitle: 'Pratica ed esperienza yoga',
            practiceImageAlt: 'Pratica yoga al resort',
            practiceText1: 'Al Muthumuni Resort pratichiamo principalmente Hatha Yoga tradizionale combinato con Pranayama (tecniche di respirazione). Questo approccio olistico è progettato per risvegliare la consapevolezza interiore e stimolare delicatamente la Kundalini, ponendo particolare enfasi sull’allineamento della colonna vertebrale e sulla flessibilità.',
            practiceText2: 'Le sessioni di yoga si tengono regolarmente e sono adatte sia ai principianti che ai praticanti esperti. Di tanto in tanto vengono introdotte sessioni speciali, come l’Ashtanga Yoga.',
            practiceText3: 'Tutte le sessioni si svolgono nella nostra Yoga Shala dedicata, uno spazio calmo e sereno pensato per favorire concentrazione, equilibrio e movimento consapevole. Ogni sessione inizia solitamente con i Saluti al Sole, seguiti da Pranayama e una sequenza di asana accuratamente selezionate per migliorare flessibilità e circolazione.',
            practiceText4: 'I nostri insegnanti di yoga esperti adattano ogni sessione alle esigenze, capacità e condizioni di salute individuali degli ospiti, garantendo un’esperienza sicura e profondamente benefica.',
            spiritualEyebrow: 'Viaggio spirituale',
            spiritualTitle: 'Meditazione e attività spirituali',
            spiritualSubtitle: 'Approfondisci la tua pratica spirituale con le nostre cerimonie sacre e sessioni di meditazione guidata',
            meditationImageAlt: 'Meditazione e pratica spirituale al resort',
            meditationTitle: 'Sessioni di meditazione',
            meditationDesc: 'Gli ospiti sono invitati a partecipare a sessioni di meditazione guidata ispirate alle pratiche tradizionali. Queste sessioni sono progettate per calmare la mente, approfondire la consapevolezza e sostenere la guarigione emotiva e spirituale in un ambiente pacifico.'
        },
        food2: {
            heroTitle: 'Cucina Ayurvedica e Costiera',
            heroSubtitle: 'Sapori autentici dello Sri Lanka e cucina costiera fresca',
            heroAlt: 'Esperienza culinaria al Muthumuni Beach Resort',
            wellnessEyebrow: 'Benessere attraverso il cibo',
            wellnessTitle: 'L’importanza del',
            ayurvedicFood: 'Cibo ayurvedico',
            wellnessIntro1: 'In Ayurveda il cibo è considerato la più grande medicina. Ciò che mangi influenza direttamente i tuoi dosha (Vata, Pitta, Kapha), la digestione (agni) e l’equilibrio generale di corpo, mente e spirito.',
            wellnessIntro2: 'La nutrizione ayurvedica pone l’accento su cibi freschi, stagionali e integrali, preparati con cura e consumati in modo consapevole. Ogni pasto include i sei sapori (dolce, acido, salato, piccante, amaro, astringente) per nutrire tutti i sensi e mantenere l’armonia.',
            wellnessIntro3: 'Una corretta alimentazione ayurvedica rafforza la digestione, aiuta a eliminare le tossine (ama), potenzia l’immunità, aumenta l’energia, riduce lo stress e previene molte condizioni croniche. Al Muthumuni ogni piatto è creato in base alla tua costituzione unica per una profonda guarigione e vitalità.',
            foodImage1Alt: 'Pasto ayurvedico tradizionale con i sei sapori',
            foodImage2Alt: 'Erbe e spezie ayurvediche per una nutrizione equilibrata',
            culinaryPhilosophyEyebrow: 'La nostra filosofia culinaria',
            culinaryPhilosophyTitle: 'Nutrizione',
            nutritionHighlight: 'Ayurvedica',
            culinaryPhilosophyResort: 'al Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Cucina ayurvedica al Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Fresco e nutriente',
            healingIngredientsAlt: 'Ingredienti e spezie ayurvediche salutari',
            healingIngredientsLabel: 'Ingredienti curativi',
            philosophyText1: 'Il cibo, che comprende i sei principali sapori (dolce, acido, salato, amaro, piccante, astringente) insieme a molte sottili variazioni, è descritto nei testi classici ayurvedici – alcuni risalenti a oltre 5.000 anni fa – insieme alle proprietà essenziali di ciascun alimento: Guna (qualità intrinseca), Virya (potenza – riscaldante o rinfrescante), Vipaka (effetto post-digestivo) e Prabhava (azione speciale unica).',
            philosophyText2: 'Per questo motivo la nutrizione ayurvedica riveste un ruolo centrale al Muthumuni Ayurveda Beach Resort. Questo non significa un regime rigido, monotono di pasti vegetariani insipidi o eccessivamente amari dettati solo dai medici. Al contrario, la nostra cucina ayurvedica è uno dei nostri punti di forza maggiori: i piatti preparati dai nostri abili cuochi vi sorprenderanno e delizieranno ogni singolo giorno del vostro soggiorno!',
            philosophyText3: 'A colazione un ricco buffet con frutta tropicale fresca, succhi appena spremuti, zuppe di erbe nutrienti, pane fatto in casa e biscotti leggeri, oltre a una varietà di opzioni autentiche per la colazione sri-lankese. A pranzo un buffet colorato e saporito con curry di pesce delicati, preparazioni di verdure e piatti infusi di erbe. La sera serviamo un menu fisso vegetariano con opzione di pesce fresco. Il sabato celebriamo la “Sri Lankan Night” con un buffet ampliato – i nostri chef preparano specialità locali tradizionali davanti a voi, creando un’esperienza vivace e autentica.',
            philosophyText4: 'In Ayurveda cibi e bevande sono classificati in molti modi – in base a sapore e proprietà, capacità digestiva (agni), idoneità a specifiche condizioni di salute, stagionalità e altro. Al Muthumuni consideriamo simultaneamente tutti questi fattori e ci impegniamo consapevolmente a includere tutti e sei i sapori in combinazioni equilibrate adattate alla costituzione individuale di ogni ospite.',
            philosophyText5: 'I nostri pasti includono verdure fresche, frutta tropicale e pesce proveniente da fonti responsabili. Non serviamo carne rossa né alcol.',
            philosophyText6: 'Durante i pasti è sempre presente un medico ayurvedico o un dietista qualificato per guidarvi. Vi consiglieranno le verdure, erbe e spezie più adatte alla fase attuale del trattamento e vi aiuteranno a scegliere o evitare determinati piatti. Il vostro elisir di erbe personalizzato e le istruzioni specifiche del team del centro benessere saranno posti al vostro tavolo individuale.',
            philosophyText7: 'Questo livello di cura personalizzata e attenzione all’alimentazione è una caratteristica distintiva dell’esperienza al Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Il cibo è considerato Prana – l’energia vitale che sostiene la vita di ogni essere umano. Per questo vi invitiamo ad avvicinarvi a ogni pasto con piena consapevolezza: apprezzando gli aromi, vivendo i sapori, percependo il calore gentile e godendo delle sensazioni del palato in modo mindful.',
            diningExperienceEyebrow: 'Esperienza culinaria',
            restaurantTitlePrefix: 'Il nostro',
            ayurvedicHighlight: 'Ristorante',
            restaurantTitleSuffix: 'Ayurvedico',
            restaurantDetail1: 'Il nostro ristorante ayurvedico al Muthumuni Beach Resort offre un’esperienza culinaria unica che armonizza i principi tradizionali dell’Ayurveda con l’autentica cucina costiera sri-lankese. Diamo priorità a ingredienti freschi e locali per creare piatti che deliziano il palato e promuovono il benessere olistico.',
            restaurantDetail2: 'Il menu è pensato con cura per bilanciare i sei sapori (dolce, acido, salato, amaro, piccante, astringente) in ogni piatto, garantendo un’esperienza nutriente e soddisfacente. Ogni portata è preparata con attenzione, incorporando erbe e spezie ayurvediche note per le loro proprietà curative.',
            restaurantDetail3: 'Gli ospiti possono godere di una varietà di piatti adattati ai loro dosha individuali (costituzioni corporee), con opzioni per diete vegetariane, vegane e pescetariane. I nostri chef collaborano strettamente con i praticanti ayurvedici per assicurare che ogni pasto supporti gli obiettivi di salute e benessere degli ospiti.',
            restaurantDetail4: 'L’atmosfera del ristorante riflette l’ambiente costiero sereno, offrendo un contesto tranquillo per un pasto consapevole. Che si tratti di un abbondante buffet a colazione o di una cena gourmet, ogni pasto nel nostro ristorante ayurvedico è un’occasione per nutrire corpo e anima.',
            restaurantDetail5: 'Unisciti a noi al ristorante ayurvedico del Muthumuni Beach Resort per un viaggio culinario che celebra i ricchi sapori dello Sri Lanka abbracciando la saggezza senza tempo dell’Ayurveda.',
            restaurantImageAlt: 'Cena al Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Dining Premium',
            premiumDiningDescription: 'Vivi un’autentica cucina ayurvedica in un ambiente tranquillo sul fiume'
        },
        events2: {
            heroEyebrow: 'Esperienze e Attività',
            heroTitle: 'I Nostri Eventi',
            heroSubtitle: 'Esperienze curate che fondono tradizione srilankese e lusso costiero',
            heroAlt: 'Eventi a Muthumuni',
            availableDaily: 'Disponibile ogni giorno',
            bookNow: 'Prenota ora',
            highlightsTitle: 'Punti salienti',
            detailAlt: 'Dettaglio {{title}}',
            ctaTitle: 'Pronto a creare ricordi indimenticabili?',
            ctaDescription: 'Contatta il nostro team per personalizzare la tua esperienza evento perfetta al Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Contattaci',
            ctaViewRooms: 'Vedi le camere',
            cookeryTitle: 'Corsi di cucina',
            cookerySubtitle: 'Il sapore dello Sri Lanka',
            cookeryDescription: 'Immergiti nei vivaci sapori della cucina srilankese. I nostri chef esperti ti guideranno in sessioni pratiche di cucina, insegnandoti ricette tradizionali tramandate di generazione in generazione. Impara a preparare curry aromatici, hoppers, sambol al cocco e molto altro con ingredienti locali freschi.',
            cookeryHighlight1: 'Ricette tradizionali srilankesi',
            cookeryHighlight2: 'Esperienza pratica di cucina',
            cookeryHighlight3: 'Ingredienti locali freschi',
            cookeryHighlight4: 'Ricette da portare a casa',
            cookeryHighlight5: 'Visita al giardino delle spezie inclusa',
            meditationTitle: 'Programmi di meditazione',
            meditationSubtitle: 'Pace interiore e consapevolezza',
            meditationDescription: 'Trova tranquillità nelle nostre sessioni di meditazione guidata con vista sull’Oceano Indiano. I nostri istruttori esperti ti guideranno attraverso antiche tecniche di mindfulness, esercizi di respirazione e pratiche yoga per calmare la mente e rigenerare lo spirito.',
            meditationHighlight1: 'Sessioni all’alba e al tramonto',
            meditationHighlight2: 'Meditazione in spiaggia',
            meditationHighlight3: 'Guidate da esperti',
            meditationHighlight4: 'Tecniche di respirazione',
            meditationHighlight5: 'Pratiche di yoga e mindfulness',
            bbqTitle: 'Feste BBQ',
            bbqSubtitle: 'Celebrazioni sulla spiaggia',
            bbqDescription: 'Vivi serate indimenticabili con le nostre feste BBQ sulla spiaggia. Assapora frutti di mare freschi alla griglia, carni di prima qualità e delizie vegetariane mentre le onde sussurrano accanto. Musica dal vivo, ballerini del fuoco e cielo stellato creano l’atmosfera perfetta per festeggiare e connettersi.',
            bbqHighlight1: 'Frutti di mare freschi alla griglia',
            bbqHighlight2: 'Cena fronte oceano',
            bbqHighlight3: 'Intrattenimento dal vivo',
            bbqHighlight4: 'Esperienza falò',
            bbqHighlight5: 'Menu personalizzabili',
            boatTitle: 'Gite in barca',
            boatSubtitle: 'Avventure fluviali e costiere',
            boatDescription: 'Parti per incantevoli viaggi in barca lungo il fiume Bentota e le acque costiere. Scivola tra foreste di mangrovie, avvista uccelli esotici e fauna selvatica o goditi romantiche crociere al tramonto. Le nostre gite in barca offrono una prospettiva unica sulla bellezza naturale e sugli ecosistemi dello Sri Lanka.',
            boatHighlight1: 'Crociere sul fiume Bentota',
            boatHighlight2: 'Esplorazione delle mangrovie',
            boatHighlight3: 'Avvistamento fauna selvatica',
            boatHighlight4: 'Tour in barca al tramonto',
            boatHighlight5: 'Noleggio privato disponibile',
            ayurvedaLecturesTitle: 'Conferenze dei medici ayurvedici',
            ayurvedaLecturesSubtitle: 'Antica saggezza e benessere moderno',
            ayurvedaLecturesDescription: 'Scopri i principi profondi dell’Ayurveda attraverso conferenze tenute da medici e praticanti ayurvedici certificati. Impara il bilanciamento dei dosha, i rimedi erboristici, le pratiche di guarigione olistica e come la saggezza antica si applica al benessere moderno. Le nostre sessioni interattive rendono la filosofia ayurvedica chiara e applicabile nella vita quotidiana.',
            ayurvedaLecturesHighlight1: 'Medici ayurvedici certificati',
            ayurvedaLecturesHighlight2: 'Analisi personalizzata dei dosha',
            ayurvedaLecturesHighlight3: 'Educazione sui rimedi erboristici',
            ayurvedaLecturesHighlight4: 'Sessioni di domande e risposte incluse',
            ayurvedaLecturesHighlight5: 'Guida benessere da portare a casa',
            traditionalClothsTitle: 'Eventi di indossamento abiti tradizionali',
            traditionalClothsSubtitle: 'Esperienza di eredità culturale',
            traditionalClothsDescription: 'Immergiti nel patrimonio culturale srilankese imparando a indossare e apprezzare l’abbigliamento tradizionale. I nostri stilisti esperti ti guideranno nel vestire autentici sari Kandyan e abiti tradizionali, spiegando il significato culturale di ogni capo. Perfetto per occasioni speciali, apprezzamento culturale o foto memorabili.',
            traditionalClothsHighlight1: 'Guida professionale allo styling',
            traditionalClothsHighlight2: 'Sari tradizionali autentici',
            traditionalClothsHighlight3: 'Spiegazione del significato culturale',
            traditionalClothsHighlight4: 'Fotografia professionale inclusa',
            traditionalClothsHighlight5: 'Workshop di moda fusion'
        },
        blogs2: {
            heroTitle: 'Blog del Muthumuni Ayurveda River Resort',
            heroSubtitle1: 'Storie dalla riva del fiume, rituali ayurvedici al',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Immergiti in consigli, storia e dietro le quinte.',
            heroAlt: 'Passeggiata sul lungofiume del resort al tramonto',
            sectionTitle: 'Blog del Muthumuni Ayurveda River Resort',
            sectionDescription: 'Guide, storie e appunti dal nostro ritiro sul fiume — dai rituali ayurvedici alle pratiche di benessere fino ai consigli di viaggio intorno a Bentota.',
            ayurvedaTitle: 'Il cuore dell’autentica Ayurveda',
            ayurvedaExcerpt: 'Vivi antiche tradizioni curative radicate nella saggezza millenaria dello Sri Lanka.',
            ayurvedaDescription: 'Al Muthumuni Ayurveda River Resort l’Ayurveda è più di un trattamento: è uno stile di vita. Le nostre terapie si basano su conoscenze secolari, sono personalizzate in base al tuo tipo di corpo e guidate da medici ayurvedici esperti per un equilibrio profondo e duraturo.',
            ayurvedaAlt: 'Preparazione per trattamento ayurvedico con oli alle erbe ed elementi naturali',
            healingTitle: 'Percorsi di guarigione personalizzati',
            healingExcerpt: 'Perché ogni programma benessere è unico per ogni ospite.',
            healingDescription: 'Dalla consulenza iniziale ai trattamenti quotidiani, il tuo percorso di guarigione è attentamente calibrato. Terapie a base di erbe, massaggi terapeutici, yoga e meditazione lavorano insieme per ristabilire l’armonia tra corpo, mente e spirito.',
            healingAlt: 'Medico ayurvedico che consulta un ospite in un ambiente tranquillo',
            natureTitle: 'Guarigione lungo il fiume',
            natureExcerpt: 'Come l’ambiente fluviale sereno e la natura tropicale amplificano il tuo benessere.',
            natureDescription: 'Immerso lungo il tranquillo fiume dello Sri Lanka, Muthumuni offre un ambiente naturalmente curativo. Il dolce scorrere del fiume, l’aria fresca e la vegetazione lussureggiante potenziano gli effetti dell’Ayurveda, regalando profondo relax e rinnovamento.',
            natureAlt: 'Vista sul fiume del resort con palme e natura',
            foodTitle: 'Cucina ayurvedica per l’equilibrio interiore',
            foodExcerpt: 'Pasti nutrienti creati per supportare il tuo trattamento.',
            foodDescription: 'La nostra cucina ayurvedica è preparata fresca ogni giorno con ingredienti di stagione provenienti dal territorio. Ogni piatto è in armonia con il tuo dosha, favorisce digestione, disintossicazione e vitalità rimanendo gustoso e soddisfacente.',
            foodAlt: 'Pasto ayurvedico tradizionale servito in ciotole naturali',
            yogaTitle: 'Yoga, meditazione e quiete interiore',
            yogaExcerpt: 'Pratiche gentili che calmano la mente e rafforzano il corpo.',
            yogaDescription: 'Sessioni quotidiane di yoga e meditazione completano i tuoi trattamenti, migliorando flessibilità, respirazione e chiarezza mentale. Queste pratiche consapevoli ti aiutano a riconnetterti con te stesso e a portare con te una sensazione di pace anche dopo la partenza.',
            yogaAlt: 'Ospiti che praticano yoga con vista sul fiume all’alba',
            lifestyleTitle: 'Portare l’Ayurveda a casa',
            lifestyleExcerpt: 'Semplici abitudini di vita per continuare il tuo percorso di benessere.',
            lifestyleDescription: 'Prima di partire, i nostri esperti ti guideranno su come mantenere l’equilibrio attraverso routine quotidiane, alimentazione e rituali di cura di sé. Porta a casa più che ricordi: porta con te un cammino sostenibile verso una vita più sana.',
            lifestyleAlt: 'Ospite che si rilassa con tè alle erbe in un ambiente sereno del resort',
            readMore: 'Leggi di più'
        },
        tours2: {
            heroTitle: 'Tour ed Escursioni',
            heroSubtitle: 'Scopri la bellezza dello Sri Lanka da Beruwala',
            kandeAlt: 'Tempio Kande Vihara - Beruwala',
            kandeTitle: 'Visita al Tempio Kande Vihara',
            kandeBuddhaAlt: 'Statua gigante del Buddha al Tempio Kande Vihara',
            bentotaTitle: 'Safari in barca sul fiume Bentota',
            bentotaAlt: 'Safari in barca sul fiume Bentota - Mangrovie e fauna selvatica',
            galleTitle: 'Tour della città vecchia di Galle',
            galleAlt: 'Tour della città vecchia di Galle',
            sigiriyaTitle: 'Tour della fortezza rocciosa di Sigiriya',
            sigiriyaAlt: 'Tour della fortezza rocciosa di Sigiriya',
            kandyTitle: 'Tour culturale a Kandy',
            kandyAlt: 'Tour culturale a Kandy',
            bookTour: 'Prenota Questo Tour',
            introPara1: 'Lo Sri Lanka è una terra di bellezza senza tempo, dove spiagge dorate, paesaggi verdi lussureggianti, antichi templi e una cultura vibrante si fondono in perfetta armonia.',
            introPara2: 'Dalla tranquilla costa sud-occidentale alle città storiche, siti sacri, riserve naturali e alle regioni collinari nebbiose, ogni viaggio offre un’esperienza unica e indimenticabile.',
            introPara3: 'Partendo dal Muthumuni Ayurveda Beach Resort a Beruwala, i nostri tour ed escursioni accuratamente selezionati sono pensati per arricchire il vostro soggiorno, bilanciando perfettamente esplorazione, relax e benessere.',
            kandeDetail1: 'Tempio Kande Vihara (Kande Viharaya) – uno dei templi buddisti più iconici vicino a Beruwala.',
            kandeDetail2: 'Fondato nel 1734, questo sereno “Tempio di Montagna” si trova in cima a una collina con viste pacifiche sulla costa.',
            kandeDetail3: 'I punti salienti includono la massiccia statua seduta del Buddha alta 48 metri (160 ft), una delle più alte dello Sri Lanka, affreschi intricati dell’epoca Kandyan, antica camera delle reliquie, splendido ingresso con pietra lunare e un albero sacro Bodhi di oltre 300 anni.',
            kandeDetail4: 'Un’esperienza spirituale e culturale perfetta per mezza giornata – ideale al mattino per evitare il caldo.',
            bentotaDetail1: 'Goditi un tranquillo e panoramico safari in barca lungo il fiume Bentota, una delle escursioni naturalistiche più popolari vicino a Beruwala.',
            bentotaDetail2: 'Scivola tra mangrovie lussureggianti, canali stretti e acque calme osservando la fauna locale.',
            bentotaDetail3: 'Avvistamenti comuni includono varani, coccodrilli, varie specie di uccelli (martin pescatore, aironi, aquile), scimmie e occasionalmente lontre o serpenti d’acqua.',
            bentotaDetail4: 'Il tuo esperto barcaiolo/guida ti indicherà flora interessante, metodi tradizionali di pesca e la vita nei villaggi lungo il fiume.',
            bentotaDetail5: 'Perfetto per gli amanti della natura e i fotografi – calmo, rilassante e complementare al tuo soggiorno ayurvedico di benessere.',
            galleDetail1: 'Esplora il Forte di Galle storico, sito UNESCO Patrimonio dell’Umanità e una delle fortezze coloniali meglio conservate dello Sri Lanka.',
            galleDetail2: 'Passeggia per le strade acciottolate fiancheggiate da edifici coloniali olandesi, boutique, caffè e gallerie d’arte.',
            galleDetail3: 'Visita punti di riferimento chiave come il Faro di Galle, la Dutch Reformed Church, il Museo Marittimo Nazionale e le mura con viste mozzafiato sull’oceano.',
            galleDetail4: 'Scopri la ricca storia, l’architettura e l’importanza culturale del forte grazie alla tua guida esperta.',
            galleDetail5: 'Ideale per appassionati di storia, amanti della cultura e per chi desidera vivere il passato coloniale dello Sri Lanka.',
            sigiriyaDetail1: 'Scopri l’antica fortezza rocciosa di Sigiriya, uno dei simboli più iconici dello Sri Lanka e sito UNESCO Patrimonio dell’Umanità.',
            sigiriyaDetail2: 'Sali sulla spettacolare roccia per esplorare le rovine del palazzo del re Kasyapa, adornate con affreschi, giardini d’acqua e la famosa Specchio Wall.',
            sigiriyaDetail3: 'Goditi viste panoramiche sulla giungla circostante e sulla campagna dalla cima.',
            sigiriyaDetail4: 'Impara la affascinante storia, l’architettura e le leggende di Sigiriya dalla tua guida esperta.',
            sigiriyaDetail5: 'Perfetto per appassionati di storia, avventurieri e per chi è interessato al ricco patrimonio culturale dello Sri Lanka.',
            kandyDetail1: 'Vivi la vibrante cultura di Kandy, l’ultima capitale reale dello Sri Lanka e sito UNESCO Patrimonio dell’Umanità.',
            kandyDetail2: 'Visita il Tempio del Dente Sacro (Sri Dalada Maligawa), uno dei luoghi buddisti più importanti al mondo.',
            kandyDetail3: 'Esplora i Royal Botanical Gardens di Peradeniya, con un’enorme collezione di piante tropicali e orchidee.',
            kandyDetail4: 'Assisti a uno spettacolo tradizionale di danza Kandyan che mette in mostra il ricco patrimonio artistico dello Sri Lanka.',
            kandyDetail5: 'Ideale per amanti della cultura, appassionati di storia e per chi desidera immergersi nelle tradizioni dello Sri Lanka.'
        },
        rooms: {
            heroTitle: 'Il tuo santuario ti aspetta',
            heroSubtitle: 'Camere meticolosamente progettate per la guarigione, il ripristino e la profonda pace.',
            heroAlt: 'Camere del Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Esplora le nostre camere',
            filterAll: 'Tutto',
            filterLuxurySuite: 'Suite Lusso',
            filterDeluxeRooms: 'Camere Deluxe',
            filterDeluxeSeaView: 'Camera Deluxe con vista sul mare',
            noRoomsFound: 'Nessuna camera trovata in questa categoria.',
            allRoomsInclude: 'Tutte le camere includono',
            essentialComforts: 'Comfort essenziali per il tuo viaggio di benessere',
            roomSize: 'Dimensioni della camera',
            guests: 'Ospiti',
            amenities: 'Servizi',
            roomAmenities: 'Servizi della camera',
            specialFeatures: 'Caratteristiche speciali',
            bookNow: 'Prenota ora',
            viewDetails: 'Visualizza dettagli',
            highSpeedWifi: 'WiFi ad alta velocità',
            herbalTea: 'Selezione di tè alle erbe',
            climateControl: 'Controllo del clima',
            rainShower: 'Doccia a pioggia',
            organicToiletries: 'Articoli da toilette biologici',
            dailyHousekeeping: 'Pulizia giornaliera della camera',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tappetino yoga e accessori',
            beginHealing: 'Inizia il tuo viaggio di guarigione',
            beginHealingDesc: 'Sperimenta il benessere ayurvedico autentico in un ambiente progettato per nutrire il tuo corpo, calmare la tua mente e ripristinare il tuo spirito.',
            reserveRoom: 'Prenota una camera',
            speakAdvisor: 'Parla con un consulente del benessere',
            exploreOurRooms: 'Esplora le nostre camere',
            viewRoom: 'Visualizza camera',
            luxurySuiteName: 'Suite Lusso',
            luxurySuiteCategory: 'Suite Lusso',
            luxurySuiteDesc: 'Sperimenta la massima tranquillità nella nostra spaziosa suite di lusso, progettata secondo i principi ayurvedici tradizionali con una vista panoramica sul mare.',
            deluxeRoomName: 'Camera Deluxe',
            deluxeRoomCategory: 'Camera Deluxe',
            deluxeRoomDesc: 'Camera armoniosamente progettata con elementi in legno naturale e caratteristiche dolci con acqua per una tranquillità perfetta.',
            seaViewDeluxeName: 'Deluxe con vista sul mare',
            seaViewDeluxeCategory: 'Camera Deluxe con vista sul mare',
            seaViewDeluxeDesc: 'Svegliati con una brezza marina tranquillizzante e viste panoramiche sul mare in questa camera deluxe elegantemente progettata.',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'Camera Deluxe — Comfort con terrazza o balcone privato',
                heroSubtitle: 'Rilassati in un tranquillo rifugio costiero ispirato alle spiagge dorate di Bentota, che unisce comfort moderni con dolci brezze marine.',
                bookThisRoom: 'Prenota questa camera',
                callReservations: 'Chiama per prenotazioni',
                navAll: 'Tutte',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe con vista sul mare',
                navSuite: 'Suite',
                sectionTitle: 'Un rifugio costiero rilassante',
                sectionDesc: 'La Camera Deluxe è realizzata per mattine lente e tramonti senza fretta. Toni neutri morbidi, ampie vetrate e illuminazione accurata invitano la vista sul mare, mentre il balcone offre il tuo perché sopra la costa.',
                highlight1Title: 'Viste panoramiche sulla spiaggia',
                highlight1Desc: 'Svegliati con acque azzurre e albe dorate dal tuo balcone privato.',
                highlight2Title: 'Interni costieri eleganti',
                highlight2Desc: 'Palette neutre morbide, accenti di legno caldo e abbondante luce naturale.',
                highlight3Title: 'Esperienza di sonno serena',
                highlight3Desc: 'Letto king plush con lenzuola premium curate per un riposo ristoratore.',
                atAGlance: 'A colpo d\'occhio',
                statSize: 'Dimensioni',
                statSizeValue: '41 mq',
                statView: 'Vista',
                statViewValue: 'Oceano Indiano',
                statGuests: 'Ospiti',
                statGuestsValue: '2 Adulti',
                statBed: 'Letto',
                statBedValue: 'King o Twin',
                reserve: 'Prenota',
                galleryAlt: 'Galleria camera Deluxe',
                inclusionsTitle: 'Incluso nel soggiorno',
                inclusionsSubtitle: 'Tocchi premurosi, comfort tutto il giorno',
                enhancedCleanliness: 'Standard di pulizia e sicurezza migliorati',
                inclusion1: 'Colazione, pranzo, cena gratuiti al ristorante Breeze',
                inclusion2: 'Wi-Fi ad alta velocità e area di lavoro in camera',
                inclusion3: 'Servizio in camera e concierge 24 ore',
                inclusion4: 'Pulizia giornaliera della camera con apertura serale',
                inclusion5: 'Accesso alla piscina a sfioro e alle strutture spa ayurvediche',
                inclusion6: 'Parcheggio gratuito e servizio navetta per le attrazioni vicine',
                amenityGroup1Title: 'Caratteristiche della camera',
                amenityGroup1Item1: '41 mq di spazio',
                amenityGroup1Item2: 'Balcone privato con posti a sedere',
                amenityGroup1Item3: 'Aria condizionata con controllo climatico',
                amenityGroup1Item4: 'Cassaforte in camera',
                amenityGroup2Title: 'Esperienza bagno',
                amenityGroup2Item1: 'Doccia a pioggia con acqua calda e fredda',
                amenityGroup2Item2: 'Articoli da bagno premium',
                amenityGroup2Item3: 'Asciugacapelli',
                amenityGroup2Item4: 'Morbidi accappatoi e pantofole',
                amenityGroup3Title: 'Comfort in camera',
                amenityGroup3Item1: 'Smart TV da 55" con cavo',
                amenityGroup3Item2: 'Stazione caffè e tè',
                amenityGroup3Item3: 'Telefono a selezione diretta',
                amenityGroup4Title: 'Connettività',
                amenityGroup4Item1: 'Wi-Fi gratuito',
                amenityGroup4Item2: 'Scrivania',
                amenityGroup4Item3: 'Supporto reception 24/7',
                essentialsTitle: 'Essenziali in camera',
                essentialsHeading: 'Tutto ciò di cui hai bisogno per sentirti a casa',
                essentialsDesc: 'Dalla connettività senza soluzione di continuità ai rinfreschi scelti con cura, la Camera Deluxe fonde svago e praticità in modo che tu possa concentrarti sui momenti che contano.',
                essential1: 'Wi-Fi gratuito',
                essential2: 'Stazione caffè e tè',
                essential3: 'Servizio in camera 24/7',
                essential4: 'Doccia a pioggia',
                oceanTitle: 'Vicino all\'oceano',
                oceanSubtitle: 'Rallenta, respira l\'aria del mare',
                oceanAlt: 'Area soggiorno camera Deluxe',
                ctaTitle: 'Pronto per soggiornare?',
                ctaHeading: 'Prenota la Camera Deluxe oggi',
                ctaDesc: 'Parla con il nostro team di prenotazioni per le migliori tariffe disponibili e offerte speciali.',
                checkAvailability: 'Verifica disponibilità'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Comfort con un fascino costiero sereno',
                bookThisRoom: 'Prenota questa camera',
                callReservations: 'Chiama prenotazioni',
                navAll: 'Tutte',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe con Vista sul Mare',
                navSuite: 'Suite',
                sectionTitle: 'Un rifugio costiero tranquillo',
                sectionDesc: 'La Suite Lussuosa è progettata per mattinate tranquille e tramonti senza fretta. Tonalità neutre morbide, generosa vetrazione e illuminazione premurosa invitano la vista sul mare, mentre il balcone offre il vostro posto sopra la riva.',
                highlight1Title: 'Viste Panoramiche sulla Spiaggia',
                highlight1Desc: 'Svegliatevi con acque azzurre e albe dorate dal vostro balcone privato.',
                highlight2Title: 'Interni Costieri Eleganti',
                highlight2Desc: 'Palette neutre morbide, accenti in legno caldo e luce naturale generosa.',
                highlight3Title: 'Esperienza di Sonno Sereno',
                highlight3Desc: 'Letto King Size morbido con biancheria di lusso curata per un riposo rigenerante.',
                atAGlance: 'A prima vista',
                statSize: 'Dimensione',
                statSizeValue: '41 mq',
                statView: 'Vista',
                statViewValue: 'Oceano Indiano',
                statGuests: 'Ospiti',
                statGuestsValue: '2 Adulti',
                statBed: 'Letto',
                statBedValue: 'King o Twin',
                reserve: 'Prenota',
                galleryAlt: 'Camera Suite',
                inclusionsTitle: 'Incluso nel soggiorno',
                inclusionsSubtitle: 'Tocchi premurosi, comfort tutto il giorno',
                enhancedCleanliness: 'Standard di pulizia e sicurezza migliorati',
                inclusion1: 'Colazione, pranzo, cena gratuiti al Ristorante Breeze',
                inclusion2: 'Wi-Fi ad alta velocità e spazio di lavoro in camera',
                inclusion3: 'Servizio in camera e concierge 24 ore',
                inclusion4: 'Pulizia giornaliera della camera con viraggio serale',
                inclusion5: 'Accesso alla piscina a sfioro e alle strutture spa Ayurveda',
                inclusion6: 'Parcheggio gratuito e servizio navetta per le attrazioni vicine',
                amenityGroup1Title: 'Caratteristiche della Camera',
                amenityGroup1Item1: '41 mq di spazio',
                amenityGroup1Item2: 'Balcone privato con posti a sedere',
                amenityGroup1Item3: 'Aria condizionata con controllo climatico',
                amenityGroup1Item4: 'Cassaforte in camera',
                amenityGroup2Title: 'Esperienza Bagno',
                amenityGroup2Item1: 'Doccia a pioggia con acqua calda e fredda',
                amenityGroup2Item2: 'Articoli da bagno di lusso',
                amenityGroup2Item3: 'Asciugacapelli',
                amenityGroup2Item4: 'Accappatoi e pantofole morbidi',
                amenityGroup3Title: 'Comfort in Camera',
                amenityGroup3Item1: 'Smart TV 55" con cavo',
                amenityGroup3Item2: 'Stazione caffè e tè',
                amenityGroup3Item3: 'Telefono con selezione diretta',
                amenityGroup4Title: 'Connettività',
                amenityGroup4Item1: 'Wi-Fi gratuito',
                amenityGroup4Item2: 'Scrivania di lavoro',
                amenityGroup4Item3: 'Supporto receptionist 24/7',
                essentialsTitle: 'Essenziali in Camera',
                essentialsHeading: 'Tutto ciò che ti serve per sentirti a casa',
                essentialsDesc: 'Dalla connettività senza soluzione di continuità ai rinfreschi accuratamente selezionati, la Suite Lussuosa fonde il tempo libero e la praticità in modo che tu possa concentrarti sui momenti che contano.',
                essential1: 'Wi-Fi gratuito',
                essential2: 'Stazione caffè e tè',
                essential3: 'Servizio in camera 24/7',
                essential4: 'Doccia a pioggia',
                oceanTitle: 'Vicino all\'oceano',
                oceanSubtitle: 'Rallenta, respira l\'aria del mare',
                oceanAlt: 'Vista dall\'oceano',
                ctaTitle: 'Pronto per soggiornare?',
                ctaHeading: 'Prenota la Suite Lussuosa oggi',
                ctaDesc: 'Parla con il nostro team di prenotazioni per le migliori tariffe disponibili e offerte speciali.',
                checkAvailability: 'Verifica disponibilità'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Resorts',
                heroTitle: 'Camera Deluxe con vista sul mare',
                heroSubtitle: 'Immergiti nel lusso con viste mozzafiato sull\'orizzonte marino',
                bookThisRoom: 'Prenota questa camera',
                callReservations: 'Chiama la prenotazione',
                navAll: 'Tutte le camere',
                navDeluxe: 'Camera Deluxe',
                navDeluxeSeaView: 'Camera Deluxe con vista sul mare',
                navSuite: 'Suite Lussuosa',
                sectionTitle: 'Scopri il lusso',
                sectionDesc: 'Le nostre camere Deluxe con vista sul mare offrono una miscela impeccabile di comfort e elegance. Ogni camera è stata attentamente progettata per fornire un\'esperienza di soggiorno senza pari.',
                highlight1Title: 'Vista sulla spiaggia privata',
                highlight1Desc: 'Accesso diretto alla nostra spiaggia privata con sabbia bianca',
                highlight2Title: 'Camera spaziosa',
                highlight2Desc: '75 metri quadri di spazio meraviglioso per vivere',
                highlight3Title: 'Vasca all\'aperto',
                highlight3Desc: 'Prova il lusso privato sotto le stelle',
                atAGlance: 'A prima vista',
                stat1Label: 'Dimensione',
                stat1Value: '75 mq',
                stat2Label: 'Visualizza',
                stat2Value: 'Vistamarina',
                stat3Label: 'Ospiti',
                stat3Value: '2 adulti',
                stat4Label: 'Letto',
                stat4Value: 'Re',
                reserve: 'Prenota',
                galleryAlt: 'Lussuosa camera Deluxe con vista sul mare',
                inclusionsTitle: 'Cosa è incluso',
                inclusionsSubtitle: 'Ogni camera include',
                inclusion1: 'Colazione con vista sul mare',
                inclusion2: 'Bevanda di benvenuto al tramonto',
                inclusion3: 'Servizio bar espresso giornaliero',
                inclusion4: 'Accesso illimitato alla spa',
                inclusion5: 'Trasporto privato in spiaggia',
                inclusion6: 'Wi-Fi premium',
                enhancedCleanliness: 'Pulizia avanzata e protocolli di sicurezza',
                amenityGroup1Title: 'Camera da letto',
                amenityGroup1Item1: 'Oscuramento automatico',
                amenityGroup1Item2: 'Cotone premium al 100%',
                amenityGroup1Item3: 'Cuscini di diverse rigidità',
                amenityGroup2Title: 'Bagno',
                amenityGroup2Item1: 'Cosmetici Bvlgari',
                amenityGroup2Item2: 'Pavimenti riscaldati',
                amenityGroup2Item3: 'Sistema SPA integrato',
                amenityGroup3Title: 'Soggiorno',
                amenityGroup3Item1: 'TV satellitare premium',
                amenityGroup3Item2: 'Cucina completamente attrezzata',
                amenityGroup3Item3: 'Home theater',
                amenityGroup4Title: 'All\'aperto',
                amenityGroup4Item1: 'Terrazza privata con vasca idromassaggio',
                amenityGroup4Item2: 'Letto sospeso in stile balinese',
                amenityGroup4Item3: 'Sistema di irrigazione automatico',
                essentialsTitle: 'Essenziali',
                essentialsHeading: 'Le tue necessità essenziali in camera',
                essentialsDesc: 'Tutto il necessario nella stanza',
                essential1: 'Minibar con bevande premium',
                essential2: 'Stazione caffè e tè',
                essential3: 'Servizio in camera 24/7',
                essential4: 'Doccia a pioggia',
                oceanTitle: 'Vicino all\'oceano',
                oceanSubtitle: 'Rallenta, respira l\'aria del mare',
                oceanAlt: 'Vista dall\'oceano',
                ctaTitle: 'Pronto per soggiornare?',
                ctaHeading: 'Prenota la camera Deluxe con vista sul mare oggi',
                ctaDesc: 'Parla con il nostro team di prenotazioni per le migliori tariffe disponibili e offerte speciali.',
                checkAvailability: 'Verifica disponibilità'
            }
        },

        navbar: {
            home: 'Home',
            aboutUs: 'Chi siamo',
            rooms: 'Camere',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Cucina',
            events: 'Eventi',
            blogs: 'Blog',
            tours: 'Tour',
            contactUs: 'Contatti',
            bookOnline: 'Prenota online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Seleziona resort',
            language: 'Lingua',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Home',
            aboutUs: 'Chi siamo',
            rooms: 'Camere',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Cucina',
            events: 'Eventi',
            blogs: 'Blog',
            tours: 'Tour',
            contactUs: 'Contatti',
            bookOnline: 'Prenota online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Seleziona resort',
            language: 'Lingua',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort si impegna a offrire un’ospitalità eccezionale e esperienze di benessere, affinché ogni ospite si senta valorizzato e rigenerato.',
            linksTitle: 'Link',
            contactTitle: 'Contatti',
            viewLocation: 'Vedi posizione',
            navHome: 'Home',
            navAbout: 'Chi siamo',
            navContact: 'Contatti',
            navRooms: 'Camere',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Sviluppato da',
            developerName: 'Redev Solution +94 764 608 225'
        }, tours: {
            heroTitle: 'Tour e Escursioni',
            heroSubtitle: 'Scopri la bellezza dello Sri Lanka da Beruwala',
            kandeAlt: 'Tempio Kande Vihara - Beruwala',
            kandeTitle: 'Visita del Tempio Kande Vihara',
            kandeBuddhaAlt: 'Gigantesca statua del Buddha al tempio Kande Vihara',
            bentotaTitle: 'Safari in barca sul fiume Bentota',
            bentotaAlt: 'Safari in barca sul fiume Bentota - Mangrovie e Fauna',
            galleTitle: 'Tour della Città Vecchia di Galle',
            galleAlt: 'Tour della Città Vecchia di Galle',
            sigiriyaTitle: 'Tour della Fortezza Rocciosa di Sigiriya',
            sigiriyaAlt: 'Tour della Fortezza Rocciosa di Sigiriya',
            kandyTitle: 'Tour Culturale di Kandy',
            kandyAlt: 'Tour Culturale di Kandy',
            bookTour: 'Prenota questo tour',
            introPara1: 'Lo Sri Lanka è una terra di bellezza senza tempo, dove spiagge dorate, paesaggi verdeggianti, templi antichi e cultura vibrante si uniscono in perfetta armonia.',
            introPara2: 'Dalla tranquilla costa sud-occidentale alle città storiche, ai siti sacri, alle riserve naturali e alle colline nebbiose, ogni viaggio offre un\'esperienza unica e indimenticabile.',
            introPara3: 'Partendo dal Muthumuni Ayurveda Beach Resort a Beruwala, i nostri tour e le escursioni accuratamente curati sono progettati per arricchire il vostro soggiorno, bilanciando perfettamente l\'esplorazione, il relax e il benessere.',
            kandeDetail1: 'Tempio Kande Vihara (Kande Viharaya) – uno dei templi buddhisti più iconici vicino a Beruwala.',
            kandeDetail2: 'Fondato nel 1734, questo sereno \'Tempio della Montagna\' si trova in cima a una collina con viste tranquille sulla costa.',
            kandeDetail3: 'I punti salienti includono la massiccia statua del Buddha seduto di 48 metri (una delle più alte dello Sri Lanka), affreschi intricati dell\'era Kandyan, un\'antica camera reliquiaria, un bellissimo ingresso in pietra di luna e un antico albero di Bodhi sacro di oltre 300 anni.',
            kandeDetail4: 'Un\'esperienza spirituale e culturale perfetta per mezza giornata – ideale per visite mattutine per evitare il caldo.',
            bentotaDetail1: 'Goditi un tranquillo e pittoresco safari in barca lungo il fiume Bentota, una delle escursioni naturalistiche più popolari vicino a Beruwala.',
            bentotaDetail2: 'Scivola attraverso lussureggianti mangrovie, canali stretti e acque serene mentre osservi la fauna locale.',
            bentotaDetail3: 'Gli avvistamenti comuni includono lucertole monitor, coccodrilli, varie specie di uccelli (martin pescatori, aironi, aquile), scimmie e occasionalmente lontre o serpenti acquatici.',
            bentotaDetail4: 'Il vostro barcaiolo/guida esperto vi indicherà flora interessante, metodi di pesca tradizionali e la vita nei villaggi fluviali.',
            bentotaDetail5: 'Perfetto per gli amanti della natura e i fotografi – tranquillo, rilassante e complementare al vostro soggiorno ayurvedico di benessere.',
            galleDetail1: 'Esplora il Forte storico di Galle, un Sito Patrimonio dell\'Umanità UNESCO e uno dei forti coloniali meglio conservati dello Sri Lanka.',
            galleDetail2: 'Passeggia per le strade acciottolate fiancheggiate da edifici coloniali olandesi, negozi boutique, caffetterie e gallerie d\'arte.',
            galleDetail3: 'Visita i monumenti chiave come il Faro di Galle, la Chiesa Riformata Olandese, il Museo Marittimo Nazionale e i bastioni che offrono splendide viste sull\'oceano.',
            galleDetail4: 'Scopri la ricca storia, l\'architettura e il significato culturale della fortezza dalla tua guida esperta.',
            galleDetail5: 'Ideale per gli appassionati di storia, gli amanti della cultura e coloro che desiderano sperimentare il passato coloniale dello Sri Lanka.',
            sigiriyaDetail1: 'Scopri l\'antica fortezza rocciosa di Sigiriya, uno dei monumenti più iconici dello Sri Lanka e un Sito Patrimonio dell\'Umanità UNESCO.',
            sigiriyaDetail2: 'Arrampicati sulla roccia impressionante per esplorare le rovine del palazzo del Re Kasyapa, ornato di affreschi, giardini d\'acqua e il famoso Muro degli Specchi.',
            sigiriyaDetail3: 'Goditi le viste panoramiche della giungla circostante e della campagna dalla vetta.',
            sigiriyaDetail4: 'Scopri la affascinante storia, l\'architettura e le leggende associate a Sigiriya dalla tua guida esperta.',
            sigiriyaDetail5: 'Perfetto per gli amanti della storia, i cercatori di avventure e coloro interessati al ricco patrimonio culturale dello Sri Lanka.',
            kandyDetail1: 'Sperimenta la cultura vibrante di Kandy, l\'ultima capitale reale dello Sri Lanka e un Sito Patrimonio dell\'Umanità UNESCO.',
            kandyDetail2: 'Visita il Tempio della Reliquia del Dente Sacro (Sri Dalada Maligawa), uno dei siti buddhisti più importanti del mondo.',
            kandyDetail3: 'Esplora i Giardini Botanici Reali a Peradeniya, sede di una vasta collezione di piante tropicali e orchidee.',
            kandyDetail4: 'Goditi un tradizionale spettacolo di danza Kandyan, che mostra il ricco patrimonio artistico dello Sri Lanka.',
            kandyDetail5: 'Ideale per gli amanti della cultura, i buffi della storia e coloro che desiderano immergersi nelle tradizioni dello Sri Lanka.'
        },
        blogs: {
            heroTitle: 'Blog di Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Storie dalla riva, rituali Ayurveda al',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Immergiti in suggerimenti, storia e note dietro le quinte.',
            heroAlt: 'Passerella sulla spiaggia del resort al tramonto',
            sectionTitle: 'Blog di Muthumuni Ayurveda Beach Resort',
            sectionDescription: 'Guide, storie e note dal nostro rifugio costiero — dai rituali Ayurveda alla storia delle gemme e consigli di viaggio intorno a Bentota.',
            ayurvedaTitle: 'Il cuore dell\'Ayurveda autentico',
            ayurvedaExcerpt: 'Sperimenta tradizioni di guarigione antiche radicate nell\'antica saggezza dello Sri Lanka.',
            ayurvedaDescription: 'Al Muthumuni Ayurveda Beach Resort, l\'Ayurveda è più di un trattamento — è uno stile di vita. Le nostre terapie si basano su conoscenze secolari, personalizzate per il tuo tipo di corpo e guidate da medici ayurvedici esperti per un equilibrio profondo e duraturo.',
            ayurvedaAlt: 'Allestimento di trattamento ayurvedico con oli alle erbe ed elementi naturali',
            healingTitle: 'Percorsi di guarigione personalizzati',
            healingExcerpt: 'Perché il programma di benessere di ogni ospite è progettato in modo unico.',
            healingDescription: 'Dalle consultazioni iniziali ai trattamenti quotidiani, il tuo percorso di guarigione è accuratamente personalizzato. Terapie a base di erbe, massaggi terapeutici, yoga e meditazione lavorano insieme per ripristinare l\'armonia tra corpo, mente e spirito.',
            healingAlt: 'Medico ayurvedico che consulta un ospite in un ambiente tranquillo',
            natureTitle: 'Guarigione in riva all\'oceano',
            natureExcerpt: 'Come la brezza marina e i dintorni tropicali migliorano il tuo benessere.',
            natureDescription: 'Situato lungo la tranquilla costa dello Sri Lanka, Muthumuni offre un ambiente naturalmente curativo. Il suono delle onde, l\'aria fresca dell\'oceano e la vegetazione rigogliosa amplificano gli effetti dell\'Ayurveda, creando profondo relax e rinnovamento.',
            natureAlt: 'Vista sulla spiaggia del resort con palme e oceano',
            foodTitle: 'Cucina ayurvedica per l\'equilibrio interiore',
            foodExcerpt: 'Pasti nutrienti creati per supportare il tuo trattamento.',
            foodDescription: 'La nostra cucina ayurvedica è preparata fresca utilizzando ingredienti stagionali di provenienza locale. Ogni pasto è allineato con il tuo dosha, supportando la digestione, la disintossicazione e la vitalità complessiva pur rimanendo gustoso e soddisfacente.',
            foodAlt: 'Pasto ayurvedico tradizionale servito in ciotole naturali',
            yogaTitle: 'Yoga, meditazione e quiete interiore',
            yogaExcerpt: 'Pratiche gentili che calmano la mente e rafforzano il corpo.',
            yogaDescription: 'Le sessioni quotidiane di yoga e meditazione completano i tuoi trattamenti, migliorando flessibilità, respirazione e chiarezza mentale. Queste pratiche consapevoli ti aiutano a riconnetterti con te stesso e a portare un senso di pace oltre il tuo soggiorno.',
            yogaAlt: 'Ospiti che praticano yoga di fronte all\'oceano all\'alba',
            lifestyleTitle: 'Portare l\'Ayurveda a casa',
            lifestyleExcerpt: 'Pratiche di stile di vita semplici per continuare il tuo percorso di benessere.',
            lifestyleDescription: 'Prima della partenza, i nostri esperti ti guidano nel mantenere l\'equilibrio attraverso routine quotidiane, dieta e rituali di cura di sé. Porta a casa più dei ricordi — porta a casa un percorso sostenibile verso una vita più sana.',
            lifestyleAlt: 'Ospite che si rilassa con tè alle erbe in un ambiente sereno del resort',
            readMore: 'Leggi di più'
        },
        events: {
            heroEyebrow: 'Esperienze e attività',
            heroTitle: 'I nostri eventi',
            heroSubtitle: 'Esperienze curate che uniscono tradizione srilankese e lusso costiero',
            heroAlt: 'Eventi a Muthumuni',
            availableDaily: 'Disponibile ogni giorno',
            bookNow: 'Prenota ora',
            highlightsTitle: 'Punti salienti',
            detailAlt: 'Dettaglio {{title}}',
            ctaTitle: 'Pronto a creare ricordi?',
            ctaDescription: 'Contatta il nostro team per personalizzare la tua esperienza evento perfetta al Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Contattaci',
            ctaViewRooms: 'Vedi camere',
            cookeryTitle: 'Programmi di cucina',
            cookerySubtitle: 'Il gusto dello Sri Lanka',
            cookeryDescription: 'Immergiti nei sapori vivaci della cucina srilankese. I nostri chef esperti ti guidano in sessioni di cucina pratica, insegnando ricette tradizionali tramandate di generazione in generazione. Impara a preparare curry aromatici, hoppers, sambol al cocco e altro con ingredienti locali freschi.',
            cookeryHighlight1: 'Ricette tradizionali srilankesi',
            cookeryHighlight2: 'Esperienza pratica di cucina',
            cookeryHighlight3: 'Ingredienti locali freschi',
            cookeryHighlight4: 'Porta a casa le ricette',
            cookeryHighlight5: 'Tour del giardino delle spezie incluso',
            meditationTitle: 'Programmi di meditazione',
            meditationSubtitle: 'Pace interiore e consapevolezza',
            meditationDescription: 'Trova tranquillità nelle nostre sessioni di meditazione guidata con lo sfondo sereno dell\'Oceano Indiano. I nostri istruttori esperti ti guidano attraverso antiche tecniche di consapevolezza, esercizi di respirazione e pratiche di yoga progettate per calmare la mente e rigenerare lo spirito.',
            meditationHighlight1: 'Sessioni all\'alba e al tramonto',
            meditationHighlight2: 'Meditazione fronte mare',
            meditationHighlight3: 'Guidato da esperti',
            meditationHighlight4: 'Tecniche di respirazione',
            meditationHighlight5: 'Pratiche di yoga e mindfulness',
            bbqTitle: 'Feste BBQ',
            bbqSubtitle: 'Celebrazioni in spiaggia',
            bbqDescription: 'Vivi serate indimenticabili con le nostre feste BBQ in spiaggia. Gusta frutti di mare appena grigliati, carni premium e delizie vegetariane mentre le onde sussurrano nelle vicinanze. Musica dal vivo, danzatori del fuoco e il cielo stellato creano l\'atmosfera perfetta per festeggiare e connettersi.',
            bbqHighlight1: 'Frutti di mare alla griglia',
            bbqHighlight2: 'Cenare fronte oceano',
            bbqHighlight3: 'Intrattenimento dal vivo',
            bbqHighlight4: 'Esperienza con falò',
            bbqHighlight5: 'Menu personalizzabili',
            boatTitle: 'Giri in barca',
            boatSubtitle: 'Avventure fluviali e costiere',
            boatDescription: 'Parti per incantevoli viaggi in barca lungo il fiume Bentota e le acque costiere. Scivola tra le mangrovie, osserva uccelli esotici e fauna selvatica o goditi romantiche crociere al tramonto. I nostri giri in barca offrono una prospettiva unica della bellezza naturale e degli ecosistemi dello Sri Lanka.',
            boatHighlight1: 'Crociere sul fiume Bentota',
            boatHighlight2: 'Esplorazione delle mangrovie',
            boatHighlight3: 'Avvistamento della fauna',
            boatHighlight4: 'Tour in barca al tramonto',
            boatHighlight5: 'Noleggio privato disponibile',
            ayurvedaLecturesTitle: 'Lezioni dei medici ayurvedici',
            ayurvedaLecturesSubtitle: 'Saggezza antica e benessere moderno',
            ayurvedaLecturesDescription: 'Scopri i principi profondi dell\'Ayurveda attraverso lezioni guidate da medici ayurvedici certificati e praticanti. Impara il bilanciamento dei dosha, i rimedi erboristici, le pratiche di guarigione olistica e come la saggezza antica si applica al benessere moderno. Le nostre sessioni interattive rendono chiara la filosofia ayurvedica e la sua applicazione nella vita quotidiana.',
            ayurvedaLecturesHighlight1: 'Medici ayurvedici certificati',
            ayurvedaLecturesHighlight2: 'Analisi dosha personalizzata',
            ayurvedaLecturesHighlight3: 'Educazione sui rimedi erboristici',
            ayurvedaLecturesHighlight4: 'Sessioni di domande e risposte',
            ayurvedaLecturesHighlight5: 'Guida al benessere da portare a casa',
            traditionalClothsTitle: 'Eventi di abbigliamento tradizionale',
            traditionalClothsSubtitle: 'Esperienza di patrimonio culturale',
            traditionalClothsDescription: 'Immergiti nel patrimonio culturale dello Sri Lanka imparando a indossare e apprezzare l\'abbigliamento tradizionale. I nostri esperti stylist ti guidano nel vestirti con autentici saree kandiani e abiti tradizionali, spiegando il significato culturale di ogni pezzo. Perfetto per occasioni speciali, apprezzamento culturale o foto memorabili.',
            traditionalClothsHighlight1: 'Guida di styling esperta',
            traditionalClothsHighlight2: 'Saree tradizionali autentici',
            traditionalClothsHighlight3: 'Significato culturale spiegato',
            traditionalClothsHighlight4: 'Fotografia professionale inclusa',
            traditionalClothsHighlight5: 'Workshop di fashion fusion'
        },
        food: {
            heroTitle: 'Cucina ayurvedica e costiera',
            heroSubtitle: 'Autentici sapori dello Sri Lanka e cucina costiera fresca',
            heroAlt: 'Esperienza culinaria al Muthumuni Beach Resort',
            wellnessEyebrow: 'Benessere attraverso il cibo',
            wellnessTitle: 'L\'importanza del',
            ayurvedicFood: 'cibo ayurvedico',
            wellnessIntro1: 'Nell\'ayurveda, il cibo è considerato la più grande medicina. Ciò che mangi influenza direttamente i tuoi dosha (Vata, Pitta, Kapha), la digestione (agni) e l\'equilibrio generale di corpo, mente e spirito.',
            wellnessIntro2: 'La nutrizione ayurvedica enfatizza cibi freschi, stagionali e integrali preparati con cura e mangiati consapevolmente. Promuove sei sapori (dolce, acido, salato, piccante, amaro, astringente) in ogni pasto per nutrire tutti i sensi e mantenere l\'armonia.',
            wellnessIntro3: 'Il corretto cibo ayurvedico supporta una forte digestione, aiuta a rimuovere le tossine (ama), aumenta l\'immunità, migliora l\'energia, riduce lo stress e previene molte condizioni croniche. A Muthumuni, ogni piatto è creato con cura per allinearsi alla tua costituzione unica per una guarigione profonda e una vitalità.',
            foodImage1Alt: 'Pasto ayurvedico tradizionale con sei sapori',
            foodImage2Alt: 'Erbe ayurvediche e spezie per una nutrizione equilibrata',
            culinaryPhilosophyEyebrow: 'La nostra filosofia culinaria',
            culinaryPhilosophyTitle: 'Nutrizione',
            nutritionHighlight: 'ayurvedica',
            culinaryPhilosophyResort: 'al Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Cucina ayurvedica al Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Fresco e nutriente',
            healingIngredientsAlt: 'Ingredienti e spezie ayurvediche salutari',
            healingIngredientsLabel: 'Ingredienti curativi',
            philosophyText1: 'Il cibo, che comprende i sei sapori principali (dolce, acido, salato, amaro, piccante e astringente) insieme a molte variazioni sottili, è stato descritto in testi ayurvedici classici — alcuni risalenti a oltre 5.000 anni fa — insieme alle proprietà essenziali di ogni cibo: Guna (qualità intrinseca), Virya (potenza/riscaldamento o raffreddamento), Vipaka (impatto post-digestivo) e Prabhava (azione speciale unica).',
            philosophyText2: 'Di conseguenza, la nutrizione ayurvedica gioca un ruolo centrale al Muthumuni Ayurveda Beach Resort. Questo non significa un regime rigido e monotono di pasti insipidi, senza sapore o eccessivamente amari determinati esclusivamente dai medici. Al contrario, la nostra cucina ayurvedica è una delle nostre più grandi forze: i piatti preparati dai nostri abili chef ti sorprenderanno e delizieranno ogni giorno del tuo soggiorno!',
            philosophyText3: 'A colazione, goditi un generoso buffet con frutta tropicale fresca, succhi appena spremuti, zuppe alle erbe nutrienti, pane fatto in casa e biscotti leggeri, più una varietà di autentiche opzioni di colazione dello Sri Lanka. A pranzo, assapora un colorato e saporito buffet con miti curry di pesce, preparazioni di verdure e piatti infusi di erbe. La sera, serviamo un menu vegetariano fisso con opzione di pesce fresco disponibile. Nel fine settimana, celebriamo la "Notte dello Sri Lanka" con un buffet ampliato — i nostri chef preparano specialità locali tradizionali direttamente davanti a te, creando un\'esperienza vivace e autentica.',
            philosophyText4: 'Nell\'ayurveda, i cibi e le bevande sono classificati in molti modi — secondo il gusto e le proprietà, la capacità digestiva del corpo (agni), l\'idoneità per condizioni di salute specifiche, l\'appropriatezza stagionale e altro ancora. A Muthumuni, consideriamo attentamente tutti questi fattori simultaneamente, facendo uno sforzo consapevole di includere tutti e sei i sapori in combinazioni equilibrate su misura per la costituzione individuale di ogni ospite.',
            philosophyText5: 'I nostri pasti presentano verdure fresche, frutta tropicale e pesce approvvigionato in modo responsabile. Non serviamo carne rossa o alcol.',
            philosophyText6: 'Durante i pasti, un medico ayurvedico o un dietista qualificato è sempre disponibile per guidarti. Ti consiglieranno sulle verdure, erbe e spezie più adatte per la tua fase di trattamento attuale e ti aiuteranno a selezionare o evitare i piatti di conseguenza. Il tuo elisir alle erbe personalizzato e le istruzioni specifiche dal team del centro sanitario saranno posizionati sul tuo tavolo individuale.',
            philosophyText7: 'Questo livello di cura personale e attenzione alla dieta è un marchio distintivo dell\'esperienza al Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Il cibo è considerato Prana — l\'energia vitale che sostiene la vita — per ogni essere umano. Ecco perché ti incoraggiamo ad affrontare ogni pasto con piena consapevolezza: assaporando gli aromi, vivendo i sapori, sentendo il calore delicato e godendo delle sensazioni affascinanti consapevolmente.',
            diningExperienceEyebrow: 'Esperienza culinaria',
            restaurantTitlePrefix: 'Il nostro',
            ayurvedicHighlight: 'ayurvedico',
            restaurantTitleSuffix: 'ristorante',
            restaurantDetail1: 'Il nostro ristorante ayurvedico al Muthumuni Beach Resort offre un\'esperienza culinaria unica che armonizza i principi ayurvedici tradizionali con l\'autentica cucina costiera dello Sri Lanka. Diamo priorità agli ingredienti freschi e a livello locale per creare piatti che non solo deliziano il palato ma promuovono anche il benessere olistico.',
            restaurantDetail2: 'Il menu è sapientemente realizzato per bilanciare i sei sapori (dolce, acido, salato, amaro, piccante e astringente) in ogni piatto, garantendo un\'esperienza nutriente e soddisfacente. Ogni pasto è preparato con cura, incorporando erbe e spezie ayurvediche note per le loro proprietà curative.',
            restaurantDetail3: 'Gli ospiti possono godere di una varietà di piatti su misura per i loro dosha individuali (costituzioni del corpo), con opzioni per diete vegetariane, vegane e pescetariane. I nostri chef lavorano a stretto contatto con i praticanti ayurvedici per assicurare che ogni pasto supporti gli obiettivi di salute e benessere degli ospiti.',
            restaurantDetail4: 'L\'atmosfera del ristorante riflette l\'ambiente costiero sereno, fornendo un\'impostazione tranquilla per il mangiare consapevole. Che tu stia godendo di un generoso buffet per la colazione o assaporando una cena gourmet, ogni pasto nel nostro ristorante ayurvedico è un\'opportunità per nutrire corpo e anima.',
            restaurantDetail5: 'Unisciti a noi nel ristorante ayurvedico del Muthumuni Beach Resort per un viaggio culinario che celebra i ricchi sapori dello Sri Lanka mentre abbraccia la saggezza senza tempo dell\'Ayurveda.',
            restaurantImageAlt: 'Cena al Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Cucina premium',
            premiumDiningDescription: 'Sperimenta l\'autentica cucina ayurvedica in un\'impostazione fluviale serena'
        },
        yoga: {
            heroTitle: 'Yoga al Resort',
            heroSubtitle: 'Trova equilibrio, forza e pace interiore a Beruwala',
            heroAlt: 'Yoga al Muthumuni Beach Resort',
            importanceEyebrow: 'Benessere & equilibrio',
            importanceTitle: 'Importanza di Yoga e Meditazione',
            importanceImageAlt: 'Importanza dello Yoga e della Meditazione',
            importanceText1: 'Yoga e meditazione sono pratiche antiche che offrono numerosi benefici fisici, mentali ed emotivi. Promuovono flessibilità, forza ed equilibrio riducendo stress e ansia.',
            importanceText2: 'La pratica regolare può migliorare la concentrazione, la qualità del sonno e aumentare il benessere generale. Lo yoga incoraggia anche la consapevolezza, aiutando le persone a connettersi con il proprio io interiore e trovare pace nel caos della vita quotidiana.',
            importanceText3: 'Al Muthumuni Beach Resort offriamo ambienti sereni perfetti per praticare yoga e meditazione, permettendo agli ospiti di rigenerare mente, corpo e spirito.',
            practiceEyebrow: 'La nostra pratica',
            practiceTitle: 'Pratica e esperienza di Yoga',
            practiceImageAlt: 'Pratica di yoga al resort',
            practiceText1: 'Al Muthumuni Ayurveda Beach Resort lo yoga viene praticato principalmente come Hatha Yoga tradizionale, combinato con il Pranayama (tecniche di respirazione). Questo approccio olistico è progettato per risvegliare la consapevolezza interiore e stimolare dolcemente la Kundalini (spesso chiamata terzo occhio). Si pone particolare enfasi sull\'allineamento della colonna vertebrale e sulla flessibilità, poiché una colonna flessibile si ritiene rallenti il processo di invecchiamento — “Si è giovani quanto la propria colonna vertebrale.”',
            practiceText2: 'Le sessioni di yoga si svolgono quattro volte a settimana e sono adatte sia ai principianti che ai praticanti esperti. Di tanto in tanto vengono introdotte sessioni speciali come l\'Ashtanga Yoga, consentendo agli ospiti di sperimentare una varietà di posture e routine. I nostri medici ayurvedici incoraggiano la partecipazione regolare per sostenere e potenziare il programma di trattamento complessivo.',
            practiceText3: 'Tutte le sessioni di yoga si tengono nella nostra Yoga Shala dedicata, uno spazio calmo e sereno progettato per supportare la concentrazione, l\'equilibrio e il movimento consapevole. Ogni sessione inizia tipicamente con i Saluti al Sole, seguiti dal Pranayama e da una sequenza di asana attentamente selezionate per migliorare flessibilità, circolazione e benessere generale.',
            practiceText4: 'I nostri insegnanti di yoga esperti adattano ogni sessione alle esigenze individuali, alle capacità e alle condizioni di salute degli ospiti, garantendo un\'esperienza sicura, di supporto e profondamente benefica per tutti.',
            spiritualEyebrow: 'Viaggio spirituale',
            spiritualTitle: 'Meditazione e attività spirituali',
            spiritualSubtitle: 'Approfondisci la tua pratica spirituale con le nostre cerimonie sacre e sessioni di meditazione guidata',
            meditationImageAlt: 'Meditazione e pratica spirituale al resort',
            meditationTitle: 'Sessioni di meditazione',
            meditationDesc: 'Gli ospiti sono invitati a partecipare a sessioni di meditazione guidata tenute tre volte a settimana, ispirate alle tradizioni buddiste. Queste sessioni sono progettate per calmare la mente, approfondire la consapevolezza e sostenere la guarigione emotiva e spirituale. La meditazione si svolge in un tranquillo tempio su un\'isola, raggiunto dagli ospiti in barca — un viaggio sereno e significativo che arricchisce l\'esperienza meditativa complessiva.'
        },
        contact: {
            heroTitle: 'Contattaci',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contattaci',
            sectionTitle: 'Non esitare a contattarci',
            sectionSubtitle: 'Siamo qui per aiutarti a rilassarti e rigenerarti',
            sectionDescription: 'Contatta Muthumuni Ayurveda Beach Resort per informazioni sul tuo soggiorno ayurvedico, pacchetti wellness, prenotazioni o qualsiasi domanda durante la tua permanenza a Beruwala, Moragalla.',
            callUs: 'Chiamaci',
            emailTitle: 'Email',
            ourLocation: 'La nostra posizione',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Mettiti in contatto',
            getInTouchDescription: 'Ci piacerebbe sentirti — il nostro team è pronto ad aiutarti nel tuo percorso di benessere, rispondere alle domande e pianificare un soggiorno rigenerante.',
            nameLabel: 'Nome',
            emailLabel: 'Email',
            contactNumberLabel: 'Numero di contatto',
            messageLabel: 'Messaggio',
            sending: 'Invio...',
            sendMessage: 'Invia messaggio',
            successMessage: 'Il tuo messaggio è stato inviato con successo! Ti risponderemo presto.',
            errorMessage: 'Si è verificato un errore durante l\'invio. Riprova.',
            findUsOnMap: 'Trovaci sulla mappa',
            whatsappSubject: 'Contatto Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Nome',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numero di contatto',
            whatsappMessage: 'Messaggio'
        },

        contact2: {
            heroTitle: 'Contattaci',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contattaci',
            sectionTitle: 'Non esitare a contattarci',
            sectionSubtitle: 'Siamo qui per aiutarti a rilassarti e rigenerarti',
            sectionDescription: 'Contatta Muthumuni Ayurveda Beach Resort per informazioni sul tuo soggiorno ayurvedico, pacchetti wellness, prenotazioni o qualsiasi domanda durante la tua permanenza a Beruwala, Moragalla.',
            callUs: 'Chiamaci',
            emailTitle: 'Email',
            ourLocation: 'La nostra posizione',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Social Network',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Mettiti in contatto',
            getInTouchDescription: 'Ci piacerebbe sentirti — il nostro team è pronto ad aiutarti nel tuo percorso di benessere, rispondere alle domande e pianificare un soggiorno rigenerante.',
            nameLabel: 'Nome',
            emailLabel: 'Email',
            contactNumberLabel: 'Numero di contatto',
            messageLabel: 'Messaggio',
            sending: 'Invio...',
            sendMessage: 'Invia messaggio',
            successMessage: 'Il tuo messaggio è stato inviato con successo! Ti risponderemo presto.',
            errorMessage: 'Si è verificato un errore durante l\'invio. Riprova.',
            findUsOnMap: 'Trovaci sulla mappa',
            whatsappSubject: 'Contatto Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Nome',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numero di contatto',
            whatsappMessage: 'Messaggio'
        },

        ayurveda: {
            accordionTitle1: 'Cos\'è il Panchakarma Ayurveda?',
            accordionDesc1: 'L\'Ayurveda è uno dei sistemi di guarigione più antichi al mondo, sviluppato oltre 5000 anni fa. Il Panchakarma Ayurveda si basa sulla convinzione che la salute dipende dall\'equilibrio tra mente, corpo, spirito e ambiente.',
            accordionTitle2: 'Panchakarma Ayurveda e Energia Vitale',
            accordionDesc2: 'L\'Ayurveda si basa sulla teoria dell\'interconnessione di tutto nell\'universo. Chi pratica l\'Ayurveda crede che ogni persona sia composta da cinque elementi: spazio, aria, fuoco, acqua e terra. Questi formano tre dosha: VATA, PITTA e KAPHA.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Il dosha più potente che controlla le funzioni corporee di base: divisione cellulare, respirazione, flusso sanguigno, funzione cardiaca. Con Vata dominante sei intelligente, creativo, energico. In squilibrio - ansia. Equilibrio attraverso meditazione, massaggio e cibi caldi.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Controlla digestione, metabolismo e ormoni. Con Pitta dominante sei determinato, competitivo, fiducioso. In squilibrio - irritabilità. Equilibrio attraverso cibi rinfrescanti e yoga lento.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Controlla crescita muscolare, forza corporea e immunità. Con Kapha dominante ami la routine, sei calmo e paziente. In squilibrio - stanchezza e aumento di peso. Equilibrio attraverso frutta, verdura ed esercizio.',
            close: 'Chiudi',
            next: 'Avanti',
            previous: 'Indietro',
            treatmentsTitle: 'I nostri trattamenti Panchakarma Ayurvedici caratteristici',
            treatmentsSubtitle: 'Sperimenta terapie tradizionali progettate per ripristinare l\'equilibrio, rilasciare tensioni e ringiovanire tutto il tuo essere.',
            bookTreatment: 'Prenota questo trattamento',
            benefitsTitle: 'Benefici dei trattamenti Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Un dolce versamento di olio caldo alle erbe sulla fronte per calmare la mente.',
            shirodhara1: 'Riduce stress e ansia',
            shirodhara2: 'Migliora il sonno',
            shirodhara3: 'Aumenta la chiarezza mentale',
            steamBath: 'Bagno turco',
            steamBathDesc: 'Un trattamento disintossicante a vapore per aprire i pori e rilassare i muscoli.',
            steamBath1: 'Disintossica il corpo',
            steamBath2: 'Migliora la circolazione',
            steamBath3: 'Allevia la tensione muscolare',
            flowerBath: 'Bagno floreale',
            flowerBathDesc: 'Un bagno rilassante infuso con fiori aromatici per il relax.',
            flowerBath1: 'Calma il sistema nervoso',
            flowerBath2: 'Idrata la pelle',
            flowerBath3: 'Migliora l\'umore',
            headMassage: 'Massaggio alla testa',
            headMassageDesc: 'Un massaggio rilassante mirato al cuoio capelluto per alleviare la tensione.',
            headMassage1: 'Riduce il mal di testa',
            headMassage2: 'Migliora la salute del cuoio capelluto',
            headMassage3: 'Promuove il relax',
            faceMassage: 'Massaggio viso',
            faceMassageDesc: 'Un massaggio ringiovanente per migliorare la luminosità del viso e ridurre lo stress.',
            faceMassage1: 'Migliora il tono della pelle',
            faceMassage2: 'Riduce la tensione facciale',
            faceMassage3: 'Promuove il drenaggio linfatico',
            neckMassage: 'Massaggio al collo',
            neckMassageDesc: 'Massaggio mirato per alleviare la rigidità e la tensione del collo.',
            neckMassage1: 'Allevia il dolore al collo',
            neckMassage2: 'Migliora la flessibilità',
            neckMassage3: 'Riduce lo stress',
            shoulderMassage: 'Massaggio alle spalle',
            shoulderMassageDesc: 'Massaggio mirato per alleviare la rigidità e il disagio alle spalle.',
            shoulderMassage1: 'Riduce il dolore alle spalle',
            shoulderMassage2: 'Migliora la postura',
            shoulderMassage3: 'Rilassa i muscoli',
            bodyMassage: 'Massaggio corpo',
            bodyMassageDesc: 'Un massaggio completo per promuovere il relax e il benessere generale.',
            bodyMassage1: 'Migliora la circolazione',
            bodyMassage2: 'Allevia il dolore muscolare',
            bodyMassage3: 'Promuove il relax',
            backMassage: 'Massaggio alla schiena',
            backMassageDesc: 'Un massaggio terapeutico mirato al dolore e alla tensione della schiena.',
            backMassage1: 'Allevia il mal di schiena',
            backMassage2: 'Migliora la salute della colonna vertebrale',
            backMassage3: 'Riduce lo stress',
            footMassage: 'Massaggio ai piedi',
            footMassageDesc: 'Un massaggio rilassante per alleviare il dolore ai piedi e promuovere il relax.',
            footMassage1: 'Migliora la circolazione',
            footMassage2: 'Riduce l\'affaticamento dei piedi',
            footMassage3: 'Promuove il relax',
            purgative: 'Purgativo',
            purgativeDesc: 'Una terapia purificante per eliminare l\'eccesso di Pitta e le tossine dal sistema digestivo.',
            purgative1: 'Pulisce il colon',
            purgative2: 'Bilancia il dosha Pitta',
            purgative3: 'Migliora la salute digestiva',
            nasalClearing: 'Pulizia nasale',
            nasalClearingDesc: 'Un trattamento nasale terapeutico per pulire i seni e migliorare la funzione respiratoria.',
            nasalClearing1: 'Elimina la congestione nasale',
            nasalClearing2: 'Migliora la respirazione',
            nasalClearing3: 'Allevia i problemi sinusali',
            powderMassage: 'Massaggio con polvere',
            powderMassageDesc: 'Un massaggio esfoliante con polveri alle erbe per ringiovanire e rinfrescare la pelle.',
            powderMassage1: 'Esfolia la pelle morta',
            powderMassage2: 'Migliora la texture della pelle',
            powderMassage3: 'Promuove la circolazione',
            intensiveMassageDesc: 'Un massaggio terapeutico profondo che mira alla tensione cronica e ai nodi muscolari con pressione decisa e tecniche specializzate.',
            intensiveMassage1: 'Allevia la tensione muscolare profonda',
            intensiveMassage2: 'Migliora la circolazione sanguigna',
            intensiveMassage3: 'Riduce il dolore muscolare',
            thermoMassage: 'Massaggio Termico',
            thermoMassageDesc: 'Un massaggio caldo con olio alle erbe utilizzando oli terapeutici riscaldati per migliorare il rilassamento e i benefici curativi.',
            thermoMassage1: 'Calma i muscoli doloranti',
            thermoMassage2: 'Promuove un profondo rilassamento',
            thermoMassage3: 'Favorisce il flusso energetico',
            synchronMassage: 'Massaggio Sincronizzato',
            synchronMassageDesc: 'Un massaggio sincronizzato a due terapisti per l’armonia completa del corpo e la distribuzione equilibrata dell’energia.',
            synchronMassage1: 'Armonia completa del corpo',
            synchronMassage2: 'Flusso energetico equilibrato',
            synchronMassage3: 'Esperienza di profondo rilassamento',
            specialMassage: 'Massaggio Speciale',
            specialMassageDesc: 'Terapia di massaggio personalizzata in base alle tue specifiche esigenze di salute e obiettivi di benessere personali.',
            specialMassage1: 'Trattamento personalizzato',
            specialMassage2: 'Mirato a problemi specifici',
            specialMassage3: 'Approccio curativo su misura',
            benefit1Title: 'Disintossicazione:',
            benefit1Desc: 'I trattamenti Panchakarma aiutano a eliminare le tossine dal corpo, promuovendo salute e vitalità complessive.',
            benefit2Title: 'Digestione migliorata:',
            benefit2Desc: 'Queste terapie migliorano la funzione digestiva per un migliore assorbimento dei nutrienti e metabolismo.',
            benefit3Title: 'Riduzione dello stress:',
            benefit3Desc: 'Panchakarma è noto per i suoi effetti calmanti su mente e corpo, riducendo i livelli di stress e ansia.',
            benefit4Title: 'Immunità rafforzata:',
            benefit4Desc: 'I trattamenti Panchakarma regolari possono rafforzare il sistema immunitario, rendendo il corpo più resistente alle malattie.',
            benefit5Title: 'Ringiovanimento:',
            benefit5Desc: 'Le terapie promuovono la rigenerazione cellulare per una migliore salute della pelle e un aspetto giovane.',
            benefit6Title: 'Equilibrio dei Dosha:',
            benefit6Desc: 'Panchakarma aiuta a ripristinare l\'equilibrio dei dosha del corpo (Vata, Pitta, Kapha), essenziale per la salute secondo i principi ayurvedici.',
            akkupancharTitle: 'Terapia Akkupanchar',
            akkupancharDesc1: 'è un\'antica terapia ayurvedica che utilizza paste ed oli alle erbe applicati su punti specifici del corpo. Questo trattamento stimola i canali energetici vitali e promuove la guarigione.',
            akkupancharBenefit: 'Benefici chiave:',
            akkupancharDesc2: 'Questa terapia specializzata aiuta ad alleviare il dolore cronico, migliorare la flessibilità articolare, la circolazione sanguigna e ripristinare il flusso energetico naturale del corpo.',
            akkupancharApplication: 'Applicazione terapeutica:',
            akkupancharDesc3: 'Akkupanchar agisce su punti marma specifici con preparati alle erbe accuratamente selezionati per bilanciare i dosha.',
            akkupancharTransform: 'Sperimenta la trasformazione:',
            akkupancharDesc4: 'Al Muthumuni Ayurveda Beach Resort, i nostri esperti personalizzano ogni sessione in base alle vostre esigenze di salute uniche.',
            gallery1: 'Terapia Shirodhara',
            gallery2: 'Bagno turco',
            gallery3: 'Bagno floreale',
            gallery4: 'Massaggio alla testa',
            gallery5: 'Massaggio corpo',
            gallery6: 'Massaggio al collo',
            gallery7: 'Massaggio viso',
            gallery8: 'Massaggio alle spalle',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Ringiovanisci Corpo, Mente e Anima a Beruwala',
            sectionEyebrow: 'PANCHAKARMA AYURVEDA AL MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Scopri l\'antico arte curativa del Panchakarma Ayurveda al Muthumuni Ayurveda Beach Resort a Beruwala. I nostri esperti praticanti offrono trattamenti personalizzati per disintossicare, ringiovanire e ripristinare l\'equilibrio.',
            treatmentProgramme: {
                title: 'Programma di trattamento ayurvedico',
                subtitle: 'Il vostro viaggio verso l equilibrio la disintossicazione e il profondo rinnovamento',
                intro: 'Sperimentate la vera guarigione ayurvedica in un ritiro pacifico progettato per ripristinare il vostro corpo, calmare la mente e rinnovare la vostra energia. Dal momento in cui arrivate, il nostro team si prende cura di ogni dettaglio – affinché possiate concentrarvi completamente sul vostro benessere.',
                welcomeTitle: 'Benvenuto e dolce inizio',
                doctorTitle: 'Consultazione medica e piano personalizzato',
                dailyTherapiesTitle: 'Terapie ayurvediche quotidiane',
                herbalMedicineTitle: 'Supporto con medicina a base di erbe',
                yogaMeditationTitle: 'Yoga e meditazione per l armonia corpo- mente',
                wellnessTitle: 'Esperienze benessere incluse',
                closingTitle: 'Rituale di chiusura e partenza',
                welcomePoints: [
                    'Ritiro dallaeroporto e trasferimento all hotel',
                    'Accoglienza calorosa e orientamento dell hotel',
                    'Introduzione al vostro programma di benessere settimanale',
                    'Massaggio rilassante (Giorno 1) presso il centro ayurvedico per alleviare la fatica da viaggio e preparare il corpo ai trattamenti'
                ],
                doctorPoints: [
                    'Consultazione medica ayurvedica (Giorno 2 – mattina)',
                    'Valutazione completa della vostra Dosha/tipo di corpo e problemi di salute',
                    'Traduttore disponibile su richiesta',
                    'Il vostro medico crea un piano di trattamento personalizzato adatto alle vostre esigenze e obiettivi'
                ],
                dailyTherapiesPoints: [
                    '4–5 trattamenti al giorno (come consigliato dal medico)',
                    'Terapie selezionate in base alla vostra costituzione corporea e condizione',
                    'Massaggi speciali possono essere aggiunti se necessario',
                    'Il medico monitora i progressi giornalmente e può adattare i trattamenti e il supporto erboristico per garantire i migliori risultati',
                    'Se appropriato, può essere consigliato un dolce processo di purificazione'
                ],
                herbalMedicinePoints: [
                    'Medicinali a base di erbe prescritti dal medico due volte al giorno:',
                    'Durante la colazione',
                    'Durante la cena',
                    'Sostengono la guarigione interna, la disintossicazione e l equilibrio duraturo'
                ],
                yogaMeditationPoints: [
                    'Sessioni di yoga 4 volte a settimana (circa 1 ora)',
                    'Sessioni di meditazione 2 volte a settimana:',
                    'Un esperienza spirituale unica in un tempio sull isola, raggiungibile in barca',
                    'Meditazione guidata diretta da monaci (circa 1 ora)'
                ],
                wellnessPoints: [
                    'Dimostrazioni settimanali di cucina salutare',
                    'Escursione gratuita (esperienza culturale/naturalistica)'
                ],
                closingPoints: [
                    'Un bellissimo bagno di fiori (ultimo giorno) – un rituale tradizionale di rinnovamento',
                    'Consultazione medica finale per rivedere i progressi e fornire:',
                    'Guida continua al benessere',
                    'Prescrizioni e raccomandazioni per la casa',
                    'Trasferimento di ritorno all aeroporto'
                ]
            }
        },
        home: {
            // Hero Section
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Ayurveda dall\'oceano',
            heroSubtitle2: 'Trova l\'equilibrio, respira consapevolmente e rinvigorisci la tua energia a Beruwala.',
            exploreResort: 'Esplora il resort',
            bookNow: 'Prenota ora',

            // Welcome Section
            welcomeLabel: 'Benvenuti',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'Situato sulle sponde incontaminate di Beruwala, Muthumuni Ayurveda Beach Resort offre un\'armoniosa fusione di antiche tradizioni di guarigione e lusso costiero moderno. Il nostro santuario ti invita a intraprendere un viaggio trasformativo di benessere, dove i suoni ritmici dell\'Oceano Indiano incontrano la saggezza senza tempo dell\'Ayurveda.',
            welcomeDesc2: 'Sperimenta trattamenti ayurvedici personalizzati, assapora piatti nutrienti elaborati per bilanciare la tua dosha, e rilassati in camere elegantemente arredate con vista mozzafiato sull\'oceano. Che tu cerchi ringiovanimento, rilassamento o rinascita spirituale, il nostro dedicato team di professionisti ayurvedici ed esperti di benessere è qui per guidarti ad ogni passo.',
            learnMore: 'Scopri di più',
            contactUs: 'Contattaci',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'Ayurveda Benessere & Beach Retreat',
            welcomeImageLocation: 'Beruwala, Sri Lanka',

            // Highlight Section
            highlightTitle: 'Un santuario ayurvedico sul mare',
            highlightDesc: 'Scopri la guarigione olistica sulla costa sud-ovest dello Sri Lanka. Dai trattamenti personalizzati ai balconi tranquilli e alla cucina consapevole, ogni dettaglio è progettato per ripristinare il tuo ritmo.',

            // Services
            service1Title: 'Terapie Ayurvediche Olistiche',
            service1Desc: 'Consultazioni personalizzate, oli erboristici autentici e trattamenti quotidiani guidati da esperti medici ayurvedici.',
            service2Title: 'Camere e Suite Fronte Spiaggia',
            service2Desc: 'Svegliati con la brezza marina, balconi privati e interni calmanti progettati per un riposo profondo.',
            service3Title: 'Cucina del Benessere',
            service3Desc: 'Prodotti freschi dello Sri Lanka, menu plant-forward e piani alimentari personalizzati che completano la tua dosha.',
            service4Title: 'Yoga e Consapevolezza',
            service4Desc: 'Yoga all\'alba, meditazione al tramonto e esercizi di respirazione al ritmo delle onde.',
            service5Title: 'Escursioni Fluviali e Costiere',
            service5Desc: 'Crociere sul fiume Bentota, visite a incubatori di tartarughe, passeggiate in giardini di spezie e tour in bicicletta nei villaggi.',

            // Rooms
            roomsTitle: 'Le Nostre Camere',
            roomsDesc: 'Scegli il santuario che corrisponde al tuo ritmo, da suite spaziose a confortevoli rifugi deluxe, ognuno caratterizzato da biancheria morbida, legno caldo e balconi pronti all\'alba.',
            roomBadge: 'Fuga Fronte Spiaggia',
            bookableNow: 'Prenotabile ora',
            seaBreezeReady: 'Pronto per la brezza marina',
            viewRoom: 'Visualizza Camera',
            room1Title: 'Camere Suite',
            room1Desc: 'Suite spaziose con area salotto, balconi generosi e palette calmanti per le mattine lente.',
            room2Title: 'Camere Deluxe',
            room2Desc: 'Ritiri accoglienti con letti lussuosi, vista giardino e accenti in legno caldo per la facilità quotidiana.',
            room3Title: 'Deluxe Vista Mare',
            room3Desc: 'Svegliati con l\'orizzonte dell\'oceano, biancheria morbida e un balcone privato realizzato per i tramonti dorati.',

            // Achievements
            achievementsTitle: 'Benessere affidabile sul mare',
            achievement1Title: 'Ospiti Felici',
            achievement1Count: '1.000+',
            achievement2Title: 'Trattamenti Ayurvedici',
            achievement2Count: '20+',
            achievement3Title: 'Anni di Assistenza',
            achievement3Count: '15+',
            achievement4Title: 'Acclamazioni Viaggiatori',
            achievement4Count: '1.000+',

            // Experiences
            experiencesTitle: 'Esplora Muthumuni Ayurveda Beach Resort',
            experiencesDesc: 'Dai percorsi ayurvedici alle escursioni curate, scegli le esperienze che rendono il tuo soggiorno indimenticabile.',
            planYourStay: 'Pianifica il tuo soggiorno',
            experience1Title: 'Camere e Suite',
            experience1Desc: 'Spazi ariosi con balconi, vista océان o giardino e comfort premurosi per soggiorni indisturbati.',
            experience2Title: 'Spa Ayurvedica',
            experience2Desc: 'Terapie autentiche, bagni a vapore e massaggi rigeneranti offerti con rituali consacrati dal tempo.',
            experience3Title: 'Esperienza Culinaria',
            experience3Desc: 'Cucina nutriente dello Sri Lanka e internazionale servita nel nostro ristorante, scrupolosamente preparata per nutrire corpo e mente.',
            experience4Title: 'Esperienze e Tour',
            experience4Desc: 'Safari fluviali, visite ai templi, sport acquatici e escursioni culturali curate intorno a Bentota.',

            // Gallery
            galleryTitle: 'Momenti a Muthumuni Ayurveda Beach Resort',
            galleryDesc: 'Uno sguardo nel nostro santuario costiero - albe, trattamenti sereni, piatti nutrienti e angoli tranquilli realizzati per te.',
            gallery1Alt: 'Spiaggia circondata da palme al sole a Muthumuni',
            gallery2Alt: 'Trattamento ayurvedico con olio in atto',
            gallery3Alt: 'Piscina del resort con lettini',
            gallery4Alt: 'Erbe preparate per la spa',
            gallery5Alt: 'Coppia che gode del tramonto in riva al mare',
            gallery6Alt: 'Ponte yoga fronte oceano',
            gallery7Alt: 'Sentiero giardino tropicale',
            gallery8Alt: 'Colazione salutare',
            gallery9Alt: 'Vista serena del fiume',
            gallery10Alt: 'Resort esternamente illuminato al tramonto',
            gallery11Alt: 'Display erbe e oli ayurvedici',
            gallery12Alt: 'Accogliente seduta in giardino',

            // Resort Images
            resort1Alt: 'Lounge all\'aperto con verde',
            resort2Alt: 'Interno camera confortevole',
            resort3Alt: 'Spazio trattamenti spa',
            resort4Alt: 'Area ristorazione con luce naturale',
            resort5Alt: 'Vista rilassante della piscina',

            // Sunset Section
            sunsetLabel: 'Capolavoro Quotidiano della Natura',
            sunsetTitle: 'Tramonto Serale',
            sunsetDesc1: 'Guarda come il giorno gracefully si arrende al crepuscolo, il cielo si trasforma in una tela di ambra, cremisi e oro. Il dolce Oceano Indiano specchia questo spettacolo celeste, creando una sinfonia affascinante di luce e acqua.',
            sunsetDesc2: 'Ogni sera a Muthumuni offre i migliori posti in prima fila per uno dei più straordinari spettacoli della natura. Trova il tuo punto di vantaggio perfetto - che sia dal tuo balcone privato, dalla lounge sulla spiaggia o dal nostro ponte di meditazione al tramonto - e lascia che la bellezza serena ti avvolga.',
            sunsetFeature1: 'Vista sull\'oceano ininterrotta da ogni angolo',
            sunsetFeature2: 'Meditazione serenità al tramonto',
            sunsetFeature3: 'Tè alle erbe complimentare servito quotidianamente',
            sunsetFeature4: 'Momenti fotogenici ogni sera',
            sunsetImageAlt: 'Tramonto serale presso Muthumuni Beach Resort',
            bestTime: 'Miglior Tempo',
            sunsetTime: '18:00 - 18:45',

            // Pool Section
            poolLabel: 'Serenità Acquatica',
            poolTitle: 'Area Piscina',
            poolDesc1: 'Immergiti nella serenità della nostra piscina infinity incontaminata, dove le acque cristalline incontrano i lussureggianti giardini tropicali. Progettata per rilassamento e ringiovanimento, la nostra area piscina offre il rifugio perfetto per rilassarsi sotto il sole dello Sri Lanka.',
            poolDesc2: 'Che tu preferisca un rinfrescante bagno mattutino, una seduta pomeridiana con un buon libro o un tranquillo tuffo serale, la nostra area piscina offre un ambiente idilliaco. Circondata da confortevoli lettini, cabine ombreggiate e servizio attentivo, ogni momento diventa un ricordo caro.',
            poolFeature1: 'Piscina infinity con controllo della temperatura',
            poolFeature2: 'Circondata da paesaggi da giardino tropicale',
            poolFeature3: 'Rinfrescanti e snack salutari a bordo piscina',
            poolFeature4: 'Lettini premium con ombrelloni',
            poolImageAlt: 'Rilassante area piscina presso Muthumuni Resort',

            // Testimonials
            testimonialsTitle: 'Ospiti durante il loro soggiorno'
        },
    },

    fr: {
        about: {
            heroTitle: 'À Propos de Nous',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'La sagesse ancienne rencontre le bien-être moderne au Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Traitements ayurvédiques personnalisés, vue sur l\'océan et hospitalité authentique du Sri Lanka',
            slide1: 'Guérison ayurvédique',
            slide2: 'Sérénité sur la plage',
            slide3: 'Tranquillité du jardin',
            slide4: 'Thérapies aux herbes',
            slide5: 'Bien-être océanique',
            historyLabel: 'Notre voyage',
            historyTitle: 'Histoire du Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Établi il y a plus de deux décennies, le Muthumuni Ayurveda Beach Resort est né d\'une vision de créer un sanctuaire où la sagesse ayurvédique ancienne rencontre la beauté tranquille de la côte sud du Sri Lanka. Ce qui a commencé comme une modeste retraite bien-être a fleuri en l\'une des destinations les plus chères de Beruwala pour la guérison holistique et rajeunissement.',
            historyDesc2: 'Nos fondateurs, inspirés par des générations de praticiens ayurvédiques traditionnels, ont cherché à préserver ces arts de guérison éprouvés tout en fournissant des conforts modernes et une authentique hospitalité du Sri Lanka. Au fil des années, nous sommes restés fidèles à notre engagement envers les expériences de bien-être authentiques, en développant nos installations sans jamais perdre de vue les soins personnalisés qui définissent notre héritage.',
            historyDesc3: 'Aujourd\'hui, Muthumuni témoigne du pouvoir durable de l\'ayurvéda, ayant accueilli des milliers de clients du monde entier. Chaque visiteur devient une partie de notre histoire, trouvant équilibre, guérison et transformation dans notre havre balnéaire.',
            statYear: '15+',
            statYearLabel: 'Années d\'excellence en bien-être',
            statGuest: '1.000+',
            statGuestLabel: 'Clients heureux servis',
            experienceLegacy: 'Expérimentez notre héritage',
            established: 'Établi',
            since2010: 'Depuis 2008',
            chairmanLabel: 'Message du président',
            chairmanTitle: 'Guidé par la bienveillance, enraciné dans l\'Ayurvéda',
            chairmanDesc1: 'Bienvenue au Muthumuni Ayurveda Beach Resort. Depuis plus de deux décennies, notre objectif a été simple : offrir une véritable guérison ancrée dans la sagesse intemporelle de l\'ayurvéda, livrée avec la chaleur de l\'hospitalité du Sri Lanka.',
            chairmanDesc2: 'Ici, chaque détail — de nos thérapies et cuisine à la tranquillité de nos espaces — est conçu pour vous aider à ralentir, rétablir l\'équilibre et vous reconnecter avec vous-même. Nous sommes honorés de faire partie de votre parcours de bien-être.',
            chairmanDesc3: 'Au nom de notre équipe dévouée, je vous invite à expérimenter la bienveillance, l\'authenticité et la sérénité qui définissent Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Président',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Président Mr. Nihal Muthumuni',
            staffLabel: 'Notre équipe',
            staffTitle: 'Rencontrez notre équipe dévouée',
            staffDesc1: 'Au Muthumuni Ayurveda Beach Resort, notre équipe est le cœur de tout ce que nous faisons. Les membres de notre personnel sont des professionnels soigneusement sélectionnés et formés qui partagent une passion profonde pour le bien-être ayurvédique et l\'hospitalité authentique.',
            staffDesc2: 'De nos praticiens ayurvédiques expérimentés et thérapeutes en massage compétents à notre équipe d\'hospitalité dévouée, chaque membre apporte des années d\'expertise et une véritable bienveillance à chaque interaction avec les clients. Nous croyons que le véritable bien-être ne vient pas seulement des traitements, mais de la chaleur et l\'attention de personnes qui se soucient sincèrement de votre parcours.',
            staffDesc3: 'Notre personnel subit une formation continue aux dernières pratiques ayurvédiques tout en maintenant les normes les plus élevées de professionnalisme et de sensibilité culturelle. Nous sommes fiers de créer des connections significatives avec nos clients, en veillant à ce que chaque visite devienne une expérience mémorable et transformatrice.',
            statStaff: '15+',
            statStaffLabel: 'Professionnels qualifiés',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Satisfaction client',
            staffImageAlt: 'Notre équipe de personnel dévouée au Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Notre engagement',
            excellenceCare: 'Excellence et bienveillance',
            ctaLabel: 'Nous contacter',
            ctaHeading: 'Prêt à commencer votre parcours de bien-être?',
            ctaDesc: 'Contactez notre équipe pour réserver votre retraite ayurvédique personnalisée. Que vous ayez des questions sur nos thérapies, hébergements ou packages bien-être spéciaux, nous sommes là pour aider à créer votre évasion parfaite.',
            ctaButtonContact: 'Nous contacter maintenant',
            ctaButtonRooms: 'Explorez les chambres',
            contactUs: 'Nous contacter',
            quickInfoCall: 'Appelez-nous',
            quickInfoEmail: 'Nous envoyer un email',
            quickInfoLocation: 'Localisation',
            locationCity: 'Beruwala, Sri Lanka'
        },
        home: {
            // Hero Section
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Ayurveda au bord de l’océan',
            heroSubtitle2: 'Trouvez l’équilibre, respirez librement et renouvelez votre énergie à Beruwala.',
            exploreResort: 'Découvrir le resort',
            bookNow: 'Réserver maintenant',

            // Welcome Section
            welcomeLabel: 'Bienvenue',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'Niché le long des plages immaculées de Beruwala, le Muthumuni Ayurveda Beach Resort offre un mélange harmonieux de traditions de guérison anciennes et de luxe côtier moderne. Notre sanctuaire vous invite à entreprendre un voyage transformateur de bien-être, où les sons rythmés de l’océan Indien rencontrent la sagesse intemporelle de l’Ayurveda.',
            welcomeDesc2: 'Vivez des traitements ayurvédiques personnalisés, savourez une cuisine nourrissante adaptée à votre dosha et détendez-vous dans des chambres élégamment aménagées avec vue imprenable sur l’océan. Que vous recherchiez le rajeunissement, la relaxation ou le renouveau spirituel, notre équipe dédiée de praticiens ayurvédiques et d’experts en bien-être est là pour vous guider à chaque étape.',
            learnMore: 'En savoir plus',
            contactUs: 'Nous contacter',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'Bien-être ayurvédique & Retraite balnéaire',
            welcomeImageLocation: 'Beruwala, Sri Lanka',

            // Highlight Section
            highlightTitle: 'Un sanctuaire ayurvédique au bord de la mer',
            highlightDesc: 'Découvrez la guérison holistique sur la côte sud-ouest du Sri Lanka. Des traitements sur mesure aux balcons calmes et à la cuisine consciente, chaque détail est conçu pour restaurer votre rythme.',

            // Services
            service1Title: 'Thérapies ayurvédiques holistiques',
            service1Desc: 'Consultations personnalisées, huiles herbales authentiques et traitements quotidiens guidés par des médecins ayurvédiques expérimentés.',
            service2Title: 'Chambres & Suites en bord de plage',
            service2Desc: 'Réveillez-vous avec la brise marine, des balcons privés et des intérieurs apaisants conçus pour un repos profond.',
            service3Title: 'Cuisine bien-être',
            service3Desc: 'Produits frais du Sri Lanka, menus à base de plantes et plans de repas adaptés à votre dosha.',
            service4Title: 'Yoga et pleine conscience',
            service4Desc: 'Yoga au lever du soleil, méditation au coucher du soleil et sessions de respiration face au rythme des vagues.',
            service5Title: 'Excursions fluviales et côtières',
            service5Desc: 'Balades en bateau sur la rivière Bentota, visites de la ferme de tortues, promenades dans les jardins d’épices et circuits à vélo dans les villages.',

            // Rooms
            roomsTitle: 'Nos chambres',
            roomsDesc: 'Choisissez le sanctuaire qui correspond à votre rythme, des suites aérées aux retraites deluxe cosy, chacune agrémentée de draps doux, de bois chaleureux et de balcons prêts pour le lever du soleil.',
            roomBadge: 'Évasion face à l’océan',
            bookableNow: 'Réservable maintenant',
            seaBreezeReady: 'Prêt pour la brise marine',
            viewRoom: 'Voir la chambre',
            room1Title: 'Chambres Suite',
            room1Desc: 'Suites spacieuses avec salon, grands balcons et palettes apaisantes pour des matins lents.',
            room2Title: 'Chambres Deluxe',
            room2Desc: 'Retraites cosy avec lits moelleux, vues sur le jardin et accents en bois chaleureux pour un confort quotidien.',
            room3Title: 'Deluxe Vue Mer',
            room3Desc: 'Réveillez-vous face à l’horizon marin, avec des draps doux et un balcon privé idéal pour les couchers de soleil dorés.',

            // Achievements
            achievementsTitle: 'Bien-être de confiance au bord de la mer',
            achievement1Title: 'Clients heureux',
            achievement1Count: '1 000+',
            achievement2Title: 'Traitements ayurvédiques',
            achievement2Count: '20+',
            achievement3Title: 'Années de soin',
            achievement3Count: '15+',
            achievement4Title: 'Reconnaissances des voyageurs',
            achievement4Count: '1 000+',

            // Experiences
            experiencesTitle: 'Découvrez Muthumuni Ayurveda Beach Resort',
            experiencesDesc: 'Des voyages ayurvédiques aux excursions organisées, choisissez les expériences qui rendront votre séjour inoubliable.',
            planYourStay: 'Planifiez votre séjour',
            experience1Title: 'Chambres & Suites',
            experience1Desc: 'Espaces aérés avec balcons, vues sur l’océan ou le jardin, et conforts pensés pour des séjours sans hâte.',
            experience2Title: 'Spa ayurvédique',
            experience2Desc: 'Thérapies authentiques, bains de vapeur et massages régénérants réalisés selon des rituels ancestraux.',
            experience3Title: 'Expérience culinaire',
            experience3Desc: 'Cuisine sri-lankaise et internationale nourrissante servie dans notre restaurant, soigneusement préparée pour nourrir corps et esprit.',
            experience4Title: 'Expériences & Excursions',
            experience4Desc: 'Safaris fluviaux, visites de temples, sports nautiques et excursions culturelles autour de Bentota.',

            // Gallery
            galleryTitle: 'Instants au Muthumuni Ayurveda Beach Resort',
            galleryDesc: 'Un aperçu de notre sanctuaire côtier — levers de soleil, traitements sereins, assiettes nourrissantes et coins tranquilles faits pour vous.',
            gallery1Alt: 'Plage ensoleillée bordée de palmiers à Muthumuni',
            gallery2Alt: 'Traitement à l’huile ayurvédique en cours',
            gallery3Alt: 'Piscine du resort avec transats',
            gallery4Alt: 'Ingrédients herbaux préparés pour le spa',
            gallery5Alt: 'Couple profitant du coucher de soleil au bord de la mer',
            gallery6Alt: 'Plateforme yoga face à l’océan',
            gallery7Alt: 'Allée dans le jardin tropical',
            gallery8Alt: 'Petit-déjeuner sain',
            gallery9Alt: 'Vue paisible sur la rivière',
            gallery10Alt: 'Extérieur du resort illuminé au crépuscule',
            gallery11Alt: 'Présentation d’herbes et huiles ayurvédiques',
            gallery12Alt: 'Coin salon cosy près du jardin',

            // Resort Images
            resort1Alt: 'Salon en plein air avec verdure',
            resort2Alt: 'Intérieur de chambre confortable',
            resort3Alt: 'Espace de traitement spa',
            resort4Alt: 'Coin repas avec lumière naturelle',
            resort5Alt: 'Vue relaxante sur la piscine',

            // Sunset Section
            sunsetLabel: 'Chef-d’œuvre quotidien de la nature',
            sunsetTitle: 'Coucher de soleil du soir',
            sunsetDesc1: 'Alors que le jour cède gracieusement la place au crépuscule, regardez le ciel se transformer en toile d’ambre, de cramoisi et d’or. L’océan Indien reflète ce spectacle céleste, créant une symphonie envoûtante de lumière et d’eau.',
            sunsetDesc2: 'Chaque soir au Muthumuni offre des places au premier rang pour l’un des spectacles les plus époustouflants de la nature. Trouvez votre point de vue idéal — depuis votre balcon privé, le lounge en bord de plage ou notre terrasse de méditation au coucher du soleil — et laissez la beauté sereine vous envelopper.',
            sunsetFeature1: 'Vues dégagées sur l’océan depuis tous les coins',
            sunsetFeature2: 'Méditation calme au coucher du soleil',
            sunsetFeature3: 'Thé aux herbes offert quotidiennement',
            sunsetFeature4: 'Moments parfaits pour les photos chaque soir',
            sunsetImageAlt: 'Coucher de soleil du soir au Muthumuni Beach Resort',
            bestTime: 'Meilleur moment',
            sunsetTime: '18h00 - 18h45',

            // Pool Section
            poolLabel: 'Sérénité aquatique',
            poolTitle: 'Zone piscine',
            poolDesc1: 'Plongez dans la tranquillité de notre piscine à débordement immaculée, où des eaux cristallines rencontrent des jardins tropicaux luxuriants. Conçue pour la détente et le rajeunissement, notre zone piscine offre l’évasion parfaite pour se relaxer sous le soleil sri-lankais.',
            poolDesc2: 'Que vous préfériez une baignade rafraîchissante le matin, une séance de détente l’après-midi avec un bon livre ou un bain paisible le soir, notre zone piscine offre un cadre idyllique. Entourée de transats confortables, de cabanes ombragées et d’un service attentif au bord de la piscine, chaque instant devient un souvenir précieux.',
            poolFeature1: 'Piscine à débordement à température contrôlée',
            poolFeature2: 'Entourée de paysages de jardin tropical',
            poolFeature3: 'Rafraîchissements et snacks sains au bord de la piscine',
            poolFeature4: 'Transats premium avec parasols',
            poolImageAlt: 'Zone piscine relaxante au Muthumuni Resort',

            // Testimonials
            testimonialsTitle: 'Avis de nos hôtes sur leur séjour'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Chambre Deluxe Vue Rivière — Confort avec terrasse ou balcon privé',
            heroSubtitle: 'Détendez-vous dans un havre paisible au bord de la rivière, inspiré par les eaux calmes de Bentota, avec des équipements modernes et une douce brise fluviale.',
            bookThisRoom: 'Réserver cette chambre',
            callReservations: 'Appeler les réservations',

            navAll: 'Toutes',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe vue rivière',

            soothingHideawayTitle: 'Un refuge apaisant au bord de la rivière',
            soothingHideawayDesc: 'Notre chambre Deluxe avec vue sur la rivière est conçue pour des matins lents et des couchers de soleil sans hâte. Tons neutres doux, larges fenêtres et éclairage soigné laissent entrer la vue sur la rivière, tandis que le balcon devient votre coin privé au-dessus de l’eau qui coule.',

            highlight1Title: 'Vue panoramique sur la rivière',
            highlight1Desc: 'Réveillez-vous avec des vues sereines sur le fleuve et des levers de soleil dorés depuis votre balcon privé.',
            highlight2Title: 'Intérieurs élégants au bord de la rivière',
            highlight2Desc: 'Palettes neutres douces, accents en bois chaleureux et généreuse lumière naturelle.',
            highlight3Title: 'Expérience de sommeil apaisante',
            highlight3Desc: 'Lit king-size moelleux avec literie premium pour un repos réparateur.',

            atAGlance: 'En un coup d’œil',
            statSizeLabel: 'Taille',
            statViewLabel: 'Vue',
            statViewValue: 'Sur la rivière',
            statGuestsLabel: 'Invités',
            statBedLabel: 'Lit',
            statBedValue: 'King ou Twin',
            reserve: 'Réserver',

            includedWithStay: 'Inclus avec votre séjour',
            thoughtfulTouches: 'Touches attentionnées, confort toute la journée',
            enhancedCleanliness: 'Normes améliorées de propreté et de sécurité',

            inclusion1: 'Petit-déjeuner, déjeuner et dîner gratuits au restaurant Breeze',
            inclusion2: 'Wi-Fi haut débit et espace de travail dans la chambre',
            inclusion3: 'Service en chambre 24h/24 et concierge',
            inclusion4: 'Nettoyage quotidien avec turndown le soir',
            inclusion5: 'Accès à la piscine à débordement et aux installations spa ayurvédiques',
            inclusion6: 'Parking gratuit et navette vers les attractions proches',

            amenityGroup1Title: 'Caractéristiques de la chambre',
            amenityGroup1Item1: '38 m² d’espace',
            amenityGroup1Item2: 'Balcon privé avec sièges',
            amenityGroup1Item3: 'Climatisation avec contrôle individuel',
            amenityGroup1Item4: 'Coffre-fort dans la chambre',

            amenityGroup2Title: 'Expérience salle de bain',
            amenityGroup2Item1: 'Douche à effet pluie avec eau chaude et froide',
            amenityGroup2Item2: 'Produits de bain premium',
            amenityGroup2Item3: 'Sèche-cheveux',
            amenityGroup2Item4: 'Peignoirs doux et chaussons',

            amenityGroup3Title: 'Confort en chambre',
            amenityGroup3Item1: 'Smart TV 55" avec câble',
            amenityGroup3Item2: 'Station café et thé',
            amenityGroup3Item3: 'Téléphone à ligne directe',

            amenityGroup4Title: 'Connectivité',
            amenityGroup4Item1: 'Wi-Fi gratuit',
            amenityGroup4Item2: 'Bureau',
            amenityGroup4Item3: 'Support réception 24/7',

            inRoomEssentials: 'Essentiels en chambre',
            everythingYouNeed: 'Tout ce dont vous avez besoin pour vous sentir chez vous',
            inRoomEssentialsDesc: 'De la connectivité fluide aux rafraîchissements soigneusement choisis — la chambre Deluxe avec vue sur la rivière allie loisirs et praticité pour vous concentrer sur les moments qui comptent.',

            complimentaryWifi: 'Wi-Fi gratuit',
            coffeeTeaStation: 'Station café et thé',
            roomService: 'Service en chambre 24h/24',
            rainShower: 'Douche à effet pluie',

            byTheRiver: 'Au bord de la rivière',
            slowDownBreathe: 'Ralentissez, respirez l’air frais',

            readyToStay: 'Prêt à séjourner ?',
            reserveDeluxeRiverViewToday: 'Réservez une chambre Deluxe avec vue sur la rivière aujourd’hui',
            speakReservations: 'Parlez à notre équipe de réservations pour les meilleures tarifs disponibles et offres spéciales.',
            checkAvailability: 'Vérifier la disponibilité'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Chambre Deluxe — Confort avec terrasse ou balcon privé',
            heroSubtitle: 'Détendez-vous dans un havre paisible au bord de la rivière, inspiré par les eaux calmes de Bentota, avec des équipements modernes et une douce brise fluviale.',
            bookThisRoom: 'Réserver cette chambre',
            callReservations: 'Appeler les réservations',

            navAll: 'Toutes',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe vue rivière',

            soothingHideawayTitle: 'Un refuge apaisant au bord de la rivière',
            soothingHideawayDesc: 'La chambre Deluxe est conçue pour des matins lents et des couchers de soleil sans hâte. Tons neutres doux, larges fenêtres et éclairage soigné laissent entrer la vue sur la rivière, tandis que le balcon devient votre coin privé au-dessus de l’eau qui coule.',

            highlight1Title: 'Vue panoramique sur la rivière',
            highlight1Desc: 'Réveillez-vous avec des vues sereines sur le fleuve et des levers de soleil tropicaux depuis votre balcon privé.',
            highlight2Title: 'Intérieurs élégants au bord de la rivière',
            highlight2Desc: 'Palettes neutres douces, accents en bois chaleureux et généreuse lumière naturelle.',
            highlight3Title: 'Expérience de sommeil apaisante',
            highlight3Desc: 'Lit king-size moelleux avec literie premium pour un repos réparateur.',

            atAGlance: 'En un coup d’œil',
            statSizeLabel: 'Taille',
            statViewLabel: 'Vue',
            statViewValue: 'Sur la rivière',
            statGuestsLabel: 'Invités',
            statBedLabel: 'Lit',
            statBedValue: 'King ou Twin',
            reserve: 'Réserver',

            includedWithStay: 'Inclus avec votre séjour',
            thoughtfulTouches: 'Touches attentionnées, confort toute la journée',
            enhancedCleanliness: 'Normes améliorées de propreté et de sécurité',

            inclusion1: 'Petit-déjeuner, déjeuner et dîner gratuits au restaurant Breeze',
            inclusion2: 'Wi-Fi haut débit et espace de travail dans la chambre',
            inclusion3: 'Service en chambre 24h/24 et concierge',
            inclusion4: 'Nettoyage quotidien avec turndown le soir',
            inclusion5: 'Accès à la piscine à débordement et aux installations spa ayurvédiques',
            inclusion6: 'Parking gratuit et navette vers les attractions proches',

            amenityGroup1Title: 'Caractéristiques de la chambre',
            amenityGroup1Item1: '41 m² d’espace',
            amenityGroup1Item2: 'Balcon privé avec sièges',
            amenityGroup1Item3: 'Climatisation avec contrôle individuel',
            amenityGroup1Item4: 'Coffre-fort dans la chambre',

            amenityGroup2Title: 'Expérience salle de bain',
            amenityGroup2Item1: 'Douche à effet pluie avec eau chaude et froide',
            amenityGroup2Item2: 'Produits de bain premium',
            amenityGroup2Item3: 'Sèche-cheveux',
            amenityGroup2Item4: 'Peignoirs doux et chaussons',

            amenityGroup3Title: 'Confort en chambre',
            amenityGroup3Item1: 'Smart TV 55" avec câble',
            amenityGroup3Item2: 'Station café et thé',
            amenityGroup3Item3: 'Téléphone à ligne directe',

            amenityGroup4Title: 'Connectivité',
            amenityGroup4Item1: 'Wi-Fi gratuit',
            amenityGroup4Item2: 'Bureau',
            amenityGroup4Item3: 'Assistance réception 24/7',

            inRoomEssentials: 'Essentiels en chambre',
            everythingYouNeed: 'Tout ce dont vous avez besoin pour vous sentir chez vous',
            inRoomEssentialsDesc: 'De la connectivité fluide aux rafraîchissements soigneusement choisis — la chambre Deluxe allie loisirs et praticité pour que vous puissiez vous concentrer sur les moments qui comptent.',

            complimentaryWifi: 'Wi-Fi gratuit',
            coffeeTeaStation: 'Station café et thé',
            roomService: 'Service en chambre 24h/24',
            rainShower: 'Douche à effet pluie',

            byTheRiver: 'Au bord de la rivière',
            slowDownBreathe: 'Ralentissez, respirez l’air frais',

            readyToStay: 'Prêt à séjourner ?',
            reserveDeluxeToday: 'Réservez la chambre Deluxe dès aujourd’hui',
            speakReservations: 'Parlez à notre équipe de réservations pour les meilleurs tarifs disponibles et offres spéciales.',
            checkAvailability: 'Vérifier la disponibilité'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Votre sanctuaire vous attend',
            heroSubtitle: 'Sanctuaires au bord de la rivière conçus pour la guérison, la restauration et une profonde paix le long du paisible fleuve Bentota.',
            exploreRooms: 'Découvrir nos chambres',

            filterAll: 'Toutes',
            filterDeluxeRooms: 'Chambres Deluxe',
            filterRiverViewDeluxe: 'Chambre Deluxe vue rivière',

            deluxeRoomName: 'Chambre Deluxe',
            deluxeRoomCategory: 'Chambres Deluxe',
            deluxeRoomDesc: 'Chambre harmonieusement équilibrée avec des éléments en bois naturel et vue sur la rivière pour une tranquillité parfaite.',

            riverViewDeluxeName: 'Deluxe vue rivière',
            riverViewDeluxeCategory: 'Chambre Deluxe avec vue sur la rivière',
            riverViewDeluxeDesc: 'Réveillez-vous aux doux sons de la rivière et profitez de vues panoramiques sur le fleuve dans cette chambre deluxe élégamment conçue.',

            noRoomsFound: 'Aucune chambre trouvée dans cette catégorie.',
            roomSize: 'Taille de la chambre',
            guests: 'Invités',
            amenitiesCount: 'Équipements',
            roomAmenities: 'Équipements de la chambre',
            specialFeatures: 'Caractéristiques spéciales',

            kingSizeBed: 'Lit King Size',
            workDesk: 'Bureau',
            rainShower: 'Douche à effet pluie',
            teaStation: 'Station thé',
            privateTerrace: 'Terrasse privée',
            binoculars: 'Jumelles',

            riverView: 'Vue sur la rivière',
            naturalLighting: 'Lumière naturelle',
            gardenView: 'Vue sur le jardin',
            sunriseBalcony: 'Balcon lever de soleil',
            soundOfRiver: 'Bruit de la rivière',

            bookNow: 'Réserver maintenant',
            viewDetails: 'Voir les détails',
            viewRoom: 'Voir la chambre',

            allRoomsInclude: 'Toutes les chambres incluent',
            essentialComforts: 'Conforts essentiels pour votre voyage de bien-être',

            highSpeedWifi: 'Wi-Fi haut débit',
            herbalTea: 'Sélection de thés aux herbes',
            climateControl: 'Climatisation',
            organicToiletries: 'Produits de toilette bio',
            dailyHousekeeping: 'Nettoyage quotidien',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tapis de yoga et accessoires',

            beginHealing: 'Commencez votre voyage de guérison',
            beginHealingDesc: 'Vivez un authentique bien-être ayurvédique dans un environnement fluvial serein conçu pour nourrir le corps, apaiser l’esprit et restaurer l’esprit.',
            reserveRoom: 'Réserver votre chambre',
            speakAdvisor: 'Parler à un conseiller bien-être',

            exploreOurRooms: 'Explorer nos chambres'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Ayurveda au bord de la rivière',
            heroTagline: 'Trouvez l’équilibre, respirez librement et renouvelez votre énergie à Aluthgama',
            exploreResort: 'Découvrir le resort',
            bookNow: 'Réserver maintenant',

            welcomeLabel: 'Bienvenue',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Niché le long de la paisible rive du fleuve Bentota, le Muthumuni Ayurveda River Resort offre une fusion harmonieuse entre les anciennes traditions de guérison et la beauté naturelle sereine. Notre sanctuaire vous invite à entreprendre un voyage transformateur de bien-être, où le doux écoulement de la rivière rencontre la sagesse intemporelle de l’Ayurveda.',
            welcomeDesc2: 'Vivez des traitements ayurvédiques personnalisés, savourez une cuisine nourrissante adaptée à votre dosha et détendez-vous dans des chambres élégamment aménagées avec une vue imprenable sur la rivière. Que vous recherchiez la régénération, la relaxation ou le renouveau spirituel, notre équipe dédiée de praticiens ayurvédiques et d’experts en bien-être vous accompagne à chaque étape.',
            learnMore: 'En savoir plus',
            contactUs: 'Nous contacter',
            welcomeImageCaption: 'Benessere ayurvédique & Retraite fluviale',
            welcomeImageLocation: 'Aluthgama, Sri Lanka',

            highlightTitle: 'Un sanctuaire ayurvédique au bord de la rivière',
            highlightDesc: 'Découvrez la guérison holistique le long de la rive paisible du Bentota. Des traitements sur mesure aux balcons silencieux en passant par une cuisine consciente : chaque détail est conçu pour rétablir votre rythme naturel.',

            roomsTitle: 'Nos chambres',
            roomsDesc: 'Choisissez le sanctuaire qui correspond à votre rythme : des suites aérées aux retraites deluxe cosy, chacune équipée de draps doux, de bois chaleureux et de balcons prêts pour le lever du soleil.',
            room1Title: 'Chambres Deluxe',
            room1Desc: 'Retraites cosy avec lits moelleux, vue sur le jardin et accents en bois chaleureux pour un confort quotidien.',
            room2Title: 'Deluxe Vue Rivière',
            room2Desc: 'Réveillez-vous avec une vue sereine sur la rivière, des draps doux et un balcon privé idéal pour des matins paisibles.',
            viewRoom: 'Voir la chambre',
            bookableNow: 'Réservable maintenant',
            riverBreezeReady: 'Prêt pour la brise fluviale',
            roomBadge: 'Évasion au bord de la rivière',

            achievementsTitle: 'Benessere fiable au bord de la rivière',
            achievement1Title: 'Clients heureux',
            achievement1Count: '1 000+',
            achievement2Title: 'Traitements ayurvédiques',
            achievement2Count: '20+',
            achievement3Title: 'Années de soin',
            achievement3Count: '15+',
            achievement4Title: 'Reconnaissances des voyageurs',
            achievement4Count: '1 000+',

            experiencesTitle: 'Découvrez les expériences au Muthumuni Ayurveda River Resort',
            experiencesDesc: 'Des parcours ayurvédiques aux excursions soigneusement sélectionnées : choisissez les expériences qui rendront votre séjour inoubliable.',
            planYourStay: 'Planifiez votre séjour',
            experience1Title: 'Nos chambres',
            experience1Desc: 'Espaces aérés avec balcons, vue sur le fleuve ou le jardin et conforts pensés pour des séjours sans hâte.',
            experience2Title: 'Spa ayurvédique',
            experience2Desc: 'Thérapies authentiques, bains de vapeur et massages régénérants réalisés selon des rituels ancestraux.',
            experience3Title: 'Dîner au bord de la rivière',
            experience3Desc: 'Cuisine nourrissante sri-lankaise et internationale conçue pour nourrir le corps et l’esprit.',
            experience4Title: 'Expériences & Excursions',
            experience4Desc: 'Safaris fluviaux sur le Bentota, visites de temples, sports nautiques et excursions culturelles autour de Bentota.',

            galleryTitle: 'Instants au Muthumuni Ayurveda River Resort',
            galleryDesc: 'Un aperçu de notre sanctuaire fluvial — levers de soleil, soins sereins, assiettes nourrissantes et coins tranquilles créés pour vous.',
            gallery1Alt: 'Rive fluviale ensoleillée bordée de palmiers à Muthumuni',
            gallery2Alt: 'Traitement ayurvédique à l’huile en cours',
            gallery3Alt: 'Piscine du resort avec transats',
            gallery4Alt: 'Ingrédients herbacés préparés pour le spa',
            gallery5Alt: 'Couple profitant du coucher de soleil au bord de la rivière',
            gallery6Alt: 'Plateforme yoga face à la rivière',
            gallery7Alt: 'Allée dans le jardin tropical',
            gallery8Alt: 'Petit-déjeuner sain',
            gallery9Alt: 'Vue paisible sur la rivière',
            gallery10Alt: 'Extérieur du resort chaleureusement éclairé au crépuscule',
            gallery11Alt: 'Exposition d’herbes et d’huiles ayurvédiques',
            gallery12Alt: 'Coin détente près du jardin',

            boatLabel: 'Aventures fluviales',
            boatTitle: 'Balades en bateau sur le fleuve Bentota',
            boatDesc1: 'Découvrez la magie du fleuve Bentota avec nos charmantes balades en bateau. Glissez sur des voies d’eau tranquilles entourées de forêts de mangroves luxuriantes, en observant une faune exotique : martin-pêcheurs colorés, crocodiles, varans et singes espiègles. Parfait pour les amoureux de la nature et les photographes en quête de moments inoubliables.',
            boatDesc2: 'Que vous optiez pour une croisière matinale paisible, un voyage romantique au coucher du soleil ou une exploration aventureuse de la faune, nos guides expérimentés partageront des informations fascinantes sur l’écosystème du fleuve. Personnalisez votre expérience avec nos options de charter privé ou rejoignez nos visites de groupe pour un contact plus intime avec la nature.',
            boatFeature1: 'Croisières pittoresques à travers les mangroves',
            boatFeature2: 'Observation de la faune — oiseaux, crocodiles & singes',
            boatFeature3: 'Options de croisière au lever et coucher du soleil',
            boatFeature4: 'Guides locaux expérimentés inclus',
            boatImageAlt: 'Balade en bateau sur le fleuve Bentota',

            poolLabel: 'Sérénité aquatique',
            poolTitle: 'Zone piscine',
            poolDesc1: 'Plongez dans la tranquillité de notre piscine à débordement immaculée, où l’eau cristalline rencontre des jardins tropicaux luxuriants. Conçue pour la détente et la régénération, la zone piscine offre l’évasion parfaite pour se relaxer sous le soleil sri-lankais.',
            poolDesc2: 'Que vous préfériez une baignade rafraîchissante le matin, une séance de détente l’après-midi avec un bon livre ou un bain paisible le soir, notre zone piscine offre un cadre idyllique. Entourée de transats confortables, de cabanes ombragées et d’un service attentif au bord de la piscine, chaque instant devient un souvenir précieux.',
            poolFeature1: 'Piscine à débordement à température contrôlée',
            poolFeature2: 'Entourée de paysages de jardin tropical',
            poolFeature3: 'Rafraîchissements et snacks sains au bord de la piscine',
            poolFeature4: 'Transats premium avec parasols',
            poolImageAlt: 'Zone piscine relaxante',

            testimonialsTitle: 'Avis des clients sur leur séjour',

            bookingDestination: 'Destination',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Arrivée',
            bookingCheckOut: 'Départ',
            bookingGuests: 'Invités',
            guestsOption1: '1 Invité',
            guestsOption2: '2 Invités',
            guestsOption3: '3 Invités',
            guestsOption4: '4+ Invités',
            bookingCheckAvailability: 'Vérifier la disponibilité',

            service1Title: 'Thérapies ayurvédiques holistiques',
            service1Desc: 'Consultations personnalisées, huiles herbales authentiques et traitements quotidiens guidés par des médecins ayurvédiques expérimentés.',

            service2Title: 'Chambres au bord de la rivière',
            service2Desc: 'Réveillez-vous au son doux de la rivière, avec des balcons privés et des intérieurs apaisants conçus pour un repos profond.',

            service3Title: 'Cuisine bien-être',
            service3Desc: 'Produits frais du Sri Lanka, menus à base de plantes et plans de repas adaptés à votre dosha.',

            service4Title: 'Yoga et pleine conscience',
            service4Desc: 'Yoga au lever du soleil, méditation au coucher du soleil et sessions de respiration face au rythme des vagues.',

            service5Title: 'Excursions fluviales et côtières',
            service5Desc: 'Balades en bateau sur la rivière Bentota, visites de la ferme de tortues, promenades dans les jardins d’épices et circuits à vélo dans les villages.'
        },
        aboutus2: {
            heroTitle: 'À propos de nous',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'La sagesse ancienne rencontre la beauté paisible du bord de rivière au Muthumuni Ayurveda River Resort',
            heroTagline2: 'Traitements ayurvédiques personnalisés, vues sur la rivière et authentique hospitalité sri-lankaise',
            slide1: 'Guérison ayurvédique',
            slide2: 'Sérénité au bord de la rivière',
            slide3: 'Tranquillité du jardin',
            slide4: 'Thérapies aux herbes',
            slide5: 'Bien-être fluvial',
            historyLabel: 'Notre parcours',
            historyTitle: 'Histoire du Muthumuni Ayurveda River Resort',
            historyDesc1: 'Fondé il y a plus de deux décennies, le Muthumuni Ayurveda River Resort est né d’une vision : créer un sanctuaire où la sagesse ancienne de l’Ayurveda rencontre la beauté paisible des paysages fluviaux du Sri Lanka. Ce qui a commencé comme un modeste centre de bien-être s’est épanoui en l’une des destinations les plus appréciées d’Aluthgama pour la guérison holistique et le rajeunissement.',
            historyDesc2: 'Nos fondateurs, inspirés par des générations de praticiens ayurvédiques traditionnels, ont cherché à préserver ces arts de guérison intemporels tout en offrant des conforts modernes et une authentique hospitalité sri-lankaise. Au fil des années, nous sommes restés fidèles à notre engagement envers des expériences de bien-être authentiques, développant nos installations sans jamais perdre de vue le soin personnalisé qui définit notre héritage.',
            historyDesc3: 'Aujourd’hui, Muthumuni témoigne de la puissance durable de l’Ayurveda, ayant accueilli des milliers de visiteurs du monde entier. Chaque hôte devient partie de notre histoire, trouvant équilibre, guérison et transformation dans notre havre paisible au bord de la rivière.',
            statYear: '15+',
            statYearLabel: 'Années d’excellence en bien-être',
            statGuest: '1 000+',
            statGuestLabel: 'Clients satisfaits',
            experienceLegacy: 'Découvrez notre héritage',
            established: 'Fondé',
            sinceYear: 'Depuis 1993',
            chairmanLabel: 'Message du président',
            chairmanTitle: 'Guidé par le soin, ancré dans l’Ayurveda',
            chairmanDesc1: 'Bienvenue au Muthumuni Ayurveda River Resort. Depuis plus de deux décennies, notre objectif est simple : offrir une guérison authentique fondée sur la sagesse intemporelle de l’Ayurveda, transmise avec la chaleur de l’hospitalité sri-lankaise.',
            chairmanDesc2: 'Ici, chaque détail — des thérapies à la cuisine en passant par la sérénité des lieux — est conçu pour vous aider à ralentir, rétablir l’équilibre et vous reconnecter à vous-même. Nous sommes honorés de faire partie de votre parcours de bien-être.',
            chairmanDesc3: 'Au nom de notre équipe dévouée, je vous invite à découvrir le soin, l’authenticité et la sérénité qui définissent Muthumuni.',
            chairmanBadge: 'Président',
            chairmanName: 'M. Nihal Muthumuni',
            chairmanSignature: '— M. Nihal Muthumuni',
            chairmanImageAlt: 'Président M. Nihal Muthumuni',
            staffLabel: 'Notre équipe',
            staffTitle: 'Rencontrez notre équipe dévouée',
            staffDesc1: 'Au Muthumuni Ayurveda River Resort, notre équipe est au cœur de tout ce que nous faisons. Nos collaborateurs sont des professionnels soigneusement sélectionnés et formés, animés par une profonde passion pour le bien-être ayurvédique et l’hospitalité authentique.',
            staffDesc2: 'De nos praticiens ayurvédiques expérimentés et thérapeutes du massage qualifiés à notre équipe d’hospitalité dédiée, chaque membre apporte des années d’expertise et une réelle attention à chaque interaction avec les hôtes. Nous croyons que le véritable bien-être ne vient pas seulement des soins, mais de la chaleur et de l’attention de personnes qui se soucient sincèrement de votre parcours.',
            staffDesc3: 'Notre personnel suit une formation continue aux dernières pratiques ayurvédiques tout en maintenant les plus hauts standards de professionnalisme et de sensibilité culturelle. Nous sommes fiers de créer des liens significatifs avec nos hôtes, garantissant que chaque séjour devienne une expérience mémorable et transformatrice.',
            statStaff: '15+',
            statStaffLabel: 'Professionnels qualifiés',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Satisfaction des hôtes',
            staffImageAlt: 'Notre équipe dévouée au Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Notre engagement',
            excellenceCare: 'Excellence & Soin',
            ctaLabel: 'Contactez-nous',
            ctaHeading: 'Prêt à commencer votre voyage de bien-être ?',
            ctaDesc: 'Contactez notre équipe pour réserver votre retraite ayurvédique personnalisée. Que vous ayez des questions sur nos thérapies, hébergements ou forfaits bien-être spéciaux, nous sommes là pour vous aider à créer votre échappée parfaite.',
            ctaButtonContact: 'Contactez-nous maintenant',
            ctaButtonRooms: 'Découvrir les chambres',
            quickInfoCall: 'Appelez-nous',
            quickInfoEmail: 'Envoyez-nous un e-mail',
            quickInfoLocation: 'Localisation',
            locationCity: 'Aluthgama, Sri Lanka'
        },
        ayurveda2: {
            accordionTitle1: 'Qu’est-ce que le Panchakarma Ayurveda ?',
            accordionDesc1: 'L’Ayurveda (mot sanskrit signifiant « science de la vie ») est un ancien système de guérison holistique. Le Panchakarma est un ensemble de thérapies de purification et de régénération visant à rétablir l’équilibre entre corps, esprit et âme.',
            accordionTitle2: 'Panchakarma Ayurveda et votre énergie vitale',
            accordionDesc2: 'Le Panchakarma se concentre sur l’élimination des toxines et le rétablissement de l’harmonie entre les doshas (Vata, Pitta, Kapha). Les soins sont personnalisés pour chaque hôte afin de soutenir un bien-être et une vitalité durables.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Vata régit le mouvement et la circulation. En équilibre, il favorise la créativité et la vitalité. Le Panchakarma propose des traitements ancrants pour apaiser l’excès de Vata et restaurer l’équilibre.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Pitta régit la digestion et le métabolisme. Des thérapies rafraîchissantes et régénérantes aident à équilibrer Pitta et à réduire inflammations et irritabilité.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Kapha soutient la structure et la stabilité. Des thérapies dynamisantes et stimulantes de la circulation sont utilisées pour réduire l’excès de Kapha et favoriser légèreté et souplesse.',
            close: 'Fermer',
            next: 'Suivant',
            previous: 'Précédent',
            treatmentsTitle: 'Nos soins Panchakarma Ayurveda signature',
            treatmentsSubtitle: 'Thérapies ancestrales pour détoxifier, régénérer et rétablir l’équilibre.',
            bookTreatment: 'Réserver ce soin',
            benefitsTitle: 'Bienfaits des soins Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Versement doux d’huile chaude aux herbes sur le front pour calmer l’esprit.',
            shirodhara1: 'Réduit stress et anxiété',
            shirodhara2: 'Favorise un meilleur sommeil',
            shirodhara3: 'Améliore la clarté mentale',
            steamBath: 'Bain de vapeur',
            steamBathDesc: 'Traitement detox à la vapeur pour ouvrir les pores et détendre les muscles.',
            steamBath1: 'Détoxifie le corps',
            steamBath2: 'Améliore la circulation',
            steamBath3: 'Soulage les tensions musculaires',
            flowerBath: 'Bain aux fleurs',
            flowerBathDesc: 'Bain apaisant infusé de fleurs parfumées pour la détente.',
            flowerBath1: 'Calme le système nerveux',
            flowerBath2: 'Hydrate la peau',
            flowerBath3: 'Élève l’humeur',
            headMassage: 'Massage de la tête',
            headMassageDesc: 'Massage relaxant ciblant le cuir chevelu pour soulager les tensions.',
            headMassage1: 'Réduit les maux de tête',
            headMassage2: 'Améliore la santé du cuir chevelu',
            headMassage3: 'Favorise la détente',
            faceMassage: 'Massage du visage',
            faceMassageDesc: 'Massage régénérant pour illuminer le teint et réduire le stress.',
            faceMassage1: 'Améliore le teint',
            faceMassage2: 'Réduit les tensions faciales',
            faceMassage3: 'Stimule le drainage lymphatique',
            neckMassage: 'Massage du cou',
            neckMassageDesc: 'Massage ciblé pour soulager raideur et tensions au cou.',
            neckMassage1: 'Soulage les douleurs cervicales',
            neckMassage2: 'Améliore la mobilité',
            neckMassage3: 'Réduit le stress',
            shoulderMassage: 'Massage des épaules',
            shoulderMassageDesc: 'Massage ciblé pour soulager raideur et inconfort aux épaules.',
            shoulderMassage1: 'Réduit les douleurs aux épaules',
            shoulderMassage2: 'Améliore la posture',
            shoulderMassage3: 'Détend les muscles',
            bodyMassage: 'Massage corporel',
            bodyMassageDesc: 'Massage complet pour favoriser détente et bien-être global.',
            bodyMassage1: 'Améliore la circulation',
            bodyMassage2: 'Soulage les courbatures',
            bodyMassage3: 'Favorise la détente',
            backMassage: 'Massage du dos',
            backMassageDesc: 'Massage thérapeutique ciblant douleurs et tensions dorsales.',
            backMassage1: 'Soulage les douleurs dorsales',
            backMassage2: 'Améliore la santé de la colonne',
            backMassage3: 'Réduit le stress',
            footMassage: 'Massage des pieds',
            footMassageDesc: 'Massage apaisant pour soulager les douleurs aux pieds et favoriser la détente.',
            footMassage1: 'Améliore la circulation',
            footMassage2: 'Réduit la fatigue des pieds',
            footMassage3: 'Favorise la détente',
            purgative: 'Purgatif',
            purgativeDesc: 'Thérapie nettoyante pour éliminer l’excès de Pitta et les toxines du système digestif.',
            purgative1: 'Nettoie le côlon',
            purgative2: 'Équilibre le dosha Pitta',
            purgative3: 'Améliore la santé digestive',
            nasalClearing: 'Nettoyage nasal',
            nasalClearingDesc: 'Traitement nasal thérapeutique pour dégager les sinus et améliorer la respiration.',
            nasalClearing1: 'Dégage la congestion nasale',
            nasalClearing2: 'Améliore la respiration',
            nasalClearing3: 'Soulage les problèmes sinusaux',
            powderMassage: 'Massage à la poudre',
            powderMassageDesc: 'Massage exfoliant avec poudres d’herbes pour régénérer et rafraîchir la peau.',
            powderMassage1: 'Exfolie la peau morte',
            powderMassage2: 'Améliore la texture de la peau',
            powderMassage3: 'Stimule la circulation',
            intensiveMassageDesc: 'Un massage thérapeutique profond ciblant les tensions chroniques et les nœuds musculaires avec une pression ferme et des techniques spécialisées.',
            intensiveMassage1: 'Soulage les tensions musculaires profondes',
            intensiveMassage2: 'Améliore la circulation sanguine',
            intensiveMassage3: 'Réduit les courbatures',
            thermoMassage: 'Massage Thermo',
            thermoMassageDesc: 'Un massage chaud à l’huile aux herbes avec des huiles thérapeutiques chauffées pour renforcer la détente et les bienfaits curatifs.',
            thermoMassage1: 'Apaise les muscles endoloris',
            thermoMassage2: 'Favorise une profonde relaxation',
            thermoMassage3: 'Améliore la circulation énergétique',
            synchronMassage: 'Massage Synchronisé',
            synchronMassageDesc: 'Un massage synchronisé à deux thérapeutes pour une harmonie corporelle complète et une répartition équilibrée de l’énergie.',
            synchronMassage1: 'Harmonie complète du corps',
            synchronMassage2: 'Flux énergétique équilibré',
            synchronMassage3: 'Expérience de relaxation profonde',
            specialMassage: 'Massage Spécial',
            specialMassageDesc: 'Thérapie de massage personnalisée adaptée à vos besoins spécifiques de santé et à vos objectifs personnels de bien-être.',
            specialMassage1: 'Traitement personnalisé',
            specialMassage2: 'Cible les problèmes spécifiques',
            specialMassage3: 'Approche de guérison sur mesure',
            benefit1Title: 'Détoxification :',
            benefit1Desc: 'Les soins Panchakarma aident à éliminer les toxines du corps, favorisant santé et vitalité globale.',
            benefit2Title: 'Amélioration de la digestion :',
            benefit2Desc: 'Ces thérapies renforcent la fonction digestive, améliorant l’absorption des nutriments et le métabolisme.',
            benefit3Title: 'Réduction du stress :',
            benefit3Desc: 'Le Panchakarma est reconnu pour ses effets calmants sur le corps et l’esprit, diminuant stress et anxiété.',
            benefit4Title: 'Renforcement de l’immunité :',
            benefit4Desc: 'Des soins réguliers de Panchakarma peuvent renforcer le système immunitaire, rendant le corps plus résistant aux maladies.',
            benefit5Title: 'Régénération :',
            benefit5Desc: 'Les thérapies favorisent la régénération cellulaire, améliorant la santé de la peau et l’apparence de jeunesse.',
            benefit6Title: 'Équilibre des doshas :',
            benefit6Desc: 'Le Panchakarma aide à rétablir l’équilibre des doshas (Vata, Pitta, Kapha), essentiel pour maintenir la santé selon les principes ayurvédiques.',
            gallery1: 'Thérapie Shirodhara',
            gallery2: 'Bain de vapeur',
            gallery3: 'Bain aux fleurs',
            gallery4: 'Massage de la tête',
            gallery5: 'Massage corporel',
            gallery6: 'Massage du cou',
            gallery7: 'Massage du visage',
            gallery8: 'Massage des épaules',
            sectionEyebrow: 'Panchakarma Ayurveda à Muthumuni',
            sectionDescription: 'Découvrez l’art ancestral de guérison du Panchakarma Ayurveda dans notre retraite au bord de la rivière. Nos praticiens ayurvédiques experts proposent des soins personnalisés pour détoxifier, régénérer et rétablir l’équilibre du corps, de l’esprit et de l’âme.',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Régénérez corps, esprit et âme à Aluthgama',
            heroAlt: 'Ayurveda & Bien-être au Muthumuni River Resort',
            treatmentProgramme: {
                title: 'Programme de traitement ayurvédique',
                subtitle: 'Votre voyage vers l\'équilibre, la détoxification et le renouveau profond',
                intro: 'Découvrez la guérison ayurvédique authentique dans une retraite paisible qui restaure votre corps, calme votre esprit et renouvelle votre énergie. Dès votre arrivée, notre équipe prend soin de chaque détail – afin que vous puissiez vous concentrer entièrement sur votre bien-être.',
                welcomeTitle: 'Accueil et début en douceur',
                welcome1: 'Transfert depuis l\'aéroport et arrivée à l\'hôtel',
                welcome2: 'Accueil chaleureux et visite de l\'hôtel',
                welcome3: 'Introduction à votre plan de bien-être hebdomadaire',
                welcome4: 'Massage de relaxation (jour 1) au centre ayurvédique pour soulager la fatigue du voyage et préparer votre corps aux traitements',
                doctorTitle: 'Consultation médicale et plan personnalisé',
                doctor1: 'Consultation médicale ayurvédique (jour 2 – matin)',
                doctor2: 'Évaluation complète de votre dosha/type de corps et problèmes de santé',
                doctor3: 'Traducteur disponible sur demande',
                doctor4: 'Votre médecin créera un plan de traitement personnalisé adapté à vos besoins et objectifs',
                dailyTitle: 'Thérapies ayurvédiques quotidiennes',
                daily1: '4–5 traitements par jour (selon recommandation du médecin)',
                daily2: 'Thérapies sélectionnées en fonction de votre constitution corporelle et de votre état',
                daily3: 'Des massages spéciaux peuvent être ajoutés selon les besoins',
                daily4: 'Le médecin surveille les progrès quotidiennement et peut ajuster les traitements et le soutien à base de plantes pour garantir les meilleurs résultats',
                daily5: 'Si nécessaire, une procédure de nettoyage/purgatif doux peut être recommandée',
                herbalTitle: 'Soutien aux médicaments à base de plantes',
                herbalIntro: 'Médicaments à base de plantes prescrits par le médecin deux fois par jour :',
                herbal1: 'au petit-déjeuner',
                herbal2: 'au dîner',
                herbalClosing: 'Soutiennent la guérison interne, la détoxification et l\'équilibre à long terme.',
                yogaTitle: 'Yoga et méditation pour l\'harmonie corps-esprit',
                yoga1: 'Séances de yoga 4 fois par semaine (environ 1 heure)',
                yoga2: 'Séances de méditation 2 fois par semaine :',
                yoga3: '— une expérience spirituelle unique dans un temple sur l\'île, accessible en bateau',
                yoga4: '— méditation guidée par des moines (environ 1 heure)',
                wellnessTitle: 'Expériences de bien-être incluses',
                wellness1: 'Démonstrations de cuisine saine hebdomadaires',
                wellness2: 'Excursion gratuite (expérience culturelle/naturelle)',
                closingTitle: 'Cérémonie de clôture et départ',
                closing1: 'Un magnifique bain de fleurs (dernier jour) – rituel traditionnel de renouveau',
                closing2: 'Consultation médicale finale pour examiner les progrès et fournir :',
                closing3: '— conseils continus pour le bien-être',
                closing4: '— prescriptions et recommandations pour la maison',
                closing5: 'Transfert vers l\'aéroport',
            }
        },
        yoga2: {
            heroTitle: 'Yoga au Resort',
            heroSubtitle: 'Trouver équilibre, force et paix intérieure à Beruwala',
            heroAlt: 'Yoga au Muthumuni Resort',
            importanceEyebrow: 'Bien-être & Équilibre',
            importanceTitle: 'Importance du Yoga et de la Méditation',
            importanceImageAlt: 'Importance du Yoga et de la Méditation',
            importanceText1: 'Le yoga et la méditation sont des pratiques anciennes offrant de nombreux bienfaits physiques, mentaux et émotionnels. Ils favorisent la souplesse, la force et l’équilibre tout en réduisant le stress et l’anxiété.',
            importanceText2: 'Une pratique régulière améliore la concentration, la qualité du sommeil et le bien-être général. Le yoga encourage également la pleine conscience, aidant les individus à se reconnecter à leur moi intérieur et à trouver la paix au milieu du tumulte de la vie quotidienne.',
            importanceText3: 'Au Muthumuni Resort, nous offrons des environnements sereins parfaits pour pratiquer le yoga et la méditation, permettant aux hôtes de revitaliser leur corps, leur esprit et leur âme.',
            practiceEyebrow: 'Notre pratique',
            practiceTitle: 'Pratique et expérience du yoga',
            practiceImageAlt: 'Pratique du yoga au resort',
            practiceText1: 'Au Muthumuni Resort, nous pratiquons principalement le Hatha Yoga traditionnel combiné au Pranayama (techniques de respiration). Cette approche holistique vise à éveiller la conscience intérieure et à stimuler doucement la Kundalini tout en mettant l’accent sur l’alignement de la colonne vertébrale et la souplesse.',
            practiceText2: 'Les sessions de yoga ont lieu régulièrement et conviennent aussi bien aux débutants qu’aux pratiquants expérimentés. De temps en temps, des sessions spéciales comme l’Ashtanga Yoga sont proposées.',
            practiceText3: 'Toutes les sessions se déroulent dans notre Yoga Shala dédiée, un espace calme et serein conçu pour favoriser la concentration, l’équilibre et le mouvement en pleine conscience. Chaque séance commence généralement par les Salutations au Soleil, suivies de Pranayama et d’une séquence d’asanas soigneusement sélectionnées pour améliorer la souplesse et la circulation.',
            practiceText4: 'Nos professeurs de yoga expérimentés adaptent chaque séance aux besoins, capacités et conditions de santé individuelles des hôtes, garantissant une expérience sûre et profondément bénéfique.',
            spiritualEyebrow: 'Voyage spirituel',
            spiritualTitle: 'Méditation et activités spirituelles',
            spiritualSubtitle: 'Approfondissez votre pratique spirituelle avec nos cérémonies sacrées et sessions de méditation guidée',
            meditationImageAlt: 'Méditation et pratique spirituelle au resort',
            meditationTitle: 'Sessions de méditation',
            meditationDesc: 'Les hôtes sont invités à participer à des sessions de méditation guidée inspirées des pratiques traditionnelles. Ces séances sont conçues pour calmer l’esprit, approfondir la conscience et soutenir la guérison émotionnelle et spirituelle dans un environnement paisible.'
        },
        food2: {
            heroTitle: 'Cuisine Ayurvédique & Côtière',
            heroSubtitle: 'Saveurs authentiques du Sri Lanka & cuisine côtière fraîche',
            heroAlt: 'Expérience culinaire au Muthumuni Beach Resort',
            wellnessEyebrow: 'Bien-être par l’alimentation',
            wellnessTitle: 'L’importance de la',
            ayurvedicFood: 'Cuisine ayurvédique',
            wellnessIntro1: 'En Ayurveda, l’alimentation est considérée comme la plus grande médecine. Ce que vous mangez influence directement vos doshas (Vata, Pitta, Kapha), votre digestion (agni) et l’équilibre global du corps, de l’esprit et de l’âme.',
            wellnessIntro2: 'La nutrition ayurvédique met l’accent sur des aliments frais, de saison et complets, préparés avec soin et consommés en pleine conscience. Chaque repas inclut les six saveurs (sucré, acide, salé, piquant, amer, astringent) pour nourrir tous les sens et maintenir l’harmonie.',
            wellnessIntro3: 'Une alimentation ayurvédique appropriée renforce la digestion, aide à éliminer les toxines (ama), stimule l’immunité, augmente l’énergie, réduit le stress et prévient de nombreuses maladies chroniques. Au Muthumuni, chaque plat est conçu selon votre constitution unique pour une guérison profonde et une vitalité renforcée.',
            foodImage1Alt: 'Repas ayurvédique traditionnel avec les six saveurs',
            foodImage2Alt: 'Herbes et épices ayurvédiques pour une nutrition équilibrée',
            culinaryPhilosophyEyebrow: 'Notre philosophie culinaire',
            culinaryPhilosophyTitle: 'Nutrition',
            nutritionHighlight: 'Ayurvédique',
            culinaryPhilosophyResort: 'au Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Cuisine ayurvédique au Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Frais & nourrissant',
            healingIngredientsAlt: 'Ingrédients et épices ayurvédiques sains',
            healingIngredientsLabel: 'Ingrédients curatifs',
            philosophyText1: 'Les aliments, qui englobent les six goûts principaux (sucré, acide, salé, amer, piquant, astringent) ainsi que de nombreuses variations subtiles, sont décrits dans les textes classiques ayurvédiques – certains datant de plus de 5 000 ans – avec leurs propriétés essentielles : Guna (qualité intrinsèque), Virya (puissance – chauffante ou rafraîchissante), Vipaka (effet post-digestif) et Prabhava (action spéciale unique).',
            philosophyText2: 'C’est pourquoi la nutrition ayurvédique joue un rôle central au Muthumuni Ayurveda Beach Resort. Cela ne signifie pas un régime rigide et monotone de plats végétariens fades, insipides ou trop amers dictés uniquement par les médecins. Au contraire, notre cuisine ayurvédique est l’une de nos plus grandes forces : les plats préparés par nos talentueux cuisiniers vous surprendront et vous raviront chaque jour de votre séjour !',
            philosophyText3: 'Au petit-déjeuner, profitez d’un généreux buffet avec des fruits tropicaux frais, des jus fraîchement pressés, des soupes d’herbes nourrissantes, du pain maison et des biscuits légers, ainsi qu’une variété d’options authentiques pour le petit-déjeuner sri-lankais. Au déjeuner, savourez un buffet coloré et savoureux avec des currys de poisson doux, des préparations de légumes et des plats infusés d’herbes. Le soir, nous proposons un menu fixe végétarien avec une option de poisson frais. Le samedi, nous célébrons la « Sri Lankan Night » avec un buffet élargi – nos chefs préparent des spécialités locales traditionnelles devant vous, créant une expérience vivante et authentique.',
            philosophyText4: 'En Ayurveda, les aliments et boissons sont classés de multiples façons – selon le goût et les propriétés, la capacité digestive (agni), l’adéquation à des conditions de santé spécifiques, la saisonnalité, etc. Au Muthumuni, nous prenons simultanément en compte tous ces facteurs et nous efforçons consciemment d’inclure les six saveurs dans des combinaisons équilibrées adaptées à la constitution individuelle de chaque hôte.',
            philosophyText5: 'Nos repas mettent en avant des légumes frais, des fruits tropicaux et du poisson issu de sources responsables. Nous ne servons ni viande rouge ni alcool.',
            philosophyText6: 'Pendant les repas, un médecin ayurvédique ou un diététicien qualifié est toujours disponible pour vous guider. Ils vous conseilleront les légumes, herbes et épices les plus adaptés à votre phase de traitement actuelle et vous aideront à choisir ou éviter certains plats. Votre élixir d’herbes personnalisé et toutes instructions spécifiques de l’équipe du centre de santé seront placés à votre table individuelle.',
            philosophyText7: 'Ce niveau de soin personnalisé et d’attention à l’alimentation est une marque distinctive de l’expérience au Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'La nourriture est considérée comme Prana – l’énergie vitale qui soutient la vie de tout être humain. C’est pourquoi nous vous invitons à aborder chaque repas avec pleine conscience : savourer les arômes, ressentir les saveurs, percevoir la douce chaleur et profiter des sensations gustatives en pleine présence.',
            diningExperienceEyebrow: 'Expérience culinaire',
            restaurantTitlePrefix: 'Notre',
            ayurvedicHighlight: 'Restaurant',
            restaurantTitleSuffix: 'Ayurvédique',
            restaurantDetail1: 'Notre restaurant ayurvédique au Muthumuni Beach Resort offre une expérience culinaire unique qui harmonise les principes traditionnels de l’Ayurveda avec la cuisine côtière authentique du Sri Lanka. Nous privilégions des ingrédients frais et locaux pour créer des plats qui ravissent le palais tout en favorisant le bien-être holistique.',
            restaurantDetail2: 'Le menu est soigneusement conçu pour équilibrer les six saveurs (sucré, acide, salé, amer, piquant, astringent) dans chaque plat, garantissant une expérience nourrissante et satisfaisante. Chaque mets est préparé avec soin, intégrant des herbes et épices ayurvédiques reconnues pour leurs vertus curatives.',
            restaurantDetail3: 'Les hôtes peuvent savourer une grande variété de plats adaptés à leurs doshas individuels (constitutions corporelles), avec des options végétariennes, véganes et pescétariennes. Nos chefs travaillent en étroite collaboration avec les praticiens ayurvédiques pour que chaque repas soutienne les objectifs de santé et de bien-être des hôtes.',
            restaurantDetail4: 'L’ambiance du restaurant reflète l’environnement côtier serein, offrant un cadre paisible pour une alimentation consciente. Que ce soit pour un copieux buffet petit-déjeuner ou un dîner gastronomique, chaque repas dans notre restaurant ayurvédique est une occasion de nourrir le corps et l’âme.',
            restaurantDetail5: 'Rejoignez-nous au restaurant ayurvédique du Muthumuni Beach Resort pour un voyage culinaire qui célèbre les riches saveurs du Sri Lanka tout en embrassant la sagesse intemporelle de l’Ayurveda.',
            restaurantImageAlt: 'Dîner au Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Dîner Premium',
            premiumDiningDescription: 'Vivez une cuisine ayurvédique authentique dans un cadre paisible au bord de la rivière'
        },
        events2: {
            heroEyebrow: 'Expériences & Activités',
            heroTitle: 'Nos Événements',
            heroSubtitle: 'Expériences soigneusement sélectionnées mêlant tradition sri-lankaise et luxe côtier',
            heroAlt: 'Événements à Muthumuni',
            availableDaily: 'Disponible tous les jours',
            bookNow: 'Réserver maintenant',
            highlightsTitle: 'Points forts',
            detailAlt: 'Détail {{title}}',
            ctaTitle: 'Prêt à créer des souvenirs ?',
            ctaDescription: 'Contactez notre équipe pour personnaliser votre expérience événementielle idéale au Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Nous contacter',
            ctaViewRooms: 'Voir les chambres',
            cookeryTitle: 'Ateliers de cuisine',
            cookerySubtitle: 'Saveurs du Sri Lanka',
            cookeryDescription: 'Plongez dans les saveurs vibrantes de la cuisine sri-lankaise. Nos chefs experts vous guident à travers des ateliers pratiques où vous apprendrez des recettes traditionnelles transmises de génération en génération. Préparez des currys parfumés, des hoppers, du sambol à la noix de coco et bien plus encore avec des ingrédients locaux frais.',
            cookeryHighlight1: 'Recettes traditionnelles sri-lankaises',
            cookeryHighlight2: 'Expérience culinaire pratique',
            cookeryHighlight3: 'Ingrédients locaux frais',
            cookeryHighlight4: 'Recettes à emporter chez soi',
            cookeryHighlight5: 'Visite du jardin d’épices incluse',
            meditationTitle: 'Programmes de méditation',
            meditationSubtitle: 'Paix intérieure & Pleine conscience',
            meditationDescription: 'Trouvez la sérénité lors de nos séances de méditation guidée face à l’océan Indien paisible. Nos instructeurs expérimentés vous initient aux anciennes techniques de pleine conscience, exercices de respiration et pratiques de yoga conçues pour apaiser l’esprit et revitaliser l’âme.',
            meditationHighlight1: 'Séances au lever et au coucher du soleil',
            meditationHighlight2: 'Méditation face à la plage',
            meditationHighlight3: 'Guidées par des experts',
            meditationHighlight4: 'Techniques de respiration',
            meditationHighlight5: 'Pratiques de yoga et de pleine conscience',
            bbqTitle: 'Soirées barbecue',
            bbqSubtitle: 'Fêtes sur la plage',
            bbqDescription: 'Vivez des soirées inoubliables lors de nos barbecues sur la plage. Savourez des fruits de mer fraîchement grillés, des viandes de qualité et des plats végétariens pendant que les vagues murmurent à proximité. Musique live, danseurs de feu et ciel étoilé créent l’ambiance parfaite pour célébrer et partager.',
            bbqHighlight1: 'Fruits de mer frais grillés',
            bbqHighlight2: 'Dîner face à l’océan',
            bbqHighlight3: 'Animations en direct',
            bbqHighlight4: 'Expérience de feu de camp',
            bbqHighlight5: 'Menus personnalisables',
            boatTitle: 'Balades en bateau',
            boatSubtitle: 'Aventures fluviales et côtières',
            boatDescription: 'Partez pour des croisières enchantées le long de la rivière Bentota et des eaux côtières. Glissez à travers les forêts de mangroves, observez des oiseaux exotiques et la faune, ou profitez de croisières romantiques au coucher du soleil. Nos balades en bateau offrent une perspective unique sur la beauté naturelle et la diversité des écosystèmes du Sri Lanka.',
            boatHighlight1: 'Croisières sur la rivière Bentota',
            boatHighlight2: 'Exploration des mangroves',
            boatHighlight3: 'Observation de la faune',
            boatHighlight4: 'Tours en bateau au coucher du soleil',
            boatHighlight5: 'Location privée disponible',
            ayurvedaLecturesTitle: 'Conférences des médecins ayurvédiques',
            ayurvedaLecturesSubtitle: 'Sagesse ancienne & Bien-être moderne',
            ayurvedaLecturesDescription: 'Découvrez les principes profonds de l’Ayurveda à travers des conférences animées par des médecins et praticiens ayurvédiques certifiés. Apprenez l’équilibrage des doshas, les remèdes à base de plantes, les approches holistiques de guérison et comment cette sagesse millénaire s’applique au bien-être contemporain. Nos sessions interactives rendent la philosophie ayurvédique claire et applicable au quotidien.',
            ayurvedaLecturesHighlight1: 'Médecins ayurvédiques certifiés',
            ayurvedaLecturesHighlight2: 'Analyse personnalisée des doshas',
            ayurvedaLecturesHighlight3: 'Formation sur les remèdes à base de plantes',
            ayurvedaLecturesHighlight4: 'Sessions de questions-réponses incluses',
            ayurvedaLecturesHighlight5: 'Guide bien-être à emporter',
            traditionalClothsTitle: 'Événements de port de vêtements traditionnels',
            traditionalClothsSubtitle: 'Expérience du patrimoine culturel',
            traditionalClothsDescription: 'Immergez-vous dans le patrimoine culturel sri-lankais en apprenant à porter et apprécier les tenues traditionnelles. Nos stylistes experts vous guident dans le port d’authentiques saris Kandyan et vêtements traditionnels, expliquant la signification culturelle de chaque pièce. Idéal pour les occasions spéciales, l’appréciation culturelle ou pour réaliser de belles photos souvenirs.',
            traditionalClothsHighlight1: 'Conseils professionnels de stylisme',
            traditionalClothsHighlight2: 'Saris traditionnels authentiques',
            traditionalClothsHighlight3: 'Explication de la signification culturelle',
            traditionalClothsHighlight4: 'Photographie professionnelle incluse',
            traditionalClothsHighlight5: 'Ateliers de fusion mode'
        },
        blogs2: {
            heroTitle: 'Blogs du Muthumuni Ayurveda River Resort',
            heroSubtitle1: 'Histoires au bord de la rivière, rituels ayurvédiques au',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Plongez dans les conseils, l’histoire et les coulisses.',
            heroAlt: 'Promenade au bord de la rivière du resort au coucher du soleil',
            sectionTitle: 'Blogs du Muthumuni Ayurveda River Resort',
            sectionDescription: 'Guides, récits et notes de notre retraite au bord de la rivière — des rituels ayurvédiques aux pratiques de bien-être en passant par les conseils de voyage autour de Bentota.',
            ayurvedaTitle: 'Le cœur de l’Ayurveda authentique',
            ayurvedaExcerpt: 'Découvrez des traditions de guérison ancestrales ancrées dans la sagesse millénaire du Sri Lanka.',
            ayurvedaDescription: 'Au Muthumuni Ayurveda River Resort, l’Ayurveda est bien plus qu’un traitement : c’est un mode de vie. Nos thérapies s’appuient sur des savoirs vieux de plusieurs siècles, sont personnalisées selon votre constitution et guidées par des médecins ayurvédiques expérimentés pour un équilibre profond et durable.',
            ayurvedaAlt: 'Installation de traitement ayurvédique avec huiles aux herbes et éléments naturels',
            healingTitle: 'Parcours de guérison personnalisés',
            healingExcerpt: 'Pourquoi le programme bien-être de chaque invité est unique.',
            healingDescription: 'De la consultation initiale aux soins quotidiens, votre parcours de guérison est soigneusement adapté. Thérapies aux plantes, massages thérapeutiques, yoga et méditation travaillent en synergie pour rétablir l’harmonie entre corps, esprit et âme.',
            healingAlt: 'Médecin ayurvédique consultant un invité dans un cadre calme',
            natureTitle: 'Guérison au bord de la rivière',
            natureExcerpt: 'Comment le cadre fluvial paisible et l’environnement tropical renforcent votre bien-être.',
            natureDescription: 'Niché le long d’une rivière tranquille au Sri Lanka, Muthumuni offre un environnement naturellement curatif. Le doux écoulement de la rivière, l’air frais et la verdure luxuriante amplifient les effets de l’Ayurveda, procurant une profonde relaxation et un renouveau.',
            natureAlt: 'Vue sur la rivière du resort avec palmiers et nature',
            foodTitle: 'Cuisine ayurvédique pour l’équilibre intérieur',
            foodExcerpt: 'Repas nourrissants conçus pour soutenir votre traitement.',
            foodDescription: 'Notre cuisine ayurvédique est préparée quotidiennement avec des ingrédients de saison locaux. Chaque plat est adapté à votre dosha, favorisant digestion, détoxification et vitalité tout en restant savoureux et satisfaisant.',
            foodAlt: 'Repas ayurvédique traditionnel servi dans des bols naturels',
            yogaTitle: 'Yoga, méditation et paix intérieure',
            yogaExcerpt: 'Pratiques douces qui apaisent l’esprit et renforcent le corps.',
            yogaDescription: 'Les séances quotidiennes de yoga et de méditation complètent vos soins, améliorant souplesse, respiration et clarté mentale. Ces pratiques conscientes vous aident à vous reconnecter à vous-même et à emporter un sentiment de paix au-delà de votre séjour.',
            yogaAlt: 'Invités pratiquant le yoga face à la rivière au lever du soleil',
            lifestyleTitle: 'Ramener l’Ayurveda chez soi',
            lifestyleExcerpt: 'Habitudes de vie simples pour prolonger votre cheminement bien-être.',
            lifestyleDescription: 'Avant votre départ, nos experts vous guident pour maintenir l’équilibre grâce à des routines quotidiennes, une alimentation et des rituels de soin personnel. Emportez plus que des souvenirs : emportez un chemin durable vers une vie plus saine.',
            lifestyleAlt: 'Invité se relaxant avec une tisane aux herbes dans un cadre paisible du resort',
            readMore: 'Lire la suite'
        },
        tours2: {
            heroTitle: 'Tours & Excursions',
            heroSubtitle: 'Découvrez la beauté du Sri Lanka depuis Beruwala',
            kandeAlt: 'Temple Kande Vihara - Beruwala',
            kandeTitle: 'Visite du Temple Kande Vihara',
            kandeBuddhaAlt: 'Statue géante de Bouddha au Temple Kande Vihara',
            bentotaTitle: 'Safari en bateau sur la rivière Bentota',
            bentotaAlt: 'Safari en bateau sur la rivière Bentota - Mangroves et faune',
            galleTitle: 'Visite de la vieille ville de Galle',
            galleAlt: 'Visite de la vieille ville de Galle',
            sigiriyaTitle: 'Visite de la forteresse rocheuse de Sigiriya',
            sigiriyaAlt: 'Visite de la forteresse rocheuse de Sigiriya',
            kandyTitle: 'Visite culturelle à Kandy',
            kandyAlt: 'Visite culturelle à Kandy',
            bookTour: 'Réserver cette excursion',
            introPara1: 'Le Sri Lanka est une terre de beauté intemporelle, où plages dorées, paysages verdoyants luxuriants, temples anciens et culture vibrante s’harmonisent parfaitement.',
            introPara2: 'De la côte sud-ouest paisible aux villes historiques, sites sacrés, réserves animalières et collines brumeuses, chaque voyage offre une expérience unique et inoubliable.',
            introPara3: 'Au départ du Muthumuni Ayurveda Beach Resort à Beruwala, nos circuits et excursions soigneusement sélectionnés sont conçus pour enrichir votre séjour en équilibrant parfaitement découverte, détente et bien-être.',
            kandeDetail1: 'Temple Kande Vihara (Kande Viharaya) – l’un des temples bouddhistes les plus emblématiques près de Beruwala.',
            kandeDetail2: 'Fondé en 1734, ce paisible « Temple de la Montagne » est perché sur une colline offrant des vues sereines sur la côte.',
            kandeDetail3: 'Points forts : l’immense statue assise de Bouddha de 48 mètres (160 ft), l’une des plus hautes du Sri Lanka, fresques détaillées de l’époque Kandyan, ancienne chambre des reliques, bel escalier en pierre de lune et arbre Bodhi sacré vieux de plus de 300 ans.',
            kandeDetail4: 'Une expérience spirituelle et culturelle idéale en demi-journée – préférable le matin pour éviter la chaleur.',
            bentotaDetail1: 'Profitez d’un safari en bateau paisible et pittoresque sur la rivière Bentota, l’une des excursions nature les plus populaires près de Beruwala.',
            bentotaDetail2: 'Glissez à travers des mangroves luxuriantes, des canaux étroits et des eaux calmes tout en observant la faune locale.',
            bentotaDetail3: 'Observations fréquentes : varans, crocodiles, diverses espèces d’oiseaux (martins-pêcheurs, hérons, aigles), singes, et parfois loutres ou serpents d’eau.',
            bentotaDetail4: 'Votre batelier/guide expérimenté vous montrera la flore intéressante, les méthodes de pêche traditionnelles et la vie des villages riverains.',
            bentotaDetail5: 'Parfait pour les amoureux de la nature et les photographes – calme, relaxant et complémentaire à votre séjour bien-être ayurvédique.',
            galleDetail1: 'Explorez le fort historique de Galle, site du patrimoine mondial de l’UNESCO et l’une des forteresses coloniales les mieux préservées du Sri Lanka.',
            galleDetail2: 'Flânez dans les rues pavées bordées de bâtiments coloniaux hollandais, boutiques, cafés et galeries d’art.',
            galleDetail3: 'Visitez les principaux monuments : le phare de Galle, l’église réformée hollandaise, le Musée maritime national et les remparts avec vue imprenable sur l’océan.',
            galleDetail4: 'Découvrez l’histoire riche, l’architecture et l’importance culturelle du fort grâce à votre guide compétent.',
            galleDetail5: 'Idéal pour les passionnés d’histoire, les amateurs de culture et ceux qui souhaitent découvrir le passé colonial du Sri Lanka.',
            sigiriyaDetail1: 'Découvrez l’ancienne forteresse rocheuse de Sigiriya, l’un des sites les plus emblématiques du Sri Lanka et patrimoine mondial de l’UNESCO.',
            sigiriyaDetail2: 'Montez sur le rocher impressionnant pour explorer les ruines du palais du roi Kasyapa, ornées de fresques, jardins d’eau et du célèbre Mur Miroir.',
            sigiriyaDetail3: 'Profitez de vues panoramiques sur la jungle environnante et la campagne depuis le sommet.',
            sigiriyaDetail4: 'Apprenez l’histoire fascinante, l’architecture et les légendes de Sigiriya auprès de votre guide expert.',
            sigiriyaDetail5: 'Parfait pour les passionnés d’histoire, les amateurs d’aventure et ceux intéressés par le riche patrimoine culturel du Sri Lanka.',
            kandyDetail1: 'Vivez la culture vibrante de Kandy, dernière capitale royale du Sri Lanka et site du patrimoine mondial de l’UNESCO.',
            kandyDetail2: 'Visitez le Temple de la Dent Sacrée (Sri Dalada Maligawa), l’un des lieux bouddhistes les plus importants au monde.',
            kandyDetail3: 'Explorez les Jardins botaniques royaux de Peradeniya, abritant une vaste collection de plantes tropicales et d’orchidées.',
            kandyDetail4: 'Assistez à un spectacle de danse traditionnelle Kandyan mettant en valeur le riche héritage artistique du Sri Lanka.',
            kandyDetail5: 'Idéal pour les amateurs de culture, les passionnés d’histoire et ceux qui souhaitent s’immerger dans les traditions sri-lankaises.'
        },
        rooms: {
            heroTitle: 'Votre sanctuaire vous attend',
            heroSubtitle: 'Des chambres méticuleusement conçues pour la guérison, la restauration et la paix profonde.',
            heroAlt: 'Chambres du Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Explorez nos chambres',
            filterAll: 'Tout',
            filterLuxurySuite: 'Suite Luxe',
            filterDeluxeRooms: 'Chambres Deluxe',
            filterDeluxeSeaView: 'Chambre Deluxe avec vue sur la mer',
            noRoomsFound: 'Aucune chambre trouvée dans cette catégorie.',
            allRoomsInclude: 'Toutes les chambres incluent',
            essentialComforts: 'Conforts essentiels pour votre voyage bien-être',
            roomSize: 'Taille de la chambre',
            guests: 'Invités',
            amenities: 'Équipements',
            roomAmenities: 'Équipements de la chambre',
            specialFeatures: 'Caractéristiques spéciales',
            bookNow: 'Réserver maintenant',
            viewDetails: 'Afficher les détails',
            highSpeedWifi: 'WiFi haut débit',
            herbalTea: 'Sélection de thés à base de plantes',
            climateControl: 'Contrôle climatique',
            rainShower: 'Douche à effet pluie',
            organicToiletries: 'Articles de toilette biologiques',
            dailyHousekeeping: 'Nettoyage quotidien de la chambre',
            concierge: 'Concierge 24/7',
            yogaMat: 'Tapis de yoga et accessoires',
            beginHealing: 'Commencez votre voyage de guérison',
            beginHealingDesc: 'Découvrez le bien-être ayurvédique authentique dans un environnement conçu pour nourrir votre corps, calmer votre esprit et restaurer votre âme.',
            reserveRoom: 'Réserver une chambre',
            speakAdvisor: 'Parler à un conseiller en bien-être',
            exploreOurRooms: 'Explorez nos chambres',
            viewRoom: 'Afficher la chambre',
            luxurySuiteName: 'Suite Luxe',
            luxurySuiteCategory: 'Suite Luxe',
            luxurySuiteDesc: 'Découvrez la tranquillité ultime dans notre suite luxe spacieuse, conçue selon les principes ayurvédiques traditionnels avec une vue spectaculaire sur la mer.',
            deluxeRoomName: 'Chambre Deluxe',
            deluxeRoomCategory: 'Chambre Deluxe',
            deluxeRoomDesc: 'Chambre harmonieusement conçue avec des éléments en bois naturel et des caractéristiques d\'eau apaisantes pour une tranquillité parfaite.',
            seaViewDeluxeName: 'Deluxe avec vue sur la mer',
            seaViewDeluxeCategory: 'Chambre Deluxe avec vue sur la mer',
            seaViewDeluxeDesc: 'Réveillez-vous avec une brise marine apaisante et des vues panoramiques sur la mer dans cette chambre deluxe élégamment conçue.',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'Chambre Deluxe — Confort avec terrasse ou balcon privé',
                heroSubtitle: 'Détendez-vous dans une retraite côtière apaisante inspirée des plages dorées de Bentota, alliant équipements modernes et douces brises marines.',
                bookThisRoom: 'Réserver cette chambre',
                callReservations: 'Appeler les réservations',
                navAll: 'Tout',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe avec vue sur la mer',
                navSuite: 'Suite',
                sectionTitle: 'Un refuge côtier apaisant',
                sectionDesc: 'La Chambre Deluxe est conçue pour les matins lents et les couchers de soleil sans hâte. Des tons neutres doux, un vitrage généreux et un éclairage réfléchi invitent la vue sur la mer, tandis que le balcon offre votre propre perchoir au-dessus du rivage.',
                highlight1Title: 'Vues panoramiques sur la plage',
                highlight1Desc: 'Réveillez-vous avec des eaux azur et des levers de soleil dorés depuis votre balcon privé.',
                highlight2Title: 'Intérieurs côtiers élégants',
                highlight2Desc: 'Palettes neutres douces, accents de bois chaleureux et lumière naturelle généreuse.',
                highlight3Title: 'Expérience de sommeil sereine',
                highlight3Desc: 'Lit king-size moelleux avec linge de lit haut de gamme sélectionné pour un repos réparateur.',
                atAGlance: 'En un coup d\'\u0153il',
                statSize: 'Taille',
                statSizeValue: '41 m²',
                statView: 'Vue',
                statViewValue: 'Océan Indien',
                statGuests: 'Invités',
                statGuestsValue: '2 Adultes',
                statBed: 'Lit',
                statBedValue: 'King ou Twin',
                reserve: 'Réserver',
                galleryAlt: 'Galerie chambre Deluxe',
                inclusionsTitle: 'Inclus dans votre séjour',
                inclusionsSubtitle: 'Touches attentionnées, confort toute la journée',
                enhancedCleanliness: 'Normes de propreté et de sécurité améliorées',
                inclusion1: 'Petit-déjeuner, déjeuner, dîner gratuits au restaurant Breeze',
                inclusion2: 'Wi-Fi haut débit et espace de travail dans la chambre',
                inclusion3: 'Service en chambre et concierge 24 heures',
                inclusion4: 'Ménage quotidien avec ouverture du lit le soir',
                inclusion5: 'Accès à la piscine à débordement et aux installations de spa ayurvédique',
                inclusion6: 'Parking gratuit et service de navette vers les attractions à proximité',
                amenityGroup1Title: 'Caractéristiques de la chambre',
                amenityGroup1Item1: '41 m² d\'espace',
                amenityGroup1Item2: 'Balcon privé avec sièges',
                amenityGroup1Item3: 'Climatisation avec contrôle climatique',
                amenityGroup1Item4: 'Coffre-fort dans la chambre',
                amenityGroup2Title: 'Expérience bain',
                amenityGroup2Item1: 'Douche à effet pluie avec eau chaude et froide',
                amenityGroup2Item2: 'Articles de bain haut de gamme',
                amenityGroup2Item3: 'Sèche-cheveux',
                amenityGroup2Item4: 'Peignoirs et pantoufles doux',
                amenityGroup3Title: 'Conforts dans la chambre',
                amenityGroup3Item1: 'Smart TV 55" avec câble',
                amenityGroup3Item2: 'Station café et thé',
                amenityGroup3Item3: 'Téléphone à sélection directe',
                amenityGroup4Title: 'Connectivité',
                amenityGroup4Item1: 'Wi-Fi gratuit',
                amenityGroup4Item2: 'Bureau',
                amenityGroup4Item3: 'Support réception 24/7',
                essentialsTitle: 'Éléments essentiels en chambre',
                essentialsHeading: 'Tout ce dont vous avez besoin pour vous sentir chez vous',
                essentialsDesc: 'D\'une connectivité transparente à des rafraîchissements soigneusement choisis, la Chambre Deluxe allie loisirs et praticité afin que vous puissiez vous concentrer sur les moments qui comptent.',
                essential1: 'Wi-Fi gratuit',
                essential2: 'Station café et thé',
                essential3: 'Service en chambre 24/7',
                essential4: 'Douche à effet pluie',
                oceanTitle: 'Près de l\'océan',
                oceanSubtitle: 'Ralentissez, respirez l\'air marin',
                oceanAlt: 'Coin salon chambre Deluxe',
                ctaTitle: 'Prêt à séjourner?',
                ctaHeading: 'Réservez la Chambre Deluxe aujourd\'hui',
                ctaDesc: 'Parlez avec notre équipe de réservations pour les meilleurs tarifs disponibles et offres spéciales.',
                checkAvailability: 'Vérifier la disponibilité'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Confort avec un charme côtier serein',
                bookThisRoom: 'Réserver cette chambre',
                callReservations: 'Appeler les réservations',
                navAll: 'Tous',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe avec Vue Mer',
                navSuite: 'Suite',
                sectionTitle: 'Une retraite côtière apaisante',
                sectionDesc: 'La Suite Luxe est conçue pour les matinées tranquilles et les couchers de soleil sans hâte. Les tons neutres doux, la verrerie généreuse et l\'éclairage réfléchi invitent la vue sur la mer, tandis que le balcon offre votre propre place au-dessus de la côte.',
                highlight1Title: 'Vues Panoramiques sur la Plage',
                highlight1Desc: 'Réveillez-vous avec des eaux azurées et des levers de soleil dorés depuis votre balcon privé.',
                highlight2Title: 'Intérieurs Côtiers Elegants',
                highlight2Desc: 'Palettes neutres douces, accents en bois chaud et lumière naturelle généreuse.',
                highlight3Title: 'Expérience de Sommeil Sereine',
                highlight3Desc: 'Lit King Size moelleux avec du linge de luxe sélectionné pour un repos régénérateur.',
                atAGlance: 'En un coup d\'oeil',
                statSize: 'Taille',
                statSizeValue: '41 m²',
                statView: 'Vue',
                statViewValue: 'Océan Indien',
                statGuests: 'Clients',
                statGuestsValue: '2 Adultes',
                statBed: 'Lit',
                statBedValue: 'King ou Twin',
                reserve: 'Réserver',
                galleryAlt: 'Chambre Suite',
                inclusionsTitle: 'Inclus dans votre séjour',
                inclusionsSubtitle: 'Touches attentionnées, confort toute la journée',
                enhancedCleanliness: 'Normes de nettoyage et de sécurité renforcées',
                inclusion1: 'Petit-déjeuner, déjeuner, dîner gratuits au restaurant Breeze',
                inclusion2: 'Wi-Fi haut débit et espace de travail dans la chambre',
                inclusion3: 'Service en chambre 24 heures et concierge',
                inclusion4: 'Nettoyage quotidien de la chambre avec virée en soirée',
                inclusion5: 'Accès à la piscine à débordement et aux installations spa Ayurveda',
                inclusion6: 'Stationnement gratuit et service de navette vers les attractions à proximité',
                amenityGroup1Title: 'Caractéristiques de la Chambre',
                amenityGroup1Item1: '41 m² d\'espace',
                amenityGroup1Item2: 'Balcon privé avec zone de détente',
                amenityGroup1Item3: 'Climatisation avec contrôle climétique',
                amenityGroup1Item4: 'Coffre-fort dans la chambre',
                amenityGroup2Title: 'Expérience Salle de Bain',
                amenityGroup2Item1: 'Douche à effet pluie avec eau chaude et froide',
                amenityGroup2Item2: 'Articles de toilette de luxe',
                amenityGroup2Item3: 'Sèche-cheveux',
                amenityGroup2Item4: 'Peignoirs et pantoufles doux',
                amenityGroup3Title: 'Confort en Chambre',
                amenityGroup3Item1: 'Téléviseur intelligent 55" avec câble',
                amenityGroup3Item2: 'Station café et thé',
                amenityGroup3Item3: 'Téléphone avec sélection directe',
                amenityGroup4Title: 'Connectivité',
                amenityGroup4Item1: 'Wi-Fi gratuit',
                amenityGroup4Item2: 'Bureau de travail',
                amenityGroup4Item3: 'Support réception 24/7',
                essentialsTitle: 'Essentiels en Chambre',
                essentialsHeading: 'Tout ce dont vous avez besoin pour vous sentir chez vous',
                essentialsDesc: 'De la connectivité transparente aux rafraîchissements soigneusement sélectionnés, la Suite Luxe fusion le loisir et la praticité afin que vous puissiez vous concentrer sur les moments qui comptent.',
                essential1: 'Wi-Fi gratuit',
                essential2: 'Station café et thé',
                essential3: 'Service en chambre 24/7',
                essential4: 'Douche à effet pluie',
                oceanTitle: 'Près de l\'océan',
                oceanSubtitle: 'Ralentissez, respirez l\'air marin',
                oceanAlt: 'Vue sur l\'océan',
                ctaTitle: 'Prêt à séjourner?',
                ctaHeading: 'Réservez la Suite Luxe aujourd\'hui',
                ctaDesc: 'Parlez avec notre équipe de réservations pour les meilleurs tarifs disponibles et offres spéciales.',
                checkAvailability: 'Vérifier la disponibilité'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Resorts',
                heroTitle: 'Chambre Deluxe avec vue sur mer',
                heroSubtitle: 'Immergez-vous dans le luxe avec des vues à couper le souffle sur l\'horizon marin',
                bookThisRoom: 'Réservez cette chambre',
                callReservations: 'Appelez la réservation',
                navAll: 'Toutes les chambres',
                navDeluxe: 'Chambre Deluxe',
                navDeluxeSeaView: 'Chambre Deluxe avec vue sur mer',
                navSuite: 'Suite Luxe',
                sectionTitle: 'Découvrez le luxe',
                sectionDesc: 'Nos chambres Deluxe avec vue sur mer offrent un mélange impeccable de confort et d\'élégance. Chaque chambre a été soigneusement conçue pour offrir une expérience de séjour sans égal.',
                highlight1Title: 'Vue sur la plage privée',
                highlight1Desc: 'Accès direct à notre plage privée aux sables blancs',
                highlight2Title: 'Chambre spacieuse',
                highlight2Desc: '75 mètres carrés d\'espace de vie merveilleux',
                highlight3Title: 'Baignoire en plein air',
                highlight3Desc: 'Profitez du luxe privé sous les étoiles',
                atAGlance: 'En un coup d\'oeil',
                stat1Label: 'Taille',
                stat1Value: '75 m²',
                stat2Label: 'Vue',
                stat2Value: 'Vue sur la mer',
                stat3Label: 'Invités',
                stat3Value: '2 adultes',
                stat4Label: 'Lit',
                stat4Value: 'Roi',
                reserve: 'Réserver',
                galleryAlt: 'Chambre Deluxe luxueuse avec vue sur la mer',
                inclusionsTitle: 'Qu\'est-ce qui est inclus',
                inclusionsSubtitle: 'Chaque chambre comprend',
                inclusion1: 'Petit-déjeuner avec vue sur la mer',
                inclusion2: 'Boisson de bienvenue au coucher du soleil',
                inclusion3: 'Service de bar expresso quotidien',
                inclusion4: 'Accès illimité au spa',
                inclusion5: 'Transfert privé à la plage',
                inclusion6: 'Wi-Fi premium',
                enhancedCleanliness: 'Nettoyage avancé et protocoles de sécurité',
                amenityGroup1Title: 'Chambre',
                amenityGroup1Item1: 'Assombrissement automatique',
                amenityGroup1Item2: 'Coton 100% premium',
                amenityGroup1Item3: 'Oreillers de différentes fermetés',
                amenityGroup2Title: 'Salle de bain',
                amenityGroup2Item1: 'Produits cosmétiques Bvlgari',
                amenityGroup2Item2: 'Planchers chauffants',
                amenityGroup2Item3: 'Système SPA intégré',
                amenityGroup3Title: 'Salon',
                amenityGroup3Item1: 'Télévision satellitaire premium',
                amenityGroup3Item2: 'Cuisine entièrement équipée',
                amenityGroup3Item3: 'Cinéma maison',
                amenityGroup4Title: 'En plein air',
                amenityGroup4Item1: 'Terrasse privée avec bain à remous',
                amenityGroup4Item2: 'Lit suspendu de style balinais',
                amenityGroup4Item3: 'Système d\'irrigation automatique',
                essentialsTitle: 'Essentiels',
                essentialsHeading: 'Vos besoins essentiels en chambre',
                essentialsDesc: 'Tout le nécessaire dans la chambre',
                essential1: 'Mini-bar avec boissons premium',
                essential2: 'Station café et thé',
                essential3: 'Service en chambre 24/7',
                essential4: 'Douche à effet pluie',
                oceanTitle: 'Près de l\'océan',
                oceanSubtitle: 'Ralentissez, respirez l\'air marin',
                oceanAlt: 'Vue sur l\'océan',
                ctaTitle: 'Prêt à séjourner?',
                ctaHeading: 'Réservez la chambre Deluxe avec vue sur mer aujourd\'hui',
                ctaDesc: 'Parlez avec notre équipe de réservations pour les meilleurs tarifs disponibles et offres spéciales.',
                checkAvailability: 'Vérifier la disponibilité'
            }
        },

        navbar: {
            home: 'Accueil',
            aboutUs: 'À propos',
            rooms: 'Chambres',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Restauration',
            events: 'Événements',
            blogs: 'Blog',
            tours: 'Circuits',
            contactUs: 'Contact',
            bookOnline: 'Réserver en ligne',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Sélectionner le resort',
            language: 'Langue',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Accueil',
            aboutUs: 'À propos',
            rooms: 'Chambres',
            ayurveda: 'Ayurveda',
            yoga: 'Yoga',
            food: 'Restauration',
            events: 'Événements',
            blogs: 'Blog',
            tours: 'Circuits',
            contactUs: 'Contact',
            bookOnline: 'Réserver en ligne',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Sélectionner le resort',
            language: 'Langue',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort s’engage à offrir une hospitalité et des expériences bien‑être d’exception, afin que chaque client se sente apprécié et régénéré.',
            linksTitle: 'Liens',
            contactTitle: 'Contact',
            viewLocation: 'Voir l’emplacement',
            navHome: 'Accueil',
            navAbout: 'À propos',
            navContact: 'Contact',
            navRooms: 'Chambres',
            navAyurveda: 'Ayurveda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Développé par',
            developerName: 'Redev Solution +94 764 608 225'
        }, tours: {
            heroTitle: 'Circuits et excursions',
            heroSubtitle: 'Découvrez la beauté du Sri Lanka depuis Beruwala',
            kandeAlt: 'Temple Kande Vihara - Beruwala',
            kandeTitle: 'Visite du Temple Kande Vihara',
            kandeBuddhaAlt: 'Gigantesque statue de Bouddha au temple Kande Vihara',
            bentotaTitle: 'Safari en bateau sur le fleuve Bentota',
            bentotaAlt: 'Safari en bateau sur le fleuve Bentota - Mangroves et Faune',
            galleTitle: 'Visite de la Vieille Ville de Galle',
            galleAlt: 'Visite de la Vieille Ville de Galle',
            sigiriyaTitle: 'Visite de la Forteresse Rocheuse de Sigiriya',
            sigiriyaAlt: 'Visite de la Forteresse Rocheuse de Sigiriya',
            kandyTitle: 'Circuit Culturel de Kandy',
            kandyAlt: 'Circuit Culturel de Kandy',
            bookTour: 'Réserver ce circuit',
            introPara1: 'Le Sri Lanka est une terre d\'une beauté intemporelle, où les plages dorées, les paysages verdoyants, les temples anciens et la culture vibrante se rencontrent en parfaite harmonie.',
            introPara2: 'De la côte sud‑ouest tranquille aux villes historiques, aux sites sacrés, aux réserves fauniques et à la région des collines brumeuses, chaque voyage offre une expérience unique et inoubliable.',
            introPara3: 'À partir de Muthumuni Ayurveda Beach Resort à Beruwala, nos circuits et excursions soigneusement sélectionnés sont conçus pour enrichir votre séjour tout en équilibrant parfaitement l\'exploration, la détente et le bien‑être.',
            kandeDetail1: 'Temple Kande Vihara (Kande Viharaya) – l\'un des temples bouddhistes les plus emblématiques près de Beruwala.',
            kandeDetail2: 'Fondé en 1734, ce serein \'Temple de la Montagne\' est situé au sommet d\'une colline offrant des vues paisibles sur la côte.',
            kandeDetail3: 'Parmi les points forts figurent la massive statue de Bouddha assis de 48 mètres (l\'une des plus hautes du Sri Lanka), les fresques complexes de l\'époque Kandyan, une ancienne chambre de relique, une belle entrée en pierre de lune et un ancien arbre Bodhi sacré datant de plus de 300 ans.',
            kandeDetail4: 'Une parfaite expérience spirituelle et culturelle d\'une demi‑journée – idéale pour les visites matinales afin d\'éviter la chaleur.',
            bentotaDetail1: 'Profitez d\'un safari en bateau paisible et pittoresque sur le fleuve Bentota, l\'une des excursions naturelles les plus populaires près de Beruwala.',
            bentotaDetail2: 'Glissez à travers les luxuriantes mangroves, les canaux étroits et les eaux sereines tout en observant la faune locale.',
            bentotaDetail3: 'Les observations communes incluent les iguanes, les crocodiles, diverses espèces d\'oiseaux (martins‑pêcheurs, hérons, aigles), les singes, et occasionnellement les loutres ou les serpents d\'eau.',
            bentotaDetail4: 'Votre batelier/guide expérimenté vous montrera une flore intéressante, les méthodes de pêche traditionnelles et la vie dans les villages fluviaux.',
            bentotaDetail5: 'Parfait pour les amoureux de la nature et les photographes – calme, relaxant et complémentaire à votre séjour de bien‑être ayurvédique.',
            galleDetail1: 'Explorez le Fort historique de Galle, un Site du Patrimoine Mondial de l\'UNESCO et l\'un des forts coloniaux les mieux préservés du Sri Lanka.',
            galleDetail2: 'Errez dans les ruelles pavées bordées de bâtiments coloniaux néerlandais, boutiques, cafés et galeries d\'art.',
            galleDetail3: 'Visitez les monuments clés tels que le Phare de Galle, l\'Église Réformée Néerlandaise, le Musée Maritime National et les remparts offrant de superbes vues sur l\'océan.',
            galleDetail4: 'Découvrez la riche histoire, l\'architecture et l\'importance culturelle du fort grâce à votre guide compétent.',
            galleDetail5: 'Idéal pour les passionnés d\'histoire, les amateurs de culture et ceux qui souhaitent découvrir le passé colonial du Sri Lanka.',
            sigiriyaDetail1: 'Découvrez la forteresse rocheuse antique de Sigiriya, l\'un des monuments les plus emblématiques du Sri Lanka et un Site du Patrimoine Mondial de l\'UNESCO.',
            sigiriyaDetail2: 'Grimpez sur le rocher impressionnant pour explorer les ruines du palais du roi Kasyapa, orné de fresques, de jardins d\'eau et du célèbre Mur des Miroirs.',
            sigiriyaDetail3: 'Profitez des vues panoramiques sur la jungle environnante et la campagne du sommet.',
            sigiriyaDetail4: 'Découvrez l\'histoire fascinante, l\'architecture et les légendes associées à Sigiriya grâce à votre guide expert.',
            sigiriyaDetail5: 'Parfait pour les passionnés d\'histoire, les chercheurs d\'aventure et ceux intéressés par le riche patrimoine culturel du Sri Lanka.',
            kandyDetail1: 'Découvrez la culture vibrante de Kandy, la dernière capitale royale du Sri Lanka et un Site du Patrimoine Mondial de l\'UNESCO.',
            kandyDetail2: 'Visitez le Temple de la Relique Sacrée de la Dent (Sri Dalada Maligawa), l\'un des sites bouddhistes les plus importants du monde.',
            kandyDetail3: 'Explorez les Jardins Botaniques Royaux de Peradeniya, abritant une vaste collection de plantes tropicales et d\'orchidées.',
            kandyDetail4: 'Profitez d\'un spectacle de danse traditionnelle Kandyan, mettant en valeur le riche patrimoine artistique du Sri Lanka.',
            kandyDetail5: 'Idéal pour les amateurs de culture, les passionnés d\'histoire et ceux qui souhaitent s\'immerger dans les traditions du Sri Lanka.'
        },
        blogs: {
            heroTitle: 'Blogs de Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Histoires du rivage, rituels Ayurveda au',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Plongez dans les conseils, l\'histoire et les notes en coulisses.',
            heroAlt: 'Allée de la plage du resort au coucher du soleil',
            sectionTitle: 'Blogs de Muthumuni Ayurveda Beach Resort',
            sectionDescription: 'Guides, histoires et notes de notre retraite côtière — couvrant les rituels Ayurveda, l\'histoire des pierres précieuses et les conseils de voyage autour de Bentota.',
            ayurvedaTitle: 'Le cœur de l\'Ayurveda authentique',
            ayurvedaExcerpt: 'Découvrez des traditions de guérison ancestrales enracinées dans la sagesse ancienne du Sri Lanka.',
            ayurvedaDescription: 'Au Muthumuni Ayurveda Beach Resort, l\'Ayurveda est plus qu\'un traitement — c\'est un mode de vie. Nos thérapies sont basées sur des connaissances séculaires, personnalisées selon votre type corporel et guidées par des médecins ayurvédiques expérimentés pour un équilibre profond et durable.',
            ayurvedaAlt: 'Installation de traitement ayurvédique avec huiles à base de plantes et éléments naturels',
            healingTitle: 'Parcours de guérison personnalisés',
            healingExcerpt: 'Pourquoi chaque programme de bien-être est conçu de manière unique.',
            healingDescription: 'Des consultations initiales aux traitements quotidiens, votre parcours de guérison est soigneusement adapté. Thérapies à base de plantes, massages thérapeutiques, yoga et méditation travaillent ensemble pour restaurer l\'harmonie entre le corps, l\'esprit et l\'âme.',
            healingAlt: 'Médecin ayurvédique consultant un client dans un cadre calme',
            natureTitle: 'Guérison au bord de l\'océan',
            natureExcerpt: 'Comment la brise marine et l\'environnement tropical améliorent votre bien-être.',
            natureDescription: 'Niché le long du littoral tranquille du Sri Lanka, Muthumuni offre un environnement naturellement curatif. Le bruit des vagues, l\'air frais de l\'océan et la verdure luxuriante amplifient les effets de l\'Ayurveda, créant une détente profonde et un renouveau.',
            natureAlt: 'Vue sur la plage du resort avec palmiers et océan',
            foodTitle: 'Cuisine ayurvédique pour l\'équilibre intérieur',
            foodExcerpt: 'Repas nourrissants conçus pour soutenir votre traitement.',
            foodDescription: 'Notre cuisine ayurvédique est fraîchement préparée avec des ingrédients de saison et d\'origine locale. Chaque repas est aligné sur votre dosha, favorisant la digestion, la détoxification et la vitalité globale tout en restant savoureux et satisfaisant.',
            foodAlt: 'Repas ayurvédique traditionnel servi dans des bols naturels',
            yogaTitle: 'Yoga, méditation et sérénité intérieure',
            yogaExcerpt: 'Pratiques douces qui calment l\'esprit et renforcent le corps.',
            yogaDescription: 'Les séances quotidiennes de yoga et de méditation complètent vos traitements, améliorant la flexibilité, la respiration et la clarté mentale. Ces pratiques conscientes vous aident à vous reconnecter avec vous-même et à emporter un sentiment de paix au-delà de votre séjour.',
            yogaAlt: 'Clients pratiquant le yoga face à l\'océan au lever du soleil',
            lifestyleTitle: 'Ramener l\'Ayurveda à la maison',
            lifestyleExcerpt: 'Pratiques de vie simples pour poursuivre votre parcours de bien-être.',
            lifestyleDescription: 'Avant votre départ, nos experts vous guident pour maintenir l\'équilibre à travers des routines quotidiennes, l\'alimentation et les rituels de soins personnels. Ramenez plus que des souvenirs — ramenez un chemin durable vers une vie plus saine.',
            lifestyleAlt: 'Client se détendant avec du thé aux herbes dans un cadre serein du resort',
            readMore: 'Lire la suite'
        },
        events: {
            heroEyebrow: 'Expériences & activités',
            heroTitle: 'Nos événements',
            heroSubtitle: 'Des expériences soigneusement conçues mêlant tradition sri-lankaise et luxe côtier',
            heroAlt: 'Événements à Muthumuni',
            availableDaily: 'Disponible tous les jours',
            bookNow: 'Réserver',
            highlightsTitle: 'Points forts',
            detailAlt: '{{title}} en détail',
            ctaTitle: 'Prêt à créer des souvenirs ?',
            ctaDescription: 'Contactez notre équipe pour personnaliser votre expérience événement idéale au Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Contactez-nous',
            ctaViewRooms: 'Voir les chambres',
            cookeryTitle: 'Programmes de cuisine',
            cookerySubtitle: 'Saveurs du Sri Lanka',
            cookeryDescription: 'Plongez dans les saveurs vibrantes de la cuisine sri-lankaise. Nos chefs experts vous guident lors de sessions de cuisine pratique, en enseignant des recettes traditionnelles transmises de génération en génération. Apprenez à préparer des currys aromatiques, des hoppers, du sambol à la noix de coco et bien plus encore avec des ingrédients locaux frais.',
            cookeryHighlight1: 'Recettes sri-lankaises traditionnelles',
            cookeryHighlight2: 'Expérience de cuisine pratique',
            cookeryHighlight3: 'Ingrédients locaux frais',
            cookeryHighlight4: 'Emportez les recettes chez vous',
            cookeryHighlight5: 'Visite du jardin d’épices incluse',
            meditationTitle: 'Programmes de méditation',
            meditationSubtitle: 'Paix intérieure & pleine conscience',
            meditationDescription: 'Trouvez la tranquillité lors de nos séances de méditation guidée avec pour toile de fond l’océan Indien. Nos instructeurs expérimentés vous guident à travers des techniques anciennes de pleine conscience, des exercices de respiration et des pratiques de yoga conçues pour apaiser l’esprit et revitaliser l’âme.',
            meditationHighlight1: 'Séances au lever et au coucher du soleil',
            meditationHighlight2: 'Méditation en bord de mer',
            meditationHighlight3: 'Guidé par des experts',
            meditationHighlight4: 'Techniques de respiration',
            meditationHighlight5: 'Pratiques de yoga et de pleine conscience',
            bbqTitle: 'Soirées BBQ',
            bbqSubtitle: 'Célébrations en bord de mer',
            bbqDescription: 'Vivez des soirées inoubliables avec nos BBQ en bord de plage. Savourez des fruits de mer fraîchement grillés, des viandes premium et des délices végétariens tandis que les vagues murmurent à proximité. Musique live, danseurs de feu et ciel étoilé créent l’ambiance parfaite pour célébrer et se connecter.',
            bbqHighlight1: 'Fruits de mer grillés frais',
            bbqHighlight2: 'Dîner face à l’océan',
            bbqHighlight3: 'Divertissement en direct',
            bbqHighlight4: 'Expérience autour du feu',
            bbqHighlight5: 'Menus personnalisables',
            boatTitle: 'Balades en bateau',
            boatSubtitle: 'Aventures fluviales et côtières',
            boatDescription: 'Partez pour des voyages enchanteurs le long de la rivière Bentota et des eaux côtières. Glissez à travers les mangroves, observez des oiseaux exotiques et la faune, ou profitez de croisières romantiques au coucher du soleil. Nos balades en bateau offrent une perspective unique sur la beauté naturelle et les écosystèmes du Sri Lanka.',
            boatHighlight1: 'Croisières sur la rivière Bentota',
            boatHighlight2: 'Exploration des mangroves',
            boatHighlight3: 'Observation de la faune',
            boatHighlight4: 'Balades en bateau au coucher du soleil',
            boatHighlight5: 'Location privée disponible',
            ayurvedaLecturesTitle: 'Conférences de médecins ayurvédiques',
            ayurvedaLecturesSubtitle: 'Sagesse ancienne & bien-être moderne',
            ayurvedaLecturesDescription: 'Découvrez les principes profonds de l’Ayurveda grâce à des conférences animées par des médecins ayurvédiques certifiés et des praticiens. Apprenez l’équilibrage des doshas, les remèdes à base de plantes, les pratiques de guérison holistique et comment la sagesse ancienne s’applique au bien-être moderne. Nos sessions interactives démystifient la philosophie ayurvédique et son application au quotidien.',
            ayurvedaLecturesHighlight1: 'Médecins ayurvédiques certifiés',
            ayurvedaLecturesHighlight2: 'Analyse dosha personnalisée',
            ayurvedaLecturesHighlight3: 'Éducation aux remèdes à base de plantes',
            ayurvedaLecturesHighlight4: 'Sessions de questions-réponses',
            ayurvedaLecturesHighlight5: 'Guide bien-être à emporter',
            traditionalClothsTitle: 'Événements de port de tenues traditionnelles',
            traditionalClothsSubtitle: 'Expérience du patrimoine culturel',
            traditionalClothsDescription: 'Immergez-vous dans le patrimoine culturel sri-lankais en apprenant à porter et à apprécier les tenues traditionnelles. Nos stylistes experts vous guident pour revêtir des sarees kandyan authentiques et des vêtements traditionnels, en expliquant la signification culturelle de chaque pièce. Idéal pour des occasions spéciales, l’appréciation culturelle ou des photos mémorables.',
            traditionalClothsHighlight1: 'Conseils de stylisme experts',
            traditionalClothsHighlight2: 'Sarees traditionnels authentiques',
            traditionalClothsHighlight3: 'Signification culturelle expliquée',
            traditionalClothsHighlight4: 'Photographie professionnelle incluse',
            traditionalClothsHighlight5: 'Ateliers de fusion mode'
        },
        contact: {
            heroTitle: 'Contactez-nous',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contactez-nous',
            sectionTitle: 'N\'hésitez pas à nous contacter',
            sectionSubtitle: 'Nous sommes là pour vous aider à vous détendre et vous ressourcer',
            sectionDescription: 'Contactez Muthumuni Ayurveda Beach Resort pour toute question sur votre séjour ayurvédique, les forfaits bien‑être, les réservations ou votre séjour à Beruwala, Moragalla.',
            callUs: 'Appelez-nous',
            emailTitle: 'Email',
            ourLocation: 'Notre adresse',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Réseaux sociaux',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Entrer en contact',
            getInTouchDescription: 'Nous serions ravis d\'échanger avec vous — notre équipe est prête à vous accompagner, répondre à vos questions et planifier un séjour ressourçant.',
            nameLabel: 'Nom',
            emailLabel: 'Email',
            contactNumberLabel: 'Numéro de contact',
            messageLabel: 'Message',
            sending: 'Envoi...',
            sendMessage: 'Envoyer le message',
            successMessage: 'Votre message a bien été envoyé ! Nous vous répondrons bientôt.',
            errorMessage: 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.',
            findUsOnMap: 'Nous trouver sur la carte',
            whatsappSubject: 'Contact Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Nom',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numéro de contact',
            whatsappMessage: 'Message'
        },

        contact2: {
            heroTitle: 'Contactez-nous',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Contactez-nous',
            sectionTitle: 'N\'hésitez pas à nous contacter',
            sectionSubtitle: 'Nous sommes là pour vous aider à vous détendre et vous ressourcer',
            sectionDescription: 'Contactez Muthumuni Ayurveda Beach Resort pour toute question sur votre séjour ayurvédique, les forfaits bien‑être, les réservations ou votre séjour à Beruwala, Moragalla.',
            callUs: 'Appelez-nous',
            emailTitle: 'Email',
            ourLocation: 'Notre adresse',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Réseaux sociaux',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Entrer en contact',
            getInTouchDescription: 'Nous serions ravis d\'échanger avec vous — notre équipe est prête à vous accompagner, répondre à vos questions et planifier un séjour ressourçant.',
            nameLabel: 'Nom',
            emailLabel: 'Email',
            contactNumberLabel: 'Numéro de contact',
            messageLabel: 'Message',
            sending: 'Envoi...',
            sendMessage: 'Envoyer le message',
            successMessage: 'Votre message a bien été envoyé ! Nous vous répondrons bientôt.',
            errorMessage: 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.',
            findUsOnMap: 'Nous trouver sur la carte',
            whatsappSubject: 'Contact Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Nom',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numéro de contact',
            whatsappMessage: 'Message'
        },

        ayurveda: {
            accordionTitle1: 'Qu\'est-ce que le Panchakarma Ayurvéda?',
            accordionDesc1: 'L\'Ayurvéda est l\'un des systèmes de guérison les plus anciens au monde, développé il y a plus de 5000 ans. Le Panchakarma Ayurvéda repose sur la conviction que la santé dépend de l\'équilibre entre l\'esprit, le corps, l\'âme et l\'environnement.',
            accordionTitle2: 'Panchakarma Ayurvéda et Énergie Vitale',
            accordionDesc2: 'L\'Ayurvéda est basé sur la théorie de l\'interconnexion de tout dans l\'univers. Ceux qui pratiquent l\'Ayurvéda croient que chaque personne est composée de cinq éléments: espace, air, feu, eau et terre. Ils forment trois doshas: VATA, PITTA et KAPHA.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Le dosha le plus puissant qui contrôle les fonctions corporelles de base: division cellulaire, respiration, flux sanguin, fonction cardiaque. Avec Vata dominant, vous êtes intelligent, créatif, énergique. En déséquilibre - anxiété. Équilibre par méditation, massage et aliments chauds.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Contrôle la digestion, le métabolisme et les hormones. Avec Pitta dominant, vous êtes déterminé, compétitif, confiant. En déséquilibre - irritabilité. Équilibre par aliments rafraîchissants et yoga lent.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Contrôle la croissance musculaire, la force corporelle et l\'immunité. Avec Kapha dominant, vous aimez la routine, êtes calme et patient. En déséquilibre - fatigue et prise de poids. Équilibre par fruits, légumes et exercice.',
            close: 'Fermer',
            next: 'Suivant',
            previous: 'Précédent',
            treatmentsTitle: 'Nos traitements Panchakarma Ayurvédiques signature',
            treatmentsSubtitle: 'Découvrez des thérapies ancestrales conçues pour restaurer l\'équilibre, libérer les tensions et rajeunir tout votre être.',
            bookTreatment: 'Réserver ce traitement',
            benefitsTitle: 'Bienfaits des traitements Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Un doux versement d\'huile chaude aux herbes sur le front pour calmer l\'esprit.',
            shirodhara1: 'Réduit le stress et l\'anxiété',
            shirodhara2: 'Améliore le sommeil',
            shirodhara3: 'Augmente la clarté mentale',
            steamBath: 'Bain de vapeur',
            steamBathDesc: 'Un traitement détoxifiant à la vapeur pour ouvrir les pores et détendre les muscles.',
            steamBath1: 'Détoxifie le corps',
            steamBath2: 'Améliore la circulation',
            steamBath3: 'Soulage la tension musculaire',
            flowerBath: 'Bain floral',
            flowerBathDesc: 'Un bain apaisant infusé de fleurs aromatiques pour la relaxation.',
            flowerBath1: 'Calme le système nerveux',
            flowerBath2: 'Hydrate la peau',
            flowerBath3: 'Améliore l\'humeur',
            headMassage: 'Massage de la tête',
            headMassageDesc: 'Un massage relaxant ciblant le cuir chevelu pour soulager les tensions.',
            headMassage1: 'Réduit les maux de tête',
            headMassage2: 'Améliore la santé du cuir chevelu',
            headMassage3: 'Favorise la relaxation',
            faceMassage: 'Massage du visage',
            faceMassageDesc: 'Un massage rajeunissant pour améliorer l\'éclat du visage et réduire le stress.',
            faceMassage1: 'Améliore le teint',
            faceMassage2: 'Réduit la tension faciale',
            faceMassage3: 'Favorise le drainage lymphatique',
            neckMassage: 'Massage du cou',
            neckMassageDesc: 'Massage ciblé pour soulager la raideur et la tension du cou.',
            neckMassage1: 'Soulage la douleur au cou',
            neckMassage2: 'Améliore la flexibilité',
            neckMassage3: 'Réduit le stress',
            shoulderMassage: 'Massage des épaules',
            shoulderMassageDesc: 'Massage ciblé pour soulager la raideur et l\'inconfort des épaules.',
            shoulderMassage1: 'Réduit la douleur aux épaules',
            shoulderMassage2: 'Améliore la posture',
            shoulderMassage3: 'Détend les muscles',
            bodyMassage: 'Massage du corps',
            bodyMassageDesc: 'Un massage complet du corps pour favoriser la relaxation et le bien‑être global.',
            bodyMassage1: 'Améliore la circulation',
            bodyMassage2: 'Soulage les douleurs musculaires',
            bodyMassage3: 'Favorise la relaxation',
            backMassage: 'Massage du dos',
            backMassageDesc: 'Un massage thérapeutique ciblant la douleur et la tension du dos.',
            backMassage1: 'Soulage le mal de dos',
            backMassage2: 'Améliore la santé spinale',
            backMassage3: 'Réduit le stress',
            footMassage: 'Massage des pieds',
            footMassageDesc: 'Un massage apaisant pour soulager la douleur des pieds et favoriser la relaxation.',
            footMassage1: 'Améliore la circulation',
            footMassage2: 'Réduit la fatigue des pieds',
            footMassage3: 'Favorise la relaxation',
            purgative: 'Purgatif',
            purgativeDesc: 'Une thérapie purifiante pour éliminer l\'excès de Pitta et les toxines du système digestif.',
            purgative1: 'Nettoie le côlon',
            purgative2: 'Équilibre le dosha Pitta',
            purgative3: 'Améliore la santé digestive',
            nasalClearing: 'Nettoyage nasal',
            nasalClearingDesc: 'Un traitement nasal thérapeutique pour dégager les sinus et améliorer la fonction respiratoire.',
            nasalClearing1: 'Dégage la congestion nasale',
            nasalClearing2: 'Améliore la respiration',
            nasalClearing3: 'Soulage les problèmes sinusaux',
            powderMassage: 'Massage à la poudre',
            powderMassageDesc: 'Un massage exfoliant utilisant des poudres aux herbes pour rajeunir et rafraîchir la peau.',
            powderMassage1: 'Exfolie la peau morte',
            powderMassage2: 'Améliore la texture de la peau',
            powderMassage3: 'Favorise la circulation',
            intensiveMassageDesc: 'Un massage thérapeutique profond ciblant les tensions chroniques et les nœuds musculaires avec une pression ferme et des techniques spécialisées.',
            intensiveMassage1: 'Soulage les tensions musculaires profondes',
            intensiveMassage2: 'Améliore la circulation sanguine',
            intensiveMassage3: 'Réduit les courbatures',
            thermoMassage: 'Massage Thermo',
            thermoMassageDesc: 'Un massage chaud à l’huile aux herbes avec des huiles thérapeutiques chauffées pour renforcer la détente et les bienfaits curatifs.',
            thermoMassage1: 'Apaise les muscles endoloris',
            thermoMassage2: 'Favorise une profonde relaxation',
            thermoMassage3: 'Améliore la circulation énergétique',
            synchronMassage: 'Massage Synchronisé',
            synchronMassageDesc: 'Un massage synchronisé à deux thérapeutes pour une harmonie corporelle complète et une répartition équilibrée de l’énergie.',
            synchronMassage1: 'Harmonie complète du corps',
            synchronMassage2: 'Flux énergétique équilibré',
            synchronMassage3: 'Expérience de relaxation profonde',
            specialMassage: 'Massage Spécial',
            specialMassageDesc: 'Thérapie de massage personnalisée adaptée à vos besoins spécifiques de santé et à vos objectifs personnels de bien-être.',
            specialMassage1: 'Traitement personnalisé',
            specialMassage2: 'Cible les problèmes spécifiques',
            specialMassage3: 'Approche de guérison sur mesure',
            benefit1Title: 'Détoxification :',
            benefit1Desc: 'Les traitements Panchakarma aident à éliminer les toxines du corps, favorisant la santé et la vitalité globales.',
            benefit2Title: 'Digestion améliorée :',
            benefit2Desc: 'Ces thérapies améliorent la fonction digestive pour une meilleure absorption des nutriments et un meilleur métabolisme.',
            benefit3Title: 'Soulagement du stress :',
            benefit3Desc: 'Panchakarma est connu pour ses effets calmants sur le corps et l\'esprit, réduisant les niveaux de stress et d\'anxiété.',
            benefit4Title: 'Immunité renforcée :',
            benefit4Desc: 'Les traitements Panchakarma réguliers peuvent renforcer le système immunitaire, rendant le corps plus résistant aux maladies.',
            benefit5Title: 'Rajeunissement :',
            benefit5Desc: 'Les thérapies favorisent la régénération cellulaire pour une meilleure santé de la peau et une apparence jeune.',
            benefit6Title: 'Équilibre des Doshas :',
            benefit6Desc: 'Panchakarma aide à restaurer l\'équilibre des doshas du corps (Vata, Pitta, Kapha), essentiel pour maintenir la santé selon les principes ayurvédiques.',
            akkupancharTitle: 'Thérapie Akkupanchar',
            akkupancharDesc1: 'est une ancienne thérapie ayurvédique utilisant des pâtes et huiles aux herbes appliquées sur des points spécifiques du corps. Ce traitement stimule les canaux énergétiques vitaux et favorise la guérison.',
            akkupancharBenefit: 'Avantages clés :',
            akkupancharDesc2: 'Cette thérapie spécialisée aide à soulager la douleur chronique, améliorer la flexibilité articulaire, la circulation sanguine et restaurer le flux énergétique naturel du corps.',
            akkupancharApplication: 'Application thérapeutique :',
            akkupancharDesc3: 'Akkupanchar agit sur des points marma spécifiques avec des préparations aux herbes soigneusement sélectionnées pour équilibrer les doshas.',
            akkupancharTransform: 'Expérimentez la transformation :',
            akkupancharDesc4: 'Au Muthumuni Ayurveda Beach Resort, nos praticiens expérimentés personnalisent chaque session pour répondre à vos besoins de santé uniques.',
            gallery1: 'Thérapie Shirodhara',
            gallery2: 'Bain de vapeur',
            gallery3: 'Bain floral',
            gallery4: 'Massage de la tête',
            gallery5: 'Massage du corps',
            gallery6: 'Massage du cou',
            gallery7: 'Massage du visage',
            gallery8: 'Massage des épaules',
            heroTitle: 'Panchakarma Ayurvéda',
            heroSubtitle: 'Rajeunissez Corps, Esprit et Âme à Beruwala',
            sectionEyebrow: 'PANCHAKARMA AYURVÉDA AU MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Découvrez l\'ancien art de guérison du Panchakarma Ayurvéda au Muthumuni Ayurveda Beach Resort à Beruwala. Nos praticiens expérimentés offrent des traitements personnalisés pour détoxifier, rajeunir et restaurer l\'équilibre.',
            treatmentProgramme: {
                title: 'Programme de Traitement Ayurvédique',
                subtitle: 'Votre Voyage vers l\'Équilibre, la Détox et le Renouveau Profond',
                intro: 'Vivez une guérison ayurvédique authentique dans une retraite paisible conçue pour restaurer votre corps, calmer votre esprit et renouveler votre énergie. Dès votre arrivée, notre équipe prend soin de chaque détail—afin que vous puissiez vous concentrer pleinement sur votre bien-être.',
                welcomeTitle: 'Accueil et Début en Douceur',
                welcomePoints: [
                    'Prise en charge à l\'aéroport et transfert à l\'hôtel',
                    'Accueil chaleureux et orientation de l\'hôtel',
                    'Présentation de votre programme de bien-être hebdomadaire',
                    'Massage de Relaxation (Jour 1) au Centre Ayurveda pour éliminer la fatigue du voyage et préparer votre corps aux traitements'
                ],
                doctorTitle: 'Consultation Médicale et Plan Personnalisé',
                doctorPoints: [
                    'Consultation avec le Médecin Ayurvédique (Jour 2 – matin)',
                    'Évaluation complète de votre Dosha/type de corps et problèmes de santé',
                    'Traducteur disponible sur demande',
                    'Votre médecin crée un plan de traitement personnalisé adapté à vos besoins et objectifs'
                ],
                dailyTherapiesTitle: 'Thérapies Ayurvédiques Quotidiennes',
                dailyTherapiesPoints: [
                    '4–5 traitements quotidiens (selon les recommandations du médecin)',
                    'Thérapies sélectionnées en fonction de votre constitution corporelle et de votre état',
                    'Des massages spéciaux peuvent être ajoutés si nécessaire',
                    'Le médecin surveille les progrès quotidiennement et peut ajuster les traitements et le soutien à base de plantes pour garantir les meilleurs résultats',
                    'Si approprié, un processus de nettoyage/purge doux peut être recommandé'
                ],
                herbalMedicineTitle: 'Soutien par Médecine à Base de Plantes',
                herbalMedicinePoints: [
                    'Médicaments à base de plantes prescrits par le médecin servis deux fois par jour:',
                    'Pendant le petit-déjeuner',
                    'Pendant le dîner',
                    'Soutenant la guérison interne, la détoxification et l\'équilibre durable'
                ],
                yogaMeditationTitle: 'Yoga et Méditation pour l\'Harmonie Corps-Esprit',
                yogaMeditationPoints: [
                    'Séances de yoga 4 fois par semaine (environ 1 heure)',
                    'Séances de méditation 2 fois par semaine:',
                    'Une expérience spirituelle unique dans un temple insulaire, accessible en bateau',
                    'Méditation guidée dirigée par des moines (environ 1 heure)'
                ],
                wellnessTitle: 'Expériences de Bien-être Incluses',
                wellnessPoints: [
                    'Démonstrations culinaires saines hebdomadaires',
                    'Excursion gratuite (expérience culturelle/nature)'
                ],
                closingTitle: 'Rituel de Clôture et Départ',
                closingPoints: [
                    'Un magnifique Bain de Fleurs (dernier jour)—un rituel traditionnel de renouveau',
                    'Consultation finale avec le médecin pour examiner les progrès et fournir:',
                    'Conseils de bien-être continus',
                    'Prescriptions et recommandations pour la maison',
                    'Transfert de retour à l\'aéroport'
                ]
            },
        },
        food: {
            heroTitle: 'Cuisine ayurvédique et cuisine côtière',
            heroSubtitle: 'Saveurs authentiques du Sri Lanka et cuisine côtière fraîche',
            heroAlt: 'Expérience culinaire au Muthumuni Beach Resort',
            wellnessEyebrow: 'Bien-être par la nourriture',
            wellnessTitle: 'L\'importance du',
            ayurvedicFood: 'aliment ayurvédique',
            wellnessIntro1: 'En Ayurveda, la nourriture est considérée comme la plus grande médecine. Ce que vous mangez influence directement vos doshas (Vata, Pitta, Kapha), votre digestion (agni) et l\'équilibre global de votre corps, esprit et âme.',
            wellnessIntro2: 'La nutrition ayurvédique met l\'accent sur les aliments frais, saisonniers et complets préparés avec soin et mangés en pleine conscience. Elle promeut six saveurs (sucrée, acide, salée, piquante, amère, astringente) dans chaque repas pour nourrir tous les sens et maintenir l\'harmonie.',
            wellnessIntro3: 'La bonne nourriture ayurvédique soutient une digestion forte, aide à éliminer les toxines (ama), renforce l\'immunité, améliore l\'énergie, réduit le stress et prévient de nombreuses maladies chroniques. À Muthumuni, chaque plat est soigneusement préparé pour s\'aligner sur votre constitution unique pour une guérison profonde et une vitalité.',
            foodImage1Alt: 'Repas ayurvédique traditionnel avec six saveurs',
            foodImage2Alt: 'Herbes ayurvédiques et épices pour une nutrition équilibrée',
            culinaryPhilosophyEyebrow: 'Notre philosophie culinaire',
            culinaryPhilosophyTitle: 'Nutrition',
            nutritionHighlight: 'ayurvédique',
            culinaryPhilosophyResort: 'au Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Cuisine ayurvédique au Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Frais et nourrissant',
            healingIngredientsAlt: 'Ingrédients et épices ayurvédiques sains',
            healingIngredientsLabel: 'Ingrédients curatifs',
            philosophyText1: 'La nourriture, qui englobe les six saveurs principales (sucrée, acide, salée, amère, piquante et astringente) ainsi que de nombreuses variations subtiles, a été décrite dans des textes ayurvédiques classiques — certains datant de plus de 5 000 ans — ainsi que les propriétés essentielles de chaque aliment : Guna (qualité inhérente), Virya (potentialité/réchauffement ou refroidissement), Vipaka (impact post-digestif) et Prabhava (action spéciale unique).',
            philosophyText2: 'En conséquence, la nutrition ayurvédique joue un rôle central au Muthumuni Ayurveda Beach Resort. Cela ne signifie pas un régime rigide et monotone de repas insipides, sans saveur ou excessivement amers dictés uniquement par les médecins. Au contraire, notre cuisine ayurvédique est l\'une de nos plus grandes forces : les plats préparés par nos cuisiniers compétents vous surprendront et vous raviront chaque jour de votre séjour !',
            philosophyText3: 'Au petit-déjeuner, profitez d\'un généreux buffet avec des fruits tropicaux frais, des jus fraîchement pressés, des soupes aux herbes nourrissantes, du pain fait maison et des biscuits légers, plus une variété d\'options d\'authentique petit-déjeuner sri-lankais. Au déjeuner, savourez un buffet coloré et savoureux avec des currys de poisson doux, des préparations de légumes et des plats infusés d\'herbes. Le soir, nous servons un menu végétarien défini avec option de poisson frais disponible. Le samedi, nous célébrons la « Nuit du Sri Lanka » avec un buffet élargi — nos chefs préparent des spécialités locales traditionnelles directement devant vous, créant une expérience animée et authentique.',
            philosophyText4: 'En Ayurveda, les aliments et les boissons sont classés de nombreuses façons — selon le goût et les propriétés, la capacité digestive du corps (agni), l\'adéquation pour des conditions de santé spécifiques, l\'opportunité saisonnière, et plus encore. À Muthumuni, nous considérons soigneusement tous ces facteurs simultanément, en faisant un effort conscient pour inclure les six saveurs dans des combinaisons équilibrées adaptées à la constitution individuelle de chaque invité.',
            philosophyText5: 'Nos repas mettent en vedette des légumes frais, des fruits tropicaux et du poisson d\'approvisionnement responsable. Nous ne servons pas de viande rouge ni d\'alcool.',
            philosophyText6: 'Pendant les repas, un médecin ayurvédique ou un diététicien qualifié est toujours disponible pour vous guider. Ils vous conseilleront sur les légumes, herbes et épices les plus appropriés pour votre phase de traitement actuelle et vous aideront à sélectionner ou à éviter les plats en conséquence. Votre élixir à base de plantes personnalisé et tout instructions spécifiques de l\'équipe du centre de santé seront placés sur votre table individuelle.',
            philosophyText7: 'Ce niveau de soins personnalisés et d\'attention au régime alimentaire est un trait distinctif de l\'expérience Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'La nourriture est considérée comme Prana — l\'énergie vitale qui soutient la vie — pour chaque être humain. C\'est pourquoi nous vous encourageons à aborder chaque repas avec une pleine conscience : en savourant les arômes, en vivant les saveurs, en ressentant la chaleur douce et en profitant des sensations savoureuses de manière consciente.',
            diningExperienceEyebrow: 'Expérience culinaire',
            restaurantTitlePrefix: 'Notre',
            ayurvedicHighlight: 'ayurvédique',
            restaurantTitleSuffix: 'restaurant',
            restaurantDetail1: 'Notre restaurant ayurvédique au Muthumuni Beach Resort offre une expérience culinaire unique qui harmonise les principes ayurvédiques traditionnels avec l\'authentique cuisine côtière du Sri Lanka. Nous accordons la priorité aux ingrédients frais et locaux pour créer des repas qui non seulement enchantent le palais mais favorisent également le bien-être global.',
            restaurantDetail2: 'Le menu est soigneusement conçu pour équilibrer les six saveurs (sucrée, acide, salée, amère, piquante et astringente) dans chaque plat, assurant une expérience nourrissante et satisfaisante. Chaque repas est préparé avec soin, incorporant des herbes et des épices ayurvédiques connues pour leurs propriétés curatives.',
            restaurantDetail3: 'Les invités peuvent profiter d\'une variété de plats adaptés à leurs doshas individuels (constitutions corporelles), avec des options pour les régimes végétariens, végétaliens et pescatariens. Nos chefs travaillent en étroite collaboration avec les praticiens ayurvédiques pour s\'assurer que chaque repas soutient les objectifs de santé et de bien-être des invités.',
            restaurantDetail4: 'L\'atmosphère du restaurant reflète l\'environnement côtier serein, offrant un cadre tranquille pour une alimentation consciente. Que vous profitiez d\'un généreux buffet de petit-déjeuner ou que vous dégustiez un dîner gastronomique, chaque repas dans notre restaurant ayurvédique est une occasion de nourrir le corps et l\'âme.',
            restaurantDetail5: 'Rejoignez-nous au restaurant ayurvédique du Muthumuni Beach Resort pour un voyage culinaire qui célèbre les saveurs riches du Sri Lanka tout en embrassant la sagesse intemporelle de l\'Ayurveda.',
            restaurantImageAlt: 'Dîner au Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Gastronomie premium',
            premiumDiningDescription: 'Découvrez une authentique cuisine ayurvédique dans un cadre fluvial serein'
        },
        yoga: {
            heroTitle: 'Yoga au resort',
            heroSubtitle: 'Trouvez équilibre, force et paix intérieure à Beruwala',
            heroAlt: 'Yoga au Muthumuni Beach Resort',
            importanceEyebrow: 'Bien-être & équilibre',
            importanceTitle: 'Importance du yoga et de la méditation',
            importanceImageAlt: 'Importance du yoga et de la méditation',
            importanceText1: 'Le yoga et la méditation sont des pratiques anciennes qui offrent de nombreux bienfaits physiques, mentaux et émotionnels. Ils favorisent la souplesse, la force et l’équilibre tout en réduisant le stress et l’anxiété.',
            importanceText2: 'Une pratique régulière peut améliorer la concentration, la qualité du sommeil et renforcer le bien-être général. Le yoga encourage aussi la pleine conscience, aidant chacun à se connecter à son moi intérieur et à trouver la paix au milieu du quotidien.',
            importanceText3: 'Au Muthumuni Beach Resort, nous offrons des environnements sereins parfaits pour pratiquer le yoga et la méditation, permettant aux invités de régénérer l’esprit, le corps et l’âme.',
            practiceEyebrow: 'Notre pratique',
            practiceTitle: 'Pratique & expérience du yoga',
            practiceImageAlt: 'Pratique du yoga au resort',
            practiceText1: 'Au Muthumuni Ayurveda Beach Resort, le yoga est principalement pratiqué sous forme de Hatha Yoga traditionnel, associé au Pranayama (techniques de respiration). Cette approche holistique vise à éveiller la conscience intérieure et à stimuler doucement la Kundalini (souvent appelée le troisième œil). Une attention particulière est portée à l’alignement de la colonne vertébrale et à la flexibilité, car une colonne souple est censée ralentir le vieillissement — « Vous n’avez que l’âge de votre colonne vertébrale. »',
            practiceText2: 'Les séances de yoga ont lieu quatre fois par semaine et conviennent aussi bien aux débutants qu’aux pratiquants expérimentés. De temps en temps, des sessions spéciales comme l’Ashtanga Yoga sont proposées, permettant aux invités de découvrir une variété de postures et de routines. Nos médecins ayurvédiques encouragent une participation régulière pour soutenir et renforcer le programme de traitement global.',
            practiceText3: 'Toutes les séances se déroulent dans notre Yoga Shala dédié, un espace calme conçu pour favoriser la concentration, l’équilibre et le mouvement conscient. Chaque session commence généralement par des salutations au soleil, suivies du Pranayama et d’une séquence d’asanas soigneusement sélectionnées visant à améliorer la souplesse, la circulation et le bien-être général.',
            practiceText4: 'Nos professeurs de yoga expérimentés adaptent chaque séance aux besoins, aux capacités et aux conditions de santé des invités, garantissant une expérience sûre, bienveillante et profondément bénéfique pour tous.',
            spiritualEyebrow: 'Voyage spirituel',
            spiritualTitle: 'Méditation & activités spirituelles',
            spiritualSubtitle: 'Approfondissez votre pratique spirituelle avec nos cérémonies sacrées et nos séances de méditation guidée',
            meditationImageAlt: 'Méditation et pratique spirituelle au resort',
            meditationTitle: 'Séances de méditation',
            meditationDesc: 'Les invités sont invités à participer à des séances de méditation guidée organisées trois fois par semaine, inspirées des traditions bouddhistes. Ces séances sont conçues pour apaiser l’esprit, approfondir la conscience et soutenir la guérison émotionnelle et spirituelle. La méditation se déroule dans un temple paisible sur une île, accessible en bateau — un voyage serein et significatif qui enrichit l’expérience méditative globale.'
        }
    },
    zh: {
        about: {
            heroTitle: '关于我们',
            heroSubtitle: 'Muthumuni 阿育吠陀',
            heroBeachResort: 'Beach Resort',
            heroTagline1: '古老的智慧与现代养生在穆图穆尼阿育吠陀海滨度假村相遇',
            heroTagline2: '个性化阿育吠陀治疗、海景和地道的斯里兰卡款待',
            slide1: '阿育吠陀疗愈',
            slide2: '海滨宁静',
            slide3: '花园宁静',
            slide4: '草本疗法',
            slide5: '海洋养生',
            historyLabel: '我们的历程',
            historyTitle: '穆图穆尼阿育吠陀海滨度假村的历史',
            historyDesc1: '穆图穆尼阿育吠陀海滨度假村建立于二十多年前，源于创建一个圣地的愿景，将古老的阿育吠陀智慧与斯里兰卡南部海岸宁静的美融为一体。起初只是一个谦逊的养生静修地，如今已发展成为贝鲁瓦拉最受欢迎的全面疗愈和复兴目的地。',
            historyDesc2: '我们的创始人受到几代传统阿育吠陀医生的启发，致力于在提供现代便利和地道斯里兰卡款待的同时，保留这些历时考验的治疗艺术。多年来，我们始终坚持对真正养生体验的承诺，扩展设施的同时，从未忘记定义我们遗产的个性化关怀。',
            historyDesc3: '如今，穆图穆尼见证了阿育吠陀持久的力量，已迎接来自世界各地的数千位宾客。每位访客都成为我们故事的一部分，在我们的海滨天堂中找到平衡、疗愈和蜕变。',
            statYear: '15+',
            statYearLabel: '年养生卓越成就',
            statGuest: '1,000+',
            statGuestLabel: '欢乐宾客服务数',
            experienceLegacy: '体验我们的遗产',
            established: '建立于',
            since2010: '自2008年起',
            chairmanLabel: '董事长的寄语',
            chairmanTitle: '用心引导，以阿育吠陀为根',
            chairmanDesc1: '欢迎来到穆图穆尼阿育吠陀海滨度假村。二十多年来，我们的目的很简单：提供植根于阿育吠陀永恒智慧的真正疗愈，用斯里兰卡款待的温暖传达。',
            chairmanDesc2: '在这里，每一个细节——从我们的治疗和美食到我们空间的宁静——都设计用来帮您放慢脚步、恢复平衡、重新与自己相连。我们荣幸成为您养生旅程的一部分。',
            chairmanDesc3: '代表我们敬业的团队，我邀请您体验定义穆图穆尼的关怀、真实和宁静。',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: '董事长',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: '董事长 Mr. Nihal Muthumuni',
            staffLabel: '我们的团队',
            staffTitle: '认识我们敬业的员工',
            staffDesc1: '在穆图穆尼阿育吠陀海滨度假村，我们的团队是一切工作的核心。我们的员工是精心甄选和培训的专业人士，对阿育吠陀养生和真正的款待怀有深厚的热情。',
            staffDesc2: '从我们经验丰富的阿育吠陀医生和技术精湛的按摩治疗师到我们敬业的款待团队，每位成员都为与每位宾客的互动带来多年的专业知识和真诚的关怀。我们相信真正的养生不仅来自治疗，更来自真正关心您旅程的人的温暖和关注。',
            staffDesc3: '我们的员工接受持续培训，掌握最新的阿育吠陀实践，同时保持专业和文化敏感性的最高标准。我们为与宾客建立有意义的联系而自豪，确保每次访问都成为难忘和蜕变的体验。',
            statStaff: '15+',
            statStaffLabel: '熟练专业人士',
            statSatisfaction: '100%',
            statSatisfactionLabel: '宾客满意度',
            staffImageAlt: '我们在穆图穆尼阿育吠陀海滨度假村的敬业员工团队',
            commitmentBadge: '我们的承诺',
            excellenceCare: '卓越与关怀',
            ctaLabel: '联系我们',
            ctaHeading: '准备好开始您的养生之旅了吗？',
            ctaDesc: '联系我们的团队预订您的个性化阿育吠陀静修。无论您对我们的治疗、住宿或特殊养生套餐有任何疑问，我们都在这里帮助您创建完美的逃脱。',
            ctaButtonContact: '立即联系我们',
            ctaButtonRooms: '探索客房',
            contactUs: '联系我们',
            quickInfoCall: '致电我们',
            quickInfoEmail: '发送邮件',
            quickInfoLocation: '位置',
            locationCity: '贝鲁瓦拉，斯里兰卡'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: '豪华河景房 — 带露台或私人阳台的舒适',
            heroSubtitle: '在受Bentota宁静河水启发的河畔宁静隐居处放松，融合现代设施与轻柔河风。',
            bookThisRoom: '预订此房',
            callReservations: '致电预订',

            navAll: '全部',
            navDeluxe: '豪华',
            navRiverViewDeluxe: '豪华河景',

            soothingHideawayTitle: '宁静的河畔隐居',
            soothingHideawayDesc: '我们的豪华河景房专为悠闲清晨和无忧日落打造。柔和中性色调、宽敞玻璃窗和精心照明将河景引入室内，阳台成为您俯瞰流水的私人角落。',

            highlight1Title: '全景河景',
            highlight1Desc: '从私人阳台醒来，欣赏宁静河景与金色日出。',
            highlight2Title: '优雅河畔室内',
            highlight2Desc: '柔和中性色调、温暖木质元素和充足自然光。',
            highlight3Title: '宁静睡眠体验',
            highlight3Desc: '豪华king-size床配高级床品，带来恢复性睡眠。',

            atAGlance: '一览',
            statSizeLabel: '面积',
            statViewLabel: '景观',
            statViewValue: '河景',
            statGuestsLabel: '入住人数',
            statBedLabel: '床型',
            statBedValue: 'King或双人',
            reserve: '预订',

            includedWithStay: '入住包含',
            thoughtfulTouches: '贴心细节，全天舒适',
            enhancedCleanliness: '提升的清洁与安全标准',

            inclusion1: 'Breeze餐厅免费早餐、午餐、晚餐',
            inclusion2: '客房高速Wi-Fi和工作区',
            inclusion3: '24小时客房服务与礼宾服务',
            inclusion4: '每日清洁及晚间整理服务',
            inclusion5: '无边泳池及阿育吠陀水疗设施使用权',
            inclusion6: '免费停车及附近景点接送服务',

            amenityGroup1Title: '客房特色',
            amenityGroup1Item1: '38平方米空间',
            amenityGroup1Item2: '带座椅的私人阳台',
            amenityGroup1Item3: '独立控制空调',
            amenityGroup1Item4: '客房保险箱',

            amenityGroup2Title: '浴室体验',
            amenityGroup2Item1: '冷热水花洒淋浴',
            amenityGroup2Item2: '高级浴室用品',
            amenityGroup2Item3: '吹风机',
            amenityGroup2Item4: '柔软浴袍与拖鞋',

            amenityGroup3Title: '客房舒适',
            amenityGroup3Item1: '55英寸带有线电视的智能电视',
            amenityGroup3Item2: '咖啡与茶水站',
            amenityGroup3Item3: '直拨电话',

            amenityGroup4Title: '连接',
            amenityGroup4Item1: '免费Wi-Fi',
            amenityGroup4Item2: '工作桌',
            amenityGroup4Item3: '24/7前台支持',

            inRoomEssentials: '客房必备',
            everythingYouNeed: '让您感到宾至如归的一切',
            inRoomEssentialsDesc: '从无缝连接到精心挑选的饮品——豪华河景房将休闲与实用完美结合，让您专注于重要时刻。',

            complimentaryWifi: '免费Wi-Fi',
            coffeeTeaStation: '咖啡与茶水站',
            roomService: '24小时客房服务',
            rainShower: '花洒淋浴',

            byTheRiver: '河畔',
            slowDownBreathe: '放慢脚步，呼吸新鲜空气',

            readyToStay: '准备入住了吗？',
            reserveDeluxeRiverViewToday: '今天预订豪华河景房',
            speakReservations: '与我们的预订团队联系，获取最佳房价和特别优惠。',
            checkAvailability: '查看房况'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: '您的圣所已为您准备好',
            heroSubtitle: '河畔圣所，专为疗愈、恢复和沿宁静Bentota河的深刻平静而设计。',
            exploreRooms: '探索我们的客房',

            filterAll: '全部',
            filterDeluxeRooms: '豪华房',
            filterRiverViewDeluxe: '豪华河景房',

            deluxeRoomName: '豪华房',
            deluxeRoomCategory: '豪华房',
            deluxeRoomDesc: '和谐平衡的客房，采用天然木质元素和河景，带来完美宁静。',

            riverViewDeluxeName: '河景豪华房',
            riverViewDeluxeCategory: '豪华河景房',
            riverViewDeluxeDesc: '在河水的轻柔声中醒来，享有宽阔的河景，在这间优雅设计的豪华房中感受宁静。',

            noRoomsFound: '此类别中未找到客房。',
            roomSize: '客房面积',
            guests: '宾客',
            amenitiesCount: '设施',
            roomAmenities: '客房设施',
            specialFeatures: '特别特色',

            kingSizeBed: '特大床',
            workDesk: '工作桌',
            rainShower: '花洒淋浴',
            teaStation: '茶水站',
            privateTerrace: '私人露台',
            binoculars: '望远镜',

            riverView: '河景',
            naturalLighting: '自然光',
            gardenView: '花园景观',
            sunriseBalcony: '日出阳台',
            soundOfRiver: '河水声',

            bookNow: '立即预订',
            viewDetails: '查看详情',
            viewRoom: '查看客房',

            allRoomsInclude: '所有客房均包含',
            essentialComforts: '您的养生之旅基本舒适设施',

            highSpeedWifi: '高速Wi-Fi',
            herbalTea: '草本茶精选',
            climateControl: '空调控制',
            organicToiletries: '有机洗浴用品',
            dailyHousekeeping: '每日客房清洁',
            concierge: '24/7礼宾服务',
            yogaMat: '瑜伽垫及配件',

            beginHealing: '开启您的疗愈之旅',
            beginHealingDesc: '在宁静的河畔环境中体验正宗阿育吠陀养生，滋养身体、平静心灵、恢复精神。',
            reserveRoom: '预订客房',
            speakAdvisor: '与养生顾问交谈',

            exploreOurRooms: '探索我们的客房'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: '豪华房 — 带露台或私人阳台的舒适',
            heroSubtitle: '在宁静的河畔隐居处放松身心，受Bentota宁静河水的启发，融合现代设施与轻柔的河风。',
            bookThisRoom: '预订此房',
            callReservations: '致电预订',

            navAll: '全部',
            navDeluxe: '豪华',
            navRiverViewDeluxe: '豪华河景房',

            soothingHideawayTitle: '宁静的河畔隐居',
            soothingHideawayDesc: '豪华房专为悠闲的清晨和日落打造。柔和的中性色调、宽敞的玻璃窗和精心设计的照明让河景融入室内，而阳台则成为您俯瞰流水的小天地。',

            highlight1Title: '全景河景',
            highlight1Desc: '从您的私人阳台醒来，欣赏宁静的河景与热带日出。',
            highlight2Title: '优雅河畔室内',
            highlight2Desc: '柔和的中性色调、温暖的木质元素和充足的自然光。',
            highlight3Title: '宁静睡眠体验',
            highlight3Desc: '豪华king-size床配以高级床品，带来恢复性睡眠。',

            atAGlance: '一览',
            statSizeLabel: '面积',
            statViewLabel: '景观',
            statViewValue: '河景',
            statGuestsLabel: '入住人数',
            statBedLabel: '床型',
            statBedValue: 'King或双人',
            reserve: '预订',

            includedWithStay: '入住包含',
            thoughtfulTouches: '贴心细节，全天舒适',
            enhancedCleanliness: '提升的清洁与安全标准',

            inclusion1: 'Breeze餐厅免费早餐、午餐、晚餐',
            inclusion2: '客房高速Wi-Fi和工作区',
            inclusion3: '24小时客房服务与礼宾服务',
            inclusion4: '每日客房清洁及晚间整理服务',
            inclusion5: '无边泳池及阿育吠陀水疗设施使用权',
            inclusion6: '免费停车及附近景点接送服务',

            amenityGroup1Title: '客房特色',
            amenityGroup1Item1: '41平方米空间',
            amenityGroup1Item2: '带座椅的私人阳台',
            amenityGroup1Item3: '独立控制空调',
            amenityGroup1Item4: '客房保险箱',

            amenityGroup2Title: '浴室体验',
            amenityGroup2Item1: '冷热水花洒淋浴',
            amenityGroup2Item2: '高级浴室用品',
            amenityGroup2Item3: '吹风机',
            amenityGroup2Item4: '柔软浴袍与拖鞋',

            amenityGroup3Title: '客房舒适',
            amenityGroup3Item1: '55英寸带有线电视的智能电视',
            amenityGroup3Item2: '咖啡与茶水站',
            amenityGroup3Item3: '直拨电话',

            amenityGroup4Title: '连接',
            amenityGroup4Item1: '免费Wi-Fi',
            amenityGroup4Item2: '工作桌',
            amenityGroup4Item3: '24/7前台支持',

            inRoomEssentials: '客房必备',
            everythingYouNeed: '让您感到宾至如归的一切',
            inRoomEssentialsDesc: '从无缝连接到精心挑选的饮品——豪华房将休闲与实用完美结合，让您专注于重要时刻。',

            complimentaryWifi: '免费Wi-Fi',
            coffeeTeaStation: '咖啡与茶水站',
            roomService: '24小时客房服务',
            rainShower: '花洒淋浴',

            byTheRiver: '河畔',
            slowDownBreathe: '放慢脚步，呼吸新鲜空气',

            readyToStay: '准备入住了吗？',
            reserveDeluxeToday: '今天预订豪华房',
            speakReservations: '与我们的预订团队联系，获取最佳房价和特别优惠。',
            checkAvailability: '查看房况'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: '河畔阿育吠陀',
            heroTagline: '在Aluthgama找到平衡、轻松呼吸并焕发能量',
            exploreResort: '探索度假村',
            bookNow: '立即预订',

            welcomeLabel: '欢迎',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Muthumuni Ayurveda River Resort坐落在宁静的Bentota河畔，将古老的阿育吠陀疗愈传统与自然宁静之美完美融合。我们的圣地邀您开启一段变革性的养生之旅，让河水的轻柔流动与阿育吠陀的永恒智慧相遇。',
            welcomeDesc2: '体验个性化的阿育吠陀疗法，品尝专为平衡您的体质而设计的营养美食，在享有壮丽河景的优雅客房中放松身心。无论您追求焕活、放松还是灵性更新，我们的阿育吠陀从业者和养生专家团队将全程陪伴指导。',
            learnMore: '了解更多',
            contactUs: '联系我们',
            welcomeImageCaption: '阿育吠陀养生与河畔静修',
            welcomeImageLocation: 'Aluthgama, 斯里兰卡',

            highlightTitle: '河畔阿育吠陀圣地',
            highlightDesc: '沿着Bentota宁静的河畔探索整体疗愈。从量身定制的疗法到安静的阳台和正念美食，每一个细节都旨在恢复您的自然节奏。',

            roomsTitle: '我们的客房',
            roomsDesc: '选择与您节奏相匹配的圣所，从通风套房到温馨豪华藏身之处，每一间都配备柔软床品、温暖木质元素和迎接日出的阳台。',
            room1Title: '豪华房',
            room1Desc: '舒适的避风港，配备豪华床品、花园景观和温暖木质装饰，带来日常的轻松。',
            room2Title: '豪华河景房',
            room2Desc: '在宁静的河景中醒来，柔软的床单和私人阳台专为平和的清晨设计。',
            viewRoom: '查看客房',
            bookableNow: '可立即预订',
            riverBreezeReady: '河风已备',
            roomBadge: '河畔逃逸',

            achievementsTitle: '河畔值得信赖的养生',
            achievement1Title: '满意宾客',
            achievement1Count: '1,000+',
            achievement2Title: '阿育吠陀疗程',
            achievement2Count: '20+',
            achievement3Title: '年养生卓越',
            achievement3Count: '15+',
            achievement4Title: '旅行者赞誉',
            achievement4Count: '1,000+',

            experiencesTitle: '探索Muthumuni Ayurveda River Resort体验',
            experiencesDesc: '从阿育吠陀之旅到精选短途游，选择让您的住宿难忘的体验。',
            planYourStay: '规划您的住宿',
            experience1Title: '我们的客房',
            experience1Desc: '通风的空间配有阳台，可欣赏河景或园景，配备周到的舒适设施，让您悠然度日。',
            experience2Title: '阿育吠陀水疗',
            experience2Desc: '正宗疗法、蒸汽浴和恢复性按摩，以古老仪式呈现。',
            experience3Title: '河畔用餐',
            experience3Desc: '营养丰富的斯里兰卡及国际美食，专为滋养身心而设计。',
            experience4Title: '体验与短途游',
            experience4Desc: 'Bentota河游船、寺庙参观、水上运动以及Bentota周边的文化短途游。',

            galleryTitle: 'Muthumuni Ayurveda River Resort的瞬间',
            galleryDesc: '一瞥我们的河畔圣地——日出、宁静疗法、滋养美食和专为您打造的安静角落。',
            gallery1Alt: 'Muthumuni河畔阳光棕榈树',
            gallery2Alt: '阿育吠陀油疗进行中',
            gallery3Alt: '度假村泳池与躺椅',
            gallery4Alt: '水疗准备的草本原料',
            gallery5Alt: '情侣在河边欣赏日落',
            gallery6Alt: '面向河流的瑜伽平台',
            gallery7Alt: '热带花园小径',
            gallery8Alt: '健康早餐拼盘',
            gallery9Alt: '宁静的河畔景观',
            gallery10Alt: '黄昏时温暖灯光的度假村外观',
            gallery11Alt: '阿育吠陀草药与油品展示',
            gallery12Alt: '花园旁的舒适座位',

            boatLabel: '河上冒险',
            boatTitle: 'Bentota河游船',
            boatDesc1: '通过我们迷人的游船体验Bentota河的魔力。滑行于宁静水道，周围环绕茂密的红树林，可观赏到色彩斑斓的翠鸟、鳄鱼、巨蜥和顽皮的猴子。非常适合热爱自然和摄影的客人，捕捉难忘瞬间。',
            boatDesc2: '无论您选择清晨的宁静游船、日落浪漫之旅还是冒险的野生动物探索，我们经验丰富的导游将分享关于河流生态的有趣知识。您可通过私人包船定制体验，或加入团体游以更亲近自然。',
            boatFeature1: '穿越红树林的风景游船',
            boatFeature2: '野生动物观察——鸟类、鳄鱼与猴子',
            boatFeature3: '日出与日落游船选项',
            boatFeature4: '经验丰富的本地导游包含',
            boatImageAlt: 'Bentota河游船',

            poolLabel: '水上宁静',
            poolTitle: '泳池区',
            poolDesc1: '在我们纯净的无边泳池中沉浸于宁静，清澈的水面与郁郁葱葱的热带花园交相辉映。专为放松与焕活而设计，泳池区为您提供在斯里兰卡阳光下舒缓身心的完美逃逸。',
            poolDesc2: '无论您喜欢清晨的清爽游泳、下午捧书慵懒时光，还是夜晚宁静的浸泡，我们的泳池区都提供理想的环境。周围环绕舒适的日光躺椅、遮阳小屋和贴心的泳池服务，每一刻都成为珍贵的回忆。',
            poolFeature1: '温控无边泳池',
            poolFeature2: '环绕热带花园景观',
            poolFeature3: '泳池边饮品与健康小食',
            poolFeature4: '高级日光躺椅配遮阳伞',
            poolImageAlt: '放松泳池区',

            testimonialsTitle: '客人的入住体验',

            bookingDestination: '目的地',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: '入住',
            bookingCheckOut: '退房',
            bookingGuests: '宾客',
            guestsOption1: '1位宾客',
            guestsOption2: '2位宾客',
            guestsOption3: '3位宾客',
            guestsOption4: '4位及以上宾客',
            bookingCheckAvailability: '查看房况',

            service1Title: '整体阿育吠陀疗法',
            service1Desc: '个性化咨询、正宗草药油，由经验丰富的阿育吠陀医生指导的每日疗程。',

            service2Title: '河畔客房',
            service2Desc: '在河水的轻柔声中醒来，享有私人阳台和专为深度休息设计的宁静室内环境。',

            service3Title: '养生美食',
            service3Desc: '新鲜斯里兰卡食材、以植物为主的菜单，以及根据您的体质量身定制的餐食计划。',

            service4Title: '瑜伽与正念',
            service4Desc: '日出瑜伽、日落冥想和呼吸练习，在河流的节奏中进行。',

            service5Title: '河畔与海岸短途游',
            service5Desc: 'Bentota河游船、海龟孵化场参观、香料园漫步以及乡村自行车游。'
        },
        aboutus2: {
            heroTitle: '关于我们',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: '古老智慧与宁静河畔美景在Muthumuni Ayurveda River Resort相遇',
            heroTagline2: '个性化阿育吠陀疗法、河景与真正的斯里兰卡热情款待',
            slide1: '阿育吠陀疗愈',
            slide2: '河畔宁静',
            slide3: '花园宁静',
            slide4: '草本疗法',
            slide5: '河畔养生',
            historyLabel: '我们的历程',
            historyTitle: 'Muthumuni Ayurveda River Resort的历史',
            historyDesc1: 'Muthumuni Ayurveda River Resort成立于二十多年前，源于一个愿景：打造一个古老阿育吠陀智慧与斯里兰卡宁静河畔风光交融的圣地。从最初的简朴养生静修之地，发展成为阿卢特加马最受珍视的整体疗愈与焕活目的地之一。',
            historyDesc2: '我们的创始人深受几代传统阿育吠陀从业者的启发，希望在提供现代舒适与正宗斯里兰卡款待的同时，传承这些永恒的疗愈艺术。多年来，我们始终坚守对真实养生体验的承诺，不断扩展设施，却从未忘记定义我们传承的个性化关怀。',
            historyDesc3: '如今，Muthumuni已成为阿育吠陀持久力量的见证，已接待来自世界各地的数千位客人。每一位访客都成为我们故事的一部分，在这片宁静的河畔天堂中找到平衡、疗愈与蜕变。',
            statYear: '15+',
            statYearLabel: '年养生卓越',
            statGuest: '1,000+',
            statGuestLabel: '满意宾客',
            experienceLegacy: '体验我们的传承',
            established: '成立',
            sinceYear: '自1993年起',
            chairmanLabel: '主席寄语',
            chairmanTitle: '以关怀为指引，以阿育吠陀为根基',
            chairmanDesc1: '欢迎来到Muthumuni Ayurveda River Resort。二十多年来，我们的初心始终如一：以阿育吠陀永恒智慧为基础，提供真诚的疗愈，并以斯里兰卡的热情款待传递温暖。',
            chairmanDesc2: '在这里，从疗法到美食，再到空间的宁静，每一个细节都旨在帮助您放慢脚步、恢复平衡，并重新与自己连接。我们深感荣幸能成为您养生之旅的一部分。',
            chairmanDesc3: '谨代表我们敬业的团队，诚邀您来体验定义Muthumuni的关怀、真实与宁静。',
            chairmanBadge: '主席',
            chairmanName: 'Nihal Muthumuni 先生',
            chairmanSignature: '— Nihal Muthumuni 先生',
            chairmanImageAlt: '主席 Nihal Muthumuni 先生',
            staffLabel: '我们的团队',
            staffTitle: '认识我们敬业的团队',
            staffDesc1: '在Muthumuni Ayurveda River Resort，我们的团队是所有工作的核心。我们的员工经过精心挑选和专业培训，怀着对阿育吠陀养生和真诚款待的深厚热情。',
            staffDesc2: '从经验丰富的阿育吠陀从业者、技艺精湛的按摩师，到专注的款待团队，每位成员都将多年专业知识与真挚关怀带入与每一位客人的互动。我们相信，真正的养生不仅来自疗法，更来自那些真正关心您旅程的人的温暖与关注。',
            staffDesc3: '我们的团队持续接受最新阿育吠陀实践培训，同时保持最高的专业水准与文化敏感度。我们以建立与客人的深层联系为荣，确保每一次到访都成为难忘且具有转化意义的体验。',
            statStaff: '15+',
            statStaffLabel: '专业人才',
            statSatisfaction: '100%',
            statSatisfactionLabel: '宾客满意度',
            staffImageAlt: 'Muthumuni Ayurveda River Resort敬业团队',
            commitmentBadge: '我们的承诺',
            excellenceCare: '卓越与关怀',
            ctaLabel: '联系我们',
            ctaHeading: '准备好开启您的养生之旅了吗？',
            ctaDesc: '联系我们的团队，预订您专属的阿育吠陀静修之旅。无论您对疗法、住宿还是特别养生套餐有任何疑问，我们都乐意帮助您打造完美的逃离体验。',
            ctaButtonContact: '立即联系',
            ctaButtonRooms: '探索房型',
            quickInfoCall: '致电我们',
            quickInfoEmail: '发送邮件',
            quickInfoLocation: '位置',
            locationCity: 'Aluthgama, 斯里兰卡'
        },
        tours2: {
            heroTitle: '旅游与短途旅行',
            heroSubtitle: '从贝鲁沃拉探索斯里兰卡的美景',
            kandeAlt: '坎德维哈拉寺 - 贝鲁沃拉',
            kandeTitle: '坎德维哈拉寺参观',
            kandeBuddhaAlt: '坎德维哈拉寺巨型佛像',
            bentotaTitle: '本托塔河游船野生动物之旅',
            bentotaAlt: '本托塔河游船 - 红树林与野生动物',
            galleTitle: '加勒老城游览',
            galleAlt: '加勒老城游览',
            sigiriyaTitle: '锡吉里耶岩石堡垒游览',
            sigiriyaAlt: '锡吉里耶岩石堡垒游览',
            kandyTitle: '康提文化之旅',
            kandyAlt: '康提文化之旅',
            bookTour: '预订此行程',
            introPara1: '斯里兰卡是一片永恒美丽的土地，金色沙滩、郁郁葱葱的绿色景观、古老寺庙和充满活力的文化在这里完美融合。',
            introPara2: '从宁静的西南海岸到历史名城、圣地、野生动物保护区和雾气缭绕的山地，每一次旅程都带来独特而难忘的体验。',
            introPara3: '从贝鲁沃拉的Muthumuni Ayurveda Beach Resort出发，我们精心策划的旅游和短途旅行旨在丰富您的住宿，完美平衡探索、放松与健康养生。',
            kandeDetail1: '坎德维哈拉寺（Kande Viharaya）——贝鲁沃拉附近最具标志性的佛教寺庙之一。',
            kandeDetail2: '建于1734年，这座宁静的“山寺”坐落在山丘顶端，可俯瞰海岸线的宁静美景。',
            kandeDetail3: '亮点包括48米（160英尺）高的巨型坐佛像（斯里兰卡最高之一）、康提时期的精美壁画、古老舍利塔、美丽的月石入口以及超过300年的神圣菩提树。',
            kandeDetail4: '完美的半日灵性与文化体验——建议早晨游览以避开高温。',
            bentotaDetail1: '享受沿本托塔河的宁静而风景如画的游船野生动物之旅，这是贝鲁沃拉附近最受欢迎的自然短途旅行之一。',
            bentotaDetail2: '穿梭于茂密的红树林、狭窄水道和宁静的内湾，同时观赏当地野生动物。',
            bentotaDetail3: '常见动物包括巨蜥、鳄鱼、多种鸟类（翠鸟、鹭、鹰）、猴子，偶尔还能看到水獭或水蛇。',
            bentotaDetail4: '经验丰富的船夫/导游会为您介绍有趣的植物、传统捕鱼方式以及河边村庄的生活。',
            bentotaDetail5: '非常适合热爱自然和摄影的人——宁静、放松，与您的阿育吠陀养生之旅完美搭配。',
            galleDetail1: '探索历史悠久的加勒堡，联合国教科文组织世界遗产，也是斯里兰卡保存最完好的殖民时期堡垒之一。',
            galleDetail2: '漫步于铺着鹅卵石的街道，两旁是荷兰殖民建筑、精品店、咖啡馆和艺术画廊。',
            galleDetail3: '参观主要地标：加勒灯塔、荷兰归正会教堂、国家海事博物馆以及拥有壮丽海景的城墙。',
            galleDetail4: '通过知识渊博的导游了解堡垒丰富的历史、建筑和文化意义。',
            galleDetail5: '非常适合历史爱好者、文化爱好者以及想体验斯里兰卡殖民历史的人。',
            sigiriyaDetail1: '探索古老的锡吉里耶岩石堡垒，斯里兰卡最具标志性的地标之一，也是联合国教科文组织世界遗产。',
            sigiriyaDetail2: '攀登令人印象深刻的岩石，探索卡西亚帕国王宫殿的遗迹，饰有壁画、水景花园和著名的镜墙。',
            sigiriyaDetail3: '从山顶欣赏周围丛林和乡村的全景。',
            sigiriyaDetail4: '通过专业导游了解锡吉里耶引人入胜的历史、建筑和传说。',
            sigiriyaDetail5: '非常适合历史爱好者、冒险者和对斯里兰卡丰富文化遗产感兴趣的人。',
            kandyDetail1: '体验康提的活力文化，斯里兰卡最后的皇家首都，也是联合国教科文组织世界遗产。',
            kandyDetail2: '参观神圣之牙寺（Sri Dalada Maligawa），世界上最重要的佛教圣地之一。',
            kandyDetail3: '游览佩拉德尼亚皇家植物园，拥有大量热带植物和兰花收藏。',
            kandyDetail4: '观看传统的康提舞蹈表演，展示斯里兰卡丰富的艺术遗产。',
            kandyDetail5: '非常适合文化爱好者、历史爱好者和希望深入体验斯里兰卡传统的人。'
        },
        yoga2: {
            heroTitle: '度假村瑜伽',
            heroSubtitle: '在贝鲁沃拉找到平衡、力量与内在平静',
            heroAlt: 'Muthumuni度假村瑜伽',
            importanceEyebrow: '健康与平衡',
            importanceTitle: '瑜伽与冥想的重要性',
            importanceImageAlt: '瑜伽与冥想的重要性',
            importanceText1: '瑜伽与冥想是古老的修行方式，为身体、心理和情绪带来诸多益处。它们促进柔韧性、力量与平衡，同时减轻压力和焦虑。',
            importanceText2: '定期练习能提升专注力、改善睡眠质量并促进整体幸福感。瑜伽还鼓励正念，帮助人们与内在自我连接，在日常生活的喧嚣中找到平静。',
            importanceText3: '在Muthumuni度假村，我们提供宁静的环境，非常适合练习瑜伽与冥想，让客人焕发身心灵魂的活力。',
            practiceEyebrow: '我们的练习',
            practiceTitle: '瑜伽练习与体验',
            practiceImageAlt: '度假村瑜伽练习',
            practiceText1: '在Muthumuni度假村，我们主要练习传统哈他瑜伽（Hatha Yoga），结合调息法（Pranayama）。这种整体方法旨在唤醒内在觉知，温和地激活昆达里尼（Kundalini），同时特别注重脊柱对齐与柔韧性。',
            practiceText2: '瑜伽课程定期举行，适合初学者和有经验的练习者。不定期还会推出特殊课程，例如阿斯汤加瑜伽（Ashtanga Yoga）。',
            practiceText3: '所有瑜伽课程都在我们专属的瑜伽厅（Yoga Shala）进行，这是一个宁静祥和的空间，专为专注、平衡与正念运动而设计。每节课通常以太阳礼拜开始，随后进行调息练习，并安排精心挑选的体式序列，以提升柔韧性和血液循环。',
            practiceText4: '我们经验丰富的瑜伽老师会根据每位客人的个人需求、能力与健康状况调整课程，确保安全且深具疗愈效果的体验。',
            spiritualEyebrow: '灵性之旅',
            spiritualTitle: '冥想与灵性活动',
            spiritualSubtitle: '通过我们的神圣仪式与引导冥想课程，深化您的灵性修行',
            meditationImageAlt: '度假村冥想与灵性修行',
            meditationTitle: '冥想课程',
            meditationDesc: '诚邀客人参与受传统启发的引导冥想课程。这些课程旨在平静心灵、深化觉知，并在安宁的环境中支持情感与灵性疗愈。'
        },
        ayurveda2: {
            accordionTitle1: '什么是潘查卡玛（Panchakarma）阿育吠陀？',
            accordionDesc1: '阿育吠陀（梵语意为“生命科学”）是一种古老的全身整体疗愈体系。潘查卡玛是一系列净化与恢复疗法，旨在恢复身心灵之间的平衡。',
            accordionTitle2: '潘查卡玛阿育吠陀与您的生命能量',
            accordionDesc2: '潘查卡玛专注于清除体内毒素并重新建立三体质（Vata、Pitta、Kapha）的和谐。每位客人的治疗方案均个性化定制，以支持持久的健康与活力。',
            accordionTitle3: 'Vata体质',
            accordionDesc3: 'Vata主宰运动与循环。平衡时促进创造力与活力。潘查卡玛提供接地疗法来舒缓过多的Vata，恢复平衡。',
            accordionTitle4: 'Pitta体质',
            accordionDesc4: 'Pitta主宰消化与新陈代谢。冷却、恢复性疗法有助于平衡Pitta，减少炎症与易怒。',
            accordionTitle5: 'Kapha体质',
            accordionDesc5: 'Kapha提供结构与稳定性。激发活力与促进循环的疗法用于减少过多的Kapha，提升轻盈感与柔韧性。',
            close: '关闭',
            next: '下一页',
            previous: '上一页',
            treatmentsTitle: '我们的招牌潘查卡玛阿育吠陀疗法',
            treatmentsSubtitle: '传统疗法，用于排毒、焕活与恢复平衡。',
            bookTreatment: '预订此疗程',
            benefitsTitle: '潘查卡玛疗法的益处',
            shirodhara: '头部油流疗法（Shirodhara）',
            shirodharaDesc: '温热的草药油轻轻浇注于额头，平静心神。',
            shirodhara1: '减轻压力与焦虑',
            shirodhara2: '促进更好睡眠',
            shirodhara3: '提升精神清晰度',
            steamBath: '蒸汽浴',
            steamBathDesc: '排毒蒸汽疗法，打开毛孔并放松肌肉。',
            steamBath1: '排出体内毒素',
            steamBath2: '改善血液循环',
            steamBath3: '缓解肌肉紧张',
            flowerBath: '花瓣浴',
            flowerBathDesc: '芳香花瓣浸泡浴，带来深度放松。',
            flowerBath1: '舒缓神经系统',
            flowerBath2: '滋润肌肤',
            flowerBath3: '提升心情',
            headMassage: '头部按摩',
            headMassageDesc: '针对头皮的放松按摩，缓解紧张。',
            headMassage1: '减轻头痛',
            headMassage2: '改善头皮健康',
            headMassage3: '促进放松',
            faceMassage: '面部按摩',
            faceMassageDesc: '焕活面部光彩并缓解压力的按摩。',
            faceMassage1: '改善肤色',
            faceMassage2: '减少面部紧张',
            faceMassage3: '促进淋巴排毒',
            neckMassage: '颈部按摩',
            neckMassageDesc: '专注缓解颈部僵硬与紧张的按摩。',
            neckMassage1: '缓解颈部疼痛',
            neckMassage2: '提升灵活性',
            neckMassage3: '减轻压力',
            shoulderMassage: '肩部按摩',
            shoulderMassageDesc: '针对肩部僵硬与不适的重点按摩。',
            shoulderMassage1: '减轻肩部疼痛',
            shoulderMassage2: '改善姿势',
            shoulderMassage3: '放松肌肉',
            bodyMassage: '全身按摩',
            bodyMassageDesc: '促进整体放松与健康的完整身体按摩。',
            bodyMassage1: '促进血液循环',
            bodyMassage2: '缓解肌肉酸痛',
            bodyMassage3: '促进放松',
            backMassage: '背部按摩',
            backMassageDesc: '针对背部疼痛与紧张的治疗性按摩。',
            backMassage1: '缓解背痛',
            backMassage2: '改善脊柱健康',
            backMassage3: '减轻压力',
            footMassage: '足部按摩',
            footMassageDesc: '舒缓足部疼痛并促进放松的按摩。',
            footMassage1: '改善血液循环',
            footMassage2: '减轻足部疲劳',
            footMassage3: '促进放松',
            purgative: '泻下疗法',
            purgativeDesc: '清除消化系统中多余Pitta与毒素的净化疗法。',
            purgative1: '清洁结肠',
            purgative2: '平衡Pitta体质',
            purgative3: '改善消化健康',
            nasalClearing: '鼻腔清洁',
            nasalClearingDesc: '治疗性鼻腔清洁，清除鼻窦并改善呼吸功能。',
            nasalClearing1: '清除鼻塞',
            nasalClearing2: '改善呼吸',
            nasalClearing3: '缓解鼻窦问题',
            powderMassage: '药粉按摩',
            powderMassageDesc: '使用草药粉末的去角质按摩，焕活并清爽肌肤。',
            powderMassage1: '去除死皮',
            powderMassage2: '改善肤质',
            powderMassage3: '促进血液循环',
            intensiveMassageDesc: '一种深层治疗按摩，针对慢性紧张和肌肉结节，采用坚定压力和专业技术。',
            intensiveMassage1: '缓解深层肌肉紧张',
            intensiveMassage2: '改善血液循环',
            intensiveMassage3: '减轻肌肉酸痛',
            thermoMassage: '热疗按摩',
            thermoMassageDesc: '使用加热的治疗性草药油进行温暖按摩，以增强放松和愈合效果。',
            thermoMassage1: '舒缓酸痛肌肉',
            thermoMassage2: '促进深度放松',
            thermoMassage3: '增强能量流动',
            synchronMassage: '同步按摩',
            synchronMassageDesc: '双人同步按摩，实现全身和谐与能量平衡分布。',
            synchronMassage1: '全身和谐',
            synchronMassage2: '平衡的能量流动',
            synchronMassage3: '深度放松体验',
            specialMassage: '特别按摩',
            specialMassageDesc: '根据您的具体健康需求和个人健康目标量身定制的按摩疗法。',
            specialMassage1: '个性化治疗',
            specialMassage2: '针对特定问题',
            specialMassage3: '定制化愈合方式',
            benefit1Title: '排毒：',
            benefit1Desc: '潘查卡玛疗法帮助清除体内毒素，促进整体健康与活力。',
            benefit2Title: '改善消化：',
            benefit2Desc: '这些疗法增强消化功能，提升营养吸收与新陈代谢。',
            benefit3Title: '减压：',
            benefit3Desc: '潘查卡玛以其平静身心的效果而闻名，可降低压力与焦虑水平。',
            benefit4Title: '增强免疫力：',
            benefit4Desc: '定期潘查卡玛疗法可强化免疫系统，使身体更能抵抗疾病。',
            benefit5Title: '焕活年轻：',
            benefit5Desc: '疗法促进细胞再生，改善皮肤健康，带来年轻容貌。',
            benefit6Title: '体质平衡：',
            benefit6Desc: '潘查卡玛帮助恢复体内的三体质（Vata、Pitta、Kapha）平衡，这是阿育吠陀健康原则的核心。',
            akkupancharTitle: '针灸疗法',
            akkupancharDesc1: '是一种古老的阿育吠陀疗法，涉及使用草药膏和油涂抹在身体的特定穴位上。这种治疗方法旨在刺激重要的能量通道并促进愈合。',
            akkupancharBenefit: '主要益处：',
            akkupancharDesc2: '这种专业疗法有助于缓解慢性疼痛、改善关节灵活性、增强血液循环并恢复身体的自然能量流动。对于寻求深度治疗性愈合和恢复活力的人特别有效。',
            akkupancharApplication: '治疗应用：',
            akkupancharDesc3: '针灸通过针对全身特定的马尔玛穴位（重要交汇点），使用精心挑选的草药制剂来平衡体质并促进最佳健康与养生。',
            akkupancharTransform: '体验蜕变：',
            akkupancharDesc4: '在Muthumuni Ayurveda River Resort，我们经验丰富的从业者会根据您独特的健康需求定制每次针灸疗程，确保深刻而持久的疗愈体验。',
            gallery1: '头部油流疗法',
            gallery2: '蒸汽浴',
            gallery3: '花瓣浴',
            gallery4: '头部按摩',
            gallery5: '全身按摩',
            gallery6: '颈部按摩',
            gallery7: '面部按摩',
            gallery8: '肩部按摩',
            sectionEyebrow: 'Muthumuni的潘查卡玛阿育吠陀',
            sectionDescription: '在我们的河畔静修之地体验古老的潘查卡玛阿育吠陀疗愈艺术。我们的专业阿育吠陀从业者提供个性化治疗，旨在排毒、焕活并恢复身心灵的平衡。',
            heroTitle: '潘查卡玛阿育吠陀',
            heroSubtitle: '在阿卢特加马焕活身心灵',
            heroAlt: 'Muthumuni River Resort的阿育吠陀与养生',
            treatmentProgramme: {
                title: '阿育吠陀治疗方案',
                subtitle: '您的平衡、排毒与深度更新之旅',
                intro: '在宁静的静修之地体验正宗的阿育吠陀疗愈，旨在恢复您的身体、平静您的心灵并更新您的能量。从您抵达的那一刻起，我们的团队就会处理每一个细节——这样您就可以完全专注于您的健康。',
                welcomeTitle: '欢迎与温和开始',
                welcome1: '机场接送至酒店',
                welcome2: '热情欢迎和酒店介绍',
                welcome3: '介绍您的每周健康日程',
                welcome4: '放松按摩（第1天）在阿育吠陀中心释放旅途疲劳并为治疗准备您的身体',
                doctorTitle: '医生咨询与个人计划',
                doctor1: '阿育吠陀医生咨询（第2天 – 上午）',
                doctor2: '全面评估您的体质/身体类型和健康问题',
                doctor3: '可根据要求提供翻译',
                doctor4: '您的医生根据您的需求和目标制定个性化治疗计划',
                dailyTitle: '每日阿育吠陀疗法',
                daily1: '每天4–5次治疗（根据医生建议）',
                daily2: '根据您的体质和身体状况选择的疗法',
                daily3: '必要时可添加特别按摩',
                daily4: '医生每天监测进展，可能会调整治疗和草药支持以确保最佳效果',
                daily5: '如适合，可能会建议温和的清洁/泻下过程',
                herbalTitle: '草药支持',
                herbalIntro: '医生开具的草药每天两次服用：',
                herbal1: '早餐期间',
                herbal2: '晚餐期间',
                herbalClosing: '支持内部疗愈、排毒和持久平衡。',
                yogaTitle: '瑜伽与冥想促进身心和谐',
                yoga1: '每周4次瑜伽课程（约1小时）',
                yoga2: '每周2次冥想课程：',
                yoga3: '——在岛屿寺庙的独特灵性体验，乘船前往',
                yoga4: '——由僧侣引导的冥想（约1小时）',
                wellnessTitle: '包含的健康体验',
                wellness1: '每周健康烹饪示范',
                wellness2: '免费游览（文化/自然体验）',
                closingTitle: '闭幕仪式与离开',
                closing1: '美丽的花瓣浴（最后一天）——传统的更新仪式',
                closing2: '最终医生咨询以审查进展并提供：',
                closing3: '——持续的健康指导',
                closing4: '——家用处方和建议',
                closing5: '送回机场',
            }
        },
        blogs2: {
            heroTitle: 'Muthumuni Ayurveda River Resort 博客',
            heroSubtitle1: '河畔故事，',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '的阿育吠陀仪式。深入了解实用建议、历史和幕后故事。',
            heroAlt: '度假村河畔步道日落景观',
            sectionTitle: 'Muthumuni Ayurveda River Resort 博客',
            sectionDescription: '来自我们河畔静修之地的指南、故事与笔记——涵盖阿育吠陀仪式、养生实践以及本托塔周边的旅行建议。',
            ayurvedaTitle: '正宗阿育吠陀的核心',
            ayurvedaExcerpt: '体验植根于斯里兰卡古老智慧的传统疗愈方式。',
            ayurvedaDescription: '在Muthumuni Ayurveda River Resort，阿育吠陀不仅仅是治疗，更是一种生活方式。我们的疗法基于数百年的知识，根据您的体质量身定制，由经验丰富的阿育吠陀医生指导，带来深层而持久的平衡。',
            ayurvedaAlt: '草药油与天然元素的阿育吠陀治疗场景',
            healingTitle: '个性化疗愈之旅',
            healingExcerpt: '为什么每位客人的养生计划都独一无二。',
            healingDescription: '从初次咨询到每日疗程，您的疗愈之旅都经过精心设计。草药疗法、治疗性按摩、瑜伽和冥想共同作用，恢复身心灵的和谐。',
            healingAlt: '阿育吠陀医生在宁静环境中为客人咨询',
            natureTitle: '河畔疗愈',
            natureExcerpt: '宁静的河景与热带环境如何提升您的健康体验。',
            natureDescription: '坐落于斯里兰卡宁静的河畔，Muthumuni提供天然的疗愈环境。河流的轻柔流动、清新空气和郁郁葱葱的绿意增强了阿育吠陀的效果，带来深度放松与焕新。',
            natureAlt: '度假村河畔景观，棕榈树与自然风光',
            foodTitle: '阿育吠陀饮食促进内在平衡',
            foodExcerpt: '专为支持治疗而设计的营养餐点。',
            foodDescription: '我们的阿育吠陀美食每天使用当季本地食材新鲜烹制。每餐都与您的体质（dosha）相匹配，支持消化、排毒和整体活力，同时保持美味与满足感。',
            foodAlt: '传统阿育吠陀餐点盛于天然碗中',
            yogaTitle: '瑜伽、冥想与内在宁静',
            yogaExcerpt: '舒缓心智、强健身体的温和练习。',
            yogaDescription: '每日瑜伽与冥想课程补充您的治疗，提升柔韧性、呼吸和精神清晰度。这些正念练习帮助您重新连接自我，并将平静感带回家。',
            yogaAlt: '客人在日出时面向河流练习瑜伽',
            lifestyleTitle: '将阿育吠陀带回家',
            lifestyleExcerpt: '延续养生之旅的简单生活习惯。',
            lifestyleDescription: '离店前，我们的专家将指导您通过日常习惯、饮食和自我关怀仪式来维持平衡。带回的不仅是回忆，更是通往更健康生活的可持续方式。',
            lifestyleAlt: '客人在宁静的度假村环境中享用草本茶放松',
            readMore: '阅读更多'
        },
        events2: {
            heroEyebrow: '体验与活动',
            heroTitle: '我们的活动',
            heroSubtitle: '融合斯里兰卡传统与海滨奢华的精选体验',
            heroAlt: 'Muthumuni的活动',
            availableDaily: '每日开放',
            bookNow: '立即预订',
            highlightsTitle: '亮点',
            detailAlt: '{{title}} 详情',
            ctaTitle: '准备好创造回忆了吗？',
            ctaDescription: '联系我们的团队，在Muthumuni Ayurveda Beach Resort定制您完美的活动体验',
            ctaContact: '联系我们',
            ctaViewRooms: '查看房型',
            cookeryTitle: '烹饪课程',
            cookerySubtitle: '斯里兰卡风味',
            cookeryDescription: '沉浸在斯里兰卡美食的鲜活风味中。我们的专业厨师将带您参与实操烹饪课程，教授代代相传的传统食谱。学习使用新鲜本地食材制作香浓咖喱、薄饼、椰子桑博等经典菜肴。',
            cookeryHighlight1: '传统斯里兰卡食谱',
            cookeryHighlight2: '亲手烹饪体验',
            cookeryHighlight3: '新鲜本地食材',
            cookeryHighlight4: '带走食谱',
            cookeryHighlight5: '包含香料园参观',
            meditationTitle: '冥想课程',
            meditationSubtitle: '内在平静与正念',
            meditationDescription: '在印度洋宁静背景下的引导冥想课程中寻找平静。我们的资深导师将带领您学习古老的正念技巧、呼吸练习和瑜伽，帮助平静心灵、焕发精神。',
            meditationHighlight1: '日出与日落时段',
            meditationHighlight2: '海滩冥想',
            meditationHighlight3: '专业导师指导',
            meditationHighlight4: '呼吸技巧',
            meditationHighlight5: '瑜伽与正念练习',
            bbqTitle: '烧烤派对',
            bbqSubtitle: '海滩庆典',
            bbqDescription: '在海滩烧烤派对中享受难忘的夜晚。品尝新鲜烤海鲜、优质肉类和素食美食，海浪轻声伴奏。现场音乐、火焰舞者和星空营造出完美的庆祝与联结氛围。',
            bbqHighlight1: '新鲜烤海鲜',
            bbqHighlight2: '海滨用餐',
            bbqHighlight3: '现场娱乐',
            bbqHighlight4: '篝火体验',
            bbqHighlight5: '可定制菜单',
            boatTitle: '乘船游览',
            boatSubtitle: '河流与海岸冒险',
            boatDescription: '沿着本托塔河和海岸水域展开迷人的船上之旅。穿越红树林，观赏奇异鸟类与野生动物，或享受浪漫的日落游船。我们的乘船体验为您带来斯里兰卡自然美景与多样生态系统的独特视角。',
            boatHighlight1: '本托塔河游船',
            boatHighlight2: '红树林探索',
            boatHighlight3: '野生动物观察',
            boatHighlight4: '日落船游',
            boatHighlight5: '提供私人包船',
            ayurvedaLecturesTitle: '阿育吠陀医生讲座',
            ayurvedaLecturesSubtitle: '古老智慧与现代养生',
            ayurvedaLecturesDescription: '通过认证阿育吠陀医生与从业者的专业讲座，深入了解阿育吠陀的深刻原理。学习体质（dosha）平衡、草药疗法、整体疗愈方法，以及古老智慧如何应用于现代健康生活。互动课程让阿育吠陀哲学清晰易懂并可融入日常生活。',
            ayurvedaLecturesHighlight1: '认证阿育吠陀医生',
            ayurvedaLecturesHighlight2: '个性化体质分析',
            ayurvedaLecturesHighlight3: '草药知识教育',
            ayurvedaLecturesHighlight4: '包含问答环节',
            ayurvedaLecturesHighlight5: '带回家养生指南',
            traditionalClothsTitle: '传统服饰穿着活动',
            traditionalClothsSubtitle: '文化遗产体验',
            traditionalClothsDescription: '通过学习穿戴和欣赏传统服饰，沉浸于斯里兰卡文化遗产。我们的专业造型师将指导您穿上正宗康提纱丽和传统服装，并讲解每件服饰的文化意义。非常适合特别场合、文化体验或拍摄难忘照片。',
            traditionalClothsHighlight1: '专业造型指导',
            traditionalClothsHighlight2: '正宗传统纱丽',
            traditionalClothsHighlight3: '文化意义讲解',
            traditionalClothsHighlight4: '包含专业摄影',
            traditionalClothsHighlight5: '时尚融合工作坊'
        },
        food2: {
            heroTitle: '阿育吠陀餐饮与海滨美食',
            heroSubtitle: '正宗斯里兰卡风味与新鲜海滨料理',
            heroAlt: 'Muthumuni海滩度假村的美食体验',
            wellnessEyebrow: '通过食物实现健康',
            wellnessTitle: '阿育吠陀',
            ayurvedicFood: '饮食的重要性',
            wellnessIntro1: '在阿育吠陀中，食物被视为最伟大的药物。你吃的食物直接影响你的体质（Vata、Pitta、Kapha）、消化力（agni）以及身心灵的整体平衡。',
            wellnessIntro2: '阿育吠陀营养强调新鲜、当季、完整的食物，以用心烹饪和正念进食。每餐都包含六种味道（甜、酸、咸、辣、苦、涩），滋养所有感官并保持和谐。',
            wellnessIntro3: '正确的阿育吠陀饮食能增强消化、帮助排出毒素（ama）、提升免疫力、增加能量、减轻压力并预防多种慢性疾病。在Muthumuni，每道菜都根据您的独特体质精心制作，促进深层疗愈与活力。',
            foodImage1Alt: '传统阿育吠陀餐点，包含六种味道',
            foodImage2Alt: '用于均衡营养的阿育吠陀草药与香料',
            culinaryPhilosophyEyebrow: '我们的烹饪哲学',
            culinaryPhilosophyTitle: '阿育吠陀',
            nutritionHighlight: '营养',
            culinaryPhilosophyResort: '在Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Muthumuni Ayurveda River Resort的阿育吠陀美食',
            freshNourishingLabel: '新鲜与滋养',
            healingIngredientsAlt: '健康阿育吠陀食材与香料',
            healingIngredientsLabel: '疗愈食材',
            philosophyText1: '食物包含六种主要味道（甜、酸、咸、苦、辣、涩）以及许多细微变化，在经典阿育吠陀文献中（部分可追溯至5000多年前）都有详细描述，并附带每种食物的基本属性：Guna（固有品质）、Virya（效力——加热或冷却）、Vipaka（消化后作用）和Prabhava（独特特殊作用）。',
            philosophyText2: '因此，阿育吠陀营养在Muthumuni Ayurveda Beach Resort中占据核心地位。这并不意味着单调、刻板的素食饮食，由医生强制规定。恰恰相反，我们的阿育吠陀厨房是我们最大的优势之一：技艺高超的厨师每天为您准备的菜肴都会带来惊喜与愉悦！',
            philosophyText3: '早餐提供丰富的自助餐，包括新鲜热带水果、现榨果汁、滋补草本汤、自制面包和轻盈饼干，以及多种正宗斯里兰卡早餐选择。午餐是色彩丰富、味道浓郁的自助餐，有温和的鱼咖喱、蔬菜料理和草本菜肴。晚餐供应固定素食菜单，可选择新鲜鱼类。周六我们举办“斯里兰卡之夜”，提供更丰富的自助餐——厨师当场为您烹制传统本地特色菜，营造生动而真实的体验。',
            philosophyText4: '在阿育吠陀中，食物和饮品根据味道、属性、消化能力（agni）、特定健康状况的适宜性、季节性等多种方式分类。在Muthumuni，我们同时考虑所有这些因素，并有意识地将六种味道以平衡组合的方式融入每位客人的个性化体质中。',
            philosophyText5: '我们的餐点使用新鲜蔬菜、热带水果和负责任来源的鱼类。不提供红肉或酒精。',
            philosophyText6: '用餐期间，始终有阿育吠陀医生或合格营养师为您提供指导。他们会根据您当前治疗阶段推荐最适合的蔬菜、草药和香料，并帮助您选择或避免某些菜品。您的个性化草本饮剂和健康中心团队的特别说明将放置在您的个人餐桌上。',
            philosophyText7: '这种个性化的关怀与对饮食的关注是Muthumuni Ayurveda Beach Resort体验的标志性特征。',
            philosophyText8: '食物被视为Prana——维持人类生命的重要能量。因此我们鼓励您以全然的觉知对待每一餐：品味香气、体验味道、感受温暖，并在正念中享受味蕾的愉悦。',
            diningExperienceEyebrow: '用餐体验',
            restaurantTitlePrefix: '我们的',
            ayurvedicHighlight: '阿育吠陀',
            restaurantTitleSuffix: '餐厅',
            restaurantDetail1: 'Muthumuni Beach Resort的阿育吠陀餐厅提供独特的用餐体验，将传统阿育吠陀原则与正宗斯里兰卡海滨美食完美融合。我们优先选用新鲜本地食材，打造既满足味蕾又促进整体健康的菜肴。',
            restaurantDetail2: '菜单经过精心设计，确保每道菜都平衡六种味道（甜、酸、咸、苦、辣、涩），带来滋养且令人满足的体验。每道菜都用心烹制，融入具有疗愈功效的阿育吠陀草药与香料。',
            restaurantDetail3: '客人可享用根据个人体质（dosha）量身定制的多样菜品，支持素食、纯素和鱼素饮食。厨师与阿育吠陀从业者紧密合作，确保每餐都支持客人的健康与养生目标。',
            restaurantDetail4: '餐厅氛围反映宁静的海滨环境，为正念用餐提供安宁的场所。无论享用丰盛早餐自助餐还是精致晚餐，我们的阿育吠陀餐厅每一次用餐都是滋养身心的机会。',
            restaurantDetail5: '欢迎来到Muthumuni Beach Resort的阿育吠陀餐厅，开启一场颂扬斯里兰卡丰富风味、拥抱阿育吠陀永恒智慧的美食之旅。',
            restaurantImageAlt: 'Muthumuni Ayurveda River Resort用餐场景',
            premiumDiningLabel: '高端餐饮',
            premiumDiningDescription: '在宁静的河畔环境中体验正宗阿育吠陀美食'
        },
        rooms: {
            heroTitle: '您的圣殿在等待',
            heroSubtitle: '精心设计的客房，专为治愈、恢复和深度平和而打造。',
            heroAlt: '木木尼阿育吠陀海滩度假村客房',
            exploreRooms: '探索我们的客房',
            filterAll: '全部',
            filterLuxurySuite: '豪华套房',
            filterDeluxeRooms: '豪华客房',
            filterDeluxeSeaView: '豪华海景客房',
            noRoomsFound: '该类别没有找到客房。',
            allRoomsInclude: '所有客房均包括',
            essentialComforts: '您的健康之旅的基本舒适设施',
            roomSize: '客房尺寸',
            guests: '客人',
            amenities: '便利设施',
            roomAmenities: '客房设施',
            specialFeatures: '特殊功能',
            bookNow: '立即预订',
            viewDetails: '查看详情',
            highSpeedWifi: '高速WiFi',
            herbalTea: '草本茶精选',
            climateControl: '气候控制',
            rainShower: '雨淋喷头',
            organicToiletries: '有机洗浴用品',
            dailyHousekeeping: '每日客房打扫',
            concierge: '24/7 礼宾服务',
            yogaMat: '瑜伽垫和配件',
            beginHealing: '开始您的治愈之旅',
            beginHealingDesc: '在一个旨在滋养您的身体、平静您的心灵和恢复您的精神的环境中体验真正的阿育吠陀健康。',
            reserveRoom: '预订客房',
            speakAdvisor: '与健康顾问交谈',
            exploreOurRooms: '探索我们的客房',
            viewRoom: '查看客房',
            luxurySuiteName: '豪华套房',
            luxurySuiteCategory: '豪华套房',
            luxurySuiteDesc: '在我们宽敞的豪华套房中体验终极宁静，采用传统阿育吠陀原则设计，拥有壮观的海景。',
            deluxeRoomName: '豪华客房',
            deluxeRoomCategory: '豪华客房',
            deluxeRoomDesc: '设计简洁的客房，采用天然木质元素和舒缓的水功能，营造完美的宁静。',
            seaViewDeluxeName: '豪华海景客房',
            seaViewDeluxeCategory: '豪华海景客房',
            seaViewDeluxeDesc: '在这间设计优雅的豪华客房中，醒来时吹着宁静的海风和全景海景。',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: '豪华客房 — 带露台或私人阳台的舒适体验',
                heroSubtitle: '在受到本托塔金色海滩启发的宁静海滨退居地中放松身心，将现代设施与温和的海风相结合。',
                bookThisRoom: '预订此客房',
                callReservations: '致电预订',
                navAll: '全部',
                navDeluxe: '豪华',
                navDeluxeSeaView: '豪华海景',
                navSuite: '套房',
                sectionTitle: '宁静的海滨隐藏地',
                sectionDesc: '豪华客房专为慢节奏的早晨和悠闲的日落而打造。柔和的中性色调、宽敞的玻璃和精心的照明将海景引入，而阳台则为您提供了自己的海岸观景台。',
                highlight1Title: '全景海滩景观',
                highlight1Desc: '从您的私人阳台醒来，欣赏蓝色海水和金色日出。',
                highlight2Title: '优雅的海滨内饰',
                highlight2Desc: '柔和的中性调色板、温暖的木材装饰和充足的自然光。',
                highlight3Title: '宁静的睡眠体验',
                highlight3Desc: '毛绒的特大号床和高端床上用品，为您提供恢复性休息。',
                atAGlance: '一览',
                statSize: '面积',
                statSizeValue: '41 平方米',
                statView: '景观',
                statViewValue: '印度洋',
                statGuests: '住客',
                statGuestsValue: '2 位成人',
                statBed: '床型',
                statBedValue: '特大号或双人',
                reserve: '预订',
                galleryAlt: '豪华客房画廊',
                inclusionsTitle: '您的住宿包括',
                inclusionsSubtitle: '体贴的细节，全天舒适',
                enhancedCleanliness: '加强的清洁和安全标准',
                inclusion1: 'Breeze 餐厅免费早餐、午餐、晚餐',
                inclusion2: '高速 Wi-Fi 和房间办公区',
                inclusion3: '24 小时客房服务和礼宾服务',
                inclusion4: '每日客房清洁和晚间整理',
                inclusion5: '使用无边泳池和阿育吠陀spa设施',
                inclusion6: '免费停车和往返附近景点的班车服务',
                amenityGroup1Title: '客房设施',
                amenityGroup1Item1: '41 平方米空间',
                amenityGroup1Item2: '带座位的私人阳台',
                amenityGroup1Item3: '带温度控制的空调',
                amenityGroup1Item4: '房间保险箱',
                amenityGroup2Title: '浴室体验',
                amenityGroup2Item1: '带冷热水的雨淋喷头',
                amenityGroup2Item2: '高端浴室用品',
                amenityGroup2Item3: '电吹风',
                amenityGroup2Item4: '柔软浴袍和拖鞋',
                amenityGroup3Title: '房间舒适',
                amenityGroup3Item1: '55英寸智能电视和有线电视',
                amenityGroup3Item2: '咖啡和茶站',
                amenityGroup3Item3: '直播电话',
                amenityGroup4Title: '连接性',
                amenityGroup4Item1: '免费 Wi-Fi',
                amenityGroup4Item2: '办公桌',
                amenityGroup4Item3: '24/7 前台支持',
                essentialsTitle: '房间必需品',
                essentialsHeading: '让您宾至如归的一切',
                essentialsDesc: '从无缝连接到精心选择的饮料，豪华客房融合了休闲和实用性，让您能够专注于重要的时刻。',
                essential1: '免费 Wi-Fi',
                essential2: '咖啡和茶站',
                essential3: '24/7 客房服务',
                essential4: '雨淋喷头',
                oceanTitle: '海边',
                oceanSubtitle: '放慢脚步，呼吸海洋空气',
                oceanAlt: '豪华客房座位区',
                ctaTitle: '准备好入住了吗？',
                ctaHeading: '今天就预订豪华客房',
                ctaDesc: '与我们的预订团队联系，了解最佳可用价格和特别优惠。',
                checkAvailability: '查询空房'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: '舒适与宁静的海滨魅力结合',
                bookThisRoom: '预订此客房',
                callReservations: '拨打预订电话',
                navAll: '全部',
                navDeluxe: '豪华房',
                navDeluxeSeaView: '豪华海景',
                navSuite: '套房',
                sectionTitle: '宁静的海滨隐藏地',
                sectionDesc: '豪华套房专为慢节奏的早晨和悠闲的日落而打造。柔和的中性色调、宽敞的玻璃和精心的照明将海景引入，而阳台则为您提供了自己的海岸观景台。',
                highlight1Title: '全景海滩景观',
                highlight1Desc: '从您的私人阳台醒来，欣赏蓝色海水和金色日出。',
                highlight2Title: '优雅的海滨内饰',
                highlight2Desc: '柔和的中性调色板、温暖的木材装饰和充足的自然光。',
                highlight3Title: '宁静的睡眠体验',
                highlight3Desc: '毛绒的特大号床和高端床上用品，为您提供恢复性休息。',
                atAGlance: '一览',
                statSize: '面积',
                statSizeValue: '41 平方米',
                statView: '景观',
                statViewValue: '印度洋',
                statGuests: '住客',
                statGuestsValue: '2 位成人',
                statBed: '床型',
                statBedValue: '特大号或双人',
                reserve: '预订',
                galleryAlt: '套房',
                inclusionsTitle: '包含在您的住宿中',
                inclusionsSubtitle: '周到的细节，全天舒适',
                enhancedCleanliness: '增强型清洁和安全标准',
                inclusion1: '微风餐厅免费早餐、午餐、晚餐',
                inclusion2: '高速 Wi-Fi 和客房工作间',
                inclusion3: '24 小时客房服务和礼宾部',
                inclusion4: '每日客房清洁和晚间转身服务',
                inclusion5: '进入无边泳池和阿育吠陀水疗设施',
                inclusion6: '免费停车和附近景点班车服务',
                amenityGroup1Title: '客房设施',
                amenityGroup1Item1: '41 平方米空间',
                amenityGroup1Item2: '带座位的私人阳台',
                amenityGroup1Item3: '空调和气候控制',
                amenityGroup1Item4: '房间保险箱',
                amenityGroup2Title: '浴室体验',
                amenityGroup2Item1: '冷热水雨淋喷头',
                amenityGroup2Item2: '高级沐浴用品',
                amenityGroup2Item3: '吹风机',
                amenityGroup2Item4: '柔软的浴衣和拖鞋',
                amenityGroup3Title: '客房舒适设施',
                amenityGroup3Item1: '55 英寸带有线电视的智能电视',
                amenityGroup3Item2: '咖啡和茶站',
                amenityGroup3Item3: '直拨电话',
                amenityGroup4Title: '连接性',
                amenityGroup4Item1: '免费 Wi-Fi',
                amenityGroup4Item2: '工作台',
                amenityGroup4Item3: '24/7 前台支持',
                essentialsTitle: '客房必需品',
                essentialsHeading: '家的温暖所需的一切',
                essentialsDesc: '从无缝连接到精心选择的饮料，豪华套房融合了休闲和实用性，让您能够专注于重要的时刻。',
                essential1: '免费 Wi-Fi',
                essential2: '咖啡和茶站',
                essential3: '24/7 客房服务',
                essential4: '雨淋喷头',
                oceanTitle: '海边',
                oceanSubtitle: '放慢脚步，呼吸海洋空气',
                oceanAlt: '海洋景观',
                ctaTitle: '准备好入住了吗？',
                ctaHeading: '今天就预订豪华套房',
                ctaDesc: '与我们的预订团队联系，了解最佳可用价格和特别优惠。',
                checkAvailability: '查询空房'
            },
            deluxeSeaViewRoom: {
                resortName: '穆图穆尼度假村',
                heroTitle: '豪华海景客房',
                heroSubtitle: '沉浸在豪华中，享受令人惊艳的海上地平线景观',
                bookThisRoom: '预订此房间',
                callReservations: '致电预订',
                navAll: '所有房间',
                navDeluxe: '豪华客房',
                navDeluxeSeaView: '豪华海景客房',
                navSuite: '豪华套房',
                sectionTitle: '发现豪华',
                sectionDesc: '我们的豪华海景客房完美结合了舒适与优雅。每间客房都经过精心设计，为您提供无与伦比的入住体验。',
                highlight1Title: '私人沙滩景色',
                highlight1Desc: '直接进入我们有白沙的私人海滩',
                highlight2Title: '宽敞的客房',
                highlight2Desc: '75平方米的奇妙生活空间',
                highlight3Title: '户外浴缸',
                highlight3Desc: '在星空下享受私密奢华',
                atAGlance: '一目了然',
                stat1Label: '大小',
                stat1Value: '75平方米',
                stat2Label: '景观',
                stat2Value: '大海景观',
                stat3Label: '客人',
                stat3Value: '2位成人',
                stat4Label: '床',
                stat4Value: '国王',
                reserve: '预订',
                galleryAlt: '豪华海景客房',
                inclusionsTitle: '包括的内容',
                inclusionsSubtitle: '每间客房包括',
                inclusion1: '海景早餐',
                inclusion2: '日落欢迎饮品',
                inclusion3: '每日浓缩咖啡吧服务',
                inclusion4: '无限水疗中心入场',
                inclusion5: '私人海滩接送',
                inclusion6: '高级Wi-Fi',
                enhancedCleanliness: '增强清洁和安全协议',
                amenityGroup1Title: '卧室',
                amenityGroup1Item1: '自动遮光',
                amenityGroup1Item2: '100%精选棉',
                amenityGroup1Item3: '不同硬度的枕头',
                amenityGroup2Title: '浴室',
                amenityGroup2Item1: '宝格丽化妆品',
                amenityGroup2Item2: '地暖',
                amenityGroup2Item3: '集成水疗系统',
                amenityGroup3Title: '客厅',
                amenityGroup3Item1: '高级卫星电视',
                amenityGroup3Item2: '全装最新厨房',
                amenityGroup3Item3: '家庭影院',
                amenityGroup4Title: '户外',
                amenityGroup4Item1: '带按摩浴缸的私人露台',
                amenityGroup4Item2: '巴厘岛风格的吊床',
                amenityGroup4Item3: '自动灌溉系统',
                essentialsTitle: '必需品',
                essentialsHeading: '您的房间基本需求',
                essentialsDesc: '房间里的所有必需物品',
                essential1: '精选饮料迷你吧',
                essential2: '咖啡和茶站',
                essential3: '24/7客房服务',
                essential4: '雨淋喷头',
                oceanTitle: '靠近海洋',
                oceanSubtitle: '放慢速度，呼吸海风',
                oceanAlt: '海景',
                ctaTitle: '准备好入住了吗？',
                ctaHeading: '立即预订豪华海景客房',
                ctaDesc: '与我们的预订团队联系，了解最佳可用价格和特别优惠。',
                checkAvailability: '查询空房'
            }
        },

        navbar: {
            home: '首页',
            aboutUs: '关于我们',
            rooms: '客房',
            ayurveda: '阿育吠陀',
            yoga: '瑜伽',
            food: '美食',
            events: '活动',
            blogs: '博客',
            tours: '旅游',
            contactUs: '联系我们',
            bookOnline: '在线预订',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: '选择度假村',
            language: '语言',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: '首页',
            aboutUs: '关于我们',
            rooms: '客房',
            ayurveda: '阿育吠陀',
            yoga: '瑜伽',
            food: '美食',
            events: '活动',
            blogs: '博客',
            tours: '旅游',
            contactUs: '联系我们',
            bookOnline: '在线预订',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: '选择度假村',
            language: '语言',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort 致力于提供卓越的待客之道与身心疗愈体验，确保每位宾客都倍感珍视与焕然一新。',
            linksTitle: '链接',
            contactTitle: '联系我们',
            viewLocation: '查看位置',
            navHome: '首页',
            navAbout: '关于我们',
            navContact: '联系我们',
            navRooms: '客房',
            navAyurveda: '阿育吠陀',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: '开发者',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: '旅游与游览',
            heroSubtitle: '从贝鲁沃拉发现斯里兰卡之美',
            kandeAlt: '甘地维哈拉寺庙 - 贝鲁沃拉',
            kandeTitle: '甘地维哈拉寺庙之旅',
            kandeBuddhaAlt: '甘地维哈拉寺庙的巨大佛像',
            bentotaTitle: '本托塔河船游',
            bentotaAlt: '本托塔河船游 - 红树林和野生动物',
            galleTitle: '加勒古城之旅',
            galleAlt: '加勒古城之旅',
            sigiriyaTitle: '狮子岩堡垒之旅',
            sigiriyaAlt: '狮子岩堡垒之旅',
            kandyTitle: '康提文化之旅',
            kandyAlt: '康提文化之旅',
            bookTour: '预订此旅游',
            introPara1: '斯里兰卡是一片永恒美丽的土地，黄金海滩、郁郁葱葱的风景、古老的寺庙和充满活力的文化在此完美和谐地汇聚。',
            introPara2: '从宁静的西南海岸到历史悠久的城市、神圣遗址、野生动物保护区和雾蒙蒙的山区，每一次旅程都能为您提供独特而难忘的体验。',
            introPara3: '从位于贝鲁沃拉的穆图穆尼阿育吠陀海滩度假村开始，我们精心策划的旅游和游览是为了丰富您的住宿体验，同时完美平衡了探索、放松和健康。',
            kandeDetail1: '甘地维哈拉寺庙（Kande Viharaya）— 贝鲁沃拉附近最具标志性的佛教寺庙之一。',
            kandeDetail2: '这座宁静的"山寺"建于1734年，坐落在山顶上，可俯瞰宁静的海岸风景。',
            kandeDetail3: '亮点包括48米高的巨大坐佛像（斯里兰卡最高的之一）、复杂的康提时代壁画、古老的舍利室、美丽的月光石入口和一棵树龄超过300年的神圣菩提树。',
            kandeDetail4: '完美的半天精神和文化体验 – 理想的上午参观时间，可避免炎热。',
            bentotaDetail1: '沿本托塔河享受宁静而风景优美的河流游船，这是贝鲁沃拉附近最受欢迎的自然游览之一。',
            bentotaDetail2: '在观察当地野生动物的同时，在郁郁葱葱的红树林、狭窄的运河和宁静的回水中滑行。',
            bentotaDetail3: '常见的观看对象包括水蜥、鳄鱼、各种鸟类（翠鸟、苍鹭、鹰）、猴子，偶尔还能看到水獭或水蛇。',
            bentotaDetail4: '您经验丰富的船夫/导游会为您指出有趣的植被、传统捕鱼方法和河边村庄的生活。',
            bentotaDetail5: '非常适合热爱大自然的人和摄影师 – 宁静、放松，与您的阿育吠陀健康之旅相得益彰。',
            galleDetail1: '探索历史悠久的加勒堡，这是联合国教科文组织世界遗产，也是斯里兰卡保存最完好的殖民地堡垒之一。',
            galleDetail2: '漫步在鹅卵石街道上，两旁是荷兰殖民建筑、精品店、咖啡馆和艺术画廊。',
            galleDetail3: '参观关键地标，如加勒灯塔、荷兰改革教会、国家海事博物馆和提供壮观海景的城堡。',
            galleDetail4: '从您知识渊博的导游那里了解这座堡垒的丰富历史、建筑和文化意义。',
            galleDetail5: '非常适合历史爱好者、文化爱好者以及那些想要体验斯里兰卡殖民地过去的人。',
            sigiriyaDetail1: '探索狮子岩这座古老的岩石堡垒，这是斯里兰卡最具标志性的地标之一，也是联合国教科文组织世界遗产。',
            sigiriyaDetail2: '爬上印象深刻的岩石，探索卡什亚帕国王宫殿的遗迹，这里装饰着壁画、水园和著名的镜墙。',
            sigiriyaDetail3: '从山顶享受周围丛林和乡村的全景。',
            sigiriyaDetail4: '从您的专家导游那里了解与狮子岩相关的迷人历史、建筑和传说。',
            sigiriyaDetail5: '非常适合历史爱好者、冒险寻求者以及对斯里兰卡丰富文化遗产感兴趣的人。',
            kandyDetail1: '体验康提充满活力的文化，这是斯里兰卡最后的皇家首都，也是联合国教科文组织世界遗产。',
            kandyDetail2: '参观神圣牙齿舍利寺（斯里达拉达玛利加瓦），这是世界上最重要的佛教遗址之一。',
            kandyDetail3: '探索佩拉德尼亚皇家植物园，拥有大量的热带植物和兰花集合。',
            kandyDetail4: '欣赏传统的康提舞蹈表演，展示斯里兰卡丰富的艺术遗产。',
            kandyDetail5: '非常适合文化爱好者、历史爱好者以及想要沉浸在斯里兰卡传统中的人。'
        },
        blogs: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort 博客',
            heroSubtitle1: '来自海岸的故事，阿育吠陀仪式在',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '。深入了解技巧、历史和幕后笔记。',
            heroAlt: '日落时度假村海滨步道',
            sectionTitle: 'Muthumuni Ayurveda Beach Resort 博客',
            sectionDescription: '来自我们海岸度假胜地的指南、故事和笔记——涵盖阿育吠陀仪式、宝石传说以及本托塔周边的旅行提示。',
            ayurvedaTitle: '正宗阿育吠陀的核心',
            ayurvedaExcerpt: '体验植根于斯里兰卡古老智慧的悠久疗愈传统。',
            ayurvedaDescription: '在Muthumuni Ayurveda Beach Resort，阿育吠陀不仅仅是一种治疗——它是一种生活方式。我们的疗法基于几个世纪的知识，根据您的体质进行个性化，并由经验丰富的阿育吠陀医生指导，以实现深刻持久的平衡。',
            ayurvedaAlt: '阿育吠陀疗愈设置，包括草药油和天然元素',
            healingTitle: '个性化疗愈之旅',
            healingExcerpt: '为什么每位客人的健康计划都是独特设计的。',
            healingDescription: '从初步咨询到日常治疗，您的疗愈之旅都经过精心定制。草药疗法、治疗性按摩、瑜伽和冥想共同作用，恢复身体、心灵和精神之间的和谐。',
            healingAlt: '阿育吠陀医生在平静的环境中咨询客人',
            natureTitle: '海洋疗愈',
            natureExcerpt: '海风和热带环境如何增强您的健康。',
            natureDescription: '坐落在斯里兰卡宁静的海岸线上，Muthumuni提供了自然疗愈的环境。海浪声、清新的海洋空气和茂盛的绿色植物放大了阿育吠陀的效果，创造深度放松和更新。',
            natureAlt: '度假村海滩景色，配有棕榈树和海洋',
            foodTitle: '阿育吠陀美食促进内在平衡',
            foodExcerpt: '精心制作的营养餐食以支持您的疗程。',
            foodDescription: '我们的阿育吠陀美食使用当季、本地采购的食材新鲜制作。每顿餐都与您的体质相一致，支持消化、排毒和整体活力，同时保持美味和令人满意。',
            foodAlt: '传统阿育吠陀餐食盛在天然碗中',
            yogaTitle: '瑜伽、冥想与内心的宁静',
            yogaExcerpt: '平静心灵和强健身体的温和练习。',
            yogaDescription: '每日瑜伽和冥想课程补充您的治疗，提高灵活性、呼吸和心智清晰度。这些正念练习帮助您重新与自己联系，并在您的住宿之后带走一种平和的感觉。',
            yogaAlt: '客人在日出时面向海洋练习瑜伽',
            lifestyleTitle: '将阿育吠陀带回家',
            lifestyleExcerpt: '简单的生活方式实践以继续您的健康之旅。',
            lifestyleDescription: '在您离开之前，我们的专家会指导您通过日常生活习惯、饮食和自我护理仪式保持平衡。带走的不仅仅是回忆——带走通往更健康生活的可持续道路。',
            lifestyleAlt: '客人在度假村宁静的环境中品尝草药茶放松身心',
            readMore: '阅读更多'
        },
        events: {
            heroEyebrow: '体验与活动',
            heroTitle: '我们的活动',
            heroSubtitle: '将斯里兰卡传统与海岸奢华融合的精心体验',
            heroAlt: 'Muthumuni 活动',
            availableDaily: '每日可参加',
            bookNow: '立即预订',
            highlightsTitle: '亮点',
            detailAlt: '{{title}} 细节',
            ctaTitle: '准备创造回忆了吗？',
            ctaDescription: '联系我们的团队，为您定制在 Muthumuni Ayurveda Beach Resort 的理想活动体验',
            ctaContact: '联系我们',
            ctaViewRooms: '查看房型',
            cookeryTitle: '烹饪课程',
            cookerySubtitle: '斯里兰卡风味',
            cookeryDescription: '沉浸在充满活力的斯里兰卡美食风味中。我们的专业厨师带领您进行动手烹饪课程，教授代代相传的传统食谱。学习使用新鲜本地食材制作香气四溢的咖喱、hoppers、椰子 sambol 等美食。',
            cookeryHighlight1: '传统斯里兰卡食谱',
            cookeryHighlight2: '动手烹饪体验',
            cookeryHighlight3: '新鲜本地食材',
            cookeryHighlight4: '带回家食谱',
            cookeryHighlight5: '包含香料园参观',
            meditationTitle: '冥想课程',
            meditationSubtitle: '内心平和与正念',
            meditationDescription: '在印度洋宁静的背景下参加我们的冥想课程，寻找内在的宁静。经验丰富的导师引导您进行古老的正念技巧、呼吸练习和瑜伽练习，帮助安抚心灵、焕新精神。',
            meditationHighlight1: '日出与日落课程',
            meditationHighlight2: '海滨冥想',
            meditationHighlight3: '专家指导',
            meditationHighlight4: '呼吸技巧',
            meditationHighlight5: '瑜伽与正念练习',
            bbqTitle: '烧烤派对',
            bbqSubtitle: '海滨庆典',
            bbqDescription: '在海边烧烤派对中度过难忘的夜晚。品尝新鲜烤制的海鲜、优质肉类和素食美味，同时聆听海浪低语。现场音乐、火舞表演与星空共同营造庆祝与交流的完美氛围。',
            bbqHighlight1: '新鲜烤海鲜',
            bbqHighlight2: '海景用餐',
            bbqHighlight3: '现场表演',
            bbqHighlight4: '篝火体验',
            bbqHighlight5: '可定制菜单',
            boatTitle: '乘船之旅',
            boatSubtitle: '河流与海岸探险',
            boatDescription: '沿着本托塔河和海岸水域开启迷人的航行。穿越红树林，观赏珍稀鸟类与野生动物，或享受浪漫的日落巡航。我们的乘船之旅带来欣赏斯里兰卡自然之美和多样生态系统的独特视角。',
            boatHighlight1: '本托塔河巡航',
            boatHighlight2: '红树林探索',
            boatHighlight3: '野生动物观赏',
            boatHighlight4: '日落船游',
            boatHighlight5: '提供私人包船',
            ayurvedaLecturesTitle: '阿育吠陀医生讲座',
            ayurvedaLecturesSubtitle: '古老智慧与现代健康',
            ayurvedaLecturesDescription: '通过认证阿育吠陀医生和从业者的专家讲座，探索阿育吠陀的深奥原则。了解体质平衡、草本疗法、整体疗愈实践，以及古老智慧如何应用于现代健康。我们的互动课程为您揭开阿育吠陀哲学及其日常应用的奥秘。',
            ayurvedaLecturesHighlight1: '认证阿育吠陀医生',
            ayurvedaLecturesHighlight2: '个性化体质分析',
            ayurvedaLecturesHighlight3: '草本疗法知识',
            ayurvedaLecturesHighlight4: '包含问答环节',
            ayurvedaLecturesHighlight5: '可带走的健康指南',
            traditionalClothsTitle: '传统服饰体验活动',
            traditionalClothsSubtitle: '文化遗产体验',
            traditionalClothsDescription: '通过学习穿着和欣赏传统服饰，沉浸在斯里兰卡的文化遗产中。我们的专家造型师指导您穿着正宗的康提纱丽和传统服装，解释每一件服饰的文化意义。非常适合特殊场合、文化体验或留下难忘照片。',
            traditionalClothsHighlight1: '专业造型指导',
            traditionalClothsHighlight2: '正宗传统纱丽',
            traditionalClothsHighlight3: '解释文化意义',
            traditionalClothsHighlight4: '包含专业摄影',
            traditionalClothsHighlight5: '时尚融合工作坊'
        },
        contact: {
            heroTitle: '联系我们',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: '联系我们',
            sectionTitle: '欢迎随时联系',
            sectionSubtitle: '我们在此帮助您放松身心',
            sectionDescription: '如需了解阿育吠陀疗程、康养套餐、预订或在贝鲁沃拉（Moragalla）住宿期间的任何问题，请联系 Muthumuni Ayurveda Beach Resort。',
            callUs: '致电我们',
            emailTitle: '邮箱',
            ourLocation: '我们的地址',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: '社交网络',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: '保持联系',
            getInTouchDescription: '期待您的来信——我们的团队随时为您的康养之旅提供帮助，解答问题并规划焕活之旅。',
            nameLabel: '姓名',
            emailLabel: '邮箱',
            contactNumberLabel: '联系电话',
            messageLabel: '留言',
            sending: '发送中...',
            sendMessage: '发送消息',
            successMessage: '您的消息已成功发送！我们会尽快回复您。',
            errorMessage: '发送时出错，请重试。',
            findUsOnMap: '在地图上找到我们',
            whatsappSubject: 'Muthumuni Ayurveda Beach Resort 联系',
            whatsappName: '姓名',
            whatsappEmail: '邮箱',
            whatsappContactNumber: '联系电话',
            whatsappMessage: '留言'
        },

        contact2: {
            heroTitle: '联系我们',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: '联系我们',
            sectionTitle: '欢迎随时联系',
            sectionSubtitle: '我们在此帮助您放松身心',
            sectionDescription: '如需了解阿育吠陀疗程、康养套餐、预订或在贝鲁沃拉（Moragalla）住宿期间的任何问题，请联系 Muthumuni Ayurveda Beach Resort。',
            callUs: '致电我们',
            emailTitle: '邮箱',
            ourLocation: '我们的地址',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: '社交网络',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: '保持联系',
            getInTouchDescription: '期待您的来信——我们的团队随时为您的康养之旅提供帮助，解答问题并规划焕活之旅。',
            nameLabel: '姓名',
            emailLabel: '邮箱',
            contactNumberLabel: '联系电话',
            messageLabel: '留言',
            sending: '发送中...',
            sendMessage: '发送消息',
            successMessage: '您的消息已发送！我们会尽快与您联系。',
            errorMessage: '发送消息时出错。请再试一次。',
            findUsOnMap: '在地图上找到我们',
            whatsappSubject: '联系 Muthumuni Ayurveda Beach Resort',
            whatsappName: '姓名',
            whatsappEmail: '邮箱',
            whatsappContactNumber: '联系电话',
            whatsappMessage: '留言'
        },

        ayurveda: {
            accordionTitle1: '什么是五业净化阿育吠陀？',
            accordionDesc1: '阿育吠陀是世界上最古老的疗愈系统之一，发展于5000多年前。五业净化阿育吠陀的核心信念是健康取决于心灵、身体、精神和环境之间的平衡。',
            accordionTitle2: '五业净化阿育吠陀与生命能量',
            accordionDesc2: '阿育吠陀基于宇宙万物相互联系的理论。阿育吠陀实践者相信每个人由五种元素组成：空间、空气、火、水和土。它们形成三种体质：瓦塔、皮塔和卡法。',
            accordionTitle3: '瓦塔体质',
            accordionDesc3: '最强大的体质，控制基本身体功能：细胞分裂、呼吸、血液循环、心脏功能。瓦塔主导时你聪明、有创造力、精力充沛。失衡时会焦虑。通过冥想、按摩和温热食物平衡。',
            accordionTitle4: '皮塔体质',
            accordionDesc4: '控制消化、新陈代谢和荷尔蒙。皮塔主导时你目标明确、竞争力强、自信。失衡时会易怒。通过清凉食物和缓慢瑜伽平衡。',
            accordionTitle5: '卡法体质',
            accordionDesc5: '控制肌肉生长、身体力量和免疫力。卡法主导时你喜欢规律、冷静有耐心。失衡时会疲劳和体重增加。通过水果、蔬菜和运动平衡。',
            close: '关闭',
            next: '下一个',
            previous: '上一个',
            treatmentsTitle: '我们标志性的五业净化阿育吠陀疗法',
            treatmentsSubtitle: '体验恢复平衡、释放压力并让您全面恢复活力的古老疗法。',
            bookTreatment: '预订此疗法',
            benefitsTitle: '五业净化疗法的益处',
            shirodhara: '额头滴油疗法',
            shirodharaDesc: '将温热的草药油轻轻浇在额头上以平静心灵。',
            shirodhara1: '减少压力和焦虑',
            shirodhara2: '促进更好的睡眠',
            shirodhara3: '提高思维清晰度',
            steamBath: '蒸汽浴',
            steamBathDesc: '排毒蒸汽疗法，打开毛孔并放松肌肉。',
            steamBath1: '为身体排毒',
            steamBath2: '改善血液循环',
            steamBath3: '缓解肌肉紧张',
            flowerBath: '花瓣浴',
            flowerBathDesc: '用芳香花朵放松的舒缓浴。',
            flowerBath1: '镇静神经系统',
            flowerBath2: '滋润肌肤',
            flowerBath3: '提升情绪',
            headMassage: '头部按摩',
            headMassageDesc: '放松的头皮按摩以缓解紧张。',
            headMassage1: '减少头痛',
            headMassage2: '改善头皮健康',
            headMassage3: '促进放松',
            faceMassage: '面部按摩',
            faceMassageDesc: '增强面部光泽并减轻压力的年轻化按摩。',
            faceMassage1: '改善肤色',
            faceMassage2: '减少面部紧张',
            faceMassage3: '促进淋巴引流',
            neckMassage: '颈部按摩',
            neckMassageDesc: '针对性按摩以缓解颈部僵硬和紧张。',
            neckMassage1: '缓解颈部疼痛',
            neckMassage2: '改善灵活性',
            neckMassage3: '减少压力',
            shoulderMassage: '肩部按摩',
            shoulderMassageDesc: '针对性按摩以缓解肩部僵硬和不适。',
            shoulderMassage1: '减少肩部疼痛',
            shoulderMassage2: '改善姿势',
            shoulderMassage3: '放松肌肉',
            bodyMassage: '全身按摩',
            bodyMassageDesc: '促进放松和幸福的全身按摩。',
            bodyMassage1: '改善血液循环',
            bodyMassage2: '缓解肌肉酸痛',
            bodyMassage3: '促进放松',
            backMassage: '背部按摩',
            backMassageDesc: '治疗背部疼痛和紧张的疗法按摩。',
            backMassage1: '缓解背部疼痛',
            backMassage2: '改善脊柱健康',
            backMassage3: '减少压力',
            footMassage: '足部按摩',
            footMassageDesc: '缓解足部疼痛和放松的舒缓按摩。',
            footMassage1: '改善血液循环',
            footMassage2: '减少足部疲劳',
            footMassage3: '促进放松',
            purgative: '泻药疗法',
            purgativeDesc: '清除消化系统中多余皮塔和毒素的净化疗法。',
            purgative1: '清洁肠道',
            purgative2: '平衡皮塔体质',
            purgative3: '改善消化健康',
            nasalClearing: '鼻腔清洁',
            nasalClearingDesc: '清除鼻窦并改善呼吸功能的治疗性鼻腔治疗。',
            nasalClearing1: '消除鼻塞',
            nasalClearing2: '改善呼吸',
            nasalClearing3: '缓解鼻窦问题',
            powderMassage: '粉末按摩',
            powderMassageDesc: '使用草药粉末使皮肤恢复活力和清爽的去角质按摩。',
            powderMassage1: '去除死皮',
            powderMassage2: '改善肌肤质地',
            powderMassage3: '促进血液循环',
            intensiveMassageDesc: '一种深层治疗按摩，针对慢性紧张和肌肉结节，采用坚定压力和专业技术。',
            intensiveMassage1: '缓解深层肌肉紧张',
            intensiveMassage2: '改善血液循环',
            intensiveMassage3: '减轻肌肉酸痛',
            thermoMassage: '热疗按摩',
            thermoMassageDesc: '使用加热的治疗性草药油进行温暖按摩，以增强放松和愈合效果。',
            thermoMassage1: '舒缓酸痛肌肉',
            thermoMassage2: '促进深度放松',
            thermoMassage3: '增强能量流动',
            synchronMassage: '同步按摩',
            synchronMassageDesc: '双人同步按摩，实现全身和谐与能量平衡分布。',
            synchronMassage1: '全身和谐',
            synchronMassage2: '平衡的能量流动',
            synchronMassage3: '深度放松体验',
            specialMassage: '特别按摩',
            specialMassageDesc: '根据您的具体健康需求和个人健康目标量身定制的按摩疗法。',
            specialMassage1: '个性化治疗',
            specialMassage2: '针对特定问题',
            specialMassage3: '定制化愈合方式',
            benefit1Title: '排毒：',
            benefit1Desc: '五业净化疗法有助于从身体中去除毒素，促进健康和活力。',
            benefit2Title: '改善消化：',
            benefit2Desc: '这些疗法改善消化功能，实现更好的营养吸收和新陈代谢。',
            benefit3Title: '减压：',
            benefit3Desc: '五业净化以其对身心的镇静作用而闻名，降低压力和焦虑水平。',
            benefit4Title: '增强免疫力：',
            benefit4Desc: '定期的五业净化疗法可增强免疫系统，使身体更具韧性。',
            benefit5Title: '年轻化：',
            benefit5Desc: '疗法促进细胞再生，改善皮肤健康和年轻外观。',
            benefit6Title: '平衡体质：',
            benefit6Desc: '五业净化有助于恢复体质平衡（瓦塔、皮塔、卡法），这对阿育吠陀原则中的健康至关重要。',
            akkupancharTitle: '穴位疗法',
            akkupancharDesc1: '是一种古老的阿育吠陀疗法，在特定的身体点上使用草药膏和油。这种疗法刺激能量通道并促进愈合。',
            akkupancharBenefit: '主要益处：',
            akkupancharDesc2: '这种专业疗法有助于慢性疼痛，改善关节灵活性，促进血液循环，并恢复自然能量流动。',
            akkupancharApplication: '治疗应用：',
            akkupancharDesc3: '穴位疗法在特定的玛尔玛点上作用，配以精心挑选的草药制剂以平衡体质。',
            akkupancharTransform: '体验转变：',
            akkupancharDesc4: '在穆图穆尼阿育吠陀海滩度假村，我们经验丰富的治疗师根据您的健康需求定制每次疗程。',
            gallery1: '额头滴油疗法',
            gallery2: '蒸汽浴',
            gallery3: '花瓣浴',
            gallery4: '头部按摩',
            gallery5: '全身按摩',
            gallery6: '颈部按摩',
            gallery7: '面部按摩',
            gallery8: '肩部按摩',
            heroTitle: '五业净化阿育吠陀',
            heroSubtitle: '在贝鲁瓦拉焕活身心灵',
            sectionEyebrow: '穆图穆尼阿育吠陀海滩度假村的五业净化阿育吠陀',
            sectionDescription: '在贝鲁瓦拉的穆图穆尼阿育吠陀海滩度假村发现古老的五业净化疗法。我们经验丰富的从业者提供个性化治疗，促进排毒、焕活和恢复平衡。',
            treatmentProgramme: {
                title: '阿育吠陀治疗计划',
                subtitle: '您通往平衡、排毒和深度更新的旅程',
                intro: '在一个宁静的静修处体验正宗的阿育吠陀疗愈，旨在恢复您的身体、平静您的心灵并重焕活力。从您抵达的那一刻起，我们的团队会照顾每一个细节——让您能够完全专注于您的健康。',
                welcomeTitle: '欢迎与温和开始',
                welcomePoints: [
                    '机场接机并转送至酒店',
                    '热情欢迎和酒店介绍',
                    '介绍您的每周健康计划',
                    '阿育吠陀中心放松按摩（第1天），释放旅途疲劳并让您的身体为治疗做好准备'
                ],
                doctorTitle: '医生咨询与个人计划',
                doctorPoints: [
                    '阿育吠陀医生咨询（第2天 – 上午）',
                    '全面评估您的体质类型和健康问题',
                    '可应要求提供翻译',
                    '您的医生会制定个性化的治疗计划，根据您的需求和目标量身定制'
                ],
                dailyTherapiesTitle: '每日阿育吠陀疗法',
                dailyTherapiesPoints: [
                    '每天4–5次治疗（根据医生建议）',
                    '根据您的体质和状况选择疗法',
                    '必要时可添加特殊按摩',
                    '医生每天监测进展，可能会调整治疗和草药支持以确保最佳效果',
                    '如果合适，可能会推荐温和的清洁/净化过程'
                ],
                herbalMedicineTitle: '草药支持',
                herbalMedicinePoints: [
                    '医生处方的草药每天两次服用：',
                    '早餐时',
                    '晚餐时',
                    '支持内部疗愈、排毒和持久平衡'
                ],
                yogaMeditationTitle: '瑜伽与冥想促进身心和谐',
                yogaMeditationPoints: [
                    '每周4次瑜伽课程（约1小时）',
                    '每周2次冥想课程：',
                    '在岛屿寺庙的独特精神体验，乘船前往',
                    '由僧侣引导的冥想（约1小时）'
                ],
                wellnessTitle: '包含的健康体验',
                wellnessPoints: [
                    '每周健康烹饪示范',
                    '免费短途旅行（文化/自然体验）'
                ],
                closingTitle: '闭幕仪式与离开',
                closingPoints: [
                    '美丽的花浴（最后一天）——传统的更新仪式',
                    '最终医生咨询，审查进展并提供：',
                    '持续的健康指导',
                    '居家处方和建议',
                    '送回机场'
                ]
            },
        },
        food: {
            heroTitle: '阿育吠陀美食与沿海美食',
            heroSubtitle: '正宗斯里兰卡风味和新鲜沿海美食',
            heroAlt: 'Muthumuni 海滩度假村的烹饪体验',
            wellnessEyebrow: '通过食物实现健康',
            wellnessTitle: '重要性',
            ayurvedicFood: '阿育吠陀食品',
            wellnessIntro1: '在阿育吠陀中，食物被认为是最伟大的药物。你吃的东西直接影响你的多沙（Vata、Pitta、Kapha）、消化（agni）以及身体、心灵和灵魂的整体平衡。',
            wellnessIntro2: '阿育吠陀营养强调用心准备和正念进食的新鲜、季节性全食。它在每餐中促进六种味道（甜、酸、咸、辛辣、苦、涩），以滋养所有感官并保持和谐。',
            wellnessIntro3: '适当的阿育吠陀食物支持强大的消化，有助于清除毒素（ama），增强免疫力，改善能量，减少压力并预防许多慢性疾病。在 Muthumuni，每道菜都经过精心准备，以符合您独特的体质，为深层治愈和活力。',
            foodImage1Alt: '六种风味的传统阿育吠陀餐',
            foodImage2Alt: '用于均衡营养的阿育吠陀草药和香料',
            culinaryPhilosophyEyebrow: '我们的烹饪哲学',
            culinaryPhilosophyTitle: '阿育吠陀',
            nutritionHighlight: '营养',
            culinaryPhilosophyResort: 'Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Muthumuni Ayurveda River Resort 的阿育吠陀美食',
            freshNourishingLabel: '新鲜和营养',
            healingIngredientsAlt: '健康的阿育吠陀成分和香料',
            healingIngredientsLabel: '治愈性成分',
            philosophyText1: '食物包括六种主要味道（甜、酸、咸、苦、辛辣和涩）以及许多微妙变化，已在经典阿育吠陀文献中描述——其中一些可以追溯到 5000 多年前——以及每种食物的基本特性：Guna（固有质量）、Virya（效力/加热或冷却）、Vipaka（消化后影响）和 Prabhava（独特的特殊作用）。',
            philosophyText2: '因此，阿育吠陀营养在 Muthumuni Ayurveda Beach Resort 中扮演核心角色。这并不意味着严格、单调的制度，由医生单独规定的平淡、无味或过度苦涩的素食。相反，我们的阿育吠陀厨房是我们最大的优势之一：由我们的技术高超的厨师准备的菜肴会在您逗留的每一天让您惊喜和高兴！',
            philosophyText3: '在早餐时，享用一份丰盛的自助餐，里面装满新鲜热带水果、新鲜果汁、营养草药汤、自家烤面包和轻饼干，以及多种正宗斯里兰卡早餐选项。在午餐时，享用色彩缤纷、美味的自助餐，配有温和的鱼咖喱、蔬菜准备和草药菜肴。晚上，我们提供固定的素食菜单，可选新鲜鱼。周六，我们庆祝"斯里兰卡之夜"，自助餐扩大——我们的厨师在您面前准备传统当地特色菜，创造充满活力和真实的体验。',
            philosophyText4: '在阿育吠陀中，食物和饮料以多种方式分类——根据味道和特性、身体的消化能力（agni）、对特定健康状况的适用性、季节适宜性等等。在 Muthumuni，我们同时仔细考虑所有这些因素，有意识地努力将所有六种风味纳入根据每位客人的个人体质量身定制的均衡组合中。',
            philosophyText5: '我们的饭菜采用新鲜蔬菜、热带水果和负责任采购的鱼。我们不提供红肉或酒精。',
            philosophyText6: '用餐时，阿育吠陀医生或合格营养师随时可用来指导您。他们会就您当前治疗阶段最合适的蔬菜、草药和香料提供建议，并帮助您相应地选择或避免菜肴。您的个性化草药灵药和健康中心团队的任何具体说明将放在您的个人桌子上。',
            philosophyText7: '这种水平的个人关怀和对饮食的关注是 Muthumuni Ayurveda Beach Resort 体验的标志。',
            philosophyText8: '食物被视为 Prana——每个人的生命维持能量。这就是为什么我们鼓励您以充分的意识对待每一顿饭：品尝香气、体验味道、感受温柔的温暖，并有意识地享受迷人的感觉。',
            diningExperienceEyebrow: '用餐体验',
            restaurantTitlePrefix: '我们的',
            ayurvedicHighlight: '阿育吠陀',
            restaurantTitleSuffix: '餐厅',
            restaurantDetail1: 'Muthumuni 海滩度假村的我们的阿育吠陀餐厅提供独特的用餐体验，融合了传统阿育吠陀原则与正宗斯里兰卡沿海美食。我们优先选择新鲜、本地采购的食材来创作不仅美味可口而且促进整体幸福的餐点。',
            restaurantDetail2: '菜单经过精心设计，以平衡每道菜中的六种味道（甜、酸、咸、苦、辛辣和涩），确保营养和令人满意的体验。每餐都是精心准备的，融入了以其治愈特性而闻名的阿育吠陀草药和香料。',
            restaurantDetail3: '客人可以享用根据其个人多沙（身体体质）量身定制的各种菜肴，并提供素食、纯素和鱼素饮食选项。我们的厨师与阿育吠陀从业者密切合作，确保每顿餐都支持客人的健康和健康目标。',
            restaurantDetail4: '餐厅的氛围反映了宁静的沿海环境，为正念饮食提供了宁静的环境。无论您是享用丰盛的早餐自助餐还是品尝美食晚餐，我们阿育吠陀餐厅的每一餐都是滋养身体和灵魂的机会。',
            restaurantDetail5: '加入我们在 Muthumuni 海滩度假村的阿育吠陀餐厅的烹饪之旅，庆祝斯里兰卡的丰富风味，同时拥抱阿育吠陀的永恒智慧。',
            restaurantImageAlt: 'Muthumuni Ayurveda River Resort 的晚餐',
            premiumDiningLabel: '高级美食',
            premiumDiningDescription: '在宁静的河边环境中享受正宗的阿育吠陀美食'
        },
        yoga: {
            heroTitle: '度假村瑜伽',
            heroSubtitle: '在贝鲁瓦拉找到平衡、力量与内心平静',
            heroAlt: 'Muthumuni 海滩度假村的瑜伽',
            importanceEyebrow: '健康与平衡',
            importanceTitle: '瑜伽与冥想的重要性',
            importanceImageAlt: '瑜伽与冥想的重要性',
            importanceText1: '瑜伽与冥想是古老的修习，带来多方面的身心益处。它们提升柔韧性、力量与平衡，同时减轻压力与焦虑。',
            importanceText2: '规律练习可以提升专注力、改善睡眠质量并增强整体幸福感。瑜伽也鼓励正念，帮助人们连接内在自我，在日常的喧嚣中找到平静。',
            importanceText3: '在 Muthumuni 海滩度假村，我们提供宁静的环境，非常适合练习瑜伽与冥想，让宾客焕新身心灵。',
            practiceEyebrow: '我们的练习',
            practiceTitle: '瑜伽练习与体验',
            practiceImageAlt: '度假村瑜伽练习',
            practiceText1: '在 Muthumuni Ayurveda Beach Resort，瑜伽主要以传统哈他瑜伽为主，并结合调息法（Pranayama）。这种整体方法旨在唤醒内在觉知并温和地激活昆达里尼（常称为第三眼）。特别强调脊柱的对齐与柔韧性，因为柔软的脊柱被认为有助于减缓衰老——“你的年龄取决于你的脊柱。”',
            practiceText2: '瑜伽课程每周进行四次，适合初学者和有经验的练习者。我们也会不定期引入阿斯汤伽瑜伽等特别课程，让宾客体验多样的体式与练习。我们的阿育吠陀医生鼓励定期参与，以支持并提升整体疗程效果。',
            practiceText3: '所有瑜伽课程都在专属 Yoga Shala 中进行，这是一处安静而宁和的空间，帮助专注、平衡与正念运动。每次课程通常以太阳致敬开始，随后是调息练习与精选体式序列，旨在改善柔韧性、循环与整体健康。',
            practiceText4: '我们的资深瑜伽老师会根据宾客的个人需求、能力与健康状况调整每一节课，确保安全、支持性强且深具益处的瑜伽体验。',
            spiritualEyebrow: '心灵之旅',
            spiritualTitle: '冥想与精神活动',
            spiritualSubtitle: '通过我们的神圣仪式和引导冥想深化你的灵修',
            meditationImageAlt: '度假村的冥想与灵修',
            meditationTitle: '冥想课程',
            meditationDesc: '宾客可参加每周三次的引导冥想课程，灵感源自佛教传统。这些课程旨在安抚心灵、深化觉知并支持情绪与精神疗愈。冥想在宁静的岛上寺庙进行，宾客需乘船前往——这段宁静而意义深远的旅程进一步提升整体冥想体验。'
        },
        home: {
            heroTitle: 'Muthumuni 阿育吠陀海滩度假村',
            heroSubtitle1: '海洋中的阿育吠陀',
            heroSubtitle2: '在贝鲁瓦拉找到平衡、轻松呼吸并更新您的能量。',
            exploreResort: '探索度假村',
            bookNow: '立即预订',
            welcomeLabel: '欢迎',
            welcomeTitle: 'Muthumuni 阿育吠陀海滩度假村',
            welcomeDesc1: '坐落在贝鲁瓦拉的原始海岸线上，Muthumuni 阿育吠陀海滩度假村融合了古老的治愈传统和现代海岸奢华。我们的圣地邀请您开始一段变革式的健康之旅，在这里印度洋的节奏声与阿育吠陀的永恒智慧相遇。',
            welcomeDesc2: '体验个性化的阿育吠陀治疗、享受为平衡您体质而精心制作的营养美食，并在优雅的客房中放松，欣赏壮观的海景。无论您寻求恢复活力、放松还是精神重生，我们敬业的阿育吠陀医生和健康专家团队都会在每一步指导您。',
            learnMore: '了解更多',
            contactUs: '联系我们',
            welcomeImageAlt: 'Muthumuni 阿育吠陀海滩度假村',
            welcomeImageCaption: '阿育吠陀健康与海滩静修',
            welcomeImageLocation: '斯里兰卡贝鲁瓦拉',
            highlightTitle: '海边的阿育吠陀圣地',
            highlightDesc: '发现斯里兰卡西南海岸的整体治愈。从定制治疗到宁静的阳台和正念美食，每个细节都旨在恢复您的节奏。',
            service1Title: '整体阿育吠陀疗法',
            service1Desc: '个性化咨询、正宗草本油和由经验丰富的阿育吠陀医生指导的日常治疗。',
            service2Title: '海滨客房和套房',
            service2Desc: '在海风中醒来，拥有私人阳台和沉静的内部装饰，为深度休息而设计。',
            service3Title: '养生美食',
            service3Desc: '新鲜的斯里兰卡产品、植物性菜单和个性化的膳食计划，补充您的体质。',
            service4Title: '瑜伽与正念',
            service4Desc: '日出瑜伽、日落冥想和呼吸练习，伴随着波浪的节奏。',
            service5Title: '河流和海岸之旅',
            service5Desc: '本托塔河巡游、海龟孵化场参观、香料园漫步和村庄自行车之旅。',
            roomsTitle: '我们的客房',
            roomsDesc: '选择符合您节奏的圣地，从宽敞的套房到舒适的豪华隐居处，每间都配有柔软的床单、温暖的木材和日出就绪的阳台。',
            roomBadge: '海滨逃亡',
            bookableNow: '现可预订',
            seaBreezeReady: '海风准备就绪',
            viewRoom: '查看客房',
            room1Title: '套房客房',
            room1Desc: '宽敞的套房，配有客厅区、慷慨的阳台和平静的调色板，适合悠闲的早晨。',
            room2Title: '豪华客房',
            room2Desc: '舒适的休闲场所，配备豪华床铺、花园景色和温暖的木制口音，日常简便。',
            room3Title: '豪华海景房',
            room3Desc: '随着海洋地平线醒来，柔软的床单和私人阳台，适合金色日落。',
            achievement1Title: '快乐的客人',
            achievement1Count: '1,000+',
            achievement2Title: '阿育吠陀治疗',
            achievement2Count: '20+',
            achievement3Title: '多年的护理',
            achievement3Count: '15+',
            achievement4Title: '旅行者的赞誉',
            achievement4Count: '1,000+',
            experiencesTitle: '探索 Muthumuni 阿育吠陀海滩度假村',
            experiencesDesc: '从阿育吠陀之旅到精心策划的游览，选择让您的住宿难忘的体验。',
            planYourStay: '规划您的住宿',
            experience1Title: '客房和套房',
            experience1Desc: '通风的空间，配有阳台、海洋或花园景色，以及周到的舒适，为不匆忙的停留。',
            experience2Title: '阿育吠陀水疗',
            experience2Desc: '道地的疗法、蒸汽浴和恢复性的按摩，采用久经考验的仪式进行。',
            experience3Title: '美食体验',
            experience3Desc: '在我们的餐厅提供营养丰富的斯里兰卡和国际美食，精心准备以滋养身体和心灵。',
            experience4Title: '体验与旅游',
            experience4Desc: '河流狩猎之旅、寺庙参观、水上运动和本托塔周围精心策划的文化游览。',
            galleryTitle: 'Muthumuni 阿育吠陀海滩度假村的时刻',
            galleryDesc: '一瞥我们的海岸圣地——日出、宁静的治疗、营养美食和为您打造的安静角落。',
            gallery1Alt: '穆图姆尼被棕榈树围绕的阳光沙滩',
            gallery2Alt: '进行中的阿育吠陀油疗',
            gallery3Alt: '配有躺椅的度假村游泳池',
            gallery4Alt: '为水疗准备的草药',
            gallery5Alt: '情侣在海边享受日落',
            gallery6Alt: '面向大海的瑜伽甲板',
            gallery7Alt: '热带花园小径',
            gallery8Alt: '健康早餐',
            gallery9Alt: '宁静的河景',
            gallery10Alt: '日落时的度假村外观光线柔和',
            gallery11Alt: '阿育吠陀草药和油展示',
            gallery12Alt: '花园里舒适的座位',
            resort1Alt: '带有绿色的露天休息室',
            resort2Alt: '舒适的房间内部',
            resort3Alt: '水疗处理空间',
            resort4Alt: '带自然光的餐饮区',
            resort5Alt: '放松的游泳池景色',
            sunsetLabel: '大自然的日常杰作',
            sunsetTitle: '晚间日落',
            sunsetDesc1: '看着白天优雅地进入黄昏，天空变成琥珀、深红和金色的画布。温柔的印度洋反映了这个天体景象，创造出光和水的迷人交响曲。',
            sunsetDesc2: '每个晚上穆图姆尼都为大自然最壮观的表演之一提供了前排座位。找到您完美的有利位置——无论是从您的私人阳台、海滨酒廊还是我们的日落冥想平台——让宁静的美丽淹没您。',
            sunsetFeature1: '从每个角落看到不受阻碍的海洋景色',
            sunsetFeature2: '日落宁静冥想',
            sunsetFeature3: '每天提供免费草本茶',
            sunsetFeature4: '每个晚上的照相时刻',
            sunsetImageAlt: 'Muthumuni 海滩度假村的晚间日落',
            bestTime: '最佳时间',
            sunsetTime: '下午 6:00 - 6:45',
            poolLabel: '水生宁静',
            poolTitle: '游泳池区域',
            poolDesc1: '沉浸在我们原始无边界泳池的宁静中，结晶水与郁郁葱葱的热带花园相遇。为放松和恢复活力而设计，我们的泳池区提供了在斯里兰卡阳光下放松的完美度假。',
            poolDesc2: '无论您喜欢清爽的晨泳、带着好书的下午放松还是宁静的晚间浸浴，我们的泳池区都提供了一个田园般的环境。周围是舒适的躺椅、遮荫小屋和贴心的泳池服务，每一刻都成为珍贵的回忆。',
            poolFeature1: '温度控制的无边界游泳池',
            poolFeature2: '被热带花园景观包围',
            poolFeature3: '泳池边的清爽饮品和健康小食',
            poolFeature4: '带遮阳伞的高级躺椅',
            poolImageAlt: 'Muthumuni 度假村令人放松的泳池区域',
            testimonialsTitle: '客人在他们的住宿期间'
        },
    },
    ja: {
        about: {
            heroTitle: '私たちについて',
            heroSubtitle: 'Muthumuni アーユルヴェーダ',
            heroBeachResort: 'Beach Resort',
            heroTagline1: '古来の知恵が現代ウェルネスと出会うムトゥムニアーユルヴェーダビーチリゾート',
            heroTagline2: 'パーソナライズされたアーユルヴェーダトリートメント、海の眺め、本物のスリランカのおもてなし',
            slide1: 'アーユルヴェーダ治療',
            slide2: 'ビーチサイドの平静',
            slide3: 'ガーデンの静寂',
            slide4: 'ハーブセラピー',
            slide5: 'オーシャンウェルネス',
            historyLabel: '私たちの歩み',
            historyTitle: 'ムトゥムニアーユルヴェーダビーチリゾートの歴史',
            historyDesc1: '2010年以上前に設立されたムトゥムニアーユルヴェーダビーチリゾートは、古代アーユルヴェーダの知恵がスリランカ南部海岸の静かな美しさと出会う聖地を作るという構想から生まれました。質素なウェルネスリトリートとして始まったものが、ベルワラで全体的な癒しと若返りのための最も愛される目的地の一つへと成長しました。',
            historyDesc2: '伝統的なアーユルヴェーダ実践者の数世代に触発された私たちの創設者は、現代的な快適さと本物のスリランカのおもてなしを提供しながら、これらの時間がたった治療法を保存することを目指していました。長年にわたって、私たちは本物のウェルネス体験へのコミットメントを堅守し、施設を拡張する一方で、私たちの遺産を定義するパーソナライズされたケアを決して見失いません。',
            historyDesc3: '今日、ムトゥムニはアーユルヴェーダの永遠の力の証として立ち、世界中から何千人ものゲストを迎えてきました。各訪問者は私たちの物語の一部となり、私たちのビーチサイドの避難所でバランス、癒し、変容を見出します。',
            statYear: '15+',
            statYearLabel: '年間ウェルネス卓越性',
            statGuest: '1,000+',
            statGuestLabel: '幸せなゲスト数',
            experienceLegacy: '私たちの遺産を体験',
            established: '設立',
            since2010: '2008年以来',
            chairmanLabel: '会長のメッセージ',
            chairmanTitle: 'ケアに導かれ、アーユルヴェーダに根ざして',
            chairmanDesc1: 'ムトゥムニアーユルヴェーダビーチリゾートへようこそ。20年以上の年月を經て、私たちの目的はシンプルです：アーユルヴェーダの永遠の知恵に根ざし、スリランカのおもてなしの温かさで届けられる本当の癒しを提供することです。',
            chairmanDesc2: 'ここでは、私たちのセラピーと料理から私たちの空間の穏やかさまで、すべての細部があなたが減速し、バランスを回復し、自分自身と再び繋がる手助けをするために設計されています。あなたのウェルネスジャーニーの一部であることを光栄に思います。',
            chairmanDesc3: '我々の献身的なチームを代表して、ムトゥムニを定義するケア、真正性、穏やかさを体験するようお誘いします。',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: '会長',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: '会長 Mr. Nihal Muthumuni',
            staffLabel: '私たちのチーム',
            staffTitle: '献身的なスタッフに会う',
            staffDesc1: 'ムトゥムニアーユルヴェーダビーチリゾートでは、私たちのチームは機能するすべての中心です。スタッフメンバーは、アーユルヴェーダウェルネスと本物のおもてなしに対する深い情熱を共有する、慧眼に選ばれ、訓練を受けた専門家です。',
            staffDesc2: '経験豊かなアーユルヴェーダ医師と熟練したマッサージセラピスト、献身的なおもてなしチームまで、各メンバーはすべてのゲストとのインタラクションに多年の専門知識と本当のケアをもたらします。真のウェルネスはトリートメントだけからは来るのではなく、あなたの旅について本当に気にかけている人々の温かさと注意から生まれると信じています。',
            staffDesc3: 'スタッフはアーユルヴェーダの最新実践における継続的なトレーニングを受け、専門性と文化的感受性の最高水準を保ちます。ゲストと意味のある関係を作ることに誇りを持ち、すべての訪問が思い出に残る変容的な経験となるようにしています。',
            statStaff: '15+',
            statStaffLabel: '熟練した専門家',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'ゲスト満足度',
            staffImageAlt: 'ムトゥムニアーユルヴェーダビーチリゾートの献身的なスタッフチーム',
            commitmentBadge: '私たちのコミットメント',
            excellenceCare: '卓越とケア',
            ctaLabel: 'お問い合わせ',
            ctaHeading: 'ウェルネスジャーニーを始める準備はできていますか？',
            ctaDesc: 'パーソナライズされたアーユルヴェーダリトリートを予約するために、私たちのチームにお問い合わせください。治療、宿泊施設、または特別なウェルネスパッケージについてご質問がある場合、私たちはあなたの完璧な逃げを作成するお手伝いをする準備ができています。',
            ctaButtonContact: '今すぐお問い合わせ',
            ctaButtonRooms: 'ルームを探索',
            contactUs: 'お問い合わせ',
            quickInfoCall: 'お電話ください',
            quickInfoEmail: 'メールをお送りください',
            quickInfoLocation: '場所',
            locationCity: 'ベルワラ、スリランカ'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'あなたの聖域が待っています',
            heroSubtitle: '癒し、回復、深い平和のために設計された川辺の聖域、穏やかなBentota川沿いに。',
            exploreRooms: '客室を探索',

            filterAll: 'すべて',
            filterDeluxeRooms: 'デラックスルーム',
            filterRiverViewDeluxe: 'リバービューデラックス',

            deluxeRoomName: 'デラックスルーム',
            deluxeRoomCategory: 'デラックスルーム',
            deluxeRoomDesc: '自然の木の要素とリバーサイドの眺めを備えた調和のとれた部屋で、完璧な静けさを。',

            riverViewDeluxeName: 'リバービューデラックス',
            riverViewDeluxeCategory: 'リバーサイドデラックスルーム',
            riverViewDeluxeDesc: '川の優しい音で目覚め、パノラマのリバーサイドビューをこのエレガントなデラックスルームでお楽しみください。',

            noRoomsFound: 'このカテゴリーに部屋が見つかりません。',
            roomSize: '部屋の広さ',
            guests: '宿泊者',
            amenitiesCount: '設備',
            roomAmenities: '部屋の設備',
            specialFeatures: '特別な特徴',

            kingSizeBed: 'キングサイズベッド',
            workDesk: 'ワークデスク',
            rainShower: 'レインシャワー',
            teaStation: 'ティーステーション',
            privateTerrace: 'プライベートテラス',
            binoculars: '双眼鏡',

            riverView: 'リバービュー',
            naturalLighting: '自然光',
            gardenView: 'ガーデンビュー',
            sunriseBalcony: 'サンライズバルコニー',
            soundOfRiver: '川の音',

            bookNow: '今すぐ予約',
            viewDetails: '詳細を見る',
            viewRoom: '部屋を見る',

            allRoomsInclude: '全室に含まれるもの',
            essentialComforts: 'あなたのウェルネス旅のための基本的な快適さ',

            highSpeedWifi: '高速Wi-Fi',
            herbalTea: 'ハーブティーセレクション',
            climateControl: '空調',
            organicToiletries: 'オーガニックトイレタリー',
            dailyHousekeeping: '毎日清掃',
            concierge: '24/7コンシェルジュ',
            yogaMat: 'ヨガマット＆プロップス',

            beginHealing: '癒しの旅を始めましょう',
            beginHealingDesc: '静かな川辺の環境で本物のアーユルヴェーダウェルネスを体験し、体を養い、心を落ち着け、精神を回復してください。',
            reserveRoom: '部屋を予約',
            speakAdvisor: 'ウェルネスアドバイザーと話す',

            exploreOurRooms: '客室を探索'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'デラックス リバービュールーム — テラスまたはプライベートバルコニー付きの快適さ',
            heroSubtitle: 'Bentota川の穏やかな水にインスパイアされた川辺の静かな隠れ家で、現代的な設備と優しい川風とともにリラックス。',
            bookThisRoom: 'この部屋を予約',
            callReservations: '予約に電話',

            navAll: 'すべて',
            navDeluxe: 'デラックス',
            navRiverViewDeluxe: 'リバービューデラックス',

            soothingHideawayTitle: '川辺の穏やかな隠れ家',
            soothingHideawayDesc: 'デラックス リバービュールームは、ゆったりした朝と慌ただしくない夕暮れのために作られています。柔らかな中間色調、大きな窓、丁寧な照明が川の景色を室内に取り込み、バルコニーは流れる水の上にあるあなただけのスペースに。',

            highlight1Title: 'パノラマリバービュー',
            highlight1Desc: 'プライベートバルコニーから穏やかな川の景色と黄金の日の出で目覚める。',
            highlight2Title: '優雅な川辺のインテリア',
            highlight2Desc: '柔らかいニュートラルカラー、温かみのある木材のアクセント、豊富な自然光。',
            highlight3Title: '穏やかな睡眠体験',
            highlight3Desc: 'プレミアムリネン付きのふかふかキングサイズベッドで回復的な休息を。',

            atAGlance: '概要',
            statSizeLabel: '広さ',
            statViewLabel: '眺望',
            statViewValue: 'リバービュー',
            statGuestsLabel: '定員',
            statBedLabel: 'ベッド',
            statBedValue: 'キングまたはツイン',
            reserve: '予約',

            includedWithStay: '滞在に含まれるもの',
            thoughtfulTouches: '心遣いの細部、終日快適',
            enhancedCleanliness: '強化された清潔・安全基準',

            inclusion1: 'Breezeレストランでの朝食・昼食・夕食無料',
            inclusion2: '客室内高速Wi-Fiとワークスペース',
            inclusion3: '24時間ルームサービスとコンシェルジュ',
            inclusion4: '毎日のハウスキーピングと夜のターンダウン',
            inclusion5: 'インフィニティプールとアーユルヴェーダスパ施設の利用',
            inclusion6: '無料駐車場と近隣観光地へのシャトルサービス',

            amenityGroup1Title: '部屋の特徴',
            amenityGroup1Item1: '38㎡の空間',
            amenityGroup1Item2: '座席付きプライベートバルコニー',
            amenityGroup1Item3: '個別空調',
            amenityGroup1Item4: '部屋のセーフ',

            amenityGroup2Title: 'バス体験',
            amenityGroup2Item1: '温水・冷水レインシャワー',
            amenityGroup2Item2: 'プレミアムバスアメニティ',
            amenityGroup2Item3: 'ドライヤー',
            amenityGroup2Item4: '柔らかいバスローブとスリッパ',

            amenityGroup3Title: '室内の快適さ',
            amenityGroup3Item1: '55インチスマートTV（ケーブル付き）',
            amenityGroup3Item2: 'コーヒー・ティーステーション',
            amenityGroup3Item3: '直通電話',

            amenityGroup4Title: '接続性',
            amenityGroup4Item1: '無料Wi-Fi',
            amenityGroup4Item2: 'ワークデスク',
            amenityGroup4Item3: '24時間フロントサポート',

            inRoomEssentials: '室内の必需品',
            everythingYouNeed: '自宅のように感じられるすべて',
            inRoomEssentialsDesc: '途切れない接続から厳選された飲み物まで——デラックス リバービュールームは余暇と実用性を融合させ、大切な瞬間に集中できるように。',

            complimentaryWifi: '無料Wi-Fi',
            coffeeTeaStation: 'コーヒー・ティーステーション',
            roomService: '24時間ルームサービス',
            rainShower: 'レインシャワー',

            byTheRiver: '川辺で',
            slowDownBreathe: 'ゆっくりして、新鮮な空気を吸ってください',

            readyToStay: '滞在の準備は？',
            reserveDeluxeRiverViewToday: '今日、デラックス リバービュールームを予約',
            speakReservations: '最高の料金と特別オファーのために予約チームにお問い合わせください。',
            checkAvailability: '空室確認'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'デラックスルーム — テラスまたはプライベートバルコニー付きの快適さ',
            heroSubtitle: 'Bentota川の穏やかな水にインスパイアされた川辺の静かな隠れ家で、現代的な設備と優しい川風とともにリラックス。',
            bookThisRoom: 'この部屋を予約',
            callReservations: '予約に電話',

            navAll: 'すべて',
            navDeluxe: 'デラックス',
            navRiverViewDeluxe: 'リバービューデラックス',

            soothingHideawayTitle: '川辺の穏やかな隠れ家',
            soothingHideawayDesc: 'デラックスルームは、ゆったりした朝と慌ただしくない夕暮れのために作られています。柔らかな中間色調、大きな窓、丁寧な照明が川の景色を室内に取り込み、バルコニーは流れる水の上にあるあなただけのスペースに。',

            highlight1Title: 'パノラマリバービュー',
            highlight1Desc: 'プライベートバルコニーから穏やかな川の景色とトロピカルな日の出で目覚める。',
            highlight2Title: '優雅な川辺のインテリア',
            highlight2Desc: '柔らかいニュートラルカラー、温かみのある木材のアクセント、豊富な自然光。',
            highlight3Title: '穏やかな睡眠体験',
            highlight3Desc: 'プレミアムリネン付きのふかふかキングサイズベッドで回復的な休息を。',

            atAGlance: '概要',
            statSizeLabel: '広さ',
            statViewLabel: '眺望',
            statViewValue: 'リバービュー',
            statGuestsLabel: '定員',
            statBedLabel: 'ベッド',
            statBedValue: 'キングまたはツイン',
            reserve: '予約',

            includedWithStay: '滞在に含まれるもの',
            thoughtfulTouches: '心遣いの細部、終日快適',
            enhancedCleanliness: '強化された清潔・安全基準',

            inclusion1: 'Breezeレストランでの朝食・昼食・夕食無料',
            inclusion2: '客室内高速Wi-Fiとワークスペース',
            inclusion3: '24時間ルームサービスとコンシェルジュ',
            inclusion4: '毎日のハウスキーピングと夜のターンダウン',
            inclusion5: 'インフィニティプールとアーユルヴェーダスパ施設の利用',
            inclusion6: '無料駐車場と近隣観光地へのシャトルサービス',

            amenityGroup1Title: '部屋の特徴',
            amenityGroup1Item1: '41㎡の空間',
            amenityGroup1Item2: '座席付きプライベートバルコニー',
            amenityGroup1Item3: '個別空調',
            amenityGroup1Item4: '部屋のセーフ',

            amenityGroup2Title: 'バス体験',
            amenityGroup2Item1: '温水・冷水レインシャワー',
            amenityGroup2Item2: 'プレミアムバスアメニティ',
            amenityGroup2Item3: 'ドライヤー',
            amenityGroup2Item4: '柔らかいバスローブとスリッパ',

            amenityGroup3Title: '室内の快適さ',
            amenityGroup3Item1: '55インチスマートTV（ケーブル付き）',
            amenityGroup3Item2: 'コーヒー・ティーステーション',
            amenityGroup3Item3: '直通電話',

            amenityGroup4Title: '接続性',
            amenityGroup4Item1: '無料Wi-Fi',
            amenityGroup4Item2: 'ワークデスク',
            amenityGroup4Item3: '24時間フロントサポート',

            inRoomEssentials: '室内の必需品',
            everythingYouNeed: '自宅のように感じられるすべて',
            inRoomEssentialsDesc: '途切れない接続から厳選された飲み物まで——デラックスルームは余暇と実用性を融合させ、大切な瞬間に集中できるように。',

            complimentaryWifi: '無料Wi-Fi',
            coffeeTeaStation: 'コーヒー・ティーステーション',
            roomService: '24時間ルームサービス',
            rainShower: 'レインシャワー',

            byTheRiver: '川辺で',
            slowDownBreathe: 'ゆっくりして、新鮮な空気を吸ってください',

            readyToStay: '滞在の準備は？',
            reserveDeluxeToday: '今日、デラックスルームを予約',
            speakReservations: '最高の料金と特別オファーのために予約チームにお問い合わせください。',
            checkAvailability: '空室確認'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: '川辺のアーユルヴェーダ',
            heroTagline: 'Aluthgamaでバランスを見つけ、深く呼吸し、エネルギーを回復してください',
            exploreResort: 'リゾートを探す',
            bookNow: '今すぐ予約',

            welcomeLabel: 'ようこそ',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Bentota川の穏やかな岸辺に位置するMuthumuni Ayurveda River Resortは、古代の癒しの伝統と静かな自然美が調和した場所です。私たちの聖域は、川の優しい流れとアーユルヴェーダの永遠の知恵が出会う、変容をもたらすウェルネスへの旅へとあなたを誘います。',
            welcomeDesc2: 'パーソナライズされたアーユルヴェーダ施術を体験し、ドーシャに合わせた栄養価の高い料理を味わい、息をのむような川の眺めを楽しめる優雅な客室でくつろいでください。再生、リラクゼーション、スピリチュアルな更新を求める方々へ、私たちの献身的なアーユルヴェーダ専門家とウェルネスチームが最後までサポートいたします。',
            learnMore: '詳しく見る',
            contactUs: 'お問い合わせ',
            welcomeImageCaption: 'アーユルヴェーダウェルネス＆川辺のリトリート',
            welcomeImageLocation: 'Aluthgama, スリランカ',

            highlightTitle: '川辺のアーユルヴェーダ聖域',
            highlightDesc: 'Bentotaの穏やかな川辺でホリスティックな癒しを発見。オーダーメイドの施術から静かなバルコニー、心を込めた料理まで、すべてがあなたの自然なリズムを取り戻すために設計されています。',

            roomsTitle: '客室',
            roomsDesc: 'あなたのペースに合う聖域をお選びください。風通しの良いスイートから居心地の良いデラックスルームまで、柔らかいリネン、温かみのある木材、朝日を浴びるバルコニーが揃っています。',
            room1Title: 'デラックスルーム',
            room1Desc: 'ふかふかのベッド、庭の眺め、温かみのある木のアクセントで日常の安らぎを提供する居心地の良い隠れ家。',
            room2Title: 'デラックス リバービュー',
            room2Desc: '穏やかな川の景色で目覚め、柔らかいリネンとプライベートバルコニーで平和な朝を迎える。',
            viewRoom: '客室を見る',
            bookableNow: '今すぐ予約可能',
            riverBreezeReady: '川のそよ風対応',
            roomBadge: '川辺の逃避',

            achievementsTitle: '川辺で信頼されるウェルネス',
            achievement1Title: '満足ゲスト',
            achievement1Count: '1,000+',
            achievement2Title: 'アーユルヴェーダ施術',
            achievement2Count: '20+',
            achievement3Title: 'ウェルネス卓越の年数',
            achievement3Count: '15+',
            achievement4Title: '旅行者の称賛',
            achievement4Count: '1,000+',

            experiencesTitle: 'Muthumuni Ayurveda River Resortの体験を探る',
            experiencesDesc: 'アーユルヴェーダの旅から厳選されたツアーまで、滞在を忘れられないものにする体験をお選びください。',
            planYourStay: '滞在を計画する',
            experience1Title: '客室',
            experience1Desc: 'バルコニー付きの開放的な空間、川または庭の眺め、ゆったり過ごすための心遣いの快適さ。',
            experience2Title: 'アーユルヴェーダスパ',
            experience2Desc: '伝統的な儀式で提供される本格療法、蒸気浴、回復マッサージ。',
            experience3Title: '川辺でのお食事',
            experience3Desc: '体と心を養うよう作られた栄養豊富なスリランカ料理と国際料理。',
            experience4Title: '体験＆ツアー',
            experience4Desc: 'Bentota川のボートサファリ、寺院巡り、水上スポーツ、Bentota周辺の文化ツアー。',

            galleryTitle: 'Muthumuni Ayurveda River Resortの瞬間',
            galleryDesc: '川辺の聖域を垣間見る——日の出、穏やかな施術、滋養たっぷりの料理、あなたのためにある静かな一角。',
            gallery1Alt: 'Muthumuniの川辺に並ぶヤシの木と陽光',
            gallery2Alt: 'アーユルヴェーダオイル施術中',
            gallery3Alt: 'リゾートプールとラウンジチェア',
            gallery4Alt: 'スパ用に準備されたハーブ原料',
            gallery5Alt: '川辺で日没を楽しむカップル',
            gallery6Alt: '川に向けたヨガデッキ',
            gallery7Alt: 'トロピカルガーデンの小道',
            gallery8Alt: 'ヘルシー朝食',
            gallery9Alt: '穏やかな川の眺め',
            gallery10Alt: '夕暮れ時の温かいリゾート外観',
            gallery11Alt: 'アーユルヴェーダのハーブとオイル展示',
            gallery12Alt: 'ガーデン脇の居心地よい席',

            boatLabel: '川の冒険',
            boatTitle: 'Bentota川ボートライド',
            boatDesc1: '私たちの魅力的なボートライドでBentota川の魔法を体験してください。滑行于宁静水道、周围环绕茂密的红树林，可观赏到色彩斑斓的翠鸟、鳄鱼、巨蜥和顽皮的猴子。非常适合热爱自然和摄影的客人，捕捉难忘瞬间。',
            boatDesc2: '清晨の穏やかなクルーズ、ロマンチックなサンセットツアー、冒険的な野生動物探索などをお選びください。経験豊富なガイドが川の生態系について興味深い情報を共有します。プライベートチャーターでカスタマイズするか、グループツアーで自然とより深くつながることもできます。',
            boatFeature1: 'マングローブを通る風光明媚なクルーズ',
            boatFeature2: '野生動物観察 — 鳥、ワニ、サル',
            boatFeature3: '日の出・日没ボートツアーオプション',
            boatFeature4: '経験豊富な地元ガイド付き',
            boatImageAlt: 'Bentota川のボートライド',

            poolLabel: '水の静寂',
            poolTitle: 'プールエリア',
            poolDesc1: '私たちの澄んだインフィニティプールで静けさに浸ってください。透明な水面と豊かなトロピカルガーデンが交わる場所。リラクゼーションと再生のために設計されたプールエリアは、スリランカの太陽の下でくつろぐのに最適な逃避先です。',
            poolDesc2: '朝の爽快な泳ぎ、午後の読書タイム、夜の静かな水浴びなど、どんな時間も理想的な環境で過ごせます。快適なサンデッキ、シェード付きカバナ、丁寧なプールサイドサービスに囲まれ、すべての瞬間が大切な思い出になります。',
            poolFeature1: '温度管理されたインフィニティプール',
            poolFeature2: 'トロピカルガーデンに囲まれた風景',
            poolFeature3: 'プールサイドのドリンク＆ヘルシースナック',
            poolFeature4: 'プレミアムサンデッキ＆パラソル',
            poolImageAlt: 'リラックスできるプールエリア',

            testimonialsTitle: 'ゲストの滞在感想',

            bookingDestination: '目的地',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'チェックイン',
            bookingCheckOut: 'チェックアウト',
            bookingGuests: 'ゲスト',
            guestsOption1: '1名',
            guestsOption2: '2名',
            guestsOption3: '3名',
            guestsOption4: '4名以上',
            bookingCheckAvailability: '空室確認',

            service1Title: 'ホリスティック・アーユルヴェーダ療法',
            service1Desc: '個別カウンセリング、本格的なハーブオイル、経験豊富なアーユルヴェーダ医師が指導する毎日の施術。',

            service2Title: '川辺の客室',
            service2Desc: '川の優しい音で目覚め、プライベートバルコニーと深い休息のための落ち着いた内装。',

            service3Title: 'ウェルネス料理',
            service3Desc: '新鮮なスリランカ産食材、植物中心のメニュー、ドーシャに合わせた個別食事プラン。',

            service4Title: 'ヨガとマインドフルネス',
            service4Desc: '日の出ヨガ、日没瞑想、波のリズムに合わせた呼吸法セッション。',

            service5Title: '川辺＆海岸エクスカーション',
            service5Desc: 'Bentota川のボートライド、ウミガメ孵化場見学、スパイスガーデン散策、村のサイクリングツアー。'
        },
        aboutus2: {
            heroTitle: '私たちについて',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: '古の知恵と穏やかな川辺の美がMuthumuni Ayurveda River Resortで出会う',
            heroTagline2: 'パーソナライズされたアーユルヴェーダ施術、川の眺め、本物のスリランカのおもてなし',
            slide1: 'アーユルヴェーダの癒し',
            slide2: '川辺の静寂',
            slide3: '庭の穏やかさ',
            slide4: 'ハーブ療法',
            slide5: '川のウェルネス',
            historyLabel: '私たちの歩み',
            historyTitle: 'Muthumuni Ayurveda River Resortの歴史',
            historyDesc1: '20年以上前に設立されたMuthumuni Ayurveda River Resortは、スリランカの静かな川辺の風景と古来のアーユルヴェーダの知恵が融合する聖域を作りたいというビジョンから生まれました。ささやかなウェルネス・リトリートとして始まったものが、今日ではアルトガマで最も愛されるホリスティック・ヒーリングと若返りの目的地へと成長しました。',
            historyDesc2: '伝統的なアーユルヴェーダ実践者の世代にインスパイアされた創設者たちは、現代の快適さと本物のスリランカのおもてなしを提供しながら、これらの時代を超えた癒しの技を保存しようとしました。長年にわたり、私たちは本物のウェルネス体験へのコミットメントを貫き、施設を拡張しながらも、個別対応のケアという遺産を見失うことはありませんでした。',
            historyDesc3: '今日、Muthumuniはアーユルヴェーダの永続的な力を象徴し、世界中から数千人のゲストを迎えています。一人ひとりの訪問者が私たちの物語の一部となり、穏やかな川辺の楽園でバランス、癒し、変容を見つけています。',
            statYear: '15+',
            statYearLabel: 'ウェルネス卓越の年数',
            statGuest: '1,000+',
            statGuestLabel: '満足したゲスト',
            experienceLegacy: '私たちの遺産を体験',
            established: '設立',
            sinceYear: '1993年以来',
            chairmanLabel: '会長メッセージ',
            chairmanTitle: 'ケアに導かれ、アーユルヴェーダに根ざして',
            chairmanDesc1: 'Muthumuni Ayurveda River Resortへようこそ。20年以上にわたり、私たちの目的はシンプルです。アーユルヴェーダの永遠の知恵に根ざした本物の癒しを、スリランカの温かいおもてなしとともに提供することです。',
            chairmanDesc2: 'ここでは、療法や料理、空間の静けさまで、すべての細部があなたにゆっくりと過ごし、バランスを取り戻し、自分自身と再びつながることを助けるために設計されています。あなたのウェルネス・ジャーニーの一部になれることを光栄に思います。',
            chairmanDesc3: '献身的なチームを代表して、Muthumuniを定義するケア、誠実さ、静寂をぜひ体感してください。',
            chairmanBadge: '会長',
            chairmanName: 'ニハル・ムトゥムニ 氏',
            chairmanSignature: '— ニハル・ムトゥムニ 氏',
            chairmanImageAlt: '会長 ニハル・ムトゥムニ 氏',
            staffLabel: '私たちのチーム',
            staffTitle: '献身的なスタッフをご紹介します',
            staffDesc1: 'Muthumuni Ayurveda River Resortでは、チームがすべての中心です。スタッフは厳選され、専門的なトレーニングを受けたプロフェッショナルで、アーユルヴェーダのウェルネスと本物のホスピタリティに深い情熱を持っています。',
            staffDesc2: '経験豊富なアーユルヴェーダ実践者や熟練のマッサージセラピストから、専任のホスピタリティチームまで、すべてのメンバーが長年の専門知識と真心を込めたケアをゲストとのあらゆる交流にもたらします。私たちは、真のウェルネスが治療だけでなく、あなたの旅を本当に大切に思う人々の温かさと配慮から生まれると信じています。',
            staffDesc3: 'スタッフは最新のアーユルヴェーダ実践を継続的に学びながら、最高のプロフェッショナリズムと文化的配慮を維持しています。私たちはゲストとの意味深いつながりを築くことを誇りに思い、すべての訪問が記憶に残り、変容をもたらす体験となるよう努めています。',
            statStaff: '15+',
            statStaffLabel: '熟練したプロフェッショナル',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'ゲスト満足度',
            staffImageAlt: 'Muthumuni Ayurveda River Resortの献身的なスタッフチーム',
            commitmentBadge: '私たちの約束',
            excellenceCare: '卓越とケア',
            ctaLabel: 'お問い合わせ',
            ctaHeading: 'ウェルネス・ジャーニーを始める準備はできていますか？',
            ctaDesc: 'パーソナライズされたアーユルヴェーダ・リトリートをご予約いただくために、ぜひチームまでご連絡ください。療法、宿泊施設、特別なウェルネスパッケージについてのご質問がございましたら、完璧な逃避行をお手伝いいたします。',
            ctaButtonContact: '今すぐお問い合わせ',
            ctaButtonRooms: 'お部屋を見る',
            quickInfoCall: 'お電話ください',
            quickInfoEmail: 'メールをお送りください',
            quickInfoLocation: '所在地',
            locationCity: 'Aluthgama, スリランカ'
        },
        ayurveda2: {
            accordionTitle1: 'パンチャカルマ・アーユルヴェーダとは？',
            accordionDesc1: 'アーユルヴェーダ（「生命の科学」を意味するサンスクリット語）は、古来の全身を癒す体系です。パンチャカルマは浄化と若返りを目的とした一連の療法で、心・体・魂のバランスを回復します。',
            accordionTitle2: 'パンチャカルマ・アーユルヴェーダとあなたの生命エネルギー',
            accordionDesc2: 'パンチャカルマは毒素の除去とドーシャ（ヴァータ、ピッタ、カパ）の調和の再構築に焦点を当てます。治療は各ゲストに合わせて個別化され、長期的な健康と活力をサポートします。',
            accordionTitle3: 'ヴァータ・ドーシャ',
            accordionDesc3: 'ヴァータは運動と循環を司ります。バランスが取れていると創造性と活力を育みます。パンチャカルマは過剰なヴァータを鎮めるグラウンディング療法を提供し、均衡を取り戻します。',
            accordionTitle4: 'ピッタ・ドーシャ',
            accordionDesc4: 'ピッタは消化と代謝を司ります。冷却・回復系の療法でピッタをバランスさせ、炎症やイライラを軽減します。',
            accordionTitle5: 'カパ・ドーシャ',
            accordionDesc5: 'カパは構造と安定性を支えます。活力と循環を高める療法で過剰なカパを減らし、軽やかさと柔軟性を促進します。',
            close: '閉じる',
            next: '次へ',
            previous: '前へ',
            treatmentsTitle: '当リゾートのシグネチャー・パンチャカルマ・アーユルヴェーダ施術',
            treatmentsSubtitle: 'デトックス・若返り・バランス回復のための伝統療法。',
            bookTreatment: 'この施術を予約',
            benefitsTitle: 'パンチャカルマ施術の効果',
            shirodhara: 'シローダーラ',
            shirodharaDesc: '温かいハーブオイルを額に優しく流し、心を鎮める。',
            shirodhara1: 'ストレスと不安を軽減',
            shirodhara2: '睡眠の質を向上',
            shirodhara3: '精神の明晰さを高める',
            steamBath: 'スチームバス',
            steamBathDesc: '毛穴を開き筋肉をほぐすデトックス蒸気療法。',
            steamBath1: '体内の毒素を排出',
            steamBath2: '血行を促進',
            steamBath3: '筋肉の緊張を緩和',
            flowerBath: 'フラワーバス',
            flowerBathDesc: '香り高い花を浮かべた癒しの入浴。',
            flowerBath1: '神経系を落ち着かせる',
            flowerBath2: '肌に潤いを与える',
            flowerBath3: '気分を高揚させる',
            headMassage: 'ヘッドマッサージ',
            headMassageDesc: '頭皮を対象としたリラックスマッサージで緊張を解放。',
            headMassage1: '頭痛を軽減',
            headMassage2: '頭皮の健康を改善',
            headMassage3: 'リラックスを促進',
            faceMassage: 'フェイシャルマッサージ',
            faceMassageDesc: '顔の輝きを高めストレスを軽減する若返りマッサージ。',
            faceMassage1: '肌のトーンを改善',
            faceMassage2: '顔の緊張を軽減',
            faceMassage3: 'リンパドレナージュを促進',
            neckMassage: 'ネックマッサージ',
            neckMassageDesc: '首のこわばりと緊張を和らげる集中マッサージ。',
            neckMassage1: '首の痛みを緩和',
            neckMassage2: '柔軟性を向上',
            neckMassage3: 'ストレスを軽減',
            shoulderMassage: 'ショルダーマッサージ',
            shoulderMassageDesc: '肩のこわばりと不快感を和らげるターゲットマッサージ。',
            shoulderMassage1: '肩の痛みを軽減',
            shoulderMassage2: '姿勢を改善',
            shoulderMassage3: '筋肉をリラックス',
            bodyMassage: 'ボディマッサージ',
            bodyMassageDesc: '全身の緊張を解き、全体的なリラクゼーションと健康を促進。',
            bodyMassage1: '血行を促進',
            bodyMassage2: '筋肉痛を緩和',
            bodyMassage3: 'リラックスを促進',
            backMassage: 'バックマッサージ',
            backMassageDesc: '背中の痛みと緊張をターゲットにした治療マッサージ。',
            backMassage1: '背中の痛みを軽減',
            backMassage2: '脊椎の健康を改善',
            backMassage3: 'ストレスを軽減',
            footMassage: 'フットマッサージ',
            footMassageDesc: '足の痛みを和らげ、リラックスを促す心地よいマッサージ。',
            footMassage1: '血行を改善',
            footMassage2: '足の疲れを軽減',
            footMassage3: 'リラックスを促進',
            purgative: '浄化（パージ）',
            purgativeDesc: '消化管から過剰なピッタと毒素を排出する浄化療法。',
            purgative1: '大腸をクレンジング',
            purgative2: 'ピッタ・ドーシャをバランス',
            purgative3: '消化の健康を向上',
            nasalClearing: '鼻腔クレンジング',
            nasalClearingDesc: '副鼻腔をクリアにし、呼吸機能を改善する治療的鼻腔ケア。',
            nasalClearing1: '鼻づまりを解消',
            nasalClearing2: '呼吸を改善',
            nasalClearing3: '副鼻腔トラブルを緩和',
            powderMassage: 'パウダーマッサージ',
            powderMassageDesc: 'ハーブパウダーを使った角質除去マッサージで肌を若返らせ爽快に。',
            powderMassage1: '古い角質を除去',
            powderMassage2: '肌の質感を改善',
            powderMassage3: '血行を促進',
            intensiveMassageDesc: '慢性的な緊張や筋肉のこりに対して、強い圧力と専門的な技術を用いた深い治療マッサージです。',
            intensiveMassage1: '深い筋肉の緊張を緩和',
            intensiveMassage2: '血行を改善',
            intensiveMassage3: '筋肉痛を軽減',
            thermoMassage: '温熱マッサージ',
            thermoMassageDesc: '温めた治療用ハーブオイルを使用した温かいマッサージで、リラクゼーションと治癒効果を高めます。',
            thermoMassage1: '痛んだ筋肉を和らげる',
            thermoMassage2: '深いリラクゼーションを促進',
            thermoMassage3: 'エネルギーの流れを向上',
            synchronMassage: 'シンクロナイズドマッサージ',
            synchronMassageDesc: '2人のセラピストによる同期マッサージで、完全な身体の調和とエネルギーのバランスを実現します。',
            synchronMassage1: '全身の調和',
            synchronMassage2: 'バランスの取れたエネルギー流',
            synchronMassage3: '深いリラクゼーション体験',
            specialMassage: 'スペシャルマッサージ',
            specialMassageDesc: 'お客様の特定の健康ニーズと個人のウェルネス目標に合わせたカスタマイズされたマッサージ療法です。',
            specialMassage1: 'パーソナライズド治療',
            specialMassage2: '特定の悩みに焦点',
            specialMassage3: 'カスタマイズされた癒しアプローチ',
            benefit1Title: 'デトックス：',
            benefit1Desc: 'パンチャカルマ療法は体内の毒素を排出させ、全体的な健康と活力を高めます。',
            benefit2Title: '消化改善：',
            benefit2Desc: 'これらの療法は消化機能を強化し、栄養吸収と代謝を向上させます。',
            benefit3Title: 'ストレス軽減：',
            benefit3Desc: 'パンチャカルマは心身を落ち着かせる効果で知られ、ストレスと不安を減少させます。',
            benefit4Title: '免疫力強化：',
            benefit4Desc: '定期的なパンチャカルマは免疫系を強化し、病気への抵抗力を高めます。',
            benefit5Title: '若返り：',
            benefit5Desc: '細胞再生を促進し、肌の健康を改善して若々しい外見をもたらします。',
            benefit6Title: 'ドーシャのバランス：',
            benefit6Desc: 'パンチャカルマはヴァータ・ピッタ・カパのバランスを回復させ、アーユルヴェーダの健康原則に基づく健康維持に不可欠です。',
            akkupancharTitle: '鍼療法',
            akkupancharDesc1: 'は、身体の特定のポイントにハーブペーストとオイルを塗布する古代のアーユルヴェーダ療法です。この治療法は、重要なエネルギーチャンネルを刺激し、治癒を促進するように設計されています。',
            akkupancharBenefit: '主な効果：',
            akkupancharDesc2: 'この専門療法は、慢性的な痛みの緩和、関節の柔軟性の向上、血液循環の促進、そして身体の自然なエネルギーフローの回復に役立ちます。深い治療的癒しと若返りを求める方に特に効果的です。',
            akkupancharApplication: '治療的応用：',
            akkupancharDesc3: '鍼療法は、身体全体の特定のマルマポイント（重要な接合部）をターゲットにし、ドーシャのバランスを取り、最適な健康とウェルネスを促進するために慎重に選ばれたハーブ調合物を使用します。',
            akkupancharTransform: '変容を体験：',
            akkupancharDesc4: 'Muthumuni Ayurveda River Resortでは、経験豊富な施術者が各鍼療法セッションをあなた独自の健康ニーズに対応するようカスタマイズし、深遠で永続的な癒しの体験を保証します。',
            gallery1: 'シローダーラ療法',
            gallery2: 'スチームバス',
            gallery3: 'フラワーバス',
            gallery4: 'ヘッドマッサージ',
            gallery5: 'ボディマッサージ',
            gallery6: 'ネックマッサージ',
            gallery7: 'フェイシャルマッサージ',
            gallery8: 'ショルダーマッサージ',
            sectionEyebrow: 'Muthumuniのパンチャカルマ・アーユルヴェーダ',
            sectionDescription: '川辺のリトリートで古代の癒し、パンチャカルマ・アーユルヴェーダを体験。専門のアーユルヴェーダ施術者がデトックス・若返り・身心灵のバランス回復を目的としたパーソナライズド治療を提供します。',
            heroTitle: 'パンチャカルマ・アーユルヴェーダ',
            heroSubtitle: 'アルトガマで身体・心・魂を若返らせる',
            heroAlt: 'Muthumuni River Resortのアーユルヴェーダ＆ウェルネス',
            treatmentProgramme: {
                title: 'アーユルヴェーダ治療プログラム',
                subtitle: 'バランス・デトックス・深い再生への旅',
                intro: '身体を回復し、心を落ち着かせ、エネルギーを更新するために設計された平和なリトリートで、本格的なアーユルヴェーダ治癒を体験してください。到着した瞬間から、私たちのチームがすべての詳細を処理します—あなたは健康に完全に集中できます。',
                welcomeTitle: 'ウェルカムと穏やかなスタート',
                welcome1: '空港送迎とホテルへの移動',
                welcome2: '温かい歓迎とホテルのオリエンテーション',
                welcome3: '週間ウェルネススケジュールの紹介',
                welcome4: 'リラクゼーションマッサージ（1日目）アーユルヴェーダセンターで旅の疲れを解放し、治療に向けて身体を準備',
                doctorTitle: '医師相談と個人プラン',
                doctor1: 'アーユルヴェーダ医師相談（2日目 – 午前）',
                doctor2: 'ドーシャ/体質タイプと健康上の懸念の完全評価',
                doctor3: 'リクエストに応じて通訳が利用可能',
                doctor4: '医師があなたのニーズと目標に合わせて個別化された治療計画を作成',
                dailyTitle: '毎日のアーユルヴェーダ療法',
                daily1: '毎日4～5回の治療（医師の推奨による）',
                daily2: '体質と状態に基づいて選択された療法',
                daily3: '必要に応じて特別なマッサージが追加される場合があります',
                daily4: '医師が毎日進捗を監視し、最良の結果を保証するために治療とハーブサポートを調整することがあります',
                daily5: '適切であれば、穏やかな浄化/下剤プロセスが推奨される場合があります',
                herbalTitle: 'ハーブ医薬サポート',
                herbalIntro: '医師が処方したハーブ薬を1日2回提供：',
                herbal1: '朝食時',
                herbal2: '夕食時',
                herbalClosing: '内部治癒、デトックス、長続きするバランスをサポート。',
                yogaTitle: '心身の調和のためのヨガと瞑想',
                yoga1: '週4回のヨガセッション（約1時間）',
                yoga2: '週2回の瞑想セッション：',
                yoga3: '——島の寺院でのユニークなスピリチュアル体験、ボートでアクセス',
                yoga4: '——僧侶による誘導瞑想（約1時間）',
                wellnessTitle: '含まれるウェルネス体験',
                wellness1: '週間健康料理デモンストレーション',
                wellness2: '無料エクスカーション（文化/自然体験）',
                closingTitle: 'クロージング儀式と出発',
                closing1: '美しいフラワーバス（最終日）—伝統的な再生の儀式',
                closing2: '最終医師相談で進捗を確認し、以下を提供：',
                closing3: '——継続的なウェルネスガイダンス',
                closing4: '——自宅用の処方と推奨事項',
                closing5: '空港への送迎',
            }
        },
        yoga2: {
            heroTitle: 'リゾートでのヨガ',
            heroSubtitle: 'ベルワラでバランス、強さ、内なる平和を見つける',
            heroAlt: 'Muthumuniリゾートでのヨガ',
            importanceEyebrow: 'ウェルネスとバランス',
            importanceTitle: 'ヨガと瞑想の重要性',
            importanceImageAlt: 'ヨガと瞑想の重要性',
            importanceText1: 'ヨガと瞑想は古来の修行法であり、身体的、精神的、感情的な数多くの利点をもたらします。柔軟性、強さ、バランスを高め、ストレスや不安を軽減します。',
            importanceText2: '定期的な実践は集中力の向上、睡眠の質の改善、全体的な幸福感の向上につながります。ヨガはマインドフルネスを促し、日常生活の喧騒の中で内なる自分とつながり、平和を見出す手助けをします。',
            importanceText3: 'Muthumuniリゾートでは、ヨガと瞑想に最適な穏やかな環境を提供し、ゲストが心身魂を再生できるようサポートします。',
            practiceEyebrow: '私たちの実践',
            practiceTitle: 'ヨガの実践と体験',
            practiceImageAlt: 'リゾートでのヨガ実践',
            practiceText1: 'Muthumuniリゾートでは、主に伝統的なハタヨガをプラナヤマ（呼吸法）と組み合わせて実践しています。この包括的なアプローチは、内なる意識を目覚めさせ、クンダリニを穏やかに刺激しつつ、背骨の整列と柔軟性に重点を置いています。',
            practiceText2: 'ヨガセッションは定期的に行われ、初心者から経験者まで対応可能です。時折、アシュタンガヨガなどの特別セッションも開催されます。',
            practiceText3: 'すべてのヨガセッションは専用のヨガシャラで行われ、集中、バランス、マインドフルな動きをサポートする穏やかで静かな空間です。各セッションは通常、太陽礼拝から始まり、プラナヤマと柔軟性・血行促進を目的とした厳選されたアーサナの流れが続きます。',
            practiceText4: '経験豊富なヨガ講師が、ゲスト一人ひとりのニーズ、能力、健康状態に合わせてセッションを調整し、安全で深く有益な体験を提供します。',
            spiritualEyebrow: 'スピリチュアルな旅',
            spiritualTitle: '瞑想とスピリチュアルな活動',
            spiritualSubtitle: '神聖な儀式とガイド付き瞑想セッションでスピリチュアルな実践を深める',
            meditationImageAlt: 'リゾートでの瞑想とスピリチュアルな実践',
            meditationTitle: '瞑想セッション',
            meditationDesc: '伝統的な実践に着想を得たガイド付き瞑想セッションにご参加いただけます。これらのセッションは心を落ち着かせ、意識を深め、平和な環境で感情的・霊的な癒しをサポートするよう設計されています。'
        },
        events2: {
            heroEyebrow: '体験とアクティビティ',
            heroTitle: 'イベント',
            heroSubtitle: 'スリランカの伝統と海岸のラグジュアリーを融合した厳選体験',
            heroAlt: 'Muthumuniでのイベント',
            availableDaily: '毎日開催',
            bookNow: '今すぐ予約',
            highlightsTitle: 'ハイライト',
            detailAlt: '{{title}} の詳細',
            ctaTitle: '思い出を作る準備はできていますか？',
            ctaDescription: 'Muthumuni Ayurveda Beach Resortであなたにぴったりのイベント体験をカスタマイズするため、チームにご連絡ください',
            ctaContact: 'お問い合わせ',
            ctaViewRooms: '客室を見る',
            cookeryTitle: 'クッキングプログラム',
            cookerySubtitle: 'スリランカの味',
            cookeryDescription: 'スリランカ料理の鮮やかな風味に浸る。熟練シェフが実践的なクッキングレッスンを通じて、代々受け継がれてきた伝統レシピを教えます。地元の新鮮な食材を使って香り高いカレー、ホッパー、ココナッツサンボルなどを学びましょう。',
            cookeryHighlight1: '伝統的なスリランカ料理レシピ',
            cookeryHighlight2: '実践的な調理体験',
            cookeryHighlight3: '新鮮な地元食材',
            cookeryHighlight4: 'レシピを持ち帰り可能',
            cookeryHighlight5: 'スパイスガーデンツアー付き',
            meditationTitle: '瞑想プログラム',
            meditationSubtitle: '内なる平和とマインドフルネス',
            meditationDescription: 'インド洋の穏やかな景色を背景に、ガイド付き瞑想セッションで静けさを見つけましょう。経験豊富なインストラクターが古代のマインドフルネス技法、呼吸法、ヨガを指導し、心を落ち着かせ魂をリフレッシュします。',
            meditationHighlight1: '日の出・日の入りセッション',
            meditationHighlight2: 'ビーチフロント瞑想',
            meditationHighlight3: '専門家による指導',
            meditationHighlight4: '呼吸法',
            meditationHighlight5: 'ヨガとマインドフルネス実践',
            bbqTitle: 'BBQパーティー',
            bbqSubtitle: 'ビーチサイドのお祝い',
            bbqDescription: 'ビーチサイドのBBQパーティーで忘れられない夜を。波の音を聞きながら新鮮なシーフード、プレミアム肉、ベジタリアンメニューをグリルで楽しめます。生演奏、ファイヤーダンサー、星空が祝いとつながりの完璧な雰囲気を作り出します。',
            bbqHighlight1: '新鮮なグリルシーフード',
            bbqHighlight2: 'オーシャンフロントダイニング',
            bbqHighlight3: 'ライブエンターテイメント',
            bbqHighlight4: '焚き火体験',
            bbqHighlight5: 'カスタマイズ可能なメニュー',
            boatTitle: 'ボートライド',
            boatSubtitle: '川と海岸の冒険',
            boatDescription: 'ベントタ川と沿岸を巡る魅惑的なボート旅へ。マングローブの森を滑り、珍しい鳥や野生動物を観察したり、ロマンチックなサンセットクルーズを楽しんだり。スリランカの自然美と多様な生態系をユニークな視点で体験できます。',
            boatHighlight1: 'ベントタ川クルーズ',
            boatHighlight2: 'マングローブ探検',
            boatHighlight3: '野生動物観察',
            boatHighlight4: 'サンセットボートツアー',
            boatHighlight5: 'プライベートチャーター可能',
            ayurvedaLecturesTitle: 'アーユルヴェーダ医師の講義',
            ayurvedaLecturesSubtitle: '古代の知恵と現代のウェルネス',
            ayurvedaLecturesDescription: '認定アーユルヴェーダ医師による専門講義でアーユルヴェーダの深い原理を学ぶ。ドーシャのバランス、ハーブ療法、ホリスティックな癒し、そして現代生活への応用を理解できます。インタラクティブなセッションで哲学をわかりやすく日常に活かせるようにします。',
            ayurvedaLecturesHighlight1: '認定アーユルヴェーダ医師',
            ayurvedaLecturesHighlight2: '個別ドーシャ分析',
            ayurvedaLecturesHighlight3: 'ハーブ療法教育',
            ayurvedaLecturesHighlight4: '質疑応答セッション付き',
            ayurvedaLecturesHighlight5: 'お持ち帰りウェルネスガイド',
            traditionalClothsTitle: '伝統衣装着用イベント',
            traditionalClothsSubtitle: '文化遺産体験',
            traditionalClothsDescription: 'スリランカの伝統衣装を着て文化遺産に触れる。専門スタイリストが本格的なカンディアン・サリーや伝統衣装の着方を指導し、それぞれの文化的意味を解説します。特別な機会、文化理解、記念写真に最適です。',
            traditionalClothsHighlight1: 'プロのスタイリング指導',
            traditionalClothsHighlight2: '本物の伝統サリー',
            traditionalClothsHighlight3: '文化的意義の説明',
            traditionalClothsHighlight4: 'プロカメラマン撮影付き',
            traditionalClothsHighlight5: 'ファッションフュージョンワークショップ'
        },
        tours2: {
            heroTitle: 'ツアーとエクスカーション',
            heroSubtitle: 'ベルワラからスリランカの美しさを発見',
            kandeAlt: 'カンデ・ヴィハーラ寺院 - ベルワラ',
            kandeTitle: 'カンデ・ヴィハーラ寺院訪問',
            kandeBuddhaAlt: 'カンデ・ヴィハーラ寺院の巨大仏像',
            bentotaTitle: 'ベントタ川ボートサファリ',
            bentotaAlt: 'ベントタ川ボートサファリ - マングローブと野生動物',
            galleTitle: 'ゴール旧市街ツアー',
            galleAlt: 'ゴール旧市街ツアー',
            sigiriyaTitle: 'シギリヤロック要塞ツアー',
            sigiriyaAlt: 'シギリヤロック要塞ツアー',
            kandyTitle: 'キャンディ文化ツアー',
            kandyAlt: 'キャンディ文化ツアー',
            bookTour: 'このツアーを予約',
            introPara1: 'スリランカは永遠の美しさを持つ国で、金色のビーチ、豊かな緑の風景、古い寺院、活気ある文化が見事に調和しています。',
            introPara2: '穏やかな南西海岸から歴史的な都市、聖地、野生動物保護区、霧深い丘陵地帯まで、どの旅もユニークで忘れられない体験をお届けします。',
            introPara3: 'ベルワラのMuthumuni Ayurveda Beach Resortを拠点に、厳選されたツアーとエクスカーションは、探検・リラックス・ウェルネスのバランスを完璧に保ちながら滞在を豊かにします。',
            kandeDetail1: 'カンデ・ヴィハーラ寺院（Kande Viharaya） – ベルワラ近くで最も象徴的な仏教寺院の一つ。',
            kandeDetail2: '1734年に創建されたこの静かな「山の寺院」は丘の上に位置し、海岸線を見渡す穏やかな景色が広がります。',
            kandeDetail3: '見どころは、高さ48m（160ft）の巨大な座像（スリランカで最も高いもののひとつ）、カンディ時代の精巧な壁画、古い舎利殿、美しい月の石の入口、300年以上の歴史を持つ聖なる菩提樹。',
            kandeDetail4: '半日のスピリチュアル＆カルチャー体験に最適 – 暑さを避けるため朝の訪問がおすすめ。',
            bentotaDetail1: 'ベントタ川沿いの穏やかで美しいボートサファリをお楽しみください。ベルワラ近くで最も人気のある自然ツアーの一つです。',
            bentotaDetail2: '豊かなマングローブ、狭い水路、静かなバックウォーターを進みながら地元の野生動物を観察。',
            bentotaDetail3: 'よく見られるのはオオトカゲ、ワニ、さまざまな鳥（カワセミ、サギ、ワシ）、サル、たまにカワウソや水蛇。',
            bentotaDetail4: '経験豊富な船頭／ガイドが興味深い植物、伝統的な漁法、川沿いの村の暮らしを解説します。',
            bentotaDetail5: '自然愛好家や写真家に最適 – 穏やかでリラックスでき、アーユルヴェーダのウェルネス滞在にぴったり。',
            galleDetail1: '歴史的なゴール要塞（UNESCO世界遺産）を探索。スリランカで最もよく保存された植民地時代の要塞の一つ。',
            galleDetail2: 'オランダ植民地様式の建物、ブティック、カフェ、アートギャラリーが並ぶ石畳の通りを散策。',
            galleDetail3: 'ゴール灯台、オランダ改革派教会、国立海洋博物館、海を見渡す城壁など主要スポットを訪問。',
            galleDetail4: '知識豊富なガイドから要塞の豊かな歴史、建築、文化的重要性について学べます。',
            galleDetail5: '歴史好き、文化好き、スリランカの植民地時代を体験したい方に最適。',
            sigiriyaDetail1: '古代の岩の要塞シギリヤを発見。スリランカを代表するランドマークであり、UNESCO世界遺産。',
            sigiriyaDetail2: '印象的な岩を登り、カーシャパ王の宮殿跡を探索。壁画、水の庭園、有名な鏡の壁が残る。',
            sigiriyaDetail3: '頂上から周辺のジャングルと田園風景のパノラマビューを楽しむ。',
            sigiriyaDetail4: '専門ガイドからシギリヤの魅力的な歴史、建築、伝説について学べます。',
            sigiriyaDetail5: '歴史好き、冒険好き、スリランカの豊かな文化遺産に興味がある方に最適。',
            kandyDetail1: 'スリランカ最後の王都キャンディの活気ある文化を体験。UNESCO世界遺産。',
            kandyDetail2: '世界で最も重要な仏教聖地のひとつ、聖なる歯の寺院（Sri Dalada Maligawa）を訪問。',
            kandyDetail3: 'ペラデニヤ王立植物園を探索。熱帯植物と蘭の膨大なコレクションが広がる。',
            kandyDetail4: 'スリランカの豊かな芸術遺産を披露する伝統的なカンディダンス公演を鑑賞。',
            kandyDetail5: '文化愛好家、歴史好き、スリランカの伝統に深く浸りたい方に最適。'
        },
        rooms: {
            heroTitle: 'あなたの休魂地があなたを待っています',
            heroSubtitle: '癒し、回復、深い平和のために細心に設計された客室。',
            heroAlt: 'ムトゥムニアーユルヴェーダビーチリゾートの客室',
            exploreRooms: '私たちの客室を探索',
            filterAll: 'すべて',
            filterLuxurySuite: 'ラグジュアリースイート',
            filterDeluxeRooms: 'デラックスルーム',
            filterDeluxeSeaView: 'デラックスシービュールーム',
            noRoomsFound: 'このカテゴリで客室が見つかりません。',
            allRoomsInclude: 'すべての客室に含まれます',
            essentialComforts: 'あなたのウェルネスジャーニーのための本質的な快適さ',
            roomSize: '客室サイズ',
            guests: 'ゲスト',
            amenities: '設備',
            roomAmenities: 'ルームアメニティ',
            specialFeatures: '特殊機能',
            bookNow: '今すぐ予約',
            viewDetails: '詳細を表示',
            highSpeedWifi: '高速WiFi',
            herbalTea: 'ハーブティーセレクション',
            climateControl: '気候制御',
            rainShower: 'レインシャワー',
            organicToiletries: 'オーガニック化粧品',
            dailyHousekeeping: '毎日のハウスキーピング',
            concierge: '24/7 コンシェルジュ',
            yogaMat: 'ヨガマットと小道具',
            beginHealing: 'あなたの癒しの旅を始めましょう',
            beginHealingDesc: '体を栄養、心を落ち着かせ、精神を回復させるために設計された環境で本物のアーユルヴェーダウェルネスを体験してください。',
            reserveRoom: '客室を予約',
            speakAdvisor: 'ウェルネスアドバイザーと相談',
            exploreOurRooms: '私たちの客室を探索',
            viewRoom: '客室を表示',
            luxurySuiteName: 'ラグジュアリースイート',
            luxurySuiteCategory: 'ラグジュアリースイート',
            luxurySuiteDesc: '伝統的なアーユルヴェーダの原則に従って設計された広々としたラグジュアリースイートで究極の静寂を体験してください。',
            deluxeRoomName: 'デラックスルーム',
            deluxeRoomCategory: 'デラックスルーム',
            deluxeRoomDesc: '調和のとれた設計の客室で、天然木の要素と落ち着いた水の特徴が完璧な静寂をもたらします。',
            seaViewDeluxeName: 'シービュー付きデラックス',
            seaViewDeluxeCategory: 'デラックスシービューム',
            seaViewDeluxeDesc: 'この優雅に設計されたデラックスルームで、落ち着いた海風と海の全景で目覚めてください。',
            deluxeRoom: {
                resortName: 'Muthumuni Ayurveda Beach Resort',
                heroTitle: 'デラックスルーム — テラスまたはプライベートバルコニー付きの快適さ',
                heroSubtitle: 'ベントタの金色のビーチに動かされた落ち着いた海岸の隠れ家でくつろぎ、現代的な設備と穏やかな海風を組み合わせます。',
                bookThisRoom: 'この部屋を予約',
                callReservations: '予約に電話',
                navAll: 'すべて',
                navDeluxe: 'デラックス',
                navDeluxeSeaView: 'デラックスシービュー',
                navSuite: 'スイート',
                sectionTitle: '穏やかな海岸の隠れ家',
                sectionDesc: 'デラックスルームは、スローな朝と急がない夕日のために作られています。柔らかい中性のトーン、寛大なガラス張り、思慮深い照明が海の景色を招き入れ、バルコニーは海岸線の上にあなた自身の止まり木を提供します。',
                highlight1Title: 'パノラマビーチビュー',
                highlight1Desc: 'プライベートバルコニーから、碧い海と金色の日の出で目覚めてください。',
                highlight2Title: 'エレガントな海岸のインテリア',
                highlight2Desc: '柔らかいニュートラルパレット、温かい木質のアクセント、豊富な自然光。',
                highlight3Title: '静謐な睡眠体験',
                highlight3Desc: '回復的な休息のために厳選されたプレミアムリネン付きのプラッシュキングベッド。',
                atAGlance: '一目で',
                statSize: 'サイズ',
                statSizeValue: '41 平方メートル',
                statView: '景観',
                statViewValue: 'インド洋',
                statGuests: '客人',
                statGuestsValue: '2 人の大人',
                statBed: 'ベッド',
                statBedValue: 'キングまたはツイン',
                reserve: '予約',
                galleryAlt: 'デラックスルームギャラリー',
                inclusionsTitle: '滋在中に含まれるもの',
                inclusionsSubtitle: '思いやりのあるタッチ、一日中の快適さ',
                enhancedCleanliness: '強化された清潔さと安全基準',
                inclusion1: 'Breeze レストランでの無料朝食、昨食、夕食',
                inclusion2: '高速 Wi-Fi と室内ワークスペース',
                inclusion3: '24 時間ルームサービスとコンシェルジュ',
                inclusion4: '毎日のハウスキーピングと夕方のターンダウン',
                inclusion5: 'インフィニティプールとアーユルヴェーダスパ施設へのアクセス',
                inclusion6: '無料駐車場と近くのアトラクションへのシャトルサービス',
                amenityGroup1Title: '客室機能',
                amenityGroup1Item1: '41 平方メートルのスペース',
                amenityGroup1Item2: '座席付きプライベートバルコニー',
                amenityGroup1Item3: '気候制御付きエアコン',
                amenityGroup1Item4: '室内セーフ',
                amenityGroup2Title: 'バス体験',
                amenityGroup2Item1: '冷温水付きレインシャワー',
                amenityGroup2Item2: 'プレミアムバスアメニティ',
                amenityGroup2Item3: 'ヘアドライヤー',
                amenityGroup2Item4: '柔らかいバスローブとスリッパ',
                amenityGroup3Title: '室内快適',
                amenityGroup3Item1: '55インチスマート TV とケーブル',
                amenityGroup3Item2: 'コーヒーと紅茶ステーション',
                amenityGroup3Item3: 'ダイレクトダイヤル電話',
                amenityGroup4Title: '接続性',
                amenityGroup4Item1: '無料 Wi-Fi',
                amenityGroup4Item2: 'ワークデスク',
                amenityGroup4Item3: '24/7 フロントデスクサポート',
                essentialsTitle: '室内必需品',
                essentialsHeading: '家にいるように感じるために必要なすべて',
                essentialsDesc: 'シームレスな接続から注意深く選ばれた飲み物まで、デラックスルームはレジャーと実用性を融合させ、大切な瞬間に集中できるようにします。',
                essential1: '無料 Wi-Fi',
                essential2: 'コーヒーと紅茶ステーション',
                essential3: '24/7 ルームサービス',
                essential4: 'レインシャワー',
                oceanTitle: '海のそば',
                oceanSubtitle: 'ペースを落とし、海の空気を呼吸',
                oceanAlt: 'デラックスルーム座席エリア',
                ctaTitle: '滋在準備はいいですか？',
                ctaHeading: '今日デラックスルームを予約',
                ctaDesc: '最高の利用可能料金と特別オファーについては、予約チームにお問い合わせください。',
                checkAvailability: '空室状況を確認'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: '穏やかな海岸の魅力を備えた快適さ',
                bookThisRoom: 'この部屋を予約',
                callReservations: '予約に電話する',
                navAll: 'すべて',
                navDeluxe: 'デラックス',
                navDeluxeSeaView: '海の景色を備えたデラックス',
                navSuite: 'スイート',
                sectionTitle: '穏やかな海岸の隠れ場',
                sectionDesc: 'ラグジュアリースイートは、緩やかな朝と急がない夕日のためにデザインされています。柔らかなニュートラルトーン、寛大なグレーザリング、思慮深い照明は海の景色を招き、バルコニーはあなた自身の海岸の上の止まり木を提供します。',
                highlight1Title: 'パノラマビーチビュー',
                highlight1Desc: 'プライベートバルコニーから紺碧の水と黄金の日の出で目覚めてください。',
                highlight2Title: 'エレガントな沿岸インテリア',
                highlight2Desc: '柔らかなニュートラルパレット、温かい木製アクセント、豊富な自然光。',
                highlight3Title: '穏やかな睡眠体験',
                highlight3Desc: 'ふかふかなキング size ベッドと回復力のある休息のためにキュレーションされたプレミアム寝具。',
                atAGlance: 'ひと目で',
                statSize: 'サイズ',
                statSizeValue: '41 平方メートル',
                statView: 'ビュー',
                statViewValue: 'インド洋',
                statGuests: 'ゲスト',
                statGuestsValue: '2 人の成人',
                statBed: 'ベッド',
                statBedValue: 'キングまたはツイン',
                reserve: '予約',
                galleryAlt: 'スイートルーム',
                inclusionsTitle: 'あなたの滞在に含まれます',
                inclusionsSubtitle: '思慮深いタッチ、終日快適さ',
                enhancedCleanliness: '強化された清潔さと安全基準',
                inclusion1: '微風レストランでの無料朝食、昼食、夕食',
                inclusion2: '高速 Wi-Fi と客室内ワークスペース',
                inclusion3: '24 時間ルームサービスとコンシェルジュ',
                inclusion4: '毎日のハウスキーピングと夜間ターンダウン',
                inclusion5: 'インフィニティプールと Ayurveda スパ施設へのアクセス',
                inclusion6: '無料駐車場と近くの観光地への送迎サービス',
                amenityGroup1Title: 'ルーム機能',
                amenityGroup1Item1: '41 平方メートルのスペース',
                amenityGroup1Item2: 'シーティングエリア付きプライベートバルコニー',
                amenityGroup1Item3: '気候制御付きエアコン',
                amenityGroup1Item4: 'ルーム金庫',
                amenityGroup2Title: 'バス体験',
                amenityGroup2Item1: '温かい水と冷たい水のレインシャワー',
                amenityGroup2Item2: 'プレミアムバスアメニティ',
                amenityGroup2Item3: 'ヘアドライ',
                amenityGroup2Item4: 'ソフトバスローブとスリッパ',
                amenityGroup3Title: 'ルームの快適さ',
                amenityGroup3Item1: 'ケーブル付き 55 インチスマートテレビ',
                amenityGroup3Item2: 'コーヒーと紅茶ステーション',
                amenityGroup3Item3: '直通電話',
                amenityGroup4Title: 'コネクティビティ',
                amenityGroup4Item1: '無料 Wi-Fi',
                amenityGroup4Item2: 'デスク',
                amenityGroup4Item3: '24/7 フロントデスク サポート',
                essentialsTitle: 'ルーム エッセンシャルズ',
                essentialsHeading: '家のように感じるために必要なすべて',
                essentialsDesc: 'シームレスな接続から注意深く選ばれた飲料まで、ラグジュアリースイートはレジャーと実用性を融合させているため、重要な瞬間に焦点を当てることができます。',
                essential1: '無料 Wi-Fi',
                essential2: 'コーヒーと紅茶ステーション',
                essential3: '24/7 ルームサービス',
                essential4: 'レインシャワー',
                oceanTitle: '海のそば',
                oceanSubtitle: 'ペースを落とし、海の空気を呼吸',
                oceanAlt: '海の景色',
                ctaTitle: '滋在準備はいいですか？',
                ctaHeading: '今日ラグジュアリースイートを予約',
                ctaDesc: '最高の利用可能料金と特別オファーについては、予約チームにお問い合わせください。',
                checkAvailability: '空室状況を確認'
            },
            deluxeSeaViewRoom: {
                resortName: 'ムトゥムニリゾート',
                heroTitle: 'デラックスシービュールーム',
                heroSubtitle: '海の地平線の見事な景色とともに贅沢に浸る',
                bookThisRoom: 'この部屋を予約',
                callReservations: '予約に電話',
                navAll: 'すべてのルーム',
                navDeluxe: 'デラックスルーム',
                navDeluxeSeaView: 'デラックスシービュールーム',
                navSuite: 'ラグジュアリースイート',
                sectionTitle: '贅沢さを発見',
                sectionDesc: '私たちのデラックスシービュールームは、快適さと優雅さの完璧なブレンドを提供します。各客室は、比類のない滞在経験を提供するために慎重に設計されています。',
                highlight1Title: 'プライベートビーチビュー',
                highlight1Desc: '白い砂浜のプライベートビーチへの直接アクセス',
                highlight2Title: '広々とした客室',
                highlight2Desc: '素晴らしい生活空間75平方メートル',
                highlight3Title: '屋外バスタブ',
                highlight3Desc: '星の下でプライベート贅沢を試す',
                atAGlance: '一目で',
                stat1Label: 'サイズ',
                stat1Value: '75平方メートル',
                stat2Label: 'ビュー',
                stat2Value: 'シービュー',
                stat3Label: 'ゲスト',
                stat3Value: '大人2名',
                stat4Label: 'ベッド',
                stat4Value: 'キング',
                reserve: '予約',
                galleryAlt: 'ラグジュアリーデラックスシービュールーム',
                inclusionsTitle: '含まれるもの',
                inclusionsSubtitle: '各客室に含まれるもの',
                inclusion1: 'シービューブレックファスト',
                inclusion2: 'サンセットウェルカムドリンク',
                inclusion3: '毎日のエスプレッソバーサービス',
                inclusion4: '無制限のスパアクセス',
                inclusion5: 'プライベートビーチトランスファー',
                inclusion6: 'プレミアムWi-Fi',
                enhancedCleanliness: '強化された清掃と安全プロトコル',
                amenityGroup1Title: 'ベッドルーム',
                amenityGroup1Item1: '自動調光',
                amenityGroup1Item2: '100%プレミアムコットン',
                amenityGroup1Item3: 'さまざまな硬さの枕',
                amenityGroup2Title: 'バスルーム',
                amenityGroup2Item1: 'ブルガリコスメティックス',
                amenityGroup2Item2: '床暖房',
                amenityGroup2Item3: '統合SPAシステム',
                amenityGroup3Title: 'リビングルーム',
                amenityGroup3Item1: 'プレミアム衛星テレビ',
                amenityGroup3Item2: 'フル装備キッチン',
                amenityGroup3Item3: 'ホームシアター',
                amenityGroup4Title: '屋外',
                amenityGroup4Item1: 'ジャグジー付きプライベートテラス',
                amenityGroup4Item2: 'バリ風ハンギングベッド',
                amenityGroup4Item3: '自動灌漑システム',
                essentialsTitle: '必需品',
                essentialsHeading: '部屋の基本的な必需品',
                essentialsDesc: 'お部屋のすべての必需品',
                essential1: 'プレミアムドリンク付きミニバー',
                essential2: 'コーヒーと紅茶ステーション',
                essential3: '24/7 ルームサービス',
                essential4: 'レインシャワー',
                oceanTitle: '海のそば',
                oceanSubtitle: 'ペースを落とし、海の空気を呼吸',
                oceanAlt: '海の景色',
                ctaTitle: '滋在準備はいいですか？',
                ctaHeading: '今日デラックスシービュールームを予約',
                ctaDesc: '最高の利用可能料金と特別オファーについては、予約チームにお問い合わせください。',
                checkAvailability: '空室状況を確認'
            }
        },

        navbar: {
            home: 'ホーム',
            aboutUs: '私たちについて',
            rooms: '客室',
            ayurveda: 'アーユルヴェーダ',
            yoga: 'ヨガ',
            food: 'お食事',
            events: 'イベント',
            blogs: 'ブログ',
            tours: 'ツアー',
            contactUs: 'お問い合わせ',
            bookOnline: 'オンライン予約',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'リゾートを選択',
            language: '言語',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'ホーム',
            aboutUs: '私たちについて',
            rooms: '客室',
            ayurveda: 'アーユルヴェーダ',
            yoga: 'ヨガ',
            food: 'お食事',
            events: 'イベント',
            blogs: 'ブログ',
            tours: 'ツアー',
            contactUs: 'お問い合わせ',
            bookOnline: 'オンライン予約',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'リゾートを選択',
            language: '言語',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        food2: {
            heroTitle: 'アーユルヴェーダ料理と海岸料理',
            heroSubtitle: '本格スリランカの風味と新鮮な海岸料理',
            heroAlt: 'Muthumuni Beach Resortでの料理体験',
            wellnessEyebrow: '食事を通じたウェルネス',
            wellnessTitle: 'アーユルヴェーダ',
            ayurvedicFood: '食の重要性',
            wellnessIntro1: 'アーユルヴェーダでは、食べ物が最大の薬とされています。食べるものが直接ドーシャ（ヴァータ、ピッタ、カパ）、消化力（アグニ）、そして身体・心・魂の全体的なバランスに影響を与えます。',
            wellnessIntro2: 'アーユルヴェーダ栄養学は新鮮で季節の食材を使い、心を込めて調理し、マインドフルに味わうことを重視します。毎食に6つの味（甘い、酸っぱい、塩辛い、辛い、苦い、渋い）をバランスよく取り入れ、全感覚を養い調和を保ちます。',
            wellnessIntro3: '適切なアーユルヴェーダ食は消化を強化し、毒素（アーマ）を排出、免疫力を高め、エネルギーを増し、ストレスを軽減し、多くの慢性疾患を予防します。Muthumuniでは、あなたの個々の体質に合わせた料理を提供し、深い癒しと活力をもたらします。',
            foodImage1Alt: '6つの味を含む伝統的なアーユルヴェーダの食事',
            foodImage2Alt: 'バランスの取れた栄養のためのアーユルヴェーダのハーブとスパイス',
            culinaryPhilosophyEyebrow: '私たちの料理哲学',
            culinaryPhilosophyTitle: 'アーユルヴェーダ',
            nutritionHighlight: '栄養',
            culinaryPhilosophyResort: 'Muthumuni Ayurveda Beach Resortにて',
            nutritionTopImageAlt: 'Muthumuni Ayurveda River Resortのアーユルヴェーダ料理',
            freshNourishingLabel: '新鮮で栄養豊富',
            healingIngredientsAlt: '健康的なアーユルヴェーダ食材とスパイス',
            healingIngredientsLabel: '癒しの食材',
            philosophyText1: '6つの主要な味（甘い、酸っぱい、塩辛い、苦い、辛い、渋い）とその微妙な変化を含む食事は、5000年以上前に遡る古典的なアーユルヴェーダ文献で詳しく記述されており、それぞれの食品の本質的な性質——グナ（固有の性質）、ヴィリヤ（加熱または冷却効果）、ヴィパーカ（消化後の影響）、プラバーヴァ（独特の特別な作用）——とともに説明されています。',
            philosophyText2: 'そのため、アーユルヴェーダ栄養学はMuthumuni Ayurveda Beach Resortで中心的な役割を果たしています。これは医師が強制する単調で味気ない、または過度に苦い菜食だけの厳格な食事ではありません。むしろ私たちのアーユルヴェーダキッチンは最大の強みの一つです。熟練した料理人が毎日驚きと喜びを与える料理を準備します！',
            philosophyText3: '朝食は新鮮なトロピカルフルーツ、フレッシュジュース、栄養価の高いハーブスープ、自家製パンと軽いクッキー、そして本格スリランカ式朝食の豊富なビュッフェ。昼食は色鮮やかで風味豊かなビュッフェで、優しい魚カレー、野菜料理、ハーブを効かせた一品。夕食は固定のベジタリアンメニューに新鮮な魚のオプションあり。土曜日は「スリランカナイト」として拡大ビュッフェを開催し、シェフが目の前で伝統的な郷土料理を調理し、活気ある本物の体験をお届けします。',
            philosophyText4: 'アーユルヴェーダでは、食品と飲料は味と性質、消化力（アグニ）、特定の健康状態への適合性、季節の適性など多角的に分類されます。Muthumuniではこれら全てを同時に考慮し、各ゲストの体質に合わせたバランスの取れた6つの味の組み合わせを意識的に提供しています。',
            philosophyText5: '私たちの食事は新鮮な野菜、トロピカルフルーツ、責任ある調達の魚を使用。赤身肉やアルコールは提供しません。',
            philosophyText6: '食事時間には常にアーユルヴェーダ医師または資格を持つ栄養士が対応し、あなたをサポートします。現在の治療段階に最適な野菜、ハーブ、スパイスをアドバイスし、料理の選択や避けるべきものを案内します。あなた専用のハーブエリクサーとヘルスセンターからの特別指示は個別のテーブルに置かれます。',
            philosophyText7: 'このレベルのパーソナライズされたケアと食事への配慮は、Muthumuni Ayurveda Beach Resort体験の象徴です。',
            philosophyText8: '食べ物はプラーナ——すべての人間を支える生命エネルギー——とされています。だからこそ、私たちは毎食を完全な気づきを持って味わうことをおすすめします。香りを楽しみ、味を感じ、温かさを感じ、口の中で広がる感覚をマインドフルに味わってください。',
            diningExperienceEyebrow: 'ダイニング体験',
            restaurantTitlePrefix: '私たちの',
            ayurvedicHighlight: 'アーユルヴェーダ',
            restaurantTitleSuffix: 'レストラン',
            restaurantDetail1: 'Muthumuni Beach Resortのアーユルヴェーダレストランは、伝統的なアーユルヴェーダの原則と本格的なスリランカ海岸料理を調和させたユニークなダイニング体験を提供します。新鮮で地元の食材を優先し、味覚を喜ばせながら全体的な健康を促進する料理をお届けします。',
            restaurantDetail2: 'メニューは6つの味（甘い、酸っぱい、塩辛い、苦い、辛い、渋い）をすべての料理でバランスよく取り入れるよう丁寧に設計され、栄養価が高く満足感のある体験を実現します。すべての料理は心を込めて調理され、癒しの効果を持つアーユルヴェーダのハーブとスパイスが使用されています。',
            restaurantDetail3: 'ゲストは個々のドーシャ（体質）に合わせた多様な料理を楽しめ、ベジタリアン、ヴィーガン、ペスクタリアンの選択肢があります。シェフはアーユルヴェーダ実践者と密に連携し、すべての食事が健康とウェルネスの目標をサポートします。',
            restaurantDetail4: 'レストランの雰囲気は穏やかな海岸環境を反映し、マインドフルな食事のための静かな空間を提供します。豊富な朝食ビュッフェから洗練されたディナーまで、当レストランでの食事は身体と魂を養う機会です。',
            restaurantDetail5: 'Muthumuni Beach Resortのアーユルヴェーダレストランへようこそ。スリランカの豊かな風味を称え、アーユルヴェーダの時代を超えた知恵を体現する美食の旅をお楽しみください。',
            restaurantImageAlt: 'Muthumuni Ayurveda River Resortでの食事',
            premiumDiningLabel: 'プレミアムダイニング',
            premiumDiningDescription: '静かなリバーサイドで本格アーユルヴェーダ料理を体験'
        },
        blogs2: {
            heroTitle: 'Muthumuni Ayurveda River Resort ブログ',
            heroSubtitle1: '川辺からの物語、',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: 'のアーユルヴェーダ儀式。ヒント、歴史、舞台裏のノートに浸る。',
            heroAlt: 'リゾートの川沿い遊歩道の夕暮れ',
            sectionTitle: 'Muthumuni Ayurveda River Resort ブログ',
            sectionDescription: '川辺のリトリートからのガイド、ストーリー、メモ — アーユルヴェーダの儀式、ウェルネス習慣、ベントタ周辺の旅のヒントまで。',
            ayurvedaTitle: '本物のアーユルヴェーダの心',
            ayurvedaExcerpt: 'スリランカの古来の知恵に根ざした伝統的な癒しの技法を体験。',
            ayurvedaDescription: 'Muthumuni Ayurveda River Resortでは、アーユルヴェーダは単なる治療ではなく生き方です。数百年の知識に基づき、あなたの体質に合わせたパーソナライズドな療法を、経験豊富なアーユルヴェーダ医師が深く持続的なバランスへと導きます。',
            ayurvedaAlt: 'ハーブオイルと自然素材を使ったアーユルヴェーダ施術',
            healingTitle: '個別化された癒しの旅',
            healingExcerpt: 'すべてのゲストのウェルネスプログラムがユニークに設計される理由。',
            healingDescription: '初回相談から毎日の施術まで、あなたの癒しの旅は丁寧にカスタマイズされます。ハーブ療法、治療マッサージ、ヨガ、瞑想が一体となって心身の調和を回復します。',
            healingAlt: '穏やかな環境でアーユルヴェーダ医師がゲストに相談',
            natureTitle: '川辺での癒し',
            natureExcerpt: '穏やかな川の環境と熱帯の自然があなたの健康をどう高めるか。',
            natureDescription: 'スリランカの静かな川沿いに位置するMuthumuniは、自然の癒し環境を提供。川の優しい流れ、新鮮な空気、豊かな緑がアーユルヴェーダの効果を増幅し、深いリラクゼーションと再生をもたらします。',
            natureAlt: 'パームツリーと自然に囲まれたリゾートの川辺風景',
            foodTitle: '内なるバランスのためのアーユルヴェーダ料理',
            foodExcerpt: '治療を支える栄養たっぷりの食事。',
            foodDescription: '当リゾートの アーユルヴェーダ料理は季節の地元食材を使い毎日新鮮に調理。あなたのドーシャに合わせた食事は消化・解毒・活力をサポートし、美味しく満足感のあるものとなっています。',
            foodAlt: '天然の器に盛られた伝統的なアーユルヴェーダ料理',
            yogaTitle: 'ヨガ・瞑想・内なる静けさ',
            yogaExcerpt: '心を落ち着かせ体を強くする穏やかな実践。',
            yogaDescription: '毎日のヨガと瞑想セッションが施術を補完し、柔軟性・呼吸・精神の明晰さを高めます。これらのマインドフルな実践は自分自身との再接続を助け、滞在後も平和な感覚を保ちます。',
            yogaAlt: '朝日の中、川を眺めながらヨガをするゲストたち',
            lifestyleTitle: 'アーユルヴェーダを自宅へ',
            lifestyleExcerpt: 'ウェルネスの旅を続けるためのシンプルな生活習慣。',
            lifestyleDescription: 'ご出発前に専門家が日常のルーティン、食事、セルフケアの儀式を通じてバランスを保つ方法を指導します。思い出だけでなく、より健康的な生活への持続可能な道をお持ち帰りください。',
            lifestyleAlt: '穏やかなリゾート環境でハーブティーを楽しむゲスト',
            readMore: '続きを読む'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort は、卓越したおもてなしとウェルネス体験を提供し、すべてのゲストが大切にされリフレッシュできるよう努めています。',
            linksTitle: 'リンク',
            contactTitle: 'お問い合わせ',
            viewLocation: '場所を見る',
            navHome: 'ホーム',
            navAbout: '私たちについて',
            navContact: 'お問い合わせ',
            navRooms: '客室',
            navAyurveda: 'アーユルヴェーダ',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: '開発',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'ツアーと遠足',
            heroSubtitle: 'ベルワラからスリランカの美しさを発見',
            kandeAlt: 'カンデ・ヴィハーラ寺院 - ベルワラ',
            kandeTitle: 'カンデ・ヴィハーラ寺院訪問',
            kandeBuddhaAlt: 'カンデ・ヴィハーラ寺院の巨大仏像',
            bentotaTitle: 'ベントタ川ボートサファリ',
            bentotaAlt: 'ベントタ川ボートサファリ - マングローブと野生動物',
            galleTitle: 'ガーレ旧市街ツアー',
            galleAlt: 'ガーレ旧市街ツアー',
            sigiriyaTitle: 'シギリヤ岩石要塞ツアー',
            sigiriyaAlt: 'シギリヤ岩石要塞ツアー',
            kandyTitle: 'キャンディ文化ツアー',
            kandyAlt: 'キャンディ文化ツアー',
            bookTour: 'このツアーを予約',
            introPara1: 'スリランカは時間を超えた美しさの地であり、黄金のビーチ、生い茂る緑の風景、古代の寺院、そして活気に満ちた文化が完璧な調和で集まっています。',
            introPara2: '静かな南西海岸から歴史的な都市、神聖な遺跡、野生動物保護区、霧がかかる丘陵地帯まで、すべての旅はユニークで忘れられない経験を提供します。',
            introPara3: 'ベルワラのムツムニ・アーユルヴェーダ・ビーチリゾートから始まり、私たちの厳選されたツアーと遠足はあなたの滞在を豊かにするために設計されており、探索、リラックス、ウェルネスのバランスを完璧に保っています。',
            kandeDetail1: 'カンデ・ヴィハーラ寺院（Kande Viharaya）— ベルワラ近郊の最も象徴的な仏教寺院の一つです。',
            kandeDetail2: '1734年に創建されたこの穏やかな「山の寺院」は丘の上に位置し、海岸線の穏やかな眺めを提供しています。',
            kandeDetail3: 'ハイライトには、48メートル（160フィート）の大きな座像の仏像（スリランカ最高のもの）、複雑なカンディアン時代のフレスコ画、古代の遺物室、美しい月石の入口、そして300年以上前の神聖なボディの木が含まれます。',
            kandeDetail4: '完璧な半日の精神的で文化的な経験 – 暑さを避けるための朝の訪問に最適です。',
            bentotaDetail1: 'ベントタ川に沿った平和で風景の美しいボートサファリをお楽しみください。これはベルワラ近郊で最も人気のある自然遠足の一つです。',
            bentotaDetail2: '地元の野生動物を観察しながら、豊かなマングローブ、狭い運河、静かなバックウォーターを滑空します。',
            bentotaDetail3: '一般的な目撃対象には、オオトカゲ、ワニ、様々な鳥の種（カワセミ、サギ、ワシ）、猿、そして時々カワウソや水ヘビが含まれます。',
            bentotaDetail4: '経験豊かなボート操縦者/ガイドが、興味深い植物、伝統的な漁法、河辺の村の生活を指摘してくれます。',
            bentotaDetail5: '自然愛好家と写真家に最適 – 穏やか、リラックス、そしてあなたのアーユルヴェーダウェルネス滞在を補完します。',
            galleDetail1: 'ユネスコ世界遺産であり、スリランカで最も保存状態の良い植民地時代の砦の一つであるガーレ砦の歴史を探索します。',
            galleDetail2: '石畳の通りを歩きながら、オランダの植民地建築、ブティック、カフェ、アートギャラリーに囲まれています。',
            galleDetail3: 'ガーレ灯台、オランダ改革派教会、国立海事博物館、素晴らしい海の眺めを提供する城壁などの主要な名所を訪問します。',
            galleDetail4: 'あなたの知識豊かなガイドから、砦の豊かな歴史、建築、文化的重要性について学びます。',
            galleDetail5: '歴史愛好家、文化愛好家、そしてスリランカの植民地時代の過去を体験したい人に最適です。',
            sigiriyaDetail1: 'スリランカで最も象徴的なランドマークの一つであり、ユネスコ世界遺産でもあるシギリヤ古代岩石要塞を発見します。',
            sigiriyaDetail2: '印象的な岩を登ったり、カシャッパ王宮殿の遺跡を探索したり、フレスコ画、庭園、有名なミラーウォールで装飾されています。',
            sigiriyaDetail3: '山頂から周囲のジャングルと田舎のパノラマビューをお楽しみください。',
            sigiriyaDetail4: 'あなたの専門ガイドからシギリヤに関連する魅力的な歴史、建築、伝説について学びます。',
            sigiriyaDetail5: '歴史愛好家、冒険家、そしてスリランカの豊かな文化遺産に興味のある人に最適です。',
            kandyDetail1: 'スリランカの最後の王都であり、ユネスコ世界遺産でもあるキャンディの活気に満ちた文化を体験します。',
            kandyDetail2: '聖歯舎利寺院（スリダラダ・マリガワ）を訪問してください。これは世界で最も重要な仏教遺跡の一つです。',
            kandyDetail3: 'ペラデニヤの王立植物園を探索し、膨大な熱帯植物やランの収集があります。',
            kandyDetail4: 'スリランカの豊かな芸術遺産を披露する伝統的なカンディアンダンスパフォーマンスをお楽しみください。',
            kandyDetail5: '文化愛好家、歴史愛好家、そしてスリランカの伝統に没頭したい人に最適です。'
        },
        blogs: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort ブログ',
            heroSubtitle1: '海岸からの物語、アーユルヴェーダの儀式',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '。ヒント、歴史、舞台裏の記録をご覧ください。',
            heroAlt: '夕日のリゾートビーチフロント散歩道',
            sectionTitle: 'Muthumuni Ayurveda Beach Resort ブログ',
            sectionDescription: '私たちの海岸リトリートからのガイド、物語、記録 — アーユルヴェーダの儀式、宝石の伝承、ベントタ周辺の旅行のヒントまで。',
            ayurvedaTitle: '本格的なアーユルヴェーダの心',
            ayurvedaExcerpt: 'スリランカの古代の知恵に根ざした歴史ある治癒の伝統を体験してください。',
            ayurvedaDescription: 'Muthumuni Ayurveda Beach Resortでは、アーユルヴェーダは単なる治療以上のものです — それは生き方です。私たちの治療法は何世紀にもわたる知識に基づいており、あなたの体質に合わせて個別化され、経験豊富なアーユルヴェーダ医師によって深い持続的なバランスのために指導されています。',
            ayurvedaAlt: 'ハーブオイルと天然要素を使ったアーユルヴェーダトリートメントセットアップ',
            healingTitle: 'パーソナライズされた癒しの旅',
            healingExcerpt: 'なぜすべてのゲストのウェルネスプログラムがユニークに設計されているのか。',
            healingDescription: '初回の相談から毎日の治療まで、あなたの癒しの旅は慎重に調整されています。ハーブ療法、治療的マッサージ、ヨガ、瞑想が協力して、身体、心、精神の調和を回復します。',
            healingAlt: '穏やかな環境でゲストに相談するアーユルヴェーダ医師',
            natureTitle: '海での癒し',
            natureExcerpt: '海風と熱帯の環境がウェルネスを高める方法。',
            natureDescription: 'スリランカの静かな海岸線に位置するMuthumuniは、自然に癒される環境を提供します。波の音、新鮮な海の空気、豊かな緑がアーユルヴェーダの効果を増幅し、深いリラクゼーションと再生を生み出します。',
            natureAlt: 'ヤシの木と海のあるリゾートのビーチフロントビュー',
            foodTitle: '内なるバランスのためのアーユルヴェーダ料理',
            foodExcerpt: 'あなたの治療をサポートするために作られた栄養価の高い食事。',
            foodDescription: '私たちのアーユルヴェーダ料理は、季節の地元産の食材を使って新鮮に調理されています。各食事はあなたのドーシャに合わせて、消化、デトックス、全体的な活力をサポートしながら、風味豊かで満足感のあるものです。',
            foodAlt: '天然のボウルに提供された伝統的なアーユルヴェーダ料理',
            yogaTitle: 'ヨガ、瞑想と内なる静けさ',
            yogaExcerpt: '心を落ち着かせ、身体を強化する穏やかな実践。',
            yogaDescription: '毎日のヨガと瞑想セッションは治療を補完し、柔軟性、呼吸、精神の明晰さを向上させます。これらのマインドフルな実践は、自分自身と再びつながり、滞在を超えて平和の感覚を持ち続けるのに役立ちます。',
            yogaAlt: '日の出時に海に面してヨガを練習するゲスト',
            lifestyleTitle: 'アーユルヴェーダを家に持ち帰る',
            lifestyleExcerpt: 'ウェルネスの旅を続けるためのシンプルなライフスタイルの実践。',
            lifestyleDescription: '出発前に、私たちの専門家が、日常のルーチン、食事、セルフケアの儀式を通じてバランスを維持する方法をご案内します。思い出以上のものを持ち帰ってください — より健康的な生活への持続可能な道を持ち帰ってください。',
            lifestyleAlt: 'リゾートの穏やかな環境でハーブティーを飲みながらリラックスするゲスト',
            readMore: 'もっと読む'
        },
        events: {
            heroEyebrow: '体験とアクティビティ',
            heroTitle: 'イベント',
            heroSubtitle: 'スリランカの伝統と海辺のラグジュアリーが融合した厳選体験',
            heroAlt: 'Muthumuniのイベント',
            availableDaily: '毎日開催',
            bookNow: '今すぐ予約',
            highlightsTitle: 'ハイライト',
            detailAlt: '{{title}}の詳細',
            ctaTitle: '思い出作りの準備はできましたか？',
            ctaDescription: 'Muthumuni Ayurveda Beach Resortで理想のイベント体験をカスタマイズするため、私たちのチームにご相談ください',
            ctaContact: 'お問い合わせ',
            ctaViewRooms: '客室を見る',
            cookeryTitle: '料理プログラム',
            cookerySubtitle: 'スリランカの味',
            cookeryDescription: '活気あふれるスリランカ料理の風味に浸ってください。熟練のシェフが実践的な料理セッションを通じて、世代を超えて受け継がれてきた伝統的なレシピを教えます。香り高いカレー、ホッパー、ココナッツ・サンボルなどを新鮮な地元食材で作る方法を学びます。',
            cookeryHighlight1: '伝統的なスリランカのレシピ',
            cookeryHighlight2: '実践的な料理体験',
            cookeryHighlight3: '新鮮な地元食材',
            cookeryHighlight4: 'レシピを持ち帰り',
            cookeryHighlight5: 'スパイスガーデンツアー付き',
            meditationTitle: '瞑想プログラム',
            meditationSubtitle: '内なる平和とマインドフルネス',
            meditationDescription: 'インド洋の穏やかな景色を背景にしたガイド付き瞑想で静けさを見つけましょう。経験豊富なインストラクターが、心を落ち着かせ精神を蘇らせる古来のマインドフルネス技法、呼吸法、ヨガの実践へ導きます。',
            meditationHighlight1: '日の出・日の入りセッション',
            meditationHighlight2: '海辺の瞑想',
            meditationHighlight3: '専門家による指導',
            meditationHighlight4: '呼吸法',
            meditationHighlight5: 'ヨガ＆マインドフルネス実践',
            bbqTitle: 'BBQパーティー',
            bbqSubtitle: 'ビーチサイドの祝祭',
            bbqDescription: 'ビーチサイドのBBQパーティーで忘れられない夜を体験してください。波のささやきを聞きながら、新鮮なシーフードのグリル、上質な肉、ベジタリアン料理を味わえます。ライブ音楽、ファイヤーダンサー、星空が祝祭と交流の完璧な雰囲気を演出します。',
            bbqHighlight1: '新鮮なシーフードのグリル',
            bbqHighlight2: 'オーシャンフロントダイニング',
            bbqHighlight3: 'ライブエンターテインメント',
            bbqHighlight4: '焚き火体験',
            bbqHighlight5: 'カスタマイズ可能なメニュー',
            boatTitle: 'ボートライド',
            boatSubtitle: '川と海岸の冒険',
            boatDescription: 'ベントータ川と沿岸水域を巡る魅力的なボート旅へ。マングローブの森を滑るように進み、珍しい鳥や野生動物を観察したり、ロマンチックなサンセットクルーズを楽しめます。ボートライドはスリランカの自然美と多様な生態系を新しい視点で体験できます。',
            boatHighlight1: 'ベントータ川クルーズ',
            boatHighlight2: 'マングローブ探索',
            boatHighlight3: '野生動物観察',
            boatHighlight4: 'サンセットボートツアー',
            boatHighlight5: 'プライベートチャーターあり',
            ayurvedaLecturesTitle: 'アーユルヴェーダ医師の講演',
            ayurvedaLecturesSubtitle: '古代の知恵と現代のウェルネス',
            ayurvedaLecturesDescription: '認定アーユルヴェーダ医師や実践者による講演で、アーユルヴェーダの深い原理を学びましょう。ドーシャのバランス、ハーブ療法、ホリスティックな癒しの実践、そして古代の知恵が現代のウェルネスにどう活かされるかを学べます。インタラクティブなセッションで、アーユルヴェーダ哲学と日常への応用を分かりやすく解説します。',
            ayurvedaLecturesHighlight1: '認定アーユルヴェーダ医師',
            ayurvedaLecturesHighlight2: 'パーソナライズされたドーシャ分析',
            ayurvedaLecturesHighlight3: 'ハーブ療法の学び',
            ayurvedaLecturesHighlight4: 'Q&Aセッション付き',
            ayurvedaLecturesHighlight5: '持ち帰り用ウェルネスガイド',
            traditionalClothsTitle: '伝統衣装体験イベント',
            traditionalClothsSubtitle: '文化遺産体験',
            traditionalClothsDescription: '伝統衣装の着付けとその価値を学ぶことで、スリランカの文化遺産に浸りましょう。専門スタイリストが本格的なキャンディアン・サリーや伝統衣装の着こなしを案内し、それぞれの文化的意義を説明します。特別な機会、文化体験、思い出に残る写真撮影に最適です。',
            traditionalClothsHighlight1: '専門的なスタイリング指導',
            traditionalClothsHighlight2: '本格的な伝統サリー',
            traditionalClothsHighlight3: '文化的意義の解説',
            traditionalClothsHighlight4: 'プロの写真撮影付き',
            traditionalClothsHighlight5: 'ファッション・フュージョンワークショップ'
        },
        contact: {
            heroTitle: 'お問い合わせ',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'お問い合わせ',
            sectionTitle: 'お気軽にご連絡ください',
            sectionSubtitle: 'リラックスとリフレッシュをお手伝いします',
            sectionDescription: 'アーユルヴェーダ滞在、ウェルネスパッケージ、予約、またはベールワラ（モラガラ）でのご滞在に関するご質問は、Muthumuni Ayurveda Beach Resortまでお問い合わせください。',
            callUs: 'お電話',
            emailTitle: 'メール',
            ourLocation: '所在地',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'ソーシャルネットワーク',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'お問い合わせ',
            getInTouchDescription: 'ぜひご連絡ください。チームがウェルネスの旅をサポートし、質問への回答やご滞在の計画をお手伝いします。',
            nameLabel: 'お名前',
            emailLabel: 'メール',
            contactNumberLabel: '連絡先番号',
            messageLabel: 'メッセージ',
            sending: '送信中...',
            sendMessage: '送信',
            successMessage: 'メッセージを送信しました。まもなくご連絡します。',
            errorMessage: '送信中にエラーが発生しました。もう一度お試しください。',
            findUsOnMap: '地図で見る',
            whatsappSubject: 'Muthumuni Ayurveda Beach Resort お問い合わせ',
            whatsappName: 'お名前',
            whatsappEmail: 'メール',
            whatsappContactNumber: '連絡先番号',
            whatsappMessage: 'メッセージ'
        },

        contact2: {
            heroTitle: 'お問い合わせ',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'お問い合わせ',
            sectionTitle: 'お気軽にご連絡ください',
            sectionSubtitle: 'リラックスとリフレッシュをお手伝いします',
            sectionDescription: 'アーユルヴェーダ滞在、ウェルネスパッケージ、予約、またはベールワラ（モラガラ）でのご滞在に関するご質問は、Muthumuni Ayurveda Beach Resortまでお問い合わせください。',
            callUs: 'お電話',
            emailTitle: 'メール',
            ourLocation: '所在地',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'ソーシャルネットワーク',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'お問い合わせ',
            getInTouchDescription: 'ぜひご連絡ください。チームがウェルネスの旅をサポートし、質問への回答やご滞在の計画をお手伝いします。',
            nameLabel: 'お名前',
            emailLabel: 'メール',
            contactNumberLabel: '連絡先番号',
            messageLabel: 'メッセージ',
            sending: '送信中...',
            sendMessage: 'メッセージを送信',
            successMessage: 'メッセージは正常に送信されました。折り返しご連絡いたします。',
            errorMessage: '送信中にエラーが発生しました。もう一度お試しください。',
            findUsOnMap: '地図で見つける',
            whatsappSubject: 'Muthumuni Ayurveda Beach Resortへのお問い合わせ',
            whatsappName: 'お名前',
            whatsappEmail: 'メール',
            whatsappContactNumber: '連絡先番号',
            whatsappMessage: 'メッセージ'
        },

        ayurveda: {
            accordionTitle1: 'パンチャカルマ・アーユルヴェーダとは？',
            accordionDesc1: 'アーユルヴェーダは5000年以上前に開発された世界最古の治癒システムの一つです。パンチャカルマ・アーユルヴェーダは、健康は心、体、魂、環境のバランスに依存するという信念に基づいています。',
            accordionTitle2: 'パンチャカルマ・アーユルヴェーダと生命エネルギー',
            accordionDesc2: 'アーユルヴェーダは宇宙のすべてが相互に関連しているという理論に基づいています。アーユルヴェーダの実践者は、人間は空間、空気、火、水、土の5つの要素で構成されていると信じています。これらが3つのドーシャを形成します：ヴァータ、ピッタ、カパ。',
            accordionTitle3: 'ヴァータ・ドーシャ',
            accordionDesc3: '最も強力なドーシャで、細胞分裂、呼吸、血流、心機能などの基本的な身体機能を制御します。ヴァータが優勢な場合、あなたは知的で創造的でエネルギッシュです。不均衡な場合は不安になります。瞑想、マッサージ、温かい食べ物でバランスを保ちます。',
            accordionTitle4: 'ピッタ・ドーシャ',
            accordionDesc4: '消化、代謝、ホルモンを制御します。ピッタが優勢な場合、あなたは決断力があり、競争力があり、自信に満ちています。不均衡な場合は短気になります。冷たい食べ物とゆっくりとしたヨガでバランスを保ちます。',
            accordionTitle5: 'カパ・ドーシャ',
            accordionDesc5: '筋肉の成長、体の強さ、免疫力を制御します。カパが優勢な場合、あなたはルーティンを好み、落ち着いていて忍耐強いです。不均衡な場合は疲労と体重増加が起こります。果物、野菜、運動でバランスを保ちます。',
            close: '閉じる',
            next: '次へ',
            previous: '前へ',
            treatmentsTitle: '当社の特徴的なパンチャカルマ・アーユルヴェーダトリートメント',
            treatmentsSubtitle: 'バランスを回復し、緊張を解放し、あなた全体を若返らせる古代の療法をご体験ください。',
            bookTreatment: 'このトリートメントを予約',
            benefitsTitle: 'パンチャカルマトリートメントの効果',
            shirodhara: 'シローダーラ',
            shirodharaDesc: '温かいハーブオイルを額に優しく注いで心を落ち着かせます。',
            shirodhara1: 'ストレスと不安を軽減',
            shirodhara2: 'より良い睡眠を促進',
            shirodhara3: '精神的な明晰さを向上',
            steamBath: 'スチームバス',
            steamBathDesc: '毛穴を開き、筋肉をリラックスさせるデトックススチームトリートメント。',
            steamBath1: '体をデトックス',
            steamBath2: '血液循環を改善',
            steamBath3: '筋肉の緊張を和らげる',
            flowerBath: 'フラワーバス',
            flowerBathDesc: '芳香の花でリラックスする癒しのバス。',
            flowerBath1: '神経系を落ち着かせる',
            flowerBath2: '肌に潤いを与える',
            flowerBath3: '気分を高める',
            headMassage: 'ヘッドマッサージ',
            headMassageDesc: '緊張を和らげるリラックスする頭皮マッサージ。',
            headMassage1: '頭痛を軽減',
            headMassage2: '頭皮の健康を改善',
            headMassage3: 'リラクゼーションを促進',
            faceMassage: 'フェイシャルマッサージ',
            faceMassageDesc: '顔の輝きを高め、ストレスを軽減する若返りマッサージ。',
            faceMassage1: '肌のトーンを改善',
            faceMassage2: '顔の緊張を軽減',
            faceMassage3: 'リンパドレナージを促進',
            neckMassage: 'ネックマッサージ',
            neckMassageDesc: '首のこわばりと緊張を和らげるターゲットマッサージ。',
            neckMassage1: '首の痛みを和らげる',
            neckMassage2: '柔軟性を向上',
            neckMassage3: 'ストレスを軽減',
            shoulderMassage: 'ショルダーマッサージ',
            shoulderMassageDesc: '肩のこわばりと不快感を和らげるターゲットマッサージ。',
            shoulderMassage1: '肩の痛みを軽減',
            shoulderMassage2: '姿勢を改善',
            shoulderMassage3: '筋肉をリラックス',
            bodyMassage: '全身マッサージ',
            bodyMassageDesc: 'リラクゼーションと幸福を促進する全身マッサージ。',
            bodyMassage1: '血液循環を改善',
            bodyMassage2: '筋肉痛を和らげる',
            bodyMassage3: 'リラクゼーションを促進',
            backMassage: 'バックマッサージ',
            backMassageDesc: '背中の痛みと緊張に対処する治療的マッサージ。',
            backMassage1: '背中の痛みを和らげる',
            backMassage2: '脊椎の健康を改善',
            backMassage3: 'ストレスを軽減',
            footMassage: 'フットマッサージ',
            footMassageDesc: '足の痛みを和らげ、リラックスする癒しのマッサージ。',
            footMassage1: '血液循環を改善',
            footMassage2: '足の疲労を軽減',
            footMassage3: 'リラクゼーションを促進',
            purgative: '下剤療法',
            purgativeDesc: '消化器系から過剰なピッタと毒素を除去する浄化療法。',
            purgative1: '腸をクレンジング',
            purgative2: 'ピッタドーシャのバランスをとる',
            purgative3: '消化器の健康を改善',
            nasalClearing: '鼻腔クリアリング',
            nasalClearingDesc: '副鼻腔をクリアにし、呼吸機能を改善する治療的鼻療法。',
            nasalClearing1: '鼻づまりを解消',
            nasalClearing2: '呼吸を改善',
            nasalClearing3: '副鼻腔の問題を和らげる',
            powderMassage: 'パウダーマッサージ',
            powderMassageDesc: 'ハーブパウダーで肌を若返らせ、リフレッシュする角質除去マッサージ。',
            powderMassage1: '死んだ皮膚を除去',
            powderMassage2: '肌の質感を改善',
            powderMassage3: '血液循環を促進',
            intensiveMassageDesc: '慢性的な緊張や筋肉のこりに対して、強い圧力と専門的な技術を用いた深い治療マッサージです。',
            intensiveMassage1: '深い筋肉の緊張を緩和',
            intensiveMassage2: '血行を改善',
            intensiveMassage3: '筋肉痛を軽減',
            thermoMassage: '温熱マッサージ',
            thermoMassageDesc: '温めた治療用ハーブオイルを使用した温かいマッサージで、リラクゼーションと治癒効果を高めます。',
            thermoMassage1: '痛んだ筋肉を和らげる',
            thermoMassage2: '深いリラクゼーションを促進',
            thermoMassage3: 'エネルギーの流れを向上',
            synchronMassage: 'シンクロナイズドマッサージ',
            synchronMassageDesc: '2人のセラピストによる同期マッサージで、完全な身体の調和とエネルギーのバランスを実現します。',
            synchronMassage1: '全身の調和',
            synchronMassage2: 'バランスの取れたエネルギー流',
            synchronMassage3: '深いリラクゼーション体験',
            specialMassage: 'スペシャルマッサージ',
            specialMassageDesc: 'お客様の特定の健康ニーズと個人のウェルネス目標に合わせたカスタマイズされたマッサージ療法です。',
            specialMassage1: 'パーソナライズド治療',
            specialMassage2: '特定の悩みに焦点',
            specialMassage3: 'カスタマイズされた癒しアプローチ',
            benefit1Title: 'デトックス：',
            benefit1Desc: 'パンチャカルマトリートメントは体から毒素を除去し、健康と活力を促進するのに役立ちます。',
            benefit2Title: '消化の改善：',
            benefit2Desc: 'これらの療法は消化機能を改善し、より良い栄養吸収と代謝を実現します。',
            benefit3Title: 'ストレス軽減：',
            benefit3Desc: 'パンチャカルマは、体と心に対する鎮静効果で知られ、ストレスと不安のレベルを低下させます。',
            benefit4Title: '免疫力の強化：',
            benefit4Desc: '定期的なパンチャカルマトリートメントは免疫システムを強化し、体をより回復力のあるものにします。',
            benefit5Title: '若返り：',
            benefit5Desc: '療法は細胞再生を促進し、肌の健康と若々しい外観を改善します。',
            benefit6Title: 'ドーシャのバランス：',
            benefit6Desc: 'パンチャカルマはドーシャ（ヴァータ、ピッタ、カパ）のバランスを回復するのに役立ち、これはアーユルヴェーダの原則において健康に不可欠です。',
            akkupancharTitle: 'アックパンチャル療法',
            akkupancharDesc1: 'は、特定の体のポイントでハーブペーストとオイルを使用する古代のアーユルヴェーダ療法です。この治療はエネルギーチャネルを刺激し、治癒を促進します。',
            akkupancharBenefit: '主な利点：',
            akkupancharDesc2: 'この専門療法は慢性的な痛みを助け、関節の柔軟性を改善し、血液循環を促進し、自然なエネルギーの流れを回復します。',
            akkupancharApplication: '治療的応用：',
            akkupancharDesc3: 'アックパンチャルは、ドーシャのバランスをとるために慎重に選択されたハーブ調合物で特定のマルマポイントに作用します。',
            akkupancharTransform: '変革を体験：',
            akkupancharDesc4: 'ムトゥムニアーユルヴェーダビーチリゾートでは、経験豊富なセラピストがあなたの健康ニーズに合わせて各セッションをカスタマイズします。',
            gallery1: 'シローダーラ療法',
            gallery2: 'スチームバス',
            gallery3: 'フラワーバス',
            gallery4: 'ヘッドマッサージ',
            gallery5: '全身マッサージ',
            gallery6: 'ネックマッサージ',
            gallery7: 'フェイシャルマッサージ',
            gallery8: 'ショルダーマッサージ',
            heroTitle: 'パンチャカルマ・アーユルヴェーダ',
            heroSubtitle: 'ベルワラで身心霊を若返らせる',
            sectionEyebrow: 'MUTHUMUNI AYURVEDA BEACH RESORTのパンチャカルマ・アーユルヴェーダ',
            sectionDescription: 'ベルワラのMuthumuni Ayurveda Beach Resortで古代の治癒芸術を発見してください。経験豊富な実践者が、解毒、若返り、バランス回復をサポートします。'
        },
        food: {
            heroTitle: 'アーユルヴェーダ食と沿岸料理',
            heroSubtitle: 'スリランカの本物の味と新鮮な沿岸料理',
            heroAlt: 'Muthumuni ビーチリゾートでの料理体験',
            wellnessEyebrow: '食べ物を通じた健康',
            wellnessTitle: 'の重要性',
            ayurvedicFood: 'アーユルヴェーダ食',
            wellnessIntro1: 'アーユルヴェーダでは、食べ物は最大の医学と考えられています。あなたが食べるものは、あなたのドーシャ（ヴァータ、ピッタ、カファ）、消化（アグニ）、そして体、心、精神全体のバランスに直接影響します。',
            wellnessIntro2: 'アーユルヴェーダ栄養は、配慮を持って準備され、マインドフルに食べられた新鮮で季節的な全食を強調しています。すべての感覚を栄養し、調和を保つために、各食事に6つの味（甘い、酸っぱい、塩辛い、ピリッとした、苦い、渋い）を促進しています。',
            wellnessIntro3: '適切なアーユルヴェーダ食は、強力な消化をサポートし、毒素（アマ）を除去するのを助け、免疫力を高め、エネルギーを改善し、ストレスを軽減し、多くの慢性疾患を予防します。Muthumuniでは、各料理はあなたのユニークな体質に深い癒しと活力をもたらすために慎重に作られています。',
            foodImage1Alt: '6つの味を持つ伝統的なアーユルヴェーダ食事',
            foodImage2Alt: 'バランスの取れた栄養のためのアーユルヴェーダハーブとスパイス',
            culinaryPhilosophyEyebrow: '私たちの料理哲学',
            culinaryPhilosophyTitle: 'アーユルヴェーダ',
            nutritionHighlight: '栄養',
            culinaryPhilosophyResort: 'Muthumuni Ayurveda Beach Resortにて',
            nutritionTopImageAlt: 'Muthumuni Ayurveda River Resortでのアーユルヴェーダ料理',
            freshNourishingLabel: '新鮮で栄養豊富',
            healingIngredientsAlt: 'ヘルシーなアーユルヴェーダ食材とスパイス',
            healingIngredientsLabel: '治癒成分',
            philosophyText1: '甘い、酸っぱい、塩辛い、苦い、ピリッとした、渋い6つの主な味を含む食べ物は、古典的なアーユルヴェーダのテキストで説明されており、5000年以上前に遡るものもあります。グナ（固有の品質）、ヴィルヤ（効力/加熱または冷却）、ヴィパカ（消化後の影響）、およびプラバヴァ（ユニークな特殊作用）を含む各食品の本質的なプロパティ。',
            philosophyText2: 'その結果、アーユルヴェーダ栄養はMuthumuni Ayurveda Beach Resortで中心的な役割を果たしています。これは、医師によってのみ指示される味気ない、無味、または過度に苦い食事の厳格で単調な体制を意味しません。それどころか、私たちのアーユルヴェーダキッチンは最大の強みの1つです。私たちの熟練したシェフが準備した料理は、滞在中毎日あなたを驚かせ、楽しませてくれます！',
            philosophyText3: '朝食には、新鮮なトロピカルフルーツ、新鮮なジュース、栄養価の高いハーブスープ、自家製パン、軽いクッキー、およびさまざまな本物のスリランカの朝食オプションが満載の豪華なビュッフェをお楽しみください。昼食には、マイルドな魚カレー、野菜の準備、ハーブが注入された料理を備えた、カラフルでおいしいビュッフェをお楽しみください。夕方には、新鮮な魚のオプションが利用可能な設定された菜食メニューを提供します。土曜日には、「スリランカの夜」をビュッフェ拡張で祝う—私たちのシェフは、生き生きで本物の経験を作成して、あなたの前で伝統的なローカルの専門性を準備します。',
            philosophyText4: 'アーユルヴェーダでは、食べ物と飲料は多くの方法で分類されています。味と特性、体の消化能力（アグニ）、特定の健康状態への適用性、季節の適切さなど。Muthumuniでは、これらすべての要因を同時に慎重に検討し、各ゲストの個々の体質に合わせた6つの味すべてのバランスの取れた組み合わせに含める意識的な努力をしています。',
            philosophyText5: '私たちの食事には、新鮮な野菜、トロピカルフルーツ、責任を持って調達された魚が含まれています。赤身の肉やアルコールは提供していません。',
            philosophyText6: 'お食事の際には、アーユルヴェーダの医師または認定栄養士がいつでもお客様のご案内をさせていただきます。彼らは、あなたの現在の治療段階に最も適切な野菜、ハーブ、スパイスについてアドバイスし、それに応じて料理を選択または避けるのを支援します。あなたの個人的なハーブエリキシルと健康センターチームからの具体的な指示は、あなたの個別テーブルに配置されます。',
            philosophyText7: 'このレベルの個人的なケアと食事への注意は、Muthumuni Ayurveda Beach Resort体験の特徴です。',
            philosophyText8: 'すべての人間にとって、食べ物はプラーナ（生命を支える重要なエネルギー）と見なされています。だからこそ、各食事に完全な意識を持って取り組むことをお勧めします。香りを味わい、味を経験し、優しい温かさを感じ、おいしい感覚を意識的に楽しんでください。',
            diningExperienceEyebrow: 'ダイニング体験',
            restaurantTitlePrefix: '私たちの',
            ayurvedicHighlight: 'アーユルヴェーダ',
            restaurantTitleSuffix: 'レストラン',
            restaurantDetail1: 'Muthumuni Beach Resortの当社のアーユルヴェーダレストランは、伝統的なアーユルヴェーダの原則とスリランカの本物の沿岸料理を調和させたユニークなダイニング体験を提供しています。新鮮で地元産の食材を優先して、味覚を喜ばすだけでなく、全体的な幸福を促進する食事を作ります。',
            restaurantDetail2: 'メニューは、各料理の6つの味（甘い、酸っぱい、塩辛い、苦い、ピリッとした、渋い）のバランスを慎重に設計されており、栄養価が高く満足のいく体験を保証しています。各食事は丁寧に準備され、その治癒特性で知られているアーユルヴェーダのハーブとスパイスが組み込まれています。',
            restaurantDetail3: 'ゲストは、個々のドーシャ（体の体質）に合わせてカスタマイズされたさまざまな料理を楽しむことができます。ベジタリアン、ビーガン、ペスカタリアンの食事のオプションがあります。私たちのシェフはアーユルヴェーダの医師と密接に協力して、各食事がゲストの健康とウェルネスの目標をサポートしていることを確認します。',
            restaurantDetail4: 'レストランの雰囲気は静かな沿岸環境を反映し、マインドフルな食事のための落ち着いた雰囲気を提供しています。豪華な朝食ビュッフェを楽しんでも、グルメディナーを味わっても、私たちのアーユルヴェーダレストランでのすべての食事は、体と魂を育む機会です。',
            restaurantDetail5: 'Muthumuni Beach Resortのアーユルヴェーダレストランで、スリランカの豊かな風味を祝いながら、アーユルヴェーダの時代を超えた知恵を受け入れる料理の旅に参加してください。',
            restaurantImageAlt: 'Muthumuni Ayurveda River Resortでのダイニング',
            premiumDiningLabel: 'プレミアムダイニング',
            premiumDiningDescription: '穏やかなリバーサイド環境で本物のアーユルヴェーダ料理をお楽しみください',
            treatmentProgramme: {
                title: 'アーユルヴェーダ治療プログラム',
                subtitle: 'バランス、解毒、深い更新へのあなたの旅',
                intro: '平和な静修地での本物のアーユルヴェーダの癒しを体験してください。体を修復し、心を落ち着かせ、エネルギーを取り戻すよう設計されています。到着した瞬間から、私たちのチームがすべての詳細を配慮します—あなたが完全にあなたの健康に焦点を当てることができるようにするためです。',
                welcomeTitle: 'ようこそと優しい始まり',
                doctorTitle: '医師相談とパーソナルプラン',
                dailyTherapiesTitle: '毎日のアーユルヴェーダセラピー',
                herbalMedicineTitle: 'ハーブ医学サポート',
                yogaMeditationTitle: 'ヨガと瞑想による心身の調和',
                wellnessTitle: 'ウェルネス体験の含有',
                closingTitle: '閉会式と出発',
                welcomePoints: [
                    '空港送迎とホテル送達',
                    '温かいおもてなしとホテルオリエンテーション',
                    'あなたの週間ウェルネススケジュールへの紹介',
                    'リラックスマッサージ（1日目）アーユルヴェーダセンターで、旅の疲労を緩和し、体を治療に備える'
                ],
                doctorPoints: [
                    'アーユルヴェーダ医師相談（2日目–午前）',
                    'あなたのドーシャ/体のタイプと健康上の懸念の完全な評価',
                    '翻訳者はリクエストに応じて利用可能',
                    'あなたの医師があなたのニーズと目標に合わせたパーソナライズされた治療プランを作成します'
                ],
                dailyTherapiesPoints: [
                    '1日4～5回の治療（医師が推奨）',
                    'あなたの体構成と状態に基づいて選ばれた療法',
                    '必要に応じて特別マッサージを追加できます',
                    '医師は毎日進行状況を監視し、最良の結果を確保するために治療とハーブサポートを調整する場合があります',
                    '適切な場合、穏やかなクレンジング/下剤プロセスが推奨される場合があります'
                ],
                herbalMedicinePoints: [
                    '医師が処方したハーブ薬を1日2回:',
                    '朝食時',
                    '夕食時',
                    '内部治癒、解毒、長期的なバランスをサポート'
                ],
                yogaMeditationPoints: [
                    '週に4回のヨガセッション（約1時間）',
                    '週に2回の瞑想セッション:',
                    '島のお寺での独特な精神体験、ボートでアクセス可能',
                    '僧侶による瞑想ガイダンス（約1時間）'
                ],
                wellnessPoints: [
                    '毎週の健康的な料理デモンストレーション',
                    '無料遠足（文化/自然体験）'
                ],
                closingPoints: [
                    '美しいフラワーバス（最後の日）—更新の伝統儀式',
                    '進捗をレビューして提供するための最終医師相談:',
                    '継続的なウェルネスガイダンス',
                    'ホーム処方と推奨事項',
                    '空港への返却送達'
                ]
            },
        },
        yoga: {
            heroTitle: 'リゾートのヨガ',
            heroSubtitle: 'ベルワラでバランス、強さ、内なる平穏を見つける',
            heroAlt: 'Muthumuni Beach Resortのヨガ',
            importanceEyebrow: 'ウェルネスとバランス',
            importanceTitle: 'ヨガと瞑想の重要性',
            importanceImageAlt: 'ヨガと瞑想の重要性',
            importanceText1: 'ヨガと瞑想は、身体的・精神的・感情的に多くの恩恵をもたらす古代の実践です。柔軟性、筋力、バランスを高めながら、ストレスや不安を軽減します。',
            importanceText2: '継続的な実践は集中力を高め、睡眠の質を改善し、全体的なウェルビーイングを促進します。ヨガはマインドフルネスも育み、内なる自分とつながり、日常の喧騒の中でも平穏を見つける助けになります。',
            importanceText3: 'Muthumuni Beach Resortでは、ヨガや瞑想に最適な静かな環境を提供し、心・体・魂をリフレッシュできるようにしています。',
            practiceEyebrow: '私たちの実践',
            practiceTitle: 'ヨガの実践と体験',
            practiceImageAlt: 'リゾートでのヨガ練習',
            practiceText1: 'Muthumuni Ayurveda Beach Resortでは、主に伝統的なハタヨガにプラーナーヤーマ（呼吸法）を組み合わせて行います。このホリスティックなアプローチは内なる気づきを高め、クンダリーニ（第三の目とも呼ばれる）を穏やかに刺激することを目的としています。背骨のアライメントと柔軟性を特に重視し、柔らかな背骨は老化を遅らせると考えられています――「あなたの年齢は背骨次第です。」',
            practiceText2: 'ヨガセッションは週4回行われ、初心者から経験者まで参加できます。時折アシュタンガ・ヨガなどの特別セッションも実施され、さまざまなポーズやルーティンを体験できます。アーユルヴェーダ医師は、治療プログラムの支援と強化のために定期的な参加を推奨しています。',
            practiceText3: 'すべてのヨガセッションは専用のYoga Shalaで行われます。集中力、バランス、マインドフルな動きを支えるために設計された静かな空間です。各セッションは通常、太陽礼拝から始まり、その後プラーナーヤーマと、柔軟性・循環・全体的な健康を高めるために選ばれたアーサナのシークエンスが続きます。',
            practiceText4: '経験豊富なヨガ講師が、ゲストのニーズ、能力、健康状態に合わせて各セッションを調整し、安全で支えのある、深く有益なヨガ体験を提供します。',
            spiritualEyebrow: 'スピリチュアルな旅',
            spiritualTitle: '瞑想とスピリチュアル活動',
            spiritualSubtitle: '神聖な儀式とガイド付き瞑想でスピリチュアルな実践を深めましょう',
            meditationImageAlt: 'リゾートでの瞑想とスピリチュアルプラクティス',
            meditationTitle: '瞑想セッション',
            meditationDesc: 'ゲストは、週3回開催される仏教の伝統に着想を得たガイド付き瞑想に参加できます。これらのセッションは、心を落ち着かせ、気づきを深め、感情的・精神的な癒やしを支えるよう設計されています。瞑想は静かな島の寺院で行われ、ゲストはボートで訪れます――穏やかで意味深い旅が全体の瞑想体験を豊かにします。'
        },
        home: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: '海のアーユルヴェーダ',
            heroSubtitle2: 'バランスを見つけ、楽に呼吸し、ベルワラであなたのエネルギーを更新してください。',
            exploreResort: 'リゾートを探索',
            bookNow: '今すぐ予約',
            welcomeLabel: 'ようこそ',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'ベルワラの手つかずの海岸に位置するMuthumuni Ayurveda Beach Resortは、古い治癒の伝統とモダンな海岸の贅沢の調和した融合を提供しています。私たちの聖域は、インド洋のリズミカルな音とアーユルヴェーダの時代を超えた叡智が出会う、変革的なウェルネスの旅へあなたを招待します。',
            welcomeDesc2: 'パーソナライズされたアーユルヴェーダトリートメント、あなたのドーシャのバランスを保つために精心込めて作られた栄養食、そして息をのむような海の景色の優雅な客室でくつろいでください。若返り、リラクゼーション、または精神的な再生を求めているかどうかにかかわらず、私たちの専任のアーユルヴェーダプラクティショナーとウェルネスの専門家チームはあらゆる段階であなたをガイドします。',
            learnMore: '詳細を学ぶ',
            contactUs: 'お問い合わせ',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'アーユルヴェーダ ウェルネス & ビーチ レトリート',
            welcomeImageLocation: 'スリランカ、ベルワラ',
            highlightTitle: '海辺のアーユルヴェーダ聖地',
            highlightDesc: 'スリランカの南西海岸で全体的な治癒を見つけます。カスタマイズされた治療から静かなバルコニーとマインドフルな食事まで、すべての細部があなたのリズムを復元するために設計されています。',
            service1Title: '総合的なアーユルヴェーダセラピー',
            service1Desc: 'パーソナライズされたコンサルテーション、正真正銘のハーバルオイル、経験豊富なアーユルヴェーダ医師に導かれた毎日のトリートメント。',
            service2Title: 'ビーチフロント客室とスイート',
            service2Desc: '海風に目覚め、プライベートバルコニー、深いリラックスのために設計されたなだめるような内部。',
            service3Title: 'ウェルネス料理',
            service3Desc: 'スリランカの新鮮な農産物、プラントフォワードメニュー、あなたのドーシャを補完するカスタマイズされた食事計画。',
            service4Title: 'ヨガとマインドフルネス',
            service4Desc: '朝日ヨガ、夕焼け瞑想、波のリズムに合わせた呼吸運動。',
            service5Title: '川と沿岸の遠足',
            service5Desc: 'ベントタ川でのボートツアー、ウミガメの孵化場訪問、スパイスガーデンウォーク、村でのサイクリングツアー。',
            roomsTitle: '私たちの客室',
            roomsDesc: 'あなたのペースに合わせた聖地を選択してください。広々としたスイートから快適なデラックスの隠れ家まで、柔らかいリネン、温かい木、日の出の準備ができたバルコニー備え付き。',
            roomBadge: 'ビーチフロント エスケープ',
            bookableNow: '今すぐ予約可能',
            seaBreezeReady: '海風の準備ができた',
            viewRoom: 'ルームを表示',
            room1Title: 'スイート客室',
            room1Desc: 'ラウンジエリア付きの広々としたスイート、広々とした バルコニー、ゆっくりした朝のための穏やかなパレット。',
            room2Title: 'デラックス客室',
            room2Desc: 'ぜいたくなベッド、庭園の景色、日常の快適さのための温かい木製のアクセント付きの居心地の良い隠れ家。',
            room3Title: 'デラックス シービュー',
            room3Desc: '海の地平線で目覚め、柔らかいリネン、黄金色の夕日のためのプライベートバルコニー。',
            achievement1Title: '幸せなゲスト',
            achievement1Count: '1,000+',
            achievement2Title: 'アーユルヴェーダトリートメント',
            achievement2Count: '20+',
            achievement3Title: 'ケアの年',
            achievement3Count: '15+',
            achievement4Title: 'トラベラー アクラレム',
            achievement4Count: '1,000+',
            experiencesTitle: 'Muthumuni Ayurveda Beach Resortを探索',
            experiencesDesc: 'アーユルヴェーダの旅から厳選された遠足まで、あなたの滞在を忘れられさせる経験を選択してください。',
            planYourStay: 'あなたのステイをプラン',
            experience1Title: '客室とスイート',
            experience1Desc: 'バルコニー、海または庭園の景色を望む風通しの良いスペース、急いでいない滞在のための思慮深いコンフォート。',
            experience2Title: 'アーユルヴェーダスパ',
            experience2Desc: '本格的なセラピー、スチームバス、時代の試練に耐えた儀式で行われた再生マッサージ。',
            experience3Title: '食事体験',
            experience3Desc: '当レストランで提供されるスリランカ料理と国際料理、心身を養うために慎重に準備。',
            experience4Title: '体験とツアー',
            experience4Desc: 'リバーサファリ、寺院訪問、ウォータースポーツ、ベントタ周辺のキュレーションされた文化遠足。',
            galleryTitle: 'Muthumuni Ayurveda Beach Resortでの瞬間',
            galleryDesc: '私たちの沿岸の聖地を垣間見ましょう――日の出、穏やかなトリートメント、栄養のある料理、あなたのための静かな角。',
            gallery1Alt: 'ムトゥムニヤシで囲まれた日当たりの良いビーチ',
            gallery2Alt: '進行中のアーユルヴェーダオイルトリートメント',
            gallery3Alt: 'ラウンジャー付きリゾートプール',
            gallery4Alt: 'スパ用に準備されたハーブ',
            gallery5Alt: 'カップルが海での日没を楽しむ',
            gallery6Alt: 'オーシャンフェーシングヨガデッキ',
            gallery7Alt: '熱帯庭園の小道',
            gallery8Alt: 'ヘルシーな朝食',
            gallery9Alt: '穏やかな河の景色',
            gallery10Alt: '夕焼け時のリゾート外観が温かく照らされた',
            gallery11Alt: 'アーユルヴェーダハーブとオイルディスプレイ',
            gallery12Alt: '庭園での快適な座席',
            resort1Alt: 'グリーンのオープンエアラウンジ',
            resort2Alt: '快適なルームインテリア',
            resort3Alt: 'スパトリートメントスペース',
            resort4Alt: '自然光付きダイニングエリア',
            resort5Alt: 'リラックスプームの眺め',
            sunsetLabel: '自然の毎日の傑作',
            sunsetTitle: '夕方の夕焼け',
            sunsetDesc1: '日が優雅に薄暮に降伏し、空が琥珀、深紅、金色のキャンバスに変わるのを見てください。温和なインド洋はこの天体の光景を反映し、光と水の魅惑的なシンフォニーを作成します。',
            sunsetDesc2: 'Muthumuniでの毎晩は、自然の最も息をのむようなパフォーマンスの1つへのフロントロウシートを提供します。あなたの完璧な有利な点を見つけてください――プライベートバルコニー、ビーチサイドラウンジ、または日没瞑想デッキから――穏やかな美しさが洗い流でください。',
            sunsetFeature1: '各隅からの遮られていない海の景色',
            sunsetFeature2: '日没穏やかな瞑想',
            sunsetFeature3: '毎日提供されるコンプリメントしてハーバルティー',
            sunsetFeature4: '毎晩のフォトジェニックな瞬間',
            sunsetImageAlt: 'Muthumuni Beach Resortでの夜間日没',
            bestTime: 'ベストタイム',
            sunsetTime: '午後6時～6時45分',
            poolLabel: '水生の静寂',
            poolTitle: 'プールエリア',
            poolDesc1: '結晶のような水が豪華な熱帯庭園と出会う、当社の素晴らしい無限プールの静寂に没入してください。リラクゼーションと若返りのために設計された、私たちのプールエリアはスリランカの太陽の下でくつろぐための完璧な逃げ場を提供します。',
            poolDesc2: '爽快な朝泳ぎ、良い本を持った午後のラウンジセッション、穏やかな夕方の浸浴を好むかどうかにかかわらず、当社のプールエリアは牧歌的な設定を提供しています。快適なラウンジャー、陰のあるカバナ、気配りのあるプールサイドサービスに囲まれて、すべての瞬間が大切な思い出になります。',
            poolFeature1: '温度制御された無限プール',
            poolFeature2: '熱帯庭園の風景に囲まれた',
            poolFeature3: 'プールサイドのリフレッシュメント＆ヘルシースナック',
            poolFeature4: '傘付きプレミアムラウンジャー',
            poolImageAlt: 'Muthumuni Resortでリラックスなプールエリア',
            testimonialsTitle: '彼らの滞在中のゲスト'
        },
    },
    cs: {
        about: {
            heroTitle: 'O nás',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Staré hlášky se setkávají s moderním v Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Personalizované ayurvédské léčby, výhled na oceán a autentické hotelnictví Sri Lanky',
            slide1: 'Ayurvédská léčba',
            slide2: 'Pobřežní klid',
            slide3: 'Zahradní klid',
            slide4: 'Bylinné terapie',
            slide5: 'u oceánu',
            historyLabel: 'Naše cesta',
            historyTitle: 'Historie resortu Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Muthumuni Ayurveda Beach Resort byl založen před více než dvěma dekádami na základě vize vytvořit svatyni, kde se staré ayurvédské moudrosti setkává s klidnou krásou jižnícího pobřeží Sri Lanky. To, co začalo jako skromný útulný, se rozvinulo v jednu z nejoblíbenějších destinací Beruwalay pro holistické uzdravení a omlazení.',
            historyDesc2: 'Naši zakladatelé, inspirovaní generacemi tradičních ayurvédských praktiků, se snažili zachovat tato prověřená léčebná umění a přitom poskytovat moderní pohodlí a autentické hotelnictví Sri Lanky. V průběhu let jsme zůstali věrni našemu závazku autentických zážitků a rozšiřovali jsme naše zařízení, aniž bychom si všimli osobní péče definující naše dědictví.',
            historyDesc3: 'Dnes Muthumuni stojí jako důkaz trvalé moci ayurvédy a miliony hostů z celého světa. Každý návštěvník se stává součástí naší příběhu a nachází rovnováhu, uzdravení a transformaci v našem pobřežním útulném.',
            statYear: '15+',
            statYearLabel: 'Let excelence',
            statGuest: '1.000+',
            statGuestLabel: 'Spokojení hosté obsluhováni',
            experienceLegacy: 'Zažijte naše dědictví',
            established: 'Založeno',
            since2010: 'Od roku 2008',
            chairmanLabel: 'Poselství předsedy',
            chairmanTitle: 'Veden péči, zakořeněn v Ayurvédě',
            chairmanDesc1: 'Vítejte v Muthumuni Ayurveda Beach Resort. Více než dvě dekády je naším účelem jednoduché: poskytnout opravdové uzdravení zakořeněné v nečasové moudrosti ayurvédy, dodávané s vřelostí hotelnictví Sri Lanky.',
            chairmanDesc2: 'Zde je každý detail — od našich léčeb a kuchyně po klid našich prostorů — navržen tak, aby vám pomohl zpomalit, obnovit rovnováhu a znovu se připojit k sobě. Jsme čestni být součástí vaší cesty.',
            chairmanDesc3: 'Jménem našeho oddaného týmu vás zvu, abyste si vyzkoušeli péči, autentičnost a klid, které definují Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Předseda',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Předseda Mr. Nihal Muthumuni',
            staffLabel: 'Náš tým',
            staffTitle: 'Poznáte náš oddaný personál',
            staffDesc1: 'V Muthumuni Ayurveda Beach Resort je náš tým jádrem všeho, co děláme. Členové našeho personálu jsou pečlivě vybraní a vyškolení odborníci, kteří sdílejí hlubokou vášeň pro ayurvédský a autentické hotelnictví.',
            staffDesc2: 'Ot našich zkušených ayurvédských praktiků a kvalifikovaných masérů až po náš oddaný tým v hotelnictví, každý člen přináší roky odbornosti a autentické péče do každé interakce s hosty. Věříme, že skutečný nepochází jen z léčeb, ale z vřelosti a pozornosti lidí, kteří se opravdu starají o vaši cestu.',
            staffDesc3: 'Náš personál prochází nepřetržitým školením v nejnovějších ayurvédských praktikách a udržuje nejvyšší standardy profesionality a kulturní citlivosti. Jsme na tvorbě smysluplných připojení s našimi hosty hrdí a zajišťujeme, aby každá návštěva zažívala paměť a transformační zkušenost.',
            statStaff: '15+',
            statStaffLabel: 'Kvalifikovaní odborníci',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Spokojenost hostů',
            staffImageAlt: 'Náš oddaný tým personálu v Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Náš závazek',
            excellenceCare: 'Dokonalost a péče',
            ctaLabel: 'Kontaktní',
            ctaHeading: 'Jste připraveni zahájit svou cestu?',
            ctaDesc: 'Kontaktujte náš tým a rezervujte si svůj personalizovaný ayurvédský útulný. Pokud máte otázky ohledně našich léčby, ubytování nebo speciálního balíčky, jsme tu proto, abychom vám pomohli vytvořit vaší dokonalou únik.',
            ctaButtonContact: 'Kontaktujte nás nyní',
            ctaButtonRooms: 'Prozkoumejte pokoje',
            contactUs: 'Kontaktujte nás',
            quickInfoCall: 'Zavolejte nám',
            quickInfoEmail: 'Pošli nam email',
            quickInfoLocation: 'Poloha',
            locationCity: 'Beruwala, Sri Lanka'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe pokoj s výhledem na řeku — Komfort s terasou nebo soukromým balkonem',
            heroSubtitle: 'Odpočívejte v klidném útočišti na břehu řeky, inspirovaném tichými vodami Bentoty, s moderním vybavením a jemným říčním vánkem.',
            bookThisRoom: 'Rezervovat tento pokoj',
            callReservations: 'Zavolat rezervacím',

            navAll: 'Vše',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe s výhledem na řeku',

            soothingHideawayTitle: 'Uklidňující úkryt na břehu řeky',
            soothingHideawayDesc: 'Náš Deluxe pokoj s výhledem na řeku je navržen pro pomalá rána a bezstarostné západy slunce. Měkké neutrální tóny, velké prosklené plochy a promyšlené osvětlení vpouští dovnitř výhled na řeku, zatímco balkon se stává vaším soukromým koutkem nad tekoucí vodou.',

            highlight1Title: 'Panoramatický výhled na řeku',
            highlight1Desc: 'Probuďte se s klidným výhledem na řeku a zlatými východy slunce z vašeho soukromého balkonu.',
            highlight2Title: 'Elegantní interiéry u řeky',
            highlight2Desc: 'Měkké neutrální odstíny, teplé dřevěné akcenty a štědré přirozené světlo.',
            highlight3Title: 'Uklidňující spánkový zážitek',
            highlight3Desc: 'Nadýchaná postel king-size s prémiovým povlečením pro regenerační odpočinek.',

            atAGlance: 'Na první pohled',
            statSizeLabel: 'Velikost',
            statViewLabel: 'Výhled',
            statViewValue: 'Na řeku',
            statGuestsLabel: 'Hosté',
            statBedLabel: 'Postel',
            statBedValue: 'King nebo Twin',
            reserve: 'Rezervovat',

            includedWithStay: 'Součástí pobytu',
            thoughtfulTouches: 'Promyšlené detaily, celodenní komfort',
            enhancedCleanliness: 'Zvýšené standardy čistoty a bezpečnosti',

            inclusion1: 'Snídaně, oběd a večeře zdarma v restauraci Breeze',
            inclusion2: 'Vysokorychlostní Wi-Fi a pracovní kout v pokoji',
            inclusion3: '24hodinový room service a concierge',
            inclusion4: 'Denní úklid s večerním turndownem',
            inclusion5: 'Přístup k nekonečnému bazénu a ayurvédskému spa',
            inclusion6: 'Parkování zdarma a kyvadlová doprava k blízkým atrakcím',

            amenityGroup1Title: 'Vlastnosti pokoje',
            amenityGroup1Item1: '38 m² prostoru',
            amenityGroup1Item2: 'Soukromý balkon se sezením',
            amenityGroup1Item3: 'Klimatizace s individuálním ovládáním',
            amenityGroup1Item4: 'Sejf v pokoji',

            amenityGroup2Title: 'Koupelna',
            amenityGroup2Item1: 'Dešťová sprcha s teplou a studenou vodou',
            amenityGroup2Item2: 'Prémiové koupelnové potřeby',
            amenityGroup2Item3: 'Fén',
            amenityGroup2Item4: 'Měkké župany a pantofle',

            amenityGroup3Title: 'Pohodlí v pokoji',
            amenityGroup3Item1: '55" chytrá TV s kabelovkou',
            amenityGroup3Item2: 'Stanice na kávu a čaj',
            amenityGroup3Item3: 'Přímá telefonní linka',

            amenityGroup4Title: 'Připojení',
            amenityGroup4Item1: 'Wi-Fi zdarma',
            amenityGroup4Item2: 'Pracovní stůl',
            amenityGroup4Item3: 'Podpora recepce 24/7',

            inRoomEssentials: 'Nezbytnosti v pokoji',
            everythingYouNeed: 'Vše, co potřebujete, abyste se cítili jako doma',
            inRoomEssentialsDesc: 'Od bezproblémového připojení po pečlivě vybrané občerstvení — Deluxe pokoj s výhledem na řeku spojuje volný čas a praktičnost, abyste se mohli soustředit na důležité okamžiky.',

            complimentaryWifi: 'Wi-Fi zdarma',
            coffeeTeaStation: 'Stanice na kávu a čaj',
            roomService: 'Room service 24/7',
            rainShower: 'Dešťová sprcha',

            byTheRiver: 'U řeky',
            slowDownBreathe: 'Zpomalte, nadechněte se čerstvého vzduchu',

            readyToStay: 'Připraveni na pobyt?',
            reserveDeluxeRiverViewToday: 'Rezervujte Deluxe pokoj s výhledem na řeku ještě dnes',
            speakReservations: 'Kontaktujte náš rezervační tým pro nejlepší dostupné ceny a speciální nabídky.',
            checkAvailability: 'Zkontrolovat dostupnost'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Vaše útočiště na vás čeká',
            heroSubtitle: 'Příbřežní útočiště navržená pro léčení, obnovu a hluboký klid podél klidné řeky Bentota.',
            exploreRooms: 'Prozkoumat pokoje',

            filterAll: 'Vše',
            filterDeluxeRooms: 'Deluxe pokoje',
            filterRiverViewDeluxe: 'Deluxe pokoj s výhledem na řeku',

            deluxeRoomName: 'Deluxe pokoj',
            deluxeRoomCategory: 'Deluxe pokoje',
            deluxeRoomDesc: 'Harmonicky vyvážený pokoj s přírodními dřevěnými prvky a výhledem na řeku pro dokonalý klid.',

            riverViewDeluxeName: 'Deluxe s výhledem na řeku',
            riverViewDeluxeCategory: 'Deluxe pokoj s výhledem na řeku',
            riverViewDeluxeDesc: 'Probuďte se za jemného šumu řeky a užívejte si panoramatický výhled na říční břeh v tomto elegantně navrženém deluxe pokoji.',

            noRoomsFound: 'V této kategorii nebyly nalezeny žádné pokoje.',
            roomSize: 'Velikost pokoje',
            guests: 'Hosté',
            amenitiesCount: 'Vybavení',
            roomAmenities: 'Vybavení pokoje',
            specialFeatures: 'Speciální vlastnosti',

            kingSizeBed: 'Postel King Size',
            workDesk: 'Pracovní stůl',
            rainShower: 'Dešťová sprcha',
            teaStation: 'Čajový koutek',
            privateTerrace: 'Soukromá terasa',
            binoculars: 'Dalekohled',

            riverView: 'Výhled na řeku',
            naturalLighting: 'Přirozené osvětlení',
            gardenView: 'Výhled do zahrady',
            sunriseBalcony: 'Balkon pro východ slunce',
            soundOfRiver: 'Zvuk řeky',

            bookNow: 'Rezervovat nyní',
            viewDetails: 'Zobrazit detaily',
            viewRoom: 'Zobrazit pokoj',

            allRoomsInclude: 'Všechny pokoje zahrnují',
            essentialComforts: 'Základní pohodlí pro vaši cestu',

            highSpeedWifi: 'Vysokorychlostní Wi-Fi',
            herbalTea: 'Výběr bylinkových čajů',
            climateControl: 'Klimatizace',
            organicToiletries: 'Organické toaletní potřeby',
            dailyHousekeeping: 'Denní úklid',
            concierge: 'Konciérž 24/7',
            yogaMat: 'Jógová podložka a pomůcky',

            beginHealing: 'Začněte svou léčebnou cestu',
            beginHealingDesc: 'Zažijte autentický ájurvédský v klidném říčním prostředí navrženém tak, aby vyživovalo tělo, uklidnilo mysl a obnovilo ducha.',
            reserveRoom: 'Rezervovat pokoj',
            speakAdvisor: 'Promluvit si s poradcem',

            exploreOurRooms: 'Prozkoumat naše pokoje'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Ájurvéda u řeky',
            heroTagline: 'Najděte rovnováhu, dýchejte volně a obnovte svou energii v Aluthgamě',
            exploreResort: 'Prozkoumat resort',
            bookNow: 'Rezervovat nyní',

            welcomeLabel: 'Vítejte',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Muthumuni Ayurveda River Resort leží na klidném břehu řeky Bentota a nabízí harmonické spojení starodávných léčebných tradic s tichou přírodní krásou. Naše útočiště vás zve na transformační cestu wellness, kde se jemný tok řeky setkává s nadčasovou moudrostí ájurvédy.',
            welcomeDesc2: 'Zažijte personalizované ájurvédské terapie, vychutnejte si výživnou kuchyni přizpůsobenou vašemu dóše a odpočívejte v elegantně zařízených pokojích s dechberoucím výhledem na řeku. Ať už hledáte regeneraci, relaxaci nebo duchovní obnovu, náš oddaný tým ájurvédských praktiků a expertů vás bude provázet na každém kroku.',
            learnMore: 'Zjistit více',
            contactUs: 'Kontaktujte nás',
            welcomeImageCaption: 'Ájurvédský & říční útočiště',
            welcomeImageLocation: 'Aluthgama, Srí Lanka',

            highlightTitle: 'Ájurvédské útočiště u řeky',
            highlightDesc: 'Objevte celostní léčení podél klidného břehu řeky Bentota. Od individuálních terapií přes tiché balkony až po vědomou kuchyni – každý detail je navržen tak, aby obnovil váš přirozený rytmus.',

            roomsTitle: 'Naše pokoje',
            roomsDesc: 'Vyberte si útočiště, které odpovídá vašemu tempu – od vzdušných suit až po útulné deluxe úkryty, každý s měkkým povlečením, teplým dřevem a balkonem připraveným na východ slunce.',
            room1Title: 'Deluxe pokoje',
            room1Desc: 'Příjemné útočiště s luxusními postelemi, výhledem do zahrady a teplými dřevěnými detaily pro každodenní pohodlí.',
            room2Title: 'Deluxe s výhledem na řeku',
            room2Desc: 'Probuďte se s výhledem na klidnou řeku, měkkým povlečením a soukromým balkonem ideálním pro poklidná rána.',
            viewRoom: 'Zobrazit pokoj',
            bookableNow: 'Rezervovatelné ihned',
            riverBreezeReady: 'Připraveno na říční vánek',
            roomBadge: 'Únik u řeky',

            achievementsTitle: 'Důvěryhodný u řeky',
            achievement1Title: 'Spokojení hosté',
            achievement1Count: '1 000+',
            achievement2Title: 'Ájurvédské terapie',
            achievement2Count: '20+',
            achievement3Title: 'Let péče',
            achievement3Count: '15+',
            achievement4Title: 'Ocenění cestovatelů',
            achievement4Count: '1 000+',

            experiencesTitle: 'Objevte zážitky v Muthumuni Ayurveda River Resort',
            experiencesDesc: 'Od ájurvédských cest po pečlivě vybrané výlety – vyberte si zážitky, které udělají váš pobyt nezapomenutelným.',
            planYourStay: 'Naplánujte si pobyt',
            experience1Title: 'Naše pokoje',
            experience1Desc: 'Vzdušné prostory s balkony, výhledem na řeku nebo zahradu a pečlivě promyšleným komfortem pro pohodový pobyt.',
            experience2Title: 'Ájurvédské spa',
            experience2Desc: 'Autentické terapie, parní lázně a regenerační masáže prováděné podle starodávných rituálů.',
            experience3Title: 'Večeře u řeky',
            experience3Desc: 'Výživná srílanská a mezinárodní kuchyně navržená tak, aby vyživovala tělo i mysl.',
            experience4Title: 'Zážitky a výlety',
            experience4Desc: 'Plavby po řece Bentota, návštěvy chrámů, vodní sporty a kurátorské kulturní výlety v okolí Bentoty.',

            galleryTitle: 'Okamžiky v Muthumuni Ayurveda River Resort',
            galleryDesc: 'Pohled do našeho říčního útočiště – východy slunce, klidné terapie, výživné pokrmy a tiché kouty vytvořené pro vás.',
            gallery1Alt: 'Sluncem ozářený břeh řeky lemovaný palmami v Muthumuni',
            gallery2Alt: 'Probíhající ájurvédská olejová terapie',
            gallery3Alt: 'Bazén resortu s lehátky',
            gallery4Alt: 'Bylinné suroviny připravené pro spa',
            gallery5Alt: 'Pár užívající si západ slunce u řeky',
            gallery6Alt: 'Jógová plošina s výhledem na řeku',
            gallery7Alt: 'Cestička tropickou zahradou',
            gallery8Alt: 'Zdravá snídaně',
            gallery9Alt: 'Klidný výhled na řeku',
            gallery10Alt: 'Teplé osvětlení exteriéru resortu za soumraku',
            gallery11Alt: 'Výstava ájurvédských bylin a olejů',
            gallery12Alt: 'Pohodlné posezení u zahrady',

            boatLabel: 'Dobrodružství na řece',
            boatTitle: 'Plavby lodí po řece Bentota',
            boatDesc1: 'Prožijte kouzlo řeky Bentota s našimi okouzlujícími plavbami lodí. Klouzejte klidnými vodními cestami obklopenými bujnými mangrovovými lesy a pozorujte exotickou faunu – barevné ledňáčky, krokodýly, varany a hravé opice. Ideální pro milovníky přírody a fotografy hledající nezapomenutelné okamžiky.',
            boatDesc2: 'Ať už zvolíte klidnou ranní plavbu, romantickou večerní cestu při západu slunce nebo dobrodružné objevování divoké přírody, naši zkušení průvodci vám povědí fascinující informace o ekosystému řeky. Přizpůsobte si zážitek s možností soukromé plavby nebo se připojte k skupinovým výletům pro hlubší spojení s přírodou.',
            boatFeature1: 'Malebné plavby řekou přes mangrovy',
            boatFeature2: 'Pozorování divoké zvěře – ptáci, krokodýli a opice',
            boatFeature3: 'Možnosti plaveb při východu a západu slunce',
            boatFeature4: 'Zkušení místní průvodci zahrnuti',
            boatImageAlt: 'Plavba lodí po řece Bentota',

            poolLabel: 'Vodní klid',
            poolTitle: 'Zóna bazénu',
            poolDesc1: 'Ponořte se do klidu v našem křišťálově čistém nekonečném bazénu, kde se hladina vody setkává s bujnou tropickou zahradou. Bazénová zóna je navržena pro relaxaci a regeneraci a nabízí dokonalý únik k odpočinku pod srílanským sluncem.',
            poolDesc2: 'Ať už dáváte přednost osvěžujícímu rannímu plavání, odpolednímu lenošení s dobrou knihou nebo klidnému večernímu koupání, naše bazénová zóna poskytuje idylické prostředí. Obklopena pohodlnými lehátky, stíněnými altánky a pozorným servisem u bazénu se každý okamžik stává vzácnou vzpomínkou.',
            poolFeature1: 'Nekonečný bazén s regulací teploty',
            poolFeature2: 'Obklopen tropickou zahradní krajinou',
            poolFeature3: 'Občerstvení a zdravé snacky u bazénu',
            poolFeature4: 'Prémiová lehátka s parasoly',
            poolImageAlt: 'Relaxační bazénová zóna',

            testimonialsTitle: 'Názory hostů na jejich pobyt',

            bookingDestination: 'Cíl',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Příjezd',
            bookingCheckOut: 'Odjezd',
            bookingGuests: 'Hosté',
            guestsOption1: '1 host',
            guestsOption2: '2 hosté',
            guestsOption3: '3 hosté',
            guestsOption4: '4+ hostů',
            bookingCheckAvailability: 'Zkontrolovat dostupnost',

            service1Title: 'Celostní ájurvédské terapie',
            service1Desc: 'Personalizované konzultace, autentické bylinné oleje a denní terapie vedené zkušenými ájurvédskými lékaři.',

            service2Title: 'Pokoje u řeky',
            service2Desc: 'Probuďte se za jemného zvuku řeky, s privátními balkony a uklidňujícím interiérem navrženým pro hluboký odpočinek.',

            service3Title: 'kuchyně',
            service3Desc: 'Čerstvé srílanské suroviny, rostlinné menu a jídelní plány přizpůsobené vašemu dóše.',

            service4Title: 'Jóga a všímavost',
            service4Desc: 'Jóga při východu slunce, meditace při západu slunce a dýchací cvičení v rytmu vln.',

            service5Title: 'Říční a pobřežní výlety',
            service5Desc: 'Plavby lodí po řece Bentota, návštěvy líhni želv, procházky v zahradách koření a cyklistické výlety po vesnicích.'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Deluxe pokoj – Komfort s terasou nebo soukromým balkonem',
            heroSubtitle: 'Odpočívejte v klidném útočišti na břehu řeky, inspirovaném tichými vodami Bentoty, s moderním vybavením a jemným říčním vánkem.',
            bookThisRoom: 'Rezervovat tento pokoj',
            callReservations: 'Zavolat rezervacím',

            navAll: 'Vše',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe s výhledem na řeku',

            soothingHideawayTitle: 'Uklidňující úkryt na břehu řeky',
            soothingHideawayDesc: 'Deluxe pokoj je navržen pro pomalá rána a bezstarostné západy slunce. Měkké neutrální tóny, velké prosklené plochy a promyšlené osvětlení vpouští dovnitř výhled na řeku, zatímco balkon se stává vaším soukromým koutkem nad tekoucí vodou.',

            highlight1Title: 'Panoramatický výhled na řeku',
            highlight1Desc: 'Probuďte se s klidným výhledem na řeku a tropickými východy slunce z vašeho soukromého balkonu.',
            highlight2Title: 'Elegantní interiéry u řeky',
            highlight2Desc: 'Měkké neutrální odstíny, teplé dřevěné akcenty a štědré přirozené světlo.',
            highlight3Title: 'Uklidňující spánkový zážitek',
            highlight3Desc: 'Nadýchaná postel king-size s prémiovým povlečením pro regenerační odpočinek.',

            atAGlance: 'Na první pohled',
            statSizeLabel: 'Velikost',
            statViewLabel: 'Výhled',
            statViewValue: 'Na řeku',
            statGuestsLabel: 'Hosté',
            statBedLabel: 'Postel',
            statBedValue: 'King nebo Twin',
            reserve: 'Rezervovat',

            includedWithStay: 'Součástí pobytu',
            thoughtfulTouches: 'Promyšlené detaily, celodenní komfort',
            enhancedCleanliness: 'Zvýšené standardy čistoty a bezpečnosti',

            inclusion1: 'Snídaně, oběd a večeře zdarma v restauraci Breeze',
            inclusion2: 'Vysokorychlostní Wi-Fi a pracovní kout v pokoji',
            inclusion3: '24hodinový room service a concierge',
            inclusion4: 'Denní úklid s večerním turndownem',
            inclusion5: 'Přístup k nekonečnému bazénu a ayurvédskému spa',
            inclusion6: 'Parkování zdarma a kyvadlová doprava k blízkým atrakcím',

            amenityGroup1Title: 'Vlastnosti pokoje',
            amenityGroup1Item1: '41 m² prostoru',
            amenityGroup1Item2: 'Soukromý balkon se sezením',
            amenityGroup1Item3: 'Klimatizace s individuálním ovládáním',
            amenityGroup1Item4: 'Sejf v pokoji',

            amenityGroup2Title: 'Koupelna',
            amenityGroup2Item1: 'Dešťová sprcha s teplou a studenou vodou',
            amenityGroup2Item2: 'Prémiové koupelnové potřeby',
            amenityGroup2Item3: 'Fén',
            amenityGroup2Item4: 'Měkké župany a pantofle',

            amenityGroup3Title: 'Pohodlí v pokoji',
            amenityGroup3Item1: '55" chytrá TV s kabelovkou',
            amenityGroup3Item2: 'Stanice na kávu a čaj',
            amenityGroup3Item3: 'Přímá telefonní linka',

            amenityGroup4Title: 'Připojení',
            amenityGroup4Item1: 'Wi-Fi zdarma',
            amenityGroup4Item2: 'Pracovní stůl',
            amenityGroup4Item3: 'Podpora recepce 24/7',

            inRoomEssentials: 'Nezbytnosti v pokoji',
            everythingYouNeed: 'Vše, co potřebujete, abyste se cítili jako doma',
            inRoomEssentialsDesc: 'Od bezproblémového připojení po pečlivě vybrané občerstvení — Deluxe pokoj spojuje volný čas a praktičnost, abyste se mohli soustředit na důležité okamžiky.',

            complimentaryWifi: 'Wi-Fi zdarma',
            coffeeTeaStation: 'Stanice na kávu a čaj',
            roomService: 'Room service 24/7',
            rainShower: 'Dešťová sprcha',

            byTheRiver: 'U řeky',
            slowDownBreathe: 'Zpomalte, nadechněte se čerstvého vzduchu',

            readyToStay: 'Připraveni na pobyt?',
            reserveDeluxeToday: 'Rezervujte Deluxe pokoj ještě dnes',
            speakReservations: 'Kontaktujte náš rezervační tým pro nejlepší dostupné ceny a speciální nabídky.',
            checkAvailability: 'Zkontrolovat dostupnost'
        },
        aboutus2: {
            heroTitle: 'O nás',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Pradávná moudrost se setkává s klidnou krásou říčního břehu v Muthumuni Ayurveda River Resort',
            heroTagline2: 'Personalizované ájurvédské terapie, výhled na řeku a opravdová srílanská pohostinnost',
            slide1: 'Ájurvédské léčení',
            slide2: 'Klid u řeky',
            slide3: 'Zahradní pohoda',
            slide4: 'Bylinné terapie',
            slide5: 'Říční wellness',
            historyLabel: 'Naše cesta',
            historyTitle: 'Historie Muthumuni Ayurveda River Resort',
            historyDesc1: 'Založen před více než dvěma desetiletími, Muthumuni Ayurveda River Resort vznikl z vize vytvořit útočiště, kde se starobylá ájurvédská moudrost setkává s klidnou krásou říčních krajin Srí Lanky. Z původního skromného útočiště se vyvinul v jedno z nejvíce ceněných míst v Aluthgamě pro celostní léčení a omlazení.',
            historyDesc2: 'Naši zakladatelé, inspirováni generacemi tradičních ájurvédských praktiků, chtěli zachovat tato nadčasová léčebná umění a zároveň nabídnout moderní pohodlí a opravdovou srílanskou pohostinnost. V průběhu let jsme zůstali věrni svému závazku k autentickým zážitkům, rozšiřovali zařízení, aniž bychom kdy ztratili ze zřetele individuální péči, která definuje naše dědictví.',
            historyDesc3: 'Dnes Muthumuni stojí jako důkaz trvalé síly ájurvédy a přivítal tisíce hostů z celého světa. Každý návštěvník se stává součástí našeho příběhu a nachází rovnováhu, uzdravení a proměnu v našem klidném útočišti na břehu řeky.',
            statYear: '15+',
            statYearLabel: 'Let excelence ve wellness',
            statGuest: '1 000+',
            statGuestLabel: 'Spokojených hostů',
            experienceLegacy: 'Poznejte naše dědictví',
            established: 'Založeno',
            sinceYear: 'Od roku 1993',
            chairmanLabel: 'Poselství předsedy',
            chairmanTitle: 'Vedení péčí, zakořeněno v ájurvédě',
            chairmanDesc1: 'Vítejte v Muthumuni Ayurveda River Resort. Více než dvě desetiletí je náš cíl jednoduchý: nabízet opravdové léčení založené na nadčasové moudrosti ájurvédy, podávané s teplem srílanské pohostinnosti.',
            chairmanDesc2: 'Zde je každý detail — od terapií přes kuchyni až po klid našich prostor — navržen tak, aby vám pomohl zpomalit, obnovit rovnováhu a znovu se spojit se sebou samým. Je nám ctí být součástí vaší cesty.',
            chairmanDesc3: 'Jménem našeho oddaného týmu vás zvu, abyste zažili péči, autenticitu a klid, které definují Muthumuni.',
            chairmanBadge: 'Předseda',
            chairmanName: 'Pan Nihal Muthumuni',
            chairmanSignature: '— Pan Nihal Muthumuni',
            chairmanImageAlt: 'Předseda pan Nihal Muthumuni',
            staffLabel: 'Náš tým',
            staffTitle: 'Seznamte se s naším oddaným personálem',
            staffDesc1: 'V Muthumuni Ayurveda River Resort je náš tým srdcem všeho, co děláme. Naši zaměstnanci jsou pečlivě vybíráni a školení profesionálové, kteří sdílejí hlubokou vášeň pro ájurvédské a autentickou pohostinnost.',
            staffDesc2: 'Od našich zkušených ájurvédských praktiků a zručných masérů až po náš oddaný tým pohostinství – každý člen přináší roky zkušeností a opravdovou péči do každé interakce s hosty. Věříme, že skutečné nepochází jen z terapií, ale z tepla a pozornosti lidí, kterým na vaší cestě opravdu záleží.',
            staffDesc3: 'Náš personál pravidelně absolvuje školení v nejnovějších ájurvédských praktikách a zároveň dodržuje nejvyšší standardy profesionality a kulturní citlivosti. Jsme hrdí na to, že vytváříme smysluplné vazby s našimi hosty a zajišťujeme, aby každá návštěva byla nezapomenutelným a proměňujícím zážitkem.',
            statStaff: '15+',
            statStaffLabel: 'Kvalifikovaní profesionálové',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Spokojenost hostů',
            staffImageAlt: 'Náš oddaný tým v Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Náš závazek',
            excellenceCare: 'Dokonalost a péče',
            ctaLabel: 'Kontaktujte nás',
            ctaHeading: 'Připraveni začít svou cestu?',
            ctaDesc: 'Kontaktujte náš tým a rezervujte si svůj personalizovaný ájurvédský pobyt. Ať už máte otázky ohledně terapií, ubytování nebo speciálních balíčků – rádi vám pomůžeme vytvořit vaši dokonalou dovolenou.',
            ctaButtonContact: 'Kontaktujte nás nyní',
            ctaButtonRooms: 'Prohlédnout si pokoje',
            quickInfoCall: 'Zavolejte nám',
            quickInfoEmail: 'Napište nám',
            quickInfoLocation: 'Poloha',
            locationCity: 'Aluthgama, Srí Lanka'
        },
        ayurveda2: {
            accordionTitle1: 'Co je Panchakarma Ájurvéda?',
            accordionDesc1: 'Ájurvéda (sanskrtské slovo znamenající „věda o životě“) je starověký celostní léčebný systém. Panchakarma je soubor čisticích a omlazujících terapií, které obnovují rovnováhu mezi myslí, tělem a duší.',
            accordionTitle2: 'Panchakarma Ájurvéda a vaše životní energie',
            accordionDesc2: 'Panchakarma se zaměřuje na odstranění toxinů a obnovení harmonie mezi dóšami (Váta, Pitta, Kapha). Léčba je individuálně přizpůsobena každému hostovi, aby podporovala dlouhodobé zdraví a vitalitu.',
            accordionTitle3: 'Dóša Váta',
            accordionDesc3: 'Váta řídí pohyb a oběh. V rovnováze podporuje kreativitu a vitalitu. Panchakarma nabízí uzemňující terapie pro uklidnění nadměrné Váty a obnovení rovnováhy.',
            accordionTitle4: 'Dóša Pitta',
            accordionDesc4: 'Pitta řídí trávení a metabolismus. Chladivé a regenerační terapie pomáhají vyrovnat Pittu a snížit záněty a podrážděnost.',
            accordionTitle5: 'Dóša Kapha',
            accordionDesc5: 'Kapha zajišťuje strukturu a stabilitu. Energizující a oběh podporující terapie se používají ke snížení nadměrné Kaphy a podpoře lehkosti a pružnosti.',
            close: 'Zavřít',
            next: 'Další',
            previous: 'Předchozí',
            treatmentsTitle: 'Naše signature Panchakarma Ájurvédské terapie',
            treatmentsSubtitle: 'Tradiční terapie pro detoxikaci, omlazení a obnovení rovnováhy.',
            bookTreatment: 'Rezervovat tuto terapii',
            benefitsTitle: 'Výhody terapií Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Jemné nalévání teplého bylinného oleje na čelo pro uklidnění mysli.',
            shirodhara1: 'Snižuje stres a úzkost',
            shirodhara2: 'Podporuje lepší spánek',
            shirodhara3: 'Zlepšuje duševní jasnost',
            steamBath: 'Parní lázeň',
            steamBathDesc: 'Detoxikační parní terapie pro otevření pórů a uvolnění svalů.',
            steamBath1: 'Detoxikuje tělo',
            steamBath2: 'Zlepšuje krevní oběh',
            steamBath3: 'Uvolňuje svalové napětí',
            flowerBath: 'Květinová koupel',
            flowerBathDesc: 'Uklidňující koupel s aromatickými květy pro relaxaci.',
            flowerBath1: 'Uklidňuje nervový systém',
            flowerBath2: 'Hydratuje pokožku',
            flowerBath3: 'Zvedá náladu',
            headMassage: 'Masáž hlavy',
            headMassageDesc: 'Relaxační masáž zaměřená na pokožku hlavy pro uvolnění napětí.',
            headMassage1: 'Zmírňuje bolesti hlavy',
            headMassage2: 'Zlepšuje zdraví pokožky hlavy',
            headMassage3: 'Podporuje relaxaci',
            faceMassage: 'Masáž obličeje',
            faceMassageDesc: 'Regenerační masáž pro zlepšení záře pleti a zmírnění stresu.',
            faceMassage1: 'Zlepšuje tón pleti',
            faceMassage2: 'Snižuje napětí v obličeji',
            faceMassage3: 'Podporuje lymfatickou drenáž',
            neckMassage: 'Masáž krku',
            neckMassageDesc: 'Cílená masáž pro zmírnění ztuhlosti a napětí v krku.',
            neckMassage1: 'Ulevuje od bolesti krku',
            neckMassage2: 'Zlepšuje pohyblivost',
            neckMassage3: 'Snižuje stres',
            shoulderMassage: 'Masáž ramen',
            shoulderMassageDesc: 'Cílená masáž pro zmírnění ztuhlosti a nepohodlí ramen.',
            shoulderMassage1: 'Snižuje bolest ramen',
            shoulderMassage2: 'Zlepšuje držení těla',
            shoulderMassage3: 'Uvolňuje svaly',
            bodyMassage: 'Masáž těla',
            bodyMassageDesc: 'Celotělová masáž pro celkovou relaxaci a zdraví.',
            bodyMassage1: 'Zlepšuje krevní oběh',
            bodyMassage2: 'Ulevuje od svalové bolesti',
            bodyMassage3: 'Podporuje relaxaci',
            backMassage: 'Masáž zad',
            backMassageDesc: 'Terapeutická masáž proti bolesti a napětí zad.',
            backMassage1: 'Zmírňuje bolesti zad',
            backMassage2: 'Zlepšuje zdraví páteře',
            backMassage3: 'Snižuje stres',
            footMassage: 'Masáž nohou',
            footMassageDesc: 'Uklidňující masáž nohou pro zmírnění bolesti a podporu relaxace.',
            footMassage1: 'Zlepšuje krevní oběh',
            footMassage2: 'Snižuje únavu nohou',
            footMassage3: 'Podporuje relaxaci',
            purgative: 'Projímadlo',
            purgativeDesc: 'Čisticí terapie pro odstranění nadbytečné Pitty a toxinů z trávicího systému.',
            purgative1: 'Čistí tlusté střevo',
            purgative2: 'Vyrovnává dóšu Pitta',
            purgative3: 'Zlepšuje zdraví trávení',
            nasalClearing: 'Čištění nosu',
            nasalClearingDesc: 'Terapeutická nosní procedura pro uvolnění dutin a zlepšení dýchání.',
            nasalClearing1: 'Uvolňuje ucpaný nos',
            nasalClearing2: 'Zlepšuje dýchání',
            nasalClearing3: 'Zmírňuje problémy s dutinami',
            powderMassage: 'Masáž práškem',
            powderMassageDesc: 'Exfoliační masáž s bylinnými prášky pro omlazení a osvěžení pokožky.',
            powderMassage1: 'Odstraňuje odumřelou kůži',
            powderMassage2: 'Zlepšuje strukturu pokožky',
            powderMassage3: 'Podporuje krevní oběh',
            intensiveMassageDesc: 'Hloubková terapeutická masáž zaměřená na chronické napětí a svalové uzly s pevným tlakem a speciálními technikami.',
            intensiveMassage1: 'Uvolňuje hluboké svalové napětí',
            intensiveMassage2: 'Zlepšuje prokrvení',
            intensiveMassage3: 'Snižuje svalovou bolest',
            thermoMassage: 'Termomasáž',
            thermoMassageDesc: 'Teplá masáž s bylinným olejem za použití ohřátých terapeutických olejů pro posílení relaxace a léčivých účinků.',
            thermoMassage1: 'Uklidňuje bolavé svaly',
            thermoMassage2: 'Podporuje hlubokou relaxaci',
            thermoMassage3: 'Zlepšuje tok energie',
            synchronMassage: 'Synchronní masáž',
            synchronMassageDesc: 'Synchronizovaná masáž dvěma terapeuty pro úplnou harmonii těla a vyvážené rozložení energie.',
            synchronMassage1: 'Kompletní harmonie těla',
            synchronMassage2: 'Vyvážený tok energie',
            synchronMassage3: 'Hloubkový relaxační zážitek',
            specialMassage: 'Speciální masáž',
            specialMassageDesc: 'Individuální masážní terapie přizpůsobená vašim konkrétním zdravotním potřebám a osobním cílům wellness.',
            specialMassage1: 'Personalizovaná léčba',
            specialMassage2: 'Zaměřená na konkrétní potíže',
            specialMassage3: 'Individuální léčebný přístup',
            benefit1Title: 'Detoxikace:',
            benefit1Desc: 'Terapie Panchakarma pomáhají odstraňovat toxiny z těla a podporují celkové zdraví a vitalitu.',
            benefit2Title: 'Zlepšení trávení:',
            benefit2Desc: 'Tyto terapie posilují trávicí funkce, což vede k lepšímu vstřebávání živin a metabolismu.',
            benefit3Title: 'Zmírnění stresu:',
            benefit3Desc: 'Panchakarma je známá svými uklidňujícími účinky na mysl a tělo, snižuje hladinu stresu a úzkosti.',
            benefit4Title: 'Posílení imunity:',
            benefit4Desc: 'Pravidelné terapie Panchakarma mohou posílit imunitní systém a učinit tělo odolnějším vůči nemocem.',
            benefit5Title: 'Omlazení:',
            benefit5Desc: 'Terapie podporují regeneraci buněk, zlepšují zdraví pokožky a dodávají mladistvý vzhled.',
            benefit6Title: 'Rovnováha dóš:',
            benefit6Desc: 'Panchakarma pomáhá obnovit rovnováhu dóš těla (Váta, Pitta, Kapha), což je podle ájurvédských principů klíčové pro udržení zdraví.',
            gallery1: 'Terapie Shirodhara',
            gallery2: 'Parní lázeň',
            gallery3: 'Květinová koupel',
            gallery4: 'Masáž hlavy',
            gallery5: 'Masáž těla',
            gallery6: 'Masáž krku',
            gallery7: 'Masáž obličeje',
            gallery8: 'Masáž ramen',
            sectionEyebrow: 'Panchakarma Ájurvéda v Muthumuni',
            sectionDescription: 'Objevte starobylé umění léčení Panchakarma Ájurvéda v našem útočišti na břehu řeky. Naši zkušení ájurvédští praktici nabízejí personalizované terapie určené k detoxikaci, omlazení a obnovení rovnováhy těla, mysli a duše.',
            heroTitle: 'Panchakarma Ájurvéda',
            heroSubtitle: 'Obnovte tělo, mysl a duši v Aluthgamě',
            heroAlt: 'Ájurvéda a v Muthumuni River Resort'
        },
        yoga2: {
            heroTitle: 'Jóga v resortu',
            heroSubtitle: 'Najděte rovnováhu, sílu a vnitřní klid v Beruwale',
            heroAlt: 'Jóga v Muthumuni Resort',
            importanceEyebrow: 'Zdraví a rovnováha',
            importanceTitle: 'Význam jógy a meditace',
            importanceImageAlt: 'Význam jógy a meditace',
            importanceText1: 'Jóga a meditace jsou prastaré praktiky, které přinášejí mnoho fyzických, mentálních a emocionálních přínosů. Podporují pružnost, sílu a rovnováhu a zároveň snižují stres a úzkost.',
            importanceText2: 'Pravidelný trénink zlepšuje soustředění, kvalitu spánku a celkovou pohodu. Jóga také podporuje všímavost a pomáhá lidem spojit se s jejich vnitřním já a najít klid uprostřed každodenního chaosu.',
            importanceText3: 'V Muthumuni Resort vytváříme klidná prostředí ideální pro cvičení jógy a meditace, aby si hosté mohli zregenerovat tělo, mysl i duši.',
            practiceEyebrow: 'Naše praxe',
            practiceTitle: 'Praxe a zkušenost s jógou',
            practiceImageAlt: 'Jógová praxe v resortu',
            practiceText1: 'V Muthumuni Resort praktikujeme především tradiční hatha jógu v kombinaci s pránájámou (dechovými technikami). Tento celostní přístup je navržen tak, aby probudil vnitřní uvědomění, jemně stimuloval kundaliní a kladl důraz na vyrovnání páteře a pružnost.',
            practiceText2: 'Hodiny jógy probíhají pravidelně a jsou vhodné jak pro začátečníky, tak pro pokročilé. Občas nabízíme speciální lekce, například ashtanga jógu.',
            practiceText3: 'Všechny lekce se konají v naší speciální jógové hale – klidném a mírovém prostoru určeném pro soustředění, rovnováhu a vědomý pohyb. Každá lekce obvykle začíná pozdravy slunci, následuje pránájáma a pečlivě vybraná sekvence ásan pro zlepšení pružnosti a krevního oběhu.',
            practiceText4: 'Naši zkušení učitelé jógy přizpůsobují každou lekci individuálním potřebám, schopnostem a zdravotnímu stavu hostů, aby zajistili bezpečný a hluboce prospěšný zážitek.',
            spiritualEyebrow: 'Duchovní cesta',
            spiritualTitle: 'Meditace a duchovní aktivity',
            spiritualSubtitle: 'Prohlubte svou duchovní praxi s našimi posvátnými obřady a vedenými meditacemi',
            meditationImageAlt: 'Meditace a duchovní praxe v resortu',
            meditationTitle: 'Meditace',
            meditationDesc: 'Hosté jsou zváni k účasti na vedených meditacích inspirovaných tradičními postupy. Tyto lekce pomáhají zklidnit mysl, prohloubit uvědomění a podpořit emocionální a duchovní uzdravení v klidném prostředí.'
        },
        food2: {
            heroTitle: 'Ájurvédské stravování a pobřežní kuchyně',
            heroSubtitle: 'Autentické srílanské chutě a čerstvá pobřežní kuchyně',
            heroAlt: 'Kulinářský zážitek v Muthumuni Beach Resort',
            wellnessEyebrow: 'Zdraví prostřednictvím jídla',
            wellnessTitle: 'Význam',
            ayurvedicFood: 'Ájurvédského stravování',
            wellnessIntro1: 'V ájurvédě je jídlo považováno za největší lék. To, co jíte, přímo ovlivňuje vaše dóši (Váta, Pitta, Kapha), trávení (agni) a celkovou rovnováhu těla, mysli a duše.',
            wellnessIntro2: 'Ájurvédská výživa klade důraz na čerstvé, sezónní, celistvé potraviny připravené s péčí a vědomým jedením. Každé jídlo obsahuje šest chutí (sladká, kyselá, slaná, pálivá, hořká, svíravá), aby vyživily všechny smysly a udržely harmonii.',
            wellnessIntro3: 'Správná ájurvédská strava posiluje trávení, pomáhá odstraňovat toxiny (ámu), zvyšuje imunitu, energii, snižuje stres a předchází mnoha chronickým onemocněním. V Muthumuni je každé jídlo připraveno podle vaší individuální konstituce pro hluboké uzdravení a vitalitu.',
            foodImage1Alt: 'Tradiční ájurvédské jídlo se šesti chutěmi',
            foodImage2Alt: 'Ájurvédské byliny a koření pro vyváženou výživu',
            culinaryPhilosophyEyebrow: 'Naše kulinářská filozofie',
            culinaryPhilosophyTitle: 'Ájurvédská',
            nutritionHighlight: 'výživa',
            culinaryPhilosophyResort: 'v Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ájurvédská kuchyně v Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Čerstvé a výživné',
            healingIngredientsAlt: 'Zdravé ájurvédské ingredience a koření',
            healingIngredientsLabel: 'Léčivé ingredience',
            philosophyText1: 'Potraviny, které zahrnují šest hlavních chutí (sladká, kyselá, slaná, hořká, pálivá, svíravá) a mnoho jemných variací, jsou popsány v klasických ájurvédských textech – některé staré více než 5000 let – spolu s podstatnými vlastnostmi každé potraviny: Guna (vlastní kvalita), Virya (potence – zahřívající nebo ochlazující), Vipaka (vliv po trávení) a Prabhava (jedinečné zvláštní působení).',
            philosophyText2: 'Proto ájurvédská výživa hraje ústřední roli v Muthumuni Ayurveda Beach Resort. Neznamená to však přísný, monotónní režim mdlých, bez chuti nebo příliš hořkých vegetariánských jídel diktovaný pouze lékaři. Naopak naše ájurvédská kuchyně patří k našim největším přednostem – pokrmy připravené našimi zručnými kuchaři vás budou každý den pobytu překvapovat a těšit!',
            philosophyText3: 'K snídani bohatý bufet s čerstvým tropickým ovocem, čerstvě vymačkanými šťávami, výživnými bylinkovými polévkami, domácím pečivem a lehkými sušenkami plus řada autentických srílanských snídaňových možností. K obědu pestrý a chutný bufet s jemnými rybími kari, zeleninovými pokrmy a bylinkovými jídly. Večer podáváme pevné vegetariánské menu s možností čerstvé ryby. V sobotu slavíme „Sri Lankan Night“ s rozšířeným bufetem – naši kuchaři připravují tradiční místní speciality přímo před vámi a vytvářejí živý a autentický zážitek.',
            philosophyText4: 'V ájurvédě jsou potraviny a nápoje klasifikovány mnoha způsoby – podle chuti a vlastností, trávicí kapacity (agni), vhodnosti pro konkrétní zdravotní stavy, sezónní vhodnosti atd. V Muthumuni zohledňujeme všechny tyto faktory současně a vědomě se snažíme zahrnout všech šest chutí v vyvážených kombinacích přizpůsobených individuální konstituci každého hosta.',
            philosophyText5: 'Naše jídla obsahují čerstvou zeleninu, tropické ovoce a zodpovědně získanou rybu. Nepodáváme červené maso ani alkohol.',
            philosophyText6: 'Během jídel je vždy přítomen ájurvédský lékař nebo kvalifikovaný dietolog, aby vás vedl. Poradí vám nejvhodnější zeleninu, byliny a koření pro aktuální fázi léčby a pomůže vám vybrat nebo se vyhnout určitým pokrmům. Váš individuální bylinný elixír a konkrétní pokyny od týmu zdravotního centra budou umístěny na vašem stole.',
            philosophyText7: 'Tato úroveň personalizované péče a pozornosti k jídlu je charakteristickým znakem zážitku v Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Jídlo je považováno za Pránu – životodárnou energii pro každého člověka. Proto vás zveme, abyste k jídlu přistupovali s plnou bdělostí: vychutnávali si vůně, prožívali chutě, cítili jemnou teplou a vědomě si užívali všechny chuťové vjemy.',
            diningExperienceEyebrow: 'Stravovací zážitek',
            restaurantTitlePrefix: 'Naše',
            ayurvedicHighlight: 'Ájurvédská',
            restaurantTitleSuffix: 'restaurace',
            restaurantDetail1: 'Naše ájurvédská restaurace v Muthumuni Beach Resort nabízí jedinečný stravovací zážitek, který harmonicky spojuje tradiční ájurvédské principy s autentickou srílanskou pobřežní kuchyní. Upřednostňujeme čerstvé, místní suroviny, abychom vytvořili jídla, která nejen potěší chuťové buňky, ale také podporují celostní zdraví.',
            restaurantDetail2: 'Menu je pečlivě navrženo tak, aby v každém pokrmu vyvážilo šest chutí (sladká, kyselá, slaná, hořká, pálivá, svíravá) a zajistilo výživný a uspokojivý zážitek. Každé jídlo je připraveno s péčí a obsahuje ájurvédské byliny a koření známé pro své léčivé vlastnosti.',
            restaurantDetail3: 'Hosté si mohou vychutnat širokou škálu jídel přizpůsobených jejich individuálním dóšám (tělesným konstitucím), s možnostmi vegetariánské, veganské a pescetariánské stravy. Naši kuchaři úzce spolupracují s ájurvédskými praktiky, aby každé jídlo podporovalo zdravotní a cíle hostů.',
            restaurantDetail4: 'Atmosféra restaurace odráží klidné pobřežní prostředí a nabízí tichý rámec pro vědomé stolování. Ať už si užíváte bohatý snídaňový bufet nebo gurmánskou večeři, každé jídlo v naší ájurvédské restauraci je příležitostí vyživovat tělo i duši.',
            restaurantDetail5: 'Přijďte do ájurvédské restaurace Muthumuni Beach Resort na kulinářskou cestu, která oslavuje bohaté chutě Srí Lanky a zároveň ztělesňuje nadčasovou moudrost ájurvédy.',
            restaurantImageAlt: 'Stravování v Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Prémiové stolování',
            premiumDiningDescription: 'Zažijte autentickou ájurvédskou kuchyni v klidném prostředí u řeky'
        },
        events2: {
            heroEyebrow: 'Zážitky a aktivity',
            heroTitle: 'Naše akce',
            heroSubtitle: 'Připravené zážitky spojující srílanskou tradici s pobřežním luxusem',
            heroAlt: 'Akce v Muthumuni',
            availableDaily: 'Dostupné denně',
            bookNow: 'Rezervovat nyní',
            highlightsTitle: 'Hlavní body',
            detailAlt: 'Detail {{title}}',
            ctaTitle: 'Připraveni vytvářet vzpomínky?',
            ctaDescription: 'Kontaktujte náš tým a nechte si na míru přizpůsobit dokonalý zážitek z akce v Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Kontaktujte nás',
            ctaViewRooms: 'Zobrazit pokoje',
            cookeryTitle: 'Kuchařské programy',
            cookerySubtitle: 'Chuť Srí Lanky',
            cookeryDescription: 'Ponořte se do živých chutí srílanské kuchyně. Naši zkušení kuchaři vás provedou praktickými lekcemi vaření a naučí vás tradiční recepty předávané z generace na generaci. Naučte se připravovat aromatická kari, hoppery, kokosový sambol a další pokrmy z čerstvých místních surovin.',
            cookeryHighlight1: 'Tradiční srílanské recepty',
            cookeryHighlight2: 'Praktická zkušenost s vařením',
            cookeryHighlight3: 'Čerstvé místní suroviny',
            cookeryHighlight4: 'Recepty s sebou domů',
            cookeryHighlight5: 'Prohlídka bylinkové zahrady v ceně',
            meditationTitle: 'Meditace programy',
            meditationSubtitle: 'Vnitřní klid a všímavost',
            meditationDescription: 'Najděte klid při našich vedených meditacích s výhledem na poklidný Indický oceán. Zkušení lektoři vás provedou starodávnými technikami všímavosti, dechovými cvičeními a jógou, které uklidňují mysl a obnovují ducha.',
            meditationHighlight1: 'Sezení při východu a západu slunce',
            meditationHighlight2: 'Meditace přímo na pláži',
            meditationHighlight3: 'Vedené odborníky',
            meditationHighlight4: 'Dechové techniky',
            meditationHighlight5: 'Jóga a praktiky všímavosti',
            bbqTitle: 'Grilovací večírky',
            bbqSubtitle: 'Oslavy na pláži',
            bbqDescription: 'Prožijte nezapomenutelné večery na našich plážových grilovačkách. Vychutnejte si čerstvě grilované mořské plody, prémiové maso a vegetariánské speciality při šumu vln. Živá hudba, ohňoví tanečníci a hvězdná obloha vytvářejí dokonalou atmosféru pro oslavu a setkání.',
            bbqHighlight1: 'Čerstvě grilované mořské plody',
            bbqHighlight2: 'Večeře u oceánu',
            bbqHighlight3: 'Živá zábava',
            bbqHighlight4: 'Zážitkový oheň',
            bbqHighlight5: 'Přizpůsobitelná menu',
            boatTitle: 'Plavby na lodi',
            boatSubtitle: 'Říční a pobřežní dobrodružství',
            boatDescription: 'Vydejte se na kouzelné lodní výlety po řece Bentota a podél pobřeží. Proplouvejte mangrovovými lesy, pozorujte exotické ptáky a divokou zvěř nebo si užijte romantické plavby při západu slunce. Naše lodní výlety nabízejí jedinečný pohled na přírodní krásy a rozmanité ekosystémy Srí Lanky.',
            boatHighlight1: 'Plavby po řece Bentota',
            boatHighlight2: 'Průzkum mangrovů',
            boatHighlight3: 'Pozorování zvířat',
            boatHighlight4: 'Plavby při západu slunce',
            boatHighlight5: 'Možnost soukromého pronájmu',
            ayurvedaLecturesTitle: 'Přednášky ájurvédských lékařů',
            ayurvedaLecturesSubtitle: 'Starodávná moudrost a moderní zdraví',
            ayurvedaLecturesDescription: 'Poznejte hluboké principy ájurvédy prostřednictvím přednášek certifikovaných ájurvédských lékařů a praktiků. Naučte se vyvažování dóš, bylinné léky, celostní metody léčení a jak starověká moudrost funguje v moderním životě. Interaktivní lekce činí ájurvédskou filozofii srozumitelnou a použitelnou v každodenním životě.',
            ayurvedaLecturesHighlight1: 'Certifikovaní ájurvédští lékaři',
            ayurvedaLecturesHighlight2: 'Individuální analýza dóš',
            ayurvedaLecturesHighlight3: 'Vzdělávání o bylinných lécích',
            ayurvedaLecturesHighlight4: 'Včetně otázek a odpovědí',
            ayurvedaLecturesHighlight5: 'Průvodce zdravím domů',
            traditionalClothsTitle: 'Akce nošení tradičního oblečení',
            traditionalClothsSubtitle: 'Zážitky kulturního dědictví',
            traditionalClothsDescription: 'Ponořte se do srílanského kulturního dědictví tím, že se naučíte nosit a chápat tradiční oděvy. Naši zkušení stylisté vás provedou oblékáním autentických kandjánských sárí a tradičních oděvů a vysvětlí kulturní význam každého kusu. Ideální pro zvláštní příležitosti, kulturní obdiv nebo krásné fotografie.',
            traditionalClothsHighlight1: 'Profesionální poradenství při stylingu',
            traditionalClothsHighlight2: 'Autentická tradiční sárí',
            traditionalClothsHighlight3: 'Vysvětlení kulturního významu',
            traditionalClothsHighlight4: 'Profesionální focení v ceně',
            traditionalClothsHighlight5: 'Workshopy módní fúze'
        },
        tours2: {
            heroTitle: 'Prohlídky a výlety',
            heroSubtitle: 'Objevte krásu Srí Lanky z Beruwaly',
            kandeAlt: 'Chrám Kande Vihara – Beruwala',
            kandeTitle: 'Návštěva chrámu Kande Vihara',
            kandeBuddhaAlt: 'Obří socha Buddhy v chrámu Kande Vihara',
            bentotaTitle: 'Plavba lodí po řece Bentota',
            bentotaAlt: 'Plavba lodí po řece Bentota – mangrovníky a divoká zvěř',
            galleTitle: 'Prohlídka starého města Galle',
            galleAlt: 'Prohlídka starého města Galle',
            sigiriyaTitle: 'Prohlídka skalní pevnosti Sigiriya',
            sigiriyaAlt: 'Prohlídka skalní pevnosti Sigiriya',
            kandyTitle: 'Kulturní prohlídka Kandy',
            kandyAlt: 'Kulturní prohlídka Kandy',
            bookTour: 'Rezervovat tento výlet',
            introPara1: 'Srí Lanka je zemí nadčasové krásy, kde zlaté pláže, bujná zelená krajina, starobylé chrámy a živá kultura vytvářejí dokonalou harmonii.',
            introPara2: 'Od klidného jihozápadního pobřeží přes historická města, posvátná místa, přírodní rezervace až po mlžné horské oblasti – každý výlet nabízí jedinečný a nezapomenutelný zážitek.',
            introPara3: 'S výchozím bodem v Muthumuni Ayurveda Beach Resort v Beruwale jsou naše pečlivě vybrané prohlídky a výlety navrženy tak, aby obohatily váš pobyt a dokonale vyvážily objevování, odpočinek a wellness.',
            kandeDetail1: 'Chrám Kande Vihara (Kande Viharaya) – jeden z nejikoničtějších buddhistických chrámů v okolí Beruwaly.',
            kandeDetail2: 'Založen v roce 1734, tento klidný „Horský chrám“ stojí na kopci a nabízí nádherný výhled na pobřeží.',
            kandeDetail3: 'Hlavní zajímavosti zahrnují obrovskou 48 metrů vysokou sedící sochu Buddhy (jednu z nejvyšších na Srí Lance), složité fresky z období Kandyan, starobylou relikviářovou komoru, krásný vchod s měsíčním kamenem a posvátný strom Bódhi starý více než 300 let.',
            kandeDetail4: 'Perfektní půldenní duchovní a kulturní zážitek – ideální ráno, aby se předešlo horku.',
            bentotaDetail1: 'Užijte si klidnou a malebnou plavbu lodí po řece Bentota, jednu z nejoblíbenějších přírodních výletů v okolí Beruwaly.',
            bentotaDetail2: 'Proplouvejte hustými mangrovníky, úzkými kanály a klidnými lagunami a pozorujte místní divokou zvěř.',
            bentotaDetail3: 'Běžně lze spatřit varany, krokodýly, různé druhy ptáků (ledňáčky, volavky, orly), opice a občas vydry nebo vodní hady.',
            bentotaDetail4: 'Váš zkušený lodivod/průvodce vám ukáže zajímavé rostliny, tradiční způsoby rybolovu a život v říčních vesnicích.',
            bentotaDetail5: 'Ideální pro milovníky přírody a fotografy – klidné, relaxační a skvěle doplňuje váš ájurvédský pobyt.',
            galleDetail1: 'Prozkoumejte historickou pevnost Galle, památku UNESCO a jednu z nejlépe zachovalých koloniálních pevností na Srí Lance.',
            galleDetail2: 'Procházejte se dlážděnými uličkami lemovanými holandskými koloniálními budovami, butiky, kavárnami a uměleckými galeriemi.',
            galleDetail3: 'Navštivte klíčové památky jako maják Galle, Holandský reformovaný kostel, Národní námořní muzeum a hradby s úchvatným výhledem na oceán.',
            galleDetail4: 'Dozvíte se od znalého průvodce o bohaté historii, architektuře a kulturním významu pevnosti.',
            galleDetail5: 'Ideální pro milovníky historie, kultury a pro ty, kteří chtějí zažít koloniální minulost Srí Lanky.',
            sigiriyaDetail1: 'Objevte starobylou skalní pevnost Sigiriya, jeden z nejznámějších symbolů Srí Lanky a památku UNESCO.',
            sigiriyaDetail2: 'Vystoupejte na impozantní skálu a prozkoumejte ruiny paláce krále Kasyapy, zdobené freskami, vodními zahradami a slavnou Zrcadlovou stěnou.',
            sigiriyaDetail3: 'Z vrcholu si užijte panoramatický výhled na okolní džungli a krajinu.',
            sigiriyaDetail4: 'Od zkušeného průvodce se dozvíte fascinující historii, architekturu a legendy spojené se Sigiriyí.',
            sigiriyaDetail5: 'Perfektní pro zájemce o historii, dobrodruhy a všechny, kdo se zajímají o bohaté kulturní dědictví Srí Lanky.',
            kandyDetail1: 'Prožijte živou kulturu Kandy, posledního královského hlavního města Srí Lanky a památky UNESCO.',
            kandyDetail2: 'Navštivte Chrám Posvátného zubu (Sri Dalada Maligawa), jedno z nejvýznamnějších buddhistických míst na světě.',
            kandyDetail3: 'Prozkoumejte Královské botanické zahrady v Peradeniyi s obrovskou sbírkou tropických rostlin a orchidejí.',
            kandyDetail4: 'Zhlédněte tradiční představení kandjánského tance, které předvádí bohaté umělecké dědictví Srí Lanky.',
            kandyDetail5: 'Ideální pro milovníky kultury, historie a pro ty, kteří se chtějí ponořit do tradic Srí Lanky.'
        },
        blogs2: {
            heroTitle: 'Blog Muthumuni Ayurveda River Resort',
            heroSubtitle1: 'Příběhy z břehu řeky, ájurvédské rituály v',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Ponořte se do tipů, historie a zákulisních poznámek.',
            heroAlt: 'Procházková cesta podél řeky v resortu při západu slunce',
            sectionTitle: 'Blog Muthumuni Ayurveda River Resort',
            sectionDescription: 'Průvodci, příběhy a poznámky z našeho útočiště na břehu řeky — od ájurvédských rituálů přes praktiky až po cestovatelské tipy v okolí Bentoty.',
            ayurvedaTitle: 'Srdce autentické ájurvédy',
            ayurvedaExcerpt: 'Prožijte osvědčené léčebné tradice zakořeněné v dávné moudrosti Srí Lanky.',
            ayurvedaDescription: 'V Muthumuni Ayurveda River Resort je ájurvéda více než léčba – je to způsob života. Naše terapie vycházejí z mnohasetletých znalostí, jsou přizpůsobeny vašemu typu těla a vedeny zkušenými ájurvédskými lékaři pro hlubokou a trvalou rovnováhu.',
            ayurvedaAlt: 'Ájurvédská procedura s bylinkovými oleji a přírodními prvky',
            healingTitle: 'Individuální cesty uzdravení',
            healingExcerpt: 'Proč je program každého hosta jedinečný.',
            healingDescription: 'Od úvodní konzultace až po denní procedury je vaše cesta uzdravení pečlivě přizpůsobena. Bylinkové terapie, léčebné masáže, jóga a meditace společně obnovují harmonii těla, mysli a ducha.',
            healingAlt: 'Ájurvédský lékař konzultuje s hostem v klidném prostředí',
            natureTitle: 'Léčení u řeky',
            natureExcerpt: 'Jak klidné říční prostředí a tropická příroda umocňují vaše zdraví.',
            natureDescription: 'Muthumuni je zasazené na klidném břehu řeky Srí Lanky a nabízí přirozené léčivé prostředí. Jemný tok řeky, čerstvý vzduch a bujná zeleň zesilují účinky ájurvédy a přinášejí hlubokou relaxaci a obnovu.',
            natureAlt: 'Pohled na řeku v resortu s palmami a přírodou',
            foodTitle: 'Ájurvédská kuchyně pro vnitřní rovnováhu',
            foodExcerpt: 'Výživná jídla vytvořená na podporu vaší léčby.',
            foodDescription: 'Naše ájurvédská kuchyně se připravuje denně čerstvá z místních sezónních surovin. Každé jídlo je sladěno s vaším dóšou, podporuje trávení, detoxikaci a vitalitu a přitom zůstává chutné a sytící.',
            foodAlt: 'Tradiční ájurvédské jídlo podávané v přírodních miskách',
            yogaTitle: 'Jóga, meditace a vnitřní klid',
            yogaExcerpt: 'Jemné praktiky, které zklidňují mysl a posilují tělo.',
            yogaDescription: 'Denní lekce jógy a meditace doplňují vaše procedury, zlepšují pružnost, dýchání a mentální jasnost. Tyto všímavé praktiky vám pomáhají znovu se spojit se sebou a odnést si pocit míru i po odjezdu.',
            yogaAlt: 'Hosté cvičí jógu s výhledem na řeku při východu slunce',
            lifestyleTitle: 'Vzít si ájurvédu domů',
            lifestyleExcerpt: 'Jednoduché životní návyky pro pokračování cesty.',
            lifestyleDescription: 'Před odjezdem vás naši odborníci naučí, jak udržet rovnováhu prostřednictvím každodenních rutin, stravy a rituálů péče o sebe. Odvezte si víc než jen vzpomínky – odvezte si udržitelnou cestu ke zdravějšímu životu.',
            lifestyleAlt: 'Host relaxuje s bylinkovým čajem v klidném prostředí resortu',
            readMore: 'Číst dále'
        },
        rooms: {
            heroTitle: 'Vaše svatyně na vás čeká',
            heroSubtitle: 'Pokoje pečlivě navržené pro uzdravení, obnovu a hluboký klid.',
            heroAlt: 'Pokoje Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Prozkoumejte naše pokoje',
            filterAll: 'Vše',
            filterLuxurySuite: 'Luxusní apartmá',
            filterDeluxeRooms: 'Pokoje Deluxe',
            filterDeluxeSeaView: 'Pokoj Deluxe s výhledem na moře',
            noRoomsFound: 'V této kategorii nebyly nalezeny žádné pokoje.',
            allRoomsInclude: 'Všechny pokoje zahrnují',
            essentialComforts: 'Základní pohodlí pro vaši cestu',
            roomSize: 'Velikost pokoje',
            guests: 'Hosté',
            amenities: 'Vybavení',
            roomAmenities: 'Vybavení pokoje',
            specialFeatures: 'Speciální funkce',
            bookNow: 'Rezervovat nyní',
            viewDetails: 'Zobrazit podrobnosti',
            highSpeedWifi: 'Vysokorychlostní WiFi',
            herbalTea: 'Výběr bylinných čajů',
            climateControl: 'Kontrola klimatu',
            rainShower: 'Sprcha jako déšť',
            organicToiletries: 'Bio. toaletní potřeby',
            dailyHousekeeping: 'Denní úklid pokoje',
            concierge: 'Concierge 24/7',
            yogaMat: 'Yogamate a příslušenství',
            beginHealing: 'Začněte svou cestu k uzdravení',
            beginHealingDesc: 'Zažijte autentické ájurvédické v prostředí navrženém tak, aby živilo vaše tělo, uklidnilo vaši mysl a obnovilo vaši duši.',
            reserveRoom: 'Rezervujte si pokoj',
            speakAdvisor: 'Mluvit s poradcem wellness',
            exploreOurRooms: 'Prozkoumejte naše pokoje',
            viewRoom: 'Zobrazit pokoj',
            luxurySuiteName: 'Luxusní apartmá',
            luxurySuiteCategory: 'Luxusní apartmá',
            luxurySuiteDesc: 'Zažijte maximální klid v našem prostorném luxusním apartmá navrženém podle tradičních ájurvédských principů s okamžitou mořskou scenérií.',
            deluxeRoomName: 'Pokoj Deluxe',
            deluxeRoomCategory: 'Pokoj Deluxe',
            deluxeRoomDesc: 'Harmonicky navržený pokoj s přírodními prvky z dřeva a zklidňujícími vodními prvky pro dokonalý klid.',
            seaViewDeluxeName: 'Deluxe s výhledem na moře',
            seaViewDeluxeCategory: 'Pokoj Deluxe s výhledem na moře',
            seaViewDeluxeDesc: 'Probuďte se s uklidňujícím mořským vánkem a panoramatickým výhledem na moře v tomto elegantně navrženém pokoji Deluxe.',
            deluxeRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Pokoj Deluxe',
                heroSubtitle: 'Kde se luxus snoubí s přírodou',
                bookThisRoom: 'Rezervovat tento pokoj',
                callReservations: 'Zavolejte na rezervace',
                navAll: 'Všechny pokoje',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe s výhledem na moře',
                navSuite: 'Suite',
                sectionTitle: 'Únik do luxusu a klidu',
                sectionDesc: 'Užijte si perfektní harmonii elegance a pohodlí v našem pokoji Deluxe. Každý detail je navržen tak, aby vytvořil nezapomenutelný zážitek, přičemž mísí moderní vybavení s vřelostí přírody.',
                highlight1Title: 'Klidný azyl',
                highlight1Desc: 'Probuďte se s něžným brušením vln a působivým východem slunce nad oceánem.',
                highlight2Title: 'Elegantní interiéry',
                highlight2Desc: 'Harmonicky navržené prostory s přírodními prvky z dřeva a kamene.',
                highlight3Title: 'Moderní vybavení',
                highlight3Desc: 'Pokročilé vybavení a služby pro snadný pobyt.',
                atAGlance: 'Na první pohled',
                statSize: 'Rozloha',
                statSizeValue: '350 čtverečních stop',
                statView: 'Výhled',
                statViewValue: 'Zahrada',
                statGuests: 'Kapacita',
                statGuestsValue: '2 dospělí',
                statBed: 'Lůžko',
                statBedValue: 'Manželská postel King',
                reserve: 'Rezervovat',
                galleryAlt: 'Pokoj Deluxe',
                inclusionsTitle: 'Co je zahrnuto',
                inclusionsSubtitle: 'Vybavení a služby',
                enhancedCleanliness: 'Vylepšené protokoly čištění',
                inclusion1: 'Bezplatné Wi-Fi v celém pokoji',
                inclusion2: 'Minibar zdarma (nealkoholické nápoje)',
                inclusion3: 'Kávovar a čajové soupravy Nespresso',
                inclusion4: '24hodinová pokojová služba',
                inclusion5: 'Prémiové toaletní potřeby',
                inclusion6: 'Denní služba úklidu',
                amenityGroup1Title: 'Technologie',
                amenityGroup1Item1: '55" Smart TV',
                amenityGroup1Item2: 'Bezplatné Wi-Fi',
                amenityGroup1Item3: 'Bluetooth reproduktor',
                amenityGroup1Item4: 'USB dobíjecí porty',
                amenityGroup2Title: 'Koupelna',
                amenityGroup2Item1: 'Dešťová sprcha',
                amenityGroup2Item2: 'Prémiové toaletní potřeby',
                amenityGroup2Item3: 'Župan a pantofle',
                amenityGroup2Item4: 'Fén',
                amenityGroup3Title: 'Pohodlí',
                amenityGroup3Item1: 'Klimatizace',
                amenityGroup3Item2: 'Stropní ventilátor',
                amenityGroup3Item3: 'Minibar',
                amenityGroup4Title: 'Závěrečné doteky',
                amenityGroup4Item1: 'Kávovar a čajové soupravy',
                amenityGroup4Item2: 'Trezor',
                amenityGroup4Item3: 'Železo a žehlicí prkno',
                essentialsTitle: 'Esenciální možnosti',
                essentialsHeading: 'Vyberte svůj zážitek',
                essentialsDesc: 'Přizpůsobte si svůj pobyt s našimi kurátorovanými doplňky a službami.',
                essential1: 'Spa & wellness',
                essential2: 'Zážitky s jízdou',
                essential3: 'Výlety',
                essential4: 'Vodní sporty',
                oceanTitle: 'Pokoj spojující vás s přírodou',
                oceanSubtitle: 'Kde se krajiny moře, nebe a země harmonicky spojují',
                oceanAlt: 'Oceánský výhled',
                ctaTitle: 'Začněte svou cestu',
                ctaHeading: 'Připraveni si užít klid?',
                ctaDesc: 'Rezervujte si svůj únik do luxusu a objevte dokonalou harmonii mezi elegancí a pohodlím.',
                checkAvailability: 'Zkontrolovat dostupnost'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Pohodlí s podmanivým pobřežním kouzlem',
                bookThisRoom: 'Rezervovat tento pokoj',
                callReservations: 'Zavolejte na rezervace',
                navAll: 'Všechny pokoje',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe s výhledem na moře',
                navSuite: 'Suite',
                sectionTitle: 'Klidná pobřežní úkryt',
                sectionDesc: 'Luxusní apartmá je navrženo pro pomalá ráno a chvíje bez spěchu. Jemné neutrální tóny, štědrá glazura a promyšlené osvětlení zvaní mořský výhled, zatímco balkon vám nabízí vlastní pozorinu nad pobřežní linii.',
                highlight1Title: 'Panoramatický výhled na pláž',
                highlight1Desc: 'Probudíte se s azurovými vodami a zlatými slunečními paprsky z vašeho soukromého balkónu.',
                highlight2Title: 'Elegantní pobřežní interiéry',
                highlight2Desc: 'Jemné neutrální palety, teplé dřevěné akcenty a štědré přirozené chaosu.',
                highlight3Title: 'Klidný spací zážitek',
                highlight3Desc: 'Měkká manželská postel s prémiovou dekou určenou pro regenerační odpočinek.',
                atAGlance: 'Na první pohled',
                statSize: 'Rozloha',
                statSizeValue: '41 m²',
                statView: 'Výhled',
                statViewValue: 'Indický oceán',
                statGuests: 'Kapacita',
                statGuestsValue: '2 dospělí',
                statBed: 'Lůžko',
                statBedValue: 'King nebo Twin',
                reserve: 'Rezervovat',
                galleryAlt: 'Apartmá Suite',
                inclusionsTitle: 'Co je zahrnuto',
                inclusionsSubtitle: 'Promyšlené detaily, pohodlí celý den',
                enhancedCleanliness: 'Vylepšené normy čistoty a bezpečnosti',
                inclusion1: 'Bezplatné snídaně, obědy, večeře v restauraci Breeze',
                inclusion2: 'Vysokorychlostní Wi-Fi a pracovní prostor v pokoji',
                inclusion3: '24hodinová pokojová služba a concierge',
                inclusion4: 'Denní úklid pokoje s večerním obratem',
                inclusion5: 'Přístup k nekonečnému bazénu a zařízením Ayurvedy',
                inclusion6: 'Bezplatné parkování a transferové služby na okolní atrakce',
                amenityGroup1Title: 'Pokojové prvky',
                amenityGroup1Item1: '41 m² prostoru',
                amenityGroup1Item2: 'Soukromý balkon se sedací zónou',
                amenityGroup1Item3: 'Klimatizace s ovládáním klimatu',
                amenityGroup1Item4: 'Sejf v pokoji',
                amenityGroup2Title: 'Koupelnová zkušenost',
                amenityGroup2Item1: 'Sprcha jako déšť s teplou a studenou vodou',
                amenityGroup2Item2: 'Prémiové toaletní potřeby',
                amenityGroup2Item3: 'Vysoušeč na vlasy',
                amenityGroup2Item4: 'Měkké župany a papuče',
                amenityGroup3Title: 'Pokoj Pohodlí',
                amenityGroup3Item1: '55" Smart TV s kabelem',
                amenityGroup3Item2: 'Stanice na kávu a čaj',
                amenityGroup3Item3: 'Přímý telefon',
                amenityGroup4Title: 'Konektivita',
                amenityGroup4Item1: 'Bezplatné Wi-Fi',
                amenityGroup4Item2: 'Pracovní stůl',
                amenityGroup4Item3: '24/7 podpora recepce',
                essentialsTitle: 'Nezbytné možnosti',
                essentialsHeading: 'Vyberte si svůj zážitek',
                essentialsDesc: 'Přizpůsobte si svůj pobyt s našimi kurátorovanými doplňky a službami.',
                essential1: 'Spa & wellness',
                essential2: 'Zážitky s jízdou',
                essential3: 'Výlety',
                essential4: 'Vodní sporty',
                oceanTitle: 'Pokoj spojující vás s přírodou',
                oceanSubtitle: 'Kde se krajiny moře, nebe a země harmonicky spojují',
                oceanAlt: 'Oceánský výhled',
                ctaTitle: 'Začněte svou cestu',
                ctaHeading: 'Připraveni si užít klid?',
                ctaDesc: 'Rezervujte si svůj únik do luxusu a objevte dokonalou harmonii mezi elegancí a pohodlím.',
                checkAvailability: 'Zkontrolovat dostupnost'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Resorts',
                heroTitle: 'Deluxe pokoj s výhledem na moře',
                heroSubtitle: 'Ponořte se do luxusu s úchvatným výhledem na mořský horizont',
                bookThisRoom: 'Zamluvit tento pokoj',
                callReservations: 'Zavolejte na rezervace',
                navAll: 'Všechny pokoje',
                navDeluxe: 'Deluxe pokoj',
                navDeluxeSeaView: 'Deluxe pokoj s výhledem na moře',
                navSuite: 'Luxusní apartmá',
                sectionTitle: 'Objevte luxus',
                sectionDesc: 'Naše deluxe pokoje s výhledem na moře nabízejí dokonalou kombinaci pohodlí a elegance. Každý pokoj byl pečlivě navržen tak, aby poskytoval nepřekonatelný zážitek ze pobytu.',
                highlight1Title: 'Výhled na soukromou pláž',
                highlight1Desc: 'Přímý přístup na naši soukromou pláž s bílým pískem',
                highlight2Title: 'Prostorný pokoj',
                highlight2Desc: '75 metrů čtverečních nádherného prostoru k bydlení',
                highlight3Title: 'Venkovní vana',
                highlight3Desc: 'Zažijte soukromý luxus pod hvězdami',
                atAGlance: 'Na první pohled',
                stat1Label: 'Velikost',
                stat1Value: '75 metrů čtverečních',
                stat2Label: 'Výhled',
                stat2Value: 'Výhled na moře',
                stat3Label: 'Hosté',
                stat3Value: '2 dospělí',
                stat4Label: 'Postel',
                stat4Value: 'Král',
                reserve: 'Rezervovat',
                galleryAlt: 'Luxusní deluxe pokoj s výhledem na moře',
                inclusionsTitle: 'Co je zahrnuto',
                inclusionsSubtitle: 'Každý pokoj obsahuje',
                inclusion1: 'Snídaně s výhledem na moře',
                inclusion2: 'Vítací nápoj při západu slunce',
                inclusion3: 'Denní služba espresso baru',
                inclusion4: 'Neomezený přístup do spa',
                inclusion5: 'Soukromý transfer na pláž',
                inclusion6: 'Premium Wi-Fi',
                enhancedCleanliness: 'Zlepšené čistění a bezpečnostní protokoly',
                amenityGroup1Title: 'Ložnice',
                amenityGroup1Item1: 'Automatické stínění',
                amenityGroup1Item2: '100% prémiový bavlna',
                amenityGroup1Item3: 'Polštáře různé tuhosti',
                amenityGroup2Title: 'Koupelna',
                amenityGroup2Item1: 'Bvlgari kosmetika',
                amenityGroup2Item2: 'Vyhřívaná podlaha',
                amenityGroup2Item3: 'Integrovaný SPA systém',
                amenityGroup3Title: 'Obývací pokoj',
                amenityGroup3Item1: 'Prémiová satelitní TV',
                amenityGroup3Item2: 'Plně vybavená kuchyň',
                amenityGroup3Item3: 'Domácí kino',
                amenityGroup4Title: 'Venkovní',
                amenityGroup4Item1: 'Soukromá terasa s vířivkou',
                amenityGroup4Item2: 'Visící postel v balijském stylu',
                amenityGroup4Item3: 'Automatický zavlažovací systém',
                essentialsTitle: 'Nezbytnosti',
                essentialsHeading: 'Vaše základní potřeby v pokoji',
                essentialsDesc: 'Všechno nezbytné v pokoji',
                essential1: 'Minibar s prémiovými nápoji',
                essential2: 'Zážitky s jízdou',
                essential3: 'Výlety',
                essential4: 'Vodní sporty',
                oceanTitle: 'Pokoj spojující vás s přírodou',
                oceanSubtitle: 'Kde se krajiny moře, nebe a země harmonicky spojují',
                oceanAlt: 'Oceánský výhled',
                ctaTitle: 'Začněte svou cestu',
                ctaHeading: 'Rezervujte si deluxe pokoj s výhledem na moře dnes',
                ctaDesc: 'Rezervujte si svůj únik do luxusu a objevte dokonalou harmonii mezi elegancí a pohodlím.',
                checkAvailability: 'Zkontrolovat dostupnost'
            }
        },

        navbar: {
            home: 'Domů',
            aboutUs: 'O nás',
            rooms: 'Pokoje',
            ayurveda: 'Ájurvéda',
            yoga: 'Jóga',
            food: 'Stravování',
            events: 'Akce',
            blogs: 'Blogy',
            tours: 'Výlety',
            contactUs: 'Kontakt',
            bookOnline: 'Rezervovat online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Vyberte resort',
            language: 'Jazyk',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Domů',
            aboutUs: 'O nás',
            rooms: 'Pokoje',
            ayurveda: 'Ájurvéda',
            yoga: 'Jóga',
            food: 'Stravování',
            events: 'Akce',
            blogs: 'Blogy',
            tours: 'Výlety',
            contactUs: 'Kontakt',
            bookOnline: 'Rezervovat online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Vyberte resort',
            language: 'Jazyk',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort se zavazuje poskytovat výjimečnou pohostinnost a zážitky, aby se každý host cítil oceněn a znovu nabitý.',
            linksTitle: 'Odkazy',
            contactTitle: 'Kontakt',
            viewLocation: 'Zobrazit polohu',
            navHome: 'Domů',
            navAbout: 'O nás',
            navContact: 'Kontakt',
            navRooms: 'Pokoje',
            navAyurveda: 'Ájurvéda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Vyvinuto',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Zájezdy a exkurze',
            heroSubtitle: 'Objevte krásu Srí Lanky z Beruwaly',
            kandeAlt: 'Chrám Kande Vihara - Beruwala',
            kandeTitle: 'Návštěva chrámu Kande Vihara',
            kandeBuddhaAlt: 'Obří socha Buddhy v chrámu Kande Vihara',
            bentotaTitle: 'Lodní safari po řece Bentota',
            bentotaAlt: 'Lodní safari po řece Bentota - Mangrovové lesy a fauna',
            galleTitle: 'Prohlídka Starého města Galle',
            galleAlt: 'Prohlídka Starého města Galle',
            sigiriyaTitle: 'Prohlídka skalní pevnosti Sigiriya',
            sigiriyaAlt: 'Prohlídka skalní pevnosti Sigiriya',
            kandyTitle: 'Kulturní prohlídka Kandy',
            kandyAlt: 'Kulturní prohlídka Kandy',
            bookTour: 'Rezervovat tento zájezd',
            introPara1: 'Srí Lanka je země věčné krásy, kde se zlaté pláže, bujné zelené krajiny, starobylé chrámy a živá kultura setkávají v dokonalé harmonii.',
            introPara2: 'Od poklidného jihozápadního pobřeží přes historická města, posvátná místa, přírodní rezervace až po mlhavou horskou krajinu - každá cesta nabízí jedinečný a nezapomenutelný zážitek.',
            introPara3: 'Počínaje resortem Muthumuni Ayurveda Beach Resort v Beruwalě jsou naše pečlivě vybrané zájezdy a exkurze navrhnuty tak, aby obohatily váš pobyt a dokonale vyvážily průzkum, relaxaci a wellness.',
            kandeDetail1: 'Chrám Kande Vihara (Kande Viharaya) – jeden z nejvýznamnějších buddhistických chrámů poblíž Beruwaly.',
            kandeDetail2: 'Založený roku 1734, tento klid "Horský chrám" se nachází na vrcholu kopce s poklidnými výhledem na pobřeží.',
            kandeDetail3: 'Mezi zajímavosti patří obrovská 48metrová sedící socha Buddhy (jedna z nejvyšších na Srí Lance), složité fresky z období Kandy, starověká komora ostatků, krásná měsíční brána a posvátný strom Bodhi starý více než 300 let.',
            kandeDetail4: 'Dokonalý duchovní a kulturní zážitek na půl dne – ideální pro ranní návštěvy, aby se zabránilo horku.',
            bentotaDetail1: 'Užijte si klidné a malebné lodní safari podél řeky Bentota, jedné z nejpopulárnějších přírodních exkurzí poblíž Beruwaly.',
            bentotaDetail2: 'Klouzejte přes bujné mangrovové lesy, úzké kanály a klidné vody a pozorujte přitom místní faunu.',
            bentotaDetail3: 'Běžná pozorování zahrnují varance, krokodýly, různé druhy ptáků (ledňáčky, volavky, orly), opice a někdy i vydry nebo vodní hadi.',
            bentotaDetail4: 'Váš zkušený lodní průvodce/průvodce vás upozorní na zajímavou flóru, tradiční metody rybolovu a život v říčních vesnicích.',
            bentotaDetail5: 'Ideální pro milovníky přírody a fotografy – klidné, relaxační a doplňující váš aýurvédský pobyt.',
            galleDetail1: 'Prozkoumejte historickou pevnost Galle, světové dědictví UNESCO a jednu z nejlépe zachovaných koloniálních pevností na Srí Lance.',
            galleDetail2: 'Procházejte se po dlážděných ulicích obklopených holandskými koloniálními budovami, butiky, kavárny a galeriemi umění.',
            galleDetail3: 'Navštivte klíčové památky, jako je majáku Galle, holandský reformovaný kostel, Národní námořní muzeum a hradby s nádherným výhledem na oceán.',
            galleDetail4: 'Poznejte bohatou historii, architekturu a kulturní significance pevnosti od svého znalého průvodce.',
            galleDetail5: 'Ideální pro milovníky historie, příznivce kultury a ty, kteří si chtějí vychutnat kolinální minulost Srí Lanky.',
            sigiriyaDetail1: 'Objevte starobylou skalní pevnost Sigiriya, jeden z nejznamenitějších landmarků Srí Lanky a světové dědictví UNESCO.',
            sigiriyaDetail2: 'Vyjděte na impozantní skálu a prozkoumejte zbytky paláce krále Kašyapy, ozdobené fresky, vodními zahradami a slávistickou Zrcadlovou zdí.',
            sigiriyaDetail3: 'Těšte se na panoramatické pohledy na okolní džungli a krajinu z vrcholu.',
            sigiriyaDetail4: 'Poznejte fascinující historii, architekturu a legendy spojené se Sigiriou od svého odborného průvodce.',
            sigiriyaDetail5: 'Ideální pro milovníky historie, dobrodruhy a ty, kteří se zajímají o bohaté kulturní dědictví Srí Lanky.',
            kandyDetail1: 'Zažijte vibrantní kulturu Kandy, poslední královské hlavní město Srí Lanky a světové dědictví UNESCO.',
            kandyDetail2: 'Navštivte chrám Svatého zubu (Sri Dalada Maligawa), jeden z nejvýznamnějších buddistických míst na světě.',
            kandyDetail3: 'Prozkoumejte Královskou botanickou zahradu v Peradenii, domov obrovské sbírky tropických rostlin a orchidejí.',
            kandyDetail4: 'Užijte si tradiční Kandyánské taneční představení, které předvádí bohaté umělecké dědictví Srí Lanky.',
            kandyDetail5: 'Ideální pro milovníky kultury, historiky a ty, kteří se chtějí ponořit do tradic Srí Lanky.'
        },
        blogs: {
            heroTitle: 'Blogy Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Příběhy z pobřeží, ayurvédské rituály v',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Ponořte se do tipů, historie a zákulisních poznámek.',
            heroAlt: 'Pobřežní cesta resortu při západu slunce',
            sectionTitle: 'Blogy Muthumuni Ayurveda Beach Resort',
            sectionDescription: 'Průvodce, příběhy a poznámky z našeho pobřežního útočiště — od ayurvédských rituálů přes historii drahých kamenů až po cestovní tipy kolem Bentoty.',
            ayurvedaTitle: 'Srdce autentického Ayurvedy',
            ayurvedaExcerpt: 'Zažijte osvědčené léčivé tradice zakořeněné v dávné moudrosti Srí Lanky.',
            ayurvedaDescription: 'V Muthumuni Ayurveda Beach Resort je Ayurveda víc než léčba — je to způsob života. Naše terapie jsou založeny na staletých znalostech, přizpůsobené vašemu typu těla a vedené zkušenými ayurvédskými lékaři pro hlubokou a trvalou rovnováhu.',
            ayurvedaAlt: 'Ayurvédské léčení s bylinkovými oleji a přírodními prvky',
            healingTitle: 'Personalizované léčivé cesty',
            healingExcerpt: 'Proč je program každého hosta jedinečně navržený.',
            healingDescription: 'Od úvodních konzultací až po denní ošetření je vaše léčivá cesta pečlivě přizpůsobena. Bylinné terapie, terapeutické masáže, jóga a meditace spolupracují na obnově harmonie mezi tělem, myslí a duší.',
            healingAlt: 'Ayurvédský lékař konzultuje hosta v klidném prostředí',
            natureTitle: 'Léčení u oceánu',
            natureExcerpt: 'Jak mořský vánek a tropické okolí posilují vaši pohodu.',
            natureDescription: 'Muthumuni leží podél klidného pobřeží Srí Lanky a nabízí přirozeně léčivé prostředí. Zvuk vln, čerstvý oceánský vzduch a bujná zeleň zesílují účinky Ayurvedy a vytvářejí hluboký odpočinek a obnovu.',
            natureAlt: 'Pohled na pláž resortu s palmami a oceánem',
            foodTitle: 'Ayurvédská kuchyně pro vnitřní rovnováhu',
            foodExcerpt: 'Výživná jídla vytvořená na podporu vaší léčby.',
            foodDescription: 'Naše ayurvédská kuchyně je čerstvě připravována ze sezonních, místně získaných surovin. Každé jídlo je sladěno s vaší došou, podporuje trávení, detoxikaci a celkovou vitalitu, přičemž zůstává chutné a uspokojivé.',
            foodAlt: 'Tradiční ayurvédské jídlo servírované v přírodních miskách',
            yogaTitle: 'Jóga, meditace a vnitřní klid',
            yogaExcerpt: 'Jemné praktiky, které uklidňují mysl a posilují tělo.',
            yogaDescription: 'Denní jógové a meditační lekce doplňují vaše ošetření, zlepšují flexibilitu, dýchání a duševní jasnost. Tyto vědomé praktiky vám pomáhají znovu se spojit se sebou a унest pocit klidu i po vašem pobytu.',
            yogaAlt: 'Hosté cvičící jógu tváří k oceánu za úsvitu',
            lifestyleTitle: 'Vzít si Ayurvedu domů',
            lifestyleExcerpt: 'Jednoduché životní praktiky pro pokračování vaší cesty.',
            lifestyleDescription: 'Před odjezdem vás naši experti poradí, jak udržet rovnováhu pomocí denních rutin, stravy a rituálů sebepéče. Vezměte si domů víc než vzpomínky — vezměte si udržitelnou cestu ke zdravějšímu životu.',
            lifestyleAlt: 'Host relaxující s bylinkovým čajem v klidném prostředí resortu',
            readMore: 'Číst více'
        },
        events: {
            heroEyebrow: 'Zážitky a aktivity',
            heroTitle: 'Naše akce',
            heroSubtitle: 'Pečlivě vybrané zážitky spojující srílanskou tradici s pobřežním luxusem',
            heroAlt: 'Akce v Muthumuni',
            availableDaily: 'Denně k dispozici',
            bookNow: 'Rezervovat',
            highlightsTitle: 'Hlavní body',
            detailAlt: '{{title}} – detail',
            ctaTitle: 'Připraveni vytvářet vzpomínky?',
            ctaDescription: 'Kontaktujte náš tým a přizpůsobte si dokonalý zážitek z akce v Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Kontaktujte nás',
            ctaViewRooms: 'Zobrazit pokoje',
            cookeryTitle: 'Kuchařské programy',
            cookerySubtitle: 'Chuť Srí Lanky',
            cookeryDescription: 'Ponořte se do živých chutí srílanské kuchyně. Naši zkušení šéfkuchaři vás provedou praktickými kulinářskými lekcemi a naučí tradiční recepty předávané po generace. Naučte se připravovat aromatická kari, hoppers, kokosový sambol a další jídla z čerstvých místních surovin.',
            cookeryHighlight1: 'Tradiční srílanské recepty',
            cookeryHighlight2: 'Praktická kuchařská zkušenost',
            cookeryHighlight3: 'Čerstvé místní suroviny',
            cookeryHighlight4: 'Recepty s sebou domů',
            cookeryHighlight5: 'Včetně prohlídky zahrady s kořením',
            meditationTitle: 'Meditační programy',
            meditationSubtitle: 'Vnitřní klid a všímavost',
            meditationDescription: 'Najděte klid v našich vedených meditacích na pozadí klidného Indického oceánu. Naši zkušení instruktoři vás provedou starodávnými technikami všímavosti, dechovými cvičeními a jógovými praktikami, které uklidňují mysl a obnovují ducha.',
            meditationHighlight1: 'Sezení při východu a západu slunce',
            meditationHighlight2: 'Meditace na pláži',
            meditationHighlight3: 'Vedené odborníky',
            meditationHighlight4: 'Dechové techniky',
            meditationHighlight5: 'Jóga a všímavost',
            bbqTitle: 'BBQ večírky',
            bbqSubtitle: 'Oslavy u moře',
            bbqDescription: 'Zažijte nezapomenutelné večery s našimi BBQ večírky na pláži. Vychutnejte si čerstvě grilované mořské plody, prémiové maso a vegetariánské dobroty, zatímco vlny šumí poblíž. Živá hudba, ohňoví tanečníci a hvězdná obloha vytvářejí dokonalou atmosféru pro oslavu a propojení.',
            bbqHighlight1: 'Čerstvé grilované mořské plody',
            bbqHighlight2: 'Stravování u oceánu',
            bbqHighlight3: 'Živá zábava',
            bbqHighlight4: 'Zážitek s ohněm',
            bbqHighlight5: 'Přizpůsobitelné menu',
            boatTitle: 'Projížďky lodí',
            boatSubtitle: 'Říční a pobřežní dobrodružství',
            boatDescription: 'Vydejte se na okouzlující plavby po řece Bentota a pobřežních vodách. Proplouvejte mangrovovými lesy, pozorujte exotické ptáky a divokou přírodu nebo si užijte romantické plavby při západu slunce. Naše projížďky lodí nabízejí jedinečný pohled na přírodní krásu Srí Lanky a její rozmanité ekosystémy.',
            boatHighlight1: 'Plavby po řece Bentota',
            boatHighlight2: 'Průzkum mangrovů',
            boatHighlight3: 'Pozorování divoké přírody',
            boatHighlight4: 'Plavby při západu slunce',
            boatHighlight5: 'Soukromý charter k dispozici',
            ayurvedaLecturesTitle: 'Přednášky lékařů ajurvédy',
            ayurvedaLecturesSubtitle: 'Starověká moudrost a moderní wellness',
            ayurvedaLecturesDescription: 'Objevte hluboké principy ajurvédy prostřednictvím přednášek vedených certifikovanými ajurvédskými lékaři a praktiky. Dozvíte se o vyvažování dóš, bylinných prostředcích, holistických léčebných praktikách a o tom, jak se starověká moudrost uplatňuje v moderním wellness. Naše interaktivní sezení objasňují ajurvédskou filosofii a její použití v každodenním životě.',
            ayurvedaLecturesHighlight1: 'Certifikovaní ajurvédští lékaři',
            ayurvedaLecturesHighlight2: 'Personalizovaná analýza dóš',
            ayurvedaLecturesHighlight3: 'Vzdělávání o bylinných prostředcích',
            ayurvedaLecturesHighlight4: 'Včetně Q&A sezení',
            ayurvedaLecturesHighlight5: 'průvodce na cestu',
            traditionalClothsTitle: 'Akce s tradičním oděvem',
            traditionalClothsSubtitle: 'Zážitek kulturního dědictví',
            traditionalClothsDescription: 'Ponořte se do srílanského kulturního dědictví tím, že se naučíte nosit a oceňovat tradiční oděv. Naši odborní stylisté vás provedou oblékáním autentických kandyských sárí a tradičních oděvů a vysvětlí kulturní význam každého kusu. Ideální pro zvláštní příležitosti, kulturní ocenění nebo vytvoření nezapomenutelných fotografií.',
            traditionalClothsHighlight1: 'Odborné stylistické vedení',
            traditionalClothsHighlight2: 'Autentická tradiční sárí',
            traditionalClothsHighlight3: 'Vysvětlení kulturního významu',
            traditionalClothsHighlight4: 'Profesionální fotografování v ceně',
            traditionalClothsHighlight5: 'Workshopy módní fúze'
        },
        contact: {
            heroTitle: 'Kontaktujte nás',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Kontaktujte nás',
            sectionTitle: 'Neváhejte nás kontaktovat',
            sectionSubtitle: 'Jsme tu, abychom vám pomohli relaxovat a načerpat síly',
            sectionDescription: 'Kontaktujte Muthumuni Ayurveda Beach Resort ohledně ayurvédského pobytu, balíčků, rezervací nebo jakýchkoli dotazů během pobytu v Beruwale, Moragalle.',
            callUs: 'Zavolejte nám',
            emailTitle: 'Email',
            ourLocation: 'Naše poloha',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Sociální sítě',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Spojte se s námi',
            getInTouchDescription: 'Rádi vás uslyšíme — náš tým je připraven pomoci s vaším pobytem, odpovědět na otázky a naplánovat regenerující pobyt.',
            nameLabel: 'Jméno',
            emailLabel: 'Email',
            contactNumberLabel: 'Kontaktní číslo',
            messageLabel: 'Zpráva',
            sending: 'Odesílání...',
            sendMessage: 'Odeslat zprávu',
            successMessage: 'Vaše zpráva byla úspěšně odeslána! Brzy se ozveme.',
            errorMessage: 'Při odesílání došlo k chybě. Zkuste to prosím znovu.',
            findUsOnMap: 'Najděte nás na mapě',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Jméno',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Kontaktní číslo',
            whatsappMessage: 'Zpráva'
        },

        contact2: {
            heroTitle: 'Kontaktujte nás',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Kontaktujte nás',
            sectionTitle: 'Neváhejte nás kontaktovat',
            sectionSubtitle: 'Jsme tu, abychom vám pomohli relaxovat a načerpat síly',
            sectionDescription: 'Kontaktujte Muthumuni Ayurveda Beach Resort ohledně ayurvédského pobytu, balíčků, rezervací nebo jakýchkoli dotazů během pobytu v Beruwale, Moragalle.',
            callUs: 'Zavolejte nám',
            emailTitle: 'Email',
            ourLocation: 'Naše poloha',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Sociální sítě',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Spojte se s námi',
            getInTouchDescription: 'Rádi vás uslyšíme — náš tým je připraven pomoci s vaším pobytem, odpovědět na otázky a naplánovat regenerující pobyt.',
            nameLabel: 'Jméno',
            emailLabel: 'Email',
            contactNumberLabel: 'Kontaktní číslo',
            messageLabel: 'Zpráva',
            sending: 'Odesílání...',
            sendMessage: 'Odeslat zprávu',
            successMessage: 'Vaše zpráva byla úspěšně odeslána! Brzy se ozveme.',
            errorMessage: 'Při odesílání došlo k chybě. Zkuste to prosím znovu.',
            findUsOnMap: 'Najděte nás na mapě',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Jméno',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Kontaktní číslo',
            whatsappMessage: 'Zpráva'
        },

        ayurveda: {
            accordionTitle1: 'Co je Pančakarma Ájurvéda?',
            accordionDesc1: 'Ájurvéda je jeden z nejstarších léčebných systémů na světě, vyvinutý před více než 5000 lety. Pančakarma Ájurvéda je založena na přesvědčení, že zdraví závisí na rovnováze mezi myslí, tělem, duší a prostředím.',
            accordionTitle2: 'Pančakarma Ájurvéda a životní energie',
            accordionDesc2: 'Ájurvéda je založena na teorii propojení všeho ve vesmíru. Ti, kdo praktikují Ájurvédu, věří, že každá osoba se skládá z pěti prvků: prostor, vzduch, oheň, voda a země. Ty tvoří tři dóšy: VÁTA, PITTA a KAPHA.',
            accordionTitle3: 'Dóša Váta',
            accordionDesc3: 'Nejmocnější dóša řídí základní tělesné funkce: buněčné dělení, dýchání, krevní oběh, srdeční funkce. Při dominantní Vátě jste inteligentní, kreativní, energičtí. V nerovnováze - úzkost. Vyvážení meditací, masáží a teplými jídly.',
            accordionTitle4: 'Dóša Pitta',
            accordionDesc4: 'Řídí trávení, metabolismus a hormony. Při dominantní Pittě jste rozhodní, soutěživí, sebevědomí. V nerovnováze - podrážděnost. Vyvážení chladivými jídly a pomalou jógou.',
            accordionTitle5: 'Dóša Kapha',
            accordionDesc5: 'Řídí růst svalů, tělesnou sílu a imunitu. Při dominantní Kaphě milujete rutinu, jste klidní a trpěliví. V nerovnováze - únava a přibírání na váze. Vyvážení ovocem, zeleninou a cvičením.',
            close: 'Zavřít',
            next: 'Další',
            previous: 'Předchozí',
            treatmentsTitle: 'Naše charakteristické procedury Pančakarma Ájurvédy',
            treatmentsSubtitle: 'Zažijte starodávné terapie k obnovení rovnováhy, uvolnění napětí a omlazení celé vaší bytosti.',
            bookTreatment: 'Rezervovat tuto proceduru',
            benefitsTitle: 'Výhody procedur Pančakarma',
            shirodhara: 'Šíródára',
            shirodharaDesc: 'Jemné lití teplého bylinného oleje na čelo pro uklidnění mysli.',
            shirodhara1: 'Snižuje stres a úzkost',
            shirodhara2: 'Podporuje lepší spánek',
            shirodhara3: 'Zlepšuje duševní jasnost',
            steamBath: 'Parní lázeň',
            steamBathDesc: 'Detoxikační parní ošetření k otevření pórů a uvolnění svalů.',
            steamBath1: 'Detoxikuje tělo',
            steamBath2: 'Zlepšuje krevní oběh',
            steamBath3: 'Uvolňuje svalové napětí',
            flowerBath: 'Květinová lázeň',
            flowerBathDesc: 'Uklidňující lázeň s aromatickými květinami pro relaxaci.',
            flowerBath1: 'Uklidňuje nervový systém',
            flowerBath2: 'Hydratuje pokožku',
            flowerBath3: 'Zvedá náladu',
            headMassage: 'Masáž hlavy',
            headMassageDesc: 'Relaxační masáž pokožky hlavy k uvolnění napětí.',
            headMassage1: 'Snižuje bolesti hlavy',
            headMassage2: 'Zlepšuje zdraví pokožky hlavy',
            headMassage3: 'Podporuje relaxaci',
            faceMassage: 'Masáž obličeje',
            faceMassageDesc: 'Omlazující masáž ke zlepšení vzhledu obličeje a snížení stresu.',
            faceMassage1: 'Zlepšuje tón pleti',
            faceMassage2: 'Snižuje napětí v obličeji',
            faceMassage3: 'Podporuje lymfatickou drenáž',
            neckMassage: 'Masáž krku',
            neckMassageDesc: 'Cílená masáž k úlevě od ztuhlosti a napětí krku.',
            neckMassage1: 'Ulevuje od bolesti krku',
            neckMassage2: 'Zlepšuje flexibilitu',
            neckMassage3: 'Snižuje stres',
            shoulderMassage: 'Masáž ramen',
            shoulderMassageDesc: 'Cílená masáž k úlevě od ztuhlosti a nepohodlí ramen.',
            shoulderMassage1: 'Snižuje bolest ramen',
            shoulderMassage2: 'Zlepšuje držení těla',
            shoulderMassage3: 'Uvolňuje svaly',
            bodyMassage: 'Celotělová masáž',
            bodyMassageDesc: 'Celotělová masáž podporující relaxaci a pohodu.',
            bodyMassage1: 'Zlepšuje krevní oběh',
            bodyMassage2: 'Ulevuje od svalových bolestí',
            bodyMassage3: 'Podporuje relaxaci',
            backMassage: 'Masáž zad',
            backMassageDesc: 'Terapeutická masáž k řešení bolestí a napětí zad.',
            backMassage1: 'Ulevuje od bolesti zad',
            backMassage2: 'Zlepšuje zdraví páteře',
            backMassage3: 'Snižuje stres',
            footMassage: 'Masáž nohou',
            footMassageDesc: 'Uklidňující masáž k úlevě od bolesti nohou a relaxaci.',
            footMassage1: 'Zlepšuje krevní oběh',
            footMassage2: 'Snižuje únavu nohou',
            footMassage3: 'Podporuje relaxaci',
            purgative: 'Projímadlo',
            purgativeDesc: 'Očistná terapie k odstranění přebytečné Pitty a toxinů z trávicího systému.',
            purgative1: 'Čistí střeva',
            purgative2: 'Vyvažuje dóšu Pitta',
            purgative3: 'Zlepšuje zdraví trávení',
            nasalClearing: 'Nosní čištění',
            nasalClearingDesc: 'Terapeutické nosní ošetření k vyčištění vedlejších nosních dutin a zlepšení dýchací funkce.',
            nasalClearing1: 'Odstraňuje ucpání nosu',
            nasalClearing2: 'Zlepšuje dýchání',
            nasalClearing3: 'Ulevuje od problémů s dutinami',
            powderMassage: 'Prášková masáž',
            powderMassageDesc: 'Exfoliační masáž s bylinkovými prášky k omlazení a osvěžení pokožky.',
            powderMassage1: 'Odstraňuje odumřelou kůži',
            powderMassage2: 'Zlepšuje texturu kůže',
            powderMassage3: 'Podporuje krevní oběh',
            intensiveMassageDesc: 'Hloubková terapeutická masáž zaměřená na chronické napětí a svalové uzly s pevným tlakem a speciálními technikami.',
            intensiveMassage1: 'Uvolňuje hluboké svalové napětí',
            intensiveMassage2: 'Zlepšuje prokrvení',
            intensiveMassage3: 'Snižuje svalovou bolest',
            thermoMassage: 'Termomasáž',
            thermoMassageDesc: 'Teplá masáž s bylinným olejem za použití ohřátých terapeutických olejů pro posílení relaxace a léčivých účinků.',
            thermoMassage1: 'Uklidňuje bolavé svaly',
            thermoMassage2: 'Podporuje hlubokou relaxaci',
            thermoMassage3: 'Zlepšuje tok energie',
            synchronMassage: 'Synchronní masáž',
            synchronMassageDesc: 'Synchronizovaná masáž dvěma terapeuty pro úplnou harmonii těla a vyvážené rozložení energie.',
            synchronMassage1: 'Kompletní harmonie těla',
            synchronMassage2: 'Vyvážený tok energie',
            synchronMassage3: 'Hloubkový relaxační zážitek',
            specialMassage: 'Speciální masáž',
            specialMassageDesc: 'Individuální masážní terapie přizpůsobená vašim konkrétním zdravotním potřebám a osobním cílům wellness.',
            specialMassage1: 'Personalizovaná léčba',
            specialMassage2: 'Zaměřená na konkrétní potíže',
            specialMassage3: 'Individuální léčebný přístup',
            benefit1Title: 'Detoxikace:',
            benefit1Desc: 'Procedury Pančakarma pomáhají odstranit toxiny z těla a podporují zdraví a vitalitu.',
            benefit2Title: 'Zlepšené trávení:',
            benefit2Desc: 'Tyto terapie zlepšují funkci trávení pro lepší vstřebávání živin a metabolismus.',
            benefit3Title: 'Snížení stresu:',
            benefit3Desc: 'Pančakarma je známá svými uklidňujícími účinky na tělo a mysl a snižuje úroveň stresu a úzkosti.',
            benefit4Title: 'Posílení imunity:',
            benefit4Desc: 'Pravidelné procedury Pančakarma posilují imunitní systém a činí tělo odolnějším.',
            benefit5Title: 'Omlazení:',
            benefit5Desc: 'Terapie podporují regeneraci buněk pro zlepšení zdraví pokožky a mladistvý vzhled.',
            benefit6Title: 'Rovnováha dóš:',
            benefit6Desc: 'Pančakarma pomáhá obnovit rovnováhu dóš (Váta, Pitta, Kapha), což je podle ájurvédských principů nezbytné pro zdraví.',
            akkupancharTitle: 'Akkupančar terapie',
            akkupancharDesc1: 'je starodávná ájurvédská terapie využívající bylinné pasty a oleje na specifických bodech těla. Toto ošetření stimuluje energetické kanály a podporuje léčení.',
            akkupancharBenefit: 'Hlavní výhody:',
            akkupancharDesc2: 'Tato specializovaná terapie pomáhá při chronických bolestech, zlepšuje flexibilitu kloubů, podporuje krevní oběh a obnovuje přirozený tok energie.',
            akkupancharApplication: 'Terapeutická aplikace:',
            akkupancharDesc3: 'Akkupančar působí na specifické marma body s pečlivě vybranými bylinkovými přípravky k vyvážení dóš.',
            akkupancharTransform: 'Zažijte transformaci:',
            akkupancharDesc4: 'V Muthumuni Ayurveda Beach Resort naši zkušení terapeuti přizpůsobují každé sezení vašim zdravotním potřebám.',
            gallery1: 'Terapie Šíródára',
            gallery2: 'Parní lázeň',
            gallery3: 'Květinová lázeň',
            gallery4: 'Masáž hlavy',
            gallery5: 'Celotělová masáž',
            gallery6: 'Masáž krku',
            gallery7: 'Masáž obličeje',
            gallery8: 'Masáž ramen',
            heroTitle: 'Pančakarma Ájurvéda',
            heroSubtitle: 'Omlazení těla, mysli a duše v Beruwale',
            sectionEyebrow: 'PANČAKARMA ÁJURVÉDA V MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Objevte starověké umění léčení Pančakarmou v Muthumuni Ayurveda Beach Resort v Beruwale. Naši zkušení praktikanti nabízejí personalizované léčby pro detoxikaci, omlazení a obnovení rovnováhy.',
            treatmentProgramme: {
                title: 'Program Ájurvédské Léčby',
                subtitle: 'Vaše Cesta k Rovnováze, Detoxikaci a Hlubokému Obnovení',
                intro: 'Zažijte autentické ájurvédské uzdravení v klidném útočišti navrženém k obnovení vašeho těla, uklidnění mysli a obnově energie. Od okamžiku vašeho příjezdu se náš tým stará o každý detail—abyste se mohli plně soustředit na své zdraví.',
                welcomeTitle: 'Vítání a Jemný Začátek',
                welcomePoints: [
                    'Vyzvednutí na letišti a transfer do hotelu',
                    'Srdečné uvítání a orientace v hotelu',
                    'Představení vašeho týdenního programu',
                    'Relaxační Masáž (1. den) v Ájurvédském Centru k uvolnění únavy z cesty a přípravě těla na ošetření'
                ],
                doctorTitle: 'Konzultace s Lékařem a Osobní Plán',
                doctorPoints: [
                    'Konzultace s Ájurvédským Lékařem (2. den – dopoledne)',
                    'Komplexní posouzení vaší Dóši/typu těla a zdravotních problémů',
                    'Tlumočník dostupný na požádání',
                    'Váš lékař vytvoří personalizovaný léčebný plán přizpůsobený vašim potřebám a cílům'
                ],
                dailyTherapiesTitle: 'Denní Ájurvédské Terapie',
                dailyTherapiesPoints: [
                    '4–5 ošetření denně (podle doporučení lékaře)',
                    'Terapie vybrané na základě vaší tělesné konstituce a stavu',
                    'Speciální masáže mohou být přidány podle potřeby',
                    'Lékař každý den sleduje pokrok a může upravit ošetření a bylinnou podporu pro zajištění nejlepších výsledků',
                    'Pokud je to vhodné, může být doporučen jemný čisticí/projímavý proces'
                ],
                herbalMedicineTitle: 'Podpora Bylinných Léků',
                herbalMedicinePoints: [
                    'Lékařem předepsané bylinné léky podávané dvakrát denně:',
                    'Během snídaně',
                    'Během večeře',
                    'Podporují vnitřní uzdravení, detoxikaci a dlouhodobou rovnováhu'
                ],
                yogaMeditationTitle: 'Jóga a Meditace pro Harmonii Těla a Mysli',
                yogaMeditationPoints: [
                    'Lekce jógy 4krát týdně (cca 1 hodina)',
                    'Meditační sezení 2krát týdně:',
                    'Jedinečný duchovní zážitek v Ostrovním Chrámu, dostupný lodí',
                    'Vedená meditace vedená mnichy (cca 1 hodina)'
                ],
                wellnessTitle: 'Zahrnuté Zážitky',
                wellnessPoints: [
                    'Týdenní ukázky zdravého vaření',
                    'Bezplatný výlet (kulturní/přírodní zážitek)'
                ],
                closingTitle: 'Závěrečný Rituál a Odjezd',
                closingPoints: [
                    'Krásná Květinová Koupel (poslední den)—tradiční rituál obnovy',
                    'Závěrečná Konzultace s Lékařem k přezkoumání pokroku a poskytnutí:',
                    'Pokračující poradenství',
                    'Recepty a doporučení pro domov',
                    'Transfer zpět na letiště'
                ]
            },
        },
        food: {
            heroTitle: 'Ayurvédská kuchyně a pobřežní kuchyně',
            heroSubtitle: 'Autentické chutě ze Srí Lanky a čerstvá pobřežní kuchyně',
            heroAlt: 'Kulinární zážitek v Muthumuni Beach Resort',
            wellnessEyebrow: 'skrze jídlo',
            wellnessTitle: 'Důležitost',
            ayurvedicFood: 'ayurvédského jídla',
            wellnessIntro1: 'V ajurvédě je jídlo považováno za největší medicínu. To, co jíte, přímo ovlivňuje vaše doshy (Vata, Pitta, Kapha), trávení (agni) a celkovou rovnováhu těla, mysli a ducha.',
            wellnessIntro2: 'Ajurvédská výživa zdůrazňuje čerstvé, sezónní potraviny celé připravované s péčí a vědomým jídlem. V každém jídle podporuje šest chutí (sladké, kyselé, slané, pálivé, hořké, tannické) pro výživu všech smyslů a zachování harmonie.',
            wellnessIntro3: 'Správné ajurvédské jídlo podporuje silné trávení, pomáhá zbavit se toxinů (ama), posílí imunitu, zlepšuje energii, snižuje stres a zabraňuje mnoha chronickým onemocněním. V Muthumuni je každé jídlo pečlivě připraveno tak, aby se vyrovnalo vaší jedinečné konstituci pro hlubokého uzdravení a vitalitu.',
            foodImage1Alt: 'Tradiční ajurvédské jídlo se šesti chutěmi',
            foodImage2Alt: 'Ajurvédské byliny a koření pro vyváženou výživu',
            culinaryPhilosophyEyebrow: 'Naše kulinární filozofie',
            culinaryPhilosophyTitle: 'Ajurvédská',
            nutritionHighlight: 'výživa',
            culinaryPhilosophyResort: 'v Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Ajurvédská kuchyně v Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Čerstvé a výživné',
            healingIngredientsAlt: 'Zdravé ajurvédské ingredience a koření',
            healingIngredientsLabel: 'Léčivé ingredience',
            philosophyText1: 'Jídlo, které obsahuje šest hlavních chutí (sladké, kyselé, slané, hořké, pálivé a tannické) spolu s mnoha jemnými variacemi, bylo popsáno v klasických ajurvédských textech — některé pocházejí z doby před více než 5000 let — spolu s podstatných vlastnostmi každé potravy: Guna (vlastní kvalita), Virya (účinnost/zahřívání nebo chlazení), Vipaka (post-digestivní dopad) a Prabhava (jedinečné zvláštní působení).',
            philosophyText2: 'V důsledku toho hraje ajurvédská výživa ústřední roli v Muthumuni Ayurveda Beach Resort. To neznamená rigidní, monotónní režim bez chuti, bez chuti nebo nadměrně hořkých vegetariánských jídel určených výhradně lékaři. Naopak, naše ajurvédská kuchyně je jednou z našich největších silných stránek: jídla připravená našimi zručnými kuchaři vás překvapí a potěší každý den vašeho pobytu!',
            philosophyText3: 'K snídani si užijte hojný bufet s čerstvým tropickým ovocem, čerstvě vymačkaným ovocem, živinnými bylinkovými polévkami, domácím chlebem a lehkými sušenkami a řadou autentických možností snídaně ze Srí Lanky. K obědu si vychutnáte barevný a chutný bufet s jemným rybím curry, přípravou zeleniny a bylinkami infuzní jídla. Večer podáváme stanoveného vegetariánské menu s dostupnou možností čerstvé ryby. V sobotu oslavujeme „noc Srí Lanky" s rozšířeným bufettem — naši kuchaři připravují tradiční místní speciality přímo před vámi, což vytváří živou a autentickou zkušenost.',
            philosophyText4: 'V ajurvédě jsou potraviny a nápoje klasifikovány mnoha způsoby — podle chuti a vlastností, trávící kapacity těla (agni), vhodnosti pro specifické zdravotní stavy, sezónní vhodnosti a další. V Muthumuni my pečlivě zvažujeme všechny tyto faktory současně, vědomě se snažíme zahrnout všech šest chutí do vyváženého kombinace přizpůsobených jednotlivé konstituci každého hosta.',
            philosophyText5: 'Naše jídla obsahují čerstvou zeleninu, tropické ovoce a odpovědně pocházející ryby. Nepodáváme červené maso ani alkohol.',
            philosophyText6: 'Během jídel je ajurvédský lékař nebo kvalifikovaný dietolog vždy k dispozici, aby vás vedl. Poradí vám na nejvhodnější zeleninu, byliny a koření pro vaši aktuální fázi léčby a pomohou vám vhodně vybírat nebo se vyhnout jídlům. Váš personalizovaný bylinný elixír a všechny konkrétní pokyny od týmu zdravotního centra budou umístěny na vašem individuálním stole.',
            philosophyText7: 'Tato úroveň osobní péče a pozornosti k dietě je charakteristikou zkušenosti v Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Jídlo se považuje za Pranu — životní energii, která udržuje život — pro každého člověka. Právě proto vás podporujeme, abyste k jednotlivým jídlům přistupovali s plným povědomím: vychutnávajícím si arom, prožívajícím chutě, cítícím jemné teplo a vědomě užívajícím chutné pocity.',
            diningExperienceEyebrow: 'Gastronomická zkušenost',
            restaurantTitlePrefix: 'Naše',
            ayurvedicHighlight: 'ajurvédské',
            restaurantTitleSuffix: 'restaurace',
            restaurantDetail1: 'Naše ajurvédská restaurace v Muthumuni Beach Resort nabízí jedinečný stravovací zážitek, který harmonizuje tradiční ajurvédské principy s autentickou kuchyní pobřeží Srí Lanky. Upřednostňujeme čerstvé, místně pocházející ingredience, abychom vytvořili jídla, která nejen potěší chutě, ale také podporují holistickou pohodu.',
            restaurantDetail2: 'Jídelní lístek je pečlivě navrhnout tak, aby vyvážit šest chutí (sladké, kyselé, slané, hořké, pálivé, tannické) v každém jídle, což zajistí výživný a uspokojivý zážitek. Každé jídlo je připraveno s péčí a začleňuje ajurvédské byliny a koření známé svými léčivými vlastnostmi.',
            restaurantDetail3: 'Hosté se mohou těšit na různé jídla přizpůsobená jejich individuálním doshah (tělesným konstituci), s možnostmi pro vegetariánské, veganské a pescetariánské strany. Naši kuchařové úzce spolupracují s ajurvédskými praktiky, aby zajistili, že každé jídlo podporuje cíle zdraví a hostů.',
            restaurantDetail4: 'Atmosféra restaurace odráží klidné pobřežní prostředí a poskytuje klidné prostředí pro vědomé jídlo. Ať už si užíváte vydatný snídaňový bufet nebo vychutnávete jemné večeře, každé jídlo v naší ajurvédské restauraci je příležitostí na výživu těla a duše.',
            restaurantDetail5: 'Připojte se k nám v ajurvédské restauraci Muthumuni Beach Resort na kulinární cestě, která slaví bohaté chutě Srí Lanky a zároveň přijímá nadčasovou moudrost Ajurvédy.',
            restaurantImageAlt: 'Stravování v Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Prémiové stravování',
            premiumDiningDescription: 'Zažijte autentickou ajurvédskou kuchyni v klidném pobřežním prostředí'
        },
        yoga: {
            heroTitle: 'Jóga v resortu',
            heroSubtitle: 'Najděte rovnováhu, sílu a vnitřní klid v Beruwale',
            heroAlt: 'Jóga v Muthumuni Beach Resort',
            importanceEyebrow: 'a rovnováha',
            importanceTitle: 'Význam jógy a meditace',
            importanceImageAlt: 'Význam jógy a meditace',
            importanceText1: 'Jóga a meditace jsou starobylé praktiky, které nabízejí řadu fyzických, duševních a emocionálních přínosů. Podporují flexibilitu, sílu a rovnováhu a zároveň snižují stres a úzkost.',
            importanceText2: 'Pravidelná praxe může zlepšit koncentraci, kvalitu spánku a celkovou pohodu. Jóga také podporuje všímavost, pomáhá lidem propojit se se svým vnitřním já a najít klid uprostřed každodenního shonu.',
            importanceText3: 'V Muthumuni Beach Resort nabízíme klidné prostředí ideální pro cvičení jógy a meditace, které hostům umožňuje obnovit mysl, tělo i ducha.',
            practiceEyebrow: 'Naše praxe',
            practiceTitle: 'Jógová praxe a zkušenost',
            practiceImageAlt: 'Jógová praxe v resortu',
            practiceText1: 'V Muthumuni Ayurveda Beach Resort se jóga praktikuje především jako tradiční Hatha Yoga v kombinaci s Pránájámou (dechové techniky). Tento holistický přístup je navržen k probuzení vnitřního uvědomění a jemné stimulaci Kundaliní (často označované jako třetí oko). Zvláštní důraz se klade na zarovnání páteře a flexibilitu, protože pružná páteř je považována za klíč ke zpomalení stárnutí — „Jste tak staří, jak stará je vaše páteř.“',
            practiceText2: 'Lekce jógy probíhají čtyřikrát týdně a jsou vhodné pro začátečníky i zkušené praktiky. Občas jsou zařazeny speciální lekce, například Ashtanga Yoga, které umožňují hostům vyzkoušet různé pozice a sestavy. Naši ayurvédští lékaři podporují pravidelnou účast, aby podpořili a posílili celkový léčebný program.',
            practiceText3: 'Všechny lekce jógy se konají v naší vyhrazené Yoga Shala, klidném prostoru navrženém pro soustředění, rovnováhu a vědomý pohyb. Každá lekce obvykle začíná Pozdravem slunci, následuje Pránájáma a sekvence pečlivě vybraných ásan zaměřených na zlepšení flexibility, cirkulace a celkové pohody.',
            practiceText4: 'Naši zkušení učitelé jógy přizpůsobují každou lekci individuálním potřebám, schopnostem a zdravotnímu stavu hostů, čímž zajišťují bezpečný, podpůrný a hluboce prospěšný zážitek pro každého.',
            spiritualEyebrow: 'Duchovní cesta',
            spiritualTitle: 'Meditace a duchovní aktivity',
            spiritualSubtitle: 'Prohlubte svou duchovní praxi s našimi posvátnými obřady a vedenými meditacemi',
            meditationImageAlt: 'Meditace a duchovní praxe v resortu',
            meditationTitle: 'Meditativní sezení',
            meditationDesc: 'Hosté jsou zváni k účasti na vedených meditacích konaných třikrát týdně, inspirovaných buddhistickými tradicemi. Tyto sezení jsou navrženy k uklidnění mysli, prohloubení uvědomění a podpoře emocionálního i duchovního uzdravení. Meditace probíhá v klidném chrámu na ostrově, kam se hosté dostanou lodí — klidná a smysluplná cesta, která obohacuje celkový meditační zážitek.'
        },
        home: {
            heroTitle: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Ayurveda u oceánu',
            heroSubtitle2: 'Najděte rovnováhu, dýchejte lehčeji a obnovte svou energii v Beruwale.',
            exploreResort: 'Prozkoumejte resort',
            bookNow: 'Rezervovat nyní',
            welcomeLabel: 'Vítejte',
            welcomeTitle: 'Muthumuni Ayurveda Beach Resort',
            welcomeDesc1: 'Resort Muthumuni Ayurveda Beach se nachází na panskyxch březích Beruwal a kombinuje staré léčebné tradice s moderním přímemo-mořským luxusem. Naše svatyně vás zve na transformující cestu wellness, kde rytmické zvuky Indického oceánu potívají věčnou moudrost Ayurvedy.',
            welcomeDesc2: 'Zažijte personalizované ayurvédské léčby, vychutnávejte živiny připravená jídla vytvořená k vyvážení vaší doši a uvolněte se v elegantně vybavených pokojích s úchvatným výhledem na oceán. Ať už hledáte omlazenní, relaxaci nebo duchovní znovuzrození, náš oddaný tým ayurvédských praktik a odborníků na vás provede každým krokem.',
            learnMore: 'Zjistěte více',
            contactUs: 'Kontaktujte nás',
            welcomeImageAlt: 'Muthumuni Ayurveda Beach Resort',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Beruwala, Sri Lanka',
            highlightTitle: 'Ayurvédické svatyně u moře',
            highlightDesc: 'Objevte holistické léčení na jiho-západním pobřeží Sri Lanky. Od přizpůsobených léčeb k klidným balkonům a vědomé kuchyni, každý detail je navržen tak, aby obnovil váš ritmus.',
            service1Title: 'Holistické ayurvédské terapie',
            service1Desc: 'Personalizované konzultace, autentické bylinné oleje a denní léčby vedené zkušenými ayurvédskými lékaři.',
            service2Title: 'Pokoje a apartmány u pláže',
            service2Desc: 'Projděte se mořským vánkem, soukromými balkóny a uklidňujícím interiérem navrženým pro hluboký odpočinek.',
            service3Title: 'kuchyně',
            service3Desc: 'Čerstvé srílanské produkty, rostlinné jídelní lístky a přizpůsobené jídelní plány, které doplňují vaši dosu.',
            service4Title: 'Jóga a vědomí',
            service4Desc: 'Jóga na východ slunce, meditace na západ slunce a dechové cvičení v rytmu vln.',
            service5Title: 'Řívní a pobřežní exkurze',
            service5Desc: 'Plavby po řekou Bentota, návštěvy líhní mořských želv, procházky zahradami koření a cyklistické zájezdy po vesnicích.',
            roomsTitle: 'Naše pokoje',
            roomsDesc: 'Vyberte si svatyni, která odpovídá vašemu tempu, od prostorných apartmánů po útulné deluxe úkryty, všechny s měkkým prádlem, teplým dřevem a balkóny připravenými na východ slunce.',
            roomBadge: 'Útěk u pláže',
            bookableNow: 'Nyní rezervovaterné',
            seaBreezeReady: 'Připraven na mořský vánek',
            viewRoom: 'Zobrazit pokoj',
            room1Title: 'Apartmánové pokoje',
            room1Desc: 'Prostorné apartmány s obývacím pokojem, velkoryse velkými balkóny a uklidňující paletou pro pomalá ráno.',
            room2Title: 'Deluxe pokoje',
            room2Desc: 'Útulné úkryty s luxusními postelemi, výhledem na zahradu a teplými dřevěnými akcenty pro denní jednoduchost.',
            room3Title: 'Deluxe s výhledem na moře',
            room3Desc: 'Projděte se s horizontem oceánu, měkkým prádlem a soukromým balkonem určeným pro zlaté západy slunce.',
            achievement1Title: 'Šťastní hosté',
            achievement1Count: '1 000+',
            achievement2Title: 'Ayurvédské léčby',
            achievement2Count: '20+',
            achievement3Title: 'Leta péče',
            achievement3Count: '15+',
            achievement4Title: 'Cestovatelé Aklamace',
            achievement4Count: '1 000+',
            experiencesTitle: 'Prozkoumejte Muthumuni Ayurveda Beach Resort',
            experiencesDesc: 'Od ayurvédských jízd k kurátorským veletům, vyberte si zážitky, které vám zpřícemní pobyt nepamíti.',
            planYourStay: 'Plánujte svůj pobyt',
            experience1Title: 'Pokoje a apartmány',
            experience1Desc: 'Větrné prostory s balkóny, výhledem na oceán nebo zahradu a promyšleným komfortem pro nespěchající spočívající pobytů.',
            experience2Title: 'Ayurveda Spa',
            experience2Desc: 'Autentické terapie, parní lázně a regenerační masáže poskytované s osvědčenými rituály.',
            experience3Title: 'Kulinářský zážitek',
            experience3Desc: 'Výživná srílanská a mezinárodní kuchyně podávaná v naší restauraci, pečlivě připravená k výživě těla a mysli.',
            experience4Title: 'Zážitky a prohlídky',
            experience4Desc: 'Řiční safari, návštěvy chrámů, vodní sporty a kurované kulturní exkurze kolem Bentuty.',
            galleryTitle: 'Chvíle v Muthumuni Ayurveda Beach Resort',
            galleryDesc: 'Vhled do naší pobřežní svatyně — východy slunce, klidné léčby, výživná jídla a klidné kouty pro vás.',
            gallery1Alt: 'Slunečná pláž obklopená palmami v Muthumuni',
            gallery2Alt: 'Probíhající ayurvédská olejová léčba',
            gallery3Alt: 'Resort bazén s lehátkys',
            gallery4Alt: 'Byliny připravené pro spa',
            gallery5Alt: 'Pár si užívá západ slunce u moře',
            gallery6Alt: 'Yoga paluba obličející oceán',
            gallery7Alt: 'Cesta tropickou zahradu',
            gallery8Alt: 'Zdravá snídaně',
            gallery9Alt: 'Klidný výhled na řeku',
            gallery10Alt: 'Resort exetrior hebce osvětleny při západu slunce',
            gallery11Alt: 'Displej ayurvédských bylin a olejů',
            gallery12Alt: 'Pohodlné sezení v zahradě',
            resort1Alt: 'Venkovní lounge se zelení',
            resort2Alt: 'Pohodlné vnitřní vybavení pokoje',
            resort3Alt: 'Prostor pro osm léčby',
            resort4Alt: 'Jídelní prostor s přirozeným světlem',
            resort5Alt: 'Relaxační výhled na bazén',
            sunsetLabel: 'Každodenní mistrovské dílo přírody',
            sunsetTitle: 'Večerní západ slunce',
            sunsetDesc1: 'Sledujte, jak se den elegantně vzdává soumraku, zatímco se obloha mění na plátno jantaru, purpury a zlata. Jemný Indický oceán odráží tuto nebeskou podívanou, což vytváří podmanivou symfonii světel a vody.',
            sunsetDesc2: 'Každý večer v Muthumuni nabízí místa v první řadě jednoho z nejúchvatných přírodnatých p',
            sunsetFeature1: 'Nerušené mořské vidiny z každé rohu',
            sunsetFeature2: 'Meditace klidu při západu slunce',
            sunsetFeature3: 'Bezplatný bylinný čaj podávaný denně',
            sunsetFeature4: 'Fotogenické momenty každý večer',
            sunsetImageAlt: 'Večerní západ slunce u Muthumuni Beach Resort',
            bestTime: 'Nejlepší čas',
            sunsetTime: '18:00 - 18:45',
            poolLabel: 'Vodní klid',
            poolTitle: 'Bazénová oblast',
            poolDesc1: 'Ponořte se do klidu na naší nedotčené infinity bazénu, kde se křišťálově čistá voda setkávání s bujnou tropickou zahradou. Navržena pro relaxaci a mládí, naše bazénová oblast nabízí dokonalý únič k relaxování pod srílanským sluncem.',
            poolDesc2: 'Ať už preferujete osvěžující ranní plavání, posezení v odpoledni s dobrou knihou nebo pokojné večerní ponory, naše bazénová oblast poskytuje nádherné prostředí. Obklopeny pohodlnými lehátkami, stinnými kajutami a pozornými službami u bazénu, každý moment se stává vzácně vzpomínkou.',
            poolFeature1: 'Infinity bazén s kontrolou teploty',
            poolFeature2: 'Obklopen tropickými zahradní krajinavami',
            poolFeature3: 'Osvěžení a zdravé občerstvení u bazénu',
            poolFeature4: 'Premium lehátky s deštníky',
            poolImageAlt: 'Relaxační bazénová oblast v Muthumuni Resort',
            testimonialsTitle: 'Hosté během jejich pobytu'
        },
    },

    pl: {
        about: {
            heroTitle: 'O nas',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroBeachResort: 'Beach Resort',
            heroTagline1: 'Starożytna mądrość spotyka się nowoczesnym w Muthumuni Ayurveda Beach Resort',
            heroTagline2: 'Spersonalizowane zabiegi ajurwedyjskie, widoki na ocean i autentyczna gościnność Sri Lanki',
            slide1: 'Uzdrawianie ajurwedyjskie',
            slide2: 'Spokój na plaży',
            slide3: 'Spokój ogrodu',
            slide4: 'Terapie ziołowe',
            slide5: 'oceanu',
            historyLabel: 'Nasza podróż',
            historyTitle: 'Historia Muthumuni Ayurveda Beach Resort',
            historyDesc1: 'Muthumuni Ayurveda Beach Resort został założony ponad dwie dekady temu z wizją stworzenia świętego miejsca, gdzie starożytna mądrość ajurwedyjska spotyka się z spokojnym pięknem południowego wybrzezia Sri Lanki. To, co zaczęło się jako skromny ośrodek wellness, rozwinęło się w jedno z najbardziej cenionych miejsc Berawali dla całościowego uzdrowienia i odmłodzenia.',
            historyDesc2: 'Nasi założyciele, zainspirowani pokoleniami tradycyjnych praktyków ajurwedy, dążyli do zachowania tych wypróbowanych sztuk uzdrawiania, jednocześnie zapewniając nowoczesny komfort i autentyczną gościnność Sri Lanki. Przez lata pozostaliśmy wierny naszemu zobowiązaniu wobec autentycznych doświadczeń wellness, rozszerzając nasze obiekty, nigdy nie tracąc z oczu spersonalizowanej opieki definiującej nasze dziedzictwo.',
            historyDesc3: 'Dziś Muthumuni stoi jako świadectwo trwałej mocy ajurwedy, gościnnie przyjawszy tysiące gości z całego świata. Każdy odwiedzający staje się częścią naszej historii, znajdując równowagę, uzdrowienie i transformację w naszym przybrzeżnym schronieniu.',
            statYear: '15+',
            statYearLabel: 'Lat doskonałości wellness',
            statGuest: '1.000+',
            statGuestLabel: 'Szczęśliwych obsługiwanych gości',
            experienceLegacy: 'Doświadcz naszego dziedzictwa',
            established: 'Założono',
            since2010: 'Od 2010 roku',
            chairmanLabel: 'Wiadomość przewodniczącego',
            chairmanTitle: 'Poprowadzony opieką, zakorzeniony w Ayurveedzie',
            chairmanDesc1: 'Witamy w Muthumuni Ayurveda Beach Resort. Przez ponad dwie dekady naszą celą było proste: zapewniać autentyczne uzdrowienie zakorzenione w niezapamiętanej mądrości ajurwedy, dostarczanej z ciepłem gościnności Sri Lanki.',
            chairmanDesc2: 'Tu każdy szczegół — od naszych zabiegów i kuchni po spokój naszych przestrzeni — jest zaprojektowany, aby pomóc ci spowolnić, przywrócić równowagę i ponownie połączyć się ze sobą. Honorem dla nas jest być częścią twojej podróży wellness.',
            chairmanDesc3: 'W imieniu naszego oddanego zespołu zapraszam cię do doświadczenia opieki, autentyczności i spokoju, które definiują Muthumuni.',
            chairmanSignature: '— Mr. Nihal Muthumuni',
            chairmanBadge: 'Przewodniczący',
            chairmanName: 'Mr. Nihal Muthumuni',
            chairmanImageAlt: 'Przewodniczący Mr. Nihal Muthumuni',
            staffLabel: 'Nasz zespół',
            staffTitle: 'Poznaj nasz oddany personel',
            staffDesc1: 'W Muthumuni Ayurveda Beach Resort nasz zespół jest sercem wszystkiego, co robimy. Członkowie naszego personelu to starannie wybranie i wytrenowani profesjonaliści, którzy dzielą głęboką passion do ajurwedyjskiego i autentycznej gościnności.',
            staffDesc2: 'Od naszych doświadczonych praktyków ajurwedy i zdolnych terapeutów masażu po nasz oddany zespół gościnności, każdy członek wnosi lata doświadczenia i autentyczną opiekę do każdej interakcji z gośćmi. Wierzymy, że autentyczny pochodzi nie tylko z zabiegów, ale z ciepła i uwagi ludzi, którzy naprawdę dbają o twoją podróż.',
            staffDesc3: 'Nasz personel przechodzi ciągłe szkolenia w najnowszych praktykach ajurwedy, jednocześnie utrzymując najwyższe standardy profesjonalizmu i wrażliwości kulturowej. Jesteśmy dumni z tworzenia znaczących połączeń z naszymi gośćmi, zapewniając, że każda wizyta staje się niezapomnianym i transformacyjnym doświadczeniem.',
            statStaff: '15+',
            statStaffLabel: 'Wykwalikowani profesjonaliści',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Zadowolenie gości',
            staffImageAlt: 'Nasz oddany zespół personelu w Muthumuni Ayurveda Beach Resort',
            commitmentBadge: 'Nasze zobowiązanie',
            excellenceCare: 'Doskonałość i opieka',
            ctaLabel: 'Skontaktuj się',
            ctaHeading: 'Gotowy/a začą́ c swoją podróż wellness?',
            ctaDesc: 'Skontaktuj się z naszym zespołem, aby zarezerwować swój spersonalizowany ajurwedyjski retreat. Niezależnie od tego, czy masz pytania dotyczące naszych zabiegów, zakwaterowania lub specjalnych pakietów wellness, jesteśmy tu, aby pomóc ci stworzyć swoją doskonałą ucieczkę.',
            ctaButtonContact: 'Skontaktuj się z nami teraz',
            ctaButtonRooms: 'Eksploruj pokoje',
            contactUs: 'Skontaktuj się z nami',
            quickInfoCall: 'Zadzwoń do nas',
            quickInfoEmail: 'Wyślij nam e-mail',
            quickInfoLocation: 'Lokalizacja',
            locationCity: 'Beruwala, Sri Lanka'
        },
        rooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Twoje sanktuarium czeka',
            heroSubtitle: 'Nadrzeczne sanktuaria zaprojektowane do uzdrawiania, regeneracji i głębokiego spokoju wzdłuż spokojnej rzeki Bentota.',
            exploreRooms: 'Poznaj nasze pokoje',

            filterAll: 'Wszystkie',
            filterDeluxeRooms: 'Pokoje Deluxe',
            filterRiverViewDeluxe: 'Deluxe z widokiem na rzekę',

            deluxeRoomName: 'Pokój Deluxe',
            deluxeRoomCategory: 'Pokoje Deluxe',
            deluxeRoomDesc: 'Harmonijnie zrównoważony pokój z naturalnymi elementami drewnianymi i widokiem na rzekę dla idealnego spokoju.',

            riverViewDeluxeName: 'Deluxe z widokiem na rzekę',
            riverViewDeluxeCategory: 'Pokój Deluxe z widokiem na rzekę',
            riverViewDeluxeDesc: 'Budź się przy delikatnym szumie rzeki i ciesz się panoramicznym widokiem na brzeg w tym elegancko zaprojektowanym pokoju deluxe.',

            noRoomsFound: 'Nie znaleziono pokoi w tej kategorii.',
            roomSize: 'Powierzchnia pokoju',
            guests: 'Goście',
            amenitiesCount: 'Udogodnienia',
            roomAmenities: 'Udogodnienia pokoju',
            specialFeatures: 'Specjalne cechy',

            kingSizeBed: 'Łóżko King Size',
            workDesk: 'Biurko',
            rainShower: 'Prysznic deszczowy',
            teaStation: 'Stacja herbaciana',
            privateTerrace: 'Prywatny taras',
            binoculars: 'Lornetka',

            riverView: 'Widok na rzekę',
            naturalLighting: 'Naturalne oświetlenie',
            gardenView: 'Widok na ogród',
            sunriseBalcony: 'Balkon na wschód słońca',
            soundOfRiver: 'Dźwięk rzeki',

            bookNow: 'Zarezerwuj teraz',
            viewDetails: 'Zobacz szczegóły',
            viewRoom: 'Zobacz pokój',

            allRoomsInclude: 'Wszystkie pokoje zawierają',
            essentialComforts: 'Podstawowe udogodnienia dla Twojej podróży wellness',

            highSpeedWifi: 'Szybkie Wi-Fi',
            herbalTea: 'Wybór herbat ziołowych',
            climateControl: 'Klimatyzacja',
            organicToiletries: 'Organiczne kosmetyki',
            dailyHousekeeping: 'Codzienne sprzątanie',
            concierge: 'Concierge 24/7',
            yogaMat: 'Mata do jogi i akcesoria',

            beginHealing: 'Rozpocznij swoją podróż uzdrawiania',
            beginHealingDesc: 'Doświadcz autentycznego ajurwedyjskiego w spokojnym nadrzecznym otoczeniu zaprojektowanym, by karmić ciało, uspokoić umysł i odnowić ducha.',
            reserveRoom: 'Zarezerwuj pokój',
            speakAdvisor: 'Porozmawiaj z doradcą wellness',

            exploreOurRooms: 'Poznaj nasze pokoje'
        },
        home2: {
            heroTitle: 'Muthumuni Ayurveda River Resort',
            heroSubtitle: 'Ajurweda nad rzeką',
            heroTagline: 'Znajdź równowagę, oddychaj swobodnie i odzyskaj energię w Aluthgamie',
            exploreResort: 'Poznaj resort',
            bookNow: 'Zarezerwuj teraz',

            welcomeLabel: 'Witamy',
            welcomeTitle: 'Muthumuni Ayurveda River Resort',
            welcomeDesc1: 'Położony wzdłuż spokojnego brzegu rzeki Bentota, Muthumuni Ayurveda River Resort oferuje harmonijne połączenie starożytnych tradycji uzdrawiania z cichym pięknem natury. Nasze sanktuarium zaprasza Cię do rozpoczęcia transformacyjnej podróży wellness, w której delikatny nurt rzeki spotyka się z ponadczasową mądrością ajurwedy.',
            welcomeDesc2: 'Doświadcz spersonalizowanych terapii ajurwedyjskich, delektuj się odżywczą kuchnią dostosowaną do Twojego dosha i odpoczywaj w elegancko urządzonych pokojach z zapierającym dech w piersiach widokiem na rzekę. Niezależnie od tego, czy szukasz odmłodzenia, relaksu czy duchowego odnowienia – nasz oddany zespół praktyków ajurwedy i ekspertów będzie Ci towarzyszył na każdym kroku.',
            learnMore: 'Dowiedz się więcej',
            contactUs: 'Skontaktuj się z nami',
            welcomeImageCaption: 'Ajurwedyjski i nadrzeczny retreat',
            welcomeImageLocation: 'Aluthgama, Sri Lanka',

            highlightTitle: 'Ajurwedyjskie sanktuarium nad rzeką',
            highlightDesc: 'Odkryj holistyczne uzdrawianie wzdłuż spokojnego brzegu Bentoty. Od indywidualnych terapii, przez ciche balkony, po świadomą kuchnię – każdy detal został stworzony, by przywrócić Twój naturalny rytm.',

            roomsTitle: 'Nasze pokoje',
            roomsDesc: 'Wybierz sanktuarium, które pasuje do Twojego tempa – od przestronnych suit po przytulne deluxe kryjówki, każdy z miękką pościelą, ciepłym drewnem i balkonami gotowymi na wschód słońca.',
            room1Title: 'Pokoje Deluxe',
            room1Desc: 'Przytulne schronienia z luksusowymi łóżkami, widokiem na ogród i ciepłymi drewnianymi akcentami na codzienne odprężenie.',
            room2Title: 'Deluxe z widokiem na rzekę',
            room2Desc: 'Budź się z widokiem na spokojną rzekę, z miękką pościelą i prywatnym balkonem stworzonym na spokojne poranki.',
            viewRoom: 'Zobacz pokój',
            bookableNow: 'Możliwość rezerwacji teraz',
            riverBreezeReady: 'Gotowy na rzeczny powiew',
            roomBadge: 'Ucieczka nad rzeką',

            achievementsTitle: 'Godny zaufania nad rzeką',
            achievement1Title: 'Zadowoleni goście',
            achievement1Count: '1 000+',
            achievement2Title: 'Terapie ajurwedyjskie',
            achievement2Count: '20+',
            achievement3Title: 'Lata opieki',
            achievement3Count: '15+',
            achievement4Title: 'Uznanie podróżników',
            achievement4Count: '1 000+',

            experiencesTitle: 'Odkryj doświadczenia w Muthumuni Ayurveda River Resort',
            experiencesDesc: 'Od ajurwedyjskich podróży po starannie wybrane wycieczki – wybierz te doświadczenia, które uczynią Twój pobyt niezapomnianym.',
            planYourStay: 'Zaplanuj swój pobyt',
            experience1Title: 'Nasze pokoje',
            experience1Desc: 'Przestronne wnętrza z balkonami, widokiem na rzekę lub ogród i starannie przemyślanym komfortem na spokojny pobyt.',
            experience2Title: 'Spa ajurwedyjskie',
            experience2Desc: 'Autentyczne terapie, łaźnie parowe i regenerujące masaże wykonywane według pradawnych rytuałów.',
            experience3Title: 'Kolacja nad rzeką',
            experience3Desc: 'Odżywcza kuchnia sri-lankijska i międzynarodowa stworzona, by karmić ciało i umysł.',
            experience4Title: 'Doświadczenia i wycieczki',
            experience4Desc: 'Safari łodzią po rzece Bentota, wizyty w świątyniach, sporty wodne i kulturalne wycieczki wokół Bentoty.',

            galleryTitle: 'Chwile w Muthumuni Ayurveda River Resort',
            galleryDesc: 'Spojrzenie na nasze nadrzeczne sanktuarium – wschody słońca, spokojne terapie, odżywcze dania i ciche zakątki stworzone dla Ciebie.',
            gallery1Alt: 'Słoneczny brzeg rzeki z palmami w Muthumuni',
            gallery2Alt: 'Trwająca terapia olejowa ajurwedyjska',
            gallery3Alt: 'Basen resortu z leżakami',
            gallery4Alt: 'Ziołowe składniki przygotowane do spa',
            gallery5Alt: 'Para ciesząca się zachodem słońca nad rzeką',
            gallery6Alt: 'Platforma jogowa z widokiem na rzekę',
            gallery7Alt: 'Ścieżka w tropikalnym ogrodzie',
            gallery8Alt: 'Zdrowe śniadanie',
            gallery9Alt: 'Spokojny widok na rzekę',
            gallery10Alt: 'Ciepło oświetlony exterior resortu o zmierzchu',
            gallery11Alt: 'Ekspozycja ajurwedyjskich ziół i olejów',
            gallery12Alt: 'Przytulny kącik wypoczynkowy przy ogrodzie',

            boatLabel: 'Przygody na rzece',
            boatTitle: 'Rejsy łodzią po rzece Bentota',
            boatDesc1: 'Doświadcz magii rzeki Bentota podczas naszych uroczych rejsów łodzią. Sun po spokojnych wodnych szlakach otoczonych bujnymi lasami namorzynowymi, obserwując egzotyczną faunę – kolorowe zimorodki, krokodyle, warany i figlarne małpy. Idealne dla miłośników przyrody i fotografów poszukujących niezapomnianych chwil.',
            boatDesc2: 'Niezależnie od tego, czy wybierzesz spokojny poranny rejs, romantyczną podróż o zachodzie słońca czy przygodowe odkrywanie dzikiej przyrody – nasi doświadczeni przewodnicy podzielą się fascynującymi informacjami o ekosystemie rzeki. Dostosuj swoje doświadczenie dzięki prywatnym czarterom lub dołącz do grupowych wycieczek, aby jeszcze głębiej połączyć się z naturą.',
            boatFeature1: 'Malownicze rejsy rzeką przez namorzyny',
            boatFeature2: 'Obserwacja dzikiej fauny – ptaki, krokodyle i małpy',
            boatFeature3: 'Opcje rejsów o wschodzie i zachodzie słońca',
            boatFeature4: 'Doświadczeni lokalni przewodnicy w cenie',
            boatImageAlt: 'Rejs łodzią po rzece Bentota',

            poolLabel: 'Wodna cisza',
            poolTitle: 'Strefa basenowa',
            poolDesc1: 'Zanurz się w spokoju naszego krystalicznie czystego basenu bez krawędzi, gdzie przejrzysta woda spotyka się z bujnymi tropikalnymi ogrodami. Strefa basenowa została zaprojektowana z myślą o relaksie i regeneracji i oferuje idealną ucieczkę do odpoczynku pod słońcem Sri Lanki.',
            poolDesc2: 'Niezależnie od tego, czy wolisz orzeźwiającą poranną kąpiel, leniwy popołudniowy relaks z dobrą książką czy spokojną wieczorną kąpiel – nasza strefa basenowa oferuje idylliczną scenerię. Otoczona wygodnymi leżakami, zacienionymi altanami i uważną obsługą przy basenie, każda chwila staje się cennym wspomnieniem.',
            poolFeature1: 'Basen bez krawędzi z regulowaną temperaturą',
            poolFeature2: 'Otoczony tropikalnym ogrodem',
            poolFeature3: 'Napoje i zdrowe przekąski przy basenie',
            poolFeature4: 'Premium leżaki z parasolami',
            poolImageAlt: 'Relaksująca strefa basenowa',

            testimonialsTitle: 'Opinie gości o ich pobycie',

            bookingDestination: 'Destynacja',
            bookingDestinationPlaceholder: 'Muthumuni Ayurveda River Resort',
            bookingDestinationDefault: 'Muthumuni Ayurveda River Resort',
            bookingCheckIn: 'Zameldowanie',
            bookingCheckOut: 'Wymeldowanie',
            bookingGuests: 'Goście',
            guestsOption1: '1 gość',
            guestsOption2: '2 gości',
            guestsOption3: '3 gości',
            guestsOption4: '4+ gości',
            bookingCheckAvailability: 'Sprawdź dostępność',

            service1Title: 'Holistyczne terapie ajurwedyjskie',
            service1Desc: 'Spersonalizowane konsultacje, autentyczne olejki ziołowe i codzienne zabiegi prowadzone przez doświadczonych lekarzy ajurwedy.',

            service2Title: 'Pokoje nad rzeką',
            service2Desc: 'Budź się przy delikatnym szumie rzeki, z prywatnymi balkonami i uspokajającymi wnętrzami zaprojektowanymi do głębokiego wypoczynku.',

            service3Title: 'Kuchnia wellness',
            service3Desc: 'Świeże produkty ze Sri Lanki, menu oparte na roślinach i indywidualne plany posiłków dopasowane do Twojego dosha.',

            service4Title: 'Joga i uważność',
            service4Desc: 'Joga o wschodzie słońca, medytacja o zachodzie słońca i sesje oddechowe w rytmie fal.',

            service5Title: 'Wycieczki nadrzeczne i nadmorskie',
            service5Desc: 'Rejsy łodzią po rzece Bentota, wizyty w ośrodku żółwi, spacery po ogrodach przypraw i wycieczki rowerowe po wioskach.'
        },
        aboutus2: {
            heroTitle: 'O nas',
            heroSubtitle: 'Muthumuni Ayurveda',
            heroRiverResort: 'River Resort',
            heroTagline1: 'Starożytna mądrość spotyka spokojne piękno nadrzeczne w Muthumuni Ayurveda River Resort',
            heroTagline2: 'Spersonalizowane terapie ajurwedyjskie, widoki na rzekę i prawdziwa gościnność ze Sri Lanki',
            slide1: 'Ajurwedyjskie uzdrawianie',
            slide2: 'Spokój nad rzeką',
            slide3: 'Spokój ogrodu',
            slide4: 'Terapie ziołowe',
            slide5: 'Rzeczny wellness',
            historyLabel: 'Nasza podróż',
            historyTitle: 'Historia Muthumuni Ayurveda River Resort',
            historyDesc1: 'Założony ponad dwie dekady temu Muthumuni Ayurveda River Resort powstał z wizji stworzenia sanktuarium, w którym starożytna mądrość ajurwedy spotyka spokojne piękno nadrzecznych krajobrazów Sri Lanki. Z skromnego ośrodka rozkwitł w jedno z najbardziej cenionych miejsc w Aluthgamie dla holistycznego uzdrawiania i odmładzania.',
            historyDesc2: 'Nasi założyciele, zainspirowani pokoleniami tradycyjnych praktyków ajurwedyjskich, chcieli zachować te ponadczasowe sztuki uzdrawiania, oferując jednocześnie nowoczesny komfort i autentyczną gościnność ze Sri Lanki. Przez lata pozostawaliśmy wierni zobowiązaniu do autentycznych doświadczeń wellness, rozbudowując obiekty, nigdy nie tracąc z oczu indywidualnej opieki, która definiuje nasze dziedzictwo.',
            historyDesc3: 'Dziś Muthumuni jest świadectwem trwałej siły ajurwedy i powitało tysiące gości z całego świata. Każdy odwiedzający staje się częścią naszej historii, odnajdując równowagę, uzdrowienie i przemianę w naszym spokojnym raju nad rzeką.',
            statYear: '15+',
            statYearLabel: 'Lat doskonałości w wellness',
            statGuest: '1 000+',
            statGuestLabel: 'Zadowolonych gości',
            experienceLegacy: 'Poznaj nasze dziedzictwo',
            established: 'Założony',
            sinceYear: 'Od 2010 roku',
            chairmanLabel: 'Przesłanie prezesa',
            chairmanTitle: 'Prowadzeni troską, zakorzenieni w ajurwedzie',
            chairmanDesc1: 'Witamy w Muthumuni Ayurveda River Resort. Od ponad dwóch dekad naszym celem jest proste: oferować autentyczne uzdrowienie oparte na ponadczasowej mądrości ajurwedy, przekazywane z ciepłem gościnności ze Sri Lanki.',
            chairmanDesc2: 'Tutaj każdy szczegół — od terapii po kuchnię i spokój naszych przestrzeni — został zaprojektowany, by pomóc Ci zwolnić, odzyskać równowagę i ponownie połączyć się z sobą. Jesteśmy zaszczyceni, że możemy być częścią Twojej podróży wellness.',
            chairmanDesc3: 'W imieniu naszego oddanego zespołu zapraszam Cię do doświadczenia troski, autentyczności i spokoju, które definiują Muthumuni.',
            chairmanBadge: 'Prezes',
            chairmanName: 'Pan Nihal Muthumuni',
            chairmanSignature: '— Pan Nihal Muthumuni',
            chairmanImageAlt: 'Prezes Pan Nihal Muthumuni',
            staffLabel: 'Nasz zespół',
            staffTitle: 'Poznaj nasz oddany personel',
            staffDesc1: 'W Muthumuni Ayurveda River Resort nasz zespół jest sercem wszystkiego, co robimy. Nasi pracownicy to starannie wyselekcjonowani i wyszkoleni profesjonaliści, którzy dzielą głęboką pasję do ajurwedyjskiego i autentycznej gościnności.',
            staffDesc2: 'Od doświadczonych praktyków ajurwedyjskich i wykwalifikowanych masażystów po nasz oddany zespół gościnności – każdy członek wnosi lata doświadczenia i prawdziwą troskę do każdej interakcji z gośćmi. Wierzymy, że prawdziwe nie pochodzi tylko z zabiegów, lecz z ciepła i uwagi ludzi, którym naprawdę zależy na Twojej podróży.',
            staffDesc3: 'Nasz personel regularnie przechodzi szkolenia z najnowszych praktyk ajurwedyjskich, zachowując przy tym najwyższe standardy profesjonalizmu i wrażliwości kulturowej. Jesteśmy dumni, że budujemy znaczące więzi z gośćmi, zapewniając, że każda wizyta staje się niezapomnianym i transformującym doświadczeniem.',
            statStaff: '20+',
            statStaffLabel: 'Wykwalifikowani profesjonaliści',
            statSatisfaction: '100%',
            statSatisfactionLabel: 'Zadowolenie gości',
            staffImageAlt: 'Nasz oddany zespół w Muthumuni Ayurveda River Resort',
            commitmentBadge: 'Nasze zobowiązanie',
            excellenceCare: 'Doskonałość i troska',
            ctaLabel: 'Skontaktuj się z nami',
            ctaHeading: 'Gotowy rozpocząć swoją podróż wellness?',
            ctaDesc: 'Skontaktuj się z naszym zespołem, aby zarezerwować spersonalizowany ajurwedyjski pobyt. Niezależnie od pytań dotyczących terapii, zakwaterowania czy specjalnych pakietów – chętnie pomożemy stworzyć Twoją idealną ucieczkę.',
            ctaButtonContact: 'Skontaktuj się teraz',
            ctaButtonRooms: 'Odkryj pokoje',
            quickInfoCall: 'Zadzwoń do nas',
            quickInfoEmail: 'Napisz do nas',
            quickInfoLocation: 'Lokalizacja',
            locationCity: 'Aluthgama, Sri Lanka'
        },
        ayurveda2: {
            accordionTitle1: 'Czym jest Panchakarma Ayurveda?',
            accordionDesc1: 'Ayurveda (sanskryckie słowo oznaczające „nauka o życiu”) to starożytny system holistycznego uzdrawiania. Panchakarma to zestaw oczyszczających i odmładzających terapii mających na celu przywrócenie równowagi między umysłem, ciałem i duchem.',
            accordionTitle2: 'Panchakarma Ayurveda i Twoja energia życiowa',
            accordionDesc2: 'Panchakarma koncentruje się na usuwaniu toksyn i ponownym ustanowieniu harmonii między doshami (Vata, Pitta, Kapha). Zabiegi są indywidualnie dostosowywane do każdego gościa, aby wspierać długotrwałe zdrowie i witalność.',
            accordionTitle3: 'Dosha Vata',
            accordionDesc3: 'Vata odpowiada za ruch i krążenie. W równowadze sprzyja kreatywności i witalności. Panchakarma oferuje uziemiające terapie, które łagodzą nadmiar Vaty i przywracają równowagę.',
            accordionTitle4: 'Dosha Pitta',
            accordionDesc4: 'Pitta odpowiada za trawienie i metabolizm. Chłodzące i regenerujące terapie pomagają zrównoważyć Pittę oraz zmniejszyć stany zapalne i rozdrażnienie.',
            accordionTitle5: 'Dosha Kapha',
            accordionDesc5: 'Kapha zapewnia strukturę i stabilność. Energetyzujące i poprawiające krążenie terapie stosuje się w celu zmniejszenia nadmiaru Kaphy oraz promowania lekkości i elastyczności.',
            close: 'Zamknij',
            next: 'Dalej',
            previous: 'Wstecz',
            treatmentsTitle: 'Nasze flagowe zabiegi Panchakarma Ayurveda',
            treatmentsSubtitle: 'Tradycyjne terapie oczyszczające, odmładzające i przywracające równowagę.',
            bookTreatment: 'Zarezerwuj ten zabieg',
            benefitsTitle: 'Korzyści zabiegów Panchakarma',
            shirodhara: 'Shirodhara',
            shirodharaDesc: 'Delikatne polewanie ciepłym olejkiem ziołowym czoła w celu uspokojenia umysłu.',
            shirodhara1: 'Zmniejsza stres i lęk',
            shirodhara2: 'Poprawia jakość snu',
            shirodhara3: 'Zwiększa jasność umysłu',
            steamBath: 'Kąpiel parowa',
            steamBathDesc: 'Detoksykacyjna kąpiel parowa otwierająca pory i rozluźniająca mięśnie.',
            steamBath1: 'Oczyszcza organizm',
            steamBath2: 'Poprawia krążenie',
            steamBath3: 'Łagodzi napięcie mięśniowe',
            flowerBath: 'Kąpiel kwiatowa',
            flowerBathDesc: 'Relaksująca kąpiel z aromatycznymi kwiatami dla odprężenia.',
            flowerBath1: 'Uspokaja układ nerwowy',
            flowerBath2: 'Nawilża skórę',
            flowerBath3: 'Poprawia nastrój',
            headMassage: 'Masáž głowy',
            headMassageDesc: 'Relaksujący masaż głowy łagodzący napięcie.',
            headMassage1: 'Zmniejsza bóle głowy',
            headMassage2: 'Poprawia kondycję skóry głowy',
            headMassage3: 'Sprzyja relaksowi',
            faceMassage: 'Masáž twarzy',
            faceMassageDesc: 'Odmładzający masaż twarzy poprawiający blask cery i redukujący stres.',
            faceMassage1: 'Poprawia koloryt skóry',
            faceMassage2: 'Zmniejsza napięcie twarzy',
            faceMassage3: 'Wspiera drenaż limfatyczny',
            neckMassage: 'Masáž karku',
            neckMassageDesc: 'Skierowany masaż łagodzący sztywność i napięcie karku.',
            neckMassage1: 'Łagodzi ból karku',
            neckMassage2: 'Poprawia ruchomość',
            neckMassage3: 'Redukuje stres',
            shoulderMassage: 'Masáž barków',
            shoulderMassageDesc: 'Celowany masaż łagodzący sztywność i dyskomfort barków.',
            shoulderMassage1: 'Zmniejsza ból barków',
            shoulderMassage2: 'Poprawia postawę',
            shoulderMassage3: 'Rozluźnia mięśnie',
            bodyMassage: 'Masáž ciała',
            bodyMassageDesc: 'Pełny masaż ciała wspierający ogólny relaks i zdrowie.',
            bodyMassage1: 'Poprawia krążenie',
            bodyMassage2: 'Łagodzi bóle mięśniowe',
            bodyMassage3: 'Sprzyja relaksowi',
            backMassage: 'Masáž pleców',
            backMassageDesc: 'Terapeutyczny masaż przeciw bólowi i napięciu pleców.',
            backMassage1: 'Łagodzi ból pleców',
            backMassage2: 'Poprawia zdrowie kręgosłupa',
            backMassage3: 'Redukuje stres',
            footMassage: 'Masáž stóp',
            footMassageDesc: 'Relaksujący masaż stóp łagodzący ból i sprzyjający odprężeniu.',
            footMassage1: 'Poprawia krążenie',
            footMassage2: 'Zmniejsza zmęczenie stóp',
            footMassage3: 'Sprzyja relaksowi',
            purgative: 'Środek oczyszczający',
            purgativeDesc: 'Terapia oczyszczająca usuwająca nadmiar Pitty i toksyny z układu pokarmowego.',
            purgative1: 'Oczyszcza jelito grube',
            purgative2: 'Równoważy doszę Pitta',
            purgative3: 'Poprawia zdrowie układu trawiennego',
            nasalClearing: 'Oczyszczanie nosa',
            nasalClearingDesc: 'Terapeutyczne oczyszczanie nosa dla udrożnienia zatok i poprawy oddychania.',
            nasalClearing1: 'Udrażnia nos',
            nasalClearing2: 'Poprawia oddychanie',
            nasalClearing3: 'Łagodzi problemy z zatokami',
            powderMassage: 'Masáž proszkiem',
            powderMassageDesc: 'Peelingujący masaż z proszkami ziołowymi dla odnowy i odświeżenia skóry.',
            powderMassage1: 'Usuwa martwy naskórek',
            powderMassage2: 'Poprawia teksturę skóry',
            powderMassage3: 'Stymuluje krążenie',
            intensiveMassageDesc: 'Głęboki masaż terapeutyczny ukierunkowany na przewlekłe napięcia i węzły mięśniowe z mocnym naciskiem i specjalistycznymi technikami.',
            intensiveMassage1: 'Rozluźnia głębokie napięcie mięśniowe',
            intensiveMassage2: 'Poprawia krążenie krwi',
            intensiveMassage3: 'Zmniejsza ból mięśni',
            thermoMassage: 'Masaż Termiczny',
            thermoMassageDesc: 'Ciepły masaż olejem ziołowym z podgrzewanymi olejami terapeutycznymi, wzmacniający relaks i efekty lecznicze.',
            thermoMassage1: 'Łagodzi obolałe mięśnie',
            thermoMassage2: 'Promuje głęboki relaks',
            thermoMassage3: 'Poprawia przepływ energii',
            synchronMassage: 'Masaż Synchronizowany',
            synchronMassageDesc: 'Zsynchronizowany masaż wykonywany przez dwóch terapeutów dla pełnej harmonii ciała i zrównoważonego rozkładu energii.',
            synchronMassage1: 'Pełna harmonia ciała',
            synchronMassage2: 'Zrównoważony przepływ energii',
            synchronMassage3: 'Głębokie doświadczenie relaksu',
            specialMassage: 'Masaż Specjalny',
            specialMassageDesc: 'Spersonalizowana terapia masażem dostosowana do Twoich konkretnych potrzeb zdrowotnych i osobistych celów wellness.',
            specialMassage1: 'Spersonalizowane leczenie',
            specialMassage2: 'Skierowany na konkretne problemy',
            specialMassage3: 'Indywidualne podejście lecznicze',
            benefit1Title: 'Detoksykacja:',
            benefit1Desc: 'Zabiegi Panchakarma pomagają usuwać toksyny z organizmu, wspierając ogólne zdrowie i witalność.',
            benefit2Title: 'Poprawa trawienia:',
            benefit2Desc: 'Terapie wzmacniają funkcje trawienne, co prowadzi do lepszego wchłaniania składników odżywczych i metabolizmu.',
            benefit3Title: 'Redukcja stresu:',
            benefit3Desc: 'Panchakarma słynie z działania uspokajającego na umysł i ciało, zmniejszając poziom stresu i lęku.',
            benefit4Title: 'Wzmocnienie odporności:',
            benefit4Desc: 'Regularne zabiegi Panchakarma mogą wzmocnić układ odpornościowy, czyniąc organizm bardziej odpornym na choroby.',
            benefit5Title: 'Odmłodzenie:',
            benefit5Desc: 'Terapie wspierają regenerację komórkową, poprawiając kondycję skóry i wygląd młodości.',
            benefit6Title: 'Równowaga dosh:',
            benefit6Desc: 'Panchakarma pomaga przywrócić równowagę dosh ciała (Vata, Pitta, Kapha), co jest kluczowe dla utrzymania zdrowia według zasad ajurwedy.',
            gallery1: 'Terapia Shirodhara',
            gallery2: 'Kąpiel parowa',
            gallery3: 'Kąpiel kwiatowa',
            gallery4: 'Masáž głowy',
            gallery5: 'Masáž ciała',
            gallery6: 'Masáž karku',
            gallery7: 'Masáž twarzy',
            gallery8: 'Masáž barków',
            sectionEyebrow: 'Panchakarma Ayurveda w Muthumuni',
            sectionDescription: 'Poznaj starożytną sztukę uzdrawiania Panchakarma Ayurveda w naszym ustroniu nad rzeką. Nasi doświadczeni praktycy ajurwedy oferują spersonalizowane terapie mające na celu detoksykację, odmłodzenie i przywrócenie równowagi ciała, umysłu i ducha.',
            heroTitle: 'Panchakarma Ayurveda',
            heroSubtitle: 'Odmładzanie ciała, umysłu i ducha w Aluthgamie',
            heroAlt: 'Ayurveda i w Muthumuni River Resort'
        },
        yoga2: {
            heroTitle: 'Joga w Resort',
            heroSubtitle: 'Znajdź równowagę, siłę i wewnętrzny spokój w Beruwali',
            heroAlt: 'Joga w Muthumuni Resort',
            importanceEyebrow: 'Zdrowie i równowaga',
            importanceTitle: 'Znaczenie jogi i medytacji',
            importanceImageAlt: 'Znaczenie jogi i medytacji',
            importanceText1: 'Joga i medytacja to starożytne praktyki, które przynoszą liczne korzyści fizyczne, psychiczne i emocjonalne. Wspierają elastyczność, siłę i równowagę, jednocześnie zmniejszając stres i niepokój.',
            importanceText2: 'Regularna praktyka poprawia koncentrację, jakość snu i ogólne samopoczucie. Joga zachęca także do uważności, pomagając ludziom połączyć się z wewnętrznym „ja” i odnaleźć spokój pośród codziennego chaosu.',
            importanceText3: 'W Muthumuni Resort oferujemy spokojne otoczenie idealnie nadające się do praktykowania jogi i medytacji, dzięki czemu goście mogą zregenerować ciało, umysł i duszę.',
            practiceEyebrow: 'Nasza praktyka',
            practiceTitle: 'Praktyka i doświadczenie jogi',
            practiceImageAlt: 'Praktyka jogi w resort',
            practiceText1: 'W Muthumuni Resort praktykujemy głównie tradycyjną hatha jogę w połączeniu z pranajamą (technikami oddechowymi). To holistyczne podejście ma na celu obudzenie wewnętrznej świadomości, delikatną stymulację kundalini z naciskiem na wyrównanie kręgosłupa i elastyczność.',
            practiceText2: 'Zajęcia jogi odbywają się regularnie i są odpowiednie zarówno dla początkujących, jak i zaawansowanych. Od czasu do czasu wprowadzamy specjalne sesje, np. ashtanga jogę.',
            practiceText3: 'Wszystkie zajęcia odbywają się w naszej dedykowanej sali jogi – spokojnej i harmonijnej przestrzeni stworzonej z myślą o koncentracji, równowadze i świadomym ruchu. Każda sesja zazwyczaj zaczyna się od powitań słońca, następnie przechodzi w pranajamę i starannie dobraną sekwencję asan poprawiających elastyczność i krążenie.',
            practiceText4: 'Nasi doświadczeni nauczyciele jogi dostosowują każdą sesję do indywidualnych potrzeb, możliwości i stanu zdrowia gości, zapewniając bezpieczne i głęboko korzystne doświadczenie.',
            spiritualEyebrow: 'Podróż duchowa',
            spiritualTitle: 'Medytacja i aktywności duchowe',
            spiritualSubtitle: 'Pogłębiaj swoją duchową praktykę dzięki naszym świętym ceremoniom i prowadzonej medytacji',
            meditationImageAlt: 'Medytacja i praktyka duchowa w resort',
            meditationTitle: 'Sesje medytacyjne',
            meditationDesc: 'Goście są zapraszani do udziału w prowadzonych sesjach medytacyjnych inspirowanych tradycyjnymi praktykami. Sesje te pomagają wyciszyć umysł, pogłębić świadomość i wspierać emocjonalne oraz duchowe uzdrowienie w spokojnej atmosferze.'
        },
        food2: {
            heroTitle: 'Kuchnia ajurwedyjska i nadmorska',
            heroSubtitle: 'Autentyczne smaki Sri Lanki i świeża kuchnia nadmorska',
            heroAlt: 'Doświadczenie kulinarne w Muthumuni Beach Resort',
            wellnessEyebrow: 'Zdrowie przez jedzenie',
            wellnessTitle: 'Znaczenie',
            ayurvedicFood: 'Żywienia ajurwedyjskiego',
            wellnessIntro1: 'W ajurwedzie jedzenie uznawane jest za największe lekarstwo. To, co jesz, bezpośrednio wpływa na Twoje dosze (Vata, Pitta, Kapha), trawienie (agni) oraz ogólną równowagę ciała, umysłu i ducha.',
            wellnessIntro2: 'Ajurwedyjskie żywienie kładzie nacisk na świeże, sezonowe, nieprzetworzone produkty, przygotowywane z troską i spożywane w pełni świadomie. Każdy posiłek zawiera sześć smaków (słodki, kwaśny, słony, ostry, gorzki, ściągający), aby odżywiać wszystkie zmysły i zachować harmonię.',
            wellnessIntro3: 'Prawidłowe ajurwedyjskie odżywianie wzmacnia trawienie, pomaga usuwać toksyny (ama), zwiększa odporność, energię, zmniejsza stres i zapobiega wielu chorobom przewlekłym. W Muthumuni każde danie jest przygotowywane zgodnie z Twoją indywidualną konstytucją, aby wspierać głębokie uzdrowienie i witalność.',
            foodImage1Alt: 'Tradycyjny posiłek ajurwedyjski z sześcioma smakami',
            foodImage2Alt: 'Ajurwedyjskie zioła i przyprawy dla zrównoważonego odżywiania',
            culinaryPhilosophyEyebrow: 'Nasza filozofia kulinarna',
            culinaryPhilosophyTitle: 'Ajurwedyjskie',
            nutritionHighlight: 'odżywianie',
            culinaryPhilosophyResort: 'w Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Kuchnia ajurwedyjska w Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Świeże i odżywcze',
            healingIngredientsAlt: 'Zdrowe ajurwedyjskie składniki i przyprawy',
            healingIngredientsLabel: 'Lecznicze składniki',
            philosophyText1: 'Żywność, obejmująca sześć głównych smaków (słodki, kwaśny, słony, gorzki, ostry, ściągający) oraz wiele subtelnych wariacji, została opisana w klasycznych tekstach ajurwedyjskich – niektóre sięgają ponad 5000 lat wstecz – wraz z podstawowymi właściwościami każdego produktu: Guna (wrodzona jakość), Virya (moc – ogrzewająca lub chłodząca), Vipaka (wpływ po strawieniu) i Prabhava (unikalne szczególne działanie).',
            philosophyText2: 'Dlatego ajurwedyjskie odżywianie odgrywa centralną rolę w Muthumuni Ayurveda Beach Resort. Nie oznacza to jednak sztywnego, monotonnego reżimu mdłych, bez smaku lub nadmiernie gorzkich wegetariańskich dań narzucanych wyłącznie przez lekarzy. Wręcz przeciwnie – nasza kuchnia ajurwedyjska jest jedną z naszych największych zalet: dania przygotowywane przez naszych utalentowanych kucharzy będą Cię zaskakiwać i zachwycać każdego dnia pobytu!',
            philosophyText3: 'Na śniadanie bogaty bufet ze świeżymi owocami tropikalnymi, świeżo wyciskanymi sokami, pożywnymi zupami ziołowymi, domowym pieczywem i lekkimi ciasteczkami oraz różnorodnymi autentycznymi opcjami śniadaniowymi ze Sri Lanki. Na obiad kolorowy i smaczny bufet z delikatnymi curry rybnymi, daniami warzywnymi i potrawami z dodatkiem ziół. Wieczorem podajemy stałe menu wegetariańskie z opcją świeżej ryby. W soboty świętujemy „Sri Lankan Night” z rozszerzonym bufetem – nasi szefowie kuchni przygotowują tradycyjne lokalne specjały na Twoich oczach, tworząc żywe i autentyczne przeżycie.',
            philosophyText4: 'W ajurwedzie żywność i napoje są klasyfikowane na wiele sposobów – według smaku i właściwości, zdolności trawiennych (agni), przydatności do konkretnych stanów zdrowia, sezonowości itp. W Muthumuni uwzględniamy wszystkie te czynniki jednocześnie i świadomie staramy się włączać wszystkie sześć smaków w zrównoważonych kombinacjach dostosowanych do indywidualnej konstytucji każdego gościa.',
            philosophyText5: 'Nasze posiłki zawierają świeże warzywa, owoce tropikalne i odpowiedzialnie pozyskiwaną rybę. Nie podajemy czerwonego mięsa ani alkoholu.',
            philosophyText6: 'Podczas posiłków zawsze obecny jest lekarz ajurwedyjski lub wykwalifikowany dietetyk, gotowy Cię poprowadzić. Doradzą najbardziej odpowiednie warzywa, zioła i przyprawy dla obecnej fazy leczenia i pomogą wybrać lub unikać określonych dań. Twój indywidualny eliksir ziołowy oraz wszelkie specjalne zalecenia zespołu centrum zdrowia zostaną umieszczone na Twoim stole.',
            philosophyText7: 'Ten poziom spersonalizowanej opieki i uwagi poświęconej diecie jest znakiem rozpoznawczym doświadczenia w Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Jedzenie uważane jest za Pranę – życiodajną energię podtrzymującą życie każdego człowieka. Dlatego zachęcamy Cię, abyś podchodził do każdego posiłku z pełną świadomością: delektował się aromatami, przeżywał smaki, czuł delikatne ciepło i w pełni świadomie cieszył się doznaniami smakowymi.',
            diningExperienceEyebrow: 'Doświadczenie kulinarne',
            restaurantTitlePrefix: 'Nasza',
            ayurvedicHighlight: 'Ajurwedyjska',
            restaurantTitleSuffix: 'restauracja',
            restaurantDetail1: 'Nasza ajurwedyjska restauracja w Muthumuni Beach Resort oferuje wyjątkowe doświadczenie kulinarne, które harmonijnie łączy tradycyjne zasady ajurwedy z autentyczną nadmorską kuchnią Sri Lanki. Stawiamy na świeże, lokalne składniki, aby tworzyć dania, które nie tylko cieszą podniebienie, ale także wspierają holistyczne zdrowie.',
            restaurantDetail2: 'Menu jest starannie zaprojektowane, aby w każdym daniu zrównoważyć sześć smaków (słodki, kwaśny, słony, gorzki, ostry, ściągający), zapewniając pożywne i satysfakcjonujące doznania. Każde danie jest przygotowywane z troską, z wykorzystaniem ajurwedyjskich ziół i przypraw znanych ze swoich właściwości leczniczych.',
            restaurantDetail3: 'Goście mogą delektować się różnorodnymi daniami dostosowanymi do ich indywidualnych dosh (konstytucji ciała), z opcjami wegetariańskimi, wegańskimi i pescetariańskimi. Nasi kucharze ściśle współpracują z praktykami ajurwedyjskimi, aby każdy posiłek wspierał cele zdrowotne i gości.',
            restaurantDetail4: 'Atmosfera restauracji odzwierciedla spokojne nadmorskie otoczenie, tworząc cichą przestrzeń do świadomego jedzenia. Niezależnie od tego, czy delektujesz się obfitym bufetem śniadaniowym, czy wykwintną kolacją – każdy posiłek w naszej ajurwedyjskiej restauracji to okazja do odżywienia ciała i duszy.',
            restaurantDetail5: 'Dołącz do nas w ajurwedyjskiej restauracji Muthumuni Beach Resort na kulinarną podróż, która celebruje bogate smaki Sri Lanki i obejmuje ponadczasową mądrość ajurwedy.',
            restaurantImageAlt: 'Posiłek w Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Premium Dining',
            premiumDiningDescription: 'Doświadcz autentycznej kuchni ajurwedyjskiej w spokojnej scenerii nad rzeką'
        },
        events2: {
            heroEyebrow: 'Doświadczenia i aktywności',
            heroTitle: 'Nasze wydarzenia',
            heroSubtitle: 'Starannie wyselekcjonowane przeżycia łączące tradycję Sri Lanki z nadmorskim luksusem',
            heroAlt: 'Wydarzenia w Muthumuni',
            availableDaily: 'Dostępne codziennie',
            bookNow: 'Zarezerwuj teraz',
            highlightsTitle: 'Najważniejsze atrakcje',
            detailAlt: 'Szczegóły {{title}}',
            ctaTitle: 'Gotowy tworzyć wspomnienia?',
            ctaDescription: 'Skontaktuj się z naszym zespołem, aby stworzyć idealne, spersonalizowane doświadczenie wydarzenia w Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Skontaktuj się z nami',
            ctaViewRooms: 'Zobacz pokoje',
            cookeryTitle: 'Programy kulinarne',
            cookerySubtitle: 'Smaki Sri Lanki',
            cookeryDescription: 'Zanurz się w żywych smakach kuchni sri lankijskiej. Nasi doświadczeni szefowie kuchni poprowadzą Cię przez praktyczne warsztaty, ucząc tradycyjnych przepisów przekazywanych z pokolenia na pokolenie. Naucz się przygotowywać aromatyczne curry, hoppery, kokosowy sambol i wiele innych dań z wykorzystaniem świeżych lokalnych składników.',
            cookeryHighlight1: 'Tradycyjne przepisy ze Sri Lanki',
            cookeryHighlight2: 'Praktyczne doświadczenie gotowania',
            cookeryHighlight3: 'Świeże lokalne składniki',
            cookeryHighlight4: 'Przepisy do zabrania do domu',
            cookeryHighlight5: 'Wycieczka po ogrodzie przypraw w cenie',
            meditationTitle: 'Programy medytacyjne',
            meditationSubtitle: 'Wewnętrzny spokój i uważność',
            meditationDescription: 'Odnajdź spokój podczas naszych prowadzonych sesji medytacyjnych z widokiem na spokojny Ocean Indyjski. Doświadczeni instruktorzy wprowadzą Cię w starożytne techniki uważności, ćwiczenia oddechowe i praktyki jogi, które wyciszają umysł i odnawiają ducha.',
            meditationHighlight1: 'Sesje o wschodzie i zachodzie słońca',
            meditationHighlight2: 'Medytacja na plaży',
            meditationHighlight3: 'Prowadzone przez ekspertów',
            meditationHighlight4: 'Techniki oddechowe',
            meditationHighlight5: 'Joga i praktyki uważności',
            bbqTitle: 'Imprezy BBQ',
            bbqSubtitle: 'Świąteczne wieczory na plaży',
            bbqDescription: 'Przeżyj niezapomniane wieczory na naszych plażowych imprezach BBQ. Smakuj świeżo grillowane owoce morza, wyśmienite mięsa i wegetariańskie przysmaki przy szumie fal. Muzyka na żywo, tancerze z ogniem i rozgwieżdżone niebo tworzą idealną atmosferę do świętowania i nawiązywania kontaktów.',
            bbqHighlight1: 'Świeże grillowane owoce morza',
            bbqHighlight2: 'Kolacja z widokiem na ocean',
            bbqHighlight3: 'Żywa muzyka i rozrywka',
            bbqHighlight4: 'Doświadczenie ogniska',
            bbqHighlight5: 'Menu do indywidualnego dopasowania',
            boatTitle: 'Rejsy łodzią',
            boatSubtitle: 'Przygody rzeczne i nadmorskie',
            boatDescription: 'Wyrusz na magiczne rejsy łodzią wzdłuż rzeki Bentota i wód przybrzeżnych. Przepływaj przez lasy namorzynowe, obserwuj egzotyczne ptaki i dzikie zwierzęta lub ciesz się romantycznymi rejsami o zachodzie słońca. Nasze wyprawy łodzią oferują wyjątkową perspektywę na naturalne piękno i różnorodne ekosystemy Sri Lanki.',
            boatHighlight1: 'Rejsy po rzece Bentota',
            boatHighlight2: 'Eksploracja namorzyn',
            boatHighlight3: 'Obserwacja dzikich zwierząt',
            boatHighlight4: 'Rejsy o zachodzie słońca',
            boatHighlight5: 'Dostępny prywatny czarter',
            ayurvedaLecturesTitle: 'Wykłady lekarzy ajurwedy',
            ayurvedaLecturesSubtitle: 'Starożytna mądrość i współczesne zdrowie',
            ayurvedaLecturesDescription: 'Poznaj głębokie zasady ajurwedy podczas wykładów prowadzonych przez certyfikowanych lekarzy i praktyków ajurwedy. Dowiedz się o równoważeniu dosh, ziołowych terapiach, holistycznych metodach leczenia oraz o tym, jak starożytna wiedza sprawdza się we współczesnym stylu życia. Interaktywne sesje sprawiają, że filozofia ajurwedy staje się zrozumiała i praktyczna na co dzień.',
            ayurvedaLecturesHighlight1: 'Certyfikowani lekarze ajurwedy',
            ayurvedaLecturesHighlight2: 'Indywidualna analiza dosh',
            ayurvedaLecturesHighlight3: 'Edukacja na temat ziół leczniczych',
            ayurvedaLecturesHighlight4: 'Sesje pytań i odpowiedzi w cenie',
            ayurvedaLecturesHighlight5: 'Przewodnik po zdrowiu do zabrania',
            traditionalClothsTitle: 'Wydarzenia związane z noszeniem tradycyjnych strojów',
            traditionalClothsSubtitle: 'Doświadczenie dziedzictwa kulturowego',
            traditionalClothsDescription: 'Zanurz się w sri lankijskim dziedzictwie kulturowym, ucząc się nosić i doceniać tradycyjne stroje. Nasi profesjonalni styliści poprowadzą Cię przez zakładanie autentycznych sari z regionu Kandy oraz tradycyjnych ubrań, wyjaśniając znaczenie kulturowe każdego elementu. Idealne na specjalne okazje, kulturową przygodę lub piękne pamiątkowe zdjęcia.',
            traditionalClothsHighlight1: 'Profesjonalne porady stylistyczne',
            traditionalClothsHighlight2: 'Autentyczne tradycyjne sari',
            traditionalClothsHighlight3: 'Wyjaśnienie znaczenia kulturowego',
            traditionalClothsHighlight4: 'Profesjonalna sesja zdjęciowa w cenie',
            traditionalClothsHighlight5: 'Warsztaty mody fusion'
        },
        blogs2: {
            heroTitle: 'Blog Muthumuni Ayurveda River Resort',
            heroSubtitle1: 'Historie z nad rzeki, rytuały ajurwedy w',
            heroSubtitle2: 'Muthumuni Ayurveda River Resort',
            heroSubtitle3: '. Zanurz się w poradach, historii i kulisach.',
            heroAlt: 'Ścieżka spacerowa nad rzeką w resorcie o zachodzie słońca',
            sectionTitle: 'Blog Muthumuni Ayurveda River Resort',
            sectionDescription: 'Przewodniki, historie i notatki z naszego ustronia nad rzeką — od rytuałów ajurwedy, przez praktyki wellness, po porady podróżnicze w okolicy Bentoty.',
            ayurvedaTitle: 'Serce autentycznej ajurwedy',
            ayurvedaExcerpt: 'Doświadcz pradawnych tradycji uzdrawiania zakorzenionych w mądrości Sri Lanki.',
            ayurvedaDescription: 'W Muthumuni Ayurveda River Resort ajurweda to coś więcej niż leczenie – to sposób na życie. Nasze terapie opierają się na wielowiekowej wiedzy, są dostosowane do Twojego typu ciała i prowadzone przez doświadczonych lekarzy ajurwedyjskich, aby zapewnić głęboką i trwałą równowagę.',
            ayurvedaAlt: 'Ustawienie zabiegu ajurwedyjskiego z olejami ziołowymi i naturalnymi elementami',
            healingTitle: 'Spersonalizowane drogi uzdrowienia',
            healingExcerpt: 'Dlaczego program każdego gościa jest unikalny.',
            healingDescription: 'Od pierwszej konsultacji po codzienne zabiegi – Twoja droga uzdrowienia jest starannie dopasowana. Terapie ziołowe, lecznicze masaże, joga i medytacja wspólnie przywracają harmonię ciała, umysłu i ducha.',
            healingAlt: 'Lekarz ajurwedyjski konsultujący się z gościem w spokojnej atmosferze',
            natureTitle: 'Uzdrowienie nad rzeką',
            natureExcerpt: 'Jak spokojne położenie nad rzeką i tropikalna okolica wzmacniają Twoje samopoczucie.',
            natureDescription: 'Położony nad spokojną rzeką Sri Lanki, Muthumuni oferuje naturalne środowisko lecznicze. Delikatny nurt rzeki, świeże powietrze i bujna zieleń potęgują działanie ajurwedy, przynosząc głęboki relaks i odnowę.',
            natureAlt: 'Widok na rzekę w resorcie z palmami i naturą',
            foodTitle: 'Kuchnia ajurwedyjska dla wewnętrznej równowagi',
            foodExcerpt: 'Odżywcze posiłki stworzone, by wspierać Twoje leczenie.',
            foodDescription: 'Nasza kuchnia ajurwedyjska jest codziennie przygotowywana ze świeżych, lokalnych, sezonowych składników. Każdy posiłek jest dopasowany do Twojej doszy, wspiera trawienie, detoksykację i witalność, a jednocześnie pozostaje smaczny i sycący.',
            foodAlt: 'Tradycyjny posiłek ajurwedyjski podany w naturalnych misach',
            yogaTitle: 'Joga, medytacja i wewnętrzny spokój',
            yogaExcerpt: 'Delikatne praktyki uspokajające umysł i wzmacniające ciało.',
            yogaDescription: 'Codzienne sesje jogi i medytacji uzupełniają Twoje zabiegi, poprawiając elastyczność, oddech i jasność umysłu. Te uważne praktyki pomagają Ci na nowo połączyć się z sobą i zabrać poczucie spokoju po powrocie do domu.',
            yogaAlt: 'Goście ćwiczący jogę z widokiem na rzekę o wschodzie słońca',
            lifestyleTitle: 'Zabierz ajurwedę do domu',
            lifestyleExcerpt: 'Proste nawyki życiowe, by kontynuować drogę wellness.',
            lifestyleDescription: 'Przed wyjazdem nasi eksperci pokażą Ci, jak zachować równowagę dzięki codziennym rutynom, diecie i rytuałom dbania o siebie. Zabierz ze sobą nie tylko wspomnienia – zabierz trwałą ścieżkę do zdrowszego życia.',
            lifestyleAlt: 'Gość relaksujący się z herbatą ziołową w spokojnej atmosferze resortu',
            readMore: 'Czytaj więcej'
        },
        tours2: {
            heroTitle: 'Wycieczki i Ekskursje',
            heroSubtitle: 'Odkryj piękno Sri Lanki z Beruwali',
            kandeAlt: 'Świątynia Kande Vihara – Beruwala',
            kandeTitle: 'Wizyta w Świątyni Kande Vihara',
            kandeBuddhaAlt: 'Gigantyczny posąg Buddy w Świątyni Kande Vihara',
            bentotaTitle: 'Rejs łodzią po rzece Bentota',
            bentotaAlt: 'Rejs łodzią po rzece Bentota – Namorzyny i dzika przyroda',
            galleTitle: 'Wycieczka po starym mieście Galle',
            galleAlt: 'Wycieczka po starym mieście Galle',
            sigiriyaTitle: 'Wycieczka do twierdzy na skale Sigiriya',
            sigiriyaAlt: 'Wycieczka do twierdzy na skale Sigiriya',
            kandyTitle: 'Wycieczka kulturalna do Kandy',
            kandyAlt: 'Wycieczka kulturalna do Kandy',
            bookTour: 'Zarezerwuj tę wycieczkę',
            introPara1: 'Sri Lanka to kraina ponadczasowego piękna, gdzie złote plaże, bujna zielona przyroda, starożytne świątynie i tętniąca życiem kultura tworzą idealną harmonię.',
            introPara2: 'Od spokojnego południowo-zachodniego wybrzeża, przez historyczne miasta, święte miejsca, rezerwaty przyrody, aż po mgliste tereny górskie – każda podróż oferuje wyjątkowe i niezapomniane przeżycia.',
            introPara3: 'Z bazy w Muthumuni Ayurveda Beach Resort w Beruwali nasze starannie wyselekcjonowane wycieczki i ekskursje zostały zaprojektowane tak, aby wzbogacić Twój pobyt, idealnie łącząc eksplorację, relaks i dobrostan.',
            kandeDetail1: 'Świątynia Kande Vihara (Kande Viharaya) – jedna z najbardziej ikonicznych buddyjskich świątyń w pobliżu Beruwali.',
            kandeDetail2: 'Założona w 1734 roku, ta spokojna „Świątynia Górska” położona jest na wzgórzu z pięknym widokiem na wybrzeże.',
            kandeDetail3: 'Najważniejsze atrakcje to ogromny 48-metrowy (160 stóp) siedzący posąg Buddy (jeden z najwyższych na Sri Lance), misternie wykonane freski z epoki Kandyan, starożytna komora relikwii, piękny wejściowy kamień księżycowy oraz święte drzewo Bodhi liczące ponad 300 lat.',
            kandeDetail4: 'Idealna półdniowa wycieczka duchowa i kulturalna – najlepiej rano, aby uniknąć upału.',
            bentotaDetail1: 'Ciesz się spokojnym i malowniczym rejsem łodzią po rzece Bentota – jednej z najpopularniejszych wycieczek przyrodniczych w pobliżu Beruwali.',
            bentotaDetail2: 'Przepływaj przez gęste namorzyny, wąskie kanały i spokojne zakola, obserwując lokalną przyrodę.',
            bentotaDetail3: 'Najczęściej spotykane zwierzęta to warany, krokodyle, różne gatunki ptaków (zimorodki, czaple, orły), małpy, a czasami wydry lub węże wodne.',
            bentotaDetail4: 'Doświadczony sternik/przewodnik wskaże ciekawe rośliny, tradycyjne metody połowu ryb oraz życie w nadbrzeżnych wioskach.',
            bentotaDetail5: 'Idealna dla miłośników przyrody i fotografów – spokojna, relaksująca i doskonale uzupełniająca Twój ajurwedyjski pobyt wellness.',
            galleDetail1: 'Odkryj historyczną twierdzę Galle – obiekt światowego dziedzictwa UNESCO i jedną z najlepiej zachowanych kolonialnych fortec na Sri Lance.',
            galleDetail2: 'Przechadzaj się brukowanymi uliczkami otoczonymi holenderskimi budynkami kolonialnymi, butikami, kawiarniami i galeriami sztuki.',
            galleDetail3: 'Odwiedź najważniejsze miejsca: latarnię morską Galle, Holenderski Kościół Reformowany, Narodowe Muzeum Morskie oraz mury obronne z zapierającym dech w piersiach widokiem na ocean.',
            galleDetail4: 'Poznaj bogatą historię, architekturę i znaczenie kulturowe twierdzy dzięki wiedzy doświadczonego przewodnika.',
            galleDetail5: 'Idealna dla miłośników historii, kultury oraz osób chcących doświadczyć kolonialnej przeszłości Sri Lanki.',
            sigiriyaDetail1: 'Odkryj starożytną twierdzę skalną Sigiriya – jeden z najbardziej ikonicznych symboli Sri Lanki i obiekt światowego dziedzictwa UNESCO.',
            sigiriyaDetail2: 'Wejdź na imponującą skałę i zwiedź ruiny pałacu króla Kasyapy zdobione freskami, ogrodami wodnymi i słynną Lustrzaną Ścianą.',
            sigiriyaDetail3: 'Z szczytu podziwiaj panoramiczne widoki na otaczającą dżunglę i okolicę.',
            sigiriyaDetail4: 'Poznaj fascynującą historię, architekturę i legendy Sigiriyi od profesjonalnego przewodnika.',
            sigiriyaDetail5: 'Idealna dla pasjonatów historii, poszukiwaczy przygód i wszystkich zainteresowanych bogatym dziedzictwem kulturowym Sri Lanki.',
            kandyDetail1: 'Doświadcz tętniącej życiem kultury Kandy – ostatniej królewskiej stolicy Sri Lanki i obiektu światowego dziedzictwa UNESCO.',
            kandyDetail2: 'Odwiedź Świątynię Świętego Zęba (Sri Dalada Maligawa) – jedno z najważniejszych buddyjskich miejsc na świecie.',
            kandyDetail3: 'Zwiedź Królewskie Ogrody Botaniczne w Peradeniyi z ogromną kolekcją roślin tropikalnych i storczyków.',
            kandyDetail4: 'Obejrzyj tradycyjny pokaz tańca kandyjskiego prezentujący bogate dziedzictwo artystyczne Sri Lanki.',
            kandyDetail5: 'Idealna dla miłośników kultury, historii i osób pragnących zanurzyć się w tradycjach Sri Lanki.'
        },
        rooms: {
            heroTitle: 'Twoja Świątynia Cię czeka',
            heroSubtitle: 'Pokoje starannie zaprojektowane do uzdrawiania, przywrócenia i głębokich spokojności.',
            heroAlt: 'Pokoje Muthumuni Ayurveda Beach Resort',
            exploreRooms: 'Odkryj nasze pokoje',
            filterAll: 'Wszystko',
            filterLuxurySuite: 'Apartament Luksusowy',
            filterDeluxeRooms: 'Pokoje Deluxe',
            filterDeluxeSeaView: 'Pokoj Deluxe z widokiem na morze',
            noRoomsFound: 'Nie znaleziono pokojów w tej kategorii.',
            allRoomsInclude: 'Wszystkie pokoje obejmują',
            essentialComforts: 'Niezbędny komfort dla twojej podróży wellness',
            roomSize: 'Rozmiar pokoju',
            guests: 'Goście',
            amenities: 'Udogodnienia',
            roomAmenities: 'Amenities pokoju',
            specialFeatures: 'Cechy szczególne',
            bookNow: 'Zarezerwuj teraz',
            viewDetails: 'Wyświetl szczegóły',
            highSpeedWifi: 'Szybki WiFi',
            herbalTea: 'Wybór herbat ziołowych',
            climateControl: 'Kontrola klimatu',
            rainShower: 'Prysznic deszczowy',
            organicToiletries: 'Artykuły toaletowe organiczne',
            dailyHousekeeping: 'Codzienna obsługa pokoju',
            concierge: 'Recepcja 24/7',
            yogaMat: 'Mata do jogi i akcesoria',
            beginHealing: 'Zacznij swoją podróż uzdrawiającą',
            beginHealingDesc: 'Doświadcz autentycznego zdrowia ajurwedy w środowisku zaprojektowanym do odżywienia ciała, uspokojenia umysłu i przywrócenia duszy.',
            reserveRoom: 'Zarezerwuj pokój',
            speakAdvisor: 'Porozmawiaj z doradcą wellness',
            exploreOurRooms: 'Odkryj nasze pokoje',
            viewRoom: 'Wyświetl pokój',
            luxurySuiteName: 'Apartament Luksusowy',
            luxurySuiteCategory: 'Apartament Luksusowy',
            luxurySuiteDesc: 'Doświadcz ostatecznego spokoju w naszym przestronnym apartamencie luksusowym, zaprojektowanym zgodnie z tradycyjnymi zasadami ajurwedy ze spektakularnym widokiem na morze.',
            deluxeRoomName: 'Pokoj Deluxe',
            deluxeRoomCategory: 'Pokoj Deluxe',
            deluxeRoomDesc: 'Harmonijnie zaprojektowany pokój z naturalnymi elementami drewna i uspokajającymi funkcjami wodnymi dla doskonałego spokoju.',
            seaViewDeluxeName: 'Deluxe z widokiem na morze',
            seaViewDeluxeCategory: 'Pokoj Deluxe z widokiem na morze',
            seaViewDeluxeDesc: 'Obudź się w miękkim morskim powietrzu i panoramicznych widokach na morze w tym elegancko zaprojektowanym pokoju Deluxe.',
            deluxeRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Pokoj Deluxe',
                heroSubtitle: 'Gdzie luksus spotyka naturę',
                bookThisRoom: 'Zarezerwuj ten pokój',
                callReservations: 'Wywołaj rezerwacje',
                navAll: 'Wszystkie pokoje',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe z widokiem na morze',
                navSuite: 'Apartament',
                sectionTitle: 'Ucieczka do luksusu i spokoju',
                sectionDesc: 'Doświadcz idealnej harmonii między elegancją a wygodą w naszym pokoju Deluxe. Każdy szczegół został starannie opracowany, aby stworzyć niezapomniane doświadczenie, łączące nowoczesne udogodnienia z ciepłem natury.',
                highlight1Title: 'Spokojny azyl',
                highlight1Desc: 'Obudź się przy łagodnym szumie fal i oszałamiającym wschodzie słońca nad oceanem.',
                highlight2Title: 'Eleganckie wnętrza',
                highlight2Desc: 'Harmonijnie zaprojektowane przestrzenie z naturalnymi elementami z drewna i kamienia.',
                highlight3Title: 'Nowoczesne udogodnienia',
                highlight3Desc: 'Najnowsze udogodnienia i usługi dla bezproblemowego pobytu.',
                atAGlance: 'W skrócie',
                statSize: 'Rozmiar',
                statSizeValue: '350 stóp kwadratowych',
                statView: 'Widok',
                statViewValue: 'Ogród',
                statGuests: 'Pojemność',
                statGuestsValue: '2 osoby dorosłe',
                statBed: 'Łóżko',
                statBedValue: 'King Size',
                reserve: 'Rezerwuj',
                galleryAlt: 'Pokoj Deluxe',
                inclusionsTitle: 'Co jest wliczone',
                inclusionsSubtitle: 'Udogodnienia i usługi',
                enhancedCleanliness: 'Ulepszone protokoły czystości',
                inclusion1: 'Bezpłatne Wi-Fi w całym pokoju',
                inclusion2: 'Bezpłatny minibar (napoje bezalkoholowe)',
                inclusion3: 'Ekspres do kawy Nespresso i zestaw herbaciany',
                inclusion4: 'Obsługa pokoju 24 godziny',
                inclusion5: 'Produkty toaletowe premium',
                inclusion6: 'Codzienna obsługa pokoju',
                amenityGroup1Title: 'Technologia',
                amenityGroup1Item1: '55" Smart TV',
                amenityGroup1Item2: 'Bezpłatne Wi-Fi',
                amenityGroup1Item3: 'Głośnik Bluetooth',
                amenityGroup1Item4: 'Porty ładujące USB',
                amenityGroup2Title: 'Łazienka',
                amenityGroup2Item1: 'Prysznic deszczowy',
                amenityGroup2Item2: 'Produkty toaletowe premium',
                amenityGroup2Item3: 'Szlafrok i kapcie',
                amenityGroup2Item4: 'Suszarka do włosów',
                amenityGroup3Title: 'Komfort',
                amenityGroup3Item1: 'Klimatyzacja',
                amenityGroup3Item2: 'Wentylator sufitowy',
                amenityGroup3Item3: 'Minibar',
                amenityGroup4Title: 'Ostatnie dotknięcia',
                amenityGroup4Item1: 'Ekspres do kawy i zestaw herbaciany',
                amenityGroup4Item2: 'Sejf',
                amenityGroup4Item3: 'Żelazko i deska do prasowania',
                essentialsTitle: 'Niezbędne możliwości',
                essentialsHeading: 'Wybierz swoje doświadczenie',
                essentialsDesc: 'Dostosuj swój pobyt za pomocą naszych kurowanych dodatków i usług.',
                essential1: 'Spa i wellness',
                essential2: 'Doświadczenia kulinarne',
                essential3: 'Wycieczki',
                essential4: 'Sporty wodne',
                oceanTitle: 'Pokój łączący Cię z naturą',
                oceanSubtitle: 'Gdzie krajobrazy morza, nieba i ziemi harmonijnie się łączą',
                oceanAlt: 'Widok oceanu',
                ctaTitle: 'Zacznij swoją podróż',
                ctaHeading: 'Gotowy do doświadczenia spokoju?',
                ctaDesc: 'Zarezerwuj swój ucieczka do luksusu i odkryj idealną harmonię między elegancją a wygodą.',
                checkAvailability: 'Sprawdź dostępność'
            },
            suiteRoom: {
                resortName: 'Muthumuni Beach Resort',
                heroTitle: 'Sea View Luxury Suite',
                heroSubtitle: 'Komfort z spokojnym urokiem nadbrzeżnym',
                bookThisRoom: 'Zarezerwuj ten pokój',
                callReservations: 'Zadzwoń na rezerwacje',
                navAll: 'Wszystkie',
                navDeluxe: 'Deluxe',
                navDeluxeSeaView: 'Deluxe z widokiem na morze',
                navSuite: 'Apartament',
                sectionTitle: 'Spokojne schronienie nadbrzeżne',
                sectionDesc: 'Apartament luksusowy jest przeznaczony do wolnych poranków i bez pośpiechu zachodów słońca. Miękkie tonalności neutralne, hojne oszklenie i przemyślane oświetlenie zapraszają widok na morze, podczas gdy balkon oferuje Ci własne miejsce nad linią brzegową.',
                highlight1Title: 'Panoramiczny widok na plażę',
                highlight1Desc: 'Obudź się niebieską wodą i złotymi wschodami słońca z Twojego prywatnego balkonu.',
                highlight2Title: 'Eleganckie wnętrza przybrzeżne',
                highlight2Desc: 'Miękkie neutralne palety, ciepłe drewniane akcenty i hojne naturalne światło.',
                highlight3Title: 'Spokojne doświadczenie snu',
                highlight3Desc: 'Miękkie łóżko king size z pościelą premium wyselekcjonowaną do regenerującego odpoczynku.',
                atAGlance: 'Na pierwszy rzut oka',
                statSize: 'Rozmiar',
                statSizeValue: '41 m²',
                statView: 'Widok',
                statViewValue: 'Ocean Indyjski',
                statGuests: 'Goście',
                statGuestsValue: '2 dorośli',
                statBed: 'Łóżko',
                statBedValue: 'King lub Twin',
                reserve: 'Rezerwuj',
                galleryAlt: 'Pokój apartamentu',
                inclusionsTitle: 'Zawarte w Twoim pobycie',
                inclusionsSubtitle: 'Przemyślane detale, cały dzień komfortu',
                enhancedCleanliness: 'Wzmocnione standardy czystości i bezpieczeństwa',
                inclusion1: 'Darmowe śniadanie, lunch, obiad w restauracji Breeze',
                inclusion2: 'Szybki Wi-Fi i pracownia w pokoju',
                inclusion3: 'Obsługa pokoju 24 godziny i concierge',
                inclusion4: 'Codzienny sprzątanie pokoju z przemiątką wieczorną',
                inclusion5: 'Dostęp do basenu bez granic i ośrodka spa Ayurvedy',
                inclusion6: 'Darmowy parking i transport do pobliskich atrakcji',
                amenityGroup1Title: 'Charakterystyka pokoju',
                amenityGroup1Item1: '41 m² przestrzeni',
                amenityGroup1Item2: 'Prywatny balkon ze strefą siadłości',
                amenityGroup1Item3: 'Klimatyzacja z kontrolą klimatu',
                amenityGroup1Item4: 'Sejf w pokoju',
                amenityGroup2Title: 'Doświadczenie łazienkowe',
                amenityGroup2Item1: 'Deszczowa prysznic z gorącą i zimną wodą',
                amenityGroup2Item2: 'Premium artykuły do kąpieli',
                amenityGroup2Item3: 'Suszarka do włosów',
                amenityGroup2Item4: 'Miękkie szlafroki i pantofle',
                amenityGroup3Title: 'Komfort pokojowy',
                amenityGroup3Item1: '55" Smart TV z kablelem',
                amenityGroup3Item2: 'Stacja kawy i herbaty',
                amenityGroup3Item3: 'Telefon z bezpośrednim wyborem',
                amenityGroup4Title: 'Łączność',
                amenityGroup4Item1: 'Darmowy Wi-Fi',
                amenityGroup4Item2: 'Biurko',
                amenityGroup4Item3: 'Wsparcie recepcji 24/7',
                essentialsTitle: 'Niezbędne w pokoju',
                essentialsHeading: 'Wszystko czego potrzebujesz by czuć się jak w domu',
                essentialsDesc: 'Od bezproblemowego połączenia do starannie wyselekcjonowanych napojów, apartament luksusowy łączy wypoczynek i praktyczność, abyś mógł skupić się na chwilach, które się liczą.',
                essential1: 'Darmowy Wi-Fi',
                essential2: 'Stacja kawy i herbaty',
                essential3: 'Obsługa pokoju 24/7',
                essential4: 'Deszczowa prysznic',
                oceanTitle: 'Pokój łączący Cię z naturą',
                oceanSubtitle: 'Gdzie krajobrazy morza, nieba i ziemi harmonijnie się łączą',
                oceanAlt: 'Widok oceanu',
                ctaTitle: 'Zacznij swoją podróż',
                ctaHeading: 'Gotowy do doświadczenia spokoju?',
                ctaDesc: 'Zarezerwuj swój ucieczka do luksusu i odkryj idealną harmonię między elegancją a wygodą.',
                checkAvailability: 'Sprawdź dostępność'
            },
            deluxeSeaViewRoom: {
                resortName: 'Muthumuni Resorts',
                heroTitle: 'Pokój Deluxe z widokiem na morze',
                heroSubtitle: 'Zanurz się w luksusie z oszałamiającymi widokami na horyzont morski',
                bookThisRoom: 'Zarezerwuj ten pokój',
                callReservations: 'Zadzwoń do rezerwacji',
                navAll: 'Wszystkie pokoje',
                navDeluxe: 'Pokój Deluxe',
                navDeluxeSeaView: 'Pokój Deluxe z widokiem na morze',
                navSuite: 'Luksusowy apartament',
                sectionTitle: 'Odkryj luksus',
                sectionDesc: 'Nasze pokoje Deluxe z widokiem na morze oferują idealne połączenie komfortu i elegancji. Każdy pokój został starannie zaprojektowany, aby zapewnić niezrównanym doświadczenie pobytu.',
                highlight1Title: 'Widok na prywatną plażę',
                highlight1Desc: 'Bezpośredni dostęp do naszej prywatnej plaży z białym piaskiem',
                highlight2Title: 'Przestronna porcja',
                highlight2Desc: '75 metrów kwadratowych wspaniałej przestrzeni mieszkalnej',
                highlight3Title: 'Wanna na zewnątrz',
                highlight3Desc: 'Doświadcz prywatnego luksusu pod gwiezdnym niebem',
                atAGlance: 'Na pierwszy rzut oka',
                stat1Label: 'Rozmiar',
                stat1Value: '75 metrów kwadratowych',
                stat2Label: 'Widok',
                stat2Value: 'Widok na morze',
                stat3Label: 'Goście',
                stat3Value: '2 dorosłych',
                stat4Label: 'Łóżko',
                stat4Value: 'Król',
                reserve: 'Zarezerwuj',
                galleryAlt: 'Luksusowy pokój Deluxe z widokiem na morze',
                inclusionsTitle: 'Co jest wliczone',
                inclusionsSubtitle: 'Każdy pokój zawiera',
                inclusion1: 'Śniadanie z widokiem na morze',
                inclusion2: 'Napój powitalny o zachodzie słońca',
                inclusion3: 'Codzienna obsługa espresso bar',
                inclusion4: 'Nieograniczony dostęp do spa',
                inclusion5: 'Prywatny transfer na plażę',
                inclusion6: 'Premium Wi-Fi',
                enhancedCleanliness: 'Ulepszone czyszczenie i protokoły bezpieczeństwa',
                amenityGroup1Title: 'Sypialnia',
                amenityGroup1Item1: 'Automatyczne zaciemnianie',
                amenityGroup1Item2: '100% bawełna premium',
                amenityGroup1Item3: 'Poduszki o różnej twardości',
                amenityGroup2Title: 'Łazienka',
                amenityGroup2Item1: 'Kosmetyki Bvlgari',
                amenityGroup2Item2: 'Ogrzewane podłogi',
                amenityGroup2Item3: 'Zintegrowany system SPA',
                amenityGroup3Title: 'Salon',
                amenityGroup3Item1: 'Premium telewizja satelitarna',
                amenityGroup3Item2: 'W pełni wyposażona kuchnia',
                amenityGroup3Item3: 'Projektor domowy',
                amenityGroup4Title: 'Na świeżym powietrzu',
                amenityGroup4Item1: 'Prywatny taras z jacuzzi',
                amenityGroup4Item2: 'Wiszące łóżko w stylu balijskim',
                amenityGroup4Item3: 'Automatyczny system irygacji',
                essentialsTitle: 'Artykuły niezbędne',
                essentialsHeading: 'Twoje podstawowe potrzeby w pokoju',
                essentialsDesc: 'Wszystko niezbędne w pokoju',
                essential1: 'Mini bar z napojami premium',
                essential2: 'Stacja kawy i herbaty',
                essential3: 'Obsługa pokoju 24/7',
                essential4: 'Deszczowa prysznic',
                oceanTitle: 'Pokój łączący Cię z naturą',
                oceanSubtitle: 'Gdzie krajobrazy morza, nieba i ziemi harmonijnie się łączą',
                oceanAlt: 'Widok oceanu',
                ctaTitle: 'Zacznij swoją podróż',
                ctaHeading: 'Zarezerwuj pokój Deluxe z widokiem na morze dzisiaj',
                ctaDesc: 'Zarezerwuj swój ucieczka do luksusu i odkryj idealną harmonię między elegancją a wygodą.',
                checkAvailability: 'Sprawdź dostępność'
            }
        },
        home: {
            heroTitle: 'Kurort Muthumuni Ayurveda Beach',
            heroSubtitle1: 'Ayurveda przy oceanie',
            heroSubtitle2: 'Znajdź równowagę, łatwo oddychaj i odnów swoją energię w Beruwale.',
            exploreResort: 'Zbadaj kurort',
            bookNow: 'Zarezerwuj teraz',
            welcomeLabel: 'Witaj',
            welcomeTitle: 'Kurort Muthumuni Ayurveda Beach',
            welcomeDesc1: 'Położony na dziewiczych brzegach Beruwal, kurort Muthumuni Ayurveda Beach oferuje harmonijne połączenie starożytnych tradycji uzdrawiania i nowoczesnego luksusu przybrzeżnego. Nasze sanktuarium zaprasza cię w transformującą podróż wellness, gdzie rytmiczne dźwięki Oceanu Indyjskiego spotykają się z ponadczasową mądrością Ayurvedy.',
            welcomeDesc2: 'Doświadcz spersonalizowanych zabiegów ajurwedyjskich, delektuj się pożywną kuchnią opracowaną w celu równoważenia Twojego dosha i zrelaksuj się w elegancko wyposażonych pokojach z zachwycającymi widokami na ocean. Niezależnie od tego, czy szukasz odmłodzenia, relaksu czy duchowego odrodzenia, nasz oddany zespół praktyków Ayurvedy i ekspertów od będzie cię prowadził na każdym kroku.',
            learnMore: 'Dowiedz się więcej',
            contactUs: 'Skontaktuj się z nami',
            welcomeImageAlt: 'Kurort Muthumuni Ayurveda Beach',
            welcomeImageCaption: 'Ayurveda & Beach Retreat',
            welcomeImageLocation: 'Beruwala, Sri Lanka',
            highlightTitle: 'Sanktuarium Ayurvedy nad morzem',
            highlightDesc: 'Odkryj holistyczne uzdrawianie na południowo-zachodnim wybrzeżu Sri Lanki. Od dostosowanych zabiegów po spokojne balkony i świadome gotowanie, każdy szczegół został zaprojektowany, aby przywrócić twój rytm.',
            service1Title: 'Holistyczne terapie Ayurvedy',
            service1Desc: 'Spersonalizowane konsultacje, autentyczne oleje roślinne i codzienne zabiegi prowadzone przez doświadczonych lekarzy Ayurvedy.',
            service2Title: 'Pokoje i apartamenty na plaży',
            service2Desc: 'Obudź się z morskim powiewem, prywatnymi balkonami i uspokajającym wnętrzem zaprojektowanym do głębokie odpoczynku.',
            service3Title: 'Kuchnia wellness',
            service3Desc: 'Świeże produkty Sri Lanki, menu oparte na roślinach i spersonalizowane plany posiłków, które uzupełniają twojego dosh.',
            service4Title: 'Joga i uważność',
            service4Desc: 'Joga o wschodzie słońca, medytacja o zachodzie słońca i ćwiczenia oddechowe w rytmie fal.',
            service5Title: 'Wycieczki po rzekach i wybrzeżu',
            service5Desc: 'Rejsy po rzece Bentota, wizyty w inkubatoriach żółwi morskich, spacery po ogrodach przypraw i wycieczki rowerowe po wsiach.',
            roomsTitle: 'Nasze pokoje',
            roomsDesc: 'Wybierz sanktuarium, które odpowiada Twojemu tempu, od przestronnych apartamentów po przytulne deluxe schroniska, każdy z miękkimi prześcieradłami, ciepłym drewnem i balkonami gotowymi na wschód słońca.',
            roomBadge: 'Ucieczka na plaży',
            bookableNow: 'Teraz zarezerwować',
            seaBreezeReady: 'Gotowy do morskiego powiewu',
            viewRoom: 'Wyświetl pokój',
            room1Title: 'Pokoje apartamentowe',
            room1Desc: 'Przestronne apartamenty z salonem, hojnymi balkonami i uspokajającą paletą dla powolnych poranków.',
            room2Title: 'Pokoje Deluxe',
            room2Desc: 'Przytulne schroniska z luksusowymi łóżkami, widokiem na ogród i ciepłymi akcentami drewnianymi dla łatwości na codzień.',
            room3Title: 'Deluxe z widokiem na morze',
            room3Desc: 'Obudź się z horyzontem oceanu, miękkimi prześcieradłami i prywatnym balkonem stworzonym dla złotych zachodów słońca.',
            achievement1Title: 'Szczęśliwych gości',
            achievement1Count: '1 000+',
            achievement2Title: 'Zabiegi Ayurvedy',
            achievement2Count: '20+',
            achievement3Title: 'Lata opieki',
            achievement3Count: '15+',
            achievement4Title: 'Pochway podróżników',
            achievement4Count: '1 000+',
            experiencesTitle: 'Odkryj Kurort Muthumuni Ayurveda Beach',
            experiencesDesc: 'Od podróży Ayurvedy do kuratorskich wycieczek, wybierz doświadczenia, które sprawią, że twój pobyt będzie niezapomniany.',
            planYourStay: 'Zaplanuj swój pobyt',
            experience1Title: 'Pokoje i apartamenty',
            experience1Desc: 'Przestrzenne pomieszczenia z balkonami, widokami na ocean lub ogród i przemyślanym komfortem dla niespiesznych pobytów.',
            experience2Title: 'Spa Ayurvedy',
            experience2Desc: 'Autentyczne terapie, kąpiele parowe i regeneracyjne masaże realizowane dzięki sprawdzonym rytuałom.',
            experience3Title: 'Doświadczenie kulinarne',
            experience3Desc: 'Odżywcza kuchnia Sri Lanki i międzynarodowa serwowana w naszej restauracji, starannie przygotowana do odżywiania ciała i umysłu.',
            experience4Title: 'Doświadczenia i wycieczki',
            experience4Desc: 'Safari po rzece, wizyty w świątyniach, sporty wodne i wyselekcjonowane wycieczki kulturalne wokół Benutami.',
            galleryTitle: 'Chwile w Kurorcie Muthumuni Ayurveda Beach',
            galleryDesc: 'Wgląd w nasze przybrzeżne sanktuarium — wschody słońca, spokojne zabiegi, pożywny jedzenie i spokojne kąty dla ciebie ',
            gallery1Alt: 'Słoneczna plaża otoczona palmami w Muthumuni',
            gallery2Alt: 'Trwająca terapia olejowa Ayurvedy',
            gallery3Alt: 'Basen kurortu z leżakami',
            gallery4Alt: 'Zioła przygotowane do spa',
            gallery5Alt: 'Para cieszy się zachodem słońca nad morzem',
            gallery6Alt: 'Taras jogi zwrócony ku oceanowi',
            gallery7Alt: 'Ścieżka tropikalnego ogrodu',
            gallery8Alt: 'Zdrowe śniadanie',
            gallery9Alt: 'Spokojny widok na rzekę',
            gallery10Alt: 'Eksterior kurortu ciepło oświetlony o zachodzie słońca',
            gallery11Alt: 'Wyświetl zioła Ayurvedy i oleje',
            gallery12Alt: 'Wygodne siedzenie w ogrodzie',
            resort1Alt: 'Otwarta loża z zielenią',
            resort2Alt: 'Wygodne wnętrze pokoju',
            resort3Alt: 'Przestrzeń spaowego leczenia',
            resort4Alt: 'Jadalnia ze światłem naturalnym',
            resort5Alt: 'Relaksujący widok basenu',
            sunsetLabel: 'Codzienny arcydzieło przyrody',
            sunsetTitle: 'Wieczorny zachód słońca',
            sunsetDesc1: 'Obserwuj, jak dzień gracefully oddaje zmrok, gdy niebo zmienia się w płótno bursztynu, karmazynu i złota. Łagodny Ocean Indyjski odzwierciedla to niebiańskie widowisko, tworząc hipnotyzującą symfonię światła i wody.',
            sunsetDesc2: 'Każdy wieczór w Muthumuni oferuje miejsca w pierwszym rzędzie jednego z najbardziej spektakularnych występów przyrody. Znajdź swój idealny punkt widzenia — czy to z twojego prywatnego balkonu, loży na plaży czy naszego pokładu medytacji przy zachodzie słońca — i pozwól spokojnej piękności go oniemielać.',
            sunsetFeature1: 'Niezakłóconymi widokami za całego nieprzerwanego morza',
            sunsetFeature2: 'Spokojność medytacji o zachodzie słońca',
            sunsetFeature3: 'Bezpłatna herbata ziołowa serwowana codziennie',
            sunsetFeature4: 'Fotogeniczne momenty każdego wieczoru',
            sunsetImageAlt: 'Wieczorny zachód słońca na Kurorcie Muthumuni Beach',
            bestTime: 'Najlepszy czas',
            sunsetTime: '18:00 - 18:45',
            poolLabel: 'Akwatyczna spokojność',
            poolTitle: 'Strefa basenu',
            poolDesc1: 'Zanurz się w spokój naszego nieskazitelnego basenu bez krawędzi, gdzie krystalowo czysta woda spotyka się z bujnymi tropikalnymi ogrodami. Zaelaprojektowana do relaksu i odmłodzenia, nasza strefa basenu oferuje doskonałą ucieczkę do relaksowania się pod słońcem Sri Lanki.',
            poolDesc2: 'Niezależnie od tego, czy wolisz oświeżające poranne pływanie, popołudniową sesję relaksu z dobrą książką czy spokojne wieczorne zanurzenia, nasza strefa basenu zapewnia idylliczne otoczenie. Otoczone wygodnymi leżakami, zacienionymi kabinami i troskliwą obsługą przy basenie, każdy moment staje się drogocennych wspomnieniem.',
            poolFeature1: 'Basen bez krawędzi z kontrolą temperatury',
            poolFeature2: 'Otoczony krajobrazami tropikalnych ogrodów',
            poolFeature3: 'Oświeżenia i zdrowe przekąski przy basenie',
            poolFeature4: 'Premium leżaki z parasolkami',
            poolImageAlt: 'Relaksująca strefa basenu w Kurorcie Muthumuni',
            testimonialsTitle: 'Goście podczas ich pobytu'
        },

        navbar: {
            home: 'Strona główna',
            aboutUs: 'O nas',
            rooms: 'Pokoje',
            ayurveda: 'Ajurweda',
            yoga: 'Joga',
            food: 'Wyżywienie',
            events: 'Wydarzenia',
            blogs: 'Blogi',
            tours: 'Wycieczki',
            contactUs: 'Kontakt',
            bookOnline: 'Rezerwuj online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Wybierz ośrodek',
            language: 'Język',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        navbar2: {
            home: 'Strona główna',
            aboutUs: 'O nas',
            rooms: 'Pokoje',
            ayurveda: 'Ajurweda',
            yoga: 'Joga',
            food: 'Wyżywienie',
            events: 'Wydarzenia',
            blogs: 'Blogi',
            tours: 'Wycieczki',
            contactUs: 'Kontakt',
            bookOnline: 'Rezerwuj online',
            locationBeruwala: 'Sri Lanka / Beruwala',
            selectResort: 'Wybierz ośrodek',
            language: 'Język',
            mainTitle: 'Muthumuni Ayurveda Beach Resort',
            resortBeach: 'Muthumuni Ayurveda Beach Resort',
            resortRiver: 'Muthumuni Ayurveda River Resort'
        },
        footer: {
            description: 'Muthumuni Ayurveda Beach Resort dokłada starań, aby zapewnić wyjątkową gościnność i doświadczenia wellness, dzięki którym każdy gość czuje się doceniony i zregenerowany.',
            linksTitle: 'Linki',
            contactTitle: 'Kontakt',
            viewLocation: 'Zobacz lokalizację',
            navHome: 'Strona główna',
            navAbout: 'O nas',
            navContact: 'Kontakt',
            navRooms: 'Pokoje',
            navAyurveda: 'Ajurweda',
            copyright: '© Copyright {{year}} Muthumuni Ayurveda Beach Resort.',
            developedBy: 'Wykonanie',
            developerName: 'Redev Solution +94 764 608 225'
        },
        tours: {
            heroTitle: 'Wycieczki i wycieczki',
            heroSubtitle: 'Odkryj piękno Sri Lanki z Beruwali',
            kandeAlt: 'Świątynia Kande Vihara - Beruwala',
            kandeTitle: 'Wizyta w świątyni Kande Vihara',
            kandeBuddhaAlt: 'Gigantyczna statua Buddy w świątyni Kande Vihara',
            bentotaTitle: 'Safari łodzią po rzece Bentota',
            bentotaAlt: 'Safari łodzią po rzece Bentota - Mangrowy i fauna',
            galleTitle: 'Wycieczka po Starym Mieście Galle',
            galleAlt: 'Wycieczka po Starym Mieście Galle',
            sigiriyaTitle: 'Wycieczka po twierdzy skalnej Sigiriya',
            sigiriyaAlt: 'Wycieczka po twierdzy skalnej Sigiriya',
            kandyTitle: 'Wycieczka kulturalna Kandy',
            kandyAlt: 'Wycieczka kulturalna Kandy',
            bookTour: 'Zarezerwuj tę wycieczkę',
            introPara1: 'Sri Lanka to kraj ponadczasowego piękna, gdzie złote plaże, bujne zielone krajobrazy, starożytne świątynie i tętniąca kulturą wspólnota łączą się w doskonałej harmonii.',
            introPara2: 'Od spokojnego południowo-zachodniego wybrzeża, poprzez zabytkowe miasta, święte miejsca, rezerwaty przyrody aż po mglisty region górski – każda podróż oferuje wyjątkowe i niezapomniane doświadczenie.',
            introPara3: 'Wycieczki i wycieczki zostały starannie wyselekcjonowane w celu wzbogacenia Twojego pobytu, doskonale łącząc badanie, relaks i wellness, rozpoczynając od kurortu Muthumuni Ayurveda Beach Resort w Beruwalę.',
            kandeDetail1: 'Świątynia Kande Vihara (Kande Viharaya) – jedna z najikoniczniejszych świątyń buddyjskich w pobliżu Beruwali.',
            kandeDetail2: 'Założona w 1734 roku, ta spokojna "Świątynia Górska" usytuowana na szczycie wzgórza oferuje spokojne widoki na linię brzegową.',
            kandeDetail3: 'Atrakcje obejmują ogromną statueę siedzącej Buddy o wysokości 48 metrów (jedną z najwyższych na Sri Lance), skomplikowane freski z epoki Kandyan, starożytną komorę relikwiarzą, piękną brame księżycową i święte drzewo Bodhi liczące ponad 300 lat.',
            kandeDetail4: 'Doskonałe doświadczenie duchowe i kulturalne na pół dnia – idealne na wizyty poranmne, aby uniknąć upału.',
            bentotaDetail1: 'Ciesz się spokojnym i malowniczym safari łodzią po rzece Bentota, jednej z najpopularniejszych ekskursji przyrodniczych w pobliżu Beruwali.',
            bentotaDetail2: 'Pływaj przez bujne mangrowy, wąskie kanały i spokojne wody, obserwując lokalną faunę.',
            bentotaDetail3: 'Typowe obserwacje obejmują jaszczurki wodne, krokodyle, różne gatunki ptaków (zimorodki, czaple, orły), małpy i czasami wydry lub węże wodne.',
            bentotaDetail4: 'Twój doświadczony przewodnik łodzią wskaże interesującą florę, tradycyjne metody połowów i życie we wsiach rzecznych.',
            bentotaDetail5: 'Doskonały dla miłośników przyrody i fotografów – spokojny, relaksujący i uzupełniający Twój pobyt ayrwedyjski wellness.',
            galleDetail1: 'Odkryj zabytkową twierdzę Galle, światowe dziedzictwo UNESCO i jedną z najlepiej zachowanych twierdz z czasów kolonialnych na Sri Lance.',
            galleDetail2: 'Spaceruj po brukowanych ulicach obsadzonych holenderskimi budynkami kolonialnymi, butików, kawiarni i galeriach sztuki.',
            galleDetail3: 'Odwiedź kluczowe atrakcje, takie jak latarnia Galle, holenderski kościół reformowany, Narodowe Muzeum Morskie i forty z wspaniałymi widokami na ocean.',
            galleDetail4: 'Poznaj bogatą historię, architekturę i znaczenie kulturowe twierdzy od swojego doświadczonego przewodnika.',
            galleDetail5: 'Idealny dla miłośników historii, entuzjastów kultury i tych, którzy chcą doświadczyć kolonialnej przeszłości Sri Lanki.',
            sigiriyaDetail1: 'Odkryj starożytną twierdze skalną Sigiriya, jeden z najbardziej znanych zabytków Sri Lanki i światowe dziedzictwo UNESCO.',
            sigiriyaDetail2: 'Wejdź na imponującą skałę i eksploruj ruiny pałacu króla Kaszjapy, zdobionego freskami, ogrodami wodnymi i słynną Ścianą Luster.',
            sigiriyaDetail3: 'Ciesz się panoramicznymi widokami na otaczającą dżunglę i okolicę ze szczytu.',
            sigiriyaDetail4: 'Poznaj fascynującą historię, architekturę i legendy związane z Sigiriją od swojego eksperta.',
            sigiriyaDetail5: 'Doskonały dla miłośników historii, poszukiwaczy przygód i tych zainteresowanych bogatym dziedzictwem kulturalnym Sri Lanki.',
            kandyDetail1: 'Doświadcz tętniącej życiem kultury Kandy, ostatniej królewskiej stolicy Sri Lanki i światowego dziedzictwa UNESCO.',
            kandyDetail2: 'Odwiedź Świątynię Świętego Zęba (Sri Dalada Maligawa), jedno z najważniejszych miejsc buddyjskich na świecie.',
            kandyDetail3: 'Eksploruj Królewskie Ogrody Botaniczne w Peradenii, siedzibę ogromnej kolekcji roślin tropikalnych i orchidei.',
            kandyDetail4: 'Ciesz się tradycyjnym przedstawieniem tańca Kandyjskiego, prezentującym bogate dziedzictwo artystyczne Sri Lanki.',
            kandyDetail5: 'Idealny dla entuzjastów kultury, pasjonatów historii i tych, którzy chcą zanurzyć się w tradycjach Sri Lanki.'
        },
        blogs: {
            heroTitle: 'Blogi Muthumuni Ayurveda Beach Resort',
            heroSubtitle1: 'Historie z wybrzeża, rytuały ajurwedy w',
            heroSubtitle2: 'Muthumuni Ayurveda Beach Resort',
            heroSubtitle3: '. Zanurz się w wskazówkach, historii i notatkach z kulis.',
            heroAlt: 'Nadmorska ścieżka kurortu o zachodzie słońca',
            sectionTitle: 'Blogi Muthumuni Ayurveda Beach Resort',
            sectionDescription: 'Przewodniki, historie i notatki z naszego nadmorskiego odosobnienia — obejmujące rytuały ajurwedy, tradycje kamieni szlachetnych i porady podróżnicze wokół Bentoty.',
            ayurvedaTitle: 'Serce autentycznej ajurwedy',
            ayurvedaExcerpt: 'Doświadcz sprawdzonych tradycji leczniczych zakorzenionych w starożytnej mądrości Sri Lanki.',
            ayurvedaDescription: 'W Muthumuni Ayurveda Beach Resort ajurweda to coś więcej niż zabieg — to styl życia. Nasze terapie opierają się na wielowiekowej wiedzy, są dostosowane do twojego typu ciała i prowadzone przez doświadczonych lekarzy ajurwedyjskich dla głębokiej, trwałej równowagi.',
            ayurvedaAlt: 'Ustawienie zabiegu ajurwedyjskiego z olejkami ziołowymi i naturalnymi elementami',
            healingTitle: 'Spersonalizowane podróże lecznicze',
            healingExcerpt: 'Dlaczego program każdego gościa jest unikalnie zaprojektowany.',
            healingDescription: 'Od wstępnych konsultacji po codzienne zabiegi, twoja podróż lecznicza jest starannie dopasowana. Terapie ziołowe, masaże terapeutyczne, joga i medytacja współpracują, aby przywrócić harmonię między ciałem, umysłem i duchem.',
            healingAlt: 'Lekarz ajurwedyjski konsultujący gościa w spokojnym otoczeniu',
            natureTitle: 'Uzdrawianie nad oceanem',
            natureExcerpt: 'Jak morska bryza i tropikalne otoczenie wzmacniają twoje samopoczucie.',
            natureDescription: 'Położony wzdłuż spokojnego wybrzeża Sri Lanki, Muthumuni oferuje naturalnie uzdrawiające środowisko. Dźwięk fal, świeże morskie powietrze i bujne zieleń wzmacniają efekty ajurwedy, tworząc głęboki relaks i odnowę.',
            natureAlt: 'Widok na plażę kurortu z palmami i oceanem',
            foodTitle: 'Kuchnia ajurwedyjska dla wewnętrznej równowagi',
            foodExcerpt: 'Odżywcze posiłki przygotowane na wsparcie twojego leczenia.',
            foodDescription: 'Nasza kuchnia ajurwedyjska jest świeżo przygotowywana z sezonowych, lokalnych składników. Każdy posiłek jest dopasowany do twojej doszy, wspierając trawienie, detoksykację i ogólną witalność, pozostając przy tym smacznym i satysfakcjonującym.',
            foodAlt: 'Tradycyjny posiłek ajurwedyjski podawany w naturalnych miseczkach',
            yogaTitle: 'Joga, medytacja i wewnętrzny spokój',
            yogaExcerpt: 'Łagodne praktyki uspokajające umysł i wzmacniające ciało.',
            yogaDescription: 'Codzienne sesje jogi i medytacji uzupełniają twoje zabiegi, poprawiając elastyczność, oddech i jasność umysłu. Te uważne praktyki pomagają ci ponownie się z sobą połączyć i przenieść poczucie spokoju poza twój pobyt.',
            yogaAlt: 'Goście praktykujący jogę z widokiem na ocean o wschodzie słońca',
            lifestyleTitle: 'Zabranie ajurwedy do domu',
            lifestyleExcerpt: 'Proste praktyki stylu życia, aby kontynuować twoją podróż wellness.',
            lifestyleDescription: 'Przed wyjazdem nasi eksperci doradzą ci, jak utrzymać równowagę poprzez codzienne rutyny, dietę i rytuały samoopieki. Zabierz do domu więcej niż wspomnienia — zabierz zrównoważoną ścieżkę do zdrowszego życia.',
            lifestyleAlt: 'Gość relaksujący się z ziołową herbatą w spokojnym otoczeniu kurortu',
            readMore: 'Czytaj więcej'
        },
        events: {
            heroEyebrow: 'Doświadczenia i aktywności',
            heroTitle: 'Nasze wydarzenia',
            heroSubtitle: 'Wyselekcjonowane doświadczenia łączące tradycję Sri Lanki z nadmorskim luksusem',
            heroAlt: 'Wydarzenia w Muthumuni',
            availableDaily: 'Dostępne codziennie',
            bookNow: 'Zarezerwuj',
            highlightsTitle: 'Najważniejsze',
            detailAlt: '{{title}} – szczegóły',
            ctaTitle: 'Gotowy na tworzenie wspomnień?',
            ctaDescription: 'Skontaktuj się z naszym zespołem, aby spersonalizować idealne doświadczenie wydarzenia w Muthumuni Ayurveda Beach Resort',
            ctaContact: 'Skontaktuj się z nami',
            ctaViewRooms: 'Zobacz pokoje',
            cookeryTitle: 'Programy kulinarne',
            cookerySubtitle: 'Smak Sri Lanki',
            cookeryDescription: 'Zanurz się w żywych smakach kuchni Sri Lanki. Nasi doświadczeni szefowie kuchni prowadzą praktyczne zajęcia kulinarne, ucząc tradycyjnych przepisów przekazywanych z pokolenia na pokolenie. Naucz się przygotowywać aromatyczne curry, hoppers, kokosowy sambol i wiele więcej z użyciem świeżych lokalnych składników.',
            cookeryHighlight1: 'Tradycyjne przepisy Sri Lanki',
            cookeryHighlight2: 'Praktyczne doświadczenie kulinarne',
            cookeryHighlight3: 'Świeże lokalne składniki',
            cookeryHighlight4: 'Zabierz przepisy do domu',
            cookeryHighlight5: 'Wizyta w ogrodzie przypraw w cenie',
            meditationTitle: 'Programy medytacyjne',
            meditationSubtitle: 'Wewnętrzny spokój i uważność',
            meditationDescription: 'Znajdź spokój podczas naszych prowadzonych sesji medytacyjnych na tle spokojnego Oceanu Indyjskiego. Nasi doświadczeni instruktorzy prowadzą przez starożytne techniki uważności, ćwiczenia oddechowe i praktyki jogi zaprojektowane, aby uspokoić umysł i odnowić ducha.',
            meditationHighlight1: 'Sesje o wschodzie i zachodzie słońca',
            meditationHighlight2: 'Medytacja na plaży',
            meditationHighlight3: 'Prowadzone przez ekspertów',
            meditationHighlight4: 'Techniki oddechowe',
            meditationHighlight5: 'Praktyki jogi i uważności',
            bbqTitle: 'Imprezy BBQ',
            bbqSubtitle: 'Świętowanie na plaży',
            bbqDescription: 'Doświadcz niezapomnianych wieczorów podczas naszych imprez BBQ na plaży. Delektuj się świeżo grillowanymi owocami morza, mięsem premium i wegetariańskimi przysmakami, gdy obok szepczą fale. Muzyka na żywo, tancerze ognia i rozgwieżdżone niebo tworzą idealną atmosferę do świętowania i integracji.',
            bbqHighlight1: 'Świeżo grillowane owoce morza',
            bbqHighlight2: 'Posiłki nad oceanem',
            bbqHighlight3: 'Rozrywka na żywo',
            bbqHighlight4: 'Doświadczenie przy ognisku',
            bbqHighlight5: 'Konfigurowalne menu',
            boatTitle: 'Rejsy łodzią',
            boatSubtitle: 'Przygody rzeczne i przybrzeżne',
            boatDescription: 'Wyrusz w czarujące rejsy po rzece Bentota i wodach przybrzeżnych. Płyń przez lasy namorzynowe, obserwuj egzotyczne ptaki i dziką przyrodę lub ciesz się romantycznymi rejsami o zachodzie słońca. Nasze rejsy oferują unikalną perspektywę naturalnego piękna i różnorodnych ekosystemów Sri Lanki.',
            boatHighlight1: 'Rejsy po rzece Bentota',
            boatHighlight2: 'Eksploracja namorzynów',
            boatHighlight3: 'Obserwacja dzikiej przyrody',
            boatHighlight4: 'Rejsy o zachodzie słońca',
            boatHighlight5: 'Dostępny czarter prywatny',
            ayurvedaLecturesTitle: 'Wykłady lekarzy ajurwedyjskich',
            ayurvedaLecturesSubtitle: 'Starożytna mądrość i nowoczesny wellness',
            ayurvedaLecturesDescription: 'Poznaj głębokie zasady ajurwedy dzięki wykładom prowadzonym przez certyfikowanych lekarzy ajurwedyjskich i praktyków. Dowiedz się o równoważeniu dosz, ziołowych środkach, holistycznych praktykach leczenia oraz o tym, jak starożytna mądrość odnosi się do nowoczesnego wellness. Nasze interaktywne sesje wyjaśniają filozofię ajurwedy i jej zastosowanie w codziennym życiu.',
            ayurvedaLecturesHighlight1: 'Certyfikowani lekarze ajurwedyjscy',
            ayurvedaLecturesHighlight2: 'Spersonalizowana analiza doszy',
            ayurvedaLecturesHighlight3: 'Edukacja o ziołowych środkach',
            ayurvedaLecturesHighlight4: 'Sesje pytań i odpowiedzi',
            ayurvedaLecturesHighlight5: 'Przewodnik do zabrania',
            traditionalClothsTitle: 'Wydarzenia z tradycyjnym strojem',
            traditionalClothsSubtitle: 'Doświadczenie dziedzictwa kulturowego',
            traditionalClothsDescription: 'Zanurz się w dziedzictwie kulturowym Sri Lanki, ucząc się nosić i doceniać tradycyjny strój. Nasi styliści poprowadzą Cię przez zakładanie autentycznych kandiańskich sari i tradycyjnych ubiorów, wyjaśniając znaczenie kulturowe każdego elementu. Idealne na specjalne okazje, dla docenienia kultury lub stworzenia niezapomnianych zdjęć.',
            traditionalClothsHighlight1: 'Profesjonalne wskazówki stylizacyjne',
            traditionalClothsHighlight2: 'Autentyczne tradycyjne sari',
            traditionalClothsHighlight3: 'Wyjaśnienie znaczenia kulturowego',
            traditionalClothsHighlight4: 'Wliczona profesjonalna fotografia',
            traditionalClothsHighlight5: 'Warsztaty fuzji mody'
        },
        contact: {
            heroTitle: 'Skontaktuj się z nami',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Skontaktuj się z nami',
            sectionTitle: 'Zapraszamy do kontaktu',
            sectionSubtitle: 'Jesteśmy tutaj, aby pomóc Ci się zrelaksować i zregenerować',
            sectionDescription: 'Skontaktuj się z Muthumuni Ayurveda Beach Resort w sprawie pobytu ajurwedyjskiego, pakietów wellness, rezerwacji lub pytań podczas pobytu w Beruwali, Moragalla.',
            callUs: 'Zadzwoń do nas',
            emailTitle: 'Email',
            ourLocation: 'Nasza lokalizacja',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Media społecznościowe',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Napisz do nas',
            getInTouchDescription: 'Chętnie od Ciebie usłyszymy — nasz zespół jest gotowy pomóc w planowaniu pobytu, odpowiedzieć na pytania i wesprzeć Twoją podróż wellness.',
            nameLabel: 'Imię',
            emailLabel: 'Email',
            contactNumberLabel: 'Numer kontaktowy',
            messageLabel: 'Wiadomość',
            sending: 'Wysyłanie...',
            sendMessage: 'Wyślij wiadomość',
            successMessage: 'Twoja wiadomość została wysłana! Wkrótce się odezwiemy.',
            errorMessage: 'Wystąpił błąd podczas wysyłania. Spróbuj ponownie.',
            findUsOnMap: 'Znajdź nas na mapie',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Imię',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numer kontaktowy',
            whatsappMessage: 'Wiadomość'
        },

        contact2: {
            heroTitle: 'Skontaktuj się z nami',
            heroSubtitle: 'Muthumuni Ayurveda Beach Resort',
            heroAlt: 'Skontaktuj się z nami',
            sectionTitle: 'Zapraszamy do kontaktu',
            sectionSubtitle: 'Jesteśmy tutaj, aby pomóc Ci się zrelaksować i zregenerować',
            sectionDescription: 'Skontaktuj się z Muthumuni Ayurveda Beach Resort w sprawie pobytu ajurwedyjskiego, pakietów wellness, rezerwacji lub pytań podczas pobytu w Beruwali, Moragalla.',
            callUs: 'Zadzwoń do nas',
            emailTitle: 'Email',
            ourLocation: 'Nasza lokalizacja',
            locationAddress: '80/24, Beach Side, Police Bunglow Road, Beruwala, Sri Lanka.',
            socialNetwork: 'Media społecznościowe',
            ariaFacebook: 'Facebook',
            ariaInstagram: 'Instagram',
            ariaWhatsApp: 'WhatsApp',
            ariaTikTok: 'TikTok',
            getInTouch: 'Napisz do nas',
            getInTouchDescription: 'Chętnie od Ciebie usłyszymy — nasz zespół jest gotowy pomóc w planowaniu pobytu, odpowiedzieć na pytania i wesprzeć Twoją podróż wellness.',
            nameLabel: 'Imię',
            emailLabel: 'Email',
            contactNumberLabel: 'Numer kontaktowy',
            messageLabel: 'Wiadomość',
            sending: 'Wysyłanie...',
            sendMessage: 'Wyślij wiadomość',
            successMessage: 'Twoja wiadomość została wysłana! Wkrótce się odezwiemy.',
            errorMessage: 'Wystąpił błąd podczas wysyłania. Spróbuj ponownie.',
            findUsOnMap: 'Znajdź nas na mapie',
            whatsappSubject: 'Kontakt Muthumuni Ayurveda Beach Resort',
            whatsappName: 'Imię',
            whatsappEmail: 'Email',
            whatsappContactNumber: 'Numer kontaktowy',
            whatsappMessage: 'Wiadomość'
        },


        ayurveda: {
            accordionTitle1: 'Czym jest Pańczakarma Ajurweda?',
            accordionDesc1: 'Ajurweda to jeden z najstarszych systemów leczenia na świecie, rozwinięty ponad 5000 lat temu. Pańczakarma Ajurweda opiera się na przekonaniu, że zdrowie zależy od równowagi między umysłem, ciałem, duszą i środowiskiem.',
            accordionTitle2: 'Pańczakarma Ajurweda i energia życiowa',
            accordionDesc2: 'Ajurweda opiera się na teorii wzajemnego powiązania wszystkiego we wszechświecie. Ci, którzy praktykują Ajurwedę, wierzą, że każda osoba składa się z pięciu elementów: przestrzeń, powietrze, ogień, woda i ziemia. Tworzą one trzy dosze: VATA, PITTA i KAPHA.',
            accordionTitle3: 'Dosza Vata',
            accordionDesc3: 'Najpotężniejsza dosza kontrolująca podstawowe funkcje organizmu: podział komórek, oddychanie, przepływ krwi, pracę serca. Przy dominującej Vacie jesteś inteligentny, kreatywny, energiczny. W braku równowagi - lęk. Równowaga przez medytację, masaż i ciepłe jedzenie.',
            accordionTitle4: 'Dosza Pitta',
            accordionDesc4: 'Kontroluje trawienie, metabolizm i hormony. Przy dominującej Pitcie jesteś zdeterminowany, konkurencyjny, pewny siebie. W braku równowagi - drażliwość. Równowaga przez chłodzące jedzenie i powolną jogę.',
            accordionTitle5: 'Dosza Kapha',
            accordionDesc5: 'Kontroluje wzrost mięśni, siłę ciała i odporność. Przy dominującej Kaphie lubisz rutynę, jesteś spokojny i cierpliwy. W braku równowagi - zmęczenie i przyrost wagi. Równowaga przez owoce, warzywa i ćwiczenia.',
            close: 'Zamknij',
            next: 'Następny',
            previous: 'Poprzedni',
            treatmentsTitle: 'Nasze charakterystyczne zabiegi Pańczakarma Ajurwedy',
            treatmentsSubtitle: 'Doświadcz starożytnych terapii przywracających równowagę, uwalniających napięcie i odmładzających całą twoją istotę.',
            bookTreatment: 'Zarezerwuj ten zabieg',
            benefitsTitle: 'Korzyści zabiegów Pańczakarma',
            shirodhara: 'Śirodhara',
            shirodharaDesc: 'Delikatne polewanie ciepłym ziołowym olejem na czoło w celu uspokojenia umysłu.',
            shirodhara1: 'Zmniejsza stres i lęk',
            shirodhara2: 'Promuje lepszy sen',
            shirodhara3: 'Poprawia jasność umysłu',
            steamBath: 'Łaźnia parowa',
            steamBathDesc: 'Detoksykujący zabieg parowy otwierający pory i relaksujący mięśnie.',
            steamBath1: 'Detoksykuje ciało',
            steamBath2: 'Poprawia krążenie krwi',
            steamBath3: 'Łagodzi napięcie mięśni',
            flowerBath: 'Kąpiel kwiatowa',
            flowerBathDesc: 'Uspokajająca kąpiel z aromatycznymi kwiatami dla relaksacji.',
            flowerBath1: 'Uspokaja układ nerwowy',
            flowerBath2: 'Nawilża skórę',
            flowerBath3: 'Podnosi nastrój',
            headMassage: 'Masaż głowy',
            headMassageDesc: 'Relaksujący masaż skóry głowy w celu uwolnienia napięcia.',
            headMassage1: 'Zmniejsza bóle głowy',
            headMassage2: 'Poprawia zdrowie skóry głowy',
            headMassage3: 'Promuje relaksację',
            faceMassage: 'Masaż twarzy',
            faceMassageDesc: 'Odmładzający masaż poprawiający blask twarzy i zmniejszający stres.',
            faceMassage1: 'Poprawia koloryt skóry',
            faceMassage2: 'Zmniejsza napięcie twarzy',
            faceMassage3: 'Promuje drenaż limfatyczny',
            neckMassage: 'Masaż szyi',
            neckMassageDesc: 'Ukierunkowany masaż łagodzący sztywność i napięcie szyi.',
            neckMassage1: 'Łagodzi ból szyi',
            neckMassage2: 'Poprawia elastyczność',
            neckMassage3: 'Zmniejsza stres',
            shoulderMassage: 'Masaż ramion',
            shoulderMassageDesc: 'Ukierunkowany masaż łagodzący sztywność i dyskomfort ramion.',
            shoulderMassage1: 'Zmniejsza ból ramion',
            shoulderMassage2: 'Poprawia postawę',
            shoulderMassage3: 'Rozluźnia mięśnie',
            bodyMassage: 'Masaż całego ciała',
            bodyMassageDesc: 'Masaż całego ciała promujący relaksację i dobre samopoczucie.',
            bodyMassage1: 'Poprawia krążenie krwi',
            bodyMassage2: 'Łagodzi bóle mięśni',
            bodyMassage3: 'Promuje relaksację',
            backMassage: 'Masaż pleców',
            backMassageDesc: 'Terapeutyczny masaż zajmujący się bólami i napięciem pleców.',
            backMassage1: 'Łagodzi ból pleców',
            backMassage2: 'Poprawia zdrowie kręgosłupa',
            backMassage3: 'Zmniejsza stres',
            footMassage: 'Masaż stóp',
            footMassageDesc: 'Uspokajający masaż łagodzący ból stóp i relaksujący.',
            footMassage1: 'Poprawia krążenie krwi',
            footMassage2: 'Zmniejsza zmęczenie stóp',
            footMassage3: 'Promuje relaksację',
            purgative: 'Środek przeczyszczający',
            purgativeDesc: 'Terapia oczyszczająca usuwająca nadmiar Pitty i toksyn z układu trawiennego.',
            purgative1: 'Oczyszcza jelita',
            purgative2: 'Równoważy doszę Pitta',
            purgative3: 'Poprawia zdrowie trawienne',
            nasalClearing: 'Oczyszczanie nosa',
            nasalClearingDesc: 'Terapeutyczne leczenie nosa oczyszczające zatoki i poprawiające funkcję oddechową.',
            nasalClearing1: 'Eliminuje zatkany nos',
            nasalClearing2: 'Poprawia oddychanie',
            nasalClearing3: 'Łagodzi problemy z zatokami',
            powderMassage: 'Masaż proszkiem',
            powderMassageDesc: 'Peeling masażem z ziołowymi proszkami odmładzający i odświeżający skórę.',
            powderMassage1: 'Usuwa martwy naskórek',
            powderMassage2: 'Poprawia teksturę skóry',
            powderMassage3: 'Promuje krążenie krwi',
            intensiveMassageDesc: 'Głęboki masaż terapeutyczny ukierunkowany na przewlekłe napięcia i węzły mięśniowe z mocnym naciskiem i specjalistycznymi technikami.',
            intensiveMassage1: 'Rozluźnia głębokie napięcie mięśniowe',
            intensiveMassage2: 'Poprawia krążenie krwi',
            intensiveMassage3: 'Zmniejsza ból mięśni',
            thermoMassage: 'Masaż Termiczny',
            thermoMassageDesc: 'Ciepły masaż olejem ziołowym z podgrzewanymi olejami terapeutycznymi, wzmacniający relaks i efekty lecznicze.',
            thermoMassage1: 'Łagodzi obolałe mięśnie',
            thermoMassage2: 'Promuje głęboki relaks',
            thermoMassage3: 'Poprawia przepływ energii',
            synchronMassage: 'Masaż Synchronizowany',
            synchronMassageDesc: 'Zsynchronizowany masaż wykonywany przez dwóch terapeutów dla pełnej harmonii ciała i zrównoważonego rozkładu energii.',
            synchronMassage1: 'Pełna harmonia ciała',
            synchronMassage2: 'Zrównoważony przepływ energii',
            synchronMassage3: 'Głębokie doświadczenie relaksu',
            specialMassage: 'Masaż Specjalny',
            specialMassageDesc: 'Spersonalizowana terapia masażem dostosowana do Twoich konkretnych potrzeb zdrowotnych i osobistych celów wellness.',
            specialMassage1: 'Spersonalizowane leczenie',
            specialMassage2: 'Skierowany na konkretne problemy',
            specialMassage3: 'Indywidualne podejście lecznicze',
            benefit1Title: 'Detoksykacja:',
            benefit1Desc: 'Zabiegi Pańczakarma pomagają usunąć toksyny z ciała, promując zdrowie i witalność.',
            benefit2Title: 'Poprawione trawienie:',
            benefit2Desc: 'Te terapie poprawiają funkcję trawienną dla lepszego wchłaniania składników odżywczych i metabolizmu.',
            benefit3Title: 'Redukcja stresu:',
            benefit3Desc: 'Pańczakarma jest znana ze swoich uspokajających efektów na ciało i umysł, zmniejszając poziomy stresu i lęku.',
            benefit4Title: 'Wzmocnienie odporności:',
            benefit4Desc: 'Regularne zabiegi Pańczakarma wzmacniają układ odpornościowy, czyniąc ciało bardziej odpornym.',
            benefit5Title: 'Odmłodzenie:',
            benefit5Desc: 'Terapie promują regenerację komórek dla poprawy zdrowia skóry i młodzieńczego wyglądu.',
            benefit6Title: 'Równowaga dosz:',
            benefit6Desc: 'Pańczakarma pomaga przywrócić równowagę dosz (Vata, Pitta, Kapha), co jest niezbędne dla zdrowia zgodnie z zasadami ajurwedy.',
            akkupancharTitle: 'Terapia Akkupanczar',
            akkupancharDesc1: 'jest starożytną terapią ajurwedyjską wykorzystującą ziołowe pasty i oleje na określonych punktach ciała. To leczenie stymuluje kanały energetyczne i promuje uzdrawianie.',
            akkupancharBenefit: 'Główne korzyści:',
            akkupancharDesc2: 'Ta specjalistyczna terapia pomaga w chronicznym bólu, poprawia elastycznośćstawów, promuje krążenie krwi i przywraca naturalny przepływ energii.',
            akkupancharApplication: 'Zastosowanie terapeutyczne:',
            akkupancharDesc3: 'Akkupanczar działa na określone punkty marma z ostrożnie dobranymi ziołowymi preparatami do równoważenia dosz.',
            akkupancharTransform: 'Doświadcz transformacji:',
            akkupancharDesc4: 'W Muthumuni Ayurveda Beach Resort nasi doświadczeni terapeuci dostosowują każdą sesję do Twoich potrzeb zdrowotnych.',
            gallery1: 'Terapia Śirodhara',
            gallery2: 'Łaźnia parowa',
            gallery3: 'Kąpiel kwiatowa',
            gallery4: 'Masaż głowy',
            gallery5: 'Masaż całego ciała',
            gallery6: 'Masaż szyi',
            gallery7: 'Masaż twarzy',
            gallery8: 'Masaż ramion',
            heroTitle: 'Pańczakarma Ajurweda',
            heroSubtitle: 'Odmłódź Ciało, Umysł i Duszę w Beruwali',
            sectionEyebrow: 'PAŃCZAKARMA AJURWEDA W MUTHUMUNI AYURVEDA BEACH RESORT',
            sectionDescription: 'Odkryj starożytną sztukę uzdrawiającą Pańczakarmę w Muthumuni Ayurveda Beach Resort w Beruwali. Nasi doświadczeni praktycy oferują spersonalizowane zabiegi do detoksykacji, odmłodzenia i przywrócenia równowagi.',
            treatmentProgramme: {
                title: 'Program Leczenia Ajurwedyjskiego',
                subtitle: 'Twoja Podróż ku Równowadze, Detoksykacji i Głębokiej Odnowie',
                intro: 'Doświadcz autentycznego uzdrawiania ajurwedyjskiego w spokojnym ośrodku zaprojektowanym do przywrócenia ciała, uspokojenia umysłu i odnowienia energii. Od momentu przyjazdu nasz zespół dba o każdy szczegół—abyś mógł w pełni skupić się na swoim samopoczuciu.',
                welcomeTitle: 'Powitanie i Łagodny Początek',
                welcomePoints: [
                    'Odbiór z lotniska i transfer do hotelu',
                    'Ciepłe powitanie i orientacja w hotelu',
                    'Wprowadzenie do cotygodniowego programu wellness',
                    'Masaż Relaksacyjny (Dzień 1) w Centrum Ajurwedy, aby uwolnić zmęczenie podróżą i przygotować ciało do zabiegów'
                ],
                doctorTitle: 'Konsultacja Lekarska i Plan Osobisty',
                doctorPoints: [
                    'Konsultacja z Lekarzem Ajurwedy (Dzień 2 – rano)',
                    'Pełna ocena Twojej Doshy/typu ciała i problemów zdrowotnych',
                    'Tłumacz dostępny na życzenie',
                    'Twój lekarz tworzy spersonalizowany plan leczenia dostosowany do Twoich potrzeb i celów'
                ],
                dailyTherapiesTitle: 'Codzienne Terapie Ajurwedyjskie',
                dailyTherapiesPoints: [
                    '4–5 zabiegów dziennie (zgodnie z zaleceniami lekarza)',
                    'Terapie wybrane na podstawie Twojej konstytucji ciała i stanu',
                    'Specjalne masaże mogą być dodane w razie potrzeby',
                    'Lekarz monitoruje postępy codziennie i może dostosować zabiegi i wsparcie ziołowe, aby zapewnić najlepsze wyniki',
                    'W razie potrzeby może zostać zalecony łagodny proces oczyszczania/przeczyszczania'
                ],
                herbalMedicineTitle: 'Wsparcie Medycyną Ziołową',
                herbalMedicinePoints: [
                    'Przepisane przez lekarza leki ziołowe podawane dwa razy dziennie:',
                    'Podczas śniadania',
                    'Podczas kolacji',
                    'Wspierające wewnętrzne uzdrawianie, detoksykację i trwałą równowagę'
                ],
                yogaMeditationTitle: 'Joga i Medytacja dla Harmonii Ciała i Umysłu',
                yogaMeditationPoints: [
                    'Sesje jogi 4 razy w tygodniu (około 1 godzina)',
                    'Sesje medytacji 2 razy w tygodniu:',
                    'Unikalne doświadczenie duchowe w Świątyni na Wyspie, dostępnej łodzią',
                    'Medytacja prowadzona przez mnichów (około 1 godzina)'
                ],
                wellnessTitle: 'Wliczone Doświadczenia Wellness',
                wellnessPoints: [
                    'Cotygodniowe pokazy zdrowego gotowania',
                    'Darmowa wycieczka (doświadczenie kulturowe/przyrodnicze)'
                ],
                closingTitle: 'Rytuał Zamknięcia i Wyjazd',
                closingPoints: [
                    'Piękna Kąpiel Kwiatowa (ostatni dzień)—tradycyjny rytuał odnowy',
                    'Końcowa Konsultacja Lekarska w celu przeglądu postępów i zapewnienia:',
                    'Ciągłych wskazówek wellness',
                    'Recept i zaleceń dla domu',
                    'Transfer z powrotem na lotnisko'
                ]
            },
        },
        food: {
            heroTitle: 'Kuchnia ajurwedyjska i kuchnia przybrzeżna',
            heroSubtitle: 'Autentyczne smaki Sri Lanki i świeża kuchnia przybrzeżna',
            heroAlt: 'Doświadczenie kulinarne w Muthumuni Beach Resort',
            wellnessEyebrow: 'przez jedzenie',
            wellnessTitle: 'Znaczenie',
            ayurvedicFood: 'jedzenia ajurwedyjskiego',
            wellnessIntro1: 'W ajurwedzie jedzenie uważa się za największą medycynę. To, co jesz, bezpośrednio wpływa na twoje dosze (Vata, Pitta, Kapha), trawienie (agni) i ogólną równowagę ciała, umysłu i ducha.',
            wellnessIntro2: 'Odżywianie ajurwedyjskie podkreśla świeże, sezonowe, całe pokarmy przygotowywane z troską i świadomym jedzeniem. Promuje sześć smaków (słodki, kwaśny, słony, pikantny, gorzki, terpenujący) w każdym posiłku, aby odżywiać wszystkie zmysły i utrzymać harmonię.',
            wellnessIntro3: 'Właściwe jedzenie ajurwedyjskie wspiera silne trawienie, pomaga usuwać toksyny (ama), wzmacnia odporność, poprawia energię, zmniejsza stres i zapobiega wielu schorzeniom przewlekłym. W Muthumuni każde danie jest ostrożnie przygotowywane, aby dostosować się do Twojej unikalnej konstytucji w celu głębokich gojenia i witalności.',
            foodImage1Alt: 'Tradycyjny posiłek ajurwedyjski z sześcioma smakami',
            foodImage2Alt: 'Zioła ajurwedyjskie i przyprawy do zbilansowanej odżywiania',
            culinaryPhilosophyEyebrow: 'Nasza filozofia kulinarna',
            culinaryPhilosophyTitle: 'Odżywianie',
            nutritionHighlight: 'ajurwedyjskie',
            culinaryPhilosophyResort: 'w Muthumuni Ayurveda Beach Resort',
            nutritionTopImageAlt: 'Kuchnia ajurwedyjska w Muthumuni Ayurveda River Resort',
            freshNourishingLabel: 'Świeże i pożywne',
            healingIngredientsAlt: 'Zdrowe składniki ajurwedyjskie i przyprawy',
            healingIngredientsLabel: 'Uzdrawiające składniki',
            philosophyText1: 'Jedzenie, które obejmuje sześć głównych smaków (słodki, kwaśny, słony, gorzki, pikantny i terminujący) wraz z wieloma subtelnym wariacjami, zostało opisane w klasycznych tekstach ajurwedyjskich — niektóre pochodzą z ponad 5000 lat temu — wraz z istotnymi właściwościami każdego pokarmu: Guna (jakość wrodzona), Virya (potencja/grzewcza lub chłodząca), Vipaka (wpływ po trawieniu) i Prabhava (unikalna akcja szczególna).',
            philosophyText2: 'W rezultacie odżywianie ajurwedyjskie odgrywa główną rolę w Muthumuni Ayurveda Beach Resort. Nie oznacza to sztywnego, monotonnego schematu niegrackich, bezsmakowych lub nadmiernie gorzkich posiłków wegetariańskich nakazanego wyłącznie przez lekarzy. Wręcz przeciwnie, nasza kuchnia ajurwedyjska jest jedną z naszych największych mocnych stron: potrawy przygotowywane przez naszych doświadczonych szefów kuchni będą Cię zadziwiać i delektować się każdego dnia pobytu!',
            philosophyText3: 'Na śniadanie ciesz się bogatym buffetem z świeżymi owocami tropikalnymi, świeżo wyciskanym sokiem, pożywną zupą z ziół, domowym chlebem i lekkimi ciasteczkami, a także wieloma autentycznymi opcjami śniadania na Sri Lance. Na obiad kosztuj kolorowego i smacznego bufetu z łagodnym curry rybnym, przygotowaniem warzyw i potrawami infuzowanymi ziołami. Wieczorem podajemy ustalane menu wegetariańskie z dostępną opcją świeżej ryby. W soboty świętujemy „Noc Sri Lanki" z powiększonym buffetem — nasi szefowie kuchni przygotowywają tradycyjne specjalności lokalne bezpośrednio przed tobą, tworząc żywą i autentyczną doświadczenie.',
            philosophyText4: 'W ajurwedzie żywność i napoje są klasyfikowane na wiele sposobów — w zależności od smaku i właściwości, zdolności trawiennej organizmu (agni), przydatności do określonych stanów zdrowotnych, stosowności sezonowej i więcej. W Muthumuni ostrożnie rozważamy wszystkie te czynniki jednocześnie, świadomie starając się uwzględnić wszystkie sześć smaków w zbilansowanych kombinacjach dostosowanych do indywidualnej konstytucji każdego gościa.',
            philosophyText5: 'Nasze posiłki zawierają świeże warzywa, owoce tropikalne i odpowiedzialnie pozyskane ryby. Nie serwujemy czerwonego mięsa ani alkoholu.',
            philosophyText6: 'Podczas posiłków lekarz ajurwedyjski lub wykwalifikowany dietetyk jest zawsze dostępny, aby Cię prowadzić. Doradzą Ci na temat najbardziej odpowiedniej warzyw, ziół i przypraw do Twojej obecnej fazy leczenia i pomogą Ci odpowiednio wybierać lub unikać potraw. Twój spersonalizowany eliksir z ziół i wszelkie określone instrukcje od zespołu centrum zdrowia będą umieszczone na Twoim indywidualnym stole.',
            philosophyText7: 'Ten poziom osobistej opieki i uwagi do diety jest wyróżniającą cechą doświadczenia Muthumuni Ayurveda Beach Resort.',
            philosophyText8: 'Żywność jest uważana za Pranę — główną energię wspierającą życie — dla każdego człowieka. Dlatego zachęcamy Cię do podejścia do każdego posiłku pełną świadomością: smakując zapachy, doświadczając smaków, odczuwając łagodne ciepło i ciesząc się urokami świadomością.',
            diningExperienceEyebrow: 'Doświadczenie kulinarne',
            restaurantTitlePrefix: 'Nasz',
            ayurvedicHighlight: 'ajurwedyjski',
            restaurantTitleSuffix: 'restauracja',
            restaurantDetail1: 'Nasza ajurwedyjska restauracja w Muthumuni Beach Resort oferuje unikalne doświadczenie kulinarne, które harmonizuje tradycyjne zasady ajurwedyjskie z autentyczną przybrzeżną kuchnią Sri Lanki. Priorytetyzujemy świeże, lokalnie pozyskane składniki, aby stworzyć posiłki, które nie tylko zachwycają podniebienie, ale także promują holistyczne dobrostanu.',
            restaurantDetail2: 'Menu jest ostrożnie opracowana, aby zbilansować sześć smaków (słodki, kwaśny, słony, gorzki, pikantny, terpenujący) w każdym daniu, zapewniając pożywne i satysfakcjonujące doświadczenie. Każdy posiłek jest przygotowywany z troską, zawierający zioła ajurwedyjskie i przyprawy znane z ich właściwości uzdrawiających.',
            restaurantDetail3: 'Goście mogą cieszyć się różnorodnością potraw dostosowanych do ich indywidualnych dosech (typów ciała), z opcjami dla diet wegetariańskiej, wegańskiej i pescetariańskiej. Nasi szefowie kuchni ściśle współpracują z praktykami ajurwedyjskimi, aby zapewnić, że każdy posiłek wspiera cele zdrowia i dobrostanu gości.',
            restaurantDetail4: 'Atmosfera restauracji odzwierciedla spokojne przybrzeżne otoczenie, zapewniając spokojne otoczenie do świadomego jedzenia. Niezależnie od tego, czy cieszysz się hojnym śniadaniowym buffetem, czy smakowaniem gourmetową kolacją, każdy posiłek w naszej ajurwedyjskiej restauracji jest okazją do odżywienia ciała i duszy.',
            restaurantDetail5: 'Dołącz do nas w ajurwedyjskiej restauracji Muthumuni Beach Resort w podróży kulinarnej, która świętuje bogate smaki Sri Lanki, jednocześnie przyjmując ponadczasową mądrość Ajurvedy.',
            restaurantImageAlt: 'Jedzenie w Muthumuni Ayurveda River Resort',
            premiumDiningLabel: 'Prywatne jedzenie',
            premiumDiningDescription: 'Doświadczenie autentycznej kuchni ajurwedyjskiej w spokojnym otoczeniu nadrzecznym'
        },
        deluxerooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Pokój Deluxe — Komfort z tarasem lub prywatnym balkonem',
            heroSubtitle: 'Wypocznij w spokojnym ustroniu nad rzeką, inspirowanym spokojnymi wodami Bentoty, z nowoczesnymi udogodnieniami i delikatną речną bryzą.',
            bookThisRoom: 'Zarezerwuj ten pokój',
            callReservations: 'Zadzwoń do rezerwacji',

            navAll: 'Wszystkie',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe z widokiem na rzekę',

            soothingHideawayTitle: 'Spokojna oaza nad rzeką',
            soothingHideawayDesc: 'Pokój Deluxe został zaprojektowany z myślą o leniwych porankach i beztroskich zachodzie słońca. Miękkie neutralne kolory, duże przeszklenia i starannie dobrane oświetlenie wpuszczają widok na rzekę do wnętrza, a balkon staje się Twoim prywatnym zakątkiem nad płynącą wodą.',

            highlight1Title: 'Panoramiczny widok na rzekę',
            highlight1Desc: 'Budź się z widokiem na spokojną rzekę i tropikalne wschody słońca z Twojego prywatnego balkonu.',
            highlight2Title: 'Eleganckie wnętrza nad rzeką',
            highlight2Desc: 'Miękkie neutralne odcienie, ciepłe drewniane akcenty i obfite naturalne światło.',
            highlight3Title: 'Spokojne doświadczenie snu',
            highlight3Desc: 'Puszyste łóżko king-size z pościelą premium dla regenerującego wypoczynku.',

            atAGlance: 'Na pierwszy rzut oka',
            statSizeLabel: 'Powierzchnia',
            statViewLabel: 'Widok',
            statViewValue: 'Na rzekę',
            statGuestsLabel: 'Goście',
            statBedLabel: 'Łóżko',
            statBedValue: 'King lub Twin',
            reserve: 'Rezerwuj',

            includedWithStay: 'Wliczone w pobyt',
            thoughtfulTouches: 'Drobiazgi z myślą o Tobie, komfort przez cały dzień',
            enhancedCleanliness: 'Podwyższone standardy czystości i bezpieczeństwa',

            inclusion1: 'Bezpłatne śniadanie, obiad i kolacja w restauracji Breeze',
            inclusion2: 'Szybkie Wi-Fi i stanowisko pracy w pokoju',
            inclusion3: 'Całodobowy room service i concierge',
            inclusion4: 'Codzienne sprzątanie z wieczornym turndownem',
            inclusion5: 'Dostęp do basenu bez krawędzi i spa ajurwedyjskiego',
            inclusion6: 'Bezpłatny parking i transfer do pobliskich atrakcji',

            amenityGroup1Title: 'Cechy pokoju',
            amenityGroup1Item1: '41 m² przestrzeni',
            amenityGroup1Item2: 'Prywatny balkon z miejscem do siedzenia',
            amenityGroup1Item3: 'Klimatyzacja z indywidualną regulacją',
            amenityGroup1Item4: 'Sejf w pokoju',

            amenityGroup2Title: 'Łazienka',
            amenityGroup2Item1: 'Prysznic deszczowy z ciepłą i zimną wodą',
            amenityGroup2Item2: 'Premium kosmetyki kąpielowe',
            amenityGroup2Item3: 'Suszarka do włosów',
            amenityGroup2Item4: 'Miękkie szlafroki i kapcie',

            amenityGroup3Title: 'Komfort w pokoju',
            amenityGroup3Item1: '55-calowy Smart TV z kablówką',
            amenityGroup3Item2: 'Stacja na kawę i herbatę',
            amenityGroup3Item3: 'Telefon z bezpośrednim wyborem',

            amenityGroup4Title: 'Łączność',
            amenityGroup4Item1: 'Bezpłatne Wi-Fi',
            amenityGroup4Item2: 'Biurko',
            amenityGroup4Item3: 'Wsparcie recepcji 24/7',

            inRoomEssentials: 'Podstawowe wyposażenie pokoju',
            everythingYouNeed: 'Wszystko, czego potrzebujesz, by poczuć się jak w domu',
            inRoomEssentialsDesc: 'Od bezproblemowego połączenia po starannie wybrane napoje — pokój Deluxe łączy relaks z praktycznością, abyś mógł skupić się na najważniejszych chwilach.',

            complimentaryWifi: 'Bezpłatne Wi-Fi',
            coffeeTeaStation: 'Stacja na kawę i herbatę',
            roomService: 'Room service 24/7',
            rainShower: 'Prysznic deszczowy',

            byTheRiver: 'Nad rzeką',
            slowDownBreathe: 'Zwolnij, odetchnij świeżym powietrzem',

            readyToStay: 'Gotowy na pobyt?',
            reserveDeluxeToday: 'Zarezerwuj pokój Deluxe już dziś',
            speakReservations: 'Skontaktuj się z naszym zespołem rezerwacji, aby uzyskać najlepsze dostępne ceny i specjalne oferty.',
            checkAvailability: 'Sprawdź dostępność'
        },
        deluxeriverrooms2: {
            resortName: 'MUTHUMUNI AYURVEDA RIVER RESORT',
            heroTitle: 'Pokój Deluxe z widokiem na rzekę — Komfort z tarasem lub prywatnym balkonem',
            heroSubtitle: 'Wypocznij w spokojnym ustroniu nad rzeką, inspirowanym spokojnymi wodami Bentoty, z nowoczesnymi udogodnieniami i delikatną речną bryzą.',
            bookThisRoom: 'Zarezerwuj ten pokój',
            callReservations: 'Zadzwoń do rezerwacji',

            navAll: 'Wszystkie',
            navDeluxe: 'Deluxe',
            navRiverViewDeluxe: 'Deluxe z widokiem na rzekę',

            soothingHideawayTitle: 'Spokojna oaza nad rzeką',
            soothingHideawayDesc: 'Nasz pokój Deluxe z widokiem na rzekę został zaprojektowany z myślą o leniwych porankach i beztroskich zachodzie słońca. Miękkie neutralne kolory, duże przeszklenia i starannie dobrane oświetlenie wpuszczają widok na rzekę do wnętrza, a balkon staje się Twoim prywatnym zakątkiem nad płynącą wodą.',

            highlight1Title: 'Panoramiczny widok na rzekę',
            highlight1Desc: 'Budź się z widokiem na spokojną rzekę i złote wschody słońca z Twojego prywatnego balkonu.',
            highlight2Title: 'Eleganckie wnętrza nad rzeką',
            highlight2Desc: 'Miękkie neutralne odcienie, ciepłe drewniane akcenty i obfite naturalne światło.',
            highlight3Title: 'Spokojne doświadczenie snu',
            highlight3Desc: 'Puszyste łóżko king-size z pościelą premium dla regenerującego wypoczynku.',

            atAGlance: 'Na pierwszy rzut oka',
            statSizeLabel: 'Powierzchnia',
            statViewLabel: 'Widok',
            statViewValue: 'Na rzekę',
            statGuestsLabel: 'Goście',
            statBedLabel: 'Łóżko',
            statBedValue: 'King lub Twin',
            reserve: 'Rezerwuj',

            includedWithStay: 'Wliczone w pobyt',
            thoughtfulTouches: 'Drobiazgi z myślą o Tobie, komfort przez cały dzień',
            enhancedCleanliness: 'Podwyższone standardy czystości i bezpieczeństwa',

            inclusion1: 'Bezpłatne śniadanie, obiad i kolacja w restauracji Breeze',
            inclusion2: 'Szybkie Wi-Fi i stanowisko pracy w pokoju',
            inclusion3: 'Całodobowy room service i concierge',
            inclusion4: 'Codzienne sprzątanie z wieczornym turndownem',
            inclusion5: 'Dostęp do basenu bez krawędzi i spa ajurwedyjskiego',
            inclusion6: 'Bezpłatny parking i transfer do pobliskich atrakcji',

            amenityGroup1Title: 'Cechy pokoju',
            amenityGroup1Item1: '38 m² przestrzeni',
            amenityGroup1Item2: 'Prywatny balkon z miejscem do siedzenia',
            amenityGroup1Item3: 'Klimatyzacja z indywidualną regulacją',
            amenityGroup1Item4: 'Sejf w pokoju',

            amenityGroup2Title: 'Łazienka',
            amenityGroup2Item1: 'Prysznic deszczowy z ciepłą i zimną wodą',
            amenityGroup2Item2: 'Premium kosmetyki kąpielowe',
            amenityGroup2Item3: 'Suszarka do włosów',
            amenityGroup2Item4: 'Miękkie szlafroki i kapcie',

            amenityGroup3Title: 'Komfort w pokoju',
            amenityGroup3Item1: '55-calowy Smart TV z kablówką',
            amenityGroup3Item2: 'Stacja na kawę i herbatę',
            amenityGroup3Item3: 'Telefon z bezpośrednim wyborem',

            amenityGroup4Title: 'Łączność',
            amenityGroup4Item1: 'Bezpłatne Wi-Fi',
            amenityGroup4Item2: 'Biurko',
            amenityGroup4Item3: 'Wsparcie recepcji 24/7',

            inRoomEssentials: 'Podstawowe wyposażenie pokoju',
            everythingYouNeed: 'Wszystko, czego potrzebujesz, by poczuć się jak w domu',
            inRoomEssentialsDesc: 'Od bezproblemowego połączenia po starannie wybrane napoje — pokój Deluxe z widokiem na rzekę łączy relaks z praktycznością, abyś mógł skupić się na najważniejszych chwilach.',

            complimentaryWifi: 'Bezpłatne Wi-Fi',
            coffeeTeaStation: 'Stacja na kawę i herbatę',
            roomService: 'Room service 24/7',
            rainShower: 'Prysznic deszczowy',

            byTheRiver: 'Nad rzeką',
            slowDownBreathe: 'Zwolnij, odetchnij świeżym powietrzem',

            readyToStay: 'Gotowy na pobyt?',
            reserveDeluxeRiverViewToday: 'Zarezerwuj pokój Deluxe z widokiem na rzekę już dziś',
            speakReservations: 'Skontaktuj się z naszym zespołem rezerwacji, aby uzyskać najlepsze dostępne ceny i specjalne oferty.',
            checkAvailability: 'Sprawdź dostępność'
        },

        yoga: {
            heroTitle: 'Joga w kurorcie',
            heroSubtitle: 'Znajdź równowagę, siłę i wewnętrzny spokój w Beruwali',
            heroAlt: 'Joga w Muthumuni Beach Resort',
            importanceEyebrow: 'i równowaga',
            importanceTitle: 'Znaczenie jogi i medytacji',
            importanceImageAlt: 'Znaczenie jogi i medytacji',
            importanceText1: 'Joga i medytacja to starożytne praktyki, które oferują liczne korzyści fizyczne, psychiczne i emocjonalne. Wspierają elastyczność, siłę i równowagę, jednocześnie redukując stres i lęk.',
            importanceText2: 'Regularna praktyka może poprawić koncentrację, jakość snu i ogólne samopoczucie. Joga zachęca również do uważności, pomagając połączyć się z własnym wnętrzem i odnaleźć spokój pośród codziennego zgiełku.',
            importanceText3: 'W Muthumuni Beach Resort zapewniamy spokojne otoczenie idealne do praktykowania jogi i medytacji, dzięki czemu goście mogą odnowić umysł, ciało i ducha.',
            practiceEyebrow: 'Nasza praktyka',
            practiceTitle: 'Praktyka i doświadczenie jogi',
            practiceImageAlt: 'Praktyka jogi w kurorcie',
            practiceText1: 'W Muthumuni Ayurveda Beach Resort joga praktykowana jest głównie jako tradycyjna hatha joga, połączona z pranajamą (technikami oddechowymi). To holistyczne podejście ma na celu przebudzenie wewnętrznej świadomości i łagodne pobudzenie kundalini (często nazywanej trzecim okiem). Szczególny nacisk kładzie się na wyrównanie kręgosłupa i elastyczność, ponieważ uważa się, że sprężysty kręgosłup spowalnia proces starzenia — „Masz tyle lat, ile ma twój kręgosłup.”',
            practiceText2: 'Sesje jogi odbywają się cztery razy w tygodniu i są odpowiednie zarówno dla początkujących, jak i zaawansowanych praktyków. Od czasu do czasu wprowadzane są specjalne sesje, takie jak Ashtanga Yoga, pozwalające doświadczyć różnych pozycji i sekwencji. Nasi lekarze ajurwedyjscy zachęcają do regularnego udziału, aby wspierać i wzmacniać cały program leczenia.',
            practiceText3: 'Wszystkie sesje jogi odbywają się w naszej dedykowanej Yoga Shala, spokojnej przestrzeni zaprojektowanej, aby wspierać koncentrację, równowagę i uważny ruch. Każda sesja zwykle zaczyna się od Powitań Słońca, po których następuje pranajama oraz sekwencja starannie dobranych asan mających na celu poprawę elastyczności, krążenia i ogólnego samopoczucia.',
            practiceText4: 'Nasi doświadczeni nauczyciele jogi dostosowują każdą sesję do indywidualnych potrzeb, możliwości i stanu zdrowia gości, zapewniając bezpieczne, wspierające i głęboko korzystne doświadczenie dla każdego.',
            spiritualEyebrow: 'Duchowa podróż',
            spiritualTitle: 'Medytacja i aktywności duchowe',
            spiritualSubtitle: 'Pogłęb swoją praktykę duchową dzięki naszym świętym ceremoniiom i sesjom medytacji prowadzonej',
            meditationImageAlt: 'Medytacja i praktyka duchowa w kurorcie',
            meditationTitle: 'Sesje medytacji',
            meditationDesc: 'Goście są zaproszeni do udziału w prowadzonych sesjach medytacyjnych odbywających się trzy razy w tygodniu, inspirowanych tradycjami buddyjskimi. Sesje te mają na celu wyciszenie umysłu, pogłębienie świadomości oraz wspieranie uzdrowienia emocjonalnego i duchowego. Medytacja odbywa się w spokojnej świątyni na wyspie, do której goście docierają łodzią — spokojna i znacząca podróż wzbogaca całe doświadczenie medytacyjne.'
        },
    }
};


i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',          // Default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;

